webpackJsonp([0],{

/***/ "../node_modules/core-js/fn/array/find.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.find;

/***/ }),

/***/ "../node_modules/core-js/fn/array/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.includes;

/***/ }),

/***/ "../node_modules/core-js/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.entries;

/***/ }),

/***/ "../node_modules/core-js/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.values;

/***/ }),

/***/ "../node_modules/core-js/fn/string/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").String.includes;

/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {



// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {



// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {



// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {



var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {



var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {



// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {



// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {



// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {



// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {



module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "../node_modules/core-js/modules/_function-to-string.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__("../node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);

/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {



// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {



var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {



var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {



module.exports = false;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {



var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {



var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {



exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {



var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {



module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var $toString = __webpack_require__("../node_modules/core-js/modules/_function-to-string.js");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {



var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {



var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {



// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {



var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {



// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {



var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {



var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var _Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {


// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {


// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "../node_modules/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/guest-upgrade/occupation/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"occupationDropDown\" class=\"dropdown confidential occupation clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown name=\"occupation\" id=\"occupation\" ng-model=\"user.occupation\"\n            ng-options=\"occupation as name for (occupation, name) in occupations()\"\n            aria-labelledby=\"occupationLabel\" ng-required=\"true\" aria-required=\"true\" required>\n        <option value=\"\">{{ content('signup.occupationLabel') }}</option>\n    </select>\n    <label for=\"occupation\" id=\"occupationLabel\">{{ content('signup.occupationLabel') }}</label>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/login-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"loginSection\" content class=\"loginRedirect\">\n    <div class=\"row-fluid\">\n        <div class=\"span13 verticallyCentered baslLoginLabelContainer\">\n            <b>{{content('largeScreenPayment.guestSignUpDesc')}}</b>\n        </div>\n        <div class=\"span11 alignRight baslLoginButtonContainer\">\n            <a class=\"btn full\" ng-click=\"logWebviewLoginClickWrapper(); redirect()\" href=\"\">{{content('login.login')}}</a>\n        </div>\n    </div>\n</div>\n\n<div id=\"loginDivider\">\n      <span class=\"textInDivider\">\n        &nbsp{{content('login.orLowercase')}}&nbsp\n      </span>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addCard/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multistepAddCard\" id=\"multistepAddCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n\n            <!-- BillingAgreement flows need to display description passed by merchant in cart -->\n            <xo-ba-message-banner ng-if=\"billingAgreementMerchantMsg\" token=\"token\"></xo-ba-message-banner>\n\n            <xo-login-button ng-if=\"showLogin\" redirect=\"redirect\"></xo-login-button>\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddcard.errorMessage\"></xo-message>\n            <xo-xoon-header token=\"token\" flags=\"multistepSignupModel.flags\" user=\"multistepSignupModel.onboard.user\" mode=\"mode\" fi-mode=\"fiMode\"></xo-xoon-header>\n\n            <form id=\"multistepAddCardForm\" name=\"multistepAddCardForm\" class=\"multistepSignupForm\"\n                  ng-submit=\"multistepAddCardForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\"\n                  novalidate form-error-detect>\n\n                <xo-country-list token=\"token\" show-mask=\"showMask\"></xo-country-list>\n                <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n                    <xo-credit-card\n                        token=\"token\"\n                        card=\"multistepSignupModel.onboard.card\"\n                        user=\"multistepSignupModel.onboard.user\"\n                        name-below=\"true\"\n                        set-buyer-fx-flag=\"setBuyerFxFlag\">\n                    </xo-credit-card>\n\n                    <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                        <a ng-if=\"!multistepSignupModel.selectedInstallmentData.preventChange\" focus-when=\"multistepSignupModel.selectedInstallmentData\" id=\"paymentMethod\" ui-sref=\"checkout.multistepsignup.multistepsignupaddcard.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-top=\"scroll-top\">\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                            <span ng-if=\"!multistepSignupModel.selectedInstallmentData\">\n                                {{content('paymentMethod.changeInstallmentLongLink')}}\n                            </span>\n                        </a>\n                        <a ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\"\n                           class=\"getInstallments btn btn-secondary\" disabled>\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                        </a>\n                        <div ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                            <a href=\"#\" id=\"installmentHelp\" alt=\"{{ content('common.altHelp') }}\" class=\"verifyHelp\">\n                            </a>\n                        </div>\n                        <xo-tooltip ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                            <div class=\"tip tipDesc emailToolTip\">\n                                {{ content('paymentMethod.installmentPreselectedHelp') }}\n                            </div>\n                        </xo-tooltip>\n                    </div>\n\n                    <input ng-if=\"isInstallmentsVisible() && !multistepSignupModel.selectedInstallmentData\"\n                           type=\"text\"\n                           name=\"installments\"\n                           id=\"installments\"\n                           ng-model=\"multistepSignupModel.selectedInstallmentData.installment_option_selected.term\"\n                           value=\"\"\n                           class=\"hiddenInput ng-pristine\"\n                           required/>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.user\"></xo-name-input>\n\n                    <xo-inline-currency-conversion\n                        card=\"multistepSignupModel.onboard.card\"\n                        token=\"token\"\n                        treatment=\"multistepSignupModel.flags.buyerFxTreatment\"\n                        ng-if=\"multistepSignupModel.flags.hasBuyerFxPrePlanData && multistepSignupModel.flags.buyerFxTreatment\">\n                    </xo-inline-currency-conversion>\n\n                    <div id=\"billingAddress\">\n                        <div class=\"inputField confidential zip\" ng-if=\"componentsFlag.zipCode\" floating-label>\n\n                            <input type=\"text\"\n                                   name=\"zip\"\n                                   id=\"zip\"\n                                   ng-model=\"formattedValues.postalCode\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   data-error-key=\"common.valueInvalid\"\n                                   ng-blur=\"prefill(false)\"\n                                   xo-error-tooltip\n                                   maxlength=\"9\"\n                                   ng-change=\"zipMasking(formattedValues.postalCode)\"\n                                   required/>\n                            <label for=\"zip\" id=\"zipLabel\" >{{ content('common.cep') }}</label>\n                        </div>\n\n\n                        <div ng-if=\"componentsFlag.billingAddressLabel\">\n                            <label class=\"labelHeight\">{{ content('addressBook.billingAddress') }}</label>\n                        </div>\n\n                        <div ng-if=\"multistepSignupModel.flags.billingAddress.addrPrefilled || locale.country!=='BR'\">\n                            <xo-add-address address=\"multistepSignupModel.onboard.billing_address\" hide-cep=\"true\" country=\"locale.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <xo-phone-input phone=\"multistepSignupModel.onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n\n                    <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"multistepSignupModel.flags.allowEditShipping\">\n                        <input ng-model=\"multistepSignupModel.flags.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\"\n                               class=\"shipToBilling\"/>\n                        <label class=\"noBottom\" for=\"shipToBilling\"\n                               ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n                    </div>\n\n                    <div ng-if=\"componentsFlag.shippingAddress\">\n                        <div id=\"shippingAddress\" class=\"billingAddressPadding\" ng-if=\"!multistepSignupModel.flags.shipToBilling\">\n                            <label class=\"labelHeight\">{{ content('shipping.shippingTitle') }}</label>\n\n                            <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n\n                            <span feature=\"changeShippingCountry\">\n                                <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                                    <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                            aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                            <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                                    </select>\n                                    <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n                                </div>\n                            </span>\n\n                            <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                            country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <div id=\"shippingMethod\" ng-if=\"multistepSignupModel.wps_flow && multistepSignupModel.merchant_has_snt_profile\">\n                        <xo-guest-select-shipping-method token=\"token\"\n                                                         show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"multistepSignupModel.onboard.billing_address\"\n                                                 shipping-address=\"multistepSignupModel.onboard.shipping_address\"\n                                                 is-shipping-same-as-billing=\"multistepSignupModel.flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 flags = \"multistepSignupModel.flags\"></xo-guest-select-shipping-method>\n                    </div>\n\n                    <div class=\"buttons visible\">\n                        <!--<a id=\"backButton\" class=\"btn btn-secondary half\"\n                           ng-click=\"backState($event)\">\n                            {{ content('common.back') }}\n                        </a>-->\n\n                        <input\n                            track-submit\n                            id=\"addCardSubmit\"\n                            type=\"submit\"\n                            value=\"{{ content(submitButtonKey, { currency: selectedCurrency }) }}\"\n                            class=\"btn half signupFlowSubmit\"\n                            ng-click=\"validated=true && positionToErrorField()\"/>\n                    </div>\n                </div>\n            </form>\n            <div ui-view></div>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addShipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepAddShipping\" id=\"multiStepAddShipping\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddshipping.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('shipping.shippingTitle')}}</h1>\n\n            <form id=\"addShippingForm\" name=\"addShippingForm\" class=\"multistepSignupForm\" ng-submit=\"addShippingForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div id=\"shippingAddress\">\n                    <span feature=\"changeShippingCountry\">\n                        <div class=\"dropdown confidential country clearfix\">\n                            <label for=\"country\" id=\"countryLabel\" class=\"accessAid\">{{content('common.country')}}</label>\n                            <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                    aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                    <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                            </select>\n                        </div>\n                    </span>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n                    <div ng-if=\"!multistepSignupModel.onboard.shippingCountryChanged\"\n                         class=\"inputField confidential zip\" floating-label>\n\n                        <input type=\"text\"\n                               name=\"zip\"\n                               id=\"zip\"\n                               ng-model=\"formattedValues.postalCode\"\n                               value=\"\"\n                               autocapitalize=\"off\"\n                               aria-required=\"true\"\n                               autocomplete=\"off\"\n                               placeholder=\"{{ content('common.cep') }}\"\n                               data-error-key=\"common.valueInvalid\"\n                               ng-blur=\"prefillDone ? prefill(false):prefill(true)\"\n                               xo-error-tooltip\n                               maxlength=\"9\"\n                               ng-change=\"zipMasking(formattedValues.postalCode)\"\n                               required/>\n                        <label for=\"zip\" id=\"zipLabel\">{{content('common.cep')}}</label>\n                    </div>\n\n                    <div ng-if=\"multistepSignupModel.flags.shippingAddress.addrPrefilled || multistepSignupModel.onboard.shipping_address.country!=='BR'\">\n                        <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                        country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                    </div>\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit id=\"addShippingSubmit\" type=\"submit\" value=\"{{ content( 'common.continueLabel' ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() && positionToErrorField()\" />\n                </div>\n            </form>\n\n            <div ui-view></div>\n\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepAddressNormalization\" id=\"multiStepAddressNormalization\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-address-normalization token=\"token\" address=\"address\" hide-back-button=\"false\" done-fn=\"doneFn\"></xo-address-normalization>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/createAccount/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepCreateAccount\" id=\"multiStepCreateAccount\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupcreateaccount.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('largeScreenAccountCreation.title')}}</h1>\n\n            <form id=\"createAccountForm\" name=\"createAccountForm\" class=\"multistepSignupForm\" ng-submit=\"createAccountForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n                    <div class=\"signupFieldGroup\">\n\n                        <div ng-class=\"{'fullSignup': fullSignup}\">\n                            <xo-email-input user=\"multistepSignupModel.onboard.user\"></xo-email-input>\n\n                            <xo-password-input user=\"multistepSignupModel.onboard.user\"></xo-password-input>\n\n                            <div ng-if=\"componentsFlag.dobDropDown\">\n                                <xo-dob-input user=\"multistepSignupModel.onboard.user\"></xo-dob-input>\n                            </div>\n\n                            <div class=\"rowPadding\">\n                                <xo-national-id-input country=\"{{locale.country}}\" user=\"multistepSignupModel.onboard.user\"></xo-national-id-input>\n                            </div>\n\n                            <div class=\"row-fluid checkbox legal rowPadding\" feature=\"econsent\">\n                                <div id=\"legalAgreeToolTip\" ng-show=\"showTooltip\">\n                                    <div class=\"errorTooltip legalAgreeCBToolTip\">{{content('largeScreenAccountCreation.agrementError')}}</div>\n                                </div>\n                                <input ng-model=\"multistepSignupModel.onboard.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" ng-change=\"legalAgreeToolTip()\" required/>\n                                <label class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('signupTerms.signupC', {country:locale.country, lang:locale.lang})\"></label>\n                            </div>\n\n                            <p class=\"billingTxt secondary row-fluid rowPadding legal\" ng-if=\"checkoutCart.isBilling() && !isRP && !isSubscription\">\n                                <span id=\"billingAgreement\" data-ng-bind-html=\"htmlContent(baContentKey, {merchantName: nonEmptyMerchantDisplayName, country: locale.country, lang: locale.lang, fiName: fiName, fiFormatLast4: fiFormatLast4})\"></span>\n                            </p>\n\n                            <p class=\"billingTxt secondary row-fluid rowPadding legal\" ng-if=\"checkoutCart.isBilling() && (isRP || isSubscription)\">\n                                <span id=\"rpAgreement\" data-ng-bind-html=\"htmlContent(rpContentKey, {merchantName: nonEmptyMerchantDisplayName, country: locale.country, lang: locale.lang, fiName: fiName, fiFormatLast4: fiFormatLast4})\"></span>\n                            </p>\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit id=\"signupSubmit\" type=\"submit\" value=\"{{ content( submitButtonKey ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() &&  positionToErrorField()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" ng-if=\"!createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n        <div class=\"span10\" ng-if=\"createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(createAccountDesignExp.propHeader)}}\"\n                            text-content=\"{{createAccountDesignExp.propText}}\"\n                            image-url=\"{{createAccountDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n\n<xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"multistepSignupModel.resolve_3ds_data\"\n        ng-if=\"multistepSignupModel.is3ds\"></xo-3ds>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n        <div class=\"returnButton\" ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{returnButtonLabel}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"message.msgs || message.msgKeys\">\n    <div id=\"notifications\" role=\"alert\" aria-live=\"assertive\" content >\n        <div id=\"pageLevelErrors\" ng-class=\"[{'extendedMsg': isgreyheader}, 'msg-' + message.type, 'msgPage']\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs track by $index\">\n                    <span data-ng-bind-html=\"msg\" data-test-id=\"message\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys track by $index\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys, message.compileWith)\" data-test-id=\"message\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\" onload=\"on3DSPageLoad()\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"bankFields\" content>\n\n    <div class=\"bban\" ng-if = \"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"bankAccountNumber\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n        </div>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"blz\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\" data-error-key=\"scripts.validIBAN\" ng-change=\"onibanKeyup()\" xo-error-tooltip />\n            <label for=\"ibanNumber\">\n                {{content('bank.iban')}}\n            </label>\n        </div>\n    </div>\n\n\n    <div id=\"ccBlock\" ng-if=\"isCurrencyConversionValid\">\n        <div>\n            <span>{{content('currencyOptions.ppConversionRate')}}</span>\n            <span>{{exchangeSpreadFormatStr}}</span>\n        </div>\n        <div class=\"date\">\n            <span>{{content('currencyOptions.textConversionDate')}}</span>\n            <span>{{fxDate}}</span>\n        </div>\n        <div ng-if=\"showTotalAmount\">\n            <span ng-bind-html=\"htmlContent('currencyOptions.estimatedTotal')\"></span>\n            <span><b>{{targetFormatStr}}</b></span>\n        </div>\n        <div ng-if=\"!showTotalAmount\" ng-bind-html=\"htmlContent('currencyOptions.merchantCurrencyRate', {currency: sourceCurrencyCode})\"></div>\n    </div>\n\n\n    <div id=\"dobBank\" class=\"dobbank mb10\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"user.dob_day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"user.dob_month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"user.dob_year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addCep/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addcard/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height>\n    <xo-aside-header back-url=\"{{backUri}}\" heading=\"asideHeader.addCard\" ng-if=\"sidebar && !checkoutSession.plccOffer && !cardmodel.card.isExisting()\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"checkout.review.sidebar.wallet\" class=\"backArrow goTray\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <xo-message message=\"message\" ng-if=\"!sidebar\"></xo-message>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n        {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\">{{ content('memberReview.notYou')}}</a>\n                </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"pagetitle\">{{ pagetitle }}</h1>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <div ng-if=\"flag('fields.address')\" id=\"billingAddress\" class=\"billingAddress confidential\">\n                    <div class=\"dropdown billingAddress nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                        <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                            {{ content(\"addressBook.billingAddress\") }}\n                        </label>\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div class=\"addressLabel\">\n                    <a href=\"\" link-button ng-click=\"gotoBilling()\">{{ content(\"addCard.addNewBillingAddress\") }}</a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n\n                <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\"><div class = \"cardIcon {{cardType}}\"></div></div>\n        <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <p class=\"creditIconLabel\" ng-if=\"showLabels\">{{content('creditcard.creditIconLabel')}}</p>\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n            <br>\n            <p class=\"debitIconLabel\" ng-if=\"showLabels\">{{content('creditcard.debitIconLabel')}}</p>\n            <div class=\"icons\"\n                 ng-repeat=\"cardType in mxDebitCards\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable inputField\" ng-if=\"!manageCardFlow && showDropDown()\"\n         floating-label-dropdown>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n        <label for=\"cardType\" id=\"cardTypeLabel\">{{ content('creditcard.typeLabel') }}</label>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" floating-label directionality>\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\"\n                name=\"cardNumber\"\n                id=\"cc\"\n                value=\"\"\n                ng-change=\"changeCardNumber(false)\"\n                js-onchange=\"checkCardForDccCall\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\"\n                data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\"\n                data-country=\"{{ locale.country }}\"\n                autocomplete=\"off\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-key=\"{{debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard'}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\" ng-if=\"!showUnsupportedCardMessage\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n            <div class=\"tip tipDesc tipCreditCard\" ng-if=\"showUnsupportedCardMessage\">\n                {{ !debitCardFlow ? content('creditcard.supportedAndUnsupportedCardType', {supportedCardNames: supportedCardNamesCommaSeparated, unsupportedCardNames: unsupportedCardNamesCommaSeparated}) : content('creditcard.acceptDebitCardOnly') }}\n            </div>\n        </xo-tooltip>\n\n        <label ng-if=\"showScanCardExperiment\"  for=\"cc\" class=\"focus\">\n            {{content('creditcard.scanCardNumber')}}\n        </label>\n        <label ng-if=\"!showScanCardExperiment\" for=\"cc\" class=\"focus\">\n            {{ !debitCardFlow ? content('creditcard.cardNumber') : content('creditcard.debitCardNumber') }}\n        </label>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\"></span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n\n        <div class=\"startDate inputField invisiField half confidential\">\n            <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n\n            <div class=\"dropdown startmonth expmonth nullable\">\n                <select xo-dropdown ng-model=\"card.start_month\" id=\"startmonth\" name=\"startmonth\"\n                        ng-required=\"true\" ng-options=\"month for month in months\">\n                    <option value=\"\">{{ content('creditcard.monthPlaceholder') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown startyear expyear nullable\">\n                <select xo-dropdown ng-model=\"card.start_year\" id=\"startyear\" name=\"startyear\"\n                        ng-required=\"true\" ng-options=\"year for year in startYears\">\n                    <option value=\"\">{{ content('creditcard.yearPlaceholder') }}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"issueNo inputField half last-child confidential last-child\">\n            <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n            <xo-tooltip trigger=\"#issueNo\">\n                <div class=\"tip tipDesc tipIssueNo\">\n                    {{ content('creditcard.issueNoLabelToolTip') }}\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n\n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\">\n    <xo-merchant-header token=\"token\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <main id=\"main\" tabindex=\"-1\">\n            <xo-header token=\"token\" is-unbranded=\"isUnbranded\" unbranded-title=\"unbrandedTitle\"\n                       unbranded-sub-title=\"unbrandedSubTitle\" language-switch=\"languageSwitchHeader\"></xo-header>\n            <div id=\"contents\">\n                <div ui-view></div>\n            </div>\n        </main>\n        <xo-spinner></xo-spinner>\n    </div>\n    <xo-footer token=\"token\" language-switch=\"languageSwitchFooter\"></xo-footer>\n    <xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-guest/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"guestWithSignup\" id=\"guestWithSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                                payment-method=\"paymentMethod\"\n                                single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props  ng-if=\"!isUnbranded\" type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n            <xo-value-props  ng-if=\"isUnbranded\" type=\"review\" title=\"{{content('guestVerify.unbrandedPropHead')}}\" text-content=\"guestVerify.unbrandedPropVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"payUponInvoice\" id=\"payUponInvoice\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-pay-upon-invoice token=\"token\" is-unbranded=\"isUnbranded\"></xo-pay-upon-invoice>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"installmentOptions\" xo-tray-height>\n    <xo-aside-header close-url=\"{{backUri}}\" heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <div class=\"installmentOptions asideContent container\">\n       <xo-installment-options token=\"token\" done-fn=\"onComplete\" card-number=\"cardInfo.number\"></xo-installment-options>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html":
/***/ (function(module, exports) {

module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\">\n    <div ui-view></div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-signup/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"fullSignup\" id=\"fullSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/object-assign/index.js":
/***/ (function(module, exports) {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};



/***/ }),

/***/ "../node_modules/paypal-sdk-constants/dist/paypal-sdk-constants.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (root, factory) {
    "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ppsdkconstants = factory() : root.ppsdkconstants = factory();
}("undefined" != typeof self ? self : undefined, function () {
    return function (modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function (exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.n = function (module) {
            var getter = module && module.__esModule ? function () {
                return module["default"];
            } : function () {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = "./src/index.js");
    }({
        "./src/index.js": function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
            

            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var _COUNTRY_LANGS,
                COUNTRY = {
                AD: "AD",
                AE: "AE",
                AG: "AG",
                AI: "AI",
                AL: "AL",
                AM: "AM",
                AN: "AN",
                AO: "AO",
                AR: "AR",
                AT: "AT",
                AU: "AU",
                AW: "AW",
                AZ: "AZ",
                BA: "BA",
                BB: "BB",
                BE: "BE",
                BF: "BF",
                BG: "BG",
                BH: "BH",
                BI: "BI",
                BJ: "BJ",
                BM: "BM",
                BN: "BN",
                BO: "BO",
                BR: "BR",
                BS: "BS",
                BT: "BT",
                BW: "BW",
                BY: "BY",
                BZ: "BZ",
                CA: "CA",
                CD: "CD",
                CG: "CG",
                CH: "CH",
                CI: "CI",
                CK: "CK",
                CL: "CL",
                CM: "CM",
                CN: "CN",
                CO: "CO",
                CR: "CR",
                CV: "CV",
                CY: "CY",
                CZ: "CZ",
                DE: "DE",
                DJ: "DJ",
                DK: "DK",
                DM: "DM",
                DO: "DO",
                DZ: "DZ",
                EC: "EC",
                EE: "EE",
                EG: "EG",
                ER: "ER",
                ES: "ES",
                ET: "ET",
                FI: "FI",
                FJ: "FJ",
                FK: "FK",
                FM: "FM",
                FO: "FO",
                FR: "FR",
                GA: "GA",
                GB: "GB",
                GD: "GD",
                GE: "GE",
                GF: "GF",
                GI: "GI",
                GL: "GL",
                GM: "GM",
                GN: "GN",
                GP: "GP",
                GR: "GR",
                GT: "GT",
                GW: "GW",
                GY: "GY",
                HK: "HK",
                HN: "HN",
                HR: "HR",
                HU: "HU",
                ID: "ID",
                IE: "IE",
                IL: "IL",
                IN: "IN",
                IS: "IS",
                IT: "IT",
                JM: "JM",
                JO: "JO",
                JP: "JP",
                KE: "KE",
                KG: "KG",
                KH: "KH",
                KI: "KI",
                KM: "KM",
                KN: "KN",
                KR: "KR",
                KW: "KW",
                KY: "KY",
                KZ: "KZ",
                LA: "LA",
                LC: "LC",
                LI: "LI",
                LK: "LK",
                LS: "LS",
                LT: "LT",
                LU: "LU",
                LV: "LV",
                MA: "MA",
                MC: "MC",
                MD: "MD",
                ME: "ME",
                MG: "MG",
                MH: "MH",
                MK: "MK",
                ML: "ML",
                MN: "MN",
                MQ: "MQ",
                MR: "MR",
                MS: "MS",
                MT: "MT",
                MU: "MU",
                MV: "MV",
                MW: "MW",
                MX: "MX",
                MY: "MY",
                MZ: "MZ",
                NA: "NA",
                NC: "NC",
                NE: "NE",
                NF: "NF",
                NG: "NG",
                NI: "NI",
                NL: "NL",
                NO: "NO",
                NP: "NP",
                NR: "NR",
                NU: "NU",
                NZ: "NZ",
                OM: "OM",
                PA: "PA",
                PE: "PE",
                PF: "PF",
                PG: "PG",
                PH: "PH",
                PL: "PL",
                PM: "PM",
                PN: "PN",
                PT: "PT",
                PW: "PW",
                PY: "PY",
                QA: "QA",
                RE: "RE",
                RO: "RO",
                RS: "RS",
                RU: "RU",
                RW: "RW",
                SA: "SA",
                SB: "SB",
                SC: "SC",
                SE: "SE",
                SG: "SG",
                SH: "SH",
                SI: "SI",
                SJ: "SJ",
                SK: "SK",
                SL: "SL",
                SM: "SM",
                SN: "SN",
                SO: "SO",
                SR: "SR",
                ST: "ST",
                SV: "SV",
                SZ: "SZ",
                TC: "TC",
                TD: "TD",
                TG: "TG",
                TH: "TH",
                TJ: "TJ",
                TM: "TM",
                TN: "TN",
                TO: "TO",
                TR: "TR",
                TT: "TT",
                TV: "TV",
                TW: "TW",
                TZ: "TZ",
                UA: "UA",
                UG: "UG",
                US: "US",
                UY: "UY",
                VA: "VA",
                VC: "VC",
                VE: "VE",
                VG: "VG",
                VN: "VN",
                VU: "VU",
                WF: "WF",
                WS: "WS",
                YE: "YE",
                YT: "YT",
                ZA: "ZA",
                ZM: "ZM",
                ZW: "ZW"
            },
                LANG = {
                AR: "ar",
                CS: "cs",
                DA: "da",
                DE: "de",
                EL: "el",
                EN: "en",
                ES: "es",
                FI: "fi",
                FR: "fr",
                HE: "he",
                HU: "hu",
                ID: "id",
                IT: "it",
                JA: "ja",
                KO: "ko",
                NL: "nl",
                NO: "no",
                PL: "pl",
                PT: "pt",
                RU: "ru",
                SK: "sk",
                SV: "sv",
                TH: "th",
                TR: "tr",
                ZH: "zh"
            },
                COUNTRY_LANGS = ((_COUNTRY_LANGS = {})[COUNTRY.AD] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR], _COUNTRY_LANGS[COUNTRY.AG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AL] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.AM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AR] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.AT] = [LANG.DE, LANG.EN], _COUNTRY_LANGS[COUNTRY.AU] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.AW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BA] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BB] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BE] = [LANG.EN, LANG.NL, LANG.FR], _COUNTRY_LANGS[COUNTRY.BF] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BH] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BI] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BJ] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BR] = [LANG.PT, LANG.EN], _COUNTRY_LANGS[COUNTRY.BS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BT] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BZ] = [LANG.EN, LANG.ES, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CA] = [LANG.EN, LANG.FR], _COUNTRY_LANGS[COUNTRY.CD] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CH] = [LANG.DE, LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CI] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CK] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CL] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CM] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CN] = [LANG.ZH], _COUNTRY_LANGS[COUNTRY.CO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CR] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CV] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.CZ] = [LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DE] = [LANG.DE, LANG.EN], _COUNTRY_LANGS[COUNTRY.DJ] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DK] = [LANG.DA, LANG.EN], _COUNTRY_LANGS[COUNTRY.DM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DZ] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EC] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EE] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EG] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ER] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ES] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.ET] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FI] = [LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FK] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FM] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.FO] = [LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FR] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.GA] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GB] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.GD] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GL] = [LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GN] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GP] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GR] = [LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GT] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GY] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HK] = [LANG.EN, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HN] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HR] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.HU] = [LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ID] = [LANG.ID, LANG.EN], _COUNTRY_LANGS[COUNTRY.IE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.IL] = [LANG.HE, LANG.EN], _COUNTRY_LANGS[COUNTRY.IN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.IS] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.IT] = [LANG.IT, LANG.EN], _COUNTRY_LANGS[COUNTRY.JM] = [LANG.EN, LANG.ES, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.JO] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.JP] = [LANG.JA, LANG.EN], _COUNTRY_LANGS[COUNTRY.KE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KH] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.KI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KM] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KR] = [LANG.KO, LANG.EN], _COUNTRY_LANGS[COUNTRY.KW] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KY] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LA] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.LC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LK] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.LS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LT] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LU] = [LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LV] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MA] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MC] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.MD] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.ME] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MH] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MK] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.ML] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MQ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MT] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MV] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MX] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.MY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NE] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.NI] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NL] = [LANG.NL, LANG.EN], _COUNTRY_LANGS[COUNTRY.NO] = [LANG.NO, LANG.EN], _COUNTRY_LANGS[COUNTRY.NP] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.NR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.OM] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PA] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PE] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PH] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.PL] = [LANG.PL, LANG.EN], _COUNTRY_LANGS[COUNTRY.PM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PT] = [LANG.PT, LANG.EN], _COUNTRY_LANGS[COUNTRY.PW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PY] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.QA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR], _COUNTRY_LANGS[COUNTRY.RE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RU] = [LANG.RU, LANG.EN], _COUNTRY_LANGS[COUNTRY.RW] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SA] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SB] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SC] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SE] = [LANG.SV, LANG.EN], _COUNTRY_LANGS[COUNTRY.SG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.SH] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SK] = [LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SL] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SN] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ST] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SV] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TD] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TG] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TH] = [LANG.TH, LANG.EN], _COUNTRY_LANGS[COUNTRY.TJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TN] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TO] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.TR] = [LANG.TR, LANG.EN], _COUNTRY_LANGS[COUNTRY.TT] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TV] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TW] = [LANG.ZH, LANG.EN], _COUNTRY_LANGS[COUNTRY.TZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UA] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.US] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UY] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VE] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.VU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.WF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.WS] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.YE] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.YT] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZW] = [LANG.EN], _COUNTRY_LANGS),
                SDK_SETTINGS = {
                CLIENT_TOKEN: "data-client-token",
                PARTNER_ATTRIBUTION_ID: "data-partner-attribution-id",
                STAGE_HOST: "data-stage-host",
                API_STAGE_HOST: "data-api-stage-host"
            },
                SDK_QUERY_KEYS = {
                COMPONENTS: "components",
                ENV: "env",
                DEBUG: "debug",
                CACHEBUST: "cachebust",
                CLIENT_ID: "client-id",
                MERCHANT_ID: "merchant-id",
                LOCALE: "locale",
                CURRENCY: "currency",
                INTENT: "intent",
                COMMIT: "commit",
                VAULT: "vault",
                BUYER_COUNTRY: "buyer-country",
                DISABLE_FUNDING: "disable-funding",
                DISABLE_CARD: "disable-card",
                LOCALE_COUNTRY: "locale-country",
                LOCALE_LANG: "locale-lang",
                ORDER_CURRENCY: "order-currency",
                ORDER_INTENT: "order-intent",
                ORDER_COMMIT: "order-commit",
                ORDER_VAULT: "order-vault"
            },
                COMPONENTS = {
                BUTTONS: "buttons",
                HOSTED_FIELDS: "hosted-fields"
            },
                DEBUG = {
                TRUE: !0,
                FALSE: !1
            },
                QUERY_BOOL = {
                TRUE: "true",
                FALSE: "false"
            },
                ENV = {
                LOCAL: "local",
                STAGE: "stage",
                SANDBOX: "sandbox",
                PRODUCTION: "production",
                TEST: "test"
            },
                FPTI_KEY = {
                FEED: "feed_name",
                STATE: "state_name",
                TRANSITION: "transition_name",
                BUTTON_TYPE: "button_type",
                SESSION_UID: "page_session_id",
                BUTTON_SESSION_UID: "button_session_id",
                TOKEN: "token",
                CONTEXT_ID: "context_id",
                CONTEXT_TYPE: "context_type",
                REFERER: "referer_url",
                PAY_ID: "pay_id",
                SELLER_ID: "seller_id",
                CLIENT_ID: "client_id",
                DATA_SOURCE: "serverside_data_source",
                BUTTON_SOURCE: "button_source",
                ERROR_CODE: "ext_error_code",
                ERROR_DESC: "ext_error_desc",
                PAGE_LOAD_TIME: "page_load_time",
                EXPERIMENT_NAME: "pxp_exp_id",
                TREATMENT_NAME: "pxp_trtmnt_id",
                TRANSITION_TIME: "transition_time",
                FUNDING_LIST: "eligible_payment_methods",
                FUNDING_COUNT: "eligible_payment_count",
                CHOSEN_FUNDING: "selected_payment_method",
                BUTTON_LAYOUT: "button_layout",
                VERSION: "checkoutjs_version",
                LOCALE: "locale",
                BUYER_COUNTRY: "buyer_cntry",
                INTEGRATION_IDENTIFIER: "integration_identifier",
                PARTNER_ATTRIBUTION_ID: "bn_code",
                SDK_NAME: "sdk_name",
                SDK_VERSION: "sdk_version",
                USER_AGENT: "user_agent",
                USER_ACTION: "user_action",
                CONTEXT_CORRID: "context_correlation_id"
            },
                FPTI_USER_ACTION = {
                COMMIT: "commit",
                CONTINUE: "continue"
            },
                FPTI_DATA_SOURCE = {
                PAYMENTS_SDK: "checkout"
            },
                FPTI_FEED = {
                PAYMENTS_SDK: "payments_sdk"
            },
                FPTI_SDK_NAME = {
                PAYMENTS_SDK: "payments_sdk"
            },
                INTENT = {
                CAPTURE: "capture",
                AUTHORIZE: "authorize",
                ORDER: "order"
            },
                COMMIT = {
                TRUE: !0,
                FALSE: !1
            },
                VAULT = {
                TRUE: !0,
                FALSE: !1
            },
                CURRENCY = {
                AUD: "AUD",
                BRL: "BRL",
                CAD: "CAD",
                CZK: "CZK",
                DKK: "DKK",
                EUR: "EUR",
                HKD: "HKD",
                HUF: "HUF",
                INR: "INR",
                ILS: "ILS",
                JPY: "JPY",
                MYR: "MYR",
                MXN: "MXN",
                TWD: "TWD",
                NZD: "NZD",
                NOK: "NOK",
                PHP: "PHP",
                PLN: "PLN",
                GBP: "GBP",
                RUB: "RUB",
                SGD: "SGD",
                SEK: "SEK",
                CHF: "CHF",
                THB: "THB",
                USD: "USD"
            },
                PLATFORM = {
                DESKTOP: "desktop",
                MOBILE: "mobile"
            },
                FUNDING = {
                PAYPAL: "paypal",
                VENMO: "venmo",
                CREDIT: "credit",
                CARD: "card",
                IDEAL: "ideal",
                SEPA: "sepa",
                BANCONTACT: "bancontact",
                GIROPAY: "giropay",
                SOFORT: "sofort",
                EPS: "eps",
                MYBANK: "mybank",
                P24: "p24",
                ZIMPLER: "zimpler",
                WECHATPAY: "wechatpay"
            },
                CARD = {
                VISA: "visa",
                MASTERCARD: "mastercard",
                AMEX: "amex",
                DISCOVER: "discover",
                HIPER: "hiper",
                ELO: "elo",
                JCB: "jcb",
                CUP: "cup"
            },
                DEFAULT_COUNTRY = COUNTRY.US,
                DEFAULT_CURRENCY = CURRENCY.USD,
                DEFAULT_INTENT = INTENT.CAPTURE,
                DEFAULT_COMMIT = COMMIT.TRUE,
                DEFAULT_VAULT = VAULT.FALSE,
                DEFAULT_COMPONENTS = COMPONENTS.BUTTONS,
                DEFAULT_DEBUG = DEBUG.FALSE;
            __webpack_require__.d(__webpack_exports__, "COUNTRY", function () {
                return COUNTRY;
            });
            __webpack_require__.d(__webpack_exports__, "LANG", function () {
                return LANG;
            });
            __webpack_require__.d(__webpack_exports__, "COUNTRY_LANGS", function () {
                return COUNTRY_LANGS;
            });
            __webpack_require__.d(__webpack_exports__, "SDK_PATH", function () {
                return "/sdk/js";
            });
            __webpack_require__.d(__webpack_exports__, "SDK_SETTINGS", function () {
                return SDK_SETTINGS;
            });
            __webpack_require__.d(__webpack_exports__, "SDK_QUERY_KEYS", function () {
                return SDK_QUERY_KEYS;
            });
            __webpack_require__.d(__webpack_exports__, "COMPONENTS", function () {
                return COMPONENTS;
            });
            __webpack_require__.d(__webpack_exports__, "DEBUG", function () {
                return DEBUG;
            });
            __webpack_require__.d(__webpack_exports__, "QUERY_BOOL", function () {
                return QUERY_BOOL;
            });
            __webpack_require__.d(__webpack_exports__, "ENV", function () {
                return ENV;
            });
            __webpack_require__.d(__webpack_exports__, "FPTI_KEY", function () {
                return FPTI_KEY;
            });
            __webpack_require__.d(__webpack_exports__, "FPTI_USER_ACTION", function () {
                return FPTI_USER_ACTION;
            });
            __webpack_require__.d(__webpack_exports__, "FPTI_DATA_SOURCE", function () {
                return FPTI_DATA_SOURCE;
            });
            __webpack_require__.d(__webpack_exports__, "FPTI_FEED", function () {
                return FPTI_FEED;
            });
            __webpack_require__.d(__webpack_exports__, "FPTI_SDK_NAME", function () {
                return FPTI_SDK_NAME;
            });
            __webpack_require__.d(__webpack_exports__, "INTENT", function () {
                return INTENT;
            });
            __webpack_require__.d(__webpack_exports__, "COMMIT", function () {
                return COMMIT;
            });
            __webpack_require__.d(__webpack_exports__, "VAULT", function () {
                return VAULT;
            });
            __webpack_require__.d(__webpack_exports__, "CURRENCY", function () {
                return CURRENCY;
            });
            __webpack_require__.d(__webpack_exports__, "PLATFORM", function () {
                return PLATFORM;
            });
            __webpack_require__.d(__webpack_exports__, "FUNDING", function () {
                return FUNDING;
            });
            __webpack_require__.d(__webpack_exports__, "CARD", function () {
                return CARD;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_COUNTRY", function () {
                return DEFAULT_COUNTRY;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_CURRENCY", function () {
                return DEFAULT_CURRENCY;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_INTENT", function () {
                return DEFAULT_INTENT;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_COMMIT", function () {
                return DEFAULT_COMMIT;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_VAULT", function () {
                return DEFAULT_VAULT;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_COMPONENTS", function () {
                return DEFAULT_COMPONENTS;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_DEBUG", function () {
                return DEFAULT_DEBUG;
            });
        }
    });
});
//# sourceMappingURL=paypal-sdk-constants.js.map
//# sourceMappingURL=paypal-sdk-constants.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/paypal-sdk-constants/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* @flow */

// $FlowFixMe
module.exports = __webpack_require__("../node_modules/paypal-sdk-constants/dist/paypal-sdk-constants.js"); // eslint-disable-line import/no-commonjs



/***/ }),

/***/ "../node_modules/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Api = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getLatestCorrelationID = $getLatestCorrelationID;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 API
 ---

 This layer is responsible for handling api requests. It has a number of responsibilities:

 - Caching responses
 - Transparently returning data that has been preloaded into the initial page response
 - Instrumentation
 - Batching multiple api calls into a single http request
 - Handling multiple types of responses and dispatching to the correct handlers
 - Emitting loading events for all http calls
 */

_config.$meta.headers = _config.$meta.headers || {};
_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];

// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
function cookiesEnabled() {
    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
}

// Cache for api responses, when cache: true
var cache = {};
var standardHeaders = {};

var latestCorrelationID = _config.$meta.correlationId;

// Window load promise
var windowLoad = _util.$util.memoize(function () {
    return _promise.$promise.resolver(function (resolve) {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            window.addEventListener('load', resolve);
        }
    });
});

// Buffer for batch requests made within the same frame
var batchQueue = {};

// Backwards compat
window.pre = {};

// Transient cache resolvers
var transientCache = {};

// Transient cache resolvers
var transientCacheResolvers = {};

// Metabuilder
var metaBuilder = void 0;

// Add to transientCache
window.preload = function (method, url, data, name) {

    if (name) {
        window.pre[name] = {
            method: method,
            uri: url,
            res: data
        };
    }

    var key = method + ':' + url;
    var resolvers = transientCacheResolvers[key] || [];

    transientCache[key] = data;

    while (resolvers.length) {
        resolvers.pop().call();
    }
};

// Preload complete
var preloadComplete = false;

window.preloadComplete = function () {
    preloadComplete = true;
    Object.keys(transientCacheResolvers).forEach(function (key) {
        var resolvers = transientCacheResolvers[key] || [];

        while (resolvers.length) {
            resolvers.pop().call();
        }
    });
};

_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');

var $Api = exports.$Api = _class.$Class.extend('$Api', {

    // Cache any GET responses indefinitely
    cache: false,

    // Http timeout for all requests
    timeout: 45000,

    // Default number of attempts on aborted requests and 500 server errors
    getAttempts: 3,
    postAttempts: 1,

    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
    action: function action(_action, options) {
        options.action = _action;
        return this.post(options);
    },

    // GET on a resource myapi.retrieve() -> GET /my/api
    retrieve: function retrieve(options) {
        options.method = 'get';
        return this.call(options);
    },

    // POST on a resource myapi.retrieve() -> POST /my/api
    post: function post(options) {
        options.method = 'post';
        return this.call(options);
    },

    // Generic handler for calling an api and dispatching requests to the right place
    call: function call(options) {
        var self = this;

        // Set up request options and params. `options` is an object which should contain everything
        // the request needs to run and handle the response

        options.api = this;
        options.uri = this.getURI(options.model, options.action);
        options.params = options.params || {};
        options.cache = options.cache || self.cache && options.method === 'get';
        options.name = this.buildAPIName(options);
        options.meta = this.buildMeta();
        options.transientError = options.transientError || false;
        options.cacheKey = _util.$util.buildURL(options.uri, options.params);

        _logger.$logger.info(options.name + '_call', {
            name: options.name,
            method: options.method,
            uri: options.uri
        });

        if (!options.silent) {
            _event.$event.emit('loading');
        }

        // Decide where to get the response
        return _promise.$promise.first([

        // If caching is enabled and we have the data in local cache, use the cache
        function () {
            if (options.cache && cache[options.cacheKey]) {
                return cache[options.cacheKey];
            }
        },

        // Otherwise if we have transient cache data for this api, we can use that
        function () {
            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {

                // The reason we use self.attemptRequest here is so any errors in the cached response
                // can trigger the retry code path, as if it were a regular request
                return self.attemptRequest(options);
            });
        },

        // If we're in batch mode, queue up a batch request
        function () {
            if (options.batch) {
                return self.batchRequest(options);
            }
        },

        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
        function () {
            return self.attemptRequest(options);
        }])['finally'](function () {

            if (!options.silent) {
                _event.$event.emit('loaded');
            }
        }).then(function (res) {

            // Cache the response if we need to
            if (options.cache) {
                cache[options.cacheKey] = res;
            }

            // Handle the response
            return self.handleResponse(res.data, options);
        }, function (err) {

            // $BatchShortCircuit will be thrown if:
            //
            // 1. batch api call B depends on api call A, but-
            // 2. api call A fails
            //
            // In which case we end up in a situation where had it been a regular chain of events,
            // api B would never have been called in the first place.
            //
            // One possibility here is to return $unresolved, which prevents the promise from ever
            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
            // corner cases.
            //
            // Instead we opt to simply reject the promise, and not call any of the response handlers

            if (err instanceof _error.$BatchShortCircuit) {
                return _promise.$promise.reject(err);
            }

            // Otherwise, handle the error normally
            return self.handleErrorResponse(err, options);
        });
    },

    // Set up a batch request for processing in the next frame
    batchRequest: function batchRequest(options) {

        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
        // layer is to combine multiple atomic api calls into a single http request, without forcing
        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
        //
        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
        // individual api call to the correct handler.
        //
        // The way this is implemented is to place each response in the transient api cache, then to yield
        // control to the regular api request handler, which will handle instrumentation and retries

        // For quick dev-time feedback...
        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);

        var name = options.batch.name;
        var id = options.batch.id;

        // Add the batch request options to the batchQueue for processing on the next frame
        var batch = batchQueue[name] = batchQueue[name] || {};

        batch[id] = options;

        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
        return this.buildBatchRequest(name).then(function (results) {

            // We get back a mapping of id->response, so we now extract the response for our api
            // call. If we have no response, we can assume the call was never made, and short circuit.
            return results[id].then(function (result) {
                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
            });
        });
    },

    // Process all of the accumulated batch api requests
    buildBatchRequest: _promise.$promise.debounce(function (name) {

        var self = this;
        var batch = batchQueue[name];
        var batchIds = _class.$Class.keys(batch);
        var batchData = {};
        var headers = {};

        delete batchQueue[name];

        // If we have just a single request, we can short-circuit and just hit that api

        if (batchIds.length === 1) {

            var batchId = batchIds[0];
            var opts = batch[batchId];

            var results = {};

            results[batchId] = opts.api.attemptRequest(opts);
            return results;
        }

        // Build the request to send to the server side. This is an mapping of id->request, each containing
        // the method, uri, data, and dependencies for each api.
        //
        // Specifying a dependency for an api essentially means the back-end will only
        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.

        _util.$util.forEach(batch, function (options, id) {

            batchData[id] = {
                method: options.method,
                uri: options.api.getURI(options.model, options.action, true),
                data: options.data,
                params: options.params,
                dependencies: options.batch.dependencies
            };

            _util.$util.extend(headers, options.headers);
        });

        // Unfortunate circular dependency... $Api depends on another api.
        //
        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
        // does not respond the first time, our batch request can still get through.

        return $batchApi.action(name, { // eslint-disable-line no-use-before-define
            data: batchData,
            headers: headers
        }).then(function (res) {

            // The final response will be a mapping of id->response-promise.
            //
            // However, we do not treat this data as our final response. Instead, we simply use it to
            // prime our transient cache, then proceed to jump to our regular request handler. This will
            // take care of retries and instrumentation as if this were a regular request.
            //
            // Note that a retry for $batchApi is different to a retry for an individual api. If
            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
            // can just retry the individual api call.

            return self.handleBatchResponse(batch, res.data);
        });
    }),

    // Process the responses for all of the batch requests we sent to the server
    handleBatchResponse: function handleBatchResponse(batch, data) {

        var self = this;

        var promises = {};

        // Loop over each individual api response contained in the batch response, and process the result

        _util.$util.forEach(batch, function (options, id) {

            // Store each response promise so we can check and wait for api dependencies

            promises[id] = _promise.$promise.run(function () {

                // Check if all of the dependencies are present for our individual api call. To do this
                // we must wait until the dependent api call is entirely complete, including any retries.

                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {

                    if (!batch[depName]) {
                        _logger.$logger.info('missing_batch_dependency', {
                            dependency: depName,
                            available: Object.keys(batch).join('|')
                        });
                    }

                    return !batch[depName] || promises[depName].then(function (dependency) {
                        return dependency && dependency.data && dependency.data.ack === 'success';
                    });
                });

                // If our dependencies are present, we can continue, otherwise we are not interested in
                // the result of the individual api call - if its dependency is not present, it will not be.

                return _promise.$promise.providing(depsPresent, function () {

                    // If there is data returned for the individual call, add it to the transient cache

                    return _promise.$promise.providing(data[id], function (result) {
                        var uri = options.api.getURI(options.model, options.action);

                        uri = _util.$util.buildURL(uri, options.params);

                        self.addTransientCacheData(options.method, uri, result);
                    }).then(function () {

                        // Regardless of whether or not there is data, we can now attempt the request.
                        // This will either get the data from the transient cache, or make an http call,
                        // and handle any retries that need to be made.

                        return options.api.attemptRequest(options);
                    });
                });
            });
        });

        return promises;
    },

    // Handle the request and any retries, using either the transient cache or http calls
    attemptRequest: function attemptRequest(options) {
        var self = this;

        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;

        // We allow a certain number of attempts/retries for each api call
        return _promise.$promise.attempt(attempts, function (remaining) {

            // Query the transient cache
            return self.getTransientCacheResponse(options).then(function (res) {

                // If we can get a response from the transient cache, then use it
                if (res) {
                    return res;
                }

                // Otherwise resort to making an http call
                return self.getHttpResponse(options);
            })['catch'](function (res) {

                // If our request was aborted without even a status code, force a single retry
                if ((!res || !res.status) && attempts === 1) {

                    _logger.$logger.warn('api_retry_aborted', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // If our request was 401 denied (probably due to a CSRF error), force a single retry
                if (res.status === 401) {

                    _logger.$logger.warn('api_retry_401', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // Set the correct response and ack for 401
                if (res.status === 401) {
                    return {
                        data: {
                            ack: 'permission_denied'
                        }
                    };
                }

                // Setup to throw a TOO_MANY_REQUESTS contingency for 429 response from ratelimiter (velocityserv)
                if (res.status === 429) {
                    return {
                        data: {
                            ack: 'contingency',
                            contingency: 'TOO_MANY_REQUESTS'
                        }
                    };
                }

                // If we have any remaining retries, log and reject
                if (remaining) {

                    _logger.$logger.warn('api_retry', {
                        method: options.method,
                        uri: options.uri
                    });

                    return _promise.$promise.reject(res);
                }

                // Otherwise reject the request with the appropriate error

                // We got ack=error in the response
                if (res && res.data && res.data.ack === 'error') {
                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
                        name: options.name,
                        method: options.method,
                        uri: options.uri,
                        stack: res.data.stack,
                        transient: options.transientError
                    }));
                }

                // We got a response error status
                else if (res && res.status) {
                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    } else if (res && res.error) {
                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    }

                    // The request was aborted
                    else {
                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
                                uri: options.uri,
                                transient: options.transientError
                            }));
                        }
            });
        });
    },

    // Get an api response via http
    getHttpResponse: function getHttpResponse(options) {
        var self = this;

        var startTime = _util.$util.now();

        var request = this.http(options);

        return request['finally'](function () {

            // Calculate the end-to-end duration of the request from the client's perspective
            options.duration = _util.$util.now() - startTime;
        })['catch'](function (res) {

            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
                return res;
            }

            return _promise.$promise.reject(res);
        }).then(function (res) {
            self.saveResponseState(res);

            var loggerPayload = {
                name: options.name,
                method: options.method,
                uri: options.uri,
                server: res.data.server,
                time: options.duration,
                duration: options.duration,
                corrid: res && res.headers('Paypal-Debug-Id')
            };

            // In certain browsers we can match up this api call to the performance data from the browser
            if (window.performance && window.performance.getEntries) {
                _util.$util.forEach(window.performance.getEntries(), function (resource) {
                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
                        _util.$util.extend(loggerPayload, resource);
                    }
                });
            }

            _logger.$logger.info('api_response', loggerPayload);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status);
            }

            return res;
        }, function (res) {
            self.saveResponseState(res);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status, {
                    corrid: res.headers('Paypal-Debug-Id'),
                    referenceId: res.headers('X-Reference-Header') || undefined // To not serialize this data if not present
                });
            }

            return _promise.$promise.reject(res);
        });
    },

    setTransientCache: function setTransientCache(data) {
        throw new Error('NotImplemented');
    },

    // Get an individual api response from the transient cache, as an object
    getTransientCacheData: function getTransientCacheData(options, pop) {

        if (!_config.$config.enablePreload) {
            return _promise.$promise.resolve();
        }

        var preMethod = options.method.toLowerCase();
        var preUri = _util.$util.buildURL(options.uri, options.params);

        var key = preMethod + ':' + preUri;

        return _promise.$promise.resolver(function (resolve) {

            function res() {
                var data = transientCache[key];

                if (pop) {
                    delete transientCache[key];
                }
                resolve(data);
            }

            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
                return res();
            }

            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
            transientCacheResolvers[key].push(res);

            windowLoad().then(res);
        });
    },

    // Check if the transient cache has the data for a particular api
    hasTransientCacheData: function hasTransientCacheData(options) {
        return this.getTransientCacheData(options, false).then(function (data) {
            return Boolean(data);
        });
    },

    // Add data to the transient cache
    addTransientCacheData: function addTransientCacheData(method, uri, data) {
        var key = method + ':' + uri;

        transientCache[key] = data;
    },

    // Get an individual api response from transient cache, as a res promise with the correct status code
    getTransientCacheResponse: function getTransientCacheResponse(options) {

        return this.getTransientCacheData(options, true).then(function (data) {

            // Preload data does not come with a response code, so massage it into a response promise
            if (data) {
                if (data.ack === 'error') {
                    return _promise.$promise.reject({
                        status: 500,
                        data: data
                    });
                } else if (data.ack === 'permission_denied') {
                    return _promise.$promise.reject({
                        status: 401,
                        data: data
                    });
                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
                    return {
                        status: 400,
                        data: data
                    };
                } else {
                    return {
                        status: 200,
                        data: data
                    };
                }
            }

            // Log a cache miss if we are currently in the first-page load
            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
                    _logger.$logger.info('preload_cache_miss', {
                        uri: options.uri
                    });
                }
        });
    },

    getHeaders: function getHeaders(options) {

        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
            _logger.$logger.warn('missing_csrf_jwt');
        }

        var headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
        };

        _util.$util.extend(headers, standardHeaders);

        if (!cookiesEnabled()) {
            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
        }

        if (options.headers) {
            _util.$util.extend(headers, options.headers);
        }

        return headers;
    },
    http: function http(options) {
        return this.httpJQuery(options);
    },


    /*
     // Raw http call
    httpAngular: function(options) {
         let request = {
            method: options.method,
            url: options.uri,
            data: {
                data: options.data,
                meta: options.meta
            },
            headers: this.getHeaders(options),
            params: options.params,
            requestType: 'json',
            responseType: 'json',
            timeout: this.timeout
        };
         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
            request.params.meta = JSON.stringify(options.meta);
        }
         return $http(request);
    },
     */

    httpJQuery: function httpJQuery(options) {

        var request = {
            method: options.method,
            data: options.method === 'get' ? options.params : JSON.stringify({
                data: options.data,
                meta: options.meta || {}
            }),
            headers: this.getHeaders(options),
            timeout: this.timeout
        };

        if (options.method === 'post') {
            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
        } else if (options.method === 'get') {
            request.data.meta = JSON.stringify(options.meta);
        }

        return _promise.$promise.resolver(function (resolve, reject) {

            function getRes(res, data) {
                return {
                    status: res.status,
                    data: data,
                    headers: function headers(name) {
                        return res.getResponseHeader(name);
                    }
                };
            }

            request.success = function (data, status, res) {
                return resolve(getRes(res, data));
            };

            request.error = function (res) {
                if (res && res.status) {
                    if (res.status >= 400) {
                        return reject(getRes(res, res.responseJSON));
                    } else {
                        return resolve(getRes(res, res.responseJSON));
                    }
                }

                return reject({
                    status: 0,
                    headers: _util.$util.noop,
                    error: res && res.statusText
                });
            };

            _jquery2['default'].ajax(options.uri, request);
        });
    },

    // Save cookies and jwt-csrf token from the response
    saveResponseState: function saveResponseState(res) {

        if (res.headers('x-csrf-jwt')) {
            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
        }

        if (res.headers('X-cookies')) {

            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');

            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
        }

        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
    },

    // Dispatch the response to the correct handlers
    handleResponse: function handleResponse(res, options) {
        var loggerName = 'ui_' + options.name;

        var loggerPayload = {
            name: options.name,
            method: options.method,
            uri: options.uri,
            time: options.duration,
            duration: options.duration
        };

        // Here we dispatch the response to the correct handler based on the ack.
        //
        // ack=success     -> options.success()
        // ack=error       -> options.error()
        // ack=validation  -> options.validation()
        // ack=contingency -> options.contingencies[contingency]()
        //
        // Why do this rather than just rejecting the promise with a custom error?
        //
        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
        //    every error they want to. This is exacerbated by the fact that there is no single thread
        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
        //
        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
        // and the global error handler will be invoked. The api responses are also given as promises.

        var resultModel = options.resultModel || options.model;

        /* jshint maxcomplexity: 17 */
        return _promise.$promise.call(function () {

            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack

            if (res.data && resultModel) {

                if (resultModel.populate) {
                    resultModel.populate(res.data);
                } else {
                    _util.$util.extend(resultModel, res.data);
                }
            }

            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
                    return _util.$util.extend(resultModel, children);
                });
            }
        }).then(function () {
            // eslint-disable-line max-statements

            // Handle each ack type, throw errors accordingly

            if (res.ack === 'success') {
                _logger.$logger.info(loggerName + '_success', loggerPayload);

                if (options.success) {
                    if (options.success instanceof Function) {
                        return options.success(res.data);
                    }
                    return options.success;
                }

                return res;
            }

            if (options.failSilently) {
                return;
            }

            if (res.ack === 'contingency') {
                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
                    contingency: res.contingency
                }));

                if (!res.contingency) {
                    throw new _error.$ApiError('expected_contingency_name', {
                        api: options.name
                    });
                }

                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });

                if (resultModel) {
                    resultModel.errorData = res.errorData || {};
                }

                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);

                _util.$util.extend(contingency, res.errorData);

                if (handler) {
                    if (handler instanceof Function) {
                        return handler(contingency.message, contingency);
                    }
                    return handler;
                }

                throw contingency;
            } else if (res.ack === 'validation') {
                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
                    validation: res.validation
                }));

                if (options.validation) {
                    return options.validation(res.validation);
                }

                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            } else if (res.ack === 'permission_denied') {
                _logger.$logger.info(loggerName + '_denied', loggerPayload);

                var properties = {
                    transient: options.transientError
                };

                if (res.reason) {
                    properties.reason = res.reason;
                }

                throw new _error.$Forbidden(options.uri + ': forbidden', properties);
            } else {
                _logger.$logger.info(loggerName + '_noack', loggerPayload);

                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            }
        });
    },

    // Handle http error responses (ack=error or unhandled errors)
    handleErrorResponse: function handleErrorResponse(err, options) {

        return _promise.$promise.run(function () {

            // If the caller provides an error handler, let them handle it
            if (options.error) {
                return options.error(err);
            }

            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
            // this will always end up in the global error handler due to how angular promises work.
            throw err;
        });
    },

    // Build the uri for the api call
    getURI: function getURI(model, action, relative) {
        var self = this;

        // build the uri as a seriest of segments
        var uri = [];

        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {

            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})

            key = key.slice(2);
            key = key.substring(0, key.length - 1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                return '';
            }

            return '/' + component;
        }).replace(/:[\w\.]+/g, function (key) {

            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})

            key = key.slice(1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
            }

            return component;
        }));

        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
        if (action) {
            uri.push(action);
        }

        // Add the extension (e.g. for doing a GET on a .json resource)
        if (this.ext) {
            uri[uri.length - 1] += '.' + this.ext;
        }

        // Join the uri segments and strip any extra slashes
        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');

        // Add on the base uri, e.g. /webapps/hermes
        if (!relative) {
            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
        }

        return uri;
    },

    // Attach meta data provided by the parent app
    buildMeta: function buildMeta() {
        if (metaBuilder) {
            return metaBuilder();
        }
    },

    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
    buildAPIName: function buildAPIName(options) {
        var self = this;
        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
        replace(/\//g, '_'). // Replace remaining '/' with '_'
        replace(/\?(.*)/, ''). // Remove everything after '?'
        replace(/[^a-zA-Z0-9_]/g, '');

        apiName = options.action ? apiName + '_' + options.action : apiName;
        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
        return apiName;
    }
});

$Api.reopenClass({
    clearCache: function clearCache() {
        cache = {};
    }
});

$Api.registerMetaBuilder = function (builder) {
    metaBuilder = builder;
};

$Api.addHeader = function (name, value) {
    standardHeaders[name] = value;
};

var $batchApi = new $Api({
    uri: '/api/batch',
    postAttempts: 3
});

function $getLatestCorrelationID() {
    return latestCorrelationID;
}

angular.value("$Api", $Api);
angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
_logger.$logger;

_event.$event;

_class.$Class;

_util.$util;

_promise.$promise;

_config.$config;

_config.$meta;

_error.$Contingency;

_error.$Forbidden;

_error.$ApiError;

_error.$BatchShortCircuit;

_loader.$loader;

/***/ }),

/***/ "../node_modules/squid/dist/core/class.js":
/***/ (function(module, exports) {



exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 Class
 -----

 A class pattern, adding sugar on top of javascript prototypes

 ### Basic Usage

 let MyClass = Class.extend({
 foo: 'bar';
 });

 myInstance = new MyClass({
 hello: 'world'
 });

 console.log(myInstance.foo, myInstance.hello)

 In this example, `foo` becomes a property on `MyClass`'s prototype,
 and `hello` becomes a property on `myInstance`.

 ### Default Object Methods

 - `init()`: Called after the object is first instantiated, with all properties available

 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default

 e.g. `myInstance.get('foo.bar.baz', 'some_default');`

 Default return value is undefined

 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep

 e.g. `myInstance.set('foo.bar.baz', 'some_value');`

 Error is thrown if no object is found to set the value on

 - `setProperties(<object>)`: Set all the properties from an object onto your object

 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`

 Can not be used with nested properties

 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair

 */

// Object Create
// -------------
//
// Shim for Object.create, if it is not supported by our browser
//
// let myPrototype = {foo: 'bar'}
// let myObject = create(myPrototype)

// Create an empty anonymous constructor with no side effects, for re-use later
var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function

var create = Object.create || function create(obj) {

    // Set a temporary prototype
    EmptyConstructor.prototype = obj;

    // Create an object using our temporary constructor/prototype
    var instance = new EmptyConstructor();

    // Reset the prototype for next time
    EmptyConstructor.prototype = null;

    // Return our new object, created without side effects
    return instance;
};

function _extend(obj, source) {

    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

// Is Object
// ---------
//
// Check of a let is an object or not
//
// isobject({}) -> true
// isobject('foo') -> false

function isobject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
}

// Transpose properties
// -------------------------------------------------------------------
//
// Transpose properties from a list of objects onto a recipient object
//
// let recipient = {};
// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
// recipient -> {a: 1, b: 2, c:3}

function transpose(recipient, args) {

    // Loop through all args
    for (var i = 0; i < args.length; i++) {
        var ob = args[i];

        // Ignore anything that is not an object
        if (!isobject(ob)) {
            continue;
        }

        // Loop through all keys in our object
        for (var key in ob) {

            // Ignore any prototypal properties
            if (!ob.hasOwnProperty(key)) {
                continue;
            }

            var item = ob[key];

            // Give the function a name
            if (item instanceof Function) {
                item.__name__ = key;
            }

            recipient[key] = item;
        }
    }
}

// Construct a Class
// -----------------
//
// This is the primary constructor for all $Class objects

function construct() {
    // eslint-disable-line no-unused-vars

    // Call any custom constructor;
    if (this.construct) {
        var ob = this.construct.apply(this, arguments);

        // If we get a new object back, return that to the user
        if (isobject(ob)) {
            return ob;
        }
    }

    // Load any provided properties directly onto the object
    transpose(this, arguments);

    // Initialize the object
    if (this.init) {
        this.init();
    }
}

// Reopen an object
// ----------------
//
// Add properties to the constructor's prototype
//
//     let Animal = $Class.extend();
//
//     Animal.reopen({
//       type: 'animal',
//     });
//
//     let cat = new Animal;
//     console.log(cat.type);
function reopen() {

    // Add some more properies to our prototype
    transpose(this.prototype, arguments);

    return this;
}

// Reopen a class
// --------------
//
// Add properties to the constructor. These will propogate through future extends
//
//     let Animal = $Class.extend();
//
//     Animal.reopenClass({
//       fromCache: function(id) {
//         return cache[id] || new this({id: id});
//       }
//     }
//
//     let cat = Animal.fromCache('cat_54');

function reopenClass() {

    // Add some more properies to our class
    transpose(this, arguments);

    // Add to __classmethods__
    transpose(this.__classmethods__, arguments);

    return this;
}

function isChild(Cls) {
    return Cls && Cls.prototype instanceof this;
}

// Generate a new class
// --------------------
//
// Generate a new constructor, with the specified name, and attach all static and prototypal methods

var id = 0;

function extend(name) {
    // eslint-disable-line max-statements
    var Cls = void 0;
    var className = void 0;
    var args = void 0;
    var argsLength = void 0;
    var startIndex = void 0;

    // Accept an optional class name
    if (typeof name === 'string') {

        // Guard against javascript injection
        if (!name.match(/^[\w$][\w\d]*$/)) {
            throw new Error('Class name can not include special characters: ' + name);
        }

        // Use the provided name and slice out the first argument
        className = name;
        argsLength = arguments.length && arguments.length - 1;
        startIndex = 1;
    } else {

        // Otherwise default to the parent name, or 'Object' if generating our first class
        className = this.name || 'Object';
        argsLength = arguments.length;
        startIndex = 0;
    }

    args = new Array(argsLength);
    for (var i = startIndex; i < arguments.length; i++) {
        args[i - startIndex] = arguments[i];
    }

    // Dynamically create our constructor with a custom name
    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval

    // Store the class name for future reference
    Cls.__name__ = className;

    // Set up a classmethods object. These will be inherited through subsequent extend() calls
    Cls.__classmethods__ = {
        extend: extend,
        reopen: reopen,
        reopenClass: reopenClass,
        isChild: isChild
    };

    id += 1;
    Cls.id = id;

    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
    if (this && this !== window) {

        // Inherit everything from superclass prototype
        Cls.prototype = create(this.prototype);

        // Re-set the constructor, which is overwritten by create
        Cls.prototype.constructor = Cls;

        // Add a reference to the superclass prototype for super method calls
        Cls.prototype._super = this.prototype;

        // Inherit any class methods from the superclass
        _extend(Cls.__classmethods__, this.__classmethods__);
    }

    // Add the class methods to our existing class
    _extend(Cls, Cls.__classmethods__);

    // Load any provided properties onto the constructor's prototype
    transpose(Cls.prototype, args);

    // Temporary: allow access from console/debugger
    if (className.indexOf('$') === 0) {
        window[className] = Cls;
    } else {
        window['$' + className] = Cls;
    }

    return Cls;
}

// Multi-layer get
// ---------------
//
// Recursively gets a deep path from an object, returning a default value if any level is not found
//
// let obj = {bar: {baz: 1}}
// get(obj, 'bar.baz', 'default') -> 1
// get(obj, 'aaa.bbb', 'default') -> default

function _get(item, path, def) {

    if (!path) {
        return def;
    }

    path = path.split('.');

    // Loop through each section of our key path
    for (var i = 0; i < path.length; i++) {

        // If we have an object, we can get the key
        if (isobject(item)) {
            item = item[path[i]];
            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default
    return item === undefined ? def : item;
}

// Multi-layer set
// ---------------
//
// Recursively sets a deep path from an object
//
// let obj = {bar: {baz: 1}}
// set(obj, 'bar.baz', 2)
// obj.bar.baz -> 1

function _set(item, path, value) {
    path = path.split('.');

    // Loop through each section of our key path except the last
    for (var i = 0; i < path.length - 1; i++) {

        // Get the next item down
        item = item[path[i]];

        // If we have an object, we're good
        if (isobject(item)) {
            continue;
            // Otherwise, there's nothing to set our key on
        } else {
            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
        }
    }

    // Do the set on the retrieved object with our value
    item[path[path.length - 1]] = value;
}

// Loop through object
// -------------------
//
// Loop an object and apply a function for each key/value
//
// let ob = {a: 1, b: 2, c: 3}
// each(ob, console.log) -> a 1  b 2  c 3

function each(ob, callback) {
    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            callback.call(ob, key, ob[key]);
        }
    }
}

// Gey keys of object
// ------------------
//
// Shim for Object.keys if it does not already exist
//
// let ob = {a: 1, b: 2, c: 3}
// keys(ob) -> ['a', 'b', 'c']

function _keys(ob) {

    if (Object.keys) {
        return Object.keys(ob);
    }

    var result = [];

    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            result.push(key);
        }
    }

    return result;
}

// Create a base class that can be inherited from
// ----------------------------------------------
//
// This is the public interface to the Class module.
// All classes with extend from Class and be provided with a set of base convenience methods.

var $Class = exports.$Class = extend('Class', {

    init: function init() {
        // Empty init class, so calls to _super can be safely made
    },

    get: function get(path, def) {
        return _get(this, path, def);
    },

    set: function set(path, value) {
        _set(this, path, value);
    },

    setProperties: function setProperties() {
        transpose(this, arguments);
    },

    forEach: function forEach(callback) {
        each(this, callback);
    },

    keys: function keys() {
        return _keys(this);
    }
});

$Class.get = _get;
$Class.set = _set;
$Class.keys = _keys;

angular.value("$Class", $Class);

/***/ }),

/***/ "../node_modules/squid/dist/core/config.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);

/***/ }),

/***/ "../node_modules/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dom = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var $dom = exports.$dom = {

    elementReady: function elementReady(id) {

        return _promise.$promise.resolver(function (resolve, reject) {

            if (document.getElementById(id)) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (document.getElementById(id)) {
                    clearInterval(interval);
                    return resolve();
                }
            }, 10);

            setTimeout(60000, reject);
        });
    },

    loadScript: function loadScript(name, src, timeout) {
        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        return _promise.$promise.resolver(function (resolve, reject) {
            var script = document.createElement('script');
            var loadTimeout = void 0;

            function clearScriptLoadTimeout() {
                if (loadTimeout) {
                    clearTimeout(loadTimeout);
                    loadTimeout = undefined;
                }
            }

            script.onload = function () {
                clearScriptLoadTimeout();
                setTimeout(resolve, 10);
            };

            // For Internet explorer 8 support
            script.onreadystatechange = function () {
                if (this.readyState === 'complete' || this.readyState === 'loaded') {
                    clearScriptLoadTimeout();
                    setTimeout(resolve, 10);
                }
            };

            script.onerror = function (event) {
                _logger.$logger.info('script_error', {
                    script: src
                });
                return reject(new Error(name + '_loading_error'));
            };

            if (timeout) {
                loadTimeout = setTimeout(function () {
                    _logger.$logger.info('script_load_timedout', {
                        script: src
                    });
                    return reject(new Error(name + '_loading_timed_out'));
                }, timeout);
            }

            script.setAttribute('src', src);

            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var attribute = _ref;

                script.setAttribute(attribute, attributes[attribute]);
            }

            document.body.appendChild(script);
        });
    },

    cssReady: function cssReady(id) {

        var el = document.getElementById(id);

        return _promise.$promise.resolver(function (resolve, reject) {

            var timeout = void 0;
            var interval = void 0;

            function check() {
                _util.$util.forEach(document.styleSheets, function (stylesheet) {
                    if (stylesheet.href === el.href) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            }

            timeout = setTimeout(function () {
                clearInterval(interval);
                reject();
                throw new Error('css_loading_timed_out');
            }, 30000);

            interval = setInterval(check, 20);
            check();
        });
    }
};

angular.value("$dom", $dom);
_logger.$logger;

_promise.$promise;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BatchShortCircuit = exports.$ShortCircuit = exports.$FallbackError = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
    var message = _ref[0],
        file = _ref[1],
        line = _ref[2],
        col = _ref[3],
        err = _ref[4];


    original();

    _event.$event.emit('$windowError', {
        message: message && (message.stack || message).toString(),
        file: file && file.toString(),
        line: line && line.toString(),
        col: col && col.toString(),
        stack: err && (err.stack || err).toString()
    });
});

var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {

    construct: function construct(err, properties) {

        if (err instanceof Error) {
            err = err.message;
        }

        if (properties) {
            _util.$util.extend(this, properties);
        }

        this.payload = properties;

        this.message = err;
    }
});

var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
    handle: function handle(handlers) {
        var handler = handlers[this.message] || handlers['DEFAULT'];

        if (handler) {
            var result = handler.call(this, this.message, this);

            if (typeof result !== 'undefined') {
                return result;
            }
            return true;
        }
    }
});

var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');

var $ApiError = exports.$ApiError = $Error.extend('$ApiError');

var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
    init: function init() {
        this.reason = this.reason || '';
        this.product = this.product || '';
        this.entryPoint = this.entryPoint || '';
    }
});

/**
 * $ShortCircuit should be thrown if you want to bypass the remainder of a promise chain, and you've already
 * done error handling for the rejection. It should be handled with a no-op in app's $exceptionHandler
 */
var $ShortCircuit = exports.$ShortCircuit = $Error.extend('$ShortCircuit');

// TO-BE-DEPRECATED: Use $ShortCircuit instead
var $BatchShortCircuit = exports.$BatchShortCircuit = $ShortCircuit;

angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$FallbackError", $FallbackError);
angular.value("$ShortCircuit", $ShortCircuit);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
_event.$event;

_class.$Class;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$event = undefined;

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var handlers = {};

var customEventEmitter = void 0;

var $event = exports.$event = {
    use: function use(eventEmitter) {
        customEventEmitter = eventEmitter;

        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var eventName = _ref;

            if (handlers[eventName]) {
                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var handler = _ref2;

                    customEventEmitter.on(eventName, handler);
                }
            }
        }
    },
    on: function on(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.on(eventName, method);
        }

        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(method);

        var cancelled = false;

        function cancel() {
            if (!cancelled) {
                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
                cancelled = true;
            }
        }

        cancel.cancel = cancel;
        return cancel;
    },
    once: function once(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.once(eventName, method);
        }

        var listener = $event.on(eventName, function () {
            listener.cancel();
            return method.apply(this, arguments);
        });

        return listener;
    },
    emit: function emit(eventName) {
        if (customEventEmitter) {
            var _customEventEmitter;

            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
        }

        var event = {
            preventDefault: function preventDefault() {
                event.defaultPrevented = true;
            }
        };

        if (handlers[eventName]) {
            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var handler = _ref3;

                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
            }
        }

        return event;
    },
    broadcast: function broadcast(eventName) {

        if (customEventEmitter) {
            var _customEventEmitter2;

            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
        }

        return $event.emit.apply($event, arguments);
    },


    refCount: function refCount($scope, start, stop) {
        return _promise.$promise.resolver(function (resolve) {

            var count = 0;

            var cancelStartListener = $scope.$on(start, function (event, data) {
                count += 1;
            });

            var cancelStopListener = $scope.$on(stop, function (event, data) {
                setTimeout(function () {
                    count -= 1;
                    res(); // eslint-disable-line no-use-before-define
                }, 50);
            });

            function res() {
                if (!count) {

                    if (cancelStartListener && cancelStopListener) {
                        cancelStartListener();
                        cancelStopListener();
                    }

                    return resolve();
                }
            }

            setTimeout(res, 50);
        });
    },

    compose: function compose(start, end, startAll, endAll) {
        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


        var count = 0;
        var active = false;

        $event.on(start, function () {
            if (!count) {
                setTimeout(function () {
                    if (count && !active) {
                        active = true;
                        $event.emit(startAll);
                    }
                }, debounce);
            }

            count += 1;
        });

        $event.on(end, function () {

            setTimeout(function () {
                count -= 1;

                if (!count && active) {
                    active = false;
                    $event.emit(endAll);
                }
            }, 0);
        });

        return {
            getCount: function getCount() {
                return count;
            },
            isActive: function isActive() {
                return Boolean(count);
            },
            reset: function reset() {
                count = 0;
            }
        };
    }
};

angular.value("$event", $event);
_promise.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/squid/dist/core/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

Object.keys(_class).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _class[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _event[key];
    }
  });
});

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

Object.keys(_integration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _integration[key];
    }
  });
});

var _model = __webpack_require__("../node_modules/squid/dist/core/model.js");

Object.keys(_model).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _model[key];
    }
  });
});

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

Object.keys(_loader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _loader[key];
    }
  });
});

var _dom = __webpack_require__("../node_modules/squid/dist/core/dom.js");

Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dom[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $DEFAULT = exports.$DEFAULT = 'DEFAULT';

var $CONTEXT = exports.$CONTEXT = {

    // Full page checkout
    FULLPAGE: 'FULLPAGE',

    // Checkout in popup
    POPUP: 'POPUP',

    // Checkout in lightbox (iframe)
    LIGHTBOX: 'LIGHTBOX',

    // Web view
    WEBVIEW: 'WEBVIEW',

    // Native checkout
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

var $integration = exports.$integration = {

    flow: $DEFAULT,

    init: function init(flow, config) {
        this.config = config || {};

        if (flow) {
            this.setFlow(flow);
        }

        this.setContext(this.getContext());
    },
    getContext: function getContext() {

        if (this.isIFrame()) {
            return $CONTEXT.LIGHTBOX;
        } else if (this.isPopup()) {
            return $CONTEXT.POPUP;
        } else {
            return $CONTEXT.FULLPAGE;
        }
    },
    isPopup: function isPopup() {
        return Boolean(window.opener);
    },
    isIFrame: function isIFrame() {
        return window.top !== window.self;
    },
    setContext: function setContext(context) {
        _logger.$logger.info('integration_context_' + context);
        this.context = context;
    },
    setFlow: function setFlow(flow) {
        _logger.$logger.info('integration_flow_' + flow);
        this.flow = flow;
    },
    is: function is(context, flow) {
        return this.isContext(context) && this.isFlow(flow);
    },
    isContext: function isContext(context) {
        return this.context === context;
    },
    isFlow: function isFlow(flow) {
        return this.flow === flow;
    },
    getConfig: function getConfig(key) {

        this.context = this.getContext();

        if (!this.config) {
            return;
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {

            return this.config[this.context][this.flow][key];
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {

            return this.config[this.context][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {

            return this.config[$DEFAULT][this.flow][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {

            return this.config[$DEFAULT][key];
        }
    },
    error: function error(message) {
        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
    }
};

angular.value("$DEFAULT", $DEFAULT);
angular.value("$CONTEXT", $CONTEXT);
angular.value("$integration", $integration);
_logger.$logger;

/***/ }),

/***/ "../node_modules/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$loader = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _firstLoad = false;

var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);

var $loader = exports.$loader = {

    isLoading: function isLoading() {
        return Boolean(loader.getCount());
    },
    firstLoad: function firstLoad() {
        return _firstLoad;
    },
    reset: function reset() {
        loader.reset();
    }
};

_event.$event.on('allLoaded', function () {
    _firstLoad = true;
});

angular.value("$loader", $loader);
_event.$event;

/***/ }),

/***/ "../node_modules/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Model = undefined;

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var $Model = exports.$Model = _class.$Class.extend('$Model', {

    init: function init() {

        if (this.keys().length) {
            this.onPopulate();
        }

        if (this.id) {
            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};

            _cache[this.id] = this;
        }

        this.meta = {
            populated: false
        };
    },

    /**
     * Add the passed in properties to this Model.
     * Sets the meta.populated to true. This flag
     * can be used later to determine if the model is populated.
     * Calls onPopulate() in the end.
     */
    populate: function populate() {

        this.meta.populated = true;
        this.setProperties.apply(this, arguments);
        delete this.meta.invalidated;
        this.onPopulate();
        return this;
    },

    fetchChildren: function fetchChildren() {
        return _promise.$promise.resolve();
    },

    /**
     * Override this method, to execute any logic after model is populated.
     */
    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method, to execute any logic after model is invalidated.
     */
    onInvalidate: function onInvalidate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method to return a Mock instance. Must return a promise which resolves to model.
     */
    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function

    },

    /**
     * Retrieves the model.
     *
     * If model is already populated just returns a promise which resolves to `this`
     * If there is a retriever for this model, then return the retreiver.
     * Else calls the api to retrieve the model.
     *
     * @param options
     * @returns {*}
     */
    retrieve: function retrieve(options) {
        var self = this;

        options = options || {};

        if (self.meta.populated) {

            if (options.success) {
                return _promise.$promise.resolve(options.success(self));
            }

            return _promise.$promise.resolve(this);
        }

        if (this.retriever) {
            return this.retriever;
        }

        if (!this.api) {
            throw new Error('Tried to populate a model with no api');
        }

        options.model = this;

        this.retriever = this.api.retrieve(options).then(function (res) {
            return self;
        })['finally'](function () {
            delete self.retriever;
        });

        return this.retriever;
    },

    /**
     * Calls a post on the api to save this model. Takes options as parameters.
     * options will passed down to api.post.
     *
     * @param options
     * @returns {*|HttpPromise}
     */
    save: function save(options) {
        options = options || {};
        options.model = this;

        options.data = options.data || this.serialize();

        return this.api.post(options);
    },

    /**
     * Calls Api.action to perform any action on the model.
     *
     * Takes action name and optional 'options' object as parameters.
     *
     * Ex: $CheckoutSession.actions('create', [options])
     *
     * @param action
     * @param options
     * @returns {*}
     */
    action: function action(_action, options) {
        options = options || {};
        options.model = this;

        return this.api.action(_action, options);
    },

    /**
     * Use this method to force a api call to get the data.
     *
     * @param options
     * @returns {*}
     */
    reload: function reload(options) {
        this.meta.populated = false;
        return this.retrieve(options);
    },

    stringify: function stringify() {
        return JSON.stringify(this, 2);
    },

    log: function log() {
        console.log(this.stringify());
    },

    serialize: function serialize() {// eslint-disable-line no-empty-function

    },

    /**
     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
     */
    invalidate: function invalidate() {
        this.meta.populated = false;
        this.meta.invalidated = true;
        this.onInvalidate();
    },

    /**
     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
     *
     * @param Cls
     * @param child
     * @returns {*}
     */
    child: function child(Cls, _child) {

        if (!_child) {
            return;
        }

        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
    },

    /**
     *
     * @param Cls
     * @param children
     * @returns {*}
     */
    children: function children(Cls, _children) {
        var self = this;

        if (!_children) {
            return _children;
        }

        return _util.$util.map(_children, function (child) {
            return self.child(Cls, child);
        });
    }
});

var cache = {};

$Model.reopenClass({

    instance: function instance(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] || this.create.apply(this, arguments);

        return instance;
    },

    retrieveInstance: function retrieveInstance() {
        return this.instance.apply(this, arguments).retrieve();
    },

    create: function create(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
            id: id || 0
        });

        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));

        return instance;
    },

    fetch: function fetch() {
        console.warn('Model.fetch is deprecated, please use Model.instance');
        return this.instance.apply(this, arguments);
    },

    clearCache: function clearCache() {
        cache = {};
    },

    /**
     * should invalidate all models where the invalidationKey is found truthy
     *
     * invalidationKey: key of type string to look for in a model
     * example: $Model.bulkInvalidate('invalidateOnLogout');
     */
    bulkInvalidate: function bulkInvalidate(invalidationKey) {
        if (!invalidationKey) {
            return;
        }
        _util.$util.forEach(cache, function (modelCache, key) {
            _util.$util.forEach(modelCache, function (modelInstance, instanceId) {
                if (modelInstance[invalidationKey]) {
                    modelInstance.invalidate();
                }
            });
        });
    }
});

angular.value("$Model", $Model);
_class.$Class;

_util.$util;

_promise.$promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$promise = $promise;

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var Promise = window.Promise;

function $promise(obj) {
    return Promise.resolve(obj);
}

_util.$util.extend($promise, {
    use: function use(CustomPromise) {
        Promise = CustomPromise;
        if (!window.Promise) {
            window.Promise = CustomPromise;
        }
    },
    resolver: function resolver(method) {
        return new Promise(method);
    },
    resolve: function resolve(value) {
        return Promise.resolve(value);
    },
    reject: function reject(value) {
        return Promise.reject(value);
    },


    run: function run(method) {
        return Promise.resolve().then(method);
    },

    call: function call(method) {
        return Promise.resolve().then(method);
    },

    sequential: function sequential(methods) {

        var prom = Promise.resolve();

        _util.$util.forEach(methods, function (method) {
            prom = prom.then(method);
        });

        return prom;
    },

    sleep: function sleep(time) {
        return new Promise(function (resolve) {
            setTimeout(resolve, time);
        });
    },

    map: function map(items, method) {

        var promises = void 0;

        if (items instanceof Array) {
            promises = [];
        } else if (items instanceof Object) {
            promises = {};
        } else {
            return Promise.resolve();
        }

        return this.all(_util.$util.map(items, function (item, key) {

            promises[key] = Promise.resolve(item).then(function (result) {
                return method(result, key, promises);
            });

            return promises[key];
        }));
    },

    all: function all(items) {

        if (items instanceof Array) {
            return Promise.all(items);
        } else if (items instanceof Object) {
            return this.hash(items);
        }

        return Promise.resolve([]);
    },

    hash: function hash(obj) {
        var results = {};

        return Promise.all(_util.$util.map(obj, function (item, key) {
            return Promise.resolve(item).then(function (result) {
                results[key] = result;
            });
        })).then(function () {
            return results;
        });
    },

    extend: function extend(obj, hash) {
        return this.hash(hash || {}).then(function (data) {
            _util.$util.extend(obj, data);
        });
    },

    attempt: function attempt(attempts, method) {

        attempts -= 1;

        return Promise.resolve().then(function () {
            return method(attempts);
        })['catch'](function (err) {

            if (attempts) {
                return $promise.attempt(attempts, method);
            }

            return Promise.reject(err);
        });
    },

    debounce: function debounce(method, time) {

        var timeout = void 0;
        var resolvers = {};

        return function () {

            var self = this;
            var args = arguments;
            var key = JSON.stringify(args);

            resolvers[key] = resolvers[key] || [];

            return new Promise(function (resolve) {
                resolvers[key].push(resolve);
                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    var result = method.apply(self, args);

                    _util.$util.forEach(resolvers[key], function (resolver) {
                        resolver(result);
                    });

                    delete resolvers[key];
                }, time);
            });
        };
    },

    every: function every(collection, handler) {
        return this.map(collection, function (item) {
            return handler(item);
        }).then(function (results) {
            return _util.$util.every(results);
        });
    },

    providing: function providing(condition, handler) {
        return Promise.resolve(condition).then(function (result) {
            if (result) {
                return handler(result);
            }
        });
    },

    until: function until(condition, pollTime, timeout, alwaysResolve) {

        return new Promise(function (resolve, reject) {
            if (condition()) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (condition()) {
                    clearInterval(interval);
                    return resolve();
                }
            }, pollTime);

            if (timeout) {
                setTimeout(function () {
                    clearInterval(interval);
                    return alwaysResolve ? resolve() : reject();
                }, timeout);
            }
        });
    },

    first: function first(handlers) {

        var prom = $promise.resolve();
        var result = void 0;

        _util.$util.forEach(handlers, function (handler) {
            prom = prom.then(function () {
                return result || handler();
            }).then(function (handlerResult) {
                result = handlerResult;
                return result;
            });
        });

        return prom;
    },

    shortCircuit: function shortCircuit() {
        return $promise.reject(new _error.$ShortCircuit());
    }
});

angular.value("$promise", $promise);
_util.$util;

_error.$ShortCircuit;

/***/ }),

/***/ "../node_modules/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$unresolved = exports.$util = exports.isUnsafeRedirect = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getRedirectUrl = $getRedirectUrl;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var redirected = false;
var paramCache = {};

var blacklist = ['password', 'pr_password'];
var blacklistRegex = new RegExp('(' + blacklist.join('|') + ')=([^&]*)', 'g');
var sanitizeUrlForLogging = function sanitizeUrlForLogging(inputUrl) {
    return inputUrl.replace(blacklistRegex, function (match, key, value) {
        return key + '=**';
    });
};

var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
    return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {

    forEach: function forEach(collection, method) {
        if (collection instanceof Array) {
            for (var i = 0; i < collection.length; i++) {
                method(collection[i], i);
            }
        } else if (collection instanceof Object) {
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    method(collection[key], key);
                }
            }
        }
    },

    idleTimeout: function idleTimeout(time) {
        setTimeout(function () {
            _logger.$logger.info('page_idle');
            $util.reload();
        }, time);
    },


    reload: function reload() {
        _logger.$logger.info('reload');
        _event.$event.emit('loading');
        location.reload();
    },

    /**
     * replace:
     * Insert URL params provided and reload the window
     * This does not find the param if it already exists in the URL. It will add it again
     * @param params {Object} param - Params to add as URL params
     */
    replace: function replace(params) {
        if (params) {
            // Note: This won't replace the
            var url = $util.buildURL(location.href.split('#')[0], params);

            url = '' + url + window.location.hash;

            _logger.$logger.info('replace', { url: url });
            _event.$event.emit('loading');
            location.replace(url);
        } else {
            $util.reload();
        }
    },

    /**
    * redirect:
    * Redirects user to the given Url with options for different redirect behaviours
    * @param params {String} url - redirect url
    * @param params {Object} options - Optional param can have flags effecting behaviour of redirect
    */
    redirect: function redirect(url, options) {

        // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
        var frameBust = options && options.frameBust;

        // Optional flag for url to not show up in browsing history. Handles back button scenario from CAPE to HERMES
        var replace = options && options.replace;

        if (isUnsafeRedirect(url)) {
            // eslint-disable-line
            _logger.$logger.error('unsafe_redirect_url', {
                url: url
            });
            throw new Error('Unsafe redirect url: ' + url);
        }

        _logger.$logger.info('redirect', {
            url: sanitizeUrlForLogging(url)
        });

        _event.$event.on('$stateChangeStart', function (event) {
            _logger.$logger.info('state_change_after_redirect');
            event.preventDefault();
        });

        function redir() {

            if (redirected) {
                return;
            }

            _logger.$logger.info('redirect', {
                url: sanitizeUrlForLogging(url)
            });

            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
                if (replace) {
                    window.top.location.replace(url);
                } else {
                    window.top.location = url;
                }
            } else if (replace) {
                window.location.replace(url);
            } else {
                window.location = url;
            }

            redirected = true;
        }

        _event.$event.emit('loading');

        _logger.$logger.flush().then(redir);
        setTimeout(redir, 500);

        _logger.$logger.done();
    },

    cookiesEnabled: function cookiesEnabled() {
        var cookiesEnabled = void 0;

        document.cookie = '_cookiecheck=1';
        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return cookiesEnabled;
    },

    storageEnabled: function storageEnabled(api) {
        try {
            window[api].setItem('__feature_test__', '0');
            window[api].removeItem('__feature_test__');
            return true;
        } catch (e) {
            return false;
        }
    },

    sessionStorageEnabled: function sessionStorageEnabled() {
        return this.storageEnabled('sessionStorage');
    },

    localStorageEnabled: function localStorageEnabled() {
        return this.storageEnabled('localStorage');
    },

    params: function params(string) {

        if (typeof string !== 'string') {
            string = this.queryString().slice(1);
        }

        var params = {};

        if (!string) {
            return params;
        }

        if (paramCache[string]) {
            return $util.extend({}, paramCache[string]);
        }

        $util.forEach(string.split('&'), function (pair) {
            pair = pair.split('=');

            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
            }
        });

        paramCache[string] = params;

        return params;
    },

    queryString: function queryString() {
        if (window.location.search) {
            return window.location.search;
        } else {
            var string = window.location.href;
            var idx = string.indexOf('&');
            var rIdx = string.lastIndexOf('#');

            if (idx) {
                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
            }
        }
        return '';
    },

    queryStringSplice: function queryStringSplice(qs, insert, remove) {
        if (qs.indexOf('?') === 0) {
            qs = qs.slice(1);
        }

        var params = $util.extend(this.params(qs), insert);

        $util.forEach(remove, function (key) {
            delete params[key];
        });

        return '?' + this.paramToQueryString(params);
    },

    extend: function extend(obj, source) {

        if (!source) {
            return obj;
        }

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                obj[key] = source[key];
            }
        }

        return obj;
    },


    paramToQueryString: function paramToQueryString(params) {
        return this.filter(this.map(Object.keys(params).sort(), function (key) {
            if (!params[key]) {
                return;
            }

            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })).join('&');
    },

    param: function $param(name) {
        return this.params()[name];
    },

    hashParam: function hashParam(name) {
        return this.params(window.location.hash.slice(1))[name];
    },

    base64Decode: function base64Decode(encodedString) {
        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    base64Encode: function base64Encode(decodedString) {
        return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
        }
    },

    assert: function $assert(value, message, payload) {
        if (!value) {
            throw new Error(message, payload || {});
        }
    },

    map: function $map(array, method) {

        array = array || [];

        var results = void 0;

        if (array instanceof Array) {
            results = [];

            $util.forEach(array, function () {
                results.push(method.apply(this, arguments));
            });

            return results;
        } else if (array instanceof Object) {

            results = {};

            $util.forEach(array, function (val, key) {
                results[key] = method.apply(this, arguments);
            });

            return results;
        } else {
            throw new Error('$util.map expects array or object');
        }
    },

    filter: function $filter(array, method) {
        method = method || Boolean;
        var results = [];

        $util.forEach(array, function (item) {
            if (method.apply(this, arguments)) {
                results.push(item);
            }
        });

        return results;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#find()
     * If you have an object, use the lodash or underscore .find() method
     *
     * @deprecated
     */
    find: function $find(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
        }

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return array[i];
            }
        }
    },

    findIndex: function $find(array, method) {

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return i;
            }
        }
    },

    range: function range(start, end) {
        if (!end) {
            end = start;
            start = 0;
        }

        var result = [];

        for (var i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    },

    pad: function $pad(string, n, char) {

        n = n || 0;
        char = char || '0';

        var padding = Array(n + 1).join(char.toString());

        return (padding + string).slice(-n);
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
     * the return value of $util.some() isn't always a Boolean. It's return value
     * is whatever the passed callback returns. If you are using $util.some to
     * find an object in an array then you need to use $util.find instead of Array#some().
     * Ex:
     *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
     *          preferredCard will be the preferred card object or undefined if there isn't a
     *          preferred card.
     *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
     *          Taking the code from #1 and simply swapping out $util.some for Array#some()
     *          will result in a different return value, in this case the Boolean true if
     *          there is a preferred card, otherwise false. In this case, instead of using
     *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
     *          as seen below:
     *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
     *
     * If you have an object, use the lodash or underscore .some() method
     *
     * @deprecated
     */
    some: function $some(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.');
        }

        var result = void 0;

        $util.forEach(array, function (item, key) {
            if (!result) {
                result = method(item, key);
            }
        });

        return result;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#every()
     * If you have an object, use the lodash or underscore .every() method
     *
     * @deprecated
     */
    every: function $every(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
        }

        method = method || Boolean;

        var result = true;

        $util.forEach(array, function (item) {
            if (!method(item)) {
                result = false;
            }
        });

        return result;
    },

    reduce: function $reduce(array, method, intial) {
        $util.forEach(array, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            intial = method.apply(undefined, [intial].concat(args));
        });

        return intial;
    },

    isPopup: function isPopup() {
        return _integration.$integration.isPopup();
    },

    isIFrame: function isIFrame() {
        return _integration.$integration.isIFrame();
    },

    buildURL: function buildURL(url, params) {
        /*
         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
         */
        this.assert(url, 'buildURL :: expected url');

        var paramKeys = Object.keys(params || {});

        if (JSON.stringify(params) === '{}') {
            return url;
        }

        if (!paramKeys.length) {
            return url;
        }

        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }

        url += this.paramToQueryString(params);

        return url;
    },

    paypalURL: function paypalURL(url, params) {
        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;

        return this.buildURL(url, params);
    },

    override: function override(obj, methodName, handler) {
        var existing = obj[methodName];

        obj[methodName] = function () {
            if (existing) {
                try {
                    existing.apply(obj, arguments);
                } catch (err) {
                    _logger.$logger.error(methodName + 'event_error', {
                        error: err.toString
                    });
                }
            }

            return handler.apply(obj, arguments);
        };
    },

    result: function result(method) {
        return method();
    },

    memoize: function memoize(method) {

        function memoized() {
            var key = JSON.stringify(arguments, function (_, value) {
                switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
                    case 'function':
                        throw new Error('Cannot memoize functional arguments');
                    case 'undefined':
                        return 'undefined';
                    default:
                        return value;
                }
            });

            if (!memoized.cache.hasOwnProperty(key)) {
                memoized.cache[key] = method.apply(this, arguments);
            }

            return memoized.cache[key];
        }

        memoized.cache = {};

        memoized.flush = function () {
            memoized.cache = {};
        };

        return memoized;
    },

    now: function now() {
        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
    },

    bindObject: function bindObject(obj, self) {
        return $util.map(obj, function (method) {
            return method.bind(self);
        });
    },

    hashStr: function hashStr(str) {
        var hash = 0;
        var i = void 0;
        var chr = void 0;
        var len = void 0;

        if (str.length === 0) {
            return hash;
        }
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
            // Convert to 32bit integer
            hash |= 0; // eslint-disable-line no-bitwise
        }
        return Math.abs(hash);
    },

    hash: function hash() {
        return this.hashStr(Math.random());
    },

    popup: function popup(name, url, options, callback) {

        callback = $util.once(callback);

        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
            return key + '=' + options[key];
        }).join(', '));

        var interval = void 0;

        function checkWindowClosed() {
            if (win.closed) {
                clearInterval(interval);
                callback();
            }
        }

        interval = setInterval(checkWindowClosed, 50);
        setTimeout(checkWindowClosed);

        try {
            var close = win.close;

            win.close = function () {
                close.apply(this, arguments);
                checkWindowClosed();
            };
        } catch (err) {
            // pass
        }

        return win;
    },

    unique: function unique(collection) {
        return collection.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    monkeyPatch: function monkeyPatch(mod, prop, method) {
        var original = mod[prop];

        mod[prop] = function () {
            var _this = this,
                _arguments = arguments;

            return method.call(this, arguments, function (self, args) {
                if (original) {
                    return original.apply(self || _this, args || _arguments);
                }
            });
        };
    },
    once: function once(method) {
        var called = false;

        return function () {
            if (!called) {
                called = true;
                return method.apply(this, arguments);
            }
        };
    },
    camelToDasherize: function camelToDasherize(string) {
        return string.replace(/([A-Z])/g, function (g) {
            return '-' + g.toLowerCase();
        });
    },
    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1];
        }).toUpperCase();
    },
    dasherizeToCamel: function dasherizeToCamel(string) {
        return string.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },


    parentWindow: function parentWindow() {
        if (window.opener) {
            return window.opener;
        } else if (window.parent !== window) {
            return window.parent;
        }
    },

    hasRTL: function hasRTL(str) {
        return new RegExp('[\u0590-\u07BF]').test(str);
    },
    noop: function noop() {// eslint-disable-line no-empty-function

    },


    /**
     * @function isObject - tests to see if a passed argument is an Object. Returns `false`
     *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
     *      as well as for `null` and `Object.create(null)`
     * @param {*} o
     * @returns {boolean}
     */
    isObject: function isObject(o) {
        var oAsString = Object.prototype.toString.call(o);

        return o instanceof Object && oAsString === '[object Object]';
    },


    /**
     * @function debounce
     * @param {function} callback
     * @param {number} time
     * @returns {function}
     */
    debounce: function debounce(callback, time) {
        var timeout = void 0;

        return function () {
            var _this2 = this;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var functionCall = function functionCall() {
                return callback.apply(_this2, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
        };
    },


    /**
     * @function getProperty
     * @param {object} obj
     * @param {string} propString
     * @param {string} splitOn
     * @returns {*}
     *
     * Ex:
     *  const obj = {
     *      a: {
     *          b: {
     *              c: 'property c'
     *          },
     *          'key.with.periods': 10
     *      }
     *  };
     *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
     *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
     *  const fDefault = $util.getProperty(
     *      obj,
     *      'a.b.c.d.e.f',
     *      { default: 'default value for f' }
     *  ); // f === 'default value for f'
     *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
     */
    getProperty: function getProperty(obj) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$splitOn = options.splitOn,
            splitOn = _options$splitOn === undefined ? '.' : _options$splitOn,
            defaultValue = options['default'];


        if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
            return;
        }

        var pathArray = path.split(splitOn);
        var prop = obj[pathArray.shift()];

        while (prop && pathArray.length && this.isObject(prop)) {
            prop = prop[pathArray.shift()];
        }

        return pathArray.length || prop === undefined ? defaultValue : prop;
    }
};

var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };

function $getRedirectUrl(product, params) {
    var url = '';
    var urlParams = $util.params();

    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
    }

    url += _config.$config.urls.fallbackUrl[product];

    $util.extend(urlParams, params || {});

    // cmd is a reserved slingshot param
    if (urlParams.cmd) {
        delete urlParams.cmd;
    }

    return $util.buildURL(url, urlParams);
}

function $dispatch(product, params, stateChange) {
    $util.assert(product, 'expected product');

    _logger.$logger.log('info', 'dispatch', {
        product: product
    });

    _event.$event.emit('loading');

    var url = '';

    url = $getRedirectUrl(product, params);

    // fire an event for xo-tracking to listen to and do fpti logging
    if (stateChange) {
        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
    }

    return $util.redirect(url);
}

function $experiment(name, sample, id, loggerPayload) {

    var throttle = $util.hashStr(name + '_' + id) % 100;

    var group = void 0;

    if ($util.param(name) === 'true') {
        group = 'test_forced';
    } else if ($util.param(name) === 'false') {
        group = 'control_forced';
    } else if (throttle < sample) {
        group = 'test';
    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
        // eslint-disable-line no-extra-parens
        group = 'control';
    } else {
        group = 'throttle';
    }

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: name,
        pxp_trtmnt_id: group
    });

    _logger.$logger.info(name + '_' + group, loggerPayload || {});

    if (group === 'test' || group === 'test_forced') {
        return true;
    } else if (group === 'control') {
        return false;
    }
}

angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;

_logger.$logger;

_config.$config;

_config.$meta;

_integration.$integration;

_angular.$log;

/***/ }),

/***/ "../node_modules/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _ng = __webpack_require__("../node_modules/squid/dist/ng/index.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paypal[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCurrencySymbol = exports.truncateCurrencyConversionString = undefined;
exports.roundingAndSeparators = roundingAndSeparators;
exports.formatCurrency = formatCurrency;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g'); // everything to do with currency formatting

// quick Griffin reference on currency format:
// ¤ : Currency Symbol = $
// # : Amount = 186432.431
// C : Currency Code = USD

var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
var ENDS_IN_WHITESPACE = new RegExp('\s$');
var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex

// This seems to be the only currency / locale specific exception in Griffin
var STYLE_EXCEPTION = {
    'tr TR TRY': '# ¤;-# ¤'
};

var AmountOnlyStyle = '#;-#'; // A currency style for number only. $9USD -> 9.00

// Griffin exceptions for separators at hundreds- xx,xx,xxx format
var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];

var isObject = function isObject(param) {
    return Object.prototype.toString.call(param) === '[object Object]';
};

// Griffin "fuzzy logic"
// apparently if the symbol is at least "66% similar" to the code, ignore it
function maybeIgnoreSymbol(style, symbol, code) {

    // THIS IS NOT COMMUTATIVE
    function fuzzyMatch(code, symbol) {
        // eslint-disable-line no-shadow
        if (code === symbol) {
            return 100;
        } else {
            var codeParts = code.split('');
            var symbolParts = symbol.split('');
            var equivalency = codeParts.reduce(function (equiv, codePart) {
                var symbolPos = symbolParts.indexOf(codePart);

                if (symbolPos !== -1) {
                    symbolParts.splice(symbolPos, 1);
                    return equiv + 1;
                }
                return equiv;
            }, 0);
            var weight = equivalency / codeParts.length;

            return weight * 100;
        }
    }

    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;

    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
}

// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
// and thousand separators
function roundingAndSeparators(amountString, _ref, _ref2) {
    var lang = _ref.lang,
        country = _ref.country;
    var decimalPlaces = _ref2.decimalPlaces,
        dot = _ref2.dot,
        comma = _ref2.comma;

    var value = parseFloat(amountString);
    var truncate = decimalPlaces === 0;
    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
    var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
    var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
    var decimalString = amountParts[1] || '00';

    return truncate ? wholeString : '' + wholeString + dot + decimalString;
}

// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
function forceCodeToRight(style) {
    var parts = CODE_IN_FRONT.exec(style) || [];
    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
    var newStyle = style;

    // if CODE_IN_FRONT regex matches, array indexes -
    // [1] negative symbol plus whitespace, if any,
    // [2] the "C" plus any whitespace,
    // [3] whatever is after "C"
    if (parts.length === 4) {
        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
    }

    return newStyle;
}

// deal with
// 1. exceptions for specific locales
// 2. positive and negative styles
// 3. griffin fuzzy logic
// 4. UED consistency logic
function getFinalStyle() {
    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
    var _ref3 = arguments[1];
    var lang = _ref3.lang,
        country = _ref3.country;
    var _ref4 = arguments[2];
    var value = _ref4.value,
        _ref4$symbol = _ref4.symbol,
        symbol = _ref4$symbol === undefined ? '' : _ref4$symbol,
        code = _ref4.code;

    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
    var currencyStyle = exception || styleString;

    var _currencyStyle$split = currencyStyle.split(';'),
        positiveStyle = _currencyStyle$split[0],
        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;


    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions

    return forceCodeToRight(griffinStyle);
}

// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
// and produce the final result.
//
// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
    var symbol = _ref5.symbol,
        code = _ref5.code,
        _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
        wrapCodeInSpan = _ref5$wrapCodeInSpan === undefined ? false : _ref5$wrapCodeInSpan;

    // the style will take care of negative symbol (see getFinalStyle function above)
    var absoluteAmountFormatted = amountFormatted.replace('-', '');

    // parallel operation is safer than serial replace
    return finalStyle.split('').map(function (char) {
        switch (char) {
            case 'C':
                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
            case '¤':
                return symbol;
            case '#':
                return absoluteAmountFormatted;
            default:
                return char;
        }
    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
}

/**
 * @function formatCurrency
 * @param {string|number} amount Amount can be a string or a number
 * @param {string} code
 * @param {boolean} wrapCodeInSpan
 * @param {string} [style=SymbolISOCurrency]
 * @returns {string} formatted currency string
 */
function formatCurrency(amount, code, wrapCodeInSpan) {
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';

    if (isObject(amount) || typeof amount === 'undefined' || amount === null) {
        return;
    }

    var _ref6 = _locale.$locale.metadata || {},
        _ref6$number = _ref6.number,
        numberConfig = _ref6$number === undefined ? {} : _ref6$number,
        _ref6$currency = _ref6.currency,
        currencyConfig = _ref6$currency === undefined ? {} : _ref6$currency;

    var _currencyConfig$digit = currencyConfig.digits,
        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
        _currencyConfig$style = currencyConfig.styles,
        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
        _currencyConfig$suppo = currencyConfig.supportedSymbols,
        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;

    var value = parseFloat(amount);

    styles.AmountOnlyStyle = AmountOnlyStyle;
    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, { decimalPlaces: digits[code], dot: dot, comma: comma });

    if (code) {
        var symbol = currencySymbols[code];
        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });

        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
    }

    return amountFormatted; // HTML?
}

/**
 * @function truncateCurrencyConversionString
 * @description Takes a fullString, amount, and amountForex and truncates
 *      the number in the full string to number of digits in amountForex.
 *      This function is used to format the PayPal currency conversion
 *      rate that is displayed to the user (e.g. '1 CAD = $0.7459 USD')
 *      e.g. inputs of:
 *          fullString = '$0.745994235 USD'
 *          amount = '0.745994235'
 *          amountForex = '0.7459'
 *      results in an output of '$0.7459 USD'
 * @param {object} Contains keys 'fullString', 'amount', and 'amountForex'
 * @returns {string}
 */
var truncateCurrencyConversionString = exports.truncateCurrencyConversionString = function truncateCurrencyConversionString() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fullString = _ref7.fullString,
        amount = _ref7.amount,
        amountForex = _ref7.amountForex;

    var allArgsAreStrings = [fullString, amount, amountForex].every(function (s) {
        return typeof s === 'string';
    });

    if (!allArgsAreStrings) {
        return fullString || '';
    }

    // Some countries, e.g. France, use commas instead of decimals
    var target = amountForex.includes(',') ? amount.replace('.', ',') : amount;

    return fullString.replace(target, amountForex);
};

/**
 * @description takes a currency code and
 *  returns either a code or a symbol based
 *  on our currency mapping.
 *  eg: USD -> $ , RUB -> RUB
 *
 * @param {*} code
 * @returns {string}
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(code) {
    var _ref8 = _locale.$locale.metadata || {},
        _ref8$currency = _ref8.currency,
        currency = _ref8$currency === undefined ? {
        supportedSymbols: {}
    } : _ref8$currency;

    return currency.supportedSymbols[code];
};

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$feature = $feature;
exports.$featureCountries = $featureCountries;

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

function $feature(prop, def, country) {

    var features = _core.$config.features || {};

    country = country || _locale.$locale.country;
    // 1. Check the feature is present in country
    var result = _core.$Class.get(features[country], prop);

    if (result !== undefined) {
        return result;
    }
    // 2. Check the feature is present in feature group

    Object.keys(_core.$config.regions).some(function (region) {
        if (_core.$config.regions[region].indexOf(country) !== -1) {
            result = _core.$Class.get(features[region], prop);
            return result !== undefined;
        }

        return false;
    });

    if (result !== undefined) {
        return result;
    }
    // 3. Check the feature is present in default group
    result = _core.$Class.get(features.DEFAULT, prop);

    if (result !== undefined) {
        return result;
    }
    return def;
}

// Build a list of all countries in our feature list and regions
// populate countries with out REGION names in the list
var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
});

// populate all the region countries in to allcountries
_core.$util.forEach(_core.$config.regions, function (countries, region) {
    _core.$util.forEach(countries, function (country) {
        if (allCountries.indexOf(country) === -1) {
            allCountries.push(country);
        }
    });
});

function $featureCountries(prop) {
    // Find the countries with a certain feature enabled
    return allCountries.filter(function (country) {
        return $feature(prop, false, country);
    });
}

angular.value("$feature", $feature);
angular.value("$featureCountries", $featureCountries);
_core.$config;

_core.$Class;

_core.$util;

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _currency[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/locale/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _name = __webpack_require__("../node_modules/squid/dist/locale/name.js");

Object.keys(_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _name[key];
    }
  });
});

var _quantity = __webpack_require__("../node_modules/squid/dist/locale/quantity.js");

Object.keys(_quantity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _quantity[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
exports.sanitize = sanitize;
exports.Content = Content;
exports.$contentVersion = $contentVersion;
exports.$renderContent = $renderContent;
exports.$flushContent = $flushContent;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

function sanitize(html) {
    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
} /* eslint-disable no-use-before-define */


var JSONStringify = JSON.stringify;

JSON.stringify = function (item) {
    if (item instanceof Content) {
        return item.toString();
    }
    return JSONStringify.apply(this, arguments);
};

function Content(key, props) {
    this.key = key;
    this.props = props;
}

Content.cache = {};

Content.get = function (key, props) {

    if (!key) {
        return '';
    }

    props = props || {};

    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
    var cacheVal = Content.cache[cacheKey];

    if (cacheVal !== undefined) {
        return cacheVal;
    }

    cacheVal = Content.cache[cacheKey] = new Content(key, props);

    return cacheVal;
};

Content.prototype.toString = Content.prototype.valueOf = function () {
    if (this.string) {
        return this.string;
    }

    this.string = this.render(false);

    return this.string;
};

Content.prototype.toSafeString = function () {
    if (this.safeString) {
        return this.safeString;
    }

    this.safeString = this.render(true);

    return this.safeString;
};

Content.prototype.render = function (safe) {
    var _this = this;

    if (!this.key) {
        return '';
    }

    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
    var keys = this.key.split('.');

    for (var i = 0; i < keys.length; i++) {
        if (value) {
            value = value[keys[i]];
        } else {
            break;
        }
    }

    if (!value) {
        return '';
    }

    return value.replace(/\{\w+\}/g, function (prop) {
        prop = prop.slice(1, prop.length - 1);

        if (prop === 'country') {
            return $locale.country;
        }

        if (prop === 'lang') {
            return $locale.lang;
        }

        if (!_this.props[prop]) {
            if (!_core.$loader.isLoading()) {
                _logger.$logger.warn('missing_content_prop', {
                    key: _this.key,
                    prop: prop
                }, { unique: true });
            }

            return '';
        }

        var propStr = _this.props[prop].toString();

        if (safe) {
            return sanitize(propStr);
        }

        return propStr;
    });
};

var contentCache = {};
var currentVersion = void 0;

window.addContent = function (country, lang, content, version) {
    var countryCache = contentCache[country] = contentCache[country] || {};

    countryCache[lang] = content;
    currentVersion = version;
};

var metadataCache = {};

window.addMetadata = function (country, lang, metadata) {
    var metadataVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';

    var countryCache = metadataCache[country] = metadataCache[country] || {};

    countryCache[lang] = countryCache[lang] || {};
    countryCache[lang][metadataVersion] = metadata;
};

function $contentVersion() {
    return currentVersion || '';
}

var PP_SPECIAL_COUNTRIES_ISO_CODES = {
    C2: 'CN'
};

var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/locales/:countryCode/:lang',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                    _logger.$logger.info('cached_content');
                    return contentCache[model.countryCode][model.lang];
                }

                _logger.$logger.info('retrieve_content', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                            _logger.$logger.info('content_retrieved');
                            return contentCache[model.countryCode][model.lang];
                        }

                        throw new Error('content_not_available');
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (content) {
                model.setProperties(content);
                return content;
            });
        }
    }),

    change: function change(country, lang) {

        if (country === this.countryCode && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        this.countryCode = country;
        this.lang = lang;

        return this.reload().then(function () {
            _core.$event.broadcast('contentChange');
        });
    }
});

var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {

    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/metadata/:country/:lang/:version?/metadata',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                var metadataVersion = model.version || 'default';

                if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                    _logger.$logger.info('cached_metadata');
                    return metadataCache[model.country][model.lang][metadataVersion];
                }

                _logger.$logger.info('retrieve_metadata', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
                        if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                            _logger.$logger.info('metadata_retrieved', {
                                uri: uri
                            });
                            return metadataCache[model.country][model.lang][metadataVersion];
                        }

                        // Retry if not found in cache
                        _logger.$logger.info('metadata_not_available', {
                            uri: uri
                        });
                        return _core.$promise.reject(new Error('metadata_not_available'));
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (metadata) {
                model.setProperties(metadata);
                return metadata;
            });
        }
    }),

    setVersion: function setVersion(country, lang) {
        var _this2 = this;

        var versionPxpName = _core.$config.features[country] && _core.$config.features[country].metadataVersionName;

        if (versionPxpName && _core.$config.metadataPxpExperiments[versionPxpName]) {
            var pxp = (0, _paypal.$pxp)(_core.$config.metadataPxpExperiments[versionPxpName].experimentName, {
                'ctx.COUNTRY': country,
                'ctx.LANGUAGE': lang
            }, _core.$config.metadataPxpExperiments[versionPxpName].experimentTreatmentName);

            return pxp.then(function (treatment) {
                if (treatment) {
                    _this2.version = versionPxpName;
                    _logger.$logger.info('metadata_version_set', {
                        country: country,
                        lang: lang,
                        version: versionPxpName
                    });
                } else {
                    delete _this2.version;
                }
            })['catch'](function () {
                delete _this2.version;
            })['finally'](function () {
                return _core.$promise.resolve();
            });
        } else {
            delete this.version;
            return _core.$promise.resolve();
        }
    },

    change: function change(country, lang) {
        var _this3 = this;

        this.country = country;
        this.lang = lang;

        return this.setVersion(country, lang).then(function () {
            return _this3.reload().then(function () {
                if (!_this3.noBroadcast) {
                    _core.$event.broadcast('metadataChange');
                }
            });
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (_core.$config.supportedCountries) {
            if (!_core.$config.supportedCountries[country]) {
                country = this.country;
            }

            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
                lang = _core.$config.supportedCountries[country][0];
            }
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    normalizeAddressFields: function normalizeAddressFields(content) {

        var CONTENT_MAPPING = {
            line1Label: 'streetAddress',
            line2Label: 'streetAddress2',
            cityLabel: 'city',
            stateLabel: 'state',
            postcodeLabel: 'postalCode'
        };

        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
        for (var prop in CONTENT_MAPPING) {
            if (this.addressEntry && this.addressEntry.strings[prop]) {
                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
            }
        }
    }
});

function mapLanguage(lang) {
    var unselectableLanguages = _core.$config.unselectableLanguages || [];

    if (unselectableLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            return 'en';
        }
    }

    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];

    if (unsupportedLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            var s = lang + '_locale_not_supported';

            throw new Error(s);
        }
    }

    return lang;
}

var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
    api: new _core.$Api({
        uri: '/api/locale'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.content = $ContentModel.instance();
        this.metadata = $MetadataModel.instance();
    },

    retrieve: function retrieve() {
        var self = this;

        return this._super.retrieve.apply(this, arguments).then(function (result) {
            self.lang = mapLanguage(self.lang);
            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {

                // TODO: This at build time... or make sure griffin metadata is complete
                self.metadata.normalizeAddressFields(self.content);

                return result;
            });
        });
    },

    change: function change(country, lang) {

        var self = this;

        lang = mapLanguage(lang);

        if (country === this.country && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        _logger.$logger.info('locale_change', {
            country: country,
            lang: lang
        });

        this.country = country;
        this.lang = lang;

        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {

            // TODO: This at build time... or make sure griffin metadata is complete
            self.metadata.normalizeAddressFields(self.content);

            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
            return loadedData;
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (!_core.$config.supportedCountries[country]) {
            country = this.country;
        }

        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
            lang = _core.$config.supportedCountries[country][0];
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    chooseCountry: function chooseCountry(country) {
        return this.choose(country, null);
    },

    chooseLang: function chooseLang(lang) {
        return this.choose(null, lang);
    },

    getLocaleCode: function getLocaleCode() {
        return this.lang + '_' + this.country;
    },

    getCountryCodeISO: function getCountryCodeISO() {
        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
    }
});

var $locale = exports.$locale = $LocaleModel.instance();

function $renderContent(key, props) {
    return Content.get(key, props);
}

function $flushContent() {
    contentCache = {};
    Content.cache = {};
    $locale.content = $ContentModel.create();
    $locale.metadata = $MetadataModel.create();
    metadataCache = {};
}

var $localeHelper = exports.$localeHelper = {
    /**
     *
     * @param locale - Ex: en_US
     * @returns {{country: *, dialect}}
     */
    normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
            return {};
        }

        locale = locale.replace('-', '_');

        var country = void 0;
        var language = void 0;

        if (locale.match(/^\w{2}_\w{2}$/)) {
            locale = locale.split('_');

            language = locale[0];
            country = locale[1];
        } else {
            language = locale;
        }

        return {
            country: country,
            language: language
        };
    }
};

angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$flushContent", $flushContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;

_core.$event;

_core.$Model;

_core.$Api;

_core.$meta;

_core.$promise;

_core.$config;

_core.$loader;

_core.$dom;

_paypal.$pxp;

/***/ }),

/***/ "../node_modules/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
    givenName: 'first_name',
    surname: 'last_name'
};

// Taken from griffin-paypal: test if a string is Latin
function isLatin(str) {
    if (!str) {
        return true;
    }

    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 0x24F) {
            return false;
        }
    }

    return true;
}

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
    var layoutMetadata = _locale.$locale.metadata.nameInformal;
    var layout = null;

    if (!layoutMetadata) {
        return name.first_name || null; // Default to first name if metadata not loaded
    }

    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
        layout = layoutMetadata['latinLayout'];
    } else {
        layout = layoutMetadata['layout'];
    }

    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
    var formattedName = [];

    for (var i = 0; i < layout.length; i++) {
        var namePart = layout[i];

        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
        } else if (namePart['$'] === 'separator') {
            formattedName.push(namePart._);
        }
    }

    return formattedName.join('');
}

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatQuantity = formatQuantity;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
    var _ref = _locale.$locale.metadata || {},
        _ref$number = _ref.number,
        numberConfig = _ref$number === undefined ? {} : _ref$number;

    var dot = '';
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
}

_locale.$locale;

_currency.roundingAndSeparators;

/***/ }),

/***/ "../node_modules/squid/dist/module.js":
/***/ (function(module, exports) {



module.exports = angular.module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Component = undefined;
exports.$populate = $populate;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

(0, _directive.$registerDirective)('prevent-default', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click', function (event) {
                event.preventDefault();
            });
        }
    };
});

(0, _directive.$registerDirective)('stop-propagation', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click keydown keypress keyup', function (event) {
                event.stopPropagation();
            });
        }
    };
});

(0, _directive.$registerDirective)('validate-submit', function () {

    return {
        link: function link($scope, $element, $attrs) {

            var $form = $element.closest('form');
            var form = $scope[$form.prop('name')];
            var formID_element = $attrs.form; // take the form attribute from submit button
            var formID_linked = $element[0] // take the id from the linked form element
            && $element[0].form && $element[0].form.id;
            var isLinkedForm = formID_element && formID_element === formID_linked; // Checking for confirmation. May not be required. Presence should be good enough.

            if (isLinkedForm) {
                $form = angular.element(document.getElementById(formID_linked));
                var scope = $form.scope(); // Linked forms should mantain form scope

                form = scope[$form.prop('name')];
            }

            $element.on('click', function (event) {
                event.preventDefault();

                $form.addClass('validated');
                $scope.validated = true;
                form.$setSubmitted();

                if (form.$valid) {
                    try {
                        $scope.$eval($attrs.validateSubmit);
                    } catch (err) {
                        _angular.$injector.get('$exceptionHandler')(err);
                    }
                } else {
                    $form.find('.ng-invalid:first').focus();
                }
            });
        }
    };
});

function assertModelsRetrievedOrEmpty(items) {
    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
        angular.forEach(items, function (item, name) {
            if (item instanceof _core.$Model) {
                if (item.meta.populated) {
                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
                }
            }
        });
    }
}

function setUpComponentRoute($scope, $Component, angular) {
    var componentRoute = $scope.componentRoute;

    componentRoute.scope = $scope;

    componentRoute.scope.goto = function (route) {
        componentRoute.goto(route);
    };

    var parentRoute = componentRoute.parent;

    if (parentRoute) {
        var parentScope = parentRoute.scope;
        var parentDirective = parentRoute.getDirective();
        var childSpec = componentRoute.childSpec;

        if (childSpec.config) {
            if (parentDirective instanceof $Component) {
                parentScope.viewConfig = childSpec.config.call(parentScope);
            } else {
                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }

        if (childSpec.props) {
            if (parentDirective instanceof $Component) {
                angular.extend($scope, childSpec.props.call(parentScope));
            } else {
                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }
    }
}

var $Component = exports.$Component = _core.$Class.extend('$Component', {

    onPopulate: angular.noop,

    init: function init() {
        var _this = this,
            _arguments = arguments;

        this.validate();

        this.name = _core.$util.dasherizeToCamel(this.tag);

        var wrapperType = this.wrapperType === 'span' ? 'span' : 'div';

        this.template = '<' + wrapperType + ' class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</' + wrapperType + '>';

        this.scope = this.scope || {};
        this.resolve = this.resolve || {};
        this.props = this.props || {};
        this.rootEvents = this.rootEvents || {};

        this.actions = this.actions || {};

        this.lifecycle = this.lifecycle || {};
        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
        this.lifecycle.populate = this.lifecycle.populate || angular.noop;

        if (this.scope && Object.keys(this.scope).length) {

            if (this.props && Object.keys(this.props).length) {
                throw new Error('Can not defined scope and props on the same component');
            }

            this.scope.componentRoute = '=';
            this.scope['export'] = '@';

            this.props = _core.$util.map(this.scope, function (type, key) {
                return {
                    type: {
                        '=': 'var',
                        '@': 'str'
                    }[type],
                    required: false
                };
            });
        } else {

            this.props.componentRoute = {
                type: 'var',
                required: false
            };

            this.props['export'] = {
                type: 'str',
                required: false
            };

            var isRequired = function isRequired() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    required = _ref.required,
                    optional = _ref.optional;

                return [true, 'true'].indexOf(required) > -1 || [false, 'false'].indexOf(optional) > -1;
            };

            this.scope = _core.$util.map(this.props, function (spec, key) {
                return {
                    'var': isRequired(spec) ? '=' : '=?',
                    str: isRequired(spec) ? '@' : '@?'
                }[spec.type || 'var'];
            });
        }

        var originalController = this.controller || angular.noop;

        this.controller = ['$scope', '$element', function ($scope, $element) {
            $scope.$element = $element;

            $scope.$on('$destroy', function () {
                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
                    delete $scope.componentRoute.parent.scope.viewConfig;
                }
                _this.lifecycle.exit.call($scope);
            });

            $scope.props = {};

            if ($scope.componentRoute) {
                setUpComponentRoute($scope, $Component, angular);
            }

            angular.forEach(_this.props, function (type, key) {

                var prop = _this.props[key];
                var required = prop.required !== false;
                var def = void 0;

                if (prop['default'] instanceof Function) {
                    def = _core.$util.memoize(prop['default'].bind($scope));
                } else {
                    def = function def() {
                        return prop['default'];
                    };
                }

                var UNDEFINED = {
                    'var': undefined,
                    str: ''
                }[prop.type];

                Object.defineProperty($scope.props, key, {
                    get: function get() {
                        var val = $scope[key];

                        if (val === UNDEFINED) {
                            if (required) {
                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
                            }

                            return def();
                        }

                        return val;
                    },

                    set: function set() {
                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
                    }
                });
            });

            $scope.fields = {};

            $scope.actions = _core.$util.bindObject(_this.actions, $scope);

            Object.keys(_this.rootEvents).forEach(function (eventName) {
                var cancel = _core.$event.on(eventName, function (event) {
                    _this.rootEvents[eventName].apply($scope, _arguments);
                });

                $scope.$on('$destroy', cancel);
            });

            $scope.display = true;

            $scope.reload = function () {

                if (!$scope.populated) {
                    throw new Error('Can not reload unpopulated component');
                }

                $scope.display = false;
                setTimeout(function () {
                    $scope.display = true;
                });
            };

            $scope.componentScope = $scope;

            if ($scope.props['export'] && $scope.$parent.componentScope) {

                $scope.exports = angular.extend({}, _this.exports || {}, {
                    reload: $scope.reload
                });

                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
                    get: function get() {
                        return $scope.exports;
                    },

                    configurable: true
                });
            }

            $scope._enablePopulateEvents = true;

            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
            _this.lifecycle.enter.call($scope);

            $scope._enablePopulateEvents = false;

            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
                if (toState === $scope.props.componentRoute) {
                    _this.lifecycle.reenter.call($scope);
                }
            });

            $scope.$on('$destroy', cancelReEnterEvent);

            return _core.$promise.sequential([function () {
                $scope.$emit('_populating');
            }, function () {
                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {

                    if (angular.isObject(resolver)) {
                        $scope[name] = resolver;
                        return resolver;
                    }

                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
                        assertModelsRetrievedOrEmpty(data);

                        return _core.$promise.hash(data).then(function (resolvedData) {

                            $scope[name] = resolvedData;
                            return resolvedData;
                        });
                    });
                });
            }, function () {

                $scope.populated = true;

                $scope.$emit('_populated');

                _core.$event.refCount($scope, '_populating', '_populated').then(function () {

                    $scope.$on('populated', function (populatedEvent) {
                        populatedEvent.stopPropagation();
                    });

                    $scope.$emit('populated');
                    _this.onPopulate.call($scope);
                    _this.lifecycle.populate.call($scope);
                });
            }]);
        }];
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var componentName = this.constructor.name;

        if (!this.tag) {
            throw new Error(componentName + ' :: expected property \'tag\'');
        }

        if (!this.tag.match(/^[a-z0-9-]+$/)) {
            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
        }

        if (!this.template) {
            throw new Error(componentName + ' :: expected property \'template\'');
        }

        if (this.resolve) {
            angular.forEach(this.resolve, function (resolver, name) {
                if (!(resolver instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
                }
            });
        }

        if (this.props) {
            angular.forEach(this.props, function (prop, name) {

                if (!(prop instanceof Object)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
                }

                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
                }

                if (prop['default'] && prop.required) {
                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
                }

                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
                }
            });
        }

        if (this.actions) {
            angular.forEach(this.actions, function (action, name) {
                if (!(action instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
                }
            });
        }

        if (this.lifecycle) {
            Object.keys(this.lifecycle).forEach(function (name) {
                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
                }
            });
        }
    }
});

$Component.reopenClass({

    extend: function extend() {

        var SubClass = _core.$Class.extend.apply(this, arguments);
        var spec = new SubClass();

        angular.module().directive(spec.name, function () {
            return spec;
        });

        return SubClass;
    },

    render: function render(scope) {
        _core.$event.emit('$resetState');

        var $scope = _angular.$rootScope.$new();

        angular.extend($scope, scope);

        var attrs = Object.keys(scope).map(function (key) {
            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
        }.bind(this)).join(' ');

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';

        console.log('RENDER', html, scope);

        var element = (0, _angular.$compile)(html)($scope);

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            element.remove();
        }));

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        element.updateProps = function (props) {
            angular.extend($scope, props);
            $scope.$digest();
            setTimeout.flush();
        };

        return element;
    }
});

function autoConvertDirectiveToComponent(_ref2, original) {
    var name = _ref2[0],
        factory = _ref2[1];


    if (!angular.isFunction(factory)) {
        return original();
    }

    var tag = _core.$util.camelToDasherize(name);
    var spec = _angular.$injector.invoke(factory);

    if (spec.controller) {
        var originalController = spec.controller;

        spec.controller = ['$scope', '$element', function ($scope, $element) {
            $scope._enablePopulateEvents = true;
            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });

            $scope._enablePopulateEvents = false;
            return result;
        }];
    }

    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
        return original(this, [name, function () {
            return spec;
        }]);
    }

    if (spec.componentize) {

        $Component.extend('$' + name + 'Component', spec, {
            tag: tag
        });

        return this;
    }

    return original(this, [name, function () {
        return spec;
    }]);
}

_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {

    $scope.$on = $scope.$on || angular.noop;
    $scope.$emit = $scope.$emit || angular.noop;

    var _enablePopulateEvents = $scope._enablePopulateEvents;

    if (_enablePopulateEvents) {
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
            $scope.$emit('populated');
        });
    }

    $scope.$on('populated', function (populatedEvent) {
        populatedEvent.stopPropagation();
    });

    if (_enablePopulateEvents) {
        $scope.$emit('_populating');
    }

    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {

        var promise = void 0;

        if (instance.then) {
            promise = instance;
        } else {
            promise = instance.retrieve();
            $scope[name] = instance;
        }

        return promise.then(function (result) {
            $scope[name] = result;
            return result;
        });
    })).then(function (result) {

        if (_enablePopulateEvents) {
            $scope.$emit('_populated');
        }

        return result;
    });
}

angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;

_angular.$compile;

_angular.$injector;

_angular.$compileProvider;

_core.$Class;

_core.$Model;

_core.$util;

_core.$promise;

_core.$config;

_core.$event;

_ng.$cleanRootScope;

_directive.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.use({
    on: function on() {
        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
    },
    once: function once(name, handler) {
        var cancel = _core.$event.on(name, function () {
            cancel();
            handler.apply(this, arguments);
        }, true);

        return cancel;
    },
    emit: function emit() {
        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
    },
    broadcast: function broadcast() {
        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
    }
});

_core.$promise.use(_angular.$q);

_angular.$q;

_angular.$rootScope;

_core.$event;

_core.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$registerDirective = $registerDirective;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function $registerDirective(tag, definition) {

    var directiveName = tag.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });

    return _angular2["default"].module().directive(directiveName, definition);
}

_angular2["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "../node_modules/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

angular.module().run(function () {

    _core.$event.on('$stateChangeStart', function (event) {
        _core.$event.emit('loading');
        _core.$event.emit('loaded');
    });

    var startLoadTime = 0;
    var currentState = 'checkout_init';

    function currentStateName() {
        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
    }

    _core.$event.on('startLoad', function () {

        if (startLoadTime) {
            startLoadTime = _core.$util.now();
        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {

            var performance = window.performance;
            var timing = window.performance.timing || {};
            var now = performance.now();

            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
    });

    _core.$event.on('allLoaded', function () {

        var newState = currentStateName();

        if (!newState) {
            return;
        }

        if (currentState === newState) {
            _core.$event.emit('page_reloaded', currentState);
        } else {

            var duration = void 0;

            if (startLoadTime) {
                duration = _core.$util.now() - startLoadTime;
            }

            var payload = {
                start: currentState,
                end: newState,
                time: duration,
                duration: duration
            };

            _core.$event.emit('$transition', {
                from: currentState,
                toState: _uiRouter.$state.current,
                duration: duration
            });

            _logger.$logger.info('transition', payload);
            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);

            _core.$event.emit('page_loaded', currentState, newState);
            _logger.$logger.flush();

            currentState = newState;
        }
    });

    _core.$event.emit('loading');

    var cancel = _core.$event.on('$stateChangeSuccess', function () {
        if (_uiRouter.$state.current.template) {
            cancel();
            setTimeout(function () {
                _core.$event.emit('loaded');
            }, 50);
        }
    });
});

_uiRouter.$state;

_logger.$logger;

_core.$event;

_core.$util;

/***/ }),

/***/ "../node_modules/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {



var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

(0, _directive.$registerDirective)('feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
            };
        }
    };
});

(0, _directive.$registerDirective)('unless-feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="!enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
            };
        }
    };
});
_directive.$registerDirective;

_locale.$feature;

_core.$integration;

/***/ }),

/***/ "../node_modules/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _core = __webpack_require__("../node_modules/squid/dist/ng/core.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _route = __webpack_require__("../node_modules/squid/dist/ng/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _component[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/ng/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/ng/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _module = __webpack_require__("../node_modules/squid/dist/ng/module.js");

Object.keys(_module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _module[key];
    }
  });
});

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _events = __webpack_require__("../node_modules/squid/dist/ng/events.js");

Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _events[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/ng/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

Object.keys(_lazyLoadRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lazyLoadRoutes[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/ng/lazyLoadRoutes.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.lazyLoadRoute = exports.findRelativeState = exports.initRoute = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var getHash = function getHash(url) {
    if (!url || !~url.indexOf('#')) {
        // eslint-disable-line no-bitwise
        return;
    }

    url = url.split('#');
    return url[url.length - 1];
};

/**
 *
 * get parent state, e.g "checkout.sidebar.addCard" -> "checkout.sidebar"
 */
var getParentState = function getParentState(path) {
    return _uiRouter.$state.get(path.slice(0, path.lastIndexOf('.')));
};

/**
 * Find route by slug
 * path - full path of the current route, e.g "checkout.payWithSelection"
 * slug - path of the route that we want to search, e.g "payWithSelection"
 */
var getRoute = function getRoute(path, slug) {
    var route = getParentState(path);

    if (!route) {
        return;
    }
    var children = route.children;

    if (children) {
        return children.find(function (child) {
            return child.slug === slug;
        });
    }
};

/**
 * Lazy load children routes in the background
 */
var lazyLoadChildren = function lazyLoadChildren(children) {
    if (children) {
        _logger.$logger.info('lazy_loading_route_load_children');
        children.forEach(function (child) {
            if (child.lazyRoute) {
                // request to download js chunk (dynamic import)
                child.lazyRoute();
            }
        });
    }
};

/**
 * Dynamically load route and initialize / register it
 * @param {Object} routeObj - route object from Route definition, e.g
 *  {
 *      name: '$PayWithSelection',
 *      slug: 'payWithSelection',
 *      lazyRouter: () => import('pages/payWithSelection/route)
 *  }
 *
 * @param {Route} parent - parent of the passed routeObj
 * @param {String} fullRoutePath - full path of the route, e.g "checkout.payWithselection"
 */
var initRoute = exports.initRoute = function initRoute(routeObj, parent, fullRoutePath) {
    if (!routeObj) {
        return;
    }

    var name = routeObj.name,
        slug = routeObj.slug,
        attributes = routeObj.attributes,
        lazyRoute = routeObj.lazyRoute;


    _logger.$logger.info('lazy_loading_route_init', {
        name: name,
        slug: slug,
        fullRoutePath: fullRoutePath
    });

    return lazyRoute().then(function (route) {
        if (!route) {
            return;
        }
        if ((typeof route === 'undefined' ? 'undefined' : _typeof(route)) === 'object') {
            route = route[name];
        }
        var childRoute = new route({ //eslint-disable-line
            parent: parent || getParentState(fullRoutePath),
            childSpec: _core.$util.extend(routeObj, { route: route }),
            childAttributes: attributes
        });
        childRoute.register();
        return childRoute;
    });
};

/**
 * Promisify all lazy routes
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes
 *      1. Go through each possible route, e.g 'checkout', 'checkout.sidebar', 'checkout.sidebar.addCardFlow', 'checkout.sidebar.addCardFlow.addCard'
 *      2. Check if each exists / already registered
 *      3. if route is not registered -> find that route and return promise
 * @param {String} targetState full path of the target route
 * Returns an array of promisified functions
 */
var findAndPromisifyRoutes = function findAndPromisifyRoutes(targetState) {
    var splittedTargetState = targetState.split('.');
    var states = splittedTargetState.slice(1);
    var routes = [];
    var path = splittedTargetState[0];

    states.forEach(function (state) {
        path += '.' + state;
        var fullRoutePath = path;

        if (!_uiRouter.$state.get(path)) {
            routes.push(function (parent) {
                var route = getRoute(fullRoutePath, state);

                return initRoute(route, parent, fullRoutePath);
            });
        }
    });
    return routes;
};

/**
 * Checks if it's a relative path (having `.` or `^`)
 * @param {String} stateName - path of the state, e.g `.mychildRoute`
 */
var isRelative = function isRelative(stateName) {
    return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
};

/**
 * finds a full path of the relative state name
 * examples:
 * '^' - will go to a parent state
 * '^.sibling' - will go to a sibling state
 * '.child.grandchild' - will go to grandchild state
 * @param {String / Object} stateOrName - state to find, e.g `^.selectFi`
 * Returns full path name of the state, e.g `^.selectFi` -> `checkout.selectFi`
 */
var findRelativeState = exports.findRelativeState = function findRelativeState(stateOrName) {
    if (!stateOrName) {
        return;
    }
    var base = _uiRouter.$state.current;

    var rel = stateOrName.split('.');
    var current = base;
    var i = 0;

    for (; i < rel.length; i++) {
        if (rel[i] === '' && i === 0) {
            current = base;
            continue;
        }
        if (rel[i] === '^') {
            if (!current.parent) {
                throw new Error('lazy-loading: path \'' + stateOrName + '\' not valid for state \'' + base.name + '\'');
            }
            current = current.parent;
            continue;
        }
        break;
    }
    rel = rel.slice(i).join('.');
    return current.name + (current.name && rel ? '.' : '') + rel;
};

/**
 * Lazy load route and redirect if successfull or reject if route was not found
 * Note: routes will be loading sequentialy for now to load parent routes first if they are lazy as well.
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes and represent separate js chunk
 *      We have to load each js chunk in order one by one to be able to register them and attach to corresponding parents.
 * @param {String} targetState - route path, e.g 'checkout.payWithSelection'
 * @param {Object} targetParams - params which route may need
 * @param {Boolean} shouldChangeState - if state should be changed after route is loaded
 */
var lazyLoadRoute = exports.lazyLoadRoute = function lazyLoadRoute(targetState) {
    var targetParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shouldChangeState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!targetState) {
        return _core.$promise.reject(new Error('lazy_loading_target_state_is_empty'));
    }
    _logger.$logger.info('lazy_loading_route', {
        targetState: targetState,
        targetParams: targetParams
    });
    if (isRelative(targetState)) {
        targetState = findRelativeState(targetState, _uiRouter.$state.current);
    }
    _core.$event.emit('loading');

    var routes = findAndPromisifyRoutes(targetState);

    return _core.$promise.sequential(routes).then(function (result) {
        if (_uiRouter.$state.get(targetState)) {
            if (result) {
                lazyLoadChildren(result.children);
            }
            _logger.$logger.info('lazy_loading_route_state_change', {
                targetState: targetState,
                targetParams: targetParams
            });
            if (!shouldChangeState) {
                return _core.$promise.resolve();
            }
            return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                if (err.message === 'transition prevented' || err.message === 'transition superseded') {
                    return _core.$promise.resolve();
                }
                return _core.$promise.reject(err);
            });
        } else {
            return _core.$promise.reject(new Error('lazy_loading_state_was_not_loaded'));
        }
    })['catch'](function (error) {
        // in case of exceptions, spinner must dissapear, because for each 'loading' event
        // that's sent in the beginning of the function must be corresponding 'loaded' event
        // otherwise, there will be infinite spinner

        _logger.$logger.info('lazy_loading_route_error', {
            targetState: targetState,
            targetParams: targetParams,
            errorMessage: error && error.message,
            errorStack: error && error.stack
        });

        return _core.$promise.reject(error);
    })['finally'](function () {
        _core.$event.emit('loaded');
    });
};

/**
 * mostly needed for use cases when user types route manually
 */
window.addEventListener('hashchange', function (event) {
    if (_config.$meta.codeSplitting) {
        var fromHash = getHash(event.oldURL);
        var toHash = getHash(event.newURL || window.location.hash);

        // skip lazy loading in case hash is undefined or empty
        // example -> <a href="#" ng-click="openModal()">OpenModal</a>
        // in that case `toHash` will be empty
        if (!toHash) {
            return;
        }

        var getHashQueryParams = function getHashQueryParams(path) {
            var splittedPath = path.split('?');
            // e.g #/checkout/genericError?code=ERROR_CODE -> code=ERROR_CODE
            var hashParams = splittedPath.length > 1 && splittedPath[1];

            if (hashParams) {
                // e.g code=ERROR_CODE -> { code: ERROR_CODE }
                return _core.$util.params(hashParams);
            }
        };
        // e.g #/checkout/review -> checkout.review
        var path = toHash.slice(1).replace(/\//g, '.');
        var hashQueryParams = getHashQueryParams(path);

        if (hashQueryParams) {
            // e.g checkout.genericError?code=ERROR_CODE -> checkout.genericError
            path = path.split('?')[0];
        }

        if (_uiRouter.$state.get(path)) {
            return;
        }

        _logger.$logger.info('hashchange_lazy_loading', {
            from: fromHash,
            to: toHash
        });

        lazyLoadRoute(path, hashQueryParams)['catch'](function () {
            _logger.$logger.info('hashchange_lazy_loading_error', {
                from: fromHash,
                to: toHash,
                params: hashQueryParams
            });
        });
    }
});

_uiRouter.$state;

_logger.$logger;

_core.$util;

_core.$promise;

_core.$event;

_config.$meta;

/***/ }),

/***/ "../node_modules/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

(0, _angular.$registerDirective)('content', function () {
    return {
        restrict: 'A',

        link: function link($scope, element, attributes) {
            $scope.content = $scope.htmlContent = function (key, props) {
                if (attributes.content) {
                    key = attributes.content + '.' + key;
                }
                var content = _locale.Content.get(key, props);

                if (content.toString()) {
                    return content;
                } else {
                    return;
                }
            };
        }
    };
});

(0, _angular.$registerDirective)('bind-html-compile', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $scope.$watch(function () {
                return $scope.$eval($attrs.bindHtmlCompile);
            }, function (value) {
                $element.html(value && value.toString());
                (0, _angular.$compile)($element.contents())($scope);
            });
        }
    };
});

(0, _angular.$registerDirective)('format-currency', function () {

    return {
        restrict: 'E',
        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
        scope: {
            amount: '=?',
            symbol: '=?',
            code: '=?',
            currencyStyle: '@?'
        },
        controller: ['$scope', function ($scope) {

            function format() {
                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
            }

            $scope.$on('$destroy', _core.$event.on('localeChange', format));

            $scope.$watch('amount', function (newValue, oldValue) {
                if (newValue !== oldValue && _locale.$locale.country) {
                    format();
                }
            });

            if (_locale.$locale.country) {
                format();
            }
        }] // controller
    }; // return
}); // registerDirective


(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().value('$sanitize', function (val) {
    if (val instanceof _locale.Content) {
        return val.toSafeString();
    }
    return (0, _locale.sanitize)(val);
});

_angular.$sce;

_angular.$registerDirective;

_angular.$compile;

_core.$event;

_locale.formatCurrency;

_locale.sanitize;

_locale.Content;

_locale.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/squid/dist/ng", "../node_modules/squid/dist/ng/locale.js"))

/***/ }),

/***/ "../node_modules/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.module = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = _angular2['default'].module;
exports.module = _module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$angularInvoke = $angularInvoke;
exports.$once = $once;
exports.$cleanRootScope = $cleanRootScope;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

function $angularInvoke(method) {
    try {
        return method();
    } catch (err) {
        _angular.$injector.get('$exceptionHandler')(err);
    }
}

function $once(name, handler) {
    var cancel = _core.$event.on(name, function () {
        cancel();
        handler.apply(this, arguments);
    }, true);
}

function $cleanRootScope(rootScope) {

    var keys = Object.keys(rootScope);

    var autoCleanupEventHandlers = [];
    var eventHandlers = [];
    var eventCancelers = [];

    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
        var name = _ref[0],
            handler = _ref[1],
            once = _ref[2];


        var cancel = original();

        var $state = void 0;

        try {
            $state = _angular.$injector.get('$state');
        } catch (err) {
            // pass
        }

        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
            autoCleanupEventHandlers.push(cancel);
            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
        }

        if (once) {
            eventCancelers.push(cancel);
            return cancel;
        }

        // Let ng-router do its thing
        if (handler.toString().indexOf('updateView') !== -1) {
            return cancel;
        }

        var stack = void 0;

        try {
            throw new Error('$rootScope.$on');
        } catch (err) {
            stack = err.stack;
        }

        var reference = {
            name: name,
            handler: handler.toString(),
            stack: stack
        };

        eventHandlers.push(reference);

        return function () {
            cancel();
            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
        };
    });

    return function () {

        _core.$event.emit('$destroy');

        autoCleanupEventHandlers.forEach(function (canceler) {
            return canceler();
        });
        autoCleanupEventHandlers = [];

        Object.keys(rootScope).forEach(function (key) {
            if (keys.indexOf(key) === -1) {
                delete rootScope[key];
            }
        });

        if (eventHandlers.length) {
            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
            }).join('\n\n'));
        }

        eventCancelers.forEach(function (cancel) {
            return cancel();
        });
    };
}

angular.value("$angularInvoke", $angularInvoke);
angular.value("$once", $once);
angular.value("$cleanRootScope", $cleanRootScope);
_angular.$injector;

_core.$util;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.on('pxp_res', function (event, pxpRes) {
    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});

_uiRouter.$state;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ComponentRoute = exports.$Route = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {

    childSpec: {},

    init: function init() {
        var _this = this;

        this.validate();

        this.url = '/' + (this.path || this.name);

        if (this.query) {
            this.url += '?' + this.query.join('&');
        }

        this.hasResolver = Boolean(this.resolve);

        var controller = this.controller = ['$scope', function ($scope) {
            $scope.route = _this;
            if ($scope.componentScope) {
                delete $scope.componentScope.view;
            }
        }];

        if (this.get('resolve.action')) {
            this.controller = ['$scope', 'action', function ($scope, action) {
                _angular.$injector.invoke(controller, this, { $scope: $scope });
                if (action) {
                    if (!action.newState) {
                        _angular.$location.replace();
                    }

                    if (angular.isObject(action) && action.to) {
                        _uiRouter.$state.go(action.to, action.params);
                    } else {
                        _uiRouter.$state.go(action);
                    }
                }
            }];
        }
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var routeName = this.constructor.name;

        if (!this.name && !this.path) {
            throw new Error(routeName + ' :: expected property \'path\'');
        }

        if (this.url) {
            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
        }

        if (this.query && !(this.query instanceof Array)) {
            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
        }

        if (this.controller) {
            // throw new Error(`${routeName} :: unexpected property 'controller'`);
        }

        if (this.resolve) {
            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
            }

            Object.keys(this.resolve).forEach(function (name) {
                if (name === 'data') {
                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
                } else if (name !== 'action') {
                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
                }
            });
        }

        if (this.template) {
            throw new Error(routeName + ' :: unexpected property \'template\'');
        }

        if (!this.directive && !this.resolve && !this.resolve.action) {
            throw new Error(routeName + ' :: expected property \'directive\'');
        }

        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
        }

        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
        }

        if (this.children) {
            this.children.forEach(function (childSpec) {

                if (!childSpec.route && !childSpec.name) {
                    throw new Error(routeName + ' :: child expected property \'route\'');
                }

                var ChildRoute = childSpec.route;
                var childName = childSpec.name || ChildRoute.name;

                // skip loading route as it won't be available to validate
                if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                    return;
                }

                if (!ChildRoute && childSpec.name) {
                    try {
                        ChildRoute = _angular.$injector.get(childSpec.name);
                    } catch (err) {
                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
                    }
                }

                if (!$Route.isChild(ChildRoute)) {
                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
                }
            });
        }
    },
    goto: function goto(route) {
        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
    },
    getDirective: function getDirective() {
        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
    },
    getDirectiveTag: function getDirectiveTag() {
        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
    },


    bootstrap: function bootstrap(defaultState, middleware) {
        var _this2 = this;

        return (0, _ng.$angularInvoke)(function () {
            // only bootstrap if not bootstrapped already
            var element = angular.element(document.body);

            if (!element.injector()) {
                angular.bootstrap(element, ['app']);
            }

            return _this2.load(defaultState, middleware);
        });
    },

    load: function load(defaultState, middleware) {

        defaultState = defaultState || this.defaultState;
        middleware = middleware || this.middleware;

        _logger.$logger.info('bootstrap_route', {
            route: this.path || this.name
        });

        var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
            var unfoundState = _ref.unfoundState,
                fromState = _ref.fromState,
                fromParams = _ref.fromParams,
                _ref$logName = _ref.logName,
                logName = _ref$logName === undefined ? '' : _ref$logName;

            _logger.$logger.error('state_not_found' + logName, {
                name: unfoundState.to,
                from: fromState.name,
                fromParams: fromParams,
                hash: window.location.hash
            });
            throw new Error('state_not_found' + logName + ': ' + unfoundState.to);
        };

        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (!_config.$meta.codeSplitting) {
                event.preventDefault();
                logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams });
            }
        });

        // for code splitting this event handler will be triggered every single time user tries to load lazy route
        // so we need to have it being listening more than once
        _core.$event.on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (_config.$meta.codeSplitting) {
                event.preventDefault();
                // if route was not found - lazy load it or throw state_not_found if it was not found
                (0, _lazyLoadRoutes.lazyLoadRoute)(unfoundState.to, unfoundState.toParams)['catch'](function () {
                    logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams, logName: '_lazy_loading' });
                });
            }
        });

        this.register();

        _uiRouter.$urlRouterProvider.otherwise(function () {
            return _logger.$logger.info('otherwise_after_bootstrap', {
                hash: window.location.hash
            });
        });

        this.runMiddleware(middleware).then(function () {
            var targetState = void 0;
            var targetParams = void 0;

            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {

                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');

                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
            }

            _logger.$logger.info('initializing_route', {
                target: targetState,
                defaultState: defaultState,
                hash: window.location.hash
            });

            _angular.$location.replace();

            /**
             * load default state in case target state was not found
             * e.g checkout.landing - is the default state in Hermes
             */
            var loadDefaultState = function loadDefaultState() {
                if (_uiRouter.$state.get(defaultState)) {
                    _logger.$logger.info('default_state', {
                        stateName: defaultState
                    });
                    return _uiRouter.$state.go(defaultState)['catch'](function (err) {
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: defaultState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                }

                throw new Error('Default state not found: ' + defaultState);
            };

            if (targetState) {
                var logUnknownState = function logUnknownState() {
                    var logName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    _logger.$logger.info('unknown_state' + logName, {
                        stateName: targetState
                    });
                };

                if (_uiRouter.$state.get(targetState)) {
                    _logger.$logger.info('existing_state', {
                        stateName: targetState
                    });
                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                        // lib/js/security.js event listener handles auth required state changes
                        // and cancels transitions if user not authenticated
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: targetState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                } else if (_config.$meta.codeSplitting) {
                    // try to lazy load route and catch / handle redirect errors
                    // 1. If route was not found -> log and try to load default state
                    // 2. If route was found but redirect throws an error -> reject
                    return (0, _lazyLoadRoutes.lazyLoadRoute)(targetState, targetParams)['catch'](function (err) {
                        if (err.message === 'lazy_loading_state_was_not_loaded') {
                            logUnknownState('_lazy_loading');
                            return loadDefaultState();
                        } else {
                            return _core.$promise.reject(err);
                        }
                    });
                } else {
                    logUnknownState();
                }
            }
            return loadDefaultState();
        })['catch'](function (err) {
            return _angular.$injector.get('$exceptionHandler')(err);
        });
    },

    runMiddleware: function runMiddleware(middleware) {

        _logger.$logger.info('middleware', {
            priority: _core.$util.map(middleware, function (method) {
                return method.name;
            }).join('|')
        });

        var promise = _core.$promise.resolve();

        angular.forEach(middleware, function (method) {
            promise = promise.then(function () {

                if (method.name) {
                    _logger.$logger.info('middleware_' + method.name);
                }

                return method();
            });
        });

        return promise;
    },

    register: function register() {
        var _this3 = this;

        this.template = this.constructTemplate(this.childAttributes || {});

        this.absolutePath = this.path || this.name;

        if (this.parent) {
            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
        }

        if (!_uiRouter.$state.get(this.absolutePath)) {
            _uiRouter.$stateProvider.state(this.absolutePath, this);
        }

        angular.forEach(this.children, function (childSpec) {
            // skip registering child if it's supposed to be lazy loaded
            if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                return;
            }
            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);

            var childRoute = new ChildRoute({
                parent: _this3,
                childSpec: childSpec,
                childAttributes: childSpec.attributes
            });

            childRoute.register();
        });
    },

    /**
     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
     * '<xo-add-bank/>'.
     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
     *
     * @param attributes - A map of name value pairs - {name: value}.
     * @returns {string}
     */
    constructTemplate: function constructTemplate(attributes) {
        var self = this;

        if (!self.directive) {
            return;
        }

        attributes['component-route'] = 'route';

        if (this.parent) {
            attributes['export'] = 'view';
        }

        var tag = this.getDirectiveTag();

        var paramString = '';

        angular.forEach(attributes, function (value, key) {
            paramString += ' ' + key + '="' + value + '"';
        });

        return '<div ' + tag + ' ' + paramString + '></div>';
    }
});

if (!_uiRouter.$state.get('default')) {
    _uiRouter.$stateProvider.state('default', {
        auth: false
    });
}

$Route.reopenClass({
    render: function render(props) {

        _core.$event.emit('$resetState');
        _core.$loader.reset();
        _uiRouter.$state.go('default');
        setTimeout.flush();

        var $scope = angular.extend(_angular.$rootScope.$new(), props);

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var element = (0, _angular.$compile)('<div id="app"><ui-view></ui-view></div>')($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            _core.$loader.reset();
            angular.element(document.getElementById('app')).remove();
        }));

        var route = new this({
            // Pass child attributes to simulate a route receiving scope variables from the parent
            childAttributes: _core.$util.reduce(props, function (result, val, key) {
                result[_core.$util.camelToDasherize(key)] = key;
                return result;
            }, {})
        });

        route.bootstrap(route.defaultState || route.path || route.name);
        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        return element;
    },


    assertActive: function assertActive() {
        var isState = _uiRouter.$state.current instanceof this;

        if (!isState) {
            throw new Error('Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
        }
    }
});

function getPageTitle(stateName) {

    var state = _uiRouter.$state.get(stateName);

    if (!state) {
        return;
    }

    if (state.titleContent) {
        return _locale.$locale.content.get(state.titleContent);
    }
}

function changePageTitle() {

    document.documentElement.setAttribute('lang', _locale.$locale.lang);

    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
        return;
    }

    var fullStateTitle = [];

    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {

        var stateName = [a, b].filter(Boolean).join('.');
        var stateTitle = getPageTitle(stateName);

        if (stateTitle) {
            fullStateTitle.push(stateTitle);
        }

        return stateName;
    }, null);

    document.title = _core.$util.unique(fullStateTitle).join(' - ');
}

_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);

var $ComponentRoute = exports.$ComponentRoute = $Route;

angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;

_angular.$location;

_angular.$injector;

_angular.$compile;

_uiRouter.$state;

_uiRouter.$stateProvider;

_uiRouter.$urlRouterProvider;

_logger.$logger;

_core.$config;

_core.$Class;

_core.$util;

_core.$promise;

_core.$event;

_core.$loader;

_locale.$locale;

_component.$Component;

_ng.$cleanRootScope;

_ng.$angularInvoke;

_ng.$once;

_config.$meta;

_lazyLoadRoutes.lazyLoadRoute;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {



var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

_core.$config.deploy = _core.$config.deploy || _env.$env;

_core.$config;

_env.$env;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/env.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $env = exports.$env = {

    isLocal: function isLocal() {
        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
    },

    isStage: function isStage() {
        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
    },

    isSandbox: function isSandbox() {
        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
    },

    isLive: function isLive() {
        return window.location.hostname === 'www.paypal.com';
    },

    isTest: function isTest() {
        return false;
    }
};

angular.value("$env", $env);

/***/ }),

/***/ "../node_modules/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

Object.keys(_env).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _env[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/paypal/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/paypal/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPModel = undefined;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpMatch = $pxpMatch;
exports.$pxpFactors = $pxpFactors;
exports.$elmo = $elmo;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var $PXPModel = exports.$PXPModel = _core.$Model.extend({
    api: new _core.$Api({
        uri: '/api/pxp/:pagename'
    })
});

function logPxp(pxpRes, params, logPayload) {
    var exp_name = [];
    var xe = [];
    var xt = [];
    var isElmoExperiment = params.isElmoExperiment;

    angular.forEach(pxpRes.treatments, function (treatment) {

        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
            experiment: pxpRes.pagename,
            treatment: treatment.treatment_name,
            experiment_id: treatment.experiment_id,
            treatment_id: treatment.treatment_id,
            loc_country: _locale.$locale.country,
            loc_lang: _locale.$locale.lang,
            exp_source: isElmoExperiment ? 'elmo' : 'pxp'
        }, params, logPayload));

        exp_name.push(treatment.treatment_name);
        xe.push(treatment.experiment_id);
        xt.push(treatment.treatment_id);
    });

    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
        pxp_exp_id: xe.join('|'),
        pxp_trtmnt_id: xt.join('|'),
        treatments: exp_name.join('|'),
        loc_country: _locale.$locale.country,
        loc_lang: _locale.$locale.lang,
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    }, params, logPayload));

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: xe.join(','),
        pxp_trtmnt_id: xt.join(','),
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    });

    _core.$event.emit('pxp_res', pxpRes);
}

function $getPxpTreatments(id, params, logPayload) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


    return _core.$promise.run(function () {
        if (isElmoExperiment) {
            Object.assign(params, { isElmoExperiment: isElmoExperiment });
        }

        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
        var forceTreatments = _core.$util.param('pxp_' + id) || _core.$util.param('elmo_' + id);

        if (forceTreatments) {
            var treatments = forceTreatments.split(',').filter(Boolean);

            pxp.treatments = treatments.map(function (treatment_name) {
                return {
                    treatment_name: treatment_name
                };
            });

            return pxp;
        }

        if (forceApiCall) {
            pxp.cached = false;

            return pxp.reload({
                params: params,
                silent: silent
            });
        }

        return pxp.retrieve({
            params: params,
            silent: silent,
            // Ignore all errors from this api, by passing transientError as true
            // Pxps are not critical calls, so they should fail silently without fallbacks (page reload / showing error page)
            transientError: true
        });
    }).then(function (pxp) {
        if (!pxp.cached) {
            logPxp(pxp, params, logPayload);
        }

        pxp.cached = true;

        return pxp;
    });
}

function $pxp(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (!pattern) {
        pattern = params;
        params = {};
    }

    pattern = new RegExp('^' + pattern + '$');

    return exports.$getPxpTreatments(id, params, null, forceApiCall, silent, isElmoExperiment).then(function (experimentResponse) {
        var result = void 0;

        (experimentResponse.treatments || []).some(function (treatment) {
            if (!pattern.test(treatment.treatment_name)) {
                return false;
            }

            result = {
                treatment_name: treatment.treatment_name,
                factors: treatment.factors
            };

            return true;
        });

        return result;
    });
}

function $pxpMatch(id, params, patterns, logPayload) {
    if (!patterns) {
        patterns = params;
        params = {};
    }

    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
        var result = {};

        angular.forEach(patterns, function (pattern, name) {
            pattern = new RegExp('^' + pattern + '$');
            result[name] = false;

            (pxpResponse.treatments || []).some(function (treatment) {
                if (!pattern.test(treatment.treatment_name)) {
                    return false;
                }

                result[name] = true;
                return true;
            });
        });

        return result;
    });
}

function $pxpFactors(id, params, pattern) {
    params.factors = 'true';
    return $pxp(id, params, pattern).then(function (pxpResponse) {
        var result = void 0;

        if (pxpResponse && pxpResponse.factors) {
            result = { treatment_name: pxpResponse.treatment_name };
            var pxpFactors = pxpResponse.factors;
            var length = pxpFactors.length;

            for (var i = 0; i < length; i++) {
                result[pxpFactors[i].name] = pxpFactors[i].value;
            }
        }

        return result;
    });
}

function $elmo(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var isElmoExperiment = true;

    return $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment);
}

window.$pxp = $pxp;
window.$elmo = $elmo;

angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
angular.value("$elmo", $elmo);
_logger.$logger;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_locale.$locale;

/***/ }),

/***/ "../node_modules/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});

}.call(window));

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddAddressComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown-multiline/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/add-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddAddressComponent = exports.$xoAddAddressComponent = _squid.$Component.extend('$xoAddAddressComponent', {
    tag: 'xo-add-address',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        isShipping: {
            type: 'var',
            required: false
        },
        country: {
            type: 'var',
            required: false
        },
        metadata: {
            type: 'str',
            required: false
        },
        hideButtonHandler: {
            type: 'var',
            required: false
        },
        hideCep: {
            type: 'var',
            required: false
        },
        hideName: {
            type: 'var',
            required: false
        },
        triggerZipCodeBlur: {
            type: 'var',
            required: false
        },
        triggerZipCodeKeyPress: {
            type: 'var',
            required: false
        },
        renderBillingAddCheckbox: {
            type: 'var',
            required: false
        }
    },
    controller: ['$scope', function ($scope) {
        // eslint-disable-line max-statements
        var sortStates = void 0;
        var country = $scope.country || $scope.address && $scope.address.country;

        $scope.country = country;
        $scope.locale = _squid.$locale;
        $scope.metadata = _squid.$MetadataModel.create();

        // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
        $scope.$watch('country', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
            onCountryChange();
        });

        function onCountryChange() {
            sortStates = (0, _squid.$feature)('sortStatesForAddress', false, $scope.country);

            if (sortStates) {
                getSortedStateList();
            }
        }

        onCountryChange();

        // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
        $scope.$on('contentChange', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
        });

        /**
         * Prefix to use for `id`, `name`, and `for` attributes. This is needed because Xoon will sometimes display both billing
         * and shipping address forms on the same page and without a prefix there will be duplicte `id`s and `name`s on the page.
         */
        $scope.attrPrefix = $scope.isShipping ? 'shipping' : 'billing';

        $scope.$watch('address.state', function () {
            _angular.$rootScope.$emit($scope.attrPrefix + 'AddressStateChange', $scope.address);
        });

        $scope.normalizeCountry = function (countryCode) {
            return (0, _squid.$feature)('AddressFormat', countryCode, countryCode) || countryCode;
        };

        $scope.isAddPreferred = (0, _squid.$feature)('preferredShipping', false, $scope.country) && $scope.isShipping;
        $scope.isAddressLookupEnabled = (0, _squid.$feature)('addressLookup', false, $scope.country);
        $scope.isShowLookupFields = $scope.isAddressLookupEnabled;

        if ($scope.isShowLookupFields) {
            // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
            if ($scope.hideButtonHandler) {
                $scope.hideButtonHandler(true);
            } else {
                $scope.isShowLookupFields = false;
            }
        }

        function getSortedStateList() {
            var states = _squid.$locale.content.get(sortStates, {});
            var statesList = [];

            angular.forEach(states, function (key, value) {
                statesList.push({ code: value, sname: key });
            });
            statesList.sort(function (a, b) {
                return a.sname.localeCompare(b.sname);
            });

            $scope.sortedStatesList = statesList;
        }

        $scope.formatZip = function () {
            var unformatted = $scope.address.postal_code && $scope.address.postal_code.replace(/[^0-9]/gi, '');
            var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
                return x[1] && x[0] + x[1] || '';
            }).join('');

            $scope.address.postal_code = formatted;
        };

        function getAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';
            var line1 = void 0;
            var line2 = void 0;

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
                // if deliveryAddresses is not an array or is empty
                // line would be empty, hence return to caller.
                return;
            }

            var array = address.deliveryAddresses;

            if (array.length > 1) {
                // populate line2 from the last element
                line2 = array.pop();
            }
            line1 = array.join(COMMA);

            var displayLine1 = line1 + prefix(line2, COMMA);
            var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
            var displayLine3 = prefix(address.country);

            return {
                line1: line1,
                line2: line2,
                city: address.city,
                state: address.state,
                postal_code: address.postal_code,
                country: address.country,
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3,
                dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
            };
        }

        function populateAddressFormFields(address) {
            $scope.address.line1 = address.line1;
            $scope.address.line2 = address.line2;
            $scope.address.city = address.city;
            $scope.address.state = address.state;
            $scope.address.postal_code = address.postal_code;
            $scope.address.neighborhood = address.neighborhood;
        }

        /**
         * Show error message and display the full-address fields
         */
        function populateErrorMessage() {
            var messages = [];

            messages.push($scope.locale.content.get('addressBook.lookupError'));
            $scope.lookupFailureMessage = {
                msgs: messages,
                type: 'warning'
            };
            $scope.isShowLookupFields = false;
            $scope.isLookupFailure = true;
        }

        function processLookupResult(list) {
            if (list.length > 1) {
                // Show drop-down list of all addresses
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = true;
                $scope.lookupAddressList = list.map(function (addr) {
                    return getAddress(addr);
                });
            } else if (list.length === 1) {
                // Show single address component
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = false;

                var address = getAddress(list[0]);

                $scope.singleAddress = address;
                populateAddressFormFields(address);
            } else {
                populateErrorMessage();
            }
        }

        if ($scope.address) {
            $scope.lastPrefilledZip = $scope.address.postal_code;
        }

        $scope.prefill = function () {
            var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
            var first_name = void 0;
            var last_name = void 0;

            if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
                return;
            }

            if ($scope.isShipping) {
                first_name = $scope.address.first_name;
                last_name = $scope.address.last_name;
            }

            $scope.prefillAddress = new _index.$PrefillAddressModel({
                id: $scope.token,
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code
                }
            });

            return $scope.prefillAddress.save({
                data: $scope.prefillAddress,
                success: function success(result) {
                    if (result) {
                        populateAddressFormFields(result);
                        $scope.lastPrefilledZip = $scope.address.postal_code;
                        if ($scope.isShipping) {
                            $scope.address.first_name = first_name;
                            $scope.address.last_name = last_name;
                        }
                    }
                }
            });
        };

        $scope.findAddress = function () {
            $scope.lookupAddress = _index.$PrefillAddressModel.create($scope.token, {
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code,
                    house_number: $scope.address.house_number,
                    building_name: $scope.address.building_name
                }
            });

            if (document.querySelector('#lookupZip.ng-invalid')) {
                document.querySelector('#addressLookupFields').classList.add('validated');
            } else {
                $scope.isLookupProcessing = true;
                $scope.lookupAddress.save({
                    data: $scope.lookupAddress,
                    silent: true,
                    success: function success(result) {
                        processLookupResult(result);
                        $scope.hideButtonHandler(false);
                    },
                    contingencies: {
                        INTERNAL_ERROR: populateErrorMessage
                    }
                });
            }
        };

        $scope.changeAddressDropDown = function () {
            populateAddressFormFields($scope.address.selectedAddress);
        };

        $scope.showFullAddress = function () {
            $scope.isShowLookupFields = false;
            $scope.hideButtonHandler(false);
        };

        /**
         * Pass an array of group names to retrieve the list of states
         * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
         */
        var stateNamesInGroup = [];

        $scope.retrieveStateNamesInGroup = function (groups) {
            if (stateNamesInGroup.length) {
                // Angular keeps watching for this method as its used in ng-model, hence return cached data.
                return stateNamesInGroup;
            }
            var content = _squid.$locale.content;

            angular.forEach(groups, function (group) {
                var groupName = content.common[group];
                var statesList = content[group];

                angular.forEach(statesList, function (value, key) {
                    stateNamesInGroup.push({
                        key: key,
                        value: value,
                        group: groupName
                    });
                });
            });
            return stateNamesInGroup;
        };

        $scope.zipCodeBlur = function () {
            if ($scope.triggerZipCodeBlur) {
                _angular.$rootScope.$emit('zip_code_blur');
            }
        };

        $scope.zipCodeKeyPress = function (event) {
            if ($scope.triggerZipCodeKeyPress) {
                _angular.$rootScope.$emit('zip_code_keypress', { event: event });
            }
        };
    }]
});

angular.value("$xoAddAddressComponent", $xoAddAddressComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;

_index.$PrefillAddressModel;

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\" attr-prefix=\"attrPrefix\"></xo-name-input>\n    <div ng-switch=\"normalizeCountry(country)\" class=\"addressGroup clearfix\">\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" prefix-attrs-with=\"{{attrPrefix}}\" attr-prefix=\"attrPrefix\" country=\"BR\" address=\"address\"\n                zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div id=\"addressFields\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\"\n                            maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\"/>\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetAddress') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\"\n                            ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetNumber') }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\"\n                        maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\"\n                        data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.neighborhood') }}\n                    </label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\"\n                            data-test-id=\"BR:addressProvince\" prefix-attrs-with=\"{{attrPrefix}}\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.otherState') }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                            <option value=\"\">{{ content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\"\n                            autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                            xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\" prefix-attrs-with=\"{{attrPrefix}}\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{ content('addressBook.enterFullAddress') }}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                    \"country\": \"GB\"\n                                    }\n                                }'\n                                ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                                {{ content('common.zip') }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" name=\"houseNo\" ng-model=\"address.house_number\"\n                            value=\"\" maxlength=\"50\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                            ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgNo') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                            value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" name=\"buildingName\"\n                            ng-disabled=\"isLookupProcessing\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">\n                            {{ content('common.change') }}\n                        </a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                        class=\"dropdown confidential clearfix\" prefix-attrs-with=\"{{attrPrefix}}\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\">\n                                {{ content('addressBook.selectYourAddress', { count: lookupAddressList.length}) }}\n                            </option>\n                            <option ng-repeat=\"addr in lookupAddressList track by $index\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{ singleAddress.displayLine1 }}<br/>\n                        {{ singleAddress.displayLine2 }}<br/>\n                        {{ singleAddress.displayLine3 }}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown prefix-attrs-with=\"{{attrPrefix}}\"\n                            ng-options=\"state.$id as state.$id for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateList }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"\n                            ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id.toUpperCase() as state.$elt for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\"\n                        aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" address=\"address\" attr-prefix=\"attrPrefix\"\n                                done-fn=\"zipCodeBlur\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                key-press-fn=\"zipCodeKeyPress\" zip-required=\"layoutItem.required\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" data-test-id=\"addrSt\" ng-model=\"address.line1\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                        data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.stAddress') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\"data-test-id=\"addrCity\" maxLength=\"100\" ng-model=\"address.city\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.otherCity') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" data-test-id=\"addrState\" ng-model=\"address.state\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalState') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" data-test-id=\"addrZipcode\" ng-model=\"address.postal_code\"\n                        value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\"\n                        autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalPostalCode') }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n\n    <div ng-if=\"renderBillingAddCheckbox\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\"  ng-model=\"address.isBA\" name=\"isBA\" id=\"addVenmoBA\" />\n        <label for=\"addVenmoBA\">{{ content('memberReview.useShippingAsBilling') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/styles.less");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-normalization/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddressNormalization', function () {
    return {
        template: _template2['default'],
        scope: {
            id: '=?',
            address: '=?',
            doneFn: '=?',
            sidebar: '=?',
            hideBackButton: '=?'
        },

        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.address, 'Original Address cannot be empty');

            $scope.showNormalization = false;

            var normalize = (0, _squid.$feature)('addressNormalization', false, $scope.address.country);
            if (!normalize) {
                $scope.doneFn($scope.address, false);
                return;
            }

            var userEnteredAddress;
            var addrFormat = (0, _squid.$feature)('FormatAddressForNormalization', $scope.address.country, $scope.address.country);

            $scope.addressSelected = 'normalizedAddress';
            $scope.transitionName = 'address_normalization_normalizedAddress';

            // Brazil specific format
            if (addrFormat === 'AddressBR') {
                userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
                userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
                userEnteredAddress.line2 = $scope.address.neighborhood;
            }

            $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
            $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';

            $scope.addressNormalization = new _index.$AddressNormalizationModel({
                id: $scope.id,
                address: $scope.servAddress
            });

            function centerLightBox() {
                var element = $('#lbox');
                if (!element.length) {
                    return;
                }

                var windowElement = $(window);
                var lboxContainerElem = $('#lboxContainer');
                element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                element.css('width', '65%');
                var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                if (computedLeft < leftBound) {
                    element.css('width', lboxContainerElem.width() * 0.8);
                }
                element.css('left', Math.max(0, elementLeft) + 'px');
                return element;
            }

            function trinityResponseCallback() {
                $scope.showNormalization = true;

                // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                (0, _angular.$timeout)(function () {
                    centerLightBox();
                    $(window).resize(centerLightBox);
                });
            }

            $scope.addressNormalization.save({
                data: $scope.addressNormalization,

                contingencies: {
                    VALIDATION_ERROR: function VALIDATION_ERROR() {
                        trinityResponseCallback();
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                },

                success: function success(result) {
                    trinityResponseCallback();
                    if (result === false) {
                        // trinity doesn't find any match
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                    $scope.normalizedAddress = result;
                    $scope.normalizedAddress.normalization_status = 'NORMALIZED';

                    if (addrFormat === 'AddressBR') {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
                        $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
                    }

                    // if the two addresses equal, no need to show the panel
                    if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
                        if ($scope.servAddress.preferred_address) {
                            $scope.normalizedAddress.preferred_address = true;
                        }

                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                        }
                        $scope.callback($scope.normalizedAddress, false);
                    } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                    }
                },

                error: trinityResponseCallback
            });

            // make space and case insensitive. sub empty vals for undefined.
            function desensitizedAddress(addr) {
                for (var key in addr) {
                    var val = addr[key];
                    if (addr.hasOwnProperty(key)) {
                        if (val && val.length) {
                            addr[key] = val.trim().toLowerCase();
                        } else {
                            addr[key] = undefined;
                        }
                    }
                }
                return addr;
            }

            // check if the two address are the same
            $scope.isEqual = function (address1, address2) {
                var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                if (!addressOne || !addressTwo) {
                    return false;
                }

                return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
            };

            // Australia displays address line2 first
            $scope.isLine2First = function () {
                return $scope.address.country === 'AU';
            };

            $scope.onBack = function () {
                $scope.callback($scope.address, true);
            };

            $scope.selection = function (value) {
                $scope.transitionName = 'address_normalization_' + value;
            };

            $scope.onContinue = function () {
                $scope.addressSelected = this.addressNormalizationForm.addressSelected;

                if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
                    if ($scope.servAddress.preferred_address) {
                        $scope.normalizedAddress.preferred_address = true;
                    }
                    $scope.callback($scope.normalizedAddress, false);
                } else {
                    $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
                    if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
                    }
                    $scope.callback($scope.servAddress, false);
                }
            };

            $scope.callback = function (address, isBack) {
                $scope.doneFn(address, isBack);
            };
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$util;

_index.$AddressNormalizationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddressNormalizationRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");

var $AddressNormalizationRoute = exports.$AddressNormalizationRoute = _squid.$ComponentRoute.extend('AddressNormalizationRoute', {
    name: 'addressNormalization',
    titleContent: 'addressNormalization.addressmatch',
    directive: 'xo-address-normalization',
    trackingData: {
        fptiState: 'address_normalization',
        buzname: {
            'fullpage': {
                'pagename': '%::address_normalization',
                'pagename2': '%::address_normalization:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,

    children: []
});

angular.value("$AddressNormalizationRoute", $AddressNormalizationRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module('beaver.level', []).factory('$logLevel', function () {
    return {
        INFO: 'info',
        DEBUG: 'debug',
        ERROR: 'error',
        WARN: 'warn',
        ALERT: 'alert'
    };
}).factory('$consoleLogLevel', function () {
    return {
        info: 'info',
        debug: 'debug',
        error: 'error',
        warn: 'warn',
        alert: 'info'
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/level.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _level = __webpack_require__("../node_modules/xo-beaver/dist/level.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable angular/di */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Logger', function () {
    var logger = {};
    var HERMES_DEV_COOKIE = 'hermesdev';

    _angular2['default'].forEach(_level.$logLevel, function (level) {
        logger[level] = function (event, payload, settings) {
            return this.log(level, event, payload, settings);
        };
    });

    var hostname = _angular.$window.location && _angular.$window.location.hostname || '';
    var uniqueEvents = [];

    _angular2['default'].extend(logger, {
        autoLog: [_level.$logLevel.WARNING, _level.$logLevel.ERROR],
        flushInterval: 10 * 60 * 1000,
        heartbeatInterval: 5000,
        sizeLimit: 500,
        debounceInterval: 10,
        uri: '/api/log',
        rootTxnUri: '/api/log/crt',
        hearbeatMaxThreshold: 50,
        deploy: {
            isLocal: function isLocal() {
                return hostname === 'localhost' || hostname === 'localhost.paypal.com';
            },

            isStage: function isStage() {
                return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
            },

            isLive: function isLive() {
                return hostname === 'www.paypal.com';
            }
        },

        init: function init() {
            var self = this;

            this.buffer = [];

            var previousBeforeUnloadHandler = _angular.$window.onbeforeunload;

            _angular.$window.onbeforeunload = function (event) {
                if (self.isDone) {
                    return;
                }

                self.info('window_beforeunload');

                if (previousBeforeUnloadHandler) {
                    return previousBeforeUnloadHandler.apply(this, arguments);
                }
            };

            var previousUnloadHandler = _angular.$window.onunload;

            _angular.$window.onunload = function (event) {

                if (self.isDone) {
                    return;
                }

                self.info('window_unload');
                self._flush();

                self.done();

                if (previousUnloadHandler) {
                    return previousUnloadHandler.apply(this, arguments);
                }
            };

            this.heartbeat();
            this.daemon();
        },

        heartbeat: function heartbeat() {
            var self = this;

            if (!window.enablePerformance) {
                return;
            }

            function timestamp() {
                var perf = window.performance;

                return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
            }

            var howBusy = {
                lastSampledTime: timestamp(),
                lastLag: 0,
                maxLag: 0,
                dampendedLag: 0
            };

            var count = 0;

            (0, _angular.$interval)(function () {

                if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
                    count = 0;
                }

                if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
                    return;
                }

                count += 1;

                var payload = {
                    count: count
                };

                var now = timestamp();

                howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
                howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
                howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
                howBusy.lastSampledTime = now;

                payload.lastLag = howBusy.lastLag.toFixed(4);
                payload.maxLag = howBusy.maxLag.toFixed(4);
                payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
                payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);

                if (howBusy.lastLag > 10000) {
                    self.info('toobusy', {}, {
                        noConsole: true,
                        unique: true
                    });
                }

                self.info('heartbeat', payload, {
                    noConsole: true
                });
            }, this.heartbeatInterval);
        },

        done: function done() {
            this.flush(true);
            this.isDone = true;
        },

        addPerformanceData: function addPerformanceData(payload) {

            if (window.enablePerformance) {
                var performance = window.performance;
                var timing = window.performance.timing || {};
                var now = performance.now();

                if (window.clientStartTime && _angular2['default'].isUndefined(payload.client_elapsed)) {
                    payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
                }

                if (timing.connectEnd && timing.navigationStart && _angular2['default'].isUndefined(payload.req_elapsed)) {
                    payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
                }
            }
        },

        addLocaleData: function addLocaleData(payload) {

            var context = {};

            try {
                context = _angular.$injector.get('$metaBuilder').buildContext();
            } catch (err) {
                return; // Continue without adding locale data
            }
            if (context.locale && context.locale.country) {
                payload.site_cntry = context.locale.country;
            }
        },

        /* jslint maxcomplexity: false */
        log: function log(level, event, payload, settings) {
            var self = this;

            payload = payload || {};

            if (_angular2['default'].isArray(payload) || !_angular2['default'].isObject(payload)) {
                payload = {
                    payload: payload
                };
            }
            settings = settings || {};

            if (settings.unique) {
                var hash = event + ':' + _angular2['default'].toJson(payload);

                if (uniqueEvents.indexOf(hash) > -1) {
                    return self;
                }
                uniqueEvents.push(hash);
            }

            payload.pageID = window.meta && window.meta.pageID;

            this.addPerformanceData(payload);
            this.addLocaleData(payload);

            self.print(level, event, payload, settings);

            if (this.buffer.length >= this.sizeLimit) {
                if (this.buffer.length === this.sizeLimit) {
                    return self.enqueue('warn', 'logger_max_buffer_length');
                }
                return self;
            }

            return self.enqueue(level, event, payload, settings);
        },

        getTimestamp: function getTimestamp() {
            var now = Date.now();

            return window.logOffset ? window.logOffset + now : now;
        },

        enqueue: function enqueue(level, event, payload, settings) {
            payload = payload || {};
            settings = settings || {};

            var data = {
                level: level,
                event: event,
                timestamp: this.getTimestamp(),
                payload: payload
            };

            this.buffer.push(data);

            // If the log level is classified as autolog, then flush the data
            if (this.autoLog.indexOf(level) > -1) {
                this.flush();
            }

            return this;
        },

        shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {

            if (settings.noConsole) {
                return false;
            }

            if (window.meta && window.meta.corp) {
                return true;
            }

            if (this.deploy.isLocal() || this.deploy.isStage()) {
                return true;
            }

            var cookies = window.cookies || {};

            if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
                return true;
            }

            return false;
        },

        print: function print(level, event, payload, settings) {

            if (!this.shouldPrintLogsToConsole(settings)) {
                return;
            }

            var args = [event];

            if (payload) {
                args.push(payload);

                if (payload.stack || payload.error || payload.warning) {
                    args.push('\n\n', payload.stack || payload.error || payload.warning);
                }
            }

            _angular.$log[_level.$consoleLogLevel[level] || 'info'].apply(_angular.$log, args);
        },

        flush: function flush(immediate) {
            var self = this;

            if (!this.buffer.length) {
                return _angular.$q.when();
            }

            if (immediate) {
                return _angular.$q.when(this._flush());
            }

            if (self.debouncer_timeout) {
                _angular.$timeout.cancel(self.debouncer_timeout);
            }

            self.debouncer_timeout = (0, _angular.$timeout)(function () {

                var resolver = self.debouncer_resolver;

                delete self.debouncer_promise;
                delete self.debouncer_resolver;
                delete self.debouncer_timeout;

                self._flush().then(function () {
                    resolver();
                });
            }, this.debounceInterval);

            self.debouncer_promise = self.debouncer_promise || (0, _angular.$q)(function (resolver) {
                self.debouncer_resolver = resolver;
            });

            return self.debouncer_promise;
        },

        _flush: function _flush() {
            var self = this;

            if (!self.buffer.length) {
                return _angular.$q.when();
            }

            var meta = {};

            try {
                meta = _angular.$injector.get('$metaBuilder').build();
            } catch (err) {
                // @TODO - Log error
            }

            var req = this.ajax('post', _angular.$window.meta.logURL || _angular.$window.config.urls.baseUrl + this.uri, {
                data: {
                    events: self.buffer
                },
                meta: meta
            });

            self.buffer = [];

            return req;
        },

        ajax: function ajax(method, url, json) {
            return (0, _angular.$q)(function (resolve) {
                var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
                var req = new XRequest('MSXML2.XMLHTTP.3.0');
                var logAppName = _angular.$window.meta.logAppName;

                req.open(method.toUpperCase(), url);

                req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                req.setRequestHeader('Content-type', 'application/json');

                if (logAppName) {
                    req.setRequestHeader('x-app-name', logAppName);
                }

                req.onreadystatechange = function () {
                    if (req.readyState > 3) {
                        resolve();
                    }
                };
                req.send(_angular2['default'].toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
            });
        },

        daemon: function daemon() {
            this.stop();

            var self = this;

            this.timer = (0, _angular.$interval)(function () {
                self.flush();
            }, this.flushInterval);
        },

        stop: function stop() {
            if (this.timer) {
                _angular.$interval.cancel(this.timer);
            }
        },

        createCalRootTxn: function createCalRootTxn(data, txnName) {
            if (data !== null && _angular2['default'].isObject(data)) {
                var rootTxnData = { 'data': {}, 'transactionName': '' };
                var url = '' + _angular.$window.config.urls.baseUrl + this.rootTxnUri;
                if (_angular2['default'].isString(txnName)) {
                    rootTxnData.transactionName = txnName;
                }
                Object.assign(rootTxnData.data, data);
                this.ajax('post', url, rootTxnData);
            }
        }
    });

    function Logger(val) {
        _angular2['default'].extend(this, val);
        this.init();
    }

    Logger.prototype = logger;
    Logger.prototype.constructor = Logger;

    return Logger;
}).factory('$logger', ['$Logger', function ($Logger) {
    return new $Logger();
}]).run(['$logger', function ($logger) {
    _angular2['default'].forEach(window.beaconQueue, function (payload) {
        $logger.log(payload.level, payload.event, payload);
    });

    window.beacon = function (level, events, payload) {
        _angular2['default'].forEach(events, function (event) {
            $logger.log(level, event, payload);
        });
    };
}]);

_level.$logLevel;

_level.$consoleLogLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "../node_modules/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$DeviceInfo', function () {
    var userAgent = _angular.$window.navigator.userAgent;
    var standalone = _angular.$window.navigator.standalone;
    var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
    var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
    var IOS_PATTERN = /iP(hone|od|ad)/i;

    function getIntegrationContext(integrationKey) {
        // additonal context sent via partners in regards to integration
        var integrationContext = _squid.$meta.integrationCTX || {};

        return integrationContext[integrationKey];
    }

    // Supports iOS and Android. Updated / more accurate method of detecting webviews
    function isWebView() {
        var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;

        var ios = /iphone|ipod|ipad/i.test(ua);
        var android = /Android/i.test(ua);

        if (ios) {
            // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
            // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
            var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);

            if (!standalone && ios_uiwebview && !isSafariViewController()) {
                // uiwebview
                logWebView('iOS');
                return true;
            }
        } else if (android) {
            // not iOS, Android platform handling
            // Whitelist for x-requested-with header values for web view detection
            var allowedXRequestedWithRegexMap = {
                ajax: /XMLHttpRequest/i,
                baiduBrowser: /com.baidu.browser.inter/i,
                operaMini: /com.opera.mini.native/i,
                maxthon: /com.mx.browser/i,
                litterPenguinBrowser: /com.explore.web.browser/i
            };
            var xRequestedWithHeaderVal = _squid.$meta.requestHeaders['x-requested-with'];

            if (xRequestedWithHeaderVal) {
                // check if x-requested-with header val is in whitelist
                for (var key in allowedXRequestedWithRegexMap) {
                    if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
                        if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
                            return false;
                        }
                    }
                }
                logWebView('Android');
                return true;
            }
        }

        return false;

        function logWebView(device) {
            if (!logEnabled) {
                return;
            }
            // cal log
            _logger.$logger.info('WebView :: ' + device);
        }
    }

    /**
     * Check if the given the user-agent string is belongs to a device.
     */
    function isDevice() {
        if (_angular2['default'].isString(userAgent)) {
            return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a tablet.
     */
    function isTablet() {
        if (_angular2['default'].isString(userAgent)) {
            return TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a mobile
     */
    function isMobile() {
        return isDevice(userAgent) && !isTablet(userAgent);
    }

    /**
     * Get the mobile platform value given the user-agent string.
     */
    function getDevicePlatform() {
        if (_angular2['default'].isString(userAgent)) {
            var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);

            if (matched && matched.length > 0) {
                return matched[0];
            }
        }
    }

    /**
     * Check if the give user agent is from an app.
     */
    function isApp(uaString) {
        userAgent = uaString || userAgent;

        if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
            if (getDevicePlatform(userAgent) === 'Android') {
                return (/Version\/\d.\d/i.test(userAgent)
                );
            }

            return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
            );
        }

        return false;
    }

    function isSafariViewController() {
        if (getIntegrationContext('brainTreeIntegration') === 'SFVC') {
            return true;
        }
        if (_angular2['default'].isString(userAgent)) {
            var ios = /iphone|ipod|ipad/i.test(userAgent);

            return ios && _angular.$window.indexedDB && isApp();
        } else {
            return false;
        }
    }

    /**
     * Get the device capabilities
     */
    function getCapabilities() {
        var capabilities = {};
        var device = DEVICE_PATTERN.test(userAgent);
        var tablet = TABLET_PATTERN.test(userAgent);
        var app = isApp(userAgent);

        if (_angular2['default'].isString(userAgent)) {
            capabilities.isWireless = device || tablet;
            capabilities.isTablet = tablet;
            capabilities.isMobile = device && !tablet;
            capabilities.isDesktop = !device;
            capabilities.isApp = app;
        }
        return capabilities;
    }

    /**
     * Get various AppIntegrationType
     */
    function getAppIntegrationType() {
        var app_int_type = void 0;

        if (isDevice()) {
            if (isApp()) {
                if (isSafariViewController()) {
                    app_int_type = 'SFVC';
                } else {
                    app_int_type = 'WebView';
                }
            } else {
                app_int_type = 'Browser';
            }
        }
        return app_int_type;
    }

    function isSafariiOSBrowserView() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);
        var safari = /safari/i.test(ua);
        var isIOSApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
        var isChromeOnIOS = /(.*?CriOS)/i.test(ua);
        var isFirefoxOnIOS = /(.*?FxiOS)/i.test(ua);
        var isSafariBrowserOnly = safari && !isChromeOnIOS && !isFirefoxOnIOS;

        return ios && !standalone && isSafariBrowserOnly && !isIOSApp;
    }

    function getiOSVersion() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);

        if (ios) {
            var version = ua.match(/OS (\d+)_(\d+)/);
            return [parseInt(version[1], 10), parseInt(version[2], 10)];
        }
        return false;
    }

    return {
        isDevice: isDevice,
        isTablet: isTablet,
        isMobile: isMobile,
        isApp: isApp,
        isSafariViewController: isSafariViewController,
        getCapabilities: getCapabilities,
        getAppIntegrationType: getAppIntegrationType,
        isWebView: isWebView,
        isSafariiOSBrowserView: isSafariiOSBrowserView,
        getiOSVersion: getiOSVersion
    };
});

_squid.$meta;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-device-info/dist", "../node_modules/xo-device-info/dist/index.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/dob-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('dobValidation', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attr, ctrl) {

            // init scope vars
            // age - above 18 yrs
            // validDate - months <= 12 and day <= 31 or based on month
            scope.isValidDate = true;
            scope.isValidAge = true;
            scope.isValid = false;
            scope.dobToolTip = 'hide';

            function isValidDate(year, month, day) {
                // dates like 02/31 33/33 should return false
                var date = new Date(year, month, day);

                var fullYear = date.getFullYear();
                var dateMonth = date.getMonth();
                var dateDay = date.getDate();

                // If birth year is in the future or before 1900, dob is invalid
                var now = new Date();
                if (fullYear > now.getFullYear() || fullYear < 1900) {
                    return false;
                }

                if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
                    return true;
                }
                return false;
            }

            function isOfLegalAge(birthDate) {
                // user should be of exact 18 years of age or older
                var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
                return tempDate <= new Date().setHours(0, 0, 0, 0);
            }

            /**
             * Parses input value to set corresponding day, month, year values for scope
             * @param {String} inputVal - the value to be parsed
             */
            function parseDob(inputVal) {
                var day;
                var month;
                var year;

                var sep = scope.dateSeparator();
                var partsArr = inputVal.split(sep);
                var first = partsArr[0];
                var sec = partsArr[1];
                var third = partsArr[2];

                if (scope.dateFormat() === 'DMY') {
                    day = first;
                    month = sec;
                    year = third;
                } else if (scope.dateFormat() === 'YMD') {
                    year = first;
                    month = sec;
                    day = third;
                } else {
                    month = first;
                    day = sec;
                    year = third;
                }

                // Validate only on entering the last digit of the dob
                var dayLen = ('' + day).length;
                var monLen = ('' + month).length;
                var yrLen = ('' + year).length;
                var validDay = dayLen === 1 || dayLen === 2;
                var validMon = monLen === 1 || monLen === 2;
                var validYr = yrLen === 4;
                var requirement = validDay && validMon && validYr;

                if (requirement) {
                    scope.isValidDate = isValidDate(year, month - 1, day);

                    scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
                    scope.isValid = scope.isValidDate && scope.isValidAge;
                    scope.dobToolTip = scope.isValid ? 'hide' : 'show';

                    scope.user.dob_day = day;
                    scope.user.dob_month = month;
                    scope.user.dob_year = year;
                } else {
                    scope.isValid = false;
                }

                ctrl.$setValidity('dobText', scope.isValid);

                return inputVal;
            }

            /**
             * Validates the inputted DOB value
             * @param {string} ngModelValue - the to-be mutated input value
             * onComplete for mask listener - called when user copy/pastes DOB into the field
             */
            scope.dobValidator = function dobValidator(ngModelValue) {
                var input = element;
                var dateMask = scope.dateMask();
                input.mask(dateMask, {
                    translation: {
                        'Z': {
                            pattern: /[0-9]/, optional: true
                        },
                        '0': {
                            pattern: /[0-9]/, optional: false
                        }
                    },
                    onComplete: function onComplete(val) {
                        ngModelValue = val;
                        return parseDob(ngModelValue);
                    }
                });

                return parseDob(ngModelValue);
            };

            scope.dobTester = function dobTester(val) {
                return parseDob(val);
            };

            ctrl.$parsers.push(scope.dobValidator);
        }
    };
}).directive('xoDobInput', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            user: '=?'
        },
        controller: ['$scope', function ($scope) {

            // To support additional date separators, simply add separator to getDateSeparators function
            var DateManager = {
                dateSeparator: undefined,
                dateFormat: undefined,
                griffinDateEntry: undefined,

                _init_: function _init_() {
                    this.griffinDateEntry = _squid.$locale.metadata.dateEntry;
                    this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
                    this.dateFormat = undefined;
                    this.dateFormat = this.getDateFormat();
                    this.dateRegex = this.getDateRegex();
                    // dob validator depends on dateFormat function in $scope, so context is bound.
                    $scope.dateFormat = this.getDateFormat.bind(this);
                    $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
                    $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
                    this.getDobNumericCheck();
                },
                getDateFormat: function getDateFormat() {
                    // cache date format value, must be unset on init
                    if (this.dateFormat) {
                        return this.dateFormat;
                    }

                    var griffinDateFormat = _squid.$locale.metadata.dateFormat.toUpperCase();
                    var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);

                    // Trim the white space in griffin dateFormat
                    // Eg: SK dateFormat is MM. DD. YYYY - here we need to strip spaces
                    dateFormatComponents = dateFormatComponents.map(function (str) {
                        return str.trim();
                    });

                    var dIdx = dateFormatComponents.indexOf('DD'),
                        mIdx = dateFormatComponents.indexOf('MM');

                    var formatComponentMap = this.getFormatComponentIdxMappings();
                    if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
                        return 'DMY';
                    } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
                        return 'MDY';
                    }
                    return 'YMD';
                },
                setDobTextPlaceHolder: function setDobTextPlaceHolder() {
                    $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
                },
                dobTextKeyupHandler: function dobTextKeyupHandler(event) {
                    this.updateDobBindings(true);
                },
                getDobNumericCheck: function getDobNumericCheck() {
                    return (0, _squid.$pxp)('xo_xoon_numeric_keypad_expirydob', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_xoon_numeric_keypad_expirydob_test').then(function (result) {
                        if (result) {
                            $scope.dobTextInputType = 'tel';
                        }
                    });
                },
                /**
                 * Absolutely makes sure that dob input doesn't contain bad characters.
                 * Called on any chatacter input AND on locale change.
                 */
                updateDobBindings: function updateDobBindings(change) {
                    var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
                    $scope.dob.value = cleanedDob;

                    // This way, our dob value is always formatted correctly.
                    if (change) {
                        $scope.dob.value = $('#dobText').val();
                    }
                },
                // Dynamically construct regex to only include date separator supported by country and nondigits
                getDateRegex: function getDateRegex() {
                    var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
                    var sep = this.dateSeparator;
                    var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
                    return new RegExp(assembledRegex, 'gi');
                },
                getDateMask: function getDateMask(dateSeparator) {
                    var dateFormat = this.dateFormat;
                    if (dateFormat === 'DMY' || dateFormat === 'MDY') {
                        return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
                    }

                    return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
                },
                getDateSeparator: function getDateSeparator(dateEntry) {
                    var ret = '';
                    this.getDateSeparators().forEach(function (ele, iter) {
                        // eslint-disable-line
                        if (dateEntry.indexOf(ele) !== -1) {
                            ret = ele;
                        }
                    });
                    return ret;
                },
                // To add any additional date separators, simply add them to the returned array.
                getDateSeparators: function getDateSeparators() {
                    return ['-', '.', '/'];
                },
                // Handles changes in date component order or date separator change.
                updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
                    var curDateVal = $scope.dob.value || '';

                    // Clear dob input if date is incomplete so user can see updated placeholder
                    if (curDateVal.length < 8) {
                        $scope.dob.value = '';
                        return;
                    }

                    var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
                        oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
                        newFormatIdxMapping = formatComponentIdxMappings[newFormat];
                    var oldDateComponents = curDateVal.split(oldSeparator),
                        newDateComponents = ['', '', ''];

                    newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
                    newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
                    newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
                    $scope.dob.value = newDateComponents.join(this.dateSeparator);
                },
                getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
                    return {
                        'DMY': {
                            'day': 0,
                            'month': 1,
                            'year': 2
                        },
                        'MDY': {
                            'day': 1,
                            'month': 0,
                            'year': 2
                        },
                        'YMD': {
                            'day': 2,
                            'month': 1,
                            'year': 0
                        }
                    };
                },
                prefillFetchedDob: function prefillFetchedDob() {
                    if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
                        if (!$scope.dob) {
                            $scope.dob = {};
                        }

                        if (this.dateFormat === 'DMY') {
                            $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
                        } else if (this.dateFormat === 'YMD') {
                            $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
                        } else {
                            $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
                        }
                    } else {
                        $scope.dob = {
                            value: ''
                        };
                    }
                }
            };

            DateManager._init_();
            DateManager.setDobTextPlaceHolder();
            DateManager.prefillFetchedDob();

            $scope.onDobTextKeyup = function (event) {
                DateManager.dobTextKeyupHandler(event);
            };

            $scope.$on('localeChange', function () {
                var oldDateFormat = DateManager.dateFormat;
                var oldSeparator = DateManager.dateSeparator;
                DateManager._init_();
                DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
                DateManager.updateDobBindings(false);
                DateManager.setDobTextPlaceHolder();
            });
        }]
    };
});

_squid.$locale;

_squid.$pxp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               aria-describedby=\"dobHelp\"\n               type=\"{{ dobTextInputType }}\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <span id=\"dobHelp\" class=\"accessAid\">{{ dobTextPlaceholder }}</span>\n        <label id=\"dobLabel\" for=\"dobText\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/gender-type/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/gender-type/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoGenderType', {
    tag: 'xo-gender-type',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: false
        }
    }
});


_index.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <div id=\"genderTypeContainer\" class=\"dropdown gender confidential halfInputElement inputField last-child\"\n         floating-label-dropdown directionality>\n        <select ng-model=\"user.gendertype\" name=\"gender\" xo-dropdown id=\"gender\"\n                aria-required=\"true\" ng-required=\"true\">\n            <option value=\"\">{{ content('common.genderLabel') }}</option>\n            <option value=\"MALE\">{{ content('common.genderMale') }}</option>\n            <option value=\"FEMALE\">{{ content('common.genderFemale') }}</option>\n        </select>\n        <label for=\"gender\" id=\"genderLabel\">{{ content('common.genderLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/template.html");

var _template2 = _interopRequireDefault(_template);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
    tag: 'xo-soldout-page',
    template: _template2['default'],
    auth: false,
    actions: {
        continueShoppingHandler: function continueShoppingHandler() {
            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            angular.element('.paypalHeader').css('display', 'none');
            angular.element('#defaultCancelLink').css('display', 'none');

            _logger.$logger.info('checkout_fpti', {
                landing_page: 'sold_out',
                int_error_code: '0',
                int_error_description: 'cart item sold out'
            });
        },
        populate: function populate() {
            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
        }
    }
});


_squid.$Component;

_squid.$locale;

_util.$ReturnToMerchant;

_uiRouter.$state;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSoldOutPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
    path: 'soldout',
    directive: _directive2['default'],
    titleContent: 'soldout.title',
    query: ['items', 'soldOutUrl'],
    auth: false,
    trackingData: {
        fptiState: 'soldout',
        templateName: 'soldout.dust',
        pageGoal: 'soldout page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-soldout',
                'pagename2': '%::fullpage-soldout:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.VALID_DIRECTION = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/language-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
    return VALID_DIRECTION.includes(n);
};


angular.module().directive('xoLanguageOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            direction: '@?'
        },

        controller: ['$scope', function ($scope) {
            $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
            $scope.showLanguages = false;

            function setLanguageVars() {
                $scope.localeModel = _squid.$locale;
                $scope.currentLanguage = $scope.localeModel.lang;
                $scope.currentCountry = $scope.localeModel.country;
                $scope.languageList = $scope.localeModel.metadata.languageLabel;
                $scope.supportedLanguages = _squid.$config.supportedCountries[$scope.currentCountry];
                $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
            }

            $scope.selectLanguage = function (language) {
                $scope.currentLanguage = language;
                _squid.$locale.chooseLang(language);
            };

            $scope.toggle = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.showLanguages = !$scope.showLanguages;
            };

            setLanguageVars();

            // Reset locale properties for languageToggle
            $scope.$on('localeChange', function () {
                setLanguageVars();
            });

            // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
            $scope.$on('clickBody', function ($event, target) {
                if ($(target).parents('.languageToggleDisplay div').length === 0) {
                    $scope.showLanguages = false;
                    $scope.$apply();
                }
            });
        }]
    };
});

_squid.$config;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"{{ direction }}\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages track by $index\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/name-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNameInput', {
    tag: 'xo-name-input',

    template: _template2['default'],

    props: {
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        user: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.metadata = _squid.$MetadataModel.create();

            var handleCountryChange = function handleCountryChange() {
                _this.metadata.choose(_this.country || _squid.$locale.country, _squid.$locale.lang);
            };

            this.$watch('country', handleCountryChange);
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$MetadataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n    <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout track by $index\">\n        <!-- First name -->\n        <div ng-if=\"layoutItem.$ === 'givenName'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"first-name-container\" floating-label disable-autoblur directionality>\n                <input ng-model=\"user.first_name\"\n                        id=\"firstName\"\n                        name=\"firstName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.first_name\" />\n                <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.firstName')}}\n                </label>\n            </div>\n        </div>\n\n        <!-- Last name -->\n        <div ng-if=\"layoutItem.$ === 'surname'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"last-name-container\" floating-label directionality>\n                <input ng-model=\"user.last_name\"\n                        id=\"lastName\"\n                        name=\"lastName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.last_name\" />\n                <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.lastName')}}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"!metadata.nameEntry.layout\">\n        <!-- First name -->\n        <div class=\"inputField half confidential\" floating-label disable-autoblur directionality>\n            <input ng-model=\"user.first_name\"\n                    id=\"firstName\"\n                    name=\"firstName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    data-test-id=\"user.first_name\" />\n            <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.firstName')}}\n            </label>\n        </div>\n\n        <!-- Last name -->\n        <div class=\"inputField half confidential last-child\" floating-label directionality>\n            <input ng-model=\"user.last_name\"\n                    id=\"lastName\"\n                    name=\"lastName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    data-test-id=\"user.last_name\" />\n            <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.lastName')}}\n            </label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().directive('brIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.cpfValidator = function cpfValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var len = value.length;

                if (len !== 11) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var x = value.match(/\b(\d)\1+\b/);

                if (x) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var v1 = 0;
                var v2 = 0;
                var dv1;
                var dv2;
                var i;
                var j;

                for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
                    // eslint-disable-line no-sequences
                    v1 += j * +value[i];
                }

                v1 = v1 % 11;
                dv1 = 11 - v1 < 10 ? 11 - v1 : 0;

                for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
                    // eslint-disable-line no-sequences
                    v2 += j * +value[i];
                }

                v2 += dv1 * 2;
                v2 = v2 % 11;
                dv2 = 11 - v2 < 10 ? 11 - v2 : 0;

                scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);

                ctrl.$setValidity('nationalId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.cpfValidator);
        }
    };
}).directive('sgIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.nricFinValidator = function nricFinValidator(ngModelValue) {
                var idType = scope.$parent.nationalIdModel.nationalId.type;
                if (idType === 'NATIONAL_ID') {
                    scope.isValid = false;

                    // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits followed by a letter.
                    if (ngModelValue.match(/^[SFTG]\d{7}[A-Z]$/)) {
                        scope.isValid = true;
                    }
                } else {
                    scope.isValid = true;
                }
                ctrl.$setValidity('nationalId', scope.isValid);
                return ngModelValue;
            };
            ctrl.$parsers.push(scope.nricFinValidator);
        }
    };
}).directive('ruIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {

            function validateSNILSChunk(sum, checksum) {
                if (sum < 100 && sum === checksum) {
                    return true;
                } else if ((sum === 100 || sum === 101) && checksum === 0) {
                    return true;
                } else if (sum > 101) {
                    var remainder = sum % 101;
                    return validateSNILSChunk(remainder, checksum);
                }

                return false;
            }

            function validateSNILS(value) {
                if (value.length === 11) {
                    if (Number(value) > 1001998) {
                        var snilsNumber = value.substring(0, 9);
                        var checksum = Number(value.substring(9));
                        var sum = 0;
                        var multiplier = 1;

                        for (var i = snilsNumber.length - 1; i >= 0; i--) {
                            sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
                            multiplier++;
                        }

                        return validateSNILSChunk(sum, checksum);
                    }

                    return true;
                }

                return false;
            }

            function validateINNChecksum(value, factor, valueLength, match) {
                var n;
                var sumn = 0;
                for (var i = 0; i < valueLength; i++) {
                    sumn = sumn + Number(value[i]) * Number(factor[i]);
                }
                n = sumn % 11;
                n = n === 10 ? 0 : n;

                if (n !== Number(match)) {
                    return false;
                }

                return true;
            }

            function validateINN(value) {
                if (value.length === 12) {
                    var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

                    if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
                        return false;
                    }

                    factor.unshift(3);

                    if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
                        return false;
                    }

                    return true;
                }

                return false;
            }

            function validateOMS(value) {
                if (value.length >= 11 && value.length <= 16) {
                    return true;
                }

                return false;
            }

            scope.idValidator = function idValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var secondaryType = scope.nationalIdModel.secondaryIdType;

                if (secondaryType === 'SNILS') {
                    scope.isValid = validateSNILS(value);
                } else if (secondaryType === 'INN') {
                    scope.isValid = validateINN(value);
                } else if (secondaryType === 'OMS') {
                    scope.isValid = validateOMS(value);
                }

                ctrl.$setValidity('secondaryId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.idValidator);
        }
    };
}).directive('xoNationalIdInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            country: '@?'
        },

        link: function link(scope, element, attr) {
            var passportMask = '0000000000';

            element.on('keyup', function (event) {
                if (scope.user.countryOfResidence === 'RU') {
                    $('#nationalId').mask(passportMask, {
                        'translation': {
                            0: { pattern: /[0-9]/ }
                        }
                    });
                } else {
                    $('#nationalId').unmask(passportMask);
                }
            });
        },

        controller: ['$scope', '$NationalIdModel', function ($scope, $NationalIdModel) {

            $scope.nationalIdModel = $NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
            $scope.user = $scope.user || {};
            $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
            $scope.formattedValues = {};
            $scope.showNationalIdFields = false;

            if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
                $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
            }

            $scope.countryChanged = function () {
                if ($scope.user.countryOfResidence === 'RU') {
                    $scope.showNationalIdFields = true;
                    $scope.minLengthNatId = 10;
                    $scope.maxLengthNatId = 10;
                } else {
                    $scope.showNationalIdFields = false;
                    $scope.minLengthNatId = 6;
                    $scope.maxLengthNatId = 15;
                }
            };

            $scope.cpfMasking = function (newValue) {
                if (newValue) {
                    var unformatted = newValue.replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.formattedValues.nationalId = formatted;
                    $scope.nationalIdModel.nationalId.value = unformatted;
                } else {
                    $scope.nationalIdModel.nationalId.value = '';
                }
            };

            $scope.secondaryIdFormatting = function () {
                var $el = $('#idValue');

                if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
                    var unformatted = $el.val().replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.nationalIdModel.secondaryIdValue = formatted;
                }
            };

            $scope.secondaryIdChange = function () {
                var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];

                $scope.nationalIdModel.secondaryIdValue = '';
                $scope.maxLength = currentSecondaryId.length;
                $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;

                $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
            };

            $scope.sgIdChange = function () {
                $scope.nationalIdModel.nationalId.value = '';
            };

            function setLocalizedNatIDLabels() {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport }
                };

                // National ID is not shown for South Korea
                if (_squid.$locale.country !== 'KR') {
                    $scope.nationalIds.NATID = { name: 'NATIONAL_ID', value: _squid.$locale.content.addTaxId.natid };
                }

                // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
                // other countries show "Driver’s License" in th national ID drop down
                if (_squid.$locale.country === 'HK' && (0, _squid.$feature)('driverLicenseToTempNationalID', false, _squid.$locale.country)) {
                    $scope.nationalIds.TNID = { name: 'TEMPORARY_NATIONAL_ID', value: _squid.$locale.content.addTaxId.tnid };
                } else {
                    $scope.nationalIds.DL = { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl };
                }
            }

            function setLocalizedRUContent() {
                $scope.countries = _squid.$locale.metadata.territory;
                $scope.secondaryIds = {
                    'INN': { name: 'INN', value: _squid.$locale.content.addTaxId.INN, length: 12 },
                    'SNILS': { name: 'SNILS', value: _squid.$locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
                    'OMS': { name: 'OMS', value: _squid.$locale.content.addTaxId.OMS, length: 16, minlength: 11 }
                };
            }

            if (_squid.$locale.country === 'BR') {
                $scope.nationalIdModel.nationalId.type = 'TAX_ID';
                $scope.nationalIdModel.nationalId.subType = 'CPF';

                $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
            } else if ($scope.country === 'RU') {
                setLocalizedRUContent();
                $scope.nationalIdModel.nationalId.type = 'PASSPORT';
                $scope.nationalIdModel.nationalId.subType = '';
                $scope.user.nativeName = $scope.user.nativeName || {};

                if (!$scope.nationalIdModel.secondaryIdType) {
                    $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
                }

                $scope.secondaryIdChange();

                $scope.countryChanged();
            } else if ($scope.country === 'KR') {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport },
                    'DL': { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl }
                };
                $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
                $scope.nationalIdModel.nationalId.subType = '';
            } else {
                // Default behaviour - set to 3pl countries
                setLocalizedNatIDLabels();
                $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
                $scope.nationalIdModel.nationalId.subType = '';
            }

            $scope.$on('contentChange', function () {
                setLocalizedNatIDLabels();

                if ($scope.country === 'RU') {
                    setLocalizedRUContent();
                }
            });
        }]
    };
}).factory('$NationalIdModel', function () {

    return _squid.$Model.extend('NationalIdModel', {

        init: function init() {
            this._super.init.apply(this);
            this.nationalId = this.nationalId || {};
        },

        serialize: function serialize() {
            return this.nationalId;
        }
    });
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$Model;

_index.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/national-id-input", "../node_modules/xo-form-components/src/national-id-input/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries track by $index\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"inputField full\" floating-label directionality>\n                        <input ng-model=\"nationalIdModel.nationalId.value\"\n                                name=\"nationalId\"\n                                id=\"nationalId\"\n                                value=\"\"\n                                autocapitalize=\"off\"\n                                aria-required=\"true\"\n                                autocomplete=\"off\"\n                                minlength=\"{{minLengthNatId}}\"\n                                maxlength=\"{{maxLengthNatId}}\"\n                                placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                xo-validation='{\"validator\": \"validRUPassport\"}'\n                                xo-error-tooltip\n                                required />\n\n                        <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                    </div>\n\n                    <xo-dob-input user=\"user\"></xo-dob-input>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType === '{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddPhone', function () {
    return {
        template: _template2['default'],
        scope: {},
        controller: ['$scope', function ($scope) {

            $scope.showPhoneDisclosure = (0, _squid.$featureCountries)('showPhoneDisclosure').indexOf(_squid.$locale.country) > -1;
            $scope.phoneConsent = (0, _squid.$feature)('phoneConsent');
            $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
            $scope.errorMessage = {
                msgKeys: ['addPhone.addPhoneNumberConsent'],
                type: 'info'
            };

            $scope.userInfo = _index2.$UserInfoModel.instance(_angular.$rootScope.token);
            $scope.phone = {};

            var CONTENT_KEY = {
                INVALID_PHONE_NUMBER: 'validPhone'
            };

            var CONTENT_MAPPING = {
                numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
                typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
            };

            var populateErrorMessage = function populateErrorMessage(name) {
                var contentKey = CONTENT_MAPPING[name];
                var msg = contentKey ? _squid.$locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;

                $scope.errorMessage = {
                    msgs: [msg],
                    type: 'error'
                };
            };

            var validationErrorHandler = {
                numberError: populateErrorMessage,
                typeError: populateErrorMessage
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                $scope.logout = function () {
                    _logger.$logger.info('not_you_logout');
                    $scope.auth.action('logout').then(function () {
                        _uiRouter.$state.go('checkout.login');
                    });
                };

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && $scope.logout;

                $scope.onSubmit = function () {
                    if ($scope.phoneConsent) {
                        $scope.phone.consent = {
                            agreed: true,
                            contentId: _squid.$locale.country + ':' + _squid.$locale.lang + ':' + $scope.consentContentKey + ':' + (0, _squid.$contentVersion)()
                        };
                    }
                    $scope.userInfo.action('addPhone', {

                        data: $scope.phone,

                        success: function success(data) {
                            return _index.$CheckoutSessionModel.instance(_angular.$rootScope.token).action('create', {
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },

                        contingencies: {
                            NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/addCard');
                            },

                            EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/updateCard');
                            }
                        },

                        validation: function validation(data) {
                            angular.forEach(data, function (value, key) {
                                validationErrorHandler[key](key);
                            });
                        }
                    });
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$location;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.$featureCountries;

_squid.$contentVersion;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return {
        'AC': {
            'status': 'reserved',
            'phoneCountryCode': '247',
            'showCountryCodeList': false
        },
        'AD': {
            'status': 'assigned',
            'phoneCountryCode': '376',
            'showCountryCodeList': false
        },
        'AE': {
            'status': 'assigned',
            'phoneCountryCode': '971',
            'showCountryCodeList': false
        },
        'AF': {
            'status': 'assigned',
            'phoneCountryCode': '93',
            'showCountryCodeList': false
        },
        'AG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AL': {
            'status': 'assigned',
            'phoneCountryCode': '355',
            'showCountryCodeList': false
        },
        'AM': {
            'status': 'assigned',
            'phoneCountryCode': '374',
            'showCountryCodeList': false
        },
        'AN': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'AO': {
            'status': 'assigned',
            'phoneCountryCode': '244',
            'showCountryCodeList': false
        },
        'AQ': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'AR': {
            'status': 'assigned',
            'phoneCountryCode': '54',
            'showCountryCodeList': false
        },
        'AS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AT': {
            'status': 'assigned',
            'phoneCountryCode': '43',
            'showCountryCodeList': true
        },
        'AU': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': true
        },
        'AW': {
            'status': 'assigned',
            'phoneCountryCode': '297',
            'showCountryCodeList': false
        },
        'AZ': {
            'status': 'assigned',
            'phoneCountryCode': '994',
            'showCountryCodeList': false
        },
        'BA': {
            'status': 'assigned',
            'phoneCountryCode': '387',
            'showCountryCodeList': false
        },
        'BB': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BD': {
            'status': 'assigned',
            'phoneCountryCode': '880',
            'showCountryCodeList': false
        },
        'BE': {
            'status': 'assigned',
            'phoneCountryCode': '32',
            'showCountryCodeList': true
        },
        'BF': {
            'status': 'assigned',
            'phoneCountryCode': '226',
            'showCountryCodeList': false
        },
        'BG': {
            'status': 'assigned',
            'phoneCountryCode': '359',
            'showCountryCodeList': false
        },
        'BH': {
            'status': 'assigned',
            'phoneCountryCode': '973',
            'showCountryCodeList': false
        },
        'BI': {
            'status': 'assigned',
            'phoneCountryCode': '257',
            'showCountryCodeList': false
        },
        'BJ': {
            'status': 'assigned',
            'phoneCountryCode': '229',
            'showCountryCodeList': false
        },
        'BL': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'BM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BN': {
            'status': 'assigned',
            'phoneCountryCode': '673',
            'showCountryCodeList': false
        },
        'BO': {
            'status': 'assigned',
            'phoneCountryCode': '591',
            'showCountryCodeList': false
        },
        'BQ': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'BR': {
            'status': 'assigned',
            'phoneCountryCode': '55',
            'showCountryCodeList': false
        },
        'BS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BT': {
            'status': 'assigned',
            'phoneCountryCode': '975',
            'showCountryCodeList': false
        },
        'BV': {
            'status': 'assigned'
        },
        'BW': {
            'status': 'assigned',
            'phoneCountryCode': '267',
            'showCountryCodeList': false
        },
        'BY': {
            'status': 'assigned',
            'phoneCountryCode': '375',
            'showCountryCodeList': false
        },
        'BZ': {
            'status': 'assigned',
            'phoneCountryCode': '501',
            'showCountryCodeList': false
        },
        'C2': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CA': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'CC': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CD': {
            'status': 'assigned',
            'phoneCountryCode': '243',
            'showCountryCodeList': false
        },
        'CF': {
            'status': 'assigned',
            'phoneCountryCode': '236',
            'showCountryCodeList': false
        },
        'CG': {
            'status': 'assigned',
            'phoneCountryCode': '242',
            'showCountryCodeList': false
        },
        'CH': {
            'status': 'assigned',
            'phoneCountryCode': '41',
            'showCountryCodeList': true
        },
        'CI': {
            'status': 'assigned',
            'phoneCountryCode': '225',
            'showCountryCodeList': false
        },
        'CK': {
            'status': 'assigned',
            'phoneCountryCode': '682',
            'showCountryCodeList': false
        },
        'CL': {
            'status': 'assigned',
            'phoneCountryCode': '56',
            'showCountryCodeList': false
        },
        'CM': {
            'status': 'assigned',
            'phoneCountryCode': '237',
            'showCountryCodeList': false
        },
        'CN': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CO': {
            'status': 'assigned',
            'phoneCountryCode': '57',
            'showCountryCodeList': false
        },
        'CR': {
            'status': 'assigned',
            'phoneCountryCode': '506',
            'showCountryCodeList': false
        },
        'CU': {
            'status': 'assigned',
            'phoneCountryCode': '53',
            'showCountryCodeList': false
        },
        'CV': {
            'status': 'assigned',
            'phoneCountryCode': '238',
            'showCountryCodeList': false
        },
        'CW': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'CX': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CY': {
            'status': 'assigned',
            'phoneCountryCode': '357',
            'showCountryCodeList': false
        },
        'CZ': {
            'status': 'assigned',
            'phoneCountryCode': '420',
            'showCountryCodeList': false
        },
        'DE': {
            'status': 'assigned',
            'phoneCountryCode': '49',
            'showCountryCodeList': false
        },
        'DJ': {
            'status': 'assigned',
            'phoneCountryCode': '253',
            'showCountryCodeList': false
        },
        'DK': {
            'status': 'assigned',
            'phoneCountryCode': '45',
            'showCountryCodeList': true
        },
        'DM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DO': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DZ': {
            'status': 'assigned',
            'phoneCountryCode': '213',
            'showCountryCodeList': false
        },
        'EC': {
            'status': 'assigned',
            'phoneCountryCode': '593',
            'showCountryCodeList': false
        },
        'EE': {
            'status': 'assigned',
            'phoneCountryCode': '372',
            'showCountryCodeList': false
        },
        'EG': {
            'status': 'assigned',
            'phoneCountryCode': '20',
            'showCountryCodeList': false
        },
        'EH': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'ER': {
            'status': 'assigned',
            'phoneCountryCode': '291',
            'showCountryCodeList': false
        },
        'ES': {
            'status': 'assigned',
            'phoneCountryCode': '34',
            'showCountryCodeList': false
        },
        'ET': {
            'status': 'assigned',
            'phoneCountryCode': '251',
            'showCountryCodeList': false
        },
        'FI': {
            'status': 'assigned',
            'phoneCountryCode': '358',
            'showCountryCodeList': false
        },
        'FJ': {
            'status': 'assigned',
            'phoneCountryCode': '679',
            'showCountryCodeList': false
        },
        'FK': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'FM': {
            'status': 'assigned',
            'phoneCountryCode': '691',
            'showCountryCodeList': false
        },
        'FO': {
            'status': 'assigned',
            'phoneCountryCode': '298',
            'showCountryCodeList': false
        },
        'FR': {
            'status': 'assigned',
            'phoneCountryCode': '33',
            'showCountryCodeList': false
        },
        'GA': {
            'status': 'assigned',
            'phoneCountryCode': '241',
            'showCountryCodeList': false
        },
        'GB': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GD': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GE': {
            'status': 'assigned',
            'phoneCountryCode': '995',
            'showCountryCodeList': false
        },
        'GF': {
            'status': 'assigned',
            'phoneCountryCode': '594',
            'showCountryCodeList': false
        },
        'GG': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GH': {
            'status': 'assigned',
            'phoneCountryCode': '233',
            'showCountryCodeList': false
        },
        'GI': {
            'status': 'assigned',
            'phoneCountryCode': '350',
            'showCountryCodeList': false
        },
        'GL': {
            'status': 'assigned',
            'phoneCountryCode': '299',
            'showCountryCodeList': false
        },
        'GM': {
            'status': 'assigned',
            'phoneCountryCode': '220',
            'showCountryCodeList': false
        },
        'GN': {
            'status': 'assigned',
            'phoneCountryCode': '224',
            'showCountryCodeList': false
        },
        'GP': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'GQ': {
            'status': 'assigned',
            'phoneCountryCode': '240',
            'showCountryCodeList': false
        },
        'GR': {
            'status': 'assigned',
            'phoneCountryCode': '30',
            'showCountryCodeList': false
        },
        'GS': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'GT': {
            'status': 'assigned',
            'phoneCountryCode': '502',
            'showCountryCodeList': false
        },
        'GU': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GW': {
            'status': 'assigned',
            'phoneCountryCode': '245',
            'showCountryCodeList': false
        },
        'GY': {
            'status': 'assigned',
            'phoneCountryCode': '592',
            'showCountryCodeList': false
        },
        'HK': {
            'status': 'assigned',
            'phoneCountryCode': '852',
            'showCountryCodeList': true
        },
        'HM': {
            'status': 'assigned'
        },
        'HN': {
            'status': 'assigned',
            'phoneCountryCode': '504',
            'showCountryCodeList': false
        },
        'HR': {
            'status': 'assigned',
            'phoneCountryCode': '385',
            'showCountryCodeList': false
        },
        'HT': {
            'status': 'assigned',
            'phoneCountryCode': '509',
            'showCountryCodeList': false
        },
        'HU': {
            'status': 'assigned',
            'phoneCountryCode': '36',
            'showCountryCodeList': false
        },
        'ID': {
            'status': 'assigned',
            'phoneCountryCode': '62',
            'showCountryCodeList': false
        },
        'IE': {
            'status': 'assigned',
            'phoneCountryCode': '353',
            'showCountryCodeList': false
        },
        'IL': {
            'status': 'assigned',
            'phoneCountryCode': '972',
            'showCountryCodeList': false
        },
        'IM': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'IN': {
            'status': 'assigned',
            'phoneCountryCode': '91',
            'showCountryCodeList': false
        },
        'IO': {
            'status': 'assigned',
            'phoneCountryCode': '246',
            'showCountryCodeList': false
        },
        'IQ': {
            'status': 'assigned',
            'phoneCountryCode': '964',
            'showCountryCodeList': false
        },
        'IR': {
            'status': 'assigned',
            'phoneCountryCode': '98',
            'showCountryCodeList': false
        },
        'IS': {
            'status': 'assigned',
            'phoneCountryCode': '354',
            'showCountryCodeList': false
        },
        'IT': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'JE': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'JM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'JO': {
            'status': 'assigned',
            'phoneCountryCode': '962',
            'showCountryCodeList': false
        },
        'JP': {
            'status': 'assigned',
            'phoneCountryCode': '81',
            'showCountryCodeList': false
        },
        'KE': {
            'status': 'assigned',
            'phoneCountryCode': '254',
            'showCountryCodeList': false
        },
        'KG': {
            'status': 'assigned',
            'phoneCountryCode': '996',
            'showCountryCodeList': false
        },
        'KH': {
            'status': 'assigned',
            'phoneCountryCode': '855',
            'showCountryCodeList': false
        },
        'KI': {
            'status': 'assigned',
            'phoneCountryCode': '686',
            'showCountryCodeList': false
        },
        'KM': {
            'status': 'assigned',
            'phoneCountryCode': '269',
            'showCountryCodeList': false
        },
        'KN': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KP': {
            'status': 'assigned',
            'phoneCountryCode': '850',
            'showCountryCodeList': false
        },
        'KR': {
            'status': 'assigned',
            'phoneCountryCode': '82',
            'showCountryCodeList': false
        },
        'KW': {
            'status': 'assigned',
            'phoneCountryCode': '965',
            'showCountryCodeList': false
        },
        'KY': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KZ': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'LA': {
            'status': 'assigned',
            'phoneCountryCode': '856',
            'showCountryCodeList': true
        },
        'LB': {
            'status': 'assigned',
            'phoneCountryCode': '961',
            'showCountryCodeList': false
        },
        'LC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'LI': {
            'status': 'assigned',
            'phoneCountryCode': '423',
            'showCountryCodeList': false
        },
        'LK': {
            'status': 'assigned',
            'phoneCountryCode': '94',
            'showCountryCodeList': false
        },
        'LR': {
            'status': 'assigned',
            'phoneCountryCode': '231',
            'showCountryCodeList': false
        },
        'LS': {
            'status': 'assigned',
            'phoneCountryCode': '266',
            'showCountryCodeList': false
        },
        'LT': {
            'status': 'assigned',
            'phoneCountryCode': '370',
            'showCountryCodeList': false
        },
        'LU': {
            'status': 'assigned',
            'phoneCountryCode': '352',
            'showCountryCodeList': false
        },
        'LV': {
            'status': 'assigned',
            'phoneCountryCode': '371',
            'showCountryCodeList': false
        },
        'LY': {
            'status': 'assigned',
            'phoneCountryCode': '218',
            'showCountryCodeList': false
        },
        'MA': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'MC': {
            'status': 'assigned',
            'phoneCountryCode': '377',
            'showCountryCodeList': false
        },
        'MD': {
            'status': 'assigned',
            'phoneCountryCode': '373',
            'showCountryCodeList': false
        },
        'ME': {
            'status': 'assigned',
            'phoneCountryCode': '382',
            'showCountryCodeList': false
        },
        'MF': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'MG': {
            'status': 'assigned',
            'phoneCountryCode': '261',
            'showCountryCodeList': false
        },
        'MH': {
            'status': 'assigned',
            'phoneCountryCode': '692',
            'showCountryCodeList': false
        },
        'MK': {
            'status': 'assigned',
            'phoneCountryCode': '389',
            'showCountryCodeList': false
        },
        'ML': {
            'status': 'assigned',
            'phoneCountryCode': '223',
            'showCountryCodeList': false
        },
        'MM': {
            'status': 'assigned',
            'phoneCountryCode': '95',
            'showCountryCodeList': false
        },
        'MN': {
            'status': 'assigned',
            'phoneCountryCode': '976',
            'showCountryCodeList': false
        },
        'MO': {
            'status': 'assigned',
            'phoneCountryCode': '853',
            'showCountryCodeList': false
        },
        'MP': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MQ': {
            'status': 'assigned',
            'phoneCountryCode': '596',
            'showCountryCodeList': false
        },
        'MR': {
            'status': 'assigned',
            'phoneCountryCode': '222',
            'showCountryCodeList': false
        },
        'MS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MT': {
            'status': 'assigned',
            'phoneCountryCode': '356',
            'showCountryCodeList': false
        },
        'MU': {
            'status': 'assigned',
            'phoneCountryCode': '230',
            'showCountryCodeList': false
        },
        'MV': {
            'status': 'assigned',
            'phoneCountryCode': '960',
            'showCountryCodeList': false
        },
        'MW': {
            'status': 'assigned',
            'phoneCountryCode': '265',
            'showCountryCodeList': false
        },
        'MX': {
            'status': 'assigned',
            'phoneCountryCode': '52',
            'showCountryCodeList': false
        },
        'MY': {
            'status': 'assigned',
            'phoneCountryCode': '60',
            'showCountryCodeList': false
        },
        'MZ': {
            'status': 'assigned',
            'phoneCountryCode': '258',
            'showCountryCodeList': false
        },
        'NA': {
            'status': 'assigned',
            'phoneCountryCode': '264',
            'showCountryCodeList': false
        },
        'NC': {
            'status': 'assigned',
            'phoneCountryCode': '687',
            'showCountryCodeList': false
        },
        'NE': {
            'status': 'assigned',
            'phoneCountryCode': '227',
            'showCountryCodeList': false
        },
        'NF': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'NG': {
            'status': 'assigned',
            'phoneCountryCode': '234',
            'showCountryCodeList': false
        },
        'NI': {
            'status': 'assigned',
            'phoneCountryCode': '505',
            'showCountryCodeList': false
        },
        'NL': {
            'status': 'assigned',
            'phoneCountryCode': '31',
            'showCountryCodeList': true
        },
        'NO': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': true
        },
        'NP': {
            'status': 'assigned',
            'phoneCountryCode': '977',
            'showCountryCodeList': false
        },
        'NR': {
            'status': 'assigned',
            'phoneCountryCode': '674',
            'showCountryCodeList': false
        },
        'NU': {
            'status': 'assigned',
            'phoneCountryCode': '683',
            'showCountryCodeList': false
        },
        'NZ': {
            'status': 'assigned',
            'phoneCountryCode': '64',
            'showCountryCodeList': false
        },
        'OM': {
            'status': 'assigned',
            'phoneCountryCode': '968',
            'showCountryCodeList': false
        },
        'PA': {
            'status': 'assigned',
            'phoneCountryCode': '507',
            'showCountryCodeList': false
        },
        'PE': {
            'status': 'assigned',
            'phoneCountryCode': '51',
            'showCountryCodeList': false
        },
        'PF': {
            'status': 'assigned',
            'phoneCountryCode': '689',
            'showCountryCodeList': false
        },
        'PG': {
            'status': 'assigned',
            'phoneCountryCode': '675',
            'showCountryCodeList': false
        },
        'PH': {
            'status': 'assigned',
            'phoneCountryCode': '63',
            'showCountryCodeList': false
        },
        'PK': {
            'status': 'assigned',
            'phoneCountryCode': '92',
            'showCountryCodeList': false
        },
        'PL': {
            'status': 'assigned',
            'phoneCountryCode': '48',
            'showCountryCodeList': true
        },
        'PM': {
            'status': 'assigned',
            'phoneCountryCode': '508',
            'showCountryCodeList': false
        },
        'PN': {
            'status': 'assigned',
            'phoneCountryCode': '870',
            'showCountryCodeList': false
        },
        'PR': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'PS': {
            'status': 'assigned',
            'phoneCountryCode': '970',
            'showCountryCodeList': false
        },
        'PT': {
            'status': 'assigned',
            'phoneCountryCode': '351',
            'showCountryCodeList': false
        },
        'PW': {
            'status': 'assigned',
            'phoneCountryCode': '680',
            'showCountryCodeList': false
        },
        'PY': {
            'status': 'assigned',
            'phoneCountryCode': '595',
            'showCountryCodeList': false
        },
        'QA': {
            'status': 'assigned',
            'phoneCountryCode': '974',
            'showCountryCodeList': false
        },
        'RE': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'RO': {
            'status': 'assigned',
            'phoneCountryCode': '40',
            'showCountryCodeList': false
        },
        'RS': {
            'status': 'assigned',
            'phoneCountryCode': '381',
            'showCountryCodeList': false
        },
        'RU': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'RW': {
            'status': 'assigned',
            'phoneCountryCode': '250',
            'showCountryCodeList': false
        },
        'SA': {
            'status': 'assigned',
            'phoneCountryCode': '966',
            'showCountryCodeList': false
        },
        'SB': {
            'status': 'assigned',
            'phoneCountryCode': '677',
            'showCountryCodeList': false
        },
        'SC': {
            'status': 'assigned',
            'phoneCountryCode': '248',
            'showCountryCodeList': false
        },
        'SD': {
            'status': 'assigned',
            'phoneCountryCode': '249',
            'showCountryCodeList': false
        },
        'SE': {
            'status': 'assigned',
            'phoneCountryCode': '46',
            'showCountryCodeList': true
        },
        'SG': {
            'status': 'assigned',
            'phoneCountryCode': '65',
            'showCountryCodeList': true
        },
        'SH': {
            'status': 'assigned',
            'phoneCountryCode': '290',
            'showCountryCodeList': false
        },
        'SI': {
            'status': 'assigned',
            'phoneCountryCode': '386',
            'showCountryCodeList': false
        },
        'SJ': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': false
        },
        'SK': {
            'status': 'assigned',
            'phoneCountryCode': '421',
            'showCountryCodeList': false
        },
        'SL': {
            'status': 'assigned',
            'phoneCountryCode': '232',
            'showCountryCodeList': false
        },
        'SM': {
            'status': 'assigned',
            'phoneCountryCode': '378',
            'showCountryCodeList': false
        },
        'SN': {
            'status': 'assigned',
            'phoneCountryCode': '221',
            'showCountryCodeList': false
        },
        'SO': {
            'status': 'assigned',
            'phoneCountryCode': '252',
            'showCountryCodeList': false
        },
        'SR': {
            'status': 'assigned',
            'phoneCountryCode': '597',
            'showCountryCodeList': false
        },
        'SS': {
            'status': 'assigned',
            'phoneCountryCode': '211',
            'showCountryCodeList': false
        },
        'ST': {
            'status': 'assigned',
            'phoneCountryCode': '239',
            'showCountryCodeList': false
        },
        'SV': {
            'status': 'assigned',
            'phoneCountryCode': '503',
            'showCountryCodeList': false
        },
        'SX': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'SY': {
            'status': 'assigned',
            'phoneCountryCode': '963',
            'showCountryCodeList': false
        },
        'SZ': {
            'status': 'assigned',
            'phoneCountryCode': '268',
            'showCountryCodeList': false
        },
        'TC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TD': {
            'status': 'assigned',
            'phoneCountryCode': '235',
            'showCountryCodeList': false
        },
        'TF': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'TG': {
            'status': 'assigned',
            'phoneCountryCode': '228',
            'showCountryCodeList': false
        },
        'TH': {
            'status': 'assigned',
            'phoneCountryCode': '66',
            'showCountryCodeList': false
        },
        'TJ': {
            'status': 'assigned',
            'phoneCountryCode': '992',
            'showCountryCodeList': false
        },
        'TK': {
            'status': 'assigned',
            'phoneCountryCode': '690',
            'showCountryCodeList': false
        },
        'TL': {
            'status': 'assigned',
            'phoneCountryCode': '670',
            'showCountryCodeList': false
        },
        'TM': {
            'status': 'assigned',
            'phoneCountryCode': '993',
            'showCountryCodeList': false
        },
        'TN': {
            'status': 'assigned',
            'phoneCountryCode': '216',
            'showCountryCodeList': false
        },
        'TO': {
            'status': 'assigned',
            'phoneCountryCode': '676',
            'showCountryCodeList': false
        },
        'TR': {
            'status': 'assigned',
            'phoneCountryCode': '90',
            'showCountryCodeList': true
        },
        'TT': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TV': {
            'status': 'assigned',
            'phoneCountryCode': '688',
            'showCountryCodeList': false
        },
        'TW': {
            'status': 'assigned',
            'phoneCountryCode': '886',
            'showCountryCodeList': true
        },
        'TZ': {
            'status': 'assigned',
            'phoneCountryCode': '255',
            'showCountryCodeList': false
        },
        'UA': {
            'status': 'assigned',
            'phoneCountryCode': '380',
            'showCountryCodeList': false
        },
        'UG': {
            'status': 'assigned',
            'phoneCountryCode': '256',
            'showCountryCodeList': false
        },
        'UM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'US': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false,
            'hideInOtherCountries': true
        },
        'UY': {
            'status': 'assigned',
            'phoneCountryCode': '598',
            'showCountryCodeList': false
        },
        'UZ': {
            'status': 'assigned',
            'phoneCountryCode': '998',
            'showCountryCodeList': false
        },
        'VA': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'VC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VE': {
            'status': 'assigned',
            'phoneCountryCode': '58',
            'showCountryCodeList': false
        },
        'VG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VN': {
            'status': 'assigned',
            'phoneCountryCode': '84',
            'showCountryCodeList': false
        },
        'VU': {
            'status': 'assigned',
            'phoneCountryCode': '678',
            'showCountryCodeList': false
        },
        'WF': {
            'status': 'assigned',
            'phoneCountryCode': '681',
            'showCountryCodeList': false
        },
        'WS': {
            'status': 'assigned',
            'phoneCountryCode': '685',
            'showCountryCodeList': false
        },
        'YE': {
            'status': 'assigned',
            'phoneCountryCode': '967',
            'showCountryCodeList': false
        },
        'YT': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'ZA': {
            'status': 'assigned',
            'phoneCountryCode': '27',
            'showCountryCodeList': false
        },
        'ZM': {
            'status': 'assigned',
            'phoneCountryCode': '260',
            'showCountryCodeList': false
        },
        'ZW': {
            'status': 'assigned',
            'phoneCountryCode': '263',
            'showCountryCodeList': false
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPhoneInput', {
    tag: 'xo-phone-input',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            reqiured: false
        },

        showPhoneType: {
            type: 'var',
            optional: true,
            'default': true
        },

        hideWork: {
            type: 'var',
            optional: true,
            'default': false
        },

        token: {
            type: 'var',
            optional: true
        },

        exclude: {
            type: 'var',
            optional: true
        },

        hidePhoneType: {
            type: 'var',
            optional: true,
            'default': false
        },

        country: {
            type: 'var',
            optional: true
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var getTreatment = function getTreatment() {

                if ((0, _squid.$feature)('showNewPhoneDesign', false, _squid.$locale.country)) {
                    return true;
                }

                var throttle = void 0;

                if (_squid.$config['newPhoneDesignThrottle']) {

                    throttle = _squid.$config['newPhoneDesignThrottle']['DEFAULT'];

                    if (_squid.$config['newPhoneDesignThrottle'][_squid.$locale.country] >= 0) {
                        throttle = _squid.$config['newPhoneDesignThrottle'][_squid.$locale.country];
                    }
                }

                var id = _squid.$locale.country + _angular.$rootScope.token;
                return throttle !== undefined && (0, _squid.$experiment)('new_phone_design_exp', throttle, id, {}) ? true : false;
            };

            this.treatment = getTreatment();

            this.$watch('showPhoneType', function () {
                _this.hidePhoneType = _this.showPhoneType === false;
            }, true);
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\" country=\"country\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"hidePhoneType\" show-phone-type=\"showPhoneType\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

var _territoriesByCode = __webpack_require__("../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js");

var _territoriesByCode2 = _interopRequireDefault(_territoriesByCode);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPhoneInputA', function () {
    return {
        template: _template2['default'],
        scope: {
            phone: '=?',
            showPhoneType: '=?',
            exclude: '@?',
            country: '=?'
        },

        link: function link(scope, element, attr, controller) {
            element.on('keyup', function (event) {
                element.find('.telephone').mask(scope.mask, {
                    'translation': {
                        0: { pattern: /[0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.IntDialingCodes = _territoriesByCode2['default'];
            $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
            $scope.showPhoneType = (0, _squid.$feature)('phoneType', true, $scope.country) && $scope.showPhoneType !== false;

            // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
            // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
            $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
                return _squid.$locale.country !== dropdownCountry && hideInOtherCountries;
            };

            $scope.phone = $scope.phone || {};
            $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
            $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;

            angular.extend($scope.phone, {
                phoneCountryCode: _squid.$locale.country
            });

            function getPhoneMask(phoneType, phoneEntry) {
                var defaultMask = '0000000000000000';
                var masks = phoneEntry && phoneEntry.masks;
                var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
                var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
                return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
            }

            function getPhonePattern(phoneEntry) {
                var defaultPattern = '^[0-9]+$';
                var patterns = phoneEntry && phoneEntry.patterns;
                // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
                // for now we use less strict regex validation because we are not ready for this more strict validation
                if (patterns) {
                    return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
                }
                return defaultPattern;

                // more strict regex validaiton based on phone type is found commented below
                // var ret;
                // switch ($scope.phone.phoneType) {
                //     case 'Mobile':
                //         ret = patterns.MOBILE;
                //         break;
                //     case 'Home':
                //     case 'Work':
                //         ret = patterns.FIXED_LINE;
                //         break;
                //     default:
                //         ret = patterns.GENERAL;
                //         break;
                // }
                // return ret ? ret : defaultPattern;
            }

            function populatePhoneMetadata() {
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    $scope.metadata = angular.copy(_squid.$locale.metadata);
                }
                var phoneEntry = $scope.metadata.phoneEntry;
                $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                $scope.pattern = getPhonePattern(phoneEntry);
            }

            populatePhoneMetadata();

            // Reset the phone number mask from according to the phone type
            $scope.phoneTypeChanged = function () {
                $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
                $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
                $('.telephone').mask($scope.mask);
            };

            $scope.$watch('phone.phoneCountryCode', function (newValue) {
                $scope.phone.IntDialingCountryCode = _territoriesByCode2['default'][newValue].phoneCountryCode;
            });

            $scope.$on('localeChange', function () {
                $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
                $scope.phone.phoneCountryCode = _squid.$locale.country;
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    populatePhoneMetadata();
                    $('.telephone').mask($scope.mask);
                }
            });

            $scope.$watch('country', function (newVal) {
                if (newVal) {
                    $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][$scope.country];
                    $scope.phone.phoneCountryCode = $scope.country;

                    if (!$scope.metadata || $scope.metadata.country !== $scope.country) {

                        $scope.metadata = _squid.$MetadataModel.create();
                        $scope.metadata.choose($scope.country, _squid.$locale.lang).then(function () {

                            var phoneEntry = $scope.metadata.phoneEntry;
                            $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                            $scope.pattern = getPhonePattern(phoneEntry);

                            $('.telephone').mask($scope.mask);
                        });
                    }
                }
            });

            $scope.showWork = $scope.exclude === 'WORK';
        }]
    };
});

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes track by $index\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/styles.less");

__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MOBILE = 'Mobile';
var KEYS = {
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    ESC: 27,
    A: 65,
    Z: 90,
    SPACE: 32
};

var query = '';
var queryTimer = null;

exports['default'] = _squid.$Component.extend('$xoPhoneInputB', {
    tag: 'xo-phone-input-b',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            required: false
        },

        hidePhoneType: {
            type: 'var',
            required: false
        },

        hideWork: {
            type: 'var',
            required: false,
            'default': false
        }
    },

    actions: {

        // return the phonePattern
        getPhonePattern: function getPhonePattern(phoneEntry) {
            var DEFAULT_PATTERN = '^[0-9]+$';
            var patterns = phoneEntry && phoneEntry.patterns;
            // less strict regex validation in place for now, just use general regex to match mobile AND fixed-line
            // formats
            // for now we use less strict regex validation because we are not ready for this more strict validation
            return patterns && patterns.GENERAL ? patterns.GENERAL : DEFAULT_PATTERN;
        },


        // return phoneMask based on phone Type
        getPhoneMask: function getPhoneMask(phoneType, phoneEntry) {
            var DEFAULT_MASK = '0000000000000000';
            var masks = phoneEntry && phoneEntry.masks;

            if (phoneType === MOBILE) {
                return masks && masks.MOBILE ? masks.MOBILE : DEFAULT_MASK;
            } else {
                return masks && masks.FIXED_LINE ? masks.FIXED_LINE : DEFAULT_MASK;
            }
        },


        // set the phone number mask and pattern
        updatePhoneMaskAndPattern: function updatePhoneMaskAndPattern() {
            var country = this.metadata.localization.country;
            // If phoneCountry does not match the country the metadata is from then
            // we set phoneEntry to a falsey value so the default pattern and mask are
            // used for the phone input.

            var phoneEntry = this.phoneCountry === country && this.metadata.phoneEntry;

            this.mask = this.actions.getPhoneMask(this.phone.phoneType, phoneEntry);
            this.pattern = this.actions.getPhonePattern(phoneEntry);
            this.actions.applyMaskOnPhoneInput();
        },
        getPhoneDialingCode: function getPhoneDialingCode(territory, state) {
            var overrides = this.metadata.regionalOverrides;

            if (state && overrides && overrides.hasOwnProperty(state) && overrides[state].props.internationalDialingCode) {
                return overrides[state].props.internationalDialingCode;
            }

            return territory.internationalDialingCode;
        },


        // fetch the passed country's international dialing code
        updateDialingCodeAndCountry: function updateDialingCodeAndCountry() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            this.phoneCountry = territory.code;
            this.phone.IntDialingCountryCode = this.actions.getPhoneDialingCode(territory, state);
            (0, _jquery2['default'])('.fixedCode').text('+' + this.phone.IntDialingCountryCode);
        },


        /* if user chooses a different dialing code -
         -. fetch the new country's metadata
         -. update phone Country and dialing code
         -. update the phone number mask and pattern (no explicit call as it happens when metadata updates)
         -. close the dropdown if open
         */
        updatePhoneFieldMetadata: function updatePhoneFieldMetadata() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            // create a local copy of metadata (only happens on initial load)
            if (!this.metadata) {
                this.metadata = _squid.$MetadataModel.instance(0, {
                    'noBroadcast': true
                });
            }

            this.metadata.choose(territory.code);

            this.actions.updateDialingCodeAndCountry(territory, state);
            // Whenever metadata is updated that is promise returns then the metadata listener will update the mask
            // and pattern so not calling it here. Moving on...

            // close the dropdown if open
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            }

            _logger.$logger.info('phone_country_code_updated', {
                territory: territory.code
            });
        },
        getTerritoryDataFromMetadata: function getTerritoryDataFromMetadata(country) {
            return _squid.$util.find(this.dialingCodeList, function (_ref) {
                var code = _ref.code;
                return code === country;
            });
        },


        // set the stage on first load or on locale change
        init: function init(country) {
            this.hidePhoneType = this.hidePhoneType || (0, _squid.$feature)('hidePhoneType', false, country);

            this.showDialingCodeContainer = (0, _squid.$feature)('showDialingCodeContainer', false, country);

            this.listVisible = false;

            // default the phone type to Mobile if not specified
            // Note: this.phone is not optional
            this.phone = this.phone || {};

            this.phone.phoneType = this.phone.phoneType || 'Mobile';

            // populate the dialing code list/options
            var _$locale$metadata = _squid.$locale.metadata,
                _$locale$metadata$ter = _$locale$metadata.territory,
                territory = _$locale$metadata$ter === undefined ? [] : _$locale$metadata$ter,
                _$locale$metadata$add = _$locale$metadata.additionalDialingCodes,
                additionalDialingCodes = _$locale$metadata$add === undefined ? [] : _$locale$metadata$add;
            var _$config$dialingCodeB = _squid.$config.dialingCodeBlacklist,
                dialingCodeBlacklist = _$config$dialingCodeB === undefined ? [] : _$config$dialingCodeB;

            // Merge dialing codes from supported countries with dialing codes from
            // assigned countries and then filtering countries that are blacklisted

            this.dialingCodeList = territory.concat(additionalDialingCodes).filter(function (_ref2) {
                var code = _ref2.code;
                return !dialingCodeBlacklist.includes(code);
            }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            var territoryData = this.actions.getTerritoryDataFromMetadata(this.phone.phoneCountry || country);

            this.actions.updatePhoneFieldMetadata(territoryData);
        },


        // helper to show the options list and focus on the selected phone country option
        expandList: function expandList() {
            (0, _jquery2['default'])('.country-list').show();
            this.listVisible = true;
            (0, _jquery2['default'])('.country-list .country.selected').focus();
        },


        // helper to collapse the options
        collapseList: function collapseList() {
            this.listVisible = false;
            (0, _jquery2['default'])('.country-list').hide();
        },


        // helper to collapse the options and xfer focus back to the parent dropdown
        collapseListAndFocusOnParent: function collapseListAndFocusOnParent() {
            this.actions.collapseList();
            (0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').focus();
        },


        // helper to toggle the dropdown list
        toggleList: function toggleList() {
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            } else {
                this.actions.expandList();
            }
        },


        // remove highlighting from other list items and highlight the given item
        highlightListItem: function highlightListItem(listItem) {
            (0, _jquery2['default'])('li.country').removeClass('highlight');
            listItem.addClass('highlight');
            listItem.focus();
        },

        // select the given item and update the phone field metadata
        selectListItem: function selectListItem(listItem) {
            var country = listItem.attr('data-country-code');
            var territory = this.actions.getTerritoryDataFromMetadata(country);

            this.actions.updatePhoneFieldMetadata(territory);
        },

        // find the first list item whose name starts with the query string
        searchForCountry: function searchForCountry(queryString) {
            for (var i = 0; i < this.dialingCodeList.length; i++) {
                if (this.actions.startsWith(this.dialingCodeList[i].name, queryString)) {

                    var listItem = (0, _jquery2['default'])('.country-list').find('[data-country-code="' + this.dialingCodeList[i].code + '"]');
                    // update highlighting and scroll
                    this.actions.highlightListItem(listItem);
                    break;
                }
            }
        },

        // check if (uppercase) string a starts with string b
        startsWith: function startsWith(a, b) {
            return a.substr(0, b.length).toUpperCase() === b;
        },

        // When Switching between double Byte -> Single Byte character
        // angular model is not properly updated by jquery-mask (PPPLMER-52127)
        // re-update the model with entered value.
        updateAngularModel: function updateAngularModel() {
            if (this.phone.ispreFill) {
                // We set the flag to false once the prefill is completed.
                // This helps to update angular model properly upon next keyUp()
                this.phone.ispreFill = false;
            } else {
                this.phone.telephone = this.$element.find('.telephone').val();
            }
        },

        // format the phone number
        applyMaskOnPhoneInput: function applyMaskOnPhoneInput() {
            // If `this.mask` is `undefined` and we try to mask this field
            // jQuery mask will throw a type error when it tries to access
            // `mask.length` during a for loop.
            if (!this.mask) {
                return;
            }

            this.actions.updateAngularModel();

            this.$element.find('.telephone').mask(this.mask, {
                'translation': {
                    0: { pattern: /[0-9]/ }
                }
            });
        },

        // highlight the event target
        handleListMouseover: function handleListMouseover($event) {
            this.actions.highlightListItem((0, _jquery2['default'])($event.target));
        },

        // expand the list when down arrow is pressed
        handleKeyboardInputForDropdown: function handleKeyboardInputForDropdown($event) {

            var key = $event.which;
            if (key === KEYS.DOWN || key === KEYS.UP || key === KEYS.SPACE) {
                $event.stopPropagation();
                $event.preventDefault();
                this.actions.expandList();
            } else {
                this.actions.collapseList();
            }
        },

        /*
         navigating list using the keyboard
         up, down, esc, enter and letter keys
         */
        handleKeyboardInputForList: function handleKeyboardInputForList($event) {
            var $listItems = (0, _jquery2['default'])('li.country');
            var key = $event.which;
            var $selected = (0, _jquery2['default'])($event.target);
            var $current = void 0;

            $event.stopPropagation();
            $event.preventDefault();

            // if user types in an input, focus on the first country starting with that query
            // upper case letters (since keyup/keydown only return upper case letters)
            if (key >= KEYS.A && key <= KEYS.Z) {
                if (queryTimer) {
                    _angular.$timeout.cancel(queryTimer);
                }

                query += String.fromCharCode(key);
                this.actions.searchForCountry(query);

                queryTimer = (0, _angular.$timeout)(function () {
                    query = '';
                }, 1e3);

                return;
            }

            // ignore other keys
            if (key !== KEYS.DOWN && key !== KEYS.UP && key !== KEYS.ENTER && key !== KEYS.ESC) {
                return;
            }

            // select the the new phone country when user hits enter
            if (key === KEYS.ENTER) {
                this.actions.selectListItem($selected);
                return;
            }

            // close the list if escape is pressed
            if (key === KEYS.ESC) {
                this.actions.collapseListAndFocusOnParent();
                return;
            }

            // highlight the next/prev element when arrow key is pressed
            if (key === KEYS.DOWN) // Down key
                {
                    if (!$selected.length || $selected.is(':last-child')) {
                        $current = $listItems.eq(0);
                    } else {
                        $current = $selected.next();
                    }
                }

            // Up key
            if (key === KEYS.UP) {
                if (!$selected.length || $selected.is(':first-child')) {
                    $current = $listItems.last();
                } else {
                    $current = $selected.prev();
                }
            }

            this.actions.highlightListItem($current);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.actions.init(_squid.$locale.country);
        },
        populate: function populate() {
            var _this = this;

            this.$on('localeChange', function () {
                _this.actions.init(_squid.$locale.country);
            });

            // update the phone mask and pattern when metadata is changed
            this.$watch('metadata', function () {
                _this.actions.updatePhoneMaskAndPattern();
            }, true);

            // update the mask when .telephone val changes either programatically or via user action
            this.$watch('this.phone.telephone', function (newVal) {
                if (newVal) {
                    _this.$element.find('.telephone').val(newVal).trigger('input');
                }
            }, true);

            var addressChangeEvent = _angular.$rootScope.$on('billingAddressStateChange', function (e, address) {
                var territory = _this.actions.getTerritoryDataFromMetadata(_this.metadata.country);
                _this.actions.updatePhoneFieldMetadata(territory, address.state);
            });

            this.$on('$destroy', addressChangeEvent);

            // hide the dropdown list if a click occurs anywhere else on the page
            (0, _jquery2['default'])('*').on('click', function (event) {
                if (!(0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').is((0, _jquery2['default'])(event.target))) {
                    _this.actions.collapseList();
                }
            });
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;

_squid.$MetadataModel;

_squid.$config;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" content>\n    <div ng-if=\"hidePhoneType !== true\"\n         id=\"phoneTypeContainer\"\n         class=\"phoneTypeContainer dropdown confidential inputField half\"\n         ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl', 'dialCodeVisible': showDialingCodeContainer}\"\n         ng-cloak\n         floating-label-dropdown >\n\n        <select xo-dropdown\n                ng-model=\"phone.phoneType\"\n                name=\"phoneType\"\n                id=\"phoneType\"\n                ng-change=\"actions.updatePhoneMaskAndPattern()\"\n                xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!hideWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n\n    <div ng-if=\"showDialingCodeContainer\"\n         id=\"dialingCodeContainer\"\n         class=\"dialingCodeContainer dropdown confidential half last-child inputField intl-tel-input\"\n         ng-cloak\n         floating-label-dropdown>\n\n        <div class=\"flag-dropdown\">\n            <div tabindex=\"0\"\n                 class=\"selected-flag\"\n                 title=\"{{ phoneCountry + ' +'+this.phone.IntDialingCountryCode }}\"\n                 ng-keydown=\"actions.handleKeyboardInputForDropdown($event)\"\n                 ng-click=\"actions.toggleList()\">\n                <div class=\"iti-flag {{ phoneCountry | lowercase }}\" style=\"pointer-events: none\"></div>\n                <div class=\"arrow\" style=\"pointer-events: none\"></div>\n            </div>\n\n            <ul class=\"country-list hide\">\n                <li ng-repeat=\"(key, value) in dialingCodeList track by $index\"\n                    tabindex=\"-1\"\n                    class=\"country\"\n                    data-country-code=\"{{ value.code }}\"\n                    ng-class=\"{'selected': value.code === phoneCountry}\"\n                    ng-click=\"actions.updatePhoneFieldMetadata(value)\"\n                    ng-keydown=\"actions.handleKeyboardInputForList($event)\"\n                    ng-mouseover=\"actions.handleListMouseover($event)\">\n\n                    <div class=\"flag\" style=\"pointer-events: none\">\n                        <div class=\"iti-flag {{ value.code | lowercase }}\"/>\n                    </div>\n\n                    <span class=\"country-name\" style=\"pointer-events: none\">{{ value.name }}</span>\n\n                    <span class=\"dial-code\" style=\"pointer-events: none\">+{{ value.internationalDialingCode }}</span>\n                </li>\n            </ul>\n        </div>\n\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\" class=\"focus accessAid\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n\n    <div id=\"phoneNumberContainer\"\n         class=\"inputField confidential last-child phoneNumber\"\n         ng-class=\"{'half': !hidePhoneType,\n            'telephoneField': !hidePhoneType,\n            'telephoneFieldFull': hidePhoneType,\n            'rtlPhoneField': locale.metadata.directionality === 'rtl',\n            'dialCodeVisible': showDialingCodeContainer,\n            'singleLineMobile' : hidePhoneType}\"\n         floating-label\n         directionality >\n\n        <span class=\"fixedCode ltrOverride\" id=\"countryTelephoneCode\">+{{ phone.IntDialingCountryCode }}</span>\n        <input id=\"telephone\"\n               class=\"telephone\"\n               ng-class=\"{'digit1' : phone.IntDialingCountryCode.length === 1, 'digit2' : phone.IntDialingCountryCode.length === 2, 'digit3' : phone.IntDialingCountryCode.length === 3, 'digit4' : phone.IntDialingCountryCode.length === 4 }\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               data-mask=\"{{mask}}\"\n               ng-change=\"actions.applyMaskOnPhoneInput()\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               aria-labelledby=\"telephoneLabel countryTelephoneCode\"\n               country-code=\"phone.phoneCountryCode\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               ng-keyup=\"actions.applyMaskOnPhoneInput()\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\" id=\"telephoneLabel\">{{content('common.phone')}}</label>\n    </div>\n\n\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/place-of-birth/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/place-of-birth/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoPlaceOfBirth', {
    tag: 'xo-place-of-birth',
    template: _template2['default'],

    props: {
        user: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.populateCountryList = function () {
                var guestBlockedCountries = _index.$config.guestBlockedCountries || [];
                _this.metadata = _angular2['default'].copy(_index.$locale.metadata);
                var placeOfBirth = {};

                _this.countriesList = _this.metadata.territory.filter(function (c) {

                    if (c.code === _index.$locale.country) {
                        placeOfBirth = c;
                    }
                    return !(guestBlockedCountries.indexOf(c.code) > -1);
                });
                // set the default select option in the place of birth dropdown
                _this.selectedPlaceOfBirth = placeOfBirth;
                _this.user.placeofbirth = placeOfBirth.code;
            };
            this.populateCountryList();
            this.$on('metadataChange', this.populateCountryList);
        }
    },

    actions: {
        updatePlaceOfBirth: function updatePlaceOfBirth(country_code) {
            this.user.placeofbirth = country_code;
        }
    }
});


_index.$Component;

_index.$locale;

_index.$config;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/place-of-birth/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown content>\n    <select xo-dropdown name=\"placeofbirth\" dropdown-text-bind-var=\"selectedPlaceOfBirth.name\"\n            ng-model=\"selectedPlaceOfBirth\"\n            ng-options=\"country.name for country in countriesList track by country.code\"\n            id=\"placeofbirth\"\n            ng-change=\"actions.updatePlaceOfBirth(selectedPlaceOfBirth.code)\"\n            xo-error-tooltip required>\n    </select>\n    <label for=\"placeofbirth\" id=\"placeofbirthlabel\">{{ content('common.placeOfBirth') }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSelectShippingCountry', {
    tag: 'xo-select-shipping-country',
    template: _template2['default'],
    props: {
        shippingAddress: {
            type: 'var',
            required: false
        },
        disableChangeShippingCountry: {
            type: 'var',
            required: false
        }
    },
    actions: {
        // Return the country list, with the selected address country at the top
        getList: function getList(address) {
            var defaultCountryCode = address && address.country || _squid.$locale.country;
            var countryList = _squid.$locale.metadata.territory;
            var isDefaultCountry = function isDefaultCountry(country) {
                return country.code === defaultCountryCode;
            };
            var defaultCountry = _squid.$util.find(countryList, isDefaultCountry);
            var res = countryList.filter(function (country) {
                return !isDefaultCountry(country);
            });

            res.unshift(defaultCountry);

            return res;
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.countryList = this.actions.getList(this.props.shippingAddress);

            this.$on('metadataChange', function () {
                _this.countryList = _this.actions.getList(_this.props.shippingAddress);
            });
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': props.disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-model=\"props.shippingAddress.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"country\" xo-error-tooltip required ng-disabled=\"props.disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _utilFunctions = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/utilFunctions.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoTravelRule', {
    tag: 'xo-travel-rule',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        finish: {
            type: 'var',
            required: false
        },
        onUserInfoSuccess: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
            };
        }
    },

    actions: {
        submit: function submit() {
            var _this = this;

            var data = {};

            if (this.needPayerGovtId) {
                var chosenIdDetails = this.idTypes.find((0, _utilFunctions.findChosenId)(this.idData.type));

                // Scrub the formatting when invoking the backend services.
                var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');

                data.newDocId = {
                    type: chosenIdDetails.idType,
                    subType: chosenIdDetails.idSubtype,
                    issuerCountry: this.idData.country,
                    issuer: chosenIdDetails.idIssuer,
                    value: unformatted,
                    collectionPoint: 'UNKNOWN',
                    placeOfIssue: this.idData.country
                };
            }

            if (this.needPayerAddress) {
                var address = this.address;


                data.newAddress = {
                    address1: address.line1,
                    address2: address.line2,
                    city: address.city,
                    state: address.state,
                    zip: address.postal_code,
                    iso_country: 'US'
                };
            }

            var onUserInfoSuccess = this.onUserInfoSuccess || function () {
                var checkoutCart = _index2.$CheckoutCartModel.instance(_this.token);

                return _this.models.checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        // Clear the errors if create checkout session was successful
                        _this.models.checkoutSession.errorData = undefined;
                        _this.finish();
                    }
                });
            };

            this.userInfo.action('governmentId-address', {
                data: data,

                success: onUserInfoSuccess,

                validation: function validation(validationData) {
                    var $field = _this.$element.find('#data');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                    $field.focus();
                }
            });
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            var country = _index.$locale.getCountryCodeISO();

            this.country = country;
            this.address = { country: country };
            this.countryList = _index.$locale.metadata.territory;
            this.idTypes = (0, _utilFunctions.getIdTypes)(_index.$locale.content);
            this.idData = (0, _utilFunctions.getIdData)();

            this.idTypeChanged = function () {
                _this2.idData.country = 'US';
            };

            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
            var payerDetailsTypes = checkoutSession.get('errorData.resolution.data', []);

            if (payerDetailsTypes.includes('GOVERNMENT_ID')) {
                this.needPayerGovtId = true;
            }

            if (payerDetailsTypes.includes('STREET_ADDRESS')) {
                this.needPayerAddress = true;
            }

            this.userInfo = _index3.$UserInfoModel.instance(this.token);
        }
    }
});
// This component probably shouldn't be in xo-form-components, as xo-address-components depends on xo-form-components
// If below is included, the tests will error due to duplicate xo-form-components being loaded.
// import 'xo-address-components/src/add-address/directive';

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index3.$UserInfoModel;

_utilFunctions.findChosenId;

_utilFunctions.getIdData;

_utilFunctions.getIdTypes;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"travelRuleForm\" name=\"travelRuleForm\" class=\"travelRuleForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <h3 class=\"gamma noHead\">{{ content('travelRule.travelRule') }}</h3>\n        <p>{{ content('travelRule.note') }}</p>\n\n        <div ng-if=\"needPayerGovtId\" class=\"govtId\">\n            <div class=\"dropdown idType inputField\" floating-label-dropdown>\n                <select xo-dropdown\n                        name=\"idType\"\n                        ng-model=\"idData.type\"\n                        id=\"idType\"\n                        ng-change=\"idTypeChanged()\"\n                        aria-required=\"true\">\n                    <option ng-repeat=\"item in idTypes track by $index\" value=\"{{item.name}}\" ng-selected=\"idData.type === '{{item.name}}'\">{{item.value}}</option>\n                </select>\n                <label for=\"idType\">{{content('travelRule.idType')}}</label>\n            </div>\n            <div></div>\n            <div class=\"inputField confidential\"\n                ng-switch on=\"idData.type\">\n                <div class=\"animate-switch\" ng-switch-when=\"SSN\">\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.ssnPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"TaxID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.taxIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.taxIdPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"EmployerID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.employerIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.employerIdPlaceHolder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"Passport\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.passportDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.passportPlaceholder') }}\"/>\n                    <div class=\"dropdown confidential country clearfix inputField\" content floating-label-dropdown>\n                        <select xo-dropdown name=\"passportCountry\" ng-model=\"idData.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"passportCountry\" aria-labelledby=\"countryLabel\" xo-error-tooltip required>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"AlienNumber\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.aNumberDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.aNumberPlaceholder') }}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"needPayerAddress\" class=\"address\">\n            <p>{{ content('travelRule.pleaseEnterStreetAddress') }}</p>\n            <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('travelRule.payButton') }}\" class=\"btn full btn-large\" validate-submit=\"actions.submit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/utilFunctions.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var findChosenId = exports.findChosenId = function findChosenId(id) {
    return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            name = _ref.name;

        return name === id;
    };
};

var getIdTypes = exports.getIdTypes = function getIdTypes(content) {
    return [{
        name: 'SSN',
        value: content.get('travelRule.ssnDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'SSN',
        idIssuer: 'US_SSN'
    }, {
        name: 'TaxID',
        value: content.get('travelRule.taxIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'ITIN',
        idIssuer: 'US_ITIN'
    }, {
        name: 'EmployerID',
        value: content.get('travelRule.employerIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'TIN',
        idIssuer: 'US_TIN'
    }, {
        name: 'Passport',
        value: content.get('travelRule.passportDropdownLabel'),
        idType: 'PASSPORT',
        idIssuer: 'PASSPORT'
    }, {
        name: 'AlienNumber',
        value: content.get('travelRule.aNumberDropdownLabel'),
        idType: 'IMMGT_ID',
        idIssuer: 'IMMIGRATION'
    }];
};

var getIdData = exports.getIdData = function getIdData() {
    return {
        type: 'SSN',
        value: '',
        country: 'US'
    };
};

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/zipcode/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoZipcode', {
    tag: 'xo-zipcode',

    template: _template2['default'],

    props: {
        address: {
            reqiured: false,
            type: 'var'
        },
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        doneFn: {
            required: false,
            type: 'var'
        },
        keyPressFn: {
            required: false,
            type: 'var'
        },
        maxLength: {
            required: false,
            type: 'var'
        },
        postalCodeLabel: {
            required: false,
            type: 'var'
        },
        zipEntry: {
            required: false,
            type: 'var'
        },
        zipErrorKey: {
            required: false,
            type: 'str'
        },
        zipLabel: {
            required: false,
            type: 'str'
        },
        zipRequired: {
            reqiured: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatRegex = undefined;
            this.inputParams = (0, _squid.$feature)('zipcodeInputParams', undefined, this.country);

            if (this.inputParams) {
                this.minLength = this.inputParams.minLength;
                this.maxLength = this.inputParams.maxLength;

                if (this.inputParams.formatPattern) {
                    this.formatRegex = new RegExp(this.inputParams.formatPattern, 'g');
                }
            }

            this.formatZipWithDash = function (zipcode, index) {
                if (zipcode.length > index) {
                    zipcode = zipcode.slice(0, index) + '-' + zipcode.slice(index);
                }

                return zipcode;
            };
        }
    },

    actions: {
        changeZip: function changeZip(zipcode) {
            if (zipcode) {

                if (this.formatRegex) {
                    zipcode = zipcode.replace(this.formatRegex, '');
                }

                if (this.inputParams && this.inputParams.formatZip) {
                    zipcode = this.formatZipWithDash(zipcode, this.inputParams.minLength);
                }

                this.address.postal_code = zipcode;
            }
        },
        doneFunction: function doneFunction() {
            if (this.doneFn) {
                this.doneFn();
            }
        },
        keyPressHandler: function keyPressHandler(event) {
            if (this.keyPressFn) {
                this.keyPressFn(event);
            }
        }
    }
});


_squid.$Component;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"zipField\" data-test-id=\"zipField\" class=\"inputField confidential postalCode\" prefix-attrs-with=\"{{attrPrefix}}\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" data-test-id=\"address.postal_code\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"actions.changeZip(address.postal_code)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"actions.doneFunction()\" ng-keypress=\"actions.keyPressHandler($event)\"\n       data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" data-test-id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ zipLabel }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/fraudnet/fn.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fn', ['$populate', '$rootScope', '$window', '$logger', '$config', '$util', '$meta', '$q', function ($populate, $rootScope, $window, $logger, $config, $util, $meta, $q) {

    var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
    var options = {
        fnSessionId: getFnCorrId(),
        sourceId: 'XOONBOARDINGNODEWEB',
        allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular2['default'].isFunction(CustomEvent),
        fnUrl: $config.urls.fraudnetUrl,
        passive: true
    };

    // Fraudnet initialization logging
    $logger.info('FN_Initialised', {
        'allowsCustomEvent': options.allowsCustomEvent
    });

    // Get the unique id to pass to fraudnet - EC/WPS/BA token
    function getFnCorrId() {

        var fnCorrId = $rootScope.token || $meta.token;

        if ($meta.baToken) {
            $logger.info('BEAM_In_Hermes_Checkout');
            fnCorrId = $meta.baToken;
        } else if ($rootScope.fraudNetId) {
            fnCorrId = $rootScope.fraudNetId;
        }

        return fnCorrId;
    }

    // Call injectConfig before calling injectScript function
    function _injectScript(fnUrl) {
        var script = document.createElement('script');

        script.id = 'js-sync';
        script.src = fnUrl;
        document.body.appendChild(script);
    }

    function _injectConfig(configOptions) {
        var script = document.getElementById('fconfig');

        if (script) {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }

        script = document.createElement('script');
        script.id = 'fconfig';
        script.type = 'application/json';
        script.setAttribute('fncls', fncls);

        script.text = '{ "f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback" }';
        document.body.appendChild(script);
    }

    /*
     * trigger - this function will call injectConfig and injectScript
     * functions which actually load fraudnet required scripts
     */
    function trigger(scope) {
        var fnLoaded = !!$rootScope.fnLoaded;

        if (fnLoaded || !(0, _squid.$feature)('enableFraudnet')) {
            return false;
        }

        if (options.fnUrl) {

            $window.fnCallback = function () {
                if (scope) {
                    scope.$emit('fnCallback');
                }
            };

            _injectConfig(options);
            _injectScript(options.fnUrl);

            $rootScope.fnLoaded = true;

            return true;
        }
        return false;
    }

    return {
        trigger: trigger
    };
}]);

_squid.$feature;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/fraudnet", "../node_modules/xo-guest-components/src/fraudnet/fn.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/constants/pxpExperimentConstants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var frs_wps_optional = {
    frs_wps_optional_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant1',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_wps_optional_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant2',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_wps_optional_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant3',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

exports['default'] = {
    test: {
        frs_wps_optional: frs_wps_optional
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/frs/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/template.html");

var _template2 = _interopRequireDefault(_template);

var _pxpExperimentConstants = __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/constants/pxpExperimentConstants.js");

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoGuestUpgradeInterstitial', {
    tag: 'xo-guest-upgrade-interstitial',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        parentModel: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.flags = this.props.parentModel.flags;
            if (!this.flags) {
                _logger.$logger.info('WPS_interstitial_render_error');
                return _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_ALREADY_DONE' });
            }
            this.flags.wpsInterstitial = true;
            this.flags.showMobileEmailSection = true;
            this.onboard = this.props.parentModel.onboard;
            this.frsContentKeys = {};

            // If US, then show new e-sign compliance experience
            // Submit button text changes and return to merchant msg above button
            // with user action 'continue'
            if (this.locale.country === 'US') {
                this.showNewSignupComplianceExp = true;
            }

            if (this.flags.freeReturnShippingOptInFlowApplicable) {
                var treatmentName = this.flags.freeReturnShippingApplicableTreatment;
                var treatmentContentKeys = _pxpExperimentConstants2['default'].test['frs_wps_optional'][treatmentName];

                this.frsContentKeys = treatmentContentKeys ? treatmentContentKeys : {};
            }

            // Wait for the component to be populated and the template to be rendered
            // and then set `interstitialOpen` to `true`, which will add the class 'upsellOpen'
            // to the interstitial and trigger the transition to slide it onto the screen
            this.$on('populated', function () {
                _this.interstitialOpen = true;
            });
        },
        populate: function populate() {
            var _this2 = this;

            this.handleFrsContingency = function (message) {
                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_' + message);
                _this2.logFptiFrsError();
                return _uiRouter.$state.go('checkout.done');
            };

            this.handleFrsError = function (message, error) {
                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_' + message, error);
                _this2.logFptiFrsError();
                return _uiRouter.$state.go('checkout.done');
            };

            this.logFptiFrsError = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'guest_upgrade_interstitial_frs_optin_flow',
                    to: 'process_frs_optin_user_failure'
                });
            };
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this3 = this;

            this.upgrade = new _index.$GuestUpgradeModel();

            this.upgrade.billing_address = this.onboard.billing_address;
            this.upgrade.user = this.onboard.user;
            this.upgrade.payerId = this.onboard.payerId;
            this.upgrade.transaction = this.onboard.transaction;
            this.upgrade.phone = this.onboard.phone;
            this.upgrade.marketing_optin = this.onboard.marketingOptin;
            this.upgrade.nationalIdModel = _directive.$NationalIdModel.instance(this.props.token);
            this.upgrade.experienceChannel = 'HERMES';

            var isFrsOptInFlow = this.flags.freeReturnShippingOptInFlowApplicable;
            var isFrsActiveFlow = this.flags.freeReturnShippingOptInActiveFlow;

            // Close the interstitial after submit so it is not shown underneath the spinner mask.
            this.interstitialOpen = false;

            return this.upgrade.save({

                data: this.upgrade.serialize(),

                success: function success() {
                    _angular.$rootScope.mode = 'signup';
                    _logger.$logger.info('WPS_guest_upgrade_success');
                    if (isFrsOptInFlow) {
                        _logger.$logger.info('checkout_fpti', {
                            from: 'guest_upgrade_interstitial_frs_optin_flow',
                            to: 'prepare_frs_optin_user'
                        });

                        // Opt in upgraded user for Free Return Shipping benefit
                        // Set whether FRS opt-in flow type is Active or Silent
                        var frsOptInModel = new _index2.$FreeReturnShippingOptInModel();

                        var frsOptInRequest = {
                            optInStatus: 'Y',
                            optInType: isFrsActiveFlow ? 'ACTIVE' : 'SILENT'
                        };

                        return frsOptInModel.save({
                            data: frsOptInRequest,
                            success: function success(optInResponse) {
                                // User is opted into FRS benefit and can request return shipping refund for eligible transactions.
                                _logger.$logger.info('WPS_guest_upgrade_free_return_shipping_optin_success');
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'guest_upgrade_interstitial_frs_optin_flow',
                                    to: 'process_frs_optin_user_success'
                                });
                                return _uiRouter.$state.go('checkout.done');
                            },
                            contingencies: {
                                // In-context FRS opt-in failed. User needs to opt-in to FRS explicitly.
                                FRS_OPTIN_ERROR: function FRS_OPTIN_ERROR() {
                                    return _this3.handleFrsContingency('FRS_OPTIN_ERROR');
                                },
                                VALIDATION_ERROR: function VALIDATION_ERROR() {
                                    return _this3.handleFrsContingency('VALIDATION_ERROR');
                                },
                                DEFAULT: function DEFAULT() {
                                    return _this3.handleFrsContingency('UNHANDLED_CONTINGENCY');
                                }
                            },
                            validation: function validation(errorResponse) {
                                return _this3.handleFrsError('SERVICE_VALIDATION_ERROR', errorResponse);
                            },
                            error: function error(errorResponse) {
                                return _this3.handleFrsError('SERVICE_ERROR', errorResponse);
                            }
                        });
                    }
                    return _uiRouter.$state.go('checkout.done');
                },
                error: function error() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                },
                contingencies: {
                    DOB_INVALID: function DOB_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    NATID_INVALID: function NATID_INVALID() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    },
                    DEFAULT: function DEFAULT() {
                        _logger.$logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
                        return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                    }
                },
                validation: function validation() {
                    _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
                    return _uiRouter.$state.go('checkout.done', { code: 'NO_UPGRADE' });
                }
            });
        }
    }
});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_index.$GuestUpgradeModel;

_directive.$NationalIdModel;

_index2.$FreeReturnShippingOptInModel;

_logger.$logger;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-guest-upgrade-interstitial.route', ['squid', 'xo-guest-upgrade-interstitial.directive']).factory('$GuestUpgradeInterstitialRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GuestUpgradeInterstitialRoute', {

            name: 'guestUpgradeInterstitial',
            directive: 'xo-guest-upgrade-interstitial',
            trackingData: {
                fptiState: 'guest_xo_upgrade_interstitial',
                trackStateExit: false,
                pageQualifier: 'guest',
                buzname: {
                    'guest': {
                        'pagename': '%::fullpage-guest-upgrade-interstitial',
                        'pagename2': '%::fullpage-guest:member:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: []
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/guest-upgrade-interstitial", "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"guestUpgradeInterstitial\" ng-class=\"{mobile: isDevice, upsellOpen: interstitialOpen}\" content>\n    <div class=\"upsellMask\"></div>\n    <div class=\"upsellWrapper\" >\n        <div class=\"profile\">&nbsp;</div>\n        <div class=\"upsellScrollWrapper\">\n            <div class=\"upsellContainer\">\n                <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n\n                <div ng-if=\"flags.freeReturnShippingOptInFlowApplicable\">\n                    <div class=\"mainTitle\">\n                        <div>{{content('signup.paymentSuccessTitle')}}</div>\n                        <div ng-if=\"frsContentKeys.title\">{{content(frsContentKeys.title)}}</div>\n                        <div ng-if=\"!frsContentKeys.title\">{{content('signup.createAccountToday')}}</div>\n                    </div>\n\n                    <div class=\"intro-content\" ng-if=\"frsContentKeys.subTitle\" ng-bind-html=\"htmlContent(frsContentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></div>\n                    <div class=\"intro-content\" ng-if=\"!frsContentKeys.subTitle\">{{ content('signup.createAccountDetails') }}</div>\n                </div>\n                <div ng-if=\"!flags.freeReturnShippingOptInFlowApplicable\">\n                    <div class=\"mainTitle\">\n                        <div>{{content('signup.paymentSuccessTitle')}}</div>\n                        <div>{{content('signup.createAccountToday')}}</div>\n                    </div>\n\n                    <div class=\"intro-content\">{{ content('signup.createAccountDetails') }}</div>\n                </div>\n\n                <div class=\"emailHelper\" >\n                    <span class=\"email\">{{onboard.user.email}}</span>\n                    <span>\n                        <a id=\"emailHelp\"\n                           class=\"verifyHelp\"\n                           aria-label=\"{{ content('login.kmliTooltipTitle') }}\"\n                           href=\"javascript:void(0)\">\n                        </a>\n                    </span>\n\n                    <xo-tooltip trigger=\"#emailHelp\" >\n                        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n                            {{ content('signup.emailHelper') }}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <form id=\"upgradeInterstitialForm\" name=\"upgradeInterstitialForm\" class=\"upgradeInterstitialForm\"\n                      ng-submit=\"upgradeInterstitialForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\"  novalidate>\n\n                    <xo-signup-options flags=\"flags\" onboard=\"onboard\" guest-upgrade=\"true\"></xo-signup-options>\n\n                    <input track-submit=\"xoon_wps_interstitial_submit\" id=\"wpsInterstitialSubmit\" type=\"submit\" ng-click=\"validated=true\"\n                           value=\"{{ content(showNewSignupComplianceExp ? 'common.agreeAndCreateAccount' : 'common.agreeAndContinue') }}\" class=\"btn full\" />\n\n                    <div class=\"intro-content\">\n                        <a aria-hidden=\"false\" class=\"notNow\" id=\"notNow\"\n                           track-link=\"guest_upgrade_interstitial_not_now\"\n                           ui-sref=\"checkout.done\" role=\"button\">\n                            {{content('common.notNow')}}\n                        </a>\n\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _index2 = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/template.html");

var _template2 = _interopRequireDefault(_template);

var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");

var _mapper = __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/lib/mapper.js");

var _mapper2 = _interopRequireDefault(_mapper);

__webpack_require__("../node_modules/xo-form-components/src/place-of-birth/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/gender-type/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/directive.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _helper = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index2.$Component.extend('xoGuestUpgrade', {
    tag: 'xo-guest-upgrade',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var options = {
                params: {
                    data: _index2.$util.param('data')
                }
            };

            return {
                preloadedData: _index4.$GuestUpgradeModel.instance().retrieve(options)
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.upgradeFromEmail = _index2.$util.param('data').length === 15 || _index2.$util.param('data').length === 16;
            this.flags = { singlePassword: false };
            this.locale = _index2.$locale;
            this.returnToMerchantTimerMsg = '';
            this.valueTitle = (0, _index2.$renderContent)('guestVerify.propHead');
            this.valueText = (0, _index2.$renderContent)('guestVerify.propVal');
            this.footerStyle = 'fullFooter';
            this.isGdprValid = _gdprCookieBanner.isGdprValid;

            // Do not show cancel URL if experience is set to minibrowser
            if (!_angular.$rootScope.miniBrowser) {
                this.cancelUrl = _index2.$util.param('cancel_url');
            } else {
                // Change the message of the overlay on the site that launched this flow.
                _index.$ReturnToMerchant.postToMerchant({
                    secureWindowmsg: _index2.$locale.content.get('signup.overlayMsg')
                });
            }

            var modelSchema = {
                user: new _index4.$OnboardUserModel({
                    country: _index2.$locale.country,
                    nationality: _index2.$locale.country
                }),

                phone: new _index4.$OnboardPhoneModel(),

                billing_address: _index3.$BillingAddressModel.create(null, {
                    country: _index2.$locale.country
                })
            };

            this.onboard = new _index4.$GuestUpgradeModel(modelSchema);

            this.fpti = {
                trackSuccess: function trackSuccess() {
                    this.track(':success');
                },
                trackError: function trackError(err) {
                    this.track(':error', err);
                },
                track: function track(suffix, err) {
                    var error = void 0;

                    if (err) {
                        error = {
                            type: 'pageError',
                            msg: err.message
                        };
                    }
                    _uiRouter.$state.current.trackingData.buzname.guestupgrade.pagename2 += suffix;
                    _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                }
            };

            this.currentYear = new Date().getFullYear().toString();
            this.validMonths = _index2.$util.map(_index2.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });
        },
        populate: function populate() {
            var _this = this;

            var isGDPRCountry = _helper.signupLib.getIsGDPRCountry(this.locale.country);

            // Market Opt-in display and checked by default is based on config settings
            this.showMarketingOptin = _helper.signupLib.getMarketingOptinShowHide(this.locale.country, isGDPRCountry);

            // If not showing a checkbox for marketing opt-in, set the flag to null as per GDPR team requirement
            if (!this.showMarketingOptin) {
                this.onboard.marketing_optin = null;
            } else {
                // DO THIS ONLY IF the marketing opt-in checkbox is displayed to users
                // Is marketing opt-in checkbox checked by default
                this.onboard.marketing_optin = _helper.signupLib.getMarketingOptinIsChecked(this.locale.country, isGDPRCountry);
                // Marketing opt-in text next to checkbox
                this.marketingOptinContentKey = _helper.signupLib.getMarketingOptinContentKey(this.locale.country, isGDPRCountry);
            }

            var getContentIdentifier = function getContentIdentifier() {
                return [_index2.$locale.country, _index2.$locale.lang, (0, _index2.$contentVersion)(), 'signupTerms.easySignupTCPA'].join(':');
            };

            var preloadedData = this.models.preloadedData;

            var getFiMode = function getFiMode() {
                var _ref = preloadedData && preloadedData.fi_details || {},
                    _ref$bank_accounts = _ref.bank_accounts,
                    bank_accounts = _ref$bank_accounts === undefined ? [] : _ref$bank_accounts;

                return bank_accounts.length > 0 ? 'bank' : '';
            };

            this.onboard.eConsentTermsContent = _helper.signupLib.getSignupTermsContentKey(this.locale.country, isGDPRCountry, getFiMode());

            if (preloadedData.guestUpgradeNewAppRedirect === true) {
                var redirectUrl = window.location.href.replace('xoonboarding', 'prox');

                _logger.$logger.info('guest_upgrade_new_app_redirect', {
                    redirectUrl: redirectUrl,
                    transactionId: preloadedData.transaction
                });
                return _index2.$util.redirect(redirectUrl);
            }
            this.onboard.payerId = preloadedData.payerId;
            this.onboard.billing_address.populate(_mapper2['default'].getFormattedAddress(preloadedData.billing_address));
            this.onboard.user.populate(preloadedData.user);
            this.specialFields = _mapper2['default'].getSpecialFieldsFor(preloadedData.user.country);
            this.onboard.contentIdentifier = getContentIdentifier();
            this.hasDialingCodeOverride = _util.hasDialingCodeOverride;

            if (this.upgradeFromEmail) {
                // Email based gxo flow

                this.onboard.card = preloadedData.card;
                this.onboard.receiptId = preloadedData.receiptId;
                this.onboard.transaction = preloadedData.transaction;
                this.onboard.experienceIdentifier = 'proxemailupgrade';
            } else {
                // Ad based gxo flow

                // Check if return_url and cancel_url are present and if the session has timed out
                if (!_index2.$util.param('cancel_url') || !_index2.$util.param('return_url') || !preloadedData.email || !preloadedData.payerId || !preloadedData.transaction) {
                    this.fpti.trackError(new Error('malformed payload'));
                    _uiRouter.$state.go('guestupgrade.genericError', {
                        code: 'GUEST_UPGRADE_SESSION_ERROR'
                    });
                    return;
                }
                _mapper2['default'].pxpMapper(this, _index2.$pxpMatch, preloadedData);
                this.onboard.transaction = preloadedData.transaction;
                this.onboard.experienceIdentifier = 'proxupgrade';

                _logger.$logger.info('guest_upgrade_ui_fields', {
                    special_fields: this.specialFields,
                    txn_id: preloadedData.transaction
                });
                if (this.specialFields.address) {
                    this.uponNormalization = function (normalizedAddress) {
                        _this.showAddressNormalizationLightbox = false;

                        // Update the new address
                        _this.onboard.billing_address = _index3.$BillingAddressModel.create(null, normalizedAddress, {
                            id: '0',
                            normalization_status: normalizedAddress.normalization_status
                        });

                        _this.upgrade();
                    };
                }
            }

            var showSuccessPage = function showSuccessPage() {
                // This changes the footer wapper ID and appropriate css classes gets applied
                _this.footerStyle = 'confirmationFooter';

                if (!_this.upgradeFromEmail) {
                    var timer = void 0;

                    _this.successUrl = _index2.$util.buildURL(_index2.$util.param('return_url'), {
                        status: 'success'
                    });

                    _this.fpti.trackSuccess();
                    _index.$ReturnToMerchant.postToMerchant(_this.successUrl);

                    var timerExecutor = function timerExecutor() {
                        // eslint-disable-line no-inner-declarations
                        // We wait for 5 secs on live and 10 secs on stage/local(helpful for automation)
                        var waitTime = _index2.$config.deploy.isLive() ? 20 : 10;

                        var updateMsg = function updateMsg() {
                            _this.returnToMerchantTimerMsg = (0, _index2.$renderContent)('signup.returnTimerMsg', {
                                waitTime: waitTime
                            });
                        };

                        _this.stopTimerAndRedirect = function () {
                            if (angular.isDefined(timer)) {
                                _angular.$interval.cancel(timer);
                                timer = undefined;
                            }
                            _index.$ReturnToMerchant.goTo(_this.successUrl);
                        };

                        updateMsg();
                        // When this.onboard becomes null, the success page is shown.
                        _this.onboard = null;

                        return function () {
                            waitTime -= 1;
                            updateMsg();
                            if (waitTime === 0) {
                                return _this.stopTimerAndRedirect();
                            }
                        };
                    };

                    timer = (0, _angular.$interval)(timerExecutor(), 1000);
                } else {
                    // When this.onboard becomes null, the success page is shown.
                    _this.onboard = null;
                }
            };

            var handleUIValidation = function handleUIValidation(errorData, displayGenericMessage) {
                var element = _mapper2['default'].errorMapper(errorData);

                if (element) {
                    var $fields = $(element);

                    $fields.addClass('backendError');
                }
                if (displayGenericMessage) {
                    _this.pageErrorMsg = { msgs: [_this.locale.content.genericError.incontextGenericPageError], type: 'error' };
                }
            };

            this.upgrade = function () {
                var data = _this.upgradeFromEmail ? _this.onboard.serializeEmailFlow() : _this.onboard.serialize();

                _this.onboard.save({
                    data: data,
                    success: showSuccessPage,
                    contingencies: {
                        DOB_INVALID: function DOB_INVALID(err, message) {
                            handleUIValidation(err);
                            _this.pageErrorMsg = { msgs: [_this.locale.content.validation.validDOB], type: 'error' };
                        },
                        PHONE_INVALID: function PHONE_INVALID(err, message) {
                            handleUIValidation(err);
                            _this.pageErrorMsg = { msgs: [_this.locale.content.validation.validPhone], type: 'error' };
                        },
                        NATID_INVALID: function NATID_INVALID(err, message) {
                            handleUIValidation(err);
                            _this.pageErrorMsg = { msgs: [_this.locale.content.validation.validNationalId], type: 'error' };
                        },
                        ADDRESS_LINEONE_INVALID: function ADDRESS_LINEONE_INVALID(err, message) {
                            handleUIValidation(err, true);
                        },
                        ADDRESS_CITY_INVALID: function ADDRESS_CITY_INVALID(err, message) {
                            handleUIValidation(err, true);
                        },
                        ADDRESS_STATE_INVALID: function ADDRESS_STATE_INVALID(err, message) {
                            handleUIValidation(err, true);
                        },
                        ADDRESS_POSTAL_CODE_INVALID: function ADDRESS_POSTAL_CODE_INVALID(err, message) {
                            handleUIValidation(err, true);
                        },
                        PASSWORD_INVALID: function PASSWORD_INVALID(err, message) {
                            handleUIValidation(err, true);
                        },
                        FI_INVALID: function FI_INVALID(err, message) {
                            handleUIValidation(err);
                        },
                        DEFAULT: function DEFAULT(name, contingency) {
                            _logger.$logger.info('guest_upgrade_contingency', {
                                'int_error_description': contingency && contingency.message,
                                'contingency_name': name
                            });
                        }
                    }
                })['catch'](function (err) {
                    _this.fpti.trackError(err);

                    _logger.$logger.error('guest_upgrade_error', { error: err });

                    if (_index2.$util.param('return_url')) {
                        var url = _index2.$util.buildURL(_index2.$util.param('return_url'), {
                            status: 'fail'
                        });

                        _this.cancelUrl = url;

                        _index.$ReturnToMerchant.postToMerchant({
                            cancelUrl: url
                        });
                    }
                });
            };
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            if (this.specialFields.nationalId) {
                this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            }

            if (this.specialFields.address) {
                this.showAddressNormalizationLightbox = true;
                return;
            }

            this.upgrade();
        },
        formatExpiry: function formatExpiry(event) {
            var key = event.keyCode || event.charCode;
            var $el = $(event.target);
            var val = $el.val().replace(/[^0-9\/]/gi, '');
            var strokes = val.length;

            // Ignore delete keys
            if (key === 8 || key === 46) {
                return;
            }

            // after two characters add a slash char
            if (strokes === 2) {
                val += '/';
            }

            this.expiryDate = val;
            $el.mask('99/99');
        },


        validate: function validate(expiryDate) {
            if (!expiryDate) {
                return;
            }

            var month = void 0,
                year = void 0,
                unformatted = void 0;
            var isValid = false;

            unformatted = expiryDate.replace(/[^0-9]/gi, '');
            if (unformatted.length > 3) {
                month = unformatted.substring(0, 2);
                year = this.currentYear.substring(0, 2) + unformatted.substring(2, 4);

                isValid = this.validMonths.indexOf(month) > -1 && year >= this.currentYear;

                if (isValid) {
                    var expDate = new Date(year, parseInt(month, 10) - 1);
                    var today = new Date();

                    isValid = expDate > today;
                }
            }

            return isValid;
        }

    }

});


_index.$ReturnToMerchant;

_index2.$Component;

_index2.$contentVersion;

_index2.$locale;

_index2.$util;

_index2.$config;

_index2.$pxpMatch;

_index2.$renderContent;

_angular.$rootScope;

_angular.$interval;

_util.hasDialingCodeOverride;

_index3.$BillingAddressModel;

_uiRouter.$state;

_logger.$logger;

_directive.$NationalIdModel;

_index4.$OnboardUserModel;

_index4.$OnboardPhoneModel;

_index4.$GuestUpgradeModel;

_fpti.$fpti;

_gdprCookieBanner.isGdprValid;

_helper.signupLib;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/lib/mapper.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var FIELD_SETS = { // eslint-disable-line no-reserved-keys
        'default': [],
        set1: ['dob', 'nationality'],
        set2: ['dob', 'nationality', 'marketing'],
        set3: ['address', 'dob', 'marketing'],
        set4: ['dob', 'nationality', 'occupation', 'marketing'],
        set5: ['dob', 'nationality', 'nationalId'],
        set6: ['dob', 'gender', 'placeOfBirth', 'nationality', 'nationalId'],
        set7: ['dob', 'nationality', 'nationalId', 'marketing']
    };

    var FIELDS = {
        US: FIELD_SETS['default'],
        IN: FIELD_SETS.set2,
        IL: FIELD_SETS.set7,
        AT: FIELD_SETS.set2,
        BE: FIELD_SETS.set2,
        DK: FIELD_SETS.set2,
        NO: FIELD_SETS.set2,
        PL: FIELD_SETS.set2,
        SE: FIELD_SETS.set2,
        AU: FIELD_SETS.set3,
        CA: FIELD_SETS.set4,
        SG: FIELD_SETS.set5,
        MY: FIELD_SETS.set2,
        KR: FIELD_SETS.set5,
        NZ: FIELD_SETS.set5,
        ID: FIELD_SETS.set5,
        TH: FIELD_SETS.set5,
        FR: FIELD_SETS.set2,
        DE: FIELD_SETS.set2,
        IT: FIELD_SETS.set2,
        ES: FIELD_SETS.set2,
        GB: FIELD_SETS.set2,
        NL: FIELD_SETS.set2,
        CH: FIELD_SETS.set7,
        TR: FIELD_SETS.set1,
        CZ: FIELD_SETS.set2,
        FI: FIELD_SETS.set2,
        EE: FIELD_SETS.set2,
        LV: FIELD_SETS.set2,
        HR: FIELD_SETS.set7,
        UA: FIELD_SETS.set1,
        PT: FIELD_SETS.set2,
        IE: FIELD_SETS.set2,
        HU: FIELD_SETS.set2,
        GR: FIELD_SETS.set2,
        SK: FIELD_SETS.set2,
        BA: FIELD_SETS.set1,
        BG: FIELD_SETS.set2,
        CY: FIELD_SETS.set2,
        HK: FIELD_SETS.set6,
        LT: FIELD_SETS.set2,
        LU: FIELD_SETS.set2,
        MT: FIELD_SETS.set2,
        PH: FIELD_SETS.set5,
        RO: FIELD_SETS.set2,
        SI: FIELD_SETS.set2,
        TW: FIELD_SETS.set1,
        AE: FIELD_SETS.set5,
        AL: FIELD_SETS.set1,
        AM: FIELD_SETS.set1,
        AZ: FIELD_SETS.set1,
        BH: FIELD_SETS.set5,
        BN: FIELD_SETS.set1,
        BY: FIELD_SETS.set1,
        EG: FIELD_SETS.set1,
        FO: FIELD_SETS.set5,
        GE: FIELD_SETS.set5,
        NG: FIELD_SETS.set1,
        OM: FIELD_SETS.set5,
        QA: FIELD_SETS.set5,
        RE: FIELD_SETS.set1,
        RS: FIELD_SETS.set5,
        SA: FIELD_SETS.set5,
        VA: FIELD_SETS.set1,
        ZA: FIELD_SETS.set5,
        ZM: FIELD_SETS.set1,
        LK: FIELD_SETS.set1,
        FM: FIELD_SETS.set1,
        MN: FIELD_SETS.set1,
        MV: FIELD_SETS.set1,
        VN: FIELD_SETS.set5,
        MK: FIELD_SETS.set1,
        GI: FIELD_SETS.set1,
        MQ: FIELD_SETS.set1,
        GP: FIELD_SETS.set1,
        MU: FIELD_SETS.set5,
        MD: FIELD_SETS.set5,
        IS: FIELD_SETS.set7,
        GL: FIELD_SETS.set5,
        KZ: FIELD_SETS.set5,
        KW: FIELD_SETS.set5,
        BT: FIELD_SETS.set1,
        KH: FIELD_SETS.set1,
        LA: FIELD_SETS.set1,
        NP: FIELD_SETS.set1,
        TO: FIELD_SETS.set1,
        WS: FIELD_SETS.set1,
        AO: FIELD_SETS.set1,
        BF: FIELD_SETS.set1,
        BI: FIELD_SETS.set1,
        BJ: FIELD_SETS.set1,
        CD: FIELD_SETS.set1,
        CG: FIELD_SETS.set1,
        CI: FIELD_SETS.set1,
        CK: FIELD_SETS.set1,
        CM: FIELD_SETS.set1,
        CV: FIELD_SETS.set1,
        DJ: FIELD_SETS.set1,
        ER: FIELD_SETS.set1,
        ET: FIELD_SETS.set1,
        FJ: FIELD_SETS.set1,
        GA: FIELD_SETS.set1,
        GF: FIELD_SETS.set1,
        GM: FIELD_SETS.set1,
        GN: FIELD_SETS.set1,
        GW: FIELD_SETS.set1,
        KG: FIELD_SETS.set1,
        KI: FIELD_SETS.set1,
        KM: FIELD_SETS.set1,
        LI: FIELD_SETS.set2,
        ME: FIELD_SETS.set1,
        MG: FIELD_SETS.set1,
        MH: FIELD_SETS.set1,
        ML: FIELD_SETS.set1,
        MR: FIELD_SETS.set1,
        MS: FIELD_SETS.set1,
        MW: FIELD_SETS.set1,
        NA: FIELD_SETS.set1,
        NC: FIELD_SETS.set1,
        NE: FIELD_SETS.set1,
        NF: FIELD_SETS.set1,
        NR: FIELD_SETS.set1,
        NU: FIELD_SETS.set1,
        PF: FIELD_SETS.set1,
        SZ: FIELD_SETS.set1,
        TD: FIELD_SETS.set1,
        TG: FIELD_SETS.set1,
        TJ: FIELD_SETS.set1,
        TM: FIELD_SETS.set1,
        TV: FIELD_SETS.set1,
        TZ: FIELD_SETS.set1,
        UG: FIELD_SETS.set5,
        VU: FIELD_SETS.set1,
        WF: FIELD_SETS.set1,
        YT: FIELD_SETS.set1,
        ZW: FIELD_SETS.set1,
        DZ: FIELD_SETS.set1,
        JO: FIELD_SETS.set5,
        MA: FIELD_SETS.set5,
        TN: FIELD_SETS.set1,
        YE: FIELD_SETS.set1,
        AD: FIELD_SETS.set5,
        BW: FIELD_SETS.set5,
        KE: FIELD_SETS.set5,
        LS: FIELD_SETS.set5,
        MC: FIELD_SETS.set5,
        MZ: FIELD_SETS.set5,
        SN: FIELD_SETS.set5,
        PG: FIELD_SETS.set1,
        PM: FIELD_SETS.set1,
        PN: FIELD_SETS.set1,
        PY: FIELD_SETS.set1,
        RW: FIELD_SETS.set1,
        SB: FIELD_SETS.set1,
        SC: FIELD_SETS.set1,
        SH: FIELD_SETS.set1,
        SJ: FIELD_SETS.set1,
        SL: FIELD_SETS.set1,
        SM: FIELD_SETS.set1,
        SO: FIELD_SETS.set1,
        ST: FIELD_SETS.set1,
        PW: FIELD_SETS.set1,
        AG: FIELD_SETS.set1,
        AN: FIELD_SETS.set1,
        AW: FIELD_SETS.set1,
        BB: FIELD_SETS.set1,
        BO: FIELD_SETS.set1,
        BZ: FIELD_SETS.set1,
        DM: FIELD_SETS.set1,
        FK: FIELD_SETS.set1,
        GD: FIELD_SETS.set1,
        GY: FIELD_SETS.set1,
        KN: FIELD_SETS.set1,
        LC: FIELD_SETS.set1,
        SR: FIELD_SETS.set1,
        TC: FIELD_SETS.set1,
        TT: FIELD_SETS.set1,
        VC: FIELD_SETS.set1,
        VG: FIELD_SETS.set1,
        AI: FIELD_SETS.set1,
        MX: FIELD_SETS.set1,
        AR: FIELD_SETS.set5,
        BM: FIELD_SETS.set5,
        BS: FIELD_SETS.set5,
        CL: FIELD_SETS.set5,
        CO: FIELD_SETS.set5,
        CR: FIELD_SETS.set5,
        DO: FIELD_SETS.set5,
        EC: FIELD_SETS.set5,
        GT: FIELD_SETS.set5,
        HN: FIELD_SETS.set5,
        JM: FIELD_SETS.set5,
        JP: FIELD_SETS.set1,
        KY: FIELD_SETS.set5,
        NI: FIELD_SETS.set5,
        PA: FIELD_SETS.set5,
        PE: FIELD_SETS.set5,
        SV: FIELD_SETS.set5,
        UY: FIELD_SETS.set5,
        VE: FIELD_SETS.set5,
        C2: FIELD_SETS.set1
    };

    // converts ['a', 'b'] to {a:true, b:true}
    function arrayToObject(array) {
        var obj = {};

        array.forEach(function (key) {
            obj[key] = true;
        });

        return obj;
    }

    return {
        getSpecialFieldsFor: function getSpecialFieldsFor(country) {
            return arrayToObject(FIELDS[country] || FIELDS.US);
        },

        getFormattedAddress: function getFormattedAddress(address) {
            if (address.country === 'AU') {
                var AUStateCodeMap = {
                    australiancapitalterritory: 'ACT',
                    newsouthwales: 'NSW',
                    northernterritory: 'NT',
                    queensland: 'QLD',
                    southaustralia: 'SA',
                    tasmania: 'TAS',
                    victoria: 'VIC',
                    westernaustralia: 'WA'
                };

                address.state = AUStateCodeMap[address.state.replace(/\s/g, '').toLowerCase()] || address.state;
            }

            return address;
        },

        errorMapper: function errorMapper(errorData) {
            var errorMap = {
                DOB_INVALID: { field: '#dobText' },
                PHONE_INVALID: { field: '#telephone' },
                NATID_INVALID: { field: '#idValue' },
                FI_INVALID: { field: '#expiry_value, #cvv' },
                ADDRESS_LINEONE_INVALID: { field: '#billingLine1' },
                ADDRESS_CITY_INVALID: { field: '#billingCity' },
                ADDRESS_STATE_INVALID: { field: '#billingState' },
                ADDRESS_POSTAL_CODE_INVALID: { field: '#billingPostalCode' },
                PASSWORD_INVALID: { field: '#password, #confirmPassword' }
            };

            return errorMap[errorData].field;
        },

        pxpMapper: function pxpMapper($scope, $pxpMatch, preloadedData) {
            var patterns = {
                proxSignupTitleTreatment: 'prox_signup_title_treatment',
                proxSinglePasswordTreatment: 'prox_single_password_treatment'
            };
            var logPayload = {
                txn_id: preloadedData.transaction
            };

            if ($scope.locale.metadata.country === 'US') {
                $pxpMatch('prox_single_password', {}, patterns, logPayload).then(function (result) {
                    if (result && result.proxSinglePasswordTreatment) {
                        $scope.flags.singlePassword = true;
                    }
                });
            }
            if ($scope.locale.metadata.country === 'US' && $scope.locale.metadata.lang === 'en') {
                $pxpMatch('prox_signup_title', {}, patterns, logPayload).then(function (result) {
                    if (result && result.proxSignupTitleTreatment) {
                        $scope.pageTitle = $scope.locale.content.signup.eBayTitle;
                    } else {
                        $scope.pageTitle = $scope.locale.content.signup.title;
                    }
                });
            }
        }
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/guest-upgrade/occupation/template.html"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {

    return angular.module('xo-guest-upgrade.occupation', ['squid', 'xo-error-tooltip.directive']).directive('xoOccupation', [function () {
        return {
            template: template,

            scope: {
                user: '=?'
            },

            controller: ['$scope', '$locale', function ($scope, $locale) {

                $scope.locale = $locale;

                $scope.occupations = function () {
                    return $locale.content.signup.occupationList;
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\">\n    <header>\n        <div id=\"header\" class=\"merchantHeader clearfix\">\n            <div class=\"headerWrapper\"></div>\n        </div>\n    </header>\n    <div id=\"wrapper\" class=\"clearfix\" ng-class=\"{confirmationPage: !onboard}\">\n        <div id=\"main\">\n            <div class=\"row-fluid paypalHeaderWrapper\">\n                <div class=\"clearfix paypalHeader\" ng-class=\"{span14: onboard, spanConfirmation: !onboard}\">\n                    <div id=\"paypalLogo\" class=\"logo\">\n                        <span class=\"accessAid\">{{content('signup.paypal')}}</span>\n                    </div>\n                </div>\n            </div>\n            <div content ui-view id=\"contents\">\n                <section class=\"guestUpgrade\" id=\"guestUpgrade\">\n                    <div class=\"row-fluid\">\n                        <div ng-if=\"!onboard\">\n                            <div class=\"tick\">\n                                <div id=\"circle\"></div>\n                                <h1 id=\"successTitle\" class=\"alpha successTitle\">{{content('signup.successTitle')}}</h1>\n                            </div>\n\n                            <p id=\"successText1\">{{content('signup.successText1')}} {{content('signup.successText2')}}</p>\n                            <p id=\"successText3\" ng-bind-html=\"htmlContent('signup.successText3')\"></p>\n                            <p ng-if=\"successUrl\" id=\"returnToEbay\" class=\"returnToMerchant\">{{content('signup.returnToEbayMsg')}}</p>\n\n                            <a ng-if=\"successUrl\" id=\"returnToEbayBtn\" track-link=\"success_redirect_return_to_merchant\" href=\"{{successUrl}}\" ng-click=\"stopTimerAndRedirect($event)\" role=\"button\" class=\"ng-binding btn btnGrey\">\n                                {{content('signup.backToEbay')}}\n                            </a>\n                        </div>\n                        <div ng-if=\"onboard\" class=\"span14\">\n                            <div>\n                                <xo-message message=\"pageErrorMsg\"></xo-message>\n\n                                <form id=\"guestUpgradeForm\" name=\"guestUpgradeForm\" class=\"guestUpgradeForm singlePagePaymentForm\" ng-submit=\"guestUpgradeForm.$valid && actions.onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                                    <div class=\"titlePadding\">\n                                        <h1 class=\"alpha\">{{ content(upgradeFromEmail ? 'guestUpgrade.emailFlowTitle' : 'signup.title') }}</h1>\n                                        <p>{{pageSubTitle}}</p>\n                                    </div>\n\n                                    <div id=\"upgradeFromEmail\" ng-if=\"upgradeFromEmail\" class=\"confidential\">\n                                        <div class=\"fieldGroup clearfix\">\n                                            <div id=\"personalInfo\" class=\"inputField half\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.contactInfo')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.first_name}} {{onboard.user.last_name}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.email}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.phone}}</p>\n                                            </div>\n                                            <div id=\"personalBillingAddress\" class=\"inputField half last-child\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.billingAddress')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.line1}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.city}}, {{onboard.billing_address.state}} {{onboard.billing_address.postal_code}}</p>\n                                            </div>\n                                        </div>\n\n                                        <p class=\"contactInfoFont fullsignup-link\" ng-bind-html=\"htmlContent('guestUpgrade.fullSignupLink', {country: locale.country})\"></p>\n\n                                        <div class=\"fieldGroup confirmCard\">\n                                            <p>{{content('guestUpgrade.confirmCard')}} {{onboard.card.brand}} x-{{onboard.card.lastFour}}</p>\n\n                                            <div class=\"inputField half expirationField\" floating-label>\n                                                <input ng-model=\"onboard.card.expiry_month\"\n                                                       name=\"expiry_value\"\n                                                       id=\"expiry_value\"\n                                                       value=\"\"\n                                                       maxlength=\"5\"\n                                                       autocapitalize=\"off\"\n                                                       autocomplete=\"off\"\n                                                       ui-validate=\"'actions.validate($value)'\"\n                                                       ng-keyup=\"actions.formatExpiry($event)\"\n                                                       required />\n\n                                                <label for=\"expiry_value\" class=\"focus\">{{content('creditcard.expiresPlaceholder')}}</label>\n                                            </div>\n\n                                            <div class=\"inputField cvvField half last-child cvvSecurityCode\" floating-label>\n                                                <input type=\"tel\"\n                                                       id=\"cvv\"\n                                                       name=\"cvv\"\n                                                       ng-model=\"onboard.card.security_code\"\n                                                       ng-pattern=\"/^[0-9]{1,4}$/\"\n                                                       ng-minlength=\"3\"\n                                                       ng-maxlength=\"4\"\n                                                       required/>\n\n                                                <label for=\"cvv\" class=\"focus\">{{content('creditcard.cscLabel')}}</label>\n\n                                                <span id=\"securityCode\" class=\"creditCard\" role=\"img\"></span>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <xo-email-input flags=\"flags\" ng-if=\"!upgradeFromEmail\" user=\"onboard.user\" disabled=\"true\"></xo-email-input>\n                                    <xo-password-input user=\"onboard.user\" single-password=\"flags.singlePassword\"></xo-password-input>\n\n                                    <!--As per the UI design, DOB and Gender needs to be side by side -->\n                                    <div class=\"dualInputElements clearfix\">\n                                        <span ng-class=\"{'halfInputElement': specialFields.gender}\" ng-if=\"specialFields.dob\">\n                                            <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                                        </span>\n                                        <!--gender is enabled only for HK-->\n                                        <span ng-if=\"specialFields.gender\">\n                                            <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                                        </span>\n                                    </div>\n\n                                    <!--placeOfBirth -->\n                                    <xo-place-of-birth ng-if=\"specialFields.placeOfBirth\" user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n\n                                    <xo-nationality ng-if=\"specialFields.nationality\" user=\"onboard.user\"></xo-nationality>\n                                    <xo-phone-input ng-if=\"!hasDialingCodeOverride()\" phone=\"onboard.phone\" optional=\"false\" countryCode=\"locale.country\"></xo-phone-input>\n                                    <xo-occupation ng-if=\"specialFields.occupation\" user=\"onboard.user\"></xo-occupation>\n\n                                    <xo-national-id-input ng-if=\"specialFields.nationalId\" country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n\n                                    <div ng-if=\"specialFields.address\" id=\"billingAddress\">\n                                        <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\"></xo-add-address>\n                                    </div>\n\n                                    <xo-phone-input ng-if=\"hasDialingCodeOverride()\" phone=\"onboard.phone\" optional=\"false\" countryCode=\"locale.country\"></xo-phone-input>\n\n                                    <div class=\"row-fluid inputField checkbox legal ltrOverride\">\n                                        <div id=\"errorSignupAgree\" ng-show=\"guestUpgradeForm.agree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('signup.agrementError') }}</div>\n\n                                        <input ng-model=\"agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" required aria-describedby=\"errorSignupAgree\"/>\n                                        <label class=\"noBottom signupTerms bgImgOnSpan\" for=\"agree\" aria-describedby=\"errorSignupAgree\">\n                                            <span class=\"bgImg\">&nbsp;</span>\n                                            <span id=\"consentTerms\" ng-bind-html=\"htmlContent(onboard.eConsentTermsContent, { country: locale.country, lang: locale.lang })\"></span>\n                                        </label>\n                                    </div> \n                                \n                                    <div class=\"terms\" feature=\"signupTerms\">\n                                        <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{country:locale.country})\"></p>\n                                    </div>\n\n                                    <div ng-if=\"showMarketingOptin\" class=\"row-fluid checkbox legal marketing\">\n                                        <input ng-model=\"onboard.marketing_optin\" type=\"checkbox\" name=\"marketing_optin\" id=\"marketing_optin\" ng-checked=\"onboard.marketing_optin\"/>\n                                        <label class=\"noBottom\" id=\"marketingOptinText\" for=\"marketing_optin\" ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n                                    </div>\n\n                                    <div class=\"buttons\">\n                                        <input track-submit id=\"guestUpgradeSubmit\" type=\"submit\" value=\"{{ content('signup.agreeAndCreateAcc')}}\" class=\"btn\"\n                                               ng-click=\"validated=true\" />\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"onboard\" class=\"span10\">\n                            <xo-value-props type=\"review\" title=\"{{valueTitle}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n                        </div>\n                    </div>\n                </section>\n                <xo-modal ng-if=\"showAddressNormalizationLightbox && specialFields.address\" show=\"true\">\n                    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n                </xo-modal>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <div ng-attr-id=\"{{footerStyle}}\">\n        <xo-footer merchant=\"{{content('signup.ebay')}}\" cancel=\"{{cancelUrl}}\"></xo-footer>\n    </div>\n    <xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/cartChanged/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/cartChanged/template.html");

var _template2 = _interopRequireDefault(_template);

var _errorHandlerHelper = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js");

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/directive.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCartChanged', {
    tag: 'xo-cart-changed',

    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },

        shippingAddress: {
            type: 'var',
            required: true
        },

        disableChangeShippingCountry: {
            type: 'var',
            required: false
        },

        ixoModel: {
            type: 'var',
            required: true
        },

        onShippingChange: {
            type: 'var',
            required: true
        },

        onContinue: {
            type: 'var',
            required: true
        },

        message: {
            type: 'var',
            required: false
        },

        showForm: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.errorMessage = '';
            document.querySelector('body').style.overflow = 'hidden';
        },
        exit: function exit() {
            document.querySelector('body').style.overflow = '';
        },
        populate: function populate() {
            var _this = this;

            this.ixoModel.updateIxoShippingMethods();

            this.cartOptions = {
                showTotal: true,
                showContainer: false
            };

            this.openForm = function () {
                _this.message = (0, _squid.$renderContent)('shippingAddress.label');
                _this.showForm = true;
            };

            this.updateShippingAddress = function () {
                return _this.models.checkoutSession.shipping.action('update', {
                    data: _this.shippingAddress.serialize(),
                    resultModel: _this.models.checkoutSession,
                    validation: function validation(errorData, message) {
                        errorHandlerHelper.errorHandler(message, errorData.fields, function () {}, null, '#cartChangedForm');
                        _this.errorMessage = {
                            msgs: [(0, _squid.$renderContent)('shippingAddress.errorInfo')],
                            type: 'error'
                        };

                        return _squid.$promise.reject();
                    }
                });
            };

            this.merchant = this.models.checkoutAppData.getMerchantDisplayName();

            var getFormattedAddress = function getFormattedAddress() {
                var fullName = _this.models.checkoutSession.shipping.name;
                var fullAddress = _this.models.checkoutSession.shipping.full_address_multiline;

                return [fullName].concat(fullAddress).join('<br/>');
            };

            this.formattedAddress = _angular.$sce.trustAsHtml(getFormattedAddress());

            (0, _angular.$timeout)(function () {
                _this.modalOpen = true;
            });
        }
    },

    actions: {
        updateShipping: function updateShipping(event) {
            if (event) {
                event.preventDefault();
            }

            this.updateShippingAddress().then(this.onShippingChange);
        },
        returnToMerchant: function returnToMerchant() {
            return (0, _util.goTo)(this.models.checkoutAppData.urls.cancel_url);
        }
    }
});


_squid.$Component;

_squid.$renderContent;

_angular.$timeout;

_angular.$sce;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_squid.$promise;

_util.goTo;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/cartChanged/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"cartChangedInterstitial\" class=\"interstitialModal\">\n    <div class=\"cartChanged\" ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\" modal-box focus-when=\"modalOpen\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n\t\t\t\t<header class=\"interstitialHeader\">\n                    <figure class=\"logo\"></figure>\n                    <xo-cart token=\"token\" show-cart-total=\"cartOptions.showTotal\" render-cart-container=\"cartOptions.showContainer\"></xo-cart>\n                    <h1 class=\"alpha center\" id=\"pageTitle\">{{message}}</h1>\n                </header>\n                <section class=\"interstitialBody\">\n                    <address class=\"bodyAddress\" ng-if=\"!showForm\">\n                        <h3>{{content('shipping.shippingTitle')}}</h3>\n                        <address ng-bind-html=\"formattedAddress\"></address>\n                        <p class=\"bodyLink\">\n                            <a class=\"editLink\" ng-click=\"openForm()\">{{content('common.edit')}}</a>\n                        </p>\n                    </address>\n                    <form id=\"cartChangedForm\" class=\"bodyForm\" ng-submit=\"actions.updateShipping($event)\" ng-if=\"showForm\">\n\t\t\t\t\t\t<xo-message message=\"errorMessage\"></xo-message>\n                        <xo-select-shipping-country token=\"token\" shipping-address=\"shippingAddress\"\n                                                disable-change-shipping-country=\"disableChangeShippingCountry\"></xo-select-shipping-country>\n                        <xo-add-address address=\"shippingAddress\" is-shipping=\"true\" token=\"token\" country=\"shippingAddress.country\"></xo-add-address>\n                        <div class=\"interstitialShippingOptions\" ng-if=\"ixoModel.ixoShippingMethods\">\n                            <xo-guest-simplified-select-shipping-methods\n                                token=\"token\"\n                                select-shipping-method=\"ixoModel.updateIxoSelectedShippingMethod\"\n                                shipping-methods=\"ixoModel.ixoShippingMethods\"\n                                selected-shipping-method=\"ixoModel.ixoSelectedShippingMethod\">\n                            </xo-guest-simplified-select-shipping-methods>\n                        </div>\n                    </form>\n                </section>\n                <footer class=\"interstitialFooter\">\n                    <button type=\"submit\" class=\"btn\" ng-click=\"showForm ? actions.updateShipping() : onContinue()\">{{content('common.continuetext')}}</button>\n                    <p id=\"defaultCancelLink\" class=\"footerLink cancelUrl\">\n                        <a track-link=\"cancel_and_return_to_merchant\" href=\"\" ng-click=\"actions.returnToMerchant()\" role=\"button\">\n                           <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n                        </a>\n                    </p>\n                </footer>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var submitButtonGuestTextKeyMap = {
    commit: 'common.payLabel',
    notCommit: 'common.continueLabel',
    commitInCurrency: 'common.payInCurrencyLabel',
    notCommitInCurrency: 'common.continueInCurrencyLabel'
};

var submitButtonSignupTextKeyMap = {
    commit: 'common.createAccountAndPayNow',
    notCommit: 'common.agreeAndCreateAccount'
};

var SUBSCRIPTION_SUBMIT_BUTTON_KEY = exports.SUBSCRIPTION_SUBMIT_BUTTON_KEY = 'wpsSubscription.guest.createAccountAndSubscribe.button.text';

var SUBMIT_BUTTON_TEXT_KEY_MAP = exports.SUBMIT_BUTTON_TEXT_KEY_MAP = {
    signup: {
        US: submitButtonSignupTextKeyMap,
        ROW: {
            commit: 'common.agreeAndPay',
            notCommit: 'common.agreeAndContinue'
        }
    },
    pomaSignup: {
        US: submitButtonSignupTextKeyMap,
        ROW: {
            commit: 'common.agreeAndPayNowPoma',
            notCommit: 'common.agreeAndContinue'
        }
    },
    guest: {
        US: submitButtonGuestTextKeyMap,
        ROW: submitButtonGuestTextKeyMap
    }
};

// This is remittance transfer rule max amount for invoicing transactions
var RTR_AMOUNT = exports.RTR_AMOUNT = 15;

// Shipping Options Label mapping for content
var SHIPPING_TYPE_LABEL_MAPPING = exports.SHIPPING_TYPE_LABEL_MAPPING = {
    PICKUP: {
        PICKUP_IN_STORE: 'shipping.pickupInStore',
        STORE_PICKUP: 'shipping.storePickup',
        PICKUP_OPTION: 'shipping.pickupOption',
        COLLECTION: 'shipping.collection',
        EXPRESS_PICKUP: 'shipping.expressPickup',
        CLICK_COLLECT: 'shipping.clickCollect',
        SHIP_TO_STORE: 'shipping.shipToStore',
        COLLECT_PLUS: 'shipping.collectPlus',
        PICKUP_FROM_STORE: 'shipping.pickupFromStore',
        FREE_NEXT_DAY_STORE_DELIVERY: 'shipping.freeNextDayStoreDelivery',
        BUY_AND_COLLECT: 'shipping.buyAndCollect',
        SHIP_TO_LOCKER: 'shipping.shipToLocker'
    },
    SHIPPING: {
        SHIP_TO_HOME: 'shipping.shipToHome',
        OVERNIGHT: 'shipping.overnightShipping', // testing multiple methods ....
        TWO_THREE_DAYS: 'shipping.twoThreeDaysShipping' // testing multiple methods ....
    }
};

// Shipping Type content mapping
var SHIPPING_TYPE_MAPPING = exports.SHIPPING_TYPE_MAPPING = {
    SHIPPING: 'shipping.shipHome',
    PICKUP: 'shipping.shipStore'
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/errorHandlerConstants.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.validationErrorMap = exports.errorElementMap = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var loginRedirectUrl = (0, _squid.$getRedirectUrl)('hermes', {
    hermesLoginRedirect: 'xoon'
});

/* Please do not remove the double encoding component 'encodeURIComponent' */
var doubleEncodeUrl = function doubleEncodeUrl(url) {
    return encodeURIComponent(encodeURIComponent(url));
};
var loginPageUrl = doubleEncodeUrl((0, _squid.$getRedirectUrl)('hermes', {}));
var landingPageUrl = doubleEncodeUrl(_index.$util.buildURL(_index.$config.urls.fallbackUrl && _index.$config.urls.fallbackUrl['hermes'] || '/webapps/hermes', _index.$util.params()));

var authflowRedirectUrl = (0, _squid.$getRedirectUrl)('authflow', {});
authflowRedirectUrl = authflowRedirectUrl + '&loginUrl=' + loginPageUrl + '&redirectUri=' + landingPageUrl;

// TODO: should we have fields in a different constant
var errorElementMap = {
    INVALID_FIRST_NAME: {
        fields: [{ field: 'user.first_name' }]
    },
    INVALID_LAST_NAME: {
        fields: [{ field: 'user.last_name' }]
    },
    INVALID_PHONE_TYPE: {
        fields: [{ field: 'phone.phoneType' }]
    },
    INVALID_PHONE_NUMBER: {
        fields: [{ field: 'phone.telephone' }]
    },
    INVALID_CITY_STATE_ZIPCODE: {
        fields: [{ field: 'address.city' }, { field: 'address.state' }, { field: 'zipCode' }]
    },
    INVALID_LINE1: {
        fields: [{ field: 'address.line1' }]
    },
    INVALID_CITY: {
        fields: [{ field: 'address.city' }]
    },
    INVALID_STATE: {
        fields: [{ field: 'address.state' }]
    },
    INVALID_ZIPCODE: {
        fields: [{ field: 'PostalCode' }, { field: 'address.postal_code' }],
        name: 'billing'
    },
    INVALID_NATIONAL_ID_TYPE: {
        element: '#nationalIdFields',
        fields: [{ field: 'type' }],
        model: 'nationalIdModel.nationalId.'
    },
    INVALID_NATIONAL_ID: {
        element: '#nationalIdFields',
        fields: [{ field: 'Value' }],
        name: 'id'
    },
    INVALID_SECONDARY_ID_TYPE: {
        element: '#nationalIdFields',
        fields: [{ field: 'secondaryIdType' }],
        model: 'nationalIdModel.'
    },
    INVALID_SECONDARY_ID: {
        element: '#nationalIdFields',
        fields: [{ field: 'secondaryIdValue' }],
        model: 'nationalIdModel.'
    },

    INVALID_BILLING_ADDRESS: {
        element: '#billingAddress',
        name: 'billing'
    },
    INVALID_SHIPPING_ADDRESS: {
        element: '#shippingAddress',
        name: 'shipping'
    },
    INVALID_EXPIRATION_DATE: {
        pageError: {
            contentKey: 'creditcard.errorExpiredCard'
        }
    },
    PASSWORD_TOO_LONG: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    PASSWORD_HAS_ILLEGAL_CHARACTERS: {
        element: '#signupContainer',
        model: 'user.',
        fields: [{ field: 'password' }, { field: 'confirmPassword' }]
    },
    ACCOUNT_ALREADY_EXISTS: {
        fields: [{ field: 'user.email' }],
        pageError: {
            contentKey: 'login.userMayHaveAccount',
            guestcontentKey: 'login.userMayHaveAccountGuest'
        },
        compileMessageWith: {
            href: loginRedirectUrl
        },
        scrollToTop: true
    },
    ACCOUNT_ALREADY_EXISTS_AUTHFLOW_REDIRECT: {
        fields: [{ field: 'user.email' }],
        pageError: {
            contentKey: 'login.userMayHaveAccountRecovery'
        },
        compileMessageWith: {
            href: authflowRedirectUrl
        },
        scrollToTop: true
    },
    INVALID_EMAIL_ID: {
        fields: [{ field: 'user.email' }]
    },
    DOB_INVALID: {
        element: '#dob, #dobBank',
        name: 'dob',
        fields: [{ field: 'Day' }, { field: 'Month' }, { field: 'Year' }, { field: 'Text' }]
    },
    REJECT_REFUSED: {
        pageError: {
            contentKey: 'creditcard.errorInstrumentRefused'
        }
    },
    INVALID_INSTRUMENT_ID: {
        pageError: {
            contentKey: 'creditcard.errorInvalidData'
        }
    },
    ADDRESS_MISMATCH: {
        pageError: {
            contentKey: 'creditcard.errorInstrumentBillingAddressNotMatch'
        }
    },
    CHECK_DIGITS_REJECTED: {
        pageError: {
            contentKey: 'creditcard.errorCheckDigits'
        }
    },
    OAS_GENERIC_ERROR: {
        pageError: {
            contentKey: 'genericError.genericError'
        },
        scrollToTop: true
    },
    BIN_BLOCKED_OR_CARD_NOT_ALLOWED: {
        pageError: {
            contentKey: 'creditcard.complianceDecline'
        }
    },
    INVALID_CARD_OR_TYPE: {
        pageError: {
            contentKey: 'creditcard.errorInvalidCCNumberOrType_global'
        }
    },
    INVALID_SECURITY_CODE: {
        fields: [{ field: 'card.security_code' }],
        pageError: {
            contentKey: 'creditcard.errorCheckDigitsNotPresent'
        }
    },
    COUNTRY_NOT_SUPPORTED: {
        pageError: {
            contentKey: 'creditcard.complianceDecline'
        }
    },
    CARD_GENERIC_ERROR: {
        pageError: {
            contentKey: 'creditcard.errorGeneral'
        }
    },
    BANK_GENERIC_ERROR: {
        pageError: {
            contentKey: 'bank.errorGeneral'
        }
    }
};

// TODO: this block needs to be depricated. looks like this is valid for a
// old service call which is killed already
var validationErrorMap = {
    INVALID_ROUTING_NUMBER: {
        contentKey: 'bank.invalidRoutingNumber'
    },
    INVALID_ACCOUNT: {
        contentKey: 'creditcard.errorInvalidData'
    },
    ISSUER_DENIED: {
        contentKey: 'creditcard.errorIssuerDenied'
    },
    ISSUER_REJECTED: {
        contentKey: 'creditcard.errorIssuerReject'
    },
    REJECT_REFUSED: {
        contentKey: 'creditcard.errorInstrumentRefused'
    },
    INVALID_INSTRUMENT_ID: {
        contentKey: 'creditcard.errorInvalidData'
    }
};

exports.errorElementMap = errorElementMap;
exports.validationErrorMap = validationErrorMap;


_squid.$getRedirectUrl;

_index.$config;

_index.$util;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/pxpExperimentConstants.js":
/***/ (function(module, exports) {



exports.__esModule = true;

var singlepassword = {
    singlepassword_test: 'xoon_single_password_test'
};

var xoon_optional_signup_content_change = {
    xoon_optional_signup_content_change_gb_test: {
        subTitle: 'common.createPayPalPropTest1',
        yesCreateAccount: 'common.yesCreateAccountTest1'
    },
    xoon_optional_signup_content_change_test1: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest1'
    },
    xoon_optional_signup_content_change_test2: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest2'
    },
    xoon_optional_signup_content_change_test3: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest3'
    },
    xoon_optional_signup_content_change_test4: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest4'
    }
};

var frsPageName = {
    wps: {
        signup: 'frs_wps_forced',
        guest: 'frs_wps_optional',
        guestonly: 'frs_wps_optional'
    },
    ec: {
        signup: 'frs_ec_forced',
        guest: 'frs_ec_optional'
    }
};

var xoon_forced_signup_buyer_protection_content = {
    xoon_forced_signup_buyer_protection_content_treatment_a: {
        titleLine1: 'common.getSecurityAndProtectionLine1',
        titleLine2: 'common.getSecurityAndProtectionLine2',
        subTitle: 'common.getSecurityAndProtectionLineSubTitle'
    },
    xoon_forced_signup_buyer_protection_content_treatment_b: {
        titleLine1: 'common.getCashbackLine1',
        titleLine2: '',
        subTitle: 'common.getCashbackLineSubTitle'
    }
};

var frs_wps_optional = {
    frs_wps_optional_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant1',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_wps_optional_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant2',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_wps_optional_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant3',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_ec_optional = {
    frs_ec_optional_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant4',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_ec_optional_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant5',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_ec_optional_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant6',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_ec_forced = {
    frs_ec_forced_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant7',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_ec_forced_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant8',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_ec_forced_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant9',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_wps_forced = {
    frs_wps_forced_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant7',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_wps_forced_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant8',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_wps_forced_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant9',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_applicable_treatments = {
    frs_wps_optional: ['frs_wps_optional_treatment1', 'frs_wps_optional_treatment2', 'frs_wps_optional_treatment3'],
    frs_ec_optional: ['frs_ec_optional_treatment1', 'frs_ec_optional_treatment2', 'frs_ec_optional_treatment3'],
    frs_ec_forced: ['frs_ec_forced_treatment1', 'frs_ec_forced_treatment2', 'frs_ec_forced_treatment3'],
    frs_wps_forced: ['frs_wps_forced_treatment1', 'frs_wps_forced_treatment2', 'frs_wps_forced_treatment3']
};

exports['default'] = {
    test: {
        singlepassword: singlepassword,
        xoon_optional_signup_content_change: xoon_optional_signup_content_change,
        frs_wps_optional: frs_wps_optional,
        frs_ec_optional: frs_ec_optional,
        frs_ec_forced: frs_ec_forced,
        frs_applicable_treatments: frs_applicable_treatments,
        frsPageName: frsPageName,
        frs_wps_forced: frs_wps_forced,
        xoon_forced_signup_buyer_protection_content: xoon_forced_signup_buyer_protection_content
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/countryList/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoCountryList', {
    tag: 'xo-country-list',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        showMask: {
            type: 'var',
            required: false
        },
        // mode is not present in multistep, so it is set as not required
        mode: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve(),
                payee: _index2.$CheckoutPayeeModel.instance(this.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            // Default to 'signup' as multistep will not pass mode prop
            this.mode = this.mode || 'signup';
        },
        populate: function populate() {
            var _this = this;

            var proxSignUpFlow = this.models.checkoutInputData.isEbayTxn();

            this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country');
            this.merchantComplianceRestricted = (0, _index.$feature)('merchantComplianceRestricted', false, this.merchantCountry);

            this.fallbackOnUnsupportedCountry = function (selectedCountry) {
                if (!(0, _index.$feature)('guest', false, selectedCountry) || (0, _index.$feature)('guestFallback', false, selectedCountry)) {
                    throw new _index.$FallbackError({
                        reason: 'other_country_selected_for_guest',
                        product: 'ux'
                    });
                }
            };

            this.fallbackOnUnsupportedCountry(_index.$locale.country);

            this.isMerchantCountrySameAsSelectedCountry = function (merchantCountry, selectedCountry) {
                var countriesWithMultipleCodes = {
                    CN: ['CN', 'C2'],
                    C2: ['CN', 'C2']
                };
                var merchantCountryList = countriesWithMultipleCodes[merchantCountry] || [merchantCountry];

                return merchantCountryList.indexOf(selectedCountry) > -1;
            };

            /**
             * This function will determine the country list will be shown to user:
             * 1. Get supported country list from griffin
             * 2. Filter out blocked countries configured in our app's config file
             * 3. Add default 'Country' option to the list if needed: ie. for merchant compliance restricted case
             */
            this.populateSupportedCountries = function () {
                _this.metadata = _angular2['default'].copy(_index.$locale.metadata) || {};
                var _metadata$territory = _this.metadata.territory,
                    territory = _metadata$territory === undefined ? [] : _metadata$territory;

                var countries = proxSignUpFlow ? _index.$config.proxSupportedCountries : _index.$config.guestBlockedCountries || [];

                _this.supportedCountries = territory.filter(function (c) {
                    if (c.code === _index.$locale.country) {
                        _this.selectedCountryObj = c;
                    }

                    var inCountires = countries.includes(c.code);

                    // When not in the prox signup flow we need to return the negated
                    // inCountires since it is checking blocked countries, not allowed countries
                    return proxSignUpFlow ? inCountires : !inCountires;
                });

                if (!proxSignUpFlow) {
                    if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _this.selectedCountryObj.code)) {
                        var defaultOption = {
                            code: '',
                            name: _index.$locale.content.common.country
                        };

                        _this.supportedCountries.push(defaultOption);
                        _this.selectedCountryObj = defaultOption;
                    }

                    if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _index.$locale.country)) {
                        _this.showMask = true;
                    }
                }
            };

            this.populateSupportedCountries();

            // TODO: to be removed - currently locale change and metadata change is not in sync which need to be fixed.
            this.$on('metadataChange', function () {
                _this.populateSupportedCountries();
            });

            /*
             * merchants can block international PayPal accounts using the merchant setting Block payments from users
             * who have non-merchant country PayPal accounts, if resolved country is not merchant country, default to merchant country
             * and disable the country list
             */
            this.blockNonDomesticPayer = this.models.checkoutAppData.get('flags.block_non_domestic_payer') && (0, _index.$feature)('blockNonDomesticPayer', false, this.merchantCountry);
            this.disableCountryList = this.blockNonDomesticPayer || this.models.checkoutCart.isWalletTokenization();
            if (this.disableCountryList && this.merchantCountry !== _index.$locale.country) {
                _logger.$logger.info('merchant block_non_domestic_payer', {
                    merchantCountry: this.merchantCountry,
                    resolvedCountry: _index.$locale.country
                });
                this.actions.countryChanged(this.merchantCountry);
            }
        }
    },

    actions: {
        countryChanged: function countryChanged(selectedCountry) {
            var _this2 = this;

            var stateName = this.mode === 'signup' ? 'signup' : 'guest_xo';

            _logger.$logger.info('country_updated', { 'to': selectedCountry, 'from': _index.$locale.country });

            _logger.$logger.info('checkout_fpti', {
                from: stateName,
                to: 'prep_change_cntry'
            });

            this.selectedCountry = selectedCountry;
            this.fallbackOnUnsupportedCountry(selectedCountry);

            if (this.merchantComplianceRestricted) {
                this.showMask = false;
                this.showMessage = false;
                this.ariaDescribedBy = '';

                if (!selectedCountry) {
                    this.showMask = true;
                    return;
                } else if (this.isMerchantCountrySameAsSelectedCountry(this.merchantCountry, selectedCountry)) {
                    this.showMask = true;
                    this.showMessage = true;
                    this.ariaDescribedBy = 'errorSignupAgree';
                    return;
                }
            }

            var resolveLang = function resolveLang() {

                var merchantLocale = _this2.models.checkoutAppData.get('merchant.merchant_locale');

                merchantLocale = merchantLocale && _index.$localeHelper.normalizeLocale(merchantLocale).language;
                merchantLocale = merchantLocale && merchantLocale.toLowerCase();

                var supportedLocales = _index.$config.supportedCountries;

                var defaultLanguageException = _index.$config.defaultLanguageException;
                var defaultExceptionLang = defaultLanguageException[selectedCountry];
                var defaultCountryLang = supportedLocales[selectedCountry] && supportedLocales[selectedCountry][0];

                var selectedLang = defaultExceptionLang || defaultCountryLang;

                var resolvedLang = merchantLocale && supportedLocales[selectedCountry] && supportedLocales[selectedCountry].indexOf(merchantLocale) !== -1 ? merchantLocale : selectedLang;

                return resolvedLang;
            };

            if (_index.$locale.country !== this.selectedCountry) {
                // Make known the country has changed
                // Used in xoon to re-issue EPM call
                _index.$event.broadcast('countryChange');

                // Perform Language Resolution only when the country is changed, as below code does not consider locale.x merchant parameter
                _index.$locale.choose(this.selectedCountry, resolveLang(selectedCountry)).then(function () {
                    _uiRouter.$state.go('checkout.landing');
                });
            }
        }
    }

});


_index.$Component;

_index.$FallbackError;

_index.$config;

_index.$event;

_index.$feature;

_index.$locale;

_index.$localeHelper;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index3.$CheckoutInputDataModel;

_logger.$logger;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/countryList/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"countryList\" class=\"countryList dropdown confidential inputField\" ng-class=\"{'validated': showMessage}\"\n     ng-cloak content floating-label-dropdown>\n    <div id=\"blockNonDomesticPayer\" ng-if=\"blockNonDomesticPayer\" class=\"infoMsg errorMsgRuleSpecific\">\n        <span class=\"infoIcon\"></span>\n        <span>{{content('billing.blockNonDomesticPayer', {countryCode: selectedCountryObj.code})}}</span>\n    </div>\n    <div ng-class=\"{'showMask': disableCountryList}\">\n        <select xo-dropdown compliance-validation dropdown-text-bind-var=\"selectedCountryObj.name\"\n                ng-model=\"selectedCountryObj\" name=\"countryName\" id=\"countrySelector\"\n                ng-required=\"true\" ng-disabled=\"disableCountryList\"\n                ng-attr-aria-describedby=\"{{ariaDescribedBy}}\"\n                ng-options=\"country.name for country in supportedCountries track by country.code\"\n                ng-change=\"actions.countryChanged(selectedCountryObj.code)\">\n        </select>\n        <label for=\"countrySelector\" id=\"countryListLabel\">{{content('country.country')}}</label>\n    </div>\n\n    <div id=\"errorSignupAgree\" ng-if=\"showMessage\" class=\"errorMsg errorMsgRuleSpecific\">\n        {{content('common.complianceRestricted', {merchantCountry: selectedCountryObj.name})}}\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/styles.less");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/template.html");

var _template2 = _interopRequireDefault(_template);

var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionLightbox', {
    tag: 'xo-currency-conversion-lightbox',

    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        },
        prePlanTreatment: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.openModal = function () {
                _logger.$logger.info('OPENING_CURRENCY_CONVERSION_LIGHTBOX', { isBuyerFx: Boolean(_this.prePlanTreatment) });
                _this.modalOpen = true;
            };

            this.updateConversionSelection = function (selection) {
                _this.models.ppconversion = selection;
                _this.setSelectedCurrency(selection);
            };

            this.isBuyerFXTreatment2 = (this.prePlanTreatment || '').includes('treatment_2');
            this.isNotBuyerFXTreatment = !(this.prePlanTreatment || '').includes('treatment');

            // This function is used to set the this.currency property which
            // is used for the `Pay in {currency}` label for the Buyer FX flow
            this.setSelectedCurrency = function (currencySelection) {
                if (_this.isBuyerFXTreatment2) {
                    _this.currency = currencySelection === 'PAYPAL' ? _this.fromCurrencyCode : _this.toCurrencyCode;
                }
            };
        },
        populate: function populate() {
            var _this2 = this;

            // Set default conversion choice to 'PAYPAL'
            this.models.ppconversion = 'PAYPAL';

            // Get conversion currency codes
            var conversion = this.models.checkoutSession.get('plan.conversion', {});

            this.fromCurrencyCode = conversion.from_code;
            this.toCurrencyCode = conversion.to_code;
            this.conversionSpread = conversion.spread;

            // We don't want to log Buyer FX information to FPTI
            // for countries not included in the PXP
            if (this.prePlanTreatment) {
                /**
                 * FPTI event #5 for Buyer FX guest experience
                 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                 * Buyer FX logging requires some extra information beyond what
                 * we log for the PILOT/ROW/EMEA DCC experience
                 */
                _logger.$logger.info('checkout_fpti', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'prepare_currency_conversion_post_plan',
                    conversion_type: 'PAYPAL', // Default selection
                    is_conversion_shown: 1,
                    currency_conversion_from_curr: this.fromCurrencyCode,
                    currency_conversion_to_curr: this.toCurrencyCode,
                    currency_conversion_spread: this.conversionSpread
                });
            }

            // Set content for Buyer FX (prePlanTreatment)
            this.setSelectedCurrency('PAYPAL');
            this.continueButton = 'common.pay' + (this.isBuyerFXTreatment2 ? 'InCurrency' : '') + 'Label';
            this.buyerFxHeader = this.prePlanTreatment === 'xo_xoon_dcc_popup_content_treatment_1' ? 'currencyOptions.bfxConversionHeaderRateInterstitial' : 'currencyOptions.bfxConversionHeaderCurrency';

            /**
             * Invoicing RegE compliance message has to be shown if Remittance Transfer Rule (RTR) applies.
             * It applies for US payers paying non US merchants an amount greater than $15 USD or the
             * equivalent in a foreign currency.
             */
            var isInvoicingFlow = this.models.checkoutAppData.get('flags.is_invoice_flow') === true;
            var amount = this.models.checkoutSession.get('plan.sources.0.amount.amount');
            var isRTRAmount = Number(amount) > _constants.RTR_AMOUNT;

            if (isInvoicingFlow) {
                var isUSBuyer = _squid.$locale.country === 'US';

                this.merchant = this.models.checkoutAppData.get('merchant');
                this.showInvoicingRegEMsg = isUSBuyer && isRTRAmount && _squid.$util.getProperty(this.merchant, 'merchant_country') !== 'US';

                // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
                // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
                // in currencyOptions.invoicingRegEMsg displayed in template
                this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true
                });
            }
            /**
             * End Reg-E logic
             */

            this.closeModal = function (event) {
                if (event && event.preventDefault) {
                    event.preventDefault();
                }

                _this2.modalOpen = false;

                // Hook css transition completion event 'transitionend'
                // to call onComplete function, guarentees best timing
                var containerEl = document.getElementById('conversionContainer');
                var onComplete = _squid.$util.once(function () {
                    _logger.$logger.info('close_currency_conversion_lightbox');
                    return _this2.props.doneFn();
                });

                containerEl.addEventListener('transitionend', onComplete);

                // If the browser doesn't support `transitionend` event callback
                // then we call onComplete after 350ms as fallback
                (0, _angular.$timeout)(onComplete, 350);
            };

            /**
             * FPTI event 7 for Buyer FX DCC - POST-PLAN
             * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
             */
            this.logFinalSelectionToFPTI = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'finalize_currency_conversion',
                    currency_conversion_selected: _this2.models.ppconversion,
                    currency_conversion_from_curr: _this2.fromCurrencyCode,
                    currency_conversion_to_curr: _this2.toCurrencyCode,
                    currency_conversion_spread: _this2.conversionSpread
                });
            };
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this3 = this;

            if (!this.models.ppconversion) {
                _logger.$logger.info('CURRENCY_CONVERSION_SUBMITTED_WITHOUT_SELECTION');

                this.message = {
                    msgKeys: ['currencyOptions.noneSelected'],
                    type: 'error'
                };

                return;
            }

            /*
             * This check cuts off flow to the 'updateConversion' service call
             * when the user has selected 'PAYPAL' for conversion. This is done
             * because the conversion is already set to 'PAYPAL' on the plan so
             * we do not need to make a patch call to update the conversion selection.
             */
            if (this.models.ppconversion === 'PAYPAL') {
                // We don't want to log Buyer FX information to FPTI
                // for countries not incldued in the PXP
                if (this.prePlanTreatment) {
                    this.logFinalSelectionToFPTI();
                }

                this.closeModal({ complete: true });

                return;
            }

            /**
             * If conversion is not 'PAYPAL' then we need to patch the cart to set the
             * conversion type to vendor.
             */
            var data = {
                conversionType: this.models.ppconversion,
                planId: this.models.checkoutSession.get('plan.id')
            };

            if (data.planId) {
                var setErrorMessage = function setErrorMessage() {
                    _logger.$logger.info('POST_PLAN_CONVERSION_ERROR');

                    _this3.message = {
                        msgKeys: ['genericError.genericError'],
                        type: 'error'
                    };
                };

                this.models.checkoutSession.fundingOptions.action('updateConversion', {
                    data: data,
                    success: function success() {
                        // We don't want to log Buyer FX information to FPTI
                        // for countries not incldued in the PXP
                        if (_this3.prePlanTreatment) {
                            _this3.logFinalSelectionToFPTI();
                        }

                        _this3.closeModal({ complete: true });
                    },
                    error: setErrorMessage,
                    contingency: setErrorMessage
                });
            }
        }
    }
});


_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_squid.$Component;

_squid.$locale;

_squid.$util;

_logger.$logger;

_angular.$timeout;

_constants.RTR_AMOUNT;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"conversionSection\">\n    <div class=\"conversion\"\n        id=\"conversionContainer\"\n        ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\"\n            focus-when=\"modalOpen\"\n            modal-box>\n\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <xo-message message=\"message\"></xo-message>\n\n                <form method=\"post\"\n                    class=\"curr_conv asideProceed formSmall\"\n                    novalidate=\"novalidate\"\n                    ng-submit=\"actions.onSubmit()\"\n                    content>\n\n                    <xo-currency-conversion-lightbox-options\n                        token=\"token\"\n                        update-conversion-selection=\"updateConversionSelection\"\n                        open-modal=\"openModal\"\n                        is-buyer-fx-pxp=\"prePlanTreatment\"\n                        ng-if=\"isNotBuyerFXTreatment\">\n                    </xo-currency-conversion-lightbox-options>\n\n                    <div ng-if=\"!isNotBuyerFXTreatment\">\n                        <h2 class=\"buyer-fx-interstitial-header\">{{ content(buyerFxHeader) }}</h2>\n                        <xo-currency-conversion-options\n                            token=\"token\"\n                            treatment=\"prePlanTreatment\"\n                            update-conversion-selection=\"updateConversionSelection\"\n                            open-modal=\"openModal\">\n                        </xo-currency-conversion-options>\n                    </div>\n\n                    <div class=\"invRegE\" ng-if=\"showInvoicingRegEMsg\">\n                        {{\n                            content(\n                                'currencyOptions.invoicingRegEMsg',\n                                {\n                                    merchantName: nonEmptyMerchantDisplayName,\n                                    amountInInvoiceCurrency: merchantTotal\n                                }\n                            )\n                        }}\n                    </div>\n\n                    <div class=\"buttons\">\n                        <input\n                            id=\"proceedButton\"\n                            type=\"submit\"\n                            value=\"{{ content(continueButton, { currency: currency }) }}\"\n                            class=\"btn full\">\n                    </div>\n\n                </form>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoInlineCurrencyConversion', {
    tag: 'xo-inline-currency-conversion',

    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        token: {
            type: 'var',
            required: false
        },
        treatment: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        populate: function populate() {
            var isRate = (this.treatment || '').includes('treatment_1');
            var headerType = isRate ? 'RateInline' : 'Currency';

            this.conversionTitle = 'currencyOptions.bfxConversionHeader' + headerType;
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"currency-conversion-container\" content>\n    <h2 class=\"sectionTitle currency-conversion-title\"\n        data-test-id=\"inline-conversion-header\">\n        {{ content(conversionTitle) }}\n    </h2>\n\n    <xo-currency-conversion-options\n        card=\"card\"\n        token=\"token\"\n        treatment=\"treatment\"\n        is-pre-plan=\"true\">\n    </xo-currency-conversion-options>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/contentUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCurrencyFrom = exports.getCurrencyTo = exports.getDccVendorExchange = exports.getDccPPExchange = exports.getDccPPTotal = exports.getDccVendorTotal = exports.getDccPPRate = exports.getVendorRateLabel = exports.getPPRateLabel = exports.getDccTitle = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var getDccTitle = function getDccTitle(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccTitleTreatment2' : 'currencyOptions.dccTitle';
}; /* eslint-disable no-arrow-condition, no-confusing-arrow */


var getPPRateLabel = function getPPRateLabel(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccPPDescTreatment1' : 'currencyOptions.dccPPDesc';
};

var getVendorRateLabel = function getVendorRateLabel(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccVendorDescTreatment1' : 'currencyOptions.dccVendorDesc';
};

var getDccPPRate = function getDccPPRate(isCountryUS, isEMEA3PLCountry) {
    return isCountryUS ? 'currencyOptions.dccPPRateTreatment1' : 'currencyOptions.dccPPRate' + (isEMEA3PLCountry ? '3PL' : '');
};

var getDccVendorTotal = function getDccVendorTotal(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccVendorTotalTreatment1' : 'currencyOptions.dccVendorTotal';
};

var getDccPPTotal = function getDccPPTotal(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccPPTotalTreatment1' : 'currencyOptions.dccPPTotal';
};

var getDccPPExchange = function getDccPPExchange(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccPPExchangeTreatment1' : 'currencyOptions.dccPPExchange';
};

var getDccVendorExchange = function getDccVendorExchange(isCountryUS) {
    return isCountryUS ? 'currencyOptions.dccVendorExchangeTreatment1' : 'currencyOptions.dccVendorExchange';
};

var getCurrencyTo = function getCurrencyTo(isCountryUS, conversion) {
    if (isCountryUS) {
        return conversion.to_amount_forex;
    }

    return (0, _squid.truncateCurrencyConversionString)({
        fullString: conversion.to,
        amount: conversion.to_amount,
        amountForex: conversion.to_amount_forex
    });
};

var getCurrencyFrom = function getCurrencyFrom(isCountryUS, conversion) {
    if (isCountryUS) {
        return '1';
    }

    return (0, _squid.truncateCurrencyConversionString)({
        fullString: conversion.from,
        amount: conversion.from_amount,
        amountForex: conversion.from_amount_forex
    });
};

exports.getDccTitle = getDccTitle;
exports.getPPRateLabel = getPPRateLabel;
exports.getVendorRateLabel = getVendorRateLabel;
exports.getDccPPRate = getDccPPRate;
exports.getDccVendorTotal = getDccVendorTotal;
exports.getDccPPTotal = getDccPPTotal;
exports.getDccPPExchange = getDccPPExchange;
exports.getDccVendorExchange = getDccVendorExchange;
exports.getCurrencyTo = getCurrencyTo;
exports.getCurrencyFrom = getCurrencyFrom;


_squid.truncateCurrencyConversionString;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _contentUtils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/contentUtils.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionLightboxOptions', {
    tag: 'xo-currency-conversion-lightbox-options',

    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        openModal: {
            type: 'var',
            required: false
        },
        updateConversionSelection: {
            type: 'var',
            required: false
        },
        isBuyerFxPxp: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            // Set conversion information
            this.conversionOptions = _squid.$config.currencyConversion.options;
            this.models.ppconversion = this.conversionOptions.PAYPAL;

            this.conversion = this.models.checkoutSession.get('plan.conversion');
            this.paypalConversionTotal = this.models.checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');

            var unformattedAmount = this.models.checkoutCart.get('purchase.amounts.total.amount');
            var merchantCurrencyCode = this.models.checkoutCart.get('purchase.amounts.total.currency_code');

            this.merchantTotal = (0, _squid.formatCurrency)(unformattedAmount, merchantCurrencyCode, false);

            var isEMEA3PLCountry = _squid.$util.getProperty(_squid.$locale.metadata, 'localization.isEMEA3PLCountry', { 'default': false });

            // Content for non Buyer FX phase 2 is different for the US.
            // The US uses content from Buyer FX phase 1 as the control.
            var isCountryUS = _squid.$locale.country === 'US';

            // Get content keys
            this.dccTitle = (0, _contentUtils.getDccTitle)(isCountryUS);
            this.ppRateLabel = (0, _contentUtils.getPPRateLabel)(isCountryUS);
            this.dccPPRate = (0, _contentUtils.getDccPPRate)(isCountryUS, isEMEA3PLCountry);
            this.vendorRateLabel = (0, _contentUtils.getVendorRateLabel)(isCountryUS);
            this.dccPPTotal = (0, _contentUtils.getDccPPTotal)(isCountryUS);
            this.dccPPExchange = (0, _contentUtils.getDccPPExchange)(isCountryUS);
            this.dccPPExchangeOptions = {
                buyerCurrency: this.conversion.from_code,
                currencyFrom: (0, _contentUtils.getCurrencyFrom)(isCountryUS, this.conversion),
                currencyTo: (0, _contentUtils.getCurrencyTo)(isCountryUS, this.conversion),
                sellerCurrency: this.conversion.to_code
            };
            this.dccVendorExchange = (0, _contentUtils.getDccVendorExchange)(isCountryUS);

            // LATAM countries have unique disclosure requirements for vendor option
            this.dccVendorTotal = (0, _contentUtils.getDccVendorTotal)(isCountryUS);

            // Open the interstitial
            this.openModal();
        }
    },

    actions: {
        onConversionOptionChange: function onConversionOptionChange() {
            // For post-plan conversion we need to update the chosen conversion
            // selection in the guest currency conversion interstitial component
            this.updateConversionSelection(this.models.ppconversion);

            // We don't want to log Buyer FX information to FPTI
            // for countries not incldued in the PXP
            if (this.isBuyerFxPxp) {
                /**
                 * FPTI event #4 & #6 for Buyer FX guest experience
                 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                 */
                _logger.$logger.info('checkout_fpti', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'changed_currency_conversion_post_plan',
                    currency_conversion_selected: this.models.ppconversion,
                    currency_conversion_from_curr: this.conversion.from_code,
                    currency_conversion_to_curr: this.conversion.to_code,
                    currency_conversion_spread: this.conversion.spread
                });
            }
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.formatCurrency;

_squid.$util;

_squid.$config;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_logger.$logger;

_contentUtils.getDccTitle;

_contentUtils.getPPRateLabel;

_contentUtils.getVendorRateLabel;

_contentUtils.getDccPPRate;

_contentUtils.getDccVendorTotal;

_contentUtils.getDccPPTotal;

_contentUtils.getDccPPExchange;

_contentUtils.getDccVendorExchange;

_contentUtils.getCurrencyTo;

_contentUtils.getCurrencyFrom;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <h1 class=\"alpha\" data-test-id=\"conversion-title\">{{ content(dccTitle) }}</h1>\n\n    <ul class=\"conversionOptions\">\n        <p class=\"merchantPrice\"\n            ng-bind-html=\"htmlContent('currencyOptions.merchPrice', {transactionTotal: merchantTotal})\">\n        </p>\n        <li class=\"conversionOption\">\n            <div class=\"radioButton\">\n                <input\n                    type=\"radio\"\n                    ng-model=\"models.ppconversion\"\n                    name=\"ppconversion\"\n                    id=\"conversionPayPal\"\n                    ng-change=\"actions.onConversionOptionChange()\"\n                    value=\"{{conversionOptions.PAYPAL}}\"/>\n                <label\n                    for=\"conversionPayPal\"\n                    data-test-id=\"conversion-paypal-label\">\n                    {{ content(ppRateLabel, { buyerCurrency: conversion.from_code }) }}\n                </label>\n            </div>\n            <ul data-test-id=\"conversion-paypal-disclaimers\">\n                <li class=\"dccDetails\"\n                    ng-bind-html=\"htmlContent(dccPPExchange, dccPPExchangeOptions)\">\n                </li>\n                <li class=\"conversionDate\" ng-if=\"isPrePlanVal\">\n                    {{ content('currencyOptions.conversionDate', {date: conversion.date}) }}\n                </li>\n                <li class=\"spread\"\n                    ng-bind-html=\"htmlContent(dccPPRate, {rate: conversion.spread})\">\n                </li>\n                <li class=\"ppConversionTotal\"\n                    ng-bind-html=\"htmlContent(dccPPTotal, {total: paypalConversionTotal})\">\n                </li>\n            </ul>\n        </li>\n        <li class=\"conversionOption\">\n            <div class=\"radioButton\">\n                <input\n                    type=\"radio\"\n                    ng-model=\"models.ppconversion\"\n                    name=\"ppconversion\"\n                    id=\"conversionVendor\"\n                    ng-change=\"actions.onConversionOptionChange()\"\n                    value=\"{{conversionOptions.VENDOR}}\"/>\n                <label\n                    for=\"conversionVendor\"\n                    data-test-id=\"conversion-vendor-label\">\n                    {{ content(vendorRateLabel, { sellerCurrency: conversion.to_code }) }}\n                </label>\n            </div>\n            <ul data-test-id=\"conversion-vendor-disclaimers\">\n                <li class=\"dccDetails\"\n                    ng-if=\"!showLATAMDisclosure\"\n                    ng-bind-html=\"htmlContent(dccVendorExchange)\">\n                </li>\n                <li class=\"dccDetails\" ng-if=\"showLATAMDisclosure\">\n                    <b>{{ content('currencyOptions.exchangeRate') }}</b> {{ content('currencyOptions.dccVendorRateNonVisa') }}\n                </li>\n                <li class=\"ppConversionTotal\" ng-bind-html=\"htmlContent(dccVendorTotal)\"></li>\n            </ul>\n        </li>\n        <li class=\"nonVisaDCCTaxDisclosureLATAM\" ng-if=\"showLATAMDisclosure\">\n            {{ content('currencyOptions.dccCommonRateNonVisa') }}\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.logBuyerFxFpti = exports.logBuyerFxFptiEvent7 = exports.logBuyerFxFptiEvent3 = exports.isConversionChangeableForCardType = exports.getForcedVendorCards = exports.getForcedPayPalCards = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var getFromCode = function getFromCode() {
    return _squid.$util.getProperty(_squid.$locale, 'metadata.currency.code');
};
var getToCode = function getToCode(purchase) {
    return _squid.$util.getProperty(purchase, 'amounts.total.currency_code');
};
var getForcedCards = function getForcedCards(type) {
    return _squid.$util.getProperty(_squid.$config, 'currencyConversion.cards.forced' + type, { 'default': [] });
};

var getForcedPayPalCards = exports.getForcedPayPalCards = function getForcedPayPalCards() {
    return getForcedCards('PayPal');
};

var getForcedVendorCards = exports.getForcedVendorCards = function getForcedVendorCards() {
    return getForcedCards('Vendor');
};

var isConversionChangeableForCardType = exports.isConversionChangeableForCardType = function isConversionChangeableForCardType(type) {
    return ![].concat(getForcedPayPalCards(), getForcedVendorCards()).includes(type);
};

/**
 * FPTI event #3 for Buyer FX guest experience
 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
 */
var logBuyerFxFptiEvent3 = exports.logBuyerFxFptiEvent3 = function logBuyerFxFptiEvent3(purchase) {
    _logger.$logger.info('checkout_fpti', {
        from: 'CURRENCY_CONVERSION',
        to: 'prepare_currency_conversion_post_plan',
        conversion_type: 'VENDOR',
        is_conversion_shown: 0, // 0 b/c we won't be showing conversion options
        currency_conversion_from_curr: getFromCode(),
        currency_conversion_to_curr: getToCode(purchase),
        currency_conversion_spread: 'N/A',
        locale: _squid.$locale.country
    });
};

/**
 * FPTI event 7 for Buyer FX DCC - PRE-PLAN MULTISTEP
 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
 */
var logBuyerFxFptiEvent7 = exports.logBuyerFxFptiEvent7 = function logBuyerFxFptiEvent7() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$card = _ref.card,
        card = _ref$card === undefined ? {} : _ref$card,
        isConversionChangeable = _ref.isConversionChangeable,
        isSignup = _ref.isSignup,
        hasPrePlanData = _ref.hasPrePlanData,
        purchase = _ref.purchase;

    var _card$currencyConvDat = card.currencyConvData;
    _card$currencyConvDat = _card$currencyConvDat === undefined ? {} : _card$currencyConvDat;
    var from_code = _card$currencyConvDat.from_code,
        to_code = _card$currencyConvDat.to_code,
        spread = _card$currencyConvDat.spread,
        type = card.type;

    /**
     * We initially set the selection to `card.ppconversion`, which is the choice
     * the user selected when they were shown the conversion options. There are
     * two scenarios we need to adjust for, which are handled by the conditional
     * statement below.
     */

    var selection = card.ppconversion;

    /**
     * Adjustment scenario 1
     * Conversion is changeable, mode is `signup` and we don't have pre-plan data
     * In this case we force the vendor rate and forgo the conversion fee so that
     * there is as little friction as possible for a user that is in the process of
     * signing up.
     */
    if (isConversionChangeable && isSignup && !hasPrePlanData) {
        selection = 'VENDOR';

        /**
         * Adjustment scenario 2
         * If conversion is not changeable we need to check if the card type should be
         * forced to the PayPal conversion rate. If not, use vendor
         */
    } else if (!isConversionChangeable) {
        selection = getForcedPayPalCards().includes(type) ? 'PAYPAL' : 'VENDOR';
    }

    _logger.$logger.info('checkout_fpti', {
        from: 'CURRENCY_CONVERSION',
        to: 'finalize_currency_conversion',
        currency_conversion_selected: selection,
        currency_conversion_from_curr: from_code || getFromCode(),
        currency_conversion_to_curr: to_code || getToCode(purchase),
        currency_conversion_spread: spread || 'N/A'
    });
};

var logBuyerFxFpti = exports.logBuyerFxFpti = function logBuyerFxFpti() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        hasPrePlanData = _ref2.hasPrePlanData,
        isSignup = _ref2.isSignup,
        _ref2$card = _ref2.card,
        card = _ref2$card === undefined ? {} : _ref2$card,
        purchase = _ref2.purchase;

    var type = card.type;

    var isConversionChangeable = isConversionChangeableForCardType(type);

    /**
     * If we don't have pre-plan data because the pre-plan API failed or becuse
     * the user is seeing the control and not one of the treatments and
     * the mode is signup and the card the chageable then we need to log event
     * 3 here. This is because for signup use cases the user won't see the
     * post-plan interstitial which is where event 3 is logged when the pre-plan
     * API fails or when the user is seeing the control experience for the guest
     * use case.
     */
    if (!hasPrePlanData && isSignup && isConversionChangeable) {
        logBuyerFxFptiEvent3(purchase);
    }

    if (isSignup || hasPrePlanData || !isConversionChangeable) {
        logBuyerFxFptiEvent7({
            card: card,
            isConversionChangeable: isConversionChangeable,
            isSignup: isSignup,
            hasPrePlanData: hasPrePlanData,
            purchase: purchase
        });
    }
};

_logger.$logger;

_squid.$config;

_squid.$locale;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _index6 = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _index7 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");

var _index8 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _fiApis = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

var _index9 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index10 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index11 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _sticky = __webpack_require__("../node_modules/xo-guest-components/src/guest/sticky.js");

var _util2 = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");

var _errorHandlerHelper = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js");

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

var _shippingChangeFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js");

var _pageProps = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/pageProps.js");

var _util3 = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/util.js");

var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/template.html");

var _template2 = _interopRequireDefault(_template);

var _index12 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _utils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js");

var _ixoUtils = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/ixoUtils.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/cartChanged/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/3ds/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = _index.$Component.extend('xoOnboardPayment', {
    tag: 'xo-onboard-payment',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        mode: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        paymentMethod: {
            type: 'var',
            required: false
        },
        singleStepModel: {
            type: 'var',
            required: false
        },
        buttonParams: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                auth: _index9.$AuthModel.instance(this.token).retrieve(),
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve()
            };
        },
        shippingRule: function shippingRule(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                if (models.checkoutAppData.is_snt_supported()) {
                    return {
                        profileRulesSummary: _index5.$ShippingRuleSummaryModel.instance(_this.token).retrieve({
                            params: {
                                merchant_id: models.payee.merchant.id,
                                currency_code: models.checkoutCart.purchase.amounts.total.currency_code
                            }
                        })
                    };
                }
            });
        },
        merchantPreferences: function merchantPreferences(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    model: _index12.$MerchantPreferenceModel.instance(models.payee.merchant.id).retrieve()
                };
            });
        },
        sepaExperiment: function sepaExperiment() {
            var isSepaOverlayRequired = this.isUnbranded && this.onboard.fiMode === 'bank';

            if (isSepaOverlayRequired) {
                return {
                    sepaOverlay: (0, _squid.$pxp)('XO_XOONBOARDING_SEPA_OVERLAY', { 'ctx.COUNTRY': _index.$locale.country }, 'XO_XOONBOARDING_SEPA_OVERLAY_TEST')
                };
            }
        },
        experiments: function experiments() {
            var flow = this.flags.wpsFlow ? 'wps' : 'ec';

            return {
                accountExistsPXP: (0, _squid.$pxp)('xo_xoon_account_exists_toggle_' + flow, { 'ctx.COUNTRY': _index.$locale.country }, 'xo_xoon_account_exists_toggle_' + flow + '_treatment')
            };
        },
        teslaAddBank: function teslaAddBank() {
            return {
                teslaAddBankEXP: (0, _squid.$elmo)('xo_xoon_tesla_add_bank', { 'ctx.COUNTRY': _index.$locale.country }, '(xo_xoon_jp_add_bank_treatment)(.*)')
            };
        },
        indiaWhitelistPxp: function indiaWhitelistPxp(resolvers) {
            var _this2 = this;

            return resolvers.models.then(function (models) {
                // show address less on-boarding experience only for EC IN whitelisted merchants.
                var eligible = !models.checkoutAppData.is_wps_flow() && !models.checkoutInputData.isEbayTxn() && !models.checkoutAppData.isInvoiceFlow() && !models.checkoutAppData.is_wps_subscription_flow() && !models.checkoutCart.isWalletTokenization();

                if (_index.$locale.country === 'IN' && eligible) {
                    var _ref = models.payee || {},
                        _ref$merchant = _ref.merchant;

                    _ref$merchant = _ref$merchant === undefined ? {} : _ref$merchant;
                    var id = _ref$merchant.id;

                    return (0, _squid.$pxp)('xo_xoon_addressless_in_whitelist', { 'uid': id }, '(xo_xoon_addressless_in_whitelist_)(.*)').then(function (result) {
                        if (result && result.treatment_name.includes('xo_xoon_addressless_in_whitelist_test')) {
                            // Hide Billing Address and DOB fields when merchant is whitelisted
                            _this2.flags.whiteListedIndiaMerchant = true;
                            _logger.$logger.info('test_whitelisted_india_merchant');
                        } else {
                            return (0, _squid.$pxp)('xo_xoon_addressless_in_ramp', { 'ctx.MID': id }, '(xo_xoon_addressless_in_ramp_)(.*)').then(function (rampResult) {
                                if (rampResult && rampResult.treatment_name.includes('xo_xoon_addressless_in_ramp_test')) {
                                    // Hide Billing Address and DOB fields when merchant is whitelisted
                                    _this2.flags.whiteListedIndiaMerchant = true;
                                    _logger.$logger.info('test_ramped_india_merchant');
                                }
                            });
                        }
                    });
                }
            });
        },
        bypassAddressVerificationExperience: function bypassAddressVerificationExperience() {
            // will only have treatment when the mode is guestonly
            return {
                bypassAddressVerificationExp: (0, _squid.$elmo)('xo_xoon_skip_avs', { 'ctx.COUNTRY': _index.$locale.country }, 'Trmt_xo_xoon_skip_avs')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this3 = this;

            this.locale = _index.$locale;
            this.currentState = _uiRouter.$state.current.name;
            this.flags = {
                shipToBilling: true,
                allowEditShipping: true,
                showSingleAddress: false,
                showShippingLabel: true,
                cupDetected: false,
                hideShippingAddress: false,
                allowPayWithSnT: false,
                allowSnTCall: true,
                instantUpdateShippingRegionSupported: true,
                freeReturnShippingOptInFlowApplicable: false,
                freeReturnShippingOptInActiveFlow: false,
                showRedirectWarningPrompt: false,
                titleSubtitlePxpTreatment: false,
                showCartChanged: false,
                whiteListedIndiaMerchant: false
            };

            this.sepa = {
                sepaGuestAgree: false,
                sepaAgree: false,
                show: false
            };

            // If US, then show new e-sign compliance experience
            // Submit button text changes and show return to merchant msg above button
            // with user action 'continue'
            if (this.locale.country === 'US') {
                this.showNewSignupComplianceExp = true;
            }

            var app_int_type = _index10.$DeviceInfo.isWebView() ? 'WebView' : _index10.$DeviceInfo.getAppIntegrationType();

            // fpti log for app integration type
            _logger.$logger.info('checkout_fpti', {
                app_int_type: app_int_type
            });

            _logger.$logger.info('checkout_fpti', {
                page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
            });

            // set the china upop flag on event heard
            this.$watch('onboard.card.type', function (newVal) {
                _this3.flags.cupDetected = newVal === 'CUP';
            });

            $(document).on('click', '#pomaLegalterms a', function () {
                _angular.$rootScope.$broadcast('trackInput', {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:',
                    transition: $(_this3).text().replace(/\s/g, '_')
                });
            });

            // This is needed in Sepa directive
            this.sectionElement = '#singlePagePayment';

            this.countries = function () {
                return _index.$locale.content.countryList;
            };

            var triggerPageDesignFPTILog = function triggerPageDesignFPTILog() {
                var pageContext = 'Full-context';

                if (_angular.$rootScope.miniBrowser) {
                    pageContext = 'In-context';
                }

                _logger.$logger.info('checkout_fpti', {
                    'design': pageContext
                });
            };
            // Log Initial Page Design

            triggerPageDesignFPTILog();
            // Trigger Design FPTI Log on Page Design Change
            _angular.$rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);

            var getPresetPaymentMethod = function getPresetPaymentMethod() {
                var paymentMethod = _this3.paymentMethod && _this3.paymentMethod.toLowerCase();

                if (!paymentMethod || paymentMethod !== 'bank' && paymentMethod !== 'card') {
                    return;
                }

                return paymentMethod === 'bank' ? 'bank' : 'card';
            };

            var getFundingSource = function getFundingSource() {
                var fundingSource = void 0;

                if (_index.$config.deploy.isLocal() || _index.$config.deploy.isStage()) {
                    // Both query param (fundingSource) and post message(window.xprops.fundingSource) are present
                    // in SPB(Smart Payment Button) integration. but post message(window.xprops.fundingSource)
                    // will not be availabe in local testing, so passing query param in the url mimics
                    // the same.
                    fundingSource = _index.$util.param('fundingSource');
                }

                if (window.xprops && window.xprops.fundingSource) {
                    fundingSource = window.xprops.fundingSource;
                }

                return fundingSource;
            };

            this.showFISwitchTab = function () {

                // If the experience is tesla-add-bank, then show the FI toggle.
                if (_this3.teslaAddBankEXP) {
                    return true;
                }

                var fundingSource = getFundingSource();

                if (getPresetPaymentMethod() || fundingSource === 'elv') {
                    return false;
                }

                return (0, _index.$feature)('fiSwitchTab', false, _index.$locale.country);
            };

            this.getDefaultFIMode = function () {
                var presetPayMentMethod = getPresetPaymentMethod();

                if (presetPayMentMethod) {
                    return presetPayMentMethod;
                }

                // Check to see if it's Tesla Add Bank experience. If so,
                // The default FI will depend on the treatments A,B or control

                if (_this3.teslaAddBankEXP) {
                    return _this3.teslaFIDefault;
                }

                if (_index.$locale.country === 'DE') {
                    var fundingSource = getFundingSource();
                    var allowRevisedEpmCallJson = _index.$config.allowRevisedEpmCall;
                    var allowSpb = allowRevisedEpmCallJson[_index.$locale.country] || allowRevisedEpmCallJson['DEFAULT'];

                    // defaulting to card tab for SPB(Smart Payment Button) integration whenever post message
                    // passing 'card' for DE.
                    if (allowSpb && fundingSource === 'card') {
                        return 'card';
                    }
                    // Default tab for branded DE transaction is Bank
                    return 'bank';
                }
                return 'card';
            };

            this.onboard = new _index7.$OnboardModel({
                user: _index7.$OnboardUserModel.instance(this.token, {
                    country: _index.$locale.country,
                    countryOfResidence: _index.$locale.country,
                    nationality: _index.$locale.country
                }),

                card: new _index8.$CardModel(),

                bank: new _index8.$BankModel(),

                fiMode: this.getDefaultFIMode(),

                billing_address: _index8.$BillingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),
                shipping_address: _index2.$ShippingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),

                phone: new _index7.$OnboardPhoneModel(),

                shipping_address_validation: false,
                billing_address_present: false,
                poma_flow: false,
                frs_optin_flow_applicable: false
            });

            this.onboard.card.ppconversion = 'PAYPAL';
            this.getSelectedCurrencyCode = function (selection) {
                var _onboard$card$currenc = _this3.onboard.card.currencyConvData;
                _onboard$card$currenc = _onboard$card$currenc === undefined ? {} : _onboard$card$currenc;
                var from_code = _onboard$card$currenc.from_code,
                    to_code = _onboard$card$currenc.to_code;


                _this3.selectedCurrency = selection === 'PAYPAL' ? from_code : to_code;
            };
            this.$watch('onboard.card.ppconversion', function (newVal) {
                _logger.$logger.info('conversion_selection_changed_to_' + newVal);
                _this3.getSelectedCurrencyCode(newVal);
            });
            this.setBuyerFxFlag = function (_ref2) {
                var treatment = _ref2.treatment,
                    hasBuyerFxPrePlanData = _ref2.hasBuyerFxPrePlanData;

                if (treatment) {
                    _this3.flags.buyerFxTreatment = treatment;
                }

                _this3.flags.hasBuyerFxPrePlanData = hasBuyerFxPrePlanData;
            };
        },
        populate: function populate() {
            var _this4 = this;

            var determineTeslaFIMode = function determineTeslaFIMode(type) {
                if (type === 'xo_xoon_jp_add_bank_treatment') {
                    return 'bank';
                } else {
                    return 'card';
                }
            };

            var checkTeslaEligbility = function checkTeslaEligbility() {
                var _teslaAddBank$teslaAd = _this4.teslaAddBank.teslaAddBankEXP,
                    teslaAddBankEXP = _teslaAddBank$teslaAd === undefined ? {} : _teslaAddBank$teslaAd;
                var teslaAddBankTreatment = teslaAddBankEXP.treatment_name;

                _this4.teslaAddBankEXP = teslaAddBankTreatment && teslaAddBankTreatment.includes('xo_xoon_jp_add_bank_treatment');

                // If it's teslaAddBankEXP treatment is successful, then change the default FI based on treatment returned.
                if (_this4.teslaAddBankEXP) {
                    _this4.teslaFIDefault = determineTeslaFIMode(teslaAddBankTreatment);
                    _this4.onboard.fiMode = _this4.teslaFIDefault;
                }
            };

            checkTeslaEligbility();

            this.getToggleKeys = (0, _pageProps.getFItoggleContentKeys)(this.teslaAddBankEXP, this.teslaFIDefault);

            // We show JP-add bank experience only when the following conditions meet:
            // A) If ELMO passes. If ELMO fails, we don't even show the toggle.
            // B) If the flow is a bank flow.

            this.showTeslaAddBankFlow = function () {
                return _this4.teslaAddBankEXP && _this4.onboard.fiMode === 'bank';
            };

            this.ixoModel = {
                ixoShippingMethods: null,
                ixoSelectedShippingMethod: null,

                updateIxoShippingMethods: function updateIxoShippingMethods() {
                    return _angular.$q.all([(0, _ixoUtils.retrieveIxoShippingMethods)(_this4.models.checkoutAppData), (0, _ixoUtils.retrieveIxoSelectedShippingMethod)(_this4.models.checkoutAppData)]).then(function (_ref3) {
                        var shippingMethods = _ref3[0],
                            selectedShippingMethod = _ref3[1];

                        _this4.ixoModel.ixoSelectedShippingMethod = selectedShippingMethod;
                        _this4.ixoModel.ixoShippingMethods = shippingMethods;
                    });
                },

                updateIxoSelectedShippingMethod: function updateIxoSelectedShippingMethod(shippingMethod) {
                    // Update the selected method in Checkout.js,
                    // Re-fetch shipping methods and selected method from Checkout.js
                    // Re-populate this object
                    return (0, _ixoUtils.updateIxoSelectedShippingMethod)(_this4.models.checkoutAppData, shippingMethod).then(function () {
                        return (0, _angular.$timeout)(function () {
                            _this4.ixoModel.ixoSelectedShippingMethod = shippingMethod;
                        });
                    });
                }
            };

            this.ixoModel.updateIxoShippingMethods();

            // tracking shipping methods
            if (this.ixoModel.ixoShippingMethods) {
                _logger.$logger.info('incontext_shipping_options_exist');
            }

            // Needed to show custom description sent by merchant in Billing Agreement flow
            this.billingAgreementMerchantMsg = this.models.checkoutCart.getBillingDescription();

            // Log to FPTI to indicate the page has been rendered
            _logger.$logger.info('checkout_fpti', {
                from: this.mode === 'guest' ? 'GUEST_XO' : 'SIGNUP',
                to: 'prepare_' + (this.mode === 'guest' ? 'guest_xo' : 'signup')
            });

            if (this.shippingRule && this.shippingRule.profileRulesSummary) {
                this.flags.wps_SnT_flow = this.shippingRule.profileRulesSummary.isSnTEnabled;
            }

            // pre-fill user first name and last name.
            // override happens at handlePrefillShippingAndBillingAddress if merchant passing
            // shipping address during cart creation.
            this.onboard.user.first_name = this.models.checkoutCart.get('payer.first_name');
            this.onboard.user.last_name = this.models.checkoutCart.get('payer.last_name');

            var setAllowShipToBilling = function setAllowShipToBilling(allow) {
                // Toggle checkbox
                _this4.flags.disallowShipToBilling = !allow;
                // Show/Hide shipping address section
                _this4.flags.shipToBilling = allow;
            };

            var checkProcessorDecline = function checkProcessorDecline() {
                var processorDeclined = _this4.models.checkoutAppData.get('flags.processor_declined');

                if (processorDeclined) {
                    _this4.errorMessage = {
                        msgs: [(0, _squid.$renderContent)('payment.processorDeclineMemberNoFIGeneric')],
                        type: 'warning'
                    };
                }
            };
            var checkLatinumRedirect = function checkLatinumRedirect() {
                if (_squid.$meta.query && _squid.$meta.query.latinumRedirect) {
                    _this4.topErrorMessage = {
                        msgs: [(0, _squid.$renderContent)('login.latinumNotUsed', { alternativeFunding: _squid.$meta.query.latinumRedirect })],
                        type: 'info'
                    };
                }
            };

            var setChangeShippingCountryAlertMsg = function setChangeShippingCountryAlertMsg() {
                var countryName = (0, _squid.$renderContent)('shippingCountry.' + _this4.merchantCountry);
                var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', {
                    shippingCountry: countryName
                });

                _this4.changeShippingCountryAlert = {
                    msgs: [infoMessage],
                    type: 'info'
                };
            };

            // pre-populate shipping and billing address
            var updateShippingAndBillingAddress = function updateShippingAndBillingAddress(shippingAddress, billingAddress) {
                // Detect invalid length country codes in which case we invalidate the country code.
                // A default value of $locale.country will subsequently be picked up for invalidated country codes in the model creation.
                if (shippingAddress && shippingAddress.country_code && shippingAddress.country_code.length !== 2) {
                    shippingAddress.country_code = undefined;
                }

                if (billingAddress && billingAddress.country_code && billingAddress.country_code.length !== 2) {
                    billingAddress.country_code = undefined;
                }

                // NOTE: this function modifies params.state value to uppercase
                (0, _util3.sanitizeStateFields)(shippingAddress, billingAddress);

                // pre-fill billing address with shipping address
                _this4.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this4.token, {
                    country: shippingAddress.country_code || _index.$locale.country
                }, shippingAddress);

                // pre-fill provided billing address
                _this4.onboard.billing_address = _index8.$BillingAddressModel.create(_this4.token, {
                    country: billingAddress.country_code || _index.$locale.country
                }, billingAddress);
            };

            var showGenericError = function showGenericError(code) {
                return function () {
                    _uiRouter.$state.go('checkout.genericError', { code: code });
                };
            };
            // handle billing and shipping address prefill scenarios
            var handlePrefillShippingAndBillingAddress = function handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress) {
                // if users already had performed planning/post on xo session. Don't prefill the address
                // due to security concerns.
                // buyer_set_in_session attribute indicates that post on xo session/planning has been invoked
                var supplementary_data = _this4.models.checkoutCart.supplementary;

                if (supplementary_data && supplementary_data.buyer_set_in_session) {
                    return;
                }
                // if both shipping and billing addresses are provided
                if (allowPrefillShippingAddress && prefilledAddress && prefilledBillingAddress) {
                    updateShippingAndBillingAddress(prefilledAddress, prefilledBillingAddress);

                    // uncheck ship to billing checkbox
                    _this4.flags.shipToBilling = false;
                } else if (allowPrefillShippingAddress && prefilledAddress) {
                    // if only shipping address is provided

                    // pre-fill user first name and last name
                    _this4.onboard.user.first_name = prefilledAddress.first_name;
                    _this4.onboard.user.last_name = prefilledAddress.last_name;

                    updateShippingAndBillingAddress(prefilledAddress, prefilledAddress);
                    if (!_this4.flags.allowEditShipping) {
                        _this4.flags.shipToBilling = false;
                    }
                } else if (prefilledBillingAddress) {
                    // if only billing address is provided
                    updateShippingAndBillingAddress(prefilledBillingAddress, prefilledBillingAddress);
                }
            };

            // remove this upon oas ramp completion
            this.onboard.testParams = {
                oas: _index.$util.param('oas'),
                cardCandidate: _index.$util.param('cardCandidate')
            };

            this.$on('localeChange', function () {
                _this4.onboard.fiMode = _this4.getDefaultFIMode();
                _this4.onboard.billing_address.country = _index.$locale.country;
                _this4.onboard.user.country = _index.$locale.country;
                _this4.onboard.user.nationality = _index.$locale.country;
                _this4.setBackButtonForWebview();

                if (_this4.flags.disableChangeShippingCountry) {
                    if (_this4.flags.allowEditShipping) {
                        setAllowShipToBilling(_index.$locale.country === _this4.merchantCountry);
                    }
                } else {
                    _this4.onboard.shipping_address.country = _index.$locale.country;
                }
            });

            this.$on('contentChange', function () {
                if (_this4.flags.disableChangeShippingCountry) {
                    setChangeShippingCountryAlertMsg();
                }
            });

            this.$on('signupClickedTimerStarted', function (event, time) {
                _this4.signupClickedStartTime = time;
            });

            this.hasDialingCodeOverride = _util2.hasDialingCodeOverride;
            this.showContactInfo = function () {
                return _this4.hasDialingCodeOverride() || _this4.flags.allowChoice;
            };

            this.displayEmailInContactInfo = function () {
                if (!(0, _util2.hasDialingCodeOverride)()) {
                    return true;
                }

                var showingEmailInSignup = !_this4.flags.allowChoice;

                if (!showingEmailInSignup) {
                    return true;
                }

                return false;
            };

            this.redirect = function () {
                _logger.$logger.info('basl_throttle_test_login');
                (0, _squid.$dispatch)('hermes', {
                    hermesLoginRedirect: 'xoon',
                    token: _this4.token,
                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                    'country.x': _index.$locale.country
                });
            };

            this.$watch('flags.shipToBilling', function (shipToBilling) {
                if (!shipToBilling && _this4.flags.allowEditShipping) {
                    $.each(_this4.onboard.billing_address, function (key, val) {
                        if (angular.isString(_this4.onboard.billing_address[key]) && !_this4.onboard.shipping_address[key]) {
                            _this4.onboard.shipping_address[key] = val;
                        }
                    });

                    _this4.onboard.shipping_address.first_name = _this4.onboard.shipping_address.first_name || _this4.onboard.user.first_name;
                    _this4.onboard.shipping_address.last_name = _this4.onboard.shipping_address.last_name || _this4.onboard.user.last_name;
                }
            });

            // Format address to display when store pick is selected
            var formatAddress = function formatAddress(address) {
                var COMMA = ', ';
                var SPACE = ' ';

                function prefix(str, prefixStr) {
                    if (str) {
                        return (prefixStr ? prefixStr : '') + str;
                    }
                    return '';
                }

                var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
                var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
                var displayLine3 = address.country ? prefix(address.country) : '';

                return {
                    displayLine1: displayLine1,
                    displayLine2: displayLine2,
                    displayLine3: displayLine3
                };
            };

            var storePickUpSelected = _angular.$rootScope.$on('store_pick_up_selected', function (event) {
                var addressType = _this4.flags.shipToBilling ? 'billing_address' : 'shipping_address';

                _this4.shippingAddress = formatAddress(_this4.onboard[addressType]);
            });

            this.$on('$destroy', storePickUpSelected);

            var showErrorFields = _angular.$rootScope.$on('showErrorFields', function (event) {
                _this4.toggleAddressFieldsValidation(true);
            });

            this.$on('$destroy', showErrorFields);

            var hideErrorFields = _angular.$rootScope.$on('hideErrorFields', function (event) {
                _this4.toggleAddressFieldsValidation(false);
            });

            this.$on('$destroy', hideErrorFields);

            // useraction flag
            var useraction = this.models.checkoutAppData.useraction();

            this.flags.commit = useraction && useraction.toLowerCase() === 'commit';
            _logger.$logger.info('checkout_fpti', {
                billing_page_button_text: this.flags.commit ? 'paynow_y' : 'paynow_n'
            });

            this.flags.wpsFlow = this.models.checkoutAppData.is_wps_flow();

            // show shipping address based on merchant passed in parameter
            this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutAppData.flags.shipping_address_required);

            this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
            if (this.isInstantUpdateFlow) {
                this.trackSntReq = {};
            }

            // flags.allowEditShipping = false, skip saving shipping address validation otherwise don't skip.
            this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);

            // Prefill email from cart
            this.onboard.user.email = this.models.checkoutCart.get('payer.email');

            this.upopConfirmButtonTextKey = (0, _pageProps.upopConfirmButtonTextKey)(this.flags);

            // *** NOTE:
            // PXP was initially intended to be used with login button, but we've opted to use back button
            // page name and treatments still have login in the name though.
            this.flags.backButtonWebview = false;
            this.setBackButtonForWebview = function () {
                if (_index10.$DeviceInfo.isWebView(false)) {
                    var floatThrottle = parseFloat((0, _index.$feature)('webviewBackButtonThrottle', 0, _index.$locale.country));

                    if (isNaN(floatThrottle)) {
                        return;
                    }

                    _this4.flags.backButtonWebview = floatThrottle && (0, _squid.$experiment)('webview_backbutton_throttle', floatThrottle, _angular.$rootScope.token, {}) ? true : false;
                    if (_this4.flags.backButtonWebview) {
                        _logger.$logger.info('BACK_BUTTON_SHOWN_FOR_WEBVIEW');
                    }
                }
            };
            this.setBackButtonForWebview();

            this.landingAbTestCheck = function () {
                /**
                 * Show the login button on xoon when:
                 * - hermes redirects to xoon in xo-landing-router
                 **/
                return _squid.$meta.query && _squid.$meta.query.abTestThrottle === 'xoon' ? true : false;
            };

            /**
             * This function takes in an International number: e.g +491721232312 and returns national number (1721232312)
             * @param {string} formattedPhone
             * @param {string} IntDialingCountryCode
             * @return {string}
             */
            this.getFormattedNationalNumber = function (formattedPhone, IntDialingCountryCode) {
                if (!formattedPhone || !IntDialingCountryCode) {
                    return;
                }

                // Generate clean number by removing empty spaces.
                var cleanPhoneNumber = formattedPhone.replace(/\s/g, '');

                var dailingCode = IntDialingCountryCode[0] === '+' ? IntDialingCountryCode : '+' + IntDialingCountryCode;

                return cleanPhoneNumber.split(dailingCode)[1];
            };

            // Get merchant passed shipping address from either purchase plan or billing agreement plan
            var prefilledAddress = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');

            var prefilledNumber = this.models.checkoutCart.get('purchase.phone_fields') || this.models.checkoutCart.get('billing.phone_fields');

            var useInternationalFormatting = (0, _index.$feature)('useInternationalFormatting', false, _index.$locale.country);

            if (prefilledNumber && prefilledNumber.telephone_country === _index.$locale.country) {
                // If UseInternationalFormatting is enabled, we use griffin's international Number
                // Formatting instead of national formatting. This can be found in feature in config.json
                if (useInternationalFormatting) {
                    this.onboard.phone.telephone = this.getFormattedNationalNumber(prefilledNumber.formatted_phone_number_international, this.onboard.phone.IntDialingCountryCode);
                } else {
                    this.onboard.phone.telephone = prefilledNumber.formatted_phone_number;
                }
                this.onboard.phone.ispreFill = true;
            }

            var allowPrefillShippingAddress = !!prefilledAddress;

            var prefilledBillingAddress = this.models.checkoutCart.get('billing_address');

            this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country', 'US');

            // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
            // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
            // in content keys used in template
            this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
                nonEmptyReturnValue: true
            });

            if ((0, _index.$feature)('supportBlockNonDomesticShipping', false, this.merchantCountry)) {
                this.flags.disableChangeShippingCountry = this.models.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                if (this.flags.disableChangeShippingCountry) {
                    _logger.$logger.info('onboard_block_non_domestic_shipping', {
                        block_non_domestic_shipping: this.flags.disableChangeShippingCountry,
                        allow_change_shipping: this.flags.allowEditShipping,
                        setec_shipping_country_code: prefilledAddress && prefilledAddress.country_code
                    });

                    if (!this.flags.allowEditShipping && prefilledAddress && prefilledAddress.country_code !== this.merchantCountry && prefilledAddress.country_code !== '') {
                        _uiRouter.$state.go('checkout.genericError', {
                            code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                        });
                    }

                    if (prefilledAddress && prefilledAddress.country_code !== this.merchantCountry) {
                        allowPrefillShippingAddress = false;
                    }

                    setChangeShippingCountryAlertMsg();
                    this.onboard.shipping_address.country = this.merchantCountry;

                    // Show shipping address section if user locale is different from merchant country
                    if (this.flags.allowEditShipping && _index.$locale.country !== this.merchantCountry) {
                        setAllowShipToBilling(false);
                    }
                }
            }

            /**
             * Handle Card-Type based Installments e.g. Brazil is card_type based installments,
             * so fetch the installments during page load.
             */
            var handleCardTypeBasedInstallments = function handleCardTypeBasedInstallments() {
                _this4.$watch('singlePagePaymentForm.$valid', function (newVal, oldVal) {
                    var cardModel = _this4.onboard.card;

                    if (newVal && newVal.luhn && newVal.luhn[0].$name === 'cardNumber') {
                        cardModel.valid = false;
                    } else {
                        cardModel.valid = true;
                    }
                });

                _this4.$watch(_this4.onboard.card.type, function (newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;

                    var cardNetwork = void 0;

                    if (newValue && _this4.installments && _this4.installments.length > 0) {
                        _this4.installments.some(function cardCheck(card, index, array) {
                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                                // Card Network Found
                                cardNetwork = card;
                                return true;
                            }
                            return false;
                        });

                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
                            // Card network && installments found
                            if (cardNetwork.installment_options.length === 1) {
                                _this4.singleStepModel.selectedInstallmentData = {
                                    installment_option_selected: cardNetwork.installment_options[0],
                                    preventChange: true
                                };
                            }

                            _this4.singleStepModel.allowInstallments = true;
                        } else {
                            // Card network does not exists Or No installment found
                            _this4.singleStepModel.allowInstallments = false;
                        }
                    } else {
                        _this4.singleStepModel.allowInstallments = false;
                    }
                });
                var installments = _index2.$InstallmentOptionsModel.instance(_this4.token);

                installments.save({
                    data: {
                        payee: _this4.models.payee,
                        checkoutCart: _this4.models.checkoutCart,
                        checkoutAppData: _this4.models.checkoutAppData
                    },
                    success: function success(result) {
                        _this4.installments = result.installments;
                    }
                });
            };

            /**
             * Handle Issuer based Installments e.g. Mexico is issuer_based (bank) installments, so fetch the
             * installments after user enters card number
             */
            var handleIssuerBasedInstallments = function handleIssuerBasedInstallments() {
                _this4.cardNumberChanged = function (unformattedCardNumber) {
                    if (unformattedCardNumber && unformattedCardNumber !== _this4.prevCardNumber) {
                        // Make sure the Installments server is hit only once for a cardNumber
                        _this4.prevCardNumber = unformattedCardNumber;
                        var installments = _index2.$InstallmentOptionsModel.instance(_this4.token);

                        installments.save({
                            silent: true,
                            data: {
                                payee: _this4.models.payee,
                                checkoutCart: _this4.models.checkoutCart,
                                checkoutAppData: _this4.models.checkoutAppData,
                                cc: unformattedCardNumber
                            },
                            success: function success(result) {
                                _this4.installments = result;

                                if (result.installment_options && result.installment_options.length > 0) {
                                    _this4.issuerBasedInstallmentsRetrieved = true;

                                    // reset the previously selected installment
                                    _this4.singleStepModel.selectedInstallmentData = undefined;
                                    if (result.installment_options.length === 1) {
                                        _this4.singleStepModel.selectedInstallmentData = {
                                            installment_option_selected: result.installment_options[0],
                                            preventChange: true
                                        };
                                    }

                                    _this4.singleStepModel.allowInstallments = true;
                                } else {
                                    _this4.singleStepModel.allowInstallments = false;
                                }
                            }
                        });
                    }
                };
            };

            // Lookup installments only when amount is greater than zero.
            // for ex: Billing Agreements can create with amount=zero.
            if ((0, _index.$feature)('installments', false, _index.$locale.country) && this.models.checkoutCart.get('purchase.amounts.total.amount', 0) > 0) {
                if ((0, _index.$feature)('issuerBasedInstallments', false, _index.$locale.country)) {
                    // e.g. Mexico is issuer_based (bank) installments, so fetch the installments after user enters card number
                    handleIssuerBasedInstallments();
                } else {
                    // e.g. Brazil is card_type based installments, so fetch the installments during page load.
                    handleCardTypeBasedInstallments();
                }
            }

            this.isInstallmentsVisible = function () {
                if (!_this4.singleStepModel) {
                    return false;
                }
                _this4.singleStepModel.onboard = _this4.onboard;

                var model = _this4.onboard;
                var hasConditionMet = _this4.singleStepModel.allowInstallments && model.card.number && (model.card.valid || _this4.issuerBasedInstallmentsRetrieved);
                var isBilling = _this4.models.checkoutCart.isBilling();

                return !isBilling && hasConditionMet;
            };

            checkProcessorDecline();

            checkLatinumRedirect();

            handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress);

            var experienceInitiator = this.models.checkoutAppData.get('flags.payment_experience_initiator');

            this.onboard.payment_experience_initiator = experienceInitiator;

            this.isApac = function () {
                return _index.$config.apacCountries && _index.$config.apacCountries.indexOf(_this4.locale.country) > -1;
            };

            this.$on('MORSDisplayed', function (event, args) {
                _this4.MORSDisplayed = args;
            });

            this.$on('MORSNotDisplayed', function (event, args) {
                _this4.MORSDisplayed = {};
            });

            var handleCardContingencySignup = function handleCardContingencySignup(errorData) {
                if (_this4.models.checkoutInputData.isEbayTxn()) {
                    (0, _squid.$dispatch)('prox', {
                        action: 'login'
                    });
                } else {
                    // redirect to hermes and we will see add card page
                    var fieldError = errorData && errorData[0] && errorData[0].field;
                    var avsRetry = fieldError === 'billing_address' ? true : false;

                    (0, _squid.$dispatch)('hermes', {
                        redirectToHermes: true,
                        addFIContingency: fieldError ? 'retry' : 'noretry',
                        avsRetry: avsRetry,
                        token: _this4.token,
                        'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                        'country.x': _index.$locale.country
                    });
                }
            };

            var handleCardContingencyGuest = function handleCardContingencyGuest() {
                var msg = void 0;

                if (_this4.models.payee.isGambling()) {
                    msg = _index.$locale.content.get('creditcard.noEligibleFI');
                } else if (_this4.onboard.billing_address.country === 'DE') {
                    if (_this4.onboard.fiMode === 'bank') {
                        delete _this4.onboard.bank;
                        msg = _index.$locale.content.get('creditcard.cannotUseBank');
                        _this4.onboard.fiMode = 'card';
                    } else {
                        msg = _index.$locale.content.get('creditcard.cannotUseCard');
                    }
                } else {
                    msg = _index.$locale.content.get('creditcard.errorInstrumentRefused');
                }

                _this4.errorMessage = {
                    msgs: [msg],
                    type: 'error'
                };
                return _angular.$q.reject()['catch'](angular.noop);
            };

            var handleCardContingency = function handleCardContingency(action) {
                return _this4.flags.mode === 'signup' ? handleCardContingencySignup() : handleCardContingencyGuest();
            };

            var show3DSLightbox = function show3DSLightbox(checkoutSession) {
                var cc_id = checkoutSession.get('resolve_3ds.ccId');
                var plans = checkoutSession.get('plan.sources', null);
                var plan = plans && plans.filter(function (e) {
                    return e.instrument_id === cc_id;
                })[0].amount || null;

                _this4.resolve_3ds_data = {
                    cc_id: cc_id,
                    flow_id: 'HERMES',
                    merchant_id: _this4.models.payee.get('merchant.id'),
                    merchant_country_code: _this4.models.checkoutAppData.get('merchant.merchant_country'),
                    transaction_amount_currency: plan && plan.currency_code,
                    transaction_amount_value: plan && plan.amount

                };
                _this4.launch3DSResolver = true;
            };

            var isDCCEligible = function isDCCEligible(checkoutSession) {
                var isGuest = _this4.flags.mode !== 'signup';
                var hasCurrencyConversion = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');

                // Decides dcc currency conversion popup show/hide
                return isGuest && hasCurrencyConversion;
            };

            /*
             * This function will determine final route of the transaction:
             * 1. return to merchant for all none WPS traffic
             * 2. go to checkout done page for WPS with not eligible interstitial traffic
             * 3. got to WPS interstitial for eligible(passes upgrade eligibility) WPS traffic
             */
            var finalRoute = function finalRoute() {
                var finishFlow = function finishFlow() {
                    var isWpsFlow = _this4.flags.wpsFlow;
                    var destination = isWpsFlow ? 'done' : 'end';

                    if (_this4.flags.poma_flow) {
                        _logger.$logger.info('LOGGING_OUT' + (isWpsFlow ? '_WPS' : '') + '_POMA_FLOW_FOR_CLEARING_COOKIES');

                        // Logging out the user only for POMA before going to END state.
                        // why are we logging out?
                        // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
                        // user is not authenticated in subsequent transaction in hermes review page
                        // while adding FI or Shipping Address.
                        // so by logging out the user, removes all the cookies except RT from the
                        // browser in which hermes does RT to AT exchange in the absence of AT and gets
                        // the limited AccessToken.
                        return _this4.models.auth.action('logout').then(function () {
                            return _uiRouter.$state.go('checkout.' + destination);
                        });
                    }

                    return _uiRouter.$state.go('checkout.' + destination);
                };

                if (_this4.flags.wpsFlow) {
                    _this4.singleStepModel.onboard = _this4.onboard;
                    _this4.singleStepModel.flags = _this4.flags;
                    // set signup/guest flag so done page
                    // renders the proper content
                    _angular.$rootScope.mode = _this4.flags && _this4.flags.mode;

                    if (_this4.flags.wpsInterstitialEligible) {
                        if (_this4.flags.buyerMode === 'signup') {
                            return _uiRouter.$state.go('checkout.done');
                        }

                        var logAndGoToDone = function logAndGoToDone(error) {
                            return function () {
                                _logger.$logger.info('wps_interstitial_ineligible_' + error);
                                return _uiRouter.$state.go('checkout.done');
                            };
                        };

                        return _this4.onboard.action('upgradeValidate', {
                            data: _this4.onboard.serialize(),
                            success: function success() {
                                return _uiRouter.$state.go('checkout.guest.guestUpgradeInterstitial');
                            },
                            contingencies: {
                                CC_LINKED: logAndGoToDone('CC_LINKED'),
                                EXISTING_MEMBER: logAndGoToDone('EXISTING_MEMBER'),
                                CC_LINKED_TO_FULL_ACCOUNT: logAndGoToDone('CC_LINKED_TO_FULL_ACCOUNT'),
                                VALIDATION_ERROR: logAndGoToDone('VALIDATION_ERROR'),
                                DEFAULT: logAndGoToDone('UHANDLED_CONTINGENCY')
                            },
                            validation: logAndGoToDone('SERVICE_VALIDATION_ERROR'),
                            error: logAndGoToDone('SERVICE_ERROR')
                        });
                    }
                }

                finishFlow();
            };

            var authorize = function authorize() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);
                var checkoutAppData = _this4.models.checkoutAppData;
                var checkoutCart = _this4.models.checkoutCart;
                var doEcOnApprove = checkoutAppData.doec_on_approve();

                return checkoutSession.action('authorize', {
                    success: function success() {
                        var isSubscriptionsV1 = checkoutCart.isSubscriptionsV1();
                        var isWpsSubscription = checkoutAppData.is_wps_subscription_flow();

                        if (isWpsSubscription || isSubscriptionsV1) {
                            return (0, _util2.redirectToSubscriptionFinalRoute)(_this4.flags.mode, isSubscriptionsV1);
                        } else if (doEcOnApprove) {
                            return checkInventoryAndPay(checkoutSession);
                        }

                        return finalRoute();
                    }
                });
            };

            var setStickyFIAndAuthorize = function setStickyFIAndAuthorize() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                return _angular.$q.when((0, _sticky.setStickyInstrument)(checkoutSession))['catch'](function (err) {
                    _logger.$logger.info('setStickyFI_Failed', err);
                })['finally'](authorize);
            };

            this.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)(this.token, this.models, this.flags);

            var postCheckoutSessionOperations = function postCheckoutSessionOperations(dccComplete) {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                /**
                 * 1. Transaction is eligible for DCC - guest flow, plan has PayPal conversion,
                 *    and conversion is changeable
                 * 2. Function wasn't called by post plan interstitial form submission
                 * 3. DCC has not been successfully called (this.onboard.cart.currencyConvData will be `undefined`)
                 *      - Beacuse it hasn't been called yet or because the prePlan API was called but it
                 *        returned an error. In that case we want to try again with the postPlan API instead
                 *        of forcing the user to abandon their cart.
                 */
                if (isDCCEligible(checkoutSession) && !dccComplete && !_this4.onboard.get('card.currencyConvData')) {
                    _logger.$logger.info('render_currency_conversion_lightbox');
                    if (_this4.flags.wpsInterstitialEligible) {
                        _logger.$logger.info('wps_interstitial_render_dcc');
                    }
                    _this4.launchCurrencyConversionLightbox = true;
                    return;
                }

                return callOnShippingChangeAndContinue();
            };

            var callOnShippingChangeAndContinue = function callOnShippingChangeAndContinue() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                function continueWith3DSOrAuthorize() {
                    if (checkoutSession.resolve_3ds) {
                        return show3DSLightbox(checkoutSession);
                    }

                    _logger.$logger.info('Initiate_setStickyFI_call_and_authorize_call');
                    return setStickyFIAndAuthorize();
                }

                // We don't have a shipping address... just continue
                if (!_this4.flags.allowEditShipping) {
                    return _angular.$q.when().then(continueWith3DSOrAuthorize);
                }

                return _this4.shippingChangeFeature.handleOnShippingChange().then(continueWith3DSOrAuthorize);
            };

            this.onCompleteDCC = function (result) {
                _this4.launchCurrencyConversionLightbox = false;
                return postCheckoutSessionOperations(true);
            };

            var makePayment = function makePayment(checkoutSession) {
                var wpsParams = _index.$util.decodeAndParse(_squid.$meta.xclickParams);

                return checkoutSession.action('createPayment', {
                    data: {
                        payer_id: checkoutSession.get('payer.id'),
                        intent: _this4.models.checkoutCart.payment_action,
                        wa_type: wpsParams && wpsParams.wa_type,
                        correlation_id: _squid.$meta.correlationId,
                        merchant_id: _this4.models.payee.get('merchant.id'),
                        custom: _this4.models.checkoutCart.get('purchase.custom'),
                        invoice: _this4.models.checkoutCart.get('purchase.invoice')
                    },
                    success: function success(result) {
                        _angular.$rootScope.paymentComplete = true;
                        _this4.onboard.payerId = checkoutSession.payer && checkoutSession.payer.id;
                        _this4.onboard.transaction = result.transactionDetails && result.transactionDetails.id;
                        if (_index.$config.enableShoppingCartWPS && _this4.models.checkoutAppData.flags.is_shopping_cart_flow) {
                            markCartCheckedout();
                        }
                        return finalRoute();
                    },
                    contingencies: {
                        TRANSACTION_REFUSED: handlePaymentContingencies('TRANSACTION_REFUSED'),
                        INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED() {
                            inventoryOperation('failed');
                            var param = {
                                mode: _this4.flags.mode
                            };

                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', param);
                        },
                        PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies('PAYMENT_DENIED'),
                        DUPLICATE_TRANSACTION: handlePaymentContingencies('PAYMENT_ALREADY_DONE'),
                        // This error needs the same handling as card decline in add card API call
                        CC_PROCESSOR_DECLINED: handleCardContingency,
                        DEFAULT: handlePaymentContingencies('DEFAULT')
                    },
                    error: function error(err) {
                        _logger.$logger.info('createPayment Failed due to service error', err);
                        inventoryOperation('failed');
                        return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                    }
                });
            };

            var inventoryOperation = function inventoryOperation(paymentStatus) {
                var cartHasInventory = _this4.models.checkoutCart.get('cartHasInventory');

                if (cartHasInventory) {
                    var inventoryModel = _index6.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryItems = inventoryModel.getInventoryItems();
                    var purchaseItems = _this4.models.checkoutCart.get('purchaseUnits');
                    var inventoryPatchInput = {};
                    var cartItems = void 0;

                    if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
                        cartItems = purchaseItems[0].item_list.items;
                    }
                    paymentStatus = paymentStatus ? paymentStatus : 'success';
                    if (cartItems && inventoryItems) {
                        inventoryPatchInput = {
                            inventoryItems: inventoryItems,
                            cartItems: cartItems,
                            merchantId: _this4.models.payee.get('merchant.id', ''),
                            paymentStatus: paymentStatus
                        };
                    } else {
                        return _angular.$q.when(); // don't need to call patchInventory if items not present
                    }

                    return inventoryModel.action('patchInventory', {
                        data: inventoryPatchInput,
                        success: function success(patchResponse) {
                            if (patchResponse) {
                                if (patchResponse.showSoldoutPage) {
                                    // show soldout page
                                    return {
                                        soldoutpage: true,
                                        items: patchResponse.soldoutItems,
                                        soldOutUrl: patchResponse.soldoutUrl
                                    };
                                } else if (patchResponse.patchCart) {
                                    var purchase_unit = _this4.models.checkoutCart.get('purchaseUnits')[0];

                                    purchase_unit.item_list.items = patchResponse.cartItems;
                                    var patchCartPayload = {
                                        id: _this4.token,
                                        patchEntities: [{
                                            field: 'inventoryItems',
                                            value: purchase_unit.item_list.items
                                        }]
                                    };

                                    return _this4.models.checkoutCart.action('patchCartData', {
                                        data: patchCartPayload
                                    });
                                }
                            } else {
                                return;
                            }
                        }
                    });
                } else {
                    return _angular.$q.when(); // not an inventory request proceed with existing flow
                }
            };

            var checkInventoryAndPay = function checkInventoryAndPay(checkoutSession) {
                return inventoryOperation().then(function (result) {
                    if (result && result.soldoutpage) {
                        return _uiRouter.$state.go('checkout.soldout', {
                            items: encodeURIComponent(result.items),
                            soldOutUrl: encodeURIComponent(result.soldOutUrl)
                        });
                    }
                    return makePayment(checkoutSession);
                });
            };

            var handlePaymentContingencies = function handlePaymentContingencies(code) {
                return function () {
                    inventoryOperation('failed');
                    return _uiRouter.$state.go('checkout.genericError', { code: code });
                };
            };

            var markCartCheckedout = function markCartCheckedout() {
                var shoppingCartModel = _index4.$ShoppingCartModel.instance(_angular.$rootScope.token);

                return shoppingCartModel.action('cartCheckedOut', {
                    success: function success(result) {
                        _logger.$logger.info('cart checked out successfully');
                    }
                });
            };

            var mapValidationErrors = function mapValidationErrors(err) {
                var fields = err && err.fields || [];

                fields.forEach(function (fieldError) {
                    if (fieldError && fieldError.property) {
                        fieldError.field = fieldError.property;
                    }
                });
                return {
                    fields: fields
                };
            };

            var mapAddCardErrors = function mapAddCardErrors(field) {
                switch (field) {
                    case 'cvv':
                        return { fields: [{ field: 'security_code' }] };
                    case 'billing_address':
                        if (_this4.$element.find('[ng-model="address.line2"]').val().length) {
                            return { fields: [{ field: 'address.line1' }, { field: 'address.line2' }, { field: 'address.postal_code' }] };
                        }
                        return { fields: [{ field: 'address.line1' }, { field: 'address.postal_code' }] };
                    default:
                        return;
                }
            };

            // TODO: clean up this code as most of filifecycleserv error handler is in
            // lib/errorHandlerHelper, and we should get rid of $fiErrorUtil
            // From my understanding following function is related to older service call
            this.handleFIContingencies = function (data, fundingInstrument) {
                return (0, _squid.$pxp)('xo_xoon_validation_error', { 'ctx.country': _index.$locale.country }, 'xo_xoon_validation_error_treatment', false, true).then(function (result) {
                    // data is an object which has error with key 0
                    // standardize data's data structure to group invalid fields together and handle all cases
                    if (result && data && data[0]) {
                        var contentBundle = 'addCardFIErrors';
                        var errorData = mapAddCardErrors(data[0].field);

                        switch (data[0].field) {
                            case 'billing_address':
                                _this4.errorMessage = _util.$fiErrorUtil.addPageErrors(data, contentBundle, _this4.props, 'VALIDATION_ERROR_BILLING_ADDRESS');
                                _util.$fiErrorUtil.addFieldErrors(errorData, _this4.$element);
                                break;
                            case 'cvv':
                                _this4.errorMessage = _util.$fiErrorUtil.addPageErrors(data, contentBundle, _this4.props, 'VALIDATION_ERROR_CVV');
                                _util.$fiErrorUtil.addFieldErrors(errorData, _this4.$element, 'card.');
                                break;
                            default:
                                _this4.errorMessage = _util.$fiErrorUtil.addPageErrors(data, fundingInstrument);
                                break;
                        }
                    }

                    if (!_this4.errorMessage) {
                        _this4.errorMessage = {
                            msgs: [_index.$locale.content.get(fundingInstrument + '.errorGeneral')],
                            type: 'error'
                        };
                    }

                    errorHandlerHelper.scrollToElement();
                });
            };

            this.handleAddFIContingencies = function (data, fundingInstrument, action) {
                if (action === 'signup') {
                    handleCardContingencySignup(data);
                } else {
                    _this4.handleFIContingencies(data, fundingInstrument);
                }
            };

            var getContentIdentifier = function getContentIdentifier(tcpaIdentifier) {
                return _index.$locale.country + ':' + _index.$locale.lang + ':' + (0, _squid.$contentVersion)() + ':' + tcpaIdentifier;
            };

            /*
             * onBoardAccount and functions calling onBoardAccount
             */
            this.onBoardAccount = function () {
                // remove the page level errors
                _this4.errorMessage = '';

                // creating this variable shipping_address_validation for back-end whether to validate
                // the shipping address or not.
                // shipping address validation required only when shipping address is different than Billing Address
                // shipToBilling flag will be false when user tries to expand the shipping address in Billing Page
                // By default shipToBilling is true, so when shipping address is shown and Billing Address
                // is not present for whitelisted india merchants, shipping address needs to be validated.
                _this4.onboard.shipping_address_validation = _this4.flags.allowEditShipping && (!_this4.flags.shipToBilling || _this4.flags.whiteListedIndiaMerchant);
                // billing_address_present passed to the back end to skip / perform billing address validation
                // billing_address_present will be false only for whitelisted merchant from INs.
                _this4.onboard.billing_address_present = !_this4.flags.whiteListedIndiaMerchant;
                _this4.onboard.billing_address.country = _index.$locale.country;

                _this4.onboard.skipInitiateAuth = true;

                _this4.onboard.poma_flow = _this4.flags.poma_flow;
                _this4.onboard.content_identifier = getContentIdentifier(_this4.flags.tcpa_identifier);
                _this4.onboard.prox_flow = _this4.models.checkoutInputData.isEbayTxn();

                // Set Free Return Shipping Opt-in flow applicability flag
                _this4.onboard.frs_optin_flow_applicable = _this4.flags.freeReturnShippingOptInFlowApplicable;
                _this4.onboard.frs_optin_active_flow = _this4.flags.freeReturnShippingOptInActiveFlow;

                // merchantCountry, merchantPreferences, and isUnbranded are needed to check for guest eligibility
                var _merchantPreferences = _this4.merchantPreferences;
                _merchantPreferences = _merchantPreferences === undefined ? {} : _merchantPreferences;
                var merchant_preferences = _merchantPreferences.model;


                _this4.onboard.flow_eligibility_data = {
                    is_unbranded: _this4.isUnbranded,
                    merchant_preferences: merchant_preferences,
                    merchant_country: _this4.merchantCountry
                };

                _this4.onboard.bypass_address_verification = _this4.bypassAddressVerificationExperience.bypassAddressVerificationExp && _this4.flags.mode === 'guest';

                // POMA should go in Singup rails, because poma usecase is passwordless member
                var action = _this4.flags.poma_flow || _this4.flags.mode === 'signup' ? 'signup' : 'guest';

                var setErrorMessage = function setErrorMessage(errMsg) {
                    _this4.errorMessage = {
                        msgs: errorHandlerHelper.getPageError(errMsg),
                        type: 'error'
                    };
                };

                return _this4.onboard.action(action, {
                    data: _this4.onboard.serialize(),

                    success: function success() {
                        return _angular.$q.when().then(function () {
                            /*
                            If we're in an in-context flow, the parent button
                            iframe may need the access token to continue running
                            and execute the payment (e.g. in 3rd party cookies
                            disabled mode)
                             We reload the auth model, since after the user is
                            onboarded this model is not updated, then pass the
                            access token up. The token will only be passed if
                            we're on the same-domain as the parent button.
                            */

                            if (window.xprops && window.xprops.onAuth) {
                                var auth = _index9.$AuthModel.instance();

                                return auth.reload().then(function () {
                                    window.xprops.onAuth({ accessToken: auth.access_token });
                                });
                            }
                        }).then(function () {
                            if (_this4.flags.poma_flow) {
                                var locale_code = _index.$locale.lang + '_' + _index.$locale.country;
                                var locale_country = _index.$locale.country;

                                return _ul.$ul.optInToOneTouch(_this4.token, locale_country, locale_code).then(function (success) {
                                    _logger.$logger.info('UL_SUCCESSFULLY_DROPPED_RT_IN_COOKIE');
                                }, function (err) {
                                    // eslint-disable-line handle-callback-err
                                    _logger.$logger.info('UL_FAILED_DROPPED_RT_IN_COOKIE');
                                });
                            }
                        }).then(function () {
                            if (_this4.models.checkoutCart.isWalletTokenization()) {
                                _logger.$logger.info('REDIRECT_' + _this4.subject + '_WALLET_TOKENIZATION');
                                (0, _squid.$dispatch)('hermes', {
                                    token: _this4.token,
                                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                                    'country.x': _index.$locale.country
                                });
                            } else {
                                // fire conversion url for MORS offer in the sign up section, ad_id = 202002
                                if (_this4.MORSDisplayed && _this4.MORSDisplayed.placementId === '202002') {
                                    _index11.$fireMORSBeacon.fireBeacon(_this4.MORSDisplayed.clickURL);
                                }

                                if (_this4.onboard.card && _this4.onboard.card.type === 'CUP' && _this4.onboard.fundingId) {
                                    _this4.onboard.card.id = _this4.onboard.fundingId;
                                    _this4.launchUpopScreen = true;
                                } else {
                                    // Create Checkout-Session
                                    return createXO();
                                }
                            }
                        });
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
                            setErrorMessage('creditcard.linkedCardToAddNewCard');
                        },
                        BANK_LINKED_TO_FULL_ACCOUNT: function BANK_LINKED_TO_FULL_ACCOUNT() {
                            setErrorMessage('bank.linkedBankError');
                        },
                        EXISTING_ACCOUNT_RESTRICTED: function EXISTING_ACCOUNT_RESTRICTED() {
                            setErrorMessage('creditcard.riskDisallowed');
                        },
                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
                            setErrorMessage('genericError.genericError');
                        },

                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
                            _this4.errorMessage = _util.$fiErrorUtil.addPageErrors(data, _this4.locale, 'bank');
                            _util.$fiErrorUtil.addFieldErrors(data, _this4.sectionElement);
                        },
                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(result, err) {
                            _this4.handleAddFIContingencies(err, 'creditcard', action);
                        },
                        ADD_BANK_CONTINGENCY: function ADD_BANK_CONTINGENCY(result, err) {
                            _this4.handleAddFIContingencies(err, 'bank', action);
                        },
                        RISK_DISALLOWED: function RISK_DISALLOWED() {
                            setErrorMessage('creditcard.riskDisallowed');
                        },
                        COUNTRY_NOT_SUPPORTED: function COUNTRY_NOT_SUPPORTED() {
                            setErrorMessage('creditcard.complianceDecline');
                        },

                        VALIDATION_ERROR: function VALIDATION_ERROR(message) {
                            var errorData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var _errorData$ = errorData[0];
                            _errorData$ = _errorData$ === undefined ? {} : _errorData$;
                            var errorCode = _errorData$.code;
                            var _experiments$accountE = _this4.experiments.accountExistsPXP,
                                accountExistsPXP = _experiments$accountE === undefined ? {} : _experiments$accountE;
                            var accountExistsTreatment = accountExistsPXP.treatment_name;

                            var isCheckAuthflowRedirect = errorCode === 'ACCOUNT_ALREADY_EXISTS' && !_this4.models.checkoutInputData.isEbayTxn() && _this4.mode === 'signup';

                            return (0, _util3.authflowRedirect)({ isCheckAuthflowRedirectParam: isCheckAuthflowRedirect, country: _index.$locale.country }).then(function (isAuthFlow) {

                                // following errorCode is added for US1174965 - forced signup
                                if (isAuthFlow) {
                                    errorData[0].errorCode = 'ACCOUNT_ALREADY_EXISTS_AUTHFLOW_REDIRECT';
                                }

                                var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this4.actions.positionToErrorField, accountExistsTreatment ? _this4.mode : '');
                                var errorType = errorHandlerHelper.getErrorType(errorCode, _this4.mode, accountExistsTreatment);

                                if (errorMsgs && errorMsgs.length > 0) {
                                    _this4.errorMessage = {
                                        msgs: errorMsgs,
                                        type: errorType
                                    };
                                }

                                if (accountExistsTreatment && errorCode === 'ACCOUNT_ALREADY_EXISTS' && _this4.mode !== 'signup') {
                                    var isPOMA = _this4.flags.poma_flow;

                                    (0, _pageProps.accountExistsOptionalCheck)(_this4.mode, isPOMA);
                                }
                            });
                        }
                    },

                    validation: function validation(res) {
                        // should catch any primary check failures like schema validations etc
                        _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), _this4.sectionElement);
                    }
                });
            };

            var addShippingAddress = function addShippingAddress() {
                return _squid.$promise.call(function () {
                    // Add shipping address if edit shipping is allowed. this.flags.allowEditShipping flag used
                    // to show "ship to Billing" checkbox
                    if (_this4.flags.allowEditShipping) {
                        var shippingAddress = _this4.onboard.shipping_address;

                        shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;
                        return shippingAddress.save({
                            data: _this4.onboard.shipping_address.serialize(),
                            validation: function validation(message, errorData) {
                                var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this4.actions.positionToErrorField);

                                if (errorMsgs && errorMsgs.length > 0) {
                                    _this4.errorMessage = {
                                        msgs: errorMsgs,
                                        type: 'error'
                                    };
                                }
                            }
                        });
                    }
                });
            };

            var createXO = function createXO() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                return checkoutSession.action('create', {
                    data: {
                        fraudnet_id: _this4.models.checkoutCart.get('supplementary.risk_correlation_id'),
                        baToken: _this4.models.checkoutCart.get('billing.ba_token'),
                        cc_login_account_number: _this4.onboard.cc_login_account_number,
                        email_login_account_number: _this4.onboard.email_login_account_number
                    },

                    success: function success() {
                        return _angular.$q.when().then(addShippingAddress).then(function () {
                            if (_this4.flags.buyerFxTreatment) {
                                /**
                                 * Here we will log the following events to FPTI
                                 * Event 3 - During signup when the the pre-plan API failed and
                                 *      the card allows for the conversion seleciton to be changed
                                 * Event 7 - All cases expect for guest checkout when the pre-plan
                                 *      API fails and the card allows for conversion selection. We
                                 *      don't log event 7 here in that case because those users will
                                 *      see the post-plan interstitial which will log event 7 upon submission
                                 */
                                (0, _utils.logBuyerFxFpti)({
                                    card: _this4.onboard.card,
                                    hasPrePlanData: _this4.flags.hasBuyerFxPrePlanData,
                                    isSignup: _this4.flags.mode === 'signup',
                                    purchase: _this4.models.checkoutCart.purchase
                                });
                            }

                            /**
                             * If checkoutSession has DCC enabled, then we do the 'updateConversion' call and upate to 'VENDOR' if:
                             * 1. Pre-Plan (Buyer FX): if 'VENDOR' was selected as the option from the inline radio buttons.
                             * 2. The user is going through the forced signup flow we need currency conversion and they didn't see the Buyer FX
                             *    experience or the API for that experience failed. For signup we don't show the post-plan
                             *    DCC interstitial since we want to minimize the number of fields the user has to fill
                             *    out. Therefore we forgo the chance at earning the conversion fee and forece 'VENDOR'.
                             */
                            var conversionPayPalAndChangeable = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');
                            var isSignupWithNoConversion = _this4.flags.mode === 'signup' && !_this4.onboard.card.currencyConvData;
                            var conversionIsVendor = _this4.onboard.card.ppconversion === 'VENDOR';

                            if (conversionPayPalAndChangeable && (isSignupWithNoConversion || conversionIsVendor)) {
                                return _index2.$FundingOptionsModel.instance(_this4.token).action('updateConversion', {
                                    data: {
                                        conversionType: 'VENDOR',
                                        planId: checkoutSession.plan.id
                                    },
                                    resultModel: checkoutSession
                                })['catch'](function (err) {
                                    return err;
                                });
                            }
                        }).then(function () {
                            // Performing a check if the card and CVV exists to determine whether or not we do a patchCVV
                            var checkCVV = checkoutSession.get('cvvData');
                            var securityCode = _this4.onboard.get('card.security_code');
                            var fundingOptions = checkoutSession.get('fundingOptions.instruments');
                            var instrumentId = fundingOptions && fundingOptions.length > 0 ? fundingOptions[0].id : null;

                            if (checkCVV) {
                                _logger.$logger.info('paps_threw_cvv_contigency_patchCvv');
                                checkoutSession.set('cvvData.security_code', securityCode);
                            } else if (securityCode && _this4.onboard.bypass_address_verification) {
                                _logger.$logger.info('bypass_skip_avs_patchCvv');
                                checkoutSession.set('cvvData', {
                                    security_code: securityCode,
                                    id: instrumentId
                                });
                            }

                            return _fiApis.$fiApis.patchCvv(checkoutSession).then(postCheckoutSessionOperations, function (err) {
                                _logger.$logger.error('patchCvv error', err);
                            });
                        });
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS() {
                            return _this4.onboard.shipping_address.save({
                                data: _this4.onboard.shipping_address.serialize(),
                                validation: function validation(message, errorData) {
                                    var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this4.actions.positionToErrorField);

                                    if (errorMsgs && errorMsgs.length > 0) {
                                        _this4.errorMessage = {
                                            msgs: errorMsgs,
                                            type: 'error'
                                        };
                                    }
                                }
                            });
                        },
                        NEED_CREDIT_CARD_OR_BANK_ACCOUNT: function NEED_CREDIT_CARD_OR_BANK_ACCOUNT() {
                            return handleCardContingency();
                        },
                        NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                            return handleCardContingency();
                        },
                        SENDING_LIMIT_EXCEEDED: function SENDING_LIMIT_EXCEEDED() {
                            /* 1. Introducing config attribute sendingLimitNoFallback for certain countries right now
                             only Japan, to go to generic error page in case of sending limit exceeded. this config
                             will be removed once all countries have proper content available.
                             2. Currently only guest mode will go to generic error page as signup mode need to handle
                             SENDING_LIMIT_EXCEEDED AND TRANSACTION_LIMIT_EXCEEDED separately but we are not getting expected
                             contingency from Symphony yet. Will remove scope.flags.mode === 'guest' condition once we are getting
                             expected contingency back.
                             */
                            if ((0, _index.$feature)('sendingLimitNoFallback') && _this4.flags.mode === 'guest') {
                                _uiRouter.$state.go('checkout.genericError', { code: 'TRANSACTION_LIMIT_EXCEEDED' });
                            } else {
                                throw new _index.$FallbackError({
                                    reason: 'sending_limit_exceeded',
                                    product: 'ux'
                                });
                            }
                        },
                        NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD() {
                            // Contingency purpose - Show OTP confirmation popup
                            // As we have already presented user with OTP popup with
                            // init call after add card (flag - launchUpopScreen),
                            // we need to redirect user to hermes at this point
                            (0, _squid.$dispatch)('hermes', {
                                token: _this4.token,
                                'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                                'country.x': _index.$locale.country
                            });
                        },
                        TRAVEL_RULE_ID_REQUIRED: function TRAVEL_RULE_ID_REQUIRED() {
                            _logger.$logger.info('invoice_travel_rule_id_required');
                            _this4.launchTravelRuleLightbox = true;
                        }
                    }
                });
            };

            this.onTravelRuleSuccess = function () {
                // Close travel rule lightbox if it is open
                _this4.launchTravelRuleLightbox = false;
                return createXO();
            };

            this.onUpopSuccess = function () {
                _this4.launchUpopScreen = false;
                return createXO();
            };

            this.onUpopCancel = function (errorData) {
                _this4.launchUpopScreen = false;

                if (_this4.flags.mode === 'signup') {
                    // If signup user closes the OTP popup window(or some error in flow)
                    // then call create checkout session, and this will intern redirect
                    // to hermes with NEED_AUTHENTICATED_CARD contingency
                    return createXO();
                } else if (errorData) {
                    // If guest user closes the OTP popup window(or some error in flow)
                    // then show a page level error to the user
                    // There is no redirect to hermes in guest case
                    if (errorData && errorData.errorCodes && errorData.errorCodes[0] === 'RESTRICTED_CARD') {
                        // Custom error messaging for RESTRICTED_CARD errorCode.
                        // RESTRICTED_CARD_GUEST content key is applicable for both Guest & Signup flows.
                        errorData.errorCodes[0] = 'RESTRICTED_CARD_GUEST';
                    }

                    // prop for last 4 digits of card in error message
                    var prop = {
                        number: _this4.onboard.card.last4()
                    };

                    _this4.errorMessage = _util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error');
                }
            };

            this.uponNormalization = function (normalizedAddress, isBack) {
                _this4.showAddressNormalizationLightbox = false;

                var newBilling = _index8.$BillingAddressModel.create(_this4.token, normalizedAddress, {
                    id: '0'
                });

                _this4.onboard.billing_address = newBilling;

                if (_this4.flags.shipToBilling) {
                    _this4.onboard.shipping_address.first_name = _this4.onboard.user.first_name;
                    _this4.onboard.shipping_address.last_name = _this4.onboard.user.last_name;
                }

                return _this4.onBoardAccount();
            };

            this.toggleAddressFieldsValidation = function (toggle) {
                if (_this4.flags.shipToBilling) {
                    _this4.billingAddressValidated = toggle;
                } else {
                    _this4.shippingAddressValidated = toggle;
                }
            };

            /*
             * Update Phone Number to remove '-' from actual Number.
             * Input: 123-4567-890 Output: 1234567890.
             */
            this.updatePhoneOnSubmit = function () {
                if (_this4.onboard.phone.telephone) {
                    _this4.onboard.phone.telephone = _this4.$element.find('.telephone').cleanVal();
                }
            };

            /*
             * Before submit the transaction, need to update shipping address if this.flags.shipToBilling is set
             * Also update city/state/zip value if the city/state/zip element is not present for the selected country
             * TODO: should enhance this function to compare the address entry from metadata based on country,
             *       the tricky part is need to consider to load metadata separately for billing and shipping
             *       if their country is different
             */
            this.updateAddressOnSubmit = function () {
                var billingState = $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0];
                var shippingState = $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
                var billingCity = $('#billingAddress #city')[0] || $('#billingAddress #billingCity')[0];
                var shippingCity = $('#shippingAddress #city')[0] || $('#shippingAddress #shippingCity')[0];
                var billingZip = $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0];
                var shippingZip = $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
                var billingLine1 = $('#billingAddress #line1')[0] || $('#billingAddress #billingLine1')[0];
                var billingLine2 = $('#billingAddress #line2')[0] || $('#billingAddress #billingLine2')[0];

                // Before submit the onboarding request, we need to make sure billing address country code is user selected country
                _this4.onboard.billing_address.country = _index.$locale.country;

                if (!billingCity) {
                    delete _this4.onboard.billing_address.city;
                }

                if (!billingState) {
                    delete _this4.onboard.billing_address.state;
                }

                if (!billingZip) {
                    delete _this4.onboard.billing_address.postal_code;
                }

                if (!billingLine1) {
                    delete _this4.onboard.billing_address.line1;
                }

                if (!billingLine2) {
                    delete _this4.onboard.billing_address.line2;
                }

                // skip populating shipping address fields for india whitelisted Merchants.
                if (_this4.flags.shipToBilling && !_this4.flags.whiteListedIndiaMerchant) {
                    _this4.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this4.token, _this4.onboard.billing_address, {
                        first_name: _this4.onboard.user.first_name,
                        last_name: _this4.onboard.user.last_name
                    });
                } else {
                    _this4.onboard.shipping_address.first_name = _this4.onboard.shipping_address.first_name || _this4.onboard.user.first_name;
                    _this4.onboard.shipping_address.last_name = _this4.onboard.shipping_address.last_name || _this4.onboard.user.last_name;

                    if (!shippingState) {
                        delete _this4.onboard.shipping_address.state;
                    }

                    if (!shippingCity) {
                        delete _this4.onboard.shipping_address.city;
                    }

                    if (!shippingZip) {
                        delete _this4.onboard.shipping_address.postal_code;
                    }

                    // Shipping / Billing Address Difference Detection
                    _this4.addrDiffDetected = compareShippingBillingAddrs(_this4.onboard.shipping_address, _this4.onboard.billing_address);
                    if (_this4.addrDiffDetected) {
                        var addrDiff = {
                            is_ship_addr_diff: 1,
                            page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
                        };

                        _angular.$rootScope.$broadcast('addrDiff', addrDiff);
                    }
                }
            };

            // This function just logs 'Non-DE' IBAN when user submits the form.
            this.logNonDEIBAN = function (iban_value) {
                if (iban_value && iban_value.slice(0, 2) !== 'DE') {
                    _logger.$logger.info('non_DE_IBAN_number_submitted_' + iban_value);
                }
            };

            // Case insensitively compare all string properties of shipping and billing address to detect difference.
            // This method is designed to work with any country with any set of address input fields.
            var compareShippingBillingAddrs = function compareShippingBillingAddrs(shipping_addr, billing_addr) {
                var diffDetected = false;

                for (var prop in shipping_addr) {
                    if (shipping_addr.hasOwnProperty(prop) && billing_addr.hasOwnProperty(prop)) {
                        if (angular.isString(shipping_addr[prop]) && angular.isString(billing_addr[prop])) {
                            if (shipping_addr[prop].toUpperCase() !== billing_addr[prop].toUpperCase()) {
                                // Special handling for postal code
                                if (prop === 'postal_code') {
                                    diffDetected = checkZip(shipping_addr[prop], billing_addr[prop]);
                                } else {
                                    diffDetected = true;
                                }
                            }
                        }
                    }
                }

                // Special case zip check to ignore differences in zipcode format
                function checkZip(zip1, zip2) {
                    var longerZip = zip1.length > zip2.length ? zip1 : zip2;
                    var shorterZip = longerZip === zip1 ? zip2 : zip1;

                    if (longerZip.indexOf(shorterZip) > -1) {
                        return false;
                    }
                    return true;
                }

                return diffDetected;
            };

            var enableSnT = function enableSnT() {
                if (_this4.flags.wps_SnT_flow && !_this4.flags.allowSnTCall) {
                    // SnT should be allowed if there is an contingency during OnBoard.
                    _this4.flags.allowSnTCall = true;
                }
            };

            var handleAllLoadedForSnT = _angular.$rootScope.$on('allLoaded', enableSnT);

            this.$on('$destroy', handleAllLoadedForSnT);

            var routeToHermesOn3DSDeclineForSignUp = function routeToHermesOn3DSDeclineForSignUp() {
                // dispatch to hermesnodeweb up on 3DS authenticate decline.
                _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
                (0, _squid.$dispatch)('hermes', {
                    redirectToHermesOn3DSDecline: 'xoon',
                    token: _this4.token,
                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                    'country.x': _index.$locale.country
                });
            };

            /**
             * call patchXO API to clear the 3DS contingency and then call authorize API.
             */
            var clear3DSContingency = function clear3DSContingency() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                return checkoutSession.action('clear3DSContingency', {
                    data: {
                        ccId: checkoutSession.resolve_3ds.ccId
                    },
                    success: function success() {
                        // don't call authorize if the contingency is not cleared
                        if (!checkoutSession.resolve_3ds) {
                            _logger.$logger.info('Initiate_setStickyFI_call_and_authorize_call_after_resolve_3ds');
                            return setStickyFIAndAuthorize();
                        } else {
                            _this4.errorMessage = {
                                msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
                                type: 'warning'
                            };
                        }
                    },
                    contingencies: {
                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
                        DEFAULT: function DEFAULT(name, contingency) {
                            _logger.$logger.info('clear3DSContingency_contingency', {
                                int_error_description: contingency && contingency.message,
                                contingency_name: name
                            });

                            if (_this4.flags.mode === 'signup') {
                                // route to member review page upon patch xo throws contingency for signup
                                routeToHermesOn3DSDeclineForSignUp();
                            } else {
                                _this4.errorMessage = {
                                    msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
                                    type: 'warning'
                                };
                            }
                        }
                    }
                });
            };

            this.onComplete3DSHandler = function (status) {
                _this4.launch3DSResolver = false;
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this4.token);

                if (status === 'decline') {
                    // Flow should route to member review page for sign up case
                    // up on receiving "decline" response from 3DS authenticate call
                    if (_this4.flags.mode === 'signup') {
                        routeToHermesOn3DSDeclineForSignUp();
                    } else {
                        // guest case
                        _this4.errorMessage = {
                            msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDecline'),
                            type: 'warning'
                        };
                    }
                } else if (status === 'close') {
                    // Closing the 3DS page should route the flow to member review for sign up case
                    // because the member account is created already.
                    // Guest remains in the Billing page, no re-direction.
                    if (_this4.flags.mode === 'signup') {
                        routeToHermesOn3DSDeclineForSignUp();
                    }
                } else if (status === 'success') {
                    // Up on Successful authenticate, perform Patch on XO session and authorise.
                    clear3DSContingency();
                }
            };

            // Added a function to set SepaOverlay flag based on pxp call
            var setSepaOverlayFlag = function setSepaOverlayFlag() {
                var sepaOverlayPXP = _this4.sepaExperiment.sepaOverlay && _this4.sepaExperiment.sepaOverlay.treatment_name === 'XO_XOONBOARDING_SEPA_OVERLAY_TEST';

                if (sepaOverlayPXP) {
                    _logger.$logger.info('checkout_fpti', { is_sepaOverlay: 1 });

                    _this4.flags.show_sepa_overlay = true;
                } else {
                    _logger.$logger.info('checkout_fpti', { is_sepaOverlay: 0 });
                    _this4.flags.show_sepa_overlay = false;
                }
            };

            setSepaOverlayFlag();

            _logger.$logger.info('sepa_overlay', {
                type: this.onboard.fiMode,
                sepa_overlay: this.flags.show_sepa_overlay,
                lang: _index.$locale.lang,
                unbrandedFlag: this.isUnbranded
            });

            // will be called upon change in flags.mode and flags.poma_flow - opt-in or opt-out
            // and when pre-plan currency conversion API returns conversion data
            var setSubmitButtonText = function setSubmitButtonText() {
                var isSubscription = _this4.models.checkoutAppData.is_wps_subscription_flow() || _this4.models.checkoutCart.isSubscriptionsV1();

                _this4.submitButtonText = (0, _pageProps.submitButtonTextKey)(_this4.flags, _this4.showNewSignupComplianceExp, _this4.flags.hasBuyerFxPrePlanData, isSubscription);
            };

            this.$watch('flags.mode', setSubmitButtonText);
            this.$watch('flags.poma_flow', setSubmitButtonText);
            this.$watch('onboard.card.currencyConvData', function () {
                _this4.getSelectedCurrencyCode(_this4.onboard.card.ppconversion);
                setSubmitButtonText();
            });

            this.openAndContinueSepaOverlay = function () {
                if (_this4.flags.show_sepa_overlay && !_this4.sepa.sepaGuestAgree) {
                    _this4.sepa.show = true;
                    return true;
                } else {
                    return false;
                }
            };

            // If its invoicing flow with Remittance transfer rule (RTR), then a dislaimer content has to be shown to the payer.
            // It applies for US payers paying non US merchants of greater than $15 USD or equivalent.
            var handleInvoicingRegE = function handleInvoicingRegE(currConvData) {
                var isInvoicingFlow = _this4.models.checkoutAppData.get('flags.is_invoice_flow') === true;

                if (isInvoicingFlow) {
                    var merchantCountry = _this4.models.checkoutAppData.get('merchant.merchant_country');
                    var payerCountry = _this4.locale.country;

                    var isRTRAmount = void 0;

                    if (currConvData) {
                        var _currConvData$payment = currConvData.payment_amt;
                        _currConvData$payment = _currConvData$payment === undefined ? {} : _currConvData$payment;
                        var value = _currConvData$payment.value,
                            currency_code = _currConvData$payment.currency_code;


                        if (value && currency_code) {
                            isRTRAmount = Number(value) > _constants.RTR_AMOUNT;
                            _this4.amountInPayerCurrency = (0, _squid.formatCurrency)(value, currency_code);
                            _this4.hasCurrConversion = true;
                        }
                    } else {
                        _this4.hasCurrConversion = false;

                        var _ref4 = _this4.models.checkoutCart.get('purchase.amounts.total') || {},
                            amount = _ref4.amount,
                            _currency_code = _ref4.currency_code;

                        isRTRAmount = Number(amount) > _constants.RTR_AMOUNT && _currency_code === 'USD';
                    }

                    _this4.showInvoicingRegEMsg = isRTRAmount && merchantCountry !== 'US' && payerCountry === 'US';

                    var _ref5 = _this4.models.checkoutCart.get('purchase.amounts.total') || {},
                        amount_formatted_currency = _ref5.amount_formatted_currency;

                    _this4.amountInInvCurrency = amount_formatted_currency;

                    // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
                    // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
                    // in content keys used in template
                    _this4.nonEmptyMerchantDisplayName = _this4.models.checkoutAppData.getMerchantDisplayName({
                        nonEmptyReturnValue: true
                    });
                }
            };

            var setInvoicingRegEDetails = function setInvoicingRegEDetails(cardType) {
                if (cardType !== undefined && cardType !== 'VISA') {
                    handleInvoicingRegE();
                } else {
                    _this4.showInvoicingRegEMsg = false;
                }
            };

            this.$watch('onboard.card.type', setInvoicingRegEDetails);

            var setInvoicingRegEDetailsWithConversion = function setInvoicingRegEDetailsWithConversion(currConvData) {
                if (currConvData !== undefined) {
                    handleInvoicingRegE(currConvData);
                } else {
                    _this4.showInvoicingRegEMsg = false;
                }
            };

            this.$watch('onboard.card.currencyConvData', setInvoicingRegEDetailsWithConversion);

            var initPaymentRequest = function initPaymentRequest(PaymentRequest) {
                var networks = ['amex', 'diners', 'discover', 'jcb', 'mastercard', 'unionpay', 'visa', 'mir'];
                var types = ['debit', 'credit', 'prepaid'];
                // supportedInstruments includes Android Pay and credit cards.
                var supportedInstruments = [{
                    supportedMethods: 'basic-card',
                    data: {
                        supportedNetworks: networks,
                        supportedTypes: types
                    }
                }];
                var details = {
                    total: {
                        label: 'Pay with PayPal',
                        amount: {
                            currency: 'USD',
                            value: '10.00'
                        }
                    }
                };
                var options = {
                    requestPayerName: true,
                    requestPayerPhone: true,
                    requestPayerEmail: true
                };

                return new PaymentRequest(supportedInstruments, details, options);
            };

            // GPayment Request API to measure impact.
            var logGPayMethods = function logGPayMethods() {
                if (angular.isFunction(window.PaymentRequest)) {
                    try {
                        var request = initPaymentRequest(window.PaymentRequest);
                        if (request.canMakePayment) {
                            request.canMakePayment().then(function (result) {
                                if (result) {
                                    _logger.$logger.info('gpayment_api_can_make_payment');
                                } else {
                                    _logger.$logger.info('gpayment_api_cannot_make_payment');
                                }
                            })['catch'](function (err) {
                                _logger.$logger.info('gpayment_api_unhandled_error', err);
                            });
                        } else {
                            _logger.$logger.info('gpayment_api_browser_cannot_make_payment');
                        }
                    } catch (e) {
                        // Could happening due to support for modifiers not being present (< chrome v62)
                        _logger.$logger.info('gpayment_api_exception_init_gpay', e);
                    }
                } else {
                    _logger.$logger.info('gpayment_api_browser_not_supported');
                }
            };

            logGPayMethods();
        } // populate

    },

    actions: {
        toggleFIMode: function toggleFIMode(event, mode) {

            var isTesla = this.teslaAddBankEXP ? 'tesla_' : '';

            // Log to FPTI with event name and mode.

            _logger.$logger.info('checkout_fpti', {
                from: this.mode === 'guest' ? 'GUEST_XO' : 'SIGNUP',
                to: 'prepare_' + isTesla + mode
            });

            _logger.$logger.info('FI_TOGGLE_CHANGED_TO', mode);

            event.preventDefault();
            this.onboard.fiMode = mode;
        },
        goBack: function goBack(event) {
            (0, _squid.$dispatch)('hermes', {
                redirectToHermes: true,
                token: this.token
            });
        },


        // Enable user to edit shipping address
        editShippingAddress: function editShippingAddress() {
            this.flags.showSingleAddress = false;
            this.flags.allowEditShipping = true;
            this.flags.disallowShipToBilling = true;
            this.flags.shipToBilling = false;
            this.flags.hideShippingAddress = false;
            _angular.$rootScope.$emit('change_in_shipping_address');
        },
        logWebviewBackButtonClick: function logWebviewBackButtonClick() {
            if (this.flags.backButtonWebview) {
                _logger.$logger.info('BACK_BUTTON_FOR_WEBVIEW_CLICKED');
            }
        },
        updatePageLevelErrorMessage: function updatePageLevelErrorMessage() {
            var msgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

            this.errorMessage = { msgs: msgs, type: type };
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            // Remove backendError class upon submit on all fields
            // This is necessary to clear backend error on fields like first name
            // and last name, that is not having frontend validation
            $(this.sectionElement + ' .backendError').removeAttr('aria-invalid').removeClass('backendError');

            // Added logging for non-DE IBAN numbers: US1022248
            this.logNonDEIBAN($(this.sectionElement + ' #ibanNumber').val());

            // Added a condition check for pxp experimentation for Sepa Overlay US755520
            if (this.openAndContinueSepaOverlay()) {
                return;
            }

            if (this.isInstantUpdateFlow) {
                var currentShippingAddress = this.flags.shipToBilling ? this.onboard.billing_address : this.onboard.shipping_address;

                if ((0, _util2.hasAddressChanged)(this.trackSntReq.address, currentShippingAddress)) {
                    _logger.$logger.info('address_changed_trigger_snt');
                    _angular.$rootScope.$emit('submission_triggered');
                    return;
                }
                if (!this.flags.instantUpdateShippingRegionSupported) {
                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_instant_update_shipping_region_unsupported');
                    return;
                }
            }

            if (this.flags.wps_SnT_flow || this.isInstantUpdateFlow) {
                /**
                 * During submit , if SnT is triggered , do not allow Pay .
                 */
                if (!this.flags.allowPayWithSnT) {
                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_without_SnT_completion');
                    return;
                }
                // Any SnT Call triggered when xoon updates the address for checkout should not be allowed.
                this.flags.allowSnTCall = false;
            }

            _logger.$logger.info(this.flags.mode + '_submit', {
                type: this.onboard.fiMode === 'bank' ? 'BANK' : this.onboard.card.type,
                country: _index.$locale.country,
                lang: _index.$locale.lang
            }).flush();

            if (this.flags.nationalIdFlag) {
                this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            }

            if (this.flags.mode !== 'signup') {
                delete this.onboard.user.password;
            }

            this.updateAddressOnSubmit();
            this.updatePhoneOnSubmit();

            if (this.onboard.card.type === 'CUP' && this.onboard.card.isCupSecureCard) {
                this.flags.allowSnTCall = true;
                // CUP Secure card is not supported in our flow
                return this.handleFIContingencies({}, 'creditcard');
            }

            var merchantPassedShipping = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');

            _logger.$logger.info('address_normalization', {
                from: 'checkout_guest',
                to: 'prepare_address_normalization',
                shipping_cnty: this.onboard.shipping_address.country,
                is_ship_addr_diff: this.addrDiffDetected,
                is_billing_present: this.models.checkoutCart.billing_address ? true : false,
                is_shipping_present: merchantPassedShipping ? true : false
            });

            if ((0, _index.$feature)('addressNormalization')) {
                this.showAddressNormalizationLightbox = true;
            } else {
                // Making sure incontext shipping methods are populated
                return (0, _ixoUtils.checkIxoShippingMethodsPopulated)(this.ixoModel.ixoShippingMethods, this.models.checkoutAppData).then(function (error) {
                    // if an error message is returned, we populate it
                    if (error) {
                        _this5.errorMessage = error;
                        return;
                    }

                    return _this5.onBoardAccount();
                });
            }
        },
        positionToErrorField: function positionToErrorField() {
            var _this6 = this;

            var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
            var firstErrorField = errorFields && errorFields.length && errorFields[0];

            // Sets the styling for validation on singlePagePaymentForm
            this.validated = true;

            // AB testing - fixes the revious bug of marking the email and password
            // as required when the user selects the 'yes' button for the first time
            this.flags.ignoreValidationTheFirstTime = false;

            if (firstErrorField) {
                firstErrorField.focus();
            } else {
                errorHandlerHelper.scrollToElement();
            }

            $('.backendError:visible').on('blur', function (event) {
                $(_this6).removeClass('backendError');
            });

            if ($('#installments').length) {
                $('#paymentMethod').addClass('ng-invalid');
            } else {
                $('#paymentMethod').removeClass('ng-invalid');
            }

            return true;
        }
    }
});


_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_ul.$ul;

_squid.$contentVersion;

_squid.$experiment;

_squid.$promise;

_squid.$renderContent;

_squid.$pxp;

_squid.$dispatch;

_squid.$meta;

_squid.formatCurrency;

_squid.$elmo;

_index.$Component;

_index.$FallbackError;

_index.$config;

_index.$feature;

_index.$locale;

_index.$util;

_index2.$CheckoutSessionModel;

_index2.$FundingOptionsModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$ShippingAddressModel;

_index2.$InstallmentOptionsModel;

_index3.$CheckoutInputDataModel;

_index4.$ShoppingCartModel;

_index5.$ShippingRuleSummaryModel;

_index6.$InventoryModel;

_index7.$OnboardModel;

_index7.$OnboardUserModel;

_index7.$OnboardPhoneModel;

_index8.$BankModel;

_index8.$CardModel;

_index8.$BillingAddressModel;

_fiApis.$fiApis;

_index9.$AuthModel;

_logger.$logger;

_uiRouter.$state;

_index10.$DeviceInfo;

_index11.$fireMORSBeacon;

_directive.$NationalIdModel;

_util.$fiErrorUtil;

_sticky.setStickyInstrument;

_util2.hasAddressChanged;

_util2.hasDialingCodeOverride;

_util2.redirectToSubscriptionFinalRoute;

_shippingChangeFeature.createShippingChangeFeature;

_pageProps.upopConfirmButtonTextKey;

_pageProps.submitButtonTextKey;

_pageProps.accountExistsOptionalCheck;

_pageProps.getFItoggleContentKeys;

_util3.authflowRedirect;

_util3.sanitizeStateFields;

_constants.RTR_AMOUNT;

_index12.$MerchantPreferenceModel;

_utils.logBuyerFxFpti;

_ixoUtils.retrieveIxoShippingMethods;

_ixoUtils.updateIxoSelectedShippingMethod;

_ixoUtils.retrieveIxoSelectedShippingMethod;

_ixoUtils.checkIxoShippingMethodsPopulated;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/styles.less");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoEmailInput', {
    tag: 'xo-email-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: false
        },
        disabled: {
            type: 'var',
            required: false
        },
        hideHelper: {
            type: 'var', // flow: Optional string, if "signup" then use the Signup tooltip
            required: false
        },
        flags: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.flags = this.flags ? this.flags : {};
            var setEmailToolTip = function setEmailToolTip() {
                _this.emailToolTip = _this.flags.mode === 'signup' ? 'common.emailHelper' : 'common.emailTooltipGuest';
            };

            this.$watch('flags.mode', setEmailToolTip);
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"inputField emailField confidential\" content floating-label directionality>\n    <input ng-model=\"user.email\" id=\"email\" name=\"email\" type=\"email\" value=\"\" autocapitalize=\"off\"\n           aria-required=\"false\" xo-validation='{ \"validator\": \"validEmail\" }' autocomplete=\"off\"\n           data-error-key='email.invalid'\n           ng-disabled=\"disabled\" xo-error-tooltip required />\n    <div class=\"emailHelper\" ng-if=\"!hideHelper\">\n        <button id=\"verifyHelp\"\n           class=\"verifyHelp\"\n           aria-label=\"{{ content('email.whyTooltip') }}\"\n           >\n        </button>\n    </div>\n    <label for=\"email\">\n        {{ content('index.EmailLabel') }}\n    </label>\n    <xo-tooltip trigger=\"#verifyHelp\" ng-if=\"!hideHelper\">\n        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n            <span ng-bind-html=\"htmlContent(emailToolTip)\">\n            </span>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.getErrorType = exports.errorHandler = exports.addFieldError = exports.get3dsPageWarning = exports.getPageError = exports.scrollToElement = undefined;

var _errorHandlerConstants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/errorHandlerConstants.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var SECTION_ELEMENT = '#singlePagePayment';

var scrollToElement = function scrollToElement(fieldName) {
    var element = $('[name=' + fieldName + ']');
    var notifications = $('#notifications');
    var logo = $('#paypalLogo');

    if (element.length) {
        element.focus();
    } else {
        var focusDiv = notifications.length ? notifications : logo;

        // Focus notifications div or logo div
        // This triggers scroll to notifications or logo from
        // hideSpinner() function
        focusDiv.attr('tabindex', '-1').focus();
    }
};

var getPageError = function getPageError(contentKey, compileMessageWith) {
    var messages = [];
    var msg = void 0;

    if (compileMessageWith) {
        msg = (0, _squid.$renderContent)(contentKey, compileMessageWith);
    } else {
        msg = _squid.$locale.content.get(contentKey);
    }

    messages.push(msg);

    scrollToElement();

    return messages;
};

var get3dsPageWarning = function get3dsPageWarning(resolve3DS, contentKey) {
    var messages = [];
    var cardType = resolve3DS.type;
    var cardLast4 = resolve3DS.number;

    messages.push((0, _squid.$renderContent)(contentKey, { cardType: cardType, last4: cardLast4 }));
    scrollToElement();
    return messages;
};

var addFieldError = function addFieldError(errorData) {
    var sectionElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SECTION_ELEMENT;

    (errorData.fields || []).forEach(function (field) {
        var $field = $(sectionElement).find('[ng-model="' + field + '"]');

        $field.addClass('backendError');
    });
};

var getErrorType = function getErrorType(errorCode, mode, treatment) {
    if (errorCode === 'ACCOUNT_ALREADY_EXISTS' && mode !== 'signup' && treatment) {
        return 'info';
    }

    return 'error';
};

/**
 * Highlight the Error Fields by ng-model
 * @param errorData
 * @param element
 * @param modelPrefix
 */
var addFieldErrors = function addFieldErrors(errorData, element, modelPrefix) {

    if (errorData.fields && errorData.fields.length) {
        errorData.fields.forEach(function (field) {
            var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');

            $field.addClass('backendError');
            $field.attr('aria-invalid', true);
        });
    }

    $(element).find('.backendError:first').focus();
};

/**
 * Highlight the Error Fields by element name
 * @param errorData
 * @param element
 * @param modelPrefix
 */
var addFieldErrorsByName = function addFieldErrorsByName(errorData, element, modelPrefix) {

    if (errorData.fields && errorData.fields.length) {
        errorData.fields.forEach(function (field) {
            var fieldName = void 0;

            if (modelPrefix && field.field && field.field.length > 0) {
                // Add prefix with CamelCase of field name
                fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
            } else {
                fieldName = field.field;
            }
            var $field = $(element).find('[name="' + fieldName + '"]');

            $field.addClass('backendError');
            $field.attr('aria-invalid', true);
        });
    }

    $(element).find('.backendError:first').focus();
};

var errorHandler = function errorHandler(message, errorData, positionToErrorField, mode) {
    var sectionElement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : SECTION_ELEMENT;

    var messages = [];
    var prefix = mode === 'guest' ? 'guest' : '';

    // TODO: this block does same thing as next block, need to depricate this
    // Next block has better features and stable on live
    if (errorData && errorData.message === 'VALIDATION_ERROR') {
        angular.forEach(errorData.errorCodes, function (errCode) {

            var validationPageError = _errorHandlerConstants.validationErrorMap[errCode];

            if (validationPageError) {
                messages = getPageError(validationPageError.contentKey);
                _logger.$logger.info('HANDLED_VALIDATION_ERROR', errCode);
            } else {
                // There are multiple services that can throw generic VALIDATION_ERROR.
                // We have chosen to use genericError for the time being since we can't pinpoint the error class.
                messages = getPageError('genericError.genericError');
                _logger.$logger.info('UNHANDLED_VALIDATION_ERROR', errCode);
            }
        });
    }

    var scrollToTop = false;

    angular.forEach(errorData, function (err) {

        // TODO: need to break if case nesting
        if (err) {
            var errElMap = _errorHandlerConstants.errorElementMap[err] || _errorHandlerConstants.errorElementMap[err.errorCode] || _errorHandlerConstants.errorElementMap[err.code];

            if (errElMap) {
                var element = sectionElement + (errElMap.element ? ' ' + errElMap.element : '');

                if (errElMap.name) {
                    // Highlight the Error Fields by name
                    addFieldErrorsByName(errElMap.fields && errElMap || err.details || err, element, errElMap.name);
                } else {
                    // Highlight the Error Fields by ng-model
                    addFieldErrors(errElMap.fields && errElMap || err.details || err, element, errElMap.model);
                }

                if (errElMap.pageError) {
                    // If guest specific content key (guestcontentKey) is not found, then pickup generic content key
                    var contentKey = errElMap.pageError[prefix + 'contentKey'] || errElMap.pageError.contentKey;

                    messages = getPageError(contentKey, errElMap.compileMessageWith);
                    scrollToTop = errElMap.scrollToTop ? true : false;
                }
            } else {
                addFieldError(err);
            }
        }
    });

    if (!scrollToTop) {
        positionToErrorField();
    }

    return messages;
};

exports.scrollToElement = scrollToElement;
exports.getPageError = getPageError;
exports.get3dsPageWarning = get3dsPageWarning;
exports.addFieldError = addFieldError;
exports.errorHandler = errorHandler;
exports.getErrorType = getErrorType;


_errorHandlerConstants.errorElementMap;

_errorHandlerConstants.validationErrorMap;

_squid.$renderContent;

_squid.$locale;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/ixoUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.checkIxoShippingMethodsPopulated = exports.updateIxoSelectedShippingMethod = exports.retrieveIxoSelectedShippingMethod = exports.retrieveIxoShippingMethods = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

/*
 Util function to retrieve Shipping Methods if they exist from parent page.

 @param { $CheckoutAppDataModel } checkoutAppData - Checkout App Data Model
 @returns { Promise<Array> } array of shipping methods if they exist. If not incontext integration, we populate an empty promise @returns { Array }

 */
var retrieveIxoShippingMethods = exports.retrieveIxoShippingMethods = function retrieveIxoShippingMethods(checkoutAppData) {
    var _window = window,
        _window$xprops = _window.xprops;
    _window$xprops = _window$xprops === undefined ? {} : _window$xprops;
    var _window$xprops$supple = _window$xprops.supplement,
        supplement = _window$xprops$supple === undefined ? {} : _window$xprops$supple;


    if (supplement.getPaymentOptions && checkoutAppData) {
        return supplement.getPaymentOptions(checkoutAppData.get('payment_id')).then(function (payment) {

            // in "/v1/payments" there's only 1 transaction in the array always.
            // https://ppaas/api/3719176155268224#apiReference
            var paymentTransaction = payment && payment.transactions && payment.transactions[0];

            return paymentTransaction && paymentTransaction.item_list && paymentTransaction.item_list.shipping_options;
        });
    }

    // return empty promise
    return _angular.$q.when();
};

/*
 Util function to retrieve the Selected Shipping Method if it exists from parent page.

 @param { $CheckoutAppDataModel } checkoutAppData - Checkout App Data Model
 @returns { Promise<Object> } selected shipping method if it exists

 */
var retrieveIxoSelectedShippingMethod = exports.retrieveIxoSelectedShippingMethod = function retrieveIxoSelectedShippingMethod(checkoutAppData) {
    var _window2 = window,
        _window2$xprops = _window2.xprops;
    _window2$xprops = _window2$xprops === undefined ? {} : _window2$xprops;
    var _window2$xprops$suppl = _window2$xprops.supplement,
        supplement = _window2$xprops$suppl === undefined ? {} : _window2$xprops$suppl;


    if (supplement.getPaymentDetails && checkoutAppData) {
        return supplement.getPaymentDetails(checkoutAppData.get('payment_id')).then(function () {
            var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return details.selected_shipping_method;
        });
    }

    return _angular.$q.when();
};

/*
 Util function to update the Selected Shipping Method.

 @param { $CheckoutAppDataModel } checkoutAppData - Checkout App Data Model
 @returns { Promise<void> }

*/
var updateIxoSelectedShippingMethod = exports.updateIxoSelectedShippingMethod = function updateIxoSelectedShippingMethod(checkoutAppData, shippingMethod) {
    var _window3 = window,
        _window3$xprops = _window3.xprops;
    _window3$xprops = _window3$xprops === undefined ? {} : _window3$xprops;
    var _window3$xprops$suppl = _window3$xprops.supplement,
        supplement = _window3$xprops$suppl === undefined ? {} : _window3$xprops$suppl;


    if (supplement.addPaymentDetails && checkoutAppData) {
        return supplement.addPaymentDetails(checkoutAppData.get('payment_id'), {
            selected_shipping_method: shippingMethod
        }).then(function () {
            return shippingMethod;
        });
    }

    return _angular.$q.when();
};

/*
 Util function to make sure Shipping Methods are populated before proceeding with checkout.
 If Shipping Methods are not populated, return an error object

 @param { ixoShippingMethods } Shipping methods populated by incontext.
 @param { $CheckoutAppDataModel } checkoutAppData - Checkout App Data Model
 @returns { Promise<Object> } Error message object to be populated at the top of the page.

 */
var checkIxoShippingMethodsPopulated = exports.checkIxoShippingMethodsPopulated = function checkIxoShippingMethodsPopulated(ixoShippingMethods, checkoutAppData) {
    var _window4 = window,
        _window4$xprops = _window4.xprops;
    _window4$xprops = _window4$xprops === undefined ? {} : _window4$xprops;
    var _window4$xprops$suppl = _window4$xprops.supplement,
        supplement = _window4$xprops$suppl === undefined ? {} : _window4$xprops$suppl;


    if (supplement.getPaymentDetails && checkoutAppData && ixoShippingMethods) {

        return supplement.getPaymentDetails(checkoutAppData.get('payment_id')).then(function (details) {
            if (!(details && details.selected_shipping_method)) {

                return {
                    type: 'error',
                    msgKeys: ['shipping.bopisErrorMessage']
                };
            }
        });
    }

    // return empty promise
    return _angular.$q.when();
};

_angular.$q;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/pageProps.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getFItoggleContentKeys = exports.accountExistsOptionalCheck = exports.submitButtonTextKey = exports.upopConfirmButtonTextKey = undefined;

var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");

var _constants2 = __webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/constants.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var upopConfirmButtonTextKey = function upopConfirmButtonTextKey(flags) {
    if (flags.wpsFlow) {
        return 'confirmUpop.confirmAndContinue';
    } else if (flags.commit) {
        return 'confirmUpop.confirmAndPay';
    }

    return 'confirmUpop.confirmAndContinueToMerch';
};

var getCommitOrContinueText = function getCommitOrContinueText(flags, mode, showSignupCompliance, hasConversion) {
    var showCurrency = mode === 'guest' && (flags.buyerFxTreatment || '').includes('treatment_2') && hasConversion;
    var commitType = flags.commit ? 'commit' + (showCurrency ? 'InCurrency' : '') : 'notCommit' + (showCurrency ? 'InCurrency' : '');
    var group = showSignupCompliance ? 'US' : 'ROW';

    return _constants.SUBMIT_BUTTON_TEXT_KEY_MAP[mode][group][commitType];
};

var submitButtonTextKey = function submitButtonTextKey(flags, showSignupCompliance, hasConversion, isSubscription) {
    var mode = flags.mode === 'signup' ? 'signup' : 'guest';

    if (flags.show_poma_ui) {
        mode = flags.poma_flow ? 'pomaSignup' : 'guest';
    }

    return mode === 'signup' && isSubscription ? _constants.SUBSCRIPTION_SUBMIT_BUTTON_KEY : getCommitOrContinueText(flags, mode, showSignupCompliance, hasConversion);
};

var accountExistsOptionalCheck = function accountExistsOptionalCheck() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'guest';
    var isPOMA = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    angular.element('#email').removeClass('backendError');

    if (mode === 'guest' && !isPOMA) {
        // Optional signup only!
        (0, _angular.$timeout)(function () {
            // Angular.element causes digest cycle error. Hence switching to document.querySelector.
            document.querySelector('#guestSignup2').click();
        }, 0);
    } else if (isPOMA) {
        // POMA flow
        (0, _angular.$timeout)(function () {
            angular.element('#saveMyInfo').click();
        }, 0);
    }
};

// Returns keys depending on the specific flow. (e.g, Tesla add bank)
var getFItoggleContentKeys = function getFItoggleContentKeys(teslaAddBank, teslaFIDefault) {

    if (!teslaAddBank) {
        return _constants2.DEFAULT_TOGGLE_FI;
    }

    // Treatment A - 'bank' selected as default.
    if (teslaAddBank && teslaFIDefault === 'bank') {
        return _constants2.TESLA_TOGGLE_FI_BANK;
    }

    // Treatment B - 'card' selected as default.
    return _constants2.TESLA_TOGGLE_FI_CARD;
};

exports.upopConfirmButtonTextKey = upopConfirmButtonTextKey;
exports.submitButtonTextKey = submitButtonTextKey;
exports.accountExistsOptionalCheck = accountExistsOptionalCheck;
exports.getFItoggleContentKeys = getFItoggleContentKeys;


_constants.SUBMIT_BUTTON_TEXT_KEY_MAP;

_constants.SUBSCRIPTION_SUBMIT_BUTTON_KEY;

_constants2.DEFAULT_TOGGLE_FI;

_constants2.TESLA_TOGGLE_FI_BANK;

_constants2.TESLA_TOGGLE_FI_CARD;

_angular.$timeout;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.createShippingChangeFeature = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _factory = __webpack_require__("../node_modules/xo-shipping-change/src/factory.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature(token, models, flags) {
    var feature = {
        message: '',
        showForm: false,
        interstitialResolver: null,

        showCartChanged: function showCartChanged() {},
        showOrResolveInterstitial: function showOrResolveInterstitial() {},
        handleOnShippingChange: function handleOnShippingChange() {}
    };

    feature.showCartChanged = function () {
        flags.showCartChanged = true;
    };

    feature.showOrResolveInterstitial = function (cartHasChanged, rejected) {
        if (rejected) {
            feature.message = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
                merchant: models.checkoutAppData.getMerchantDisplayName()
            });
            feature.showForm = true;

            return feature.showCartChanged();
        }

        if (cartHasChanged) {
            feature.message = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: models.checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
            });
            feature.showForm = false;

            return feature.showCartChanged();
        }

        feature.interstitialResolver();
    };

    feature.handleOnShippingChange = function () {

        if (!window.xprops || !window.xprops.onShippingChange) {
            return (0, _squid.$promise)();
        }

        var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');

        _squid.$event.emit('loading');
        _squid.$event.emit('loadingMessage', loadingMsg);

        flags.showCartChanged = false;

        var checkoutSession = _index.$CheckoutSessionModel.instance(token);
        var shippingChangeFactory = (0, _factory.$ShippingChangeFactory)(token, models.checkoutAppData, checkoutSession, models.checkoutCart);

        return shippingChangeFactory.getPayload().then(function (payload) {
            _logger.$logger.info('shipping_change_payload_recieved', payload);
            return shippingChangeFactory.callOnShippingChange(payload);
        }).then(function (_ref) {
            var cartHasChanged = _ref.cartHasChanged,
                rejected = _ref.rejected;

            _logger.$logger.info('shipping_change_called', { cartHasChanged: cartHasChanged, rejected: rejected });

            _squid.$event.emit('loaded');

            /**
             * There's currently a pending promise that's
             * waiting on a successful response from the interstitial
             * in order to continue.
             */
            if (feature.interstitialResolver) {
                return feature.showOrResolveInterstitial(cartHasChanged, rejected);
            }

            return _squid.$promise.resolver(function (resolve) {
                feature.interstitialResolver = resolve;
                return feature.showOrResolveInterstitial(cartHasChanged, rejected);
            });
        })['catch'](function (err) {
            _squid.$event.emit('loaded');
            _logger.$logger.error('shipping_change_error', err);

            return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
        });
    };

    return feature;
};

_squid.$promise;

_squid.$renderContent;

_squid.$locale;

_squid.$event;

_uiRouter.$state;

_index.$CheckoutSessionModel;

_factory.$ShippingChangeFactory;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.sanitizeStateFields = exports.authflowRedirect = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var authflowRedirect = function authflowRedirect(_ref) {
    var isCheckAuthflowRedirectParam = _ref.isCheckAuthflowRedirectParam,
        country = _ref.country;

    if (isCheckAuthflowRedirectParam) {
        return (0, _squid.$elmo)('xo_xoon_account_already_exists', { 'ctx.COUNTRY': country }, 'xo_xoon_account_already_exists_treatment').then(function (result) {
            return Boolean(result);
        });
    }
    return _squid.$promise.resolve(false);
};

// There are two ways to prefill state related info.
// NVP and REST integration. For NVP the shippingAddress.state || billingAddress.state is capitalized before landing here
// REST does not do any capitalization.
// In order to make prefilling consistent across all integrations, we convert them to uppercase!
var sanitizeStateFields = function sanitizeStateFields(shippingAddress, billingAddress) {
    if (shippingAddress && shippingAddress.state) {
        shippingAddress.state = shippingAddress.state.toUpperCase();
    }

    if (billingAddress && billingAddress.state) {
        billingAddress.state = billingAddress.state.toUpperCase();
    }
};

exports.authflowRedirect = authflowRedirect;
exports.sanitizeStateFields = sanitizeStateFields;


_squid.$promise;

_squid.$elmo;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/styles.less");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoNationality', {
    tag: 'xo-nationality',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: true
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var bindLocalizedCountries = function bindLocalizedCountries() {

                var guestBlockedCountries = _squid.$config.guestBlockedCountries || [];

                _this.metadata = angular.copy(_squid.$locale.metadata);

                _this.countries = _this.metadata.territory.filter(function (c) {
                    // don't show the blocked countries in the dropdown
                    return !(guestBlockedCountries.indexOf(c.code) > -1);
                });
            };

            bindLocalizedCountries();
            this.$on('metadataChange', bindLocalizedCountries);
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$config;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalityDropDown\" class=\"dropdown confidential nationality clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown id=\"nationality\"\n            name=\"nationality\"\n            ng-model=\"user.nationality\"\n            ng-options=\"countryList.code as countryList.name for countryList in countries | filter: {country: '!others'} | filter: {country: '!change'}\"\n            aria-labelledby=\"nationalityLabel\"\n            xo-error-tooltip\n            required>\n    </select>\n    <label id=\"nationalityLabel\" for=\"nationality\">{{ content('country.nationality') }}</label>\n</div>"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/frs/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index6 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _contentKeys = __webpack_require__("../node_modules/xo-guest-components/src/lib/contentKeys.js");

var _pxpExperimentConstants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/pxpExperimentConstants.js");

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/guest/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoOnboardOptions', {
    tag: 'xo-onboard-options',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        flags: {
            type: 'var',
            required: false
        },
        mode: {
            type: 'var',
            required: false
        },
        onboard: {
            type: 'var',
            required: false
        },
        singlePagePaymentForm: {
            type: 'var',
            required: false
        },
        validated: {
            type: 'var',
            required: false
        },
        sepa: {
            type: 'var',
            required: false
        },
        merchant: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutInputData: _index2.$CheckoutInputDataModel.instance(this.token).retrieve(),
                payee: _index3.$CheckoutPayeeModel.instance(this.token).retrieve(),
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.token).retrieve(),
                flowEligibility: _index3.$FlowEligibilityModel.instance(this.token).retrieve()
            };
        },
        pomaExperiment: function pomaExperiment() {
            if (this.mode === 'guest') {
                return {
                    poma: (0, _index.$pxp)('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': _index.$locale.country }, '(XO_XOONBOARDING_POMA_GLOBAL_)(.*)')
                };
            }
        },
        populateFlags: function populateFlags(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                // Saving various flow indicators in to flags for future use.
                // These flags can be reused in this file instead of referring it from models always
                var _ref = models.payee || {},
                    _ref$merchant = _ref.merchant;

                _ref$merchant = _ref$merchant === undefined ? {} : _ref$merchant;
                var id = _ref$merchant.id;

                // is_wps_flow indicator in checkoutAppData will be undefined for ebay flows
                // isEbaytxn() will be true only for prox flows.

                var flowFLags = {
                    isWpsFlow: models.checkoutAppData.is_wps_flow(),
                    isEcFlow: !models.checkoutAppData.is_wps_flow() && !models.checkoutInputData.isEbayTxn(),
                    isInvoiceFlow: models.checkoutAppData.isInvoiceFlow(),
                    isWpsSubscription: models.checkoutAppData.is_wps_subscription_flow(),
                    isSubscriptionsV1: models.checkoutCart.isSubscriptionsV1(),
                    isRP: models.checkoutCart.get('billing.type') === 'RECURRING_PAYMENTS',
                    showBAContent: models.checkoutCart.isBilling() && !models.checkoutCart.isWalletTokenization(),
                    tokenWalletization: models.checkoutCart.isWalletTokenization()
                };

                Object.assign(_this.flags, flowFLags);
                _this.flags.flowName = flowFLags.isEcFlow ? 'ec' : 'wps';

                return _index4.$MerchantPreferenceModel.instance(id).retrieve().then(function (merchantPreferences) {
                    _this.flags.merchantPreferences = merchantPreferences;
                });
            });
        },
        experiments: function experiments() {
            return {
                optionalSignupContent: (0, _index.$pxp)('xoon_optional_signup_content_change', { 'ctx.COUNTRY': _index.$locale.country }, '(xoon_optional_signup_content_change_)(.*)'),
                marketingOfferTitleContentExp: (0, _index.$pxp)('xoon_forced_signup_buyer_protection_content', { 'ctx.COUNTRY': _index.$locale.country }, '(xoon_forced_signup_buyer_protection_content_)(.*)')
            };
        },
        freeReturnShippingExperiments: function freeReturnShippingExperiments(resolvers) {
            var _this2 = this;

            return resolvers.populateFlags.then(function () {
                var ecSignupWalletTokenization = _this2.flags.isEcFlow && _this2.mode === 'signup' && _this2.flags.tokenWalletization;

                var wpsAutoreturnPdtEnabled = _this2.flags.isWpsFlow && (_this2.flags.merchantPreferences.autoReturn() || _this2.flags.merchantPreferences.pdtEnabled());

                // frs content not applicable for prox flows.
                // frs content not applicable for when cart has TOKENIZED_WALLET and mode is signup
                // frs content not applicable for when autoreturns/pdt present in merchant preferences
                // frs content not applicable for split screen experience
                if (!wpsAutoreturnPdtEnabled && !ecSignupWalletTokenization && (_this2.flags.isWpsFlow || _this2.flags.isEcFlow)) {
                    var pageName = _pxpExperimentConstants2['default'].test['frsPageName'][_this2.flags.flowName][_this2.mode];

                    return (0, _index.$pxp)(pageName, { 'ctx.COUNTRY': _index.$locale.country }, pageName + '_(.*)');
                }
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        },
        populate: function populate() {
            var _this3 = this;

            this.showBillingAgreementText = this.flags.showBAContent && !this.flags.isRP && !this.flags.isWpsSubscription && !this.flags.isSubscriptionsV1;
            this.showRpAgreementText = this.flags.showBAContent && (this.flags.isRP || this.flags.isWpsSubscription || this.flags.isSubscriptionsV1);
            this.contentKeys = {};
            this.frsContentKeys = {};

            this.showMarketingOffers = function () {
                return !_this3.flags.allowChoice && !_this3.models.checkoutCart.isWalletTokenization() && !_this3.flags.freeReturnShippingOptInFlowApplicable && !_this3.flags.titleSubtitlePxpTreatment;
            };

            var setUnbrandedContent = function setUnbrandedContent() {
                _this3.onboardTitleLine1 = _this3.isUnbranded ? 'common.getBenefitsUnBrandedLine1' : 'common.getBenefitsLine1';
                _this3.subTitle = _this3.isUnbranded ? 'common.createPayPalUnBrandedProp' : 'common.createPayPalProp';
                _this3.paypalSubTitle = _this3.isUnbranded ? 'common.createPayPalUnBrandedSubTitle' : 'common.createPayPalSubTitle';
                _this3.guestSignup1 = _this3.isUnbranded ? 'common.yesCreateUnBrandedAccount' : 'common.yesCreateAccount';
                _this3.guestSignup2 = _this3.isUnbranded ? 'common.nothanksUnBranded' : 'common.nothanks';
            };

            setUnbrandedContent();

            var contentOpts = {
                $config: _index.$config,
                cart: this.models.checkoutCart,
                appData: this.models.checkoutAppData,
                locale: this.locale
            };

            this.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
            this.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);

            /**
             * show WPS interstitial page, if
             * 1. its optional sign up flow and
             * 2. not multistep flow and not DE
             * 3. merchant pref not have pdt or auto return and
             * 4. one touch throttle is not control
             * 5. wps interstitial throttle return treatment experiment
             **/
            var checkWPSInterstitialEligibility = function checkWPSInterstitialEligibility() {
                if (!_this3.flags.isWpsFlow) {
                    return;
                }

                if (_this3.flags.isWpsSubscription) {
                    _logger.$logger.info('wps_interstitial_not_eligible_for_wps_subscription_flow');
                    return;
                }

                if (_this3.mode === 'signup') {
                    _logger.$logger.info('wps_interstitial_not_eligible_force_signup');
                    return;
                }

                if (_this3.flags.merchantPreferences) {
                    var autoReturnEnabled = (0, _index.$feature)('wpsMerchantAutoReturn', false) && _this3.flags.merchantPreferences.autoReturn();

                    if (autoReturnEnabled) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_auto_return');
                        return;
                    }

                    var pdtEnabled = (0, _index.$feature)('wpsMerchantPdt', false) && _this3.flags.merchantPreferences.pdtEnabled();

                    if (pdtEnabled) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_pdt_enabled');
                        return;
                    }
                }

                _logger.$logger.info('wps_interstitial_pxp_eligible_show_guestonly_and_wps_interstitial');
                _this3.flags.wpsInterstitialEligible = true;
                _this3.mode = 'guestonly';
            };

            var setEcPomaFlag = function setEcPomaFlag() {
                var _pomaExperiment$poma = _this3.pomaExperiment.poma;
                _pomaExperiment$poma = _pomaExperiment$poma === undefined ? {} : _pomaExperiment$poma;
                var _pomaExperiment$poma$ = _pomaExperiment$poma.treatment_name,
                    treatment_name = _pomaExperiment$poma$ === undefined ? [] : _pomaExperiment$poma$;


                if (treatment_name.includes('XO_XOONBOARDING_POMA_GLOBAL_TREATMENT')) {
                    _logger.$logger.info('checkout_fpti', { is_poma: 1 });
                    _this3.flags.wpsInterstitialEligible = false;
                    _this3.flags.showPomaUi = true;
                    _this3.POMAContentType = treatment_name.includes('TREATMENT_A') ? 'TREATMENT_A' : 'TREATMENT_B';
                }
            };

            var setOptionalSignupPromotionContent = function setOptionalSignupPromotionContent() {
                if (_this3.mode !== 'guest') {
                    return;
                }

                var optionSignupContentPXP = _this3.experiments.optionalSignupContent;

                if (optionSignupContentPXP && optionSignupContentPXP.treatment_name) {
                    var treatmentContentKeys = _pxpExperimentConstants2['default'].test['xoon_optional_signup_content_change'][optionSignupContentPXP.treatment_name];

                    _this3.contentKeys = treatmentContentKeys ? treatmentContentKeys : {};
                }
            };

            // This Marketing Header is set for IN guest experience users where the header title and subtitle are updated based on the PXP value.
            var setINMarketingOfferContent = function setINMarketingOfferContent() {
                if (_this3.mode !== 'signup' || _index.$locale.country !== 'IN') {
                    return;
                }

                _this3.flags.marketingOfferTitleContentExp = false;
                _this3.marketingOfferTitleContentExpContentKeys = {};

                var marketingOfferTitleContentExp = _this3.experiments.marketingOfferTitleContentExp;

                if (marketingOfferTitleContentExp && marketingOfferTitleContentExp.treatment_name) {
                    var treatmentContentKeys = _pxpExperimentConstants2['default'].test['xoon_forced_signup_buyer_protection_content'][marketingOfferTitleContentExp.treatment_name];
                    // Check whether the treatment key exists or is it a control. This will set the marketingOfferTitleContentExp variable as false so that the control text is rendered.

                    if (treatmentContentKeys) {
                        _this3.flags.marketingOfferTitleContentExp = true;
                        _this3.marketingOfferTitleContentExpContentKeys = treatmentContentKeys ? treatmentContentKeys : {};

                        _logger.$logger.info('xoon_forced_signup_buyer_protection_content', {
                            message: marketingOfferTitleContentExp.treatment_name
                        });
                    }
                }
            };

            var handleFrsContingency = function handleFrsContingency(message) {
                _logger.$logger.info('free_return_shipping_applicability_check_merchant_' + message);
                return false;
            };

            var handleFrsError = function handleFrsError(message, error) {
                _logger.$logger.info('free_return_shipping_applicability_check_merchant_' + message, error);
                return false;
            };

            var checkMerchantApplicabilityForFRS = function checkMerchantApplicabilityForFRS() {
                if (_index.$config.deploy.isLocal() || _index.$config.deploy.isStage()) {
                    // URL param used in Dev and Staging environment for testing purpose
                    var passedInVal = _index.$util.param('frsMerchantCheck');

                    if ('off'.includes(passedInVal)) {
                        _logger.$logger.info('skipping_frs_merchant_applicability_check');
                        return _angular.$q.when(true);
                    }
                }

                var frsMerchantApplicabilityModel = new _index5.$FreeReturnShippingApplicabilityModel();

                var merchantApplicabilityRequest = {
                    context: 'MERCHANT',
                    merchantId: _this3.models.payee.get('merchant.id')
                };

                _logger.$logger.info('checkout_fpti', {
                    from: 'frs_flow_applicability',
                    to: 'prepare_frs_merchant_applicability'
                });

                // Once throttling of FRS experience is complete, we need to perform FRS applicability check in resolvers
                return frsMerchantApplicabilityModel.save({
                    data: merchantApplicabilityRequest,
                    success: function success(frsApplicabilityResponse) {
                        _logger.$logger.info('checkout_fpti', {
                            from: 'frs_flow_applicability',
                            to: 'process_frs_merchant_applicability',
                            eligibility_reason: frsApplicabilityResponse && frsApplicabilityResponse.applicable
                        });

                        return frsApplicabilityResponse && frsApplicabilityResponse.applicable;
                    },
                    contingencies: {
                        FRS_APPLICABILITY_ERROR: function FRS_APPLICABILITY_ERROR() {
                            return handleFrsContingency('FRS_APPLICABILITY_ERROR');
                        },
                        VALIDATION_ERROR: function VALIDATION_ERROR() {
                            return handleFrsContingency('VALIDATION_ERROR');
                        },
                        DEFAULT: function DEFAULT() {
                            return handleFrsContingency('UNHANDLED_CONTINGENCY');
                        }
                    },
                    validation: function validation(err) {
                        return handleFrsError('SERVICE_VALIDATION_ERROR', err);
                    },
                    error: function error(err) {
                        return handleFrsError('SERVICE_ERROR', err);
                    }
                });
            };

            var checkFrsFlowApplicability = function checkFrsFlowApplicability() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    treatment_name = _ref2.treatment_name;

                var flowType = arguments[1];

                var frsApplicableTreatments = _pxpExperimentConstants2['default'].test['frs_applicable_treatments'];
                var isTreatmentApplicable = (frsApplicableTreatments[flowType] || []).includes(treatment_name);

                _logger.$logger.info('checkout_fpti', {
                    from: 'frs_flow_applicability',
                    to: 'prepare_frs_optin_flow_applicability'
                });

                /**
                 * Invoke FRS check applicability API to determine eligible vs ineligible traffic for both test and control group
                 * When FRS treatment flow is applicable and FRS merchant applicability is true, FRS experience will be shown to user
                 * When FRS control flow is applicable, FRS experience will not be shown to user. Hence, return frs as not applicable
                 */
                return checkMerchantApplicabilityForFRS().then(function (isFrsApplicable) {
                    var isFlowApplicable = isTreatmentApplicable ? isFrsApplicable : false;

                    _logger.$logger.info('checkout_fpti', {
                        from: 'frs_flow_applicability',
                        to: 'process_frs_optin_flow_applicability',
                        eligibility_reason: isFlowApplicable
                    });

                    return isFlowApplicable;
                });
            };

            var setFreeReturnShippingEligibilityFlags = function setFreeReturnShippingEligibilityFlags() {
                if (_this3.flags.showPomaUi) {
                    _logger.$logger.info('POMA_UI_enabled_free_return_shipping_feature_not_applicable');
                    return false;
                }

                // pxp treatments for FRS present only for wps optional/signup or EC optional/signup
                var frsExp = _this3.freeReturnShippingExperiments;

                if (frsExp) {
                    var flowType = _pxpExperimentConstants2['default'].test['frsPageName'][_this3.flags.flowName][_this3.mode];

                    checkFrsFlowApplicability(frsExp, flowType).then(function (frsFlowApplicable) {
                        if (frsFlowApplicable) {
                            _logger.$logger.info('free_return_shipping_optin_flow_applicable');

                            _this3.flags.freeReturnShippingOptInFlowApplicable = true;
                            /**
                             * Set whether FRS opt-in flow is Active (true) or Silent (false)
                             * Active flow - When opt-in involves explicit user action like activate button, checkbox.
                             * Silent flow - When opt-in doesn't have user action and performed automatically with account signup flow.
                             */
                            _this3.flags.freeReturnShippingOptInActiveFlow = false;

                            _this3.onboard.frs_optin_flow_applicable = true;
                            _this3.onboard.frs_optin_active_flow = false;

                            if (_this3.flags.wpsInterstitialEligible) {
                                _this3.flags.freeReturnShippingApplicableTreatment = frsExp.treatment_name;
                            } else {
                                _this3.frsNonWpsInterstitalFlow = true;
                                var treatmentContentKeys = _pxpExperimentConstants2['default'].test[flowType][frsExp.treatment_name];

                                _this3.frsContentKeys = treatmentContentKeys ? treatmentContentKeys : {};
                            }
                        }
                    });
                }
            };

            var setFlagsPostFlowEligibility = function setFlagsPostFlowEligibility() {
                var trackingModes = ['guest', 'guestonly'];

                _this3.flags.track_submit_transition = trackingModes.includes(_this3.mode) ? 'guest_xo' : 'signup';

                checkWPSInterstitialEligibility();
                setOptionalSignupPromotionContent();
                setINMarketingOfferContent();

                // POMA - Passwordless Onboarding of Member Accounts
                if (_this3.mode === 'guest' && _index.$locale.country === 'US' && !_index6.$DeviceInfo.isWebView()) {
                    if (!_this3.flags.isWpsFlow && !_this3.flags.isInvoiceFlow) {
                        setEcPomaFlag();
                    }
                }

                _this3.flags.mode = _this3.mode;
                _this3.flags.signupEnabled = _this3.mode !== 'guestonly';
                _this3.flags.allowChoice = _this3.mode !== 'signup';

                // Initialize showDisabledPasswordField to true.
                // NOTE: We use the if condition to check for undefined so the variable is assigned only once.
                // This method is called on every locale change, so we don't want it to be true on every change.
                // In future cases, signupSelected and guestSelected will set it accordingly.
                if (_this3.flags.showDisabledPasswordField === undefined) {
                    _this3.flags.showDisabledPasswordField = true;
                }

                // Set Free Return Shipping Opt-in eligibility flags
                setFreeReturnShippingEligibilityFlags();
            };

            setFlagsPostFlowEligibility();
        }
    },
    actions: {
        setBuyerModeFlags: function setBuyerModeFlags(newValue) {
            switch (newValue) {
                case 'guest':
                case 'guestonly':
                    // show disabled password field for variant2
                    this.flags.showDisabledPasswordField = true;
                    _logger.$logger.info('Guest_Signup_No');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_xo';
                    break;
                case 'signup':
                    // hide disabled password field
                    this.flags.showDisabledPasswordField = false;
                    this.flags.ignoreValidationTheFirstTime = true;
                    _logger.$logger.info('Guest_Signup_Yes');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_optional_signup';
                    break;
                default:
                // Do Nothing
            }
            this.accountCreationSectionErrorMessage = '';
            $('.signupFieldsContainer .radioButton').removeClass('warning');
            _uiRouter.$state.current.trackingData.pageQualifier = newValue;
            return true;
        },
        triggerTimerForSignupClicked: function triggerTimerForSignupClicked() {
            if (window.performance) {
                _logger.$logger.info('sign up option clicked, start timer...', window.performance.now());
                this.$emit('signupClickedTimerStarted', window.performance.now());
            }
        },
        onCheckedSavedMyInfo: function onCheckedSavedMyInfo($event) {
            if ($event.target.checked) {
                // populating the legal terms key to send the TCPA details to OAS later during onboarding
                this.flags.tcpa_identifier = 'poma.legalTerms';
                this.flags.poma_flow = true;
                this.flags.track_submit_transition = 'poma_signup';
                $('.pomaFieldsContainer').addClass('focusBorder');
                $('.pomaFieldsContainer').addClass('active');
                _logger.$logger.info('POMA_CHECKBOX_SELECTED');
                if ($('#pomaSubmit').offset()) {
                    window.scrollTo(0, this.$element.parent().find('#pomaSubmit').offset().top);
                }
            } else {
                this.flags.tcpa_identifier = undefined;
                this.flags.poma_flow = false;
                this.flags.track_submit_transition = 'guest_xo';
                $('.pomaFieldsContainer').removeClass('focusBorder');
                $('.pomaFieldsContainer').removeClass('active');
                _logger.$logger.info('POMA_CHECKBOX_DESELECTED');
            }
        }
    }
});


_index.$Component;

_index.$locale;

_index.$pxp;

_index.$config;

_index.$util;

_index.$feature;

_angular.$q;

_index2.$CheckoutInputDataModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index3.$FlowEligibilityModel;

_index4.$MerchantPreferenceModel;

_index5.$FreeReturnShippingApplicabilityModel;

_logger.$logger;

_uiRouter.$state;

_index6.$DeviceInfo;

_contentKeys.getBAContentKey;

_contentKeys.getRPContentKey;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/guest/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoGuestOptions', {
    tag: 'xo-guest-options',
    template: _template2['default'],

    props: {
        flags: {
            type: 'var',
            required: false
        },
        onboard: {
            type: 'var',
            required: false
        },
        singlePagePaymentForm: {
            type: 'var',
            required: false
        },
        validated: {
            type: 'var',
            required: false
        },
        sepa: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                guestEconsentAMLD4Pxp: (0, _squid.$pxp)('xo_xoonboarding_guest_econsent_amld4', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_xoonboarding_guest_econsent_amld4)(.*)')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.showGuestAMLD4Terms = false;
            var _$config$AMLRuleCount = _squid.$config.AMLRuleCountries,
                AMLRuleCountries = _$config$AMLRuleCount === undefined ? [] : _$config$AMLRuleCount;


            this.isAmlCountry = AMLRuleCountries.includes(_squid.$locale.country);
        },
        populate: function populate() {
            var _this = this;

            var getAMLGuestTermsContentKey = function getAMLGuestTermsContentKey() {
                var _experiments$guestEco = _this.experiments.guestEconsentAMLD4Pxp;
                _experiments$guestEco = _experiments$guestEco === undefined ? {} : _experiments$guestEco;
                var _experiments$guestEco2 = _experiments$guestEco.treatment_name,
                    treatment_name = _experiments$guestEco2 === undefined ? [] : _experiments$guestEco2;


                if (treatment_name.includes('xo_xoonboarding_guest_econsent_amld4_test')) {
                    _this.showGuestAMLD4Terms = true;
                    return _this.onboard.fiMode === 'bank' ? 'signupTerms.guestEconsentBankTermsAMLD4' : 'signupTerms.guestEconsentTermsAMLD4';
                }
                // either its control or PXP error, default to existing guest AML rules
                return 'signupTerms.guestAML4Rule';
            };

            this.$watch('onboard.fiMode', function (newVal) {
                _this.econsentKey = _this.isAmlCountry ? getAMLGuestTermsContentKey() : 'signupTerms.guest';
            });
        }
    },
    actions: {
        openSepa: function openSepa() {
            this.props.sepa.show = true;
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$config;

_squid.$pxp;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/guest/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"guestOption\" content>\n    <div ng-if=\"flags.buyerMode === 'guest' || flags.mode === 'guestonly'\"\n         ng-class=\"{'signupFieldsContainer': !flags.signupEnabled, 'signupFields': flags.mode === 'guest'}\">\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"econsentGuest\" ng-if=\"!showGuestAMLD4Terms\">\n            <div id=\"errorGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestagree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestagree\" type=\"checkbox\" name=\"guestagree\" id=\"guestagree\" required aria-describedby=\"errorGuestAgree\"/>\n            <label class=\"noBottom\" for=\"guestagree\" ng-bind-html=\"htmlContent(econsentKey, {country:locale.country, lang:locale.lang})\" aria-describedby=\"errorGuestAgree\"></label>\n        </div>\n        <div class=\"row-fluid legal\" feature=\"econsentGuest\" ng-if=\"showGuestAMLD4Terms\">\n            <p class=\"noBottom\" id=\"guestAmld4Terms\" ng-bind-html=\"htmlContent(econsentKey, {country:locale.country, lang:locale.lang})\"></p>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"guestTerms\">\n            <div id=\"errorGuestTerms\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestTerms.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestTerms\" type=\"checkbox\" name=\"guestTerms\" id=\"guestTerms\" required aria-describedby=\"errorGuestTerms\"/>\n            <label class=\"noBottom\" for=\"guestTerms\" ng-bind-html=\"htmlContent('signupTerms.guestTerms', {country:locale.country, lang:locale.lang})\" aria-describedby=\"errorGuestTerms\"></label>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.show_sepa_overlay\">\n            <div id=\"errorSepaGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaGuestAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"sepa.sepaGuestAgree\" type=\"checkbox\" name=\"sepaGuestAgree\" id=\"sepaGuestAgree\" required aria-describedby=\"errorSepaGuestAgree\"/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaGuestAgree\"\n                   bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                   aria-describedby=\"errorSepaGuestAgree\"></label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.signupLib = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var getIsGDPRCountry = function getIsGDPRCountry() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$locale.country;

    // Refer to config.GDPR for countries list
    return _squid.$util.getProperty(_squid.$config, 'GDPR.countries', { 'default': [] }).indexOf(country) > -1;
};

var getMarketingOptinShowHide = function getMarketingOptinShowHide() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$locale.country;
    var isGDPRCountry = arguments[1];

    if (isGDPRCountry) {
        return true;
    }

    // GDPR config overrides all country specific config
    return (0, _squid.$feature)('marketingOptinMember', false, country);
};

var getMarketingOptinIsChecked = function getMarketingOptinIsChecked() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$locale.country;
    var isGDPRCountry = arguments[1];

    // If GDPR country, then check for marketing opt-in
    // unchecked countries list in GDPR config object
    if (isGDPRCountry) {
        return _squid.$util.getProperty(_squid.$config, 'GDPR.marketingOptinUncheckedCountries', { 'default': [] }).indexOf(country) < 0;
    }

    // GDPR config overrides all country specific config
    return (0, _squid.$feature)('checkMarketingOptIn', false, country);
};

var getMarketingOptinContentKey = function getMarketingOptinContentKey() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$locale.country;
    var isGDPRCountry = arguments[1];

    if (isGDPRCountry) {
        return 'signupTerms.GDPRAgreeMarketing';
    }

    // GDPR config overrides all country specific config
    return 'signupTerms.agreeMarketing';
};

var getSignupTermsContentKey = function getSignupTermsContentKey() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$locale.country;
    var isGDPRCountry = arguments[1];
    var fiMode = arguments[2];


    if (country === 'US') {
        return 'signupTerms.signupTCPA3';
    }

    // GDPR pxp treatment check
    if (isGDPRCountry) {
        return fiMode === 'bank' ? 'signupTerms.GDPRAgreeTermsBank' : 'signupTerms.GDPRAgreeTerms';
    }

    // We dont need to check for Bank here as DE (Bank payment enabled) is a GDPR country
    return 'signupTerms.signupC';
};

var signupLib = {
    getIsGDPRCountry: getIsGDPRCountry,
    getMarketingOptinIsChecked: getMarketingOptinIsChecked,
    getMarketingOptinShowHide: getMarketingOptinShowHide,
    getMarketingOptinContentKey: getMarketingOptinContentKey,
    getSignupTermsContentKey: getSignupTermsContentKey
};

exports.signupLib = signupLib;


_squid.$util;

_squid.$locale;

_squid.$feature;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/place-of-birth/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/gender-type/directive.js");

var _helper = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoSignupOptions', {
    tag: 'xo-signup-options',
    template: _template2['default'],

    props: {
        flags: {
            type: 'var',
            required: false
        },
        onboard: {
            type: 'var',
            required: false
        },
        singlePagePaymentForm: {
            type: 'var',
            required: false
        },
        validated: {
            type: 'var',
            required: false
        },
        sepa: {
            type: 'var',
            required: false
        },
        guestUpgrade: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                // countries in the contextual rules
                // "GB,"FR","ES","IE","PL","CY","BG","BE","CZ","DK","EE","FI",
                // "GF","GI","GP","GR","HU","LV","LI","LT","LU","MT","MQ","PT",
                // "RE","RO","SM","SK","SI","SE","NO","AT","NL","IT","DE"
                nationalityThrottle: (0, _index.$pxp)('xo_xoonboarding_eu_nationality_throttle', { 'ctx.COUNTRY': _index.$locale.country }, '(xo_xoonboarding_eu_nationality_throttle_)(.*)')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
            this.flags.nationalIdFlag = _index.$config.nationalIdRequiredCountries && _index.$config.nationalIdRequiredCountries.indexOf(this.locale.country) > -1;
            this.isGenderFieldEnabled = (0, _index.$feature)('gender', false, this.locale.country);
            this.showNationalityField = (0, _index.$feature)('nationalityRequired', false, this.locale.country);
        },
        populate: function populate() {
            var _this = this;

            var isGDPRCountry = _helper.signupLib.getIsGDPRCountry(this.locale.country);

            // Market Opt-in display and checked by default is based on config settings
            this.showMarketingOptin = _helper.signupLib.getMarketingOptinShowHide(this.locale.country, isGDPRCountry);

            // By default, if we are not showing a checkbox for marketing opt-in
            // then, get all signup/POMA users opted-in for marketing emails
            // Setting the flag to null as per GDPR team requirement
            if (!this.showMarketingOptin) {
                this.onboard.marketingOptin = null;
            } else {
                // DO THIS ONLY IF the marketing opt-in checkbox is displayed to users
                // Is marketing opt-in checkbox checked by default
                this.onboard.marketingOptin = _helper.signupLib.getMarketingOptinIsChecked(this.locale.country, isGDPRCountry);
                // Marketing opt-in text next to checkbox
                this.marketingOptinContentKey = _helper.signupLib.getMarketingOptinContentKey(this.locale.country, isGDPRCountry);
            }

            // Get Signup agree terms content and update the this.onboard object with they key
            var getSignupTermsContentKey = function getSignupTermsContentKey() {
                return _helper.signupLib.getSignupTermsContentKey(_this.locale.country, isGDPRCountry, _this.onboard.fiMode);
            };

            this.onboard.eConsentTermsContent = getSignupTermsContentKey();

            // control treatment will be returned for the countries which are in the contextual rules and falls in to control,
            // for those don't show the national ID field.
            // Test treatment / undefined (In-case of the countries not in the contextual rules),
            // read "nationalityRequired" from config.json which by default determined in enter()
            var pxpTreatments = this.experiments.nationalityThrottle;

            if (pxpTreatments && pxpTreatments.treatment_name.indexOf('xo_xoonboarding_eu_nationality_throttle_control') > -1 && this.showNationalityField) {
                this.showNationalityField = false;
            }

            // TODO: Remove watch after GDPR ramp (may 25th, 2018), we will have
            // one signup terms text for both bank and card fi types
            // DE - based on FI mode, we need to change signup agree terms
            this.$watch('onboard.fiMode', function (newVal) {
                _this.onboard.eConsentTermsContent = getSignupTermsContentKey();
            });
        }
    },

    actions: {
        openSepa: function openSepa() {
            this.sepa.show = true;
        }
    }
});


_index.$Component;

_index.$locale;

_index.$pxp;

_index.$config;

_index.$feature;

_helper.signupLib;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/signup/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"signupOptions\" content>\n    <div ng-if=\"flags.showDisabledPasswordField && flags.allowChoice && !guestUpgrade\" class=\"signupFields\">\n        <xo-password-input user=\"onboard.user\" is-disabled=\"true\"></xo-password-input>\n    </div>\n    <div class=\"signupFields\" ng-if=\"guestUpgrade || flags.mode === 'signup' || flags.buyerMode === 'signup'\"\n         ng-class=\"{'fullSignup': fullSignup || !flags.allowChoice, 'ignoreValidation': flags.ignoreValidationTheFirstTime }\">\n            <xo-email-input flow=\"signup\" flags=\"flags\" user=\"onboard.user\" ng-if=\"!flags.allowChoice\"></xo-email-input>\n            <xo-password-input class=\"highZindexTooltip\" user=\"onboard.user\"></xo-password-input>\n\n            <!--As per the UI design, DOB and Gender needs to be side by side for HK and others just DOB-->\n            <div class=\"dualInputElements clearfix\">\n                <span feature=\"dobRequired\" ng-class=\"{'halfInputElement': isGenderFieldEnabled}\" ng-if=\"onboard.fiMode === 'card' && !flags.whiteListedIndiaMerchant\">\n                    <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                </span>\n                <!--gender is enabled only for HK-->\n                <span feature=\"gender\">\n                    <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                </span>\n            </div>\n\n            <!--placeOfBirth is enabled only for HK-->\n            <span feature=\"placeOfBirth\">\n                <xo-place-of-birth user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n            </span>\n\n            <span feature=\"collectOccupation\">\n                <xo-occupation user=\"onboard.user\"></xo-occupation>\n            </span>\n\n            <span ng-if=\"showNationalityField\">\n                <xo-nationality user=\"onboard.user\"></xo-nationality>\n            </span>\n\n            <span ng-if=\"flags.nationalIdFlag\">\n                <xo-national-id-input country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n            </span>\n\n            <xo-citizenship user=\"onboard.user\"></xo-citizenship>\n\n            <div class=\"row-fluid inputField checkbox legal ltrOverride\" directionality feature=\"econsent\">\n                <div id=\"errorSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.agree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n                <input ng-model=\"agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" required aria-describedby=\"errorSignupAgree\"/>\n                <label class=\"noBottom signupTerms bgImgOnSpan\" for=\"agree\" aria-describedby=\"errorSignupAgree\">\n                    <span class=\"bgImg\">&nbsp;</span>\n                    <span id=\"consentTerms\" ng-bind-html=\"htmlContent(onboard.eConsentTermsContent, { country: locale.country, lang: locale.lang })\"></span>\n                </label>\n            </div>\n            <div class=\"terms\" feature=\"signupTerms\">\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisory',{ country: locale.country })\"></p>\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"!flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{ country: locale.country })\"></p>\n            </div>\n            <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.wpsInterstitial\">\n                <div id=\"errorSepaSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n                <input ng-model=\"sepa.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required aria-describedby=\"errorSepaSignupAgree\"/>\n                <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                       bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                       aria-describedby=\"errorSepaSignupAgree\"></label>\n            </div>\n            <div class=\"row-fluid checkbox legal marketingOptin\" ng-if=\"showMarketingOptin\">\n                <input ng-model=\"onboard.marketingOptin\" type=\"checkbox\" name=\"marketingOptin\" id=\"marketingOptin\" ng-checked=\"onboard.marketingOptin\"/>\n                <label id=\"marketingOptinText\" class=\"noBottom marketingOptin\" for=\"marketingOptin\"\n                       ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n            </div>\n        </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"onboardOptions\" content>\n\n    <!-- signup/guest fieldset container open -->\n    <div ng-if=\"flags.signupEnabled && !flags.showPomaUi\" class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n        <fieldset>\n\n            <div ng-if=\"frsNonWpsInterstitalFlow\">\n\n                <legend>\n                    <h2 class=\"onboard-header alpha\">\n                        <p id=\"onboardTitleLine1\" class=\"onboardTitleLine1\">{{content(frsContentKeys.title)}}</p>\n                    </h2>\n                </legend>\n\n                <p class=\"subTitle\" id=\"subTitle\" ng-bind-html=\"htmlContent(frsContentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n\n                <xo-message ng-if=\"validated && singlePagePaymentForm.guestSignup.$error.required\" id=\"guestSignupErrorMessage\"\n                            message=\"{ msgs: [content('largeScreenPayment.chooseAnOption')], type: 'warning' }\"></xo-message>\n            </div>\n\n            <legend ng-if=\"!flags.allowChoice && flags.titleSubtitlePxpTreatment && !flags.marketingOfferTitleContentExp\">\n                <h2 class=\"onboard-header alpha\" ng-bind-html=\"htmlContent('splitScreenExp.payPalAccountDetails')\"></h2>\n            </legend>\n\n            <div ng-if=\"flags.allowChoice && !flags.freeReturnShippingOptInFlowApplicable\">\n\n                <legend ng-if=\"!contentKeys.title\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p id=\"onboardTitleLine1\" class=\"onboardTitleLine1\">{{content(onboardTitleLine1)}}</p>\n                        <p class=\"onboardTitleLine2\">{{content('common.getBenefitsLine2')}}</p>\n                    </h2>\n                </legend>\n\n                <legend ng-if=\"contentKeys.title\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p class=\"onboardTitleLine1\">{{content(contentKeys.title)}}</p>\n                    </h2>\n                </legend>\n\n                <p class=\"subTitle\" id=\"subTitle\" ng-if=\"!contentKeys.subTitle\" ng-bind-html=\"htmlContent(subTitle, {country: locale.country, lang: locale.lang})\"></p>\n                <p class=\"subTitle\" ng-if=\"contentKeys.subTitle\" ng-bind-html=\"htmlContent(contentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n\n                <xo-message ng-if=\"validated && singlePagePaymentForm.guestSignup.$error.required\" id=\"guestSignupErrorMessage\"\n                            message=\"{ msgs: [content('largeScreenPayment.chooseAnOption')], type: 'warning' }\"></xo-message>\n\n                <p id =\"paypalSubTitle\" ng-bind-html=\"htmlContent(paypalSubTitle)\"></p>\n            </div>\n\n            <!-- we cannot merge all variable on ng-if into one showMarkingOffers variable -->\n            <!-- as change in any flag value after template is rendered, will not refect in template -->\n            <div ng-if=\"showMarketingOffers() && !flags.marketingOfferTitleContentExp\">\n                <legend>\n                    <xo-marketing-offers\n                        placement-code=\"'202002'\"\n                        token=\"token\"\n                        page-name=\"'HERMES_GUEST_CHECKOUT'\"\n                        title-txt-property=\"'common.createPayPalSubTitleSignup'\"\n                        subtitle-property=\"'common.buyerProtectionSignup'\"\n                        xo-title-class=\"onboard-header alpha\"\n                        xo-title-tag=\"h2\">\n                    </xo-marketing-offers>\n                </legend>\n            </div>\n\n            <div ng-if=\"showMarketingOffers() && flags.marketingOfferTitleContentExp\">\n                <legend ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine1\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine1\" class=\"onboardTitleLine1\">{{content(marketingOfferTitleContentExpContentKeys.titleLine1)}}</p>\n                        <p ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine2\" class=\"onboardTitleLine2\">{{content(marketingOfferTitleContentExpContentKeys.titleLine2)}}</p>\n                    </h2>\n                </legend>\n                <p class=\"subTitle\" ng-if=\"marketingOfferTitleContentExpContentKeys.subTitle\" ng-bind-html=\"htmlContent(marketingOfferTitleContentExpContentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n            </div>\n\n            <div ng-if=\"models.checkoutCart.isWalletTokenization()\">\n                <h2 class=\"onboard-header alpha\">{{content('signup.loginDetails')}}</h2>\n            </div>\n            <div class=\"signupFieldGroup\">\n\n                <div class=\"row-fluid radioButton\" ng-if=\"flags.allowChoice\"\n                     ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\">\n                    <input track-input=\"Guest_Signup_Yes\" ng-model=\"flags.buyerMode\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup1\"\n                           value=\"signup\" required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\"\n                           ng-change=\"actions.setBuyerModeFlags(flags.buyerMode) && actions.triggerTimerForSignupClicked()\" />\n\n                    <label class=\"noBottom\" for=\"guestSignup1\" ng-if=\"!contentKeys.yesCreateAccount\">{{ content(guestSignup1)}}</label>\n                    <label class=\"noBottom\" for=\"guestSignup1\" ng-if=\"contentKeys.yesCreateAccount\">{{ content(contentKeys.yesCreateAccount) }}</label>\n                </div>\n\n                <xo-signup-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" flags=\"flags\" is-unbranded=\"isUnbranded\"\n                        onboard=\"onboard\" sepa=\"sepa\"></xo-signup-options>\n\n            </div>\n\n            <div class=\"row-fluid radioButton\"\n                 ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\" ng-if=\"flags.allowChoice\">\n                <input track-input=\"Guest_Signup_No\" ng-model=\"flags.buyerMode\" ng-change=\"actions.setBuyerModeFlags(flags.buyerMode)\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup2\" value=\"guest\"\n                       required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\" />\n                <label class=\"noBottom\" for=\"guestSignup2\">{{ content('common.noCreateAccount') || content(guestSignup2) }}</label>\n            </div>\n\n            <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                              onboard=\"onboard\" sepa=\"sepa\"></xo-guest-options>\n\n        </fieldset>\n\n    </div>\n    <!-- signup/guest fieldset container closed -->\n\n    <div ng-if=\"mode === 'guestonly'\">\n        <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                          onboard=\"onboard\" sepa=\"sepa\"></xo-guest-options>\n    </div>\n\n    <div ng-if=\"flags.showPomaUi\" class=\"pomaFieldsContainer\" id=\"pomaContainer\">\n        <div class=\"pomaBgImg cardIcon VISA\">&nbsp;</div>\n\n        <div ng-switch on=\"POMAContentType\">\n            <div ng-switch-when=\"TREATMENT_B\">\n                <h2 class=\"alpha\">{{content('poma.headingB')}}</h2>\n                <div>\n                    <p class=\"subTitle\">{{content('poma.para1B')}}</p>\n                    <p class=\"subTitle\">{{content('poma.para2B')}}</p>\n                </div>\n                <div class=\"checkbox saveMyInfoBoxB\">\n                    <input track-input=\"POMA_CHECKBOX\" ng-model=\"saveMyInfo\" type=\"checkbox\" name=\"saveMyInfo\" id=\"saveMyInfo\" ng-click=\"actions.onCheckedSavedMyInfo($event)\"/>\n                    <label for=\"saveMyInfo\">{{content('poma.saveMyInfoCheckBoxB')}}</label>\n                </div>\n                <div ng-if=\"saveMyInfo\">\n                    <p class=\"legal\" id=\"pomaLegalterms\" ng-bind-html=\"htmlContent('poma.legalTerms', {country:locale.country, lang:locale.lang})\"></p>\n                </div>\n            </div>\n            <div ng-switch-default>\n                <h2 class=\"alpha\">{{content('poma.heading')}}</h2>\n                <div>\n                    <p class=\"subTitle\">{{content('poma.para1')}}</p>\n                    <p class=\"hfast noMarginBottom\">{{content('poma.para2')}}</p>\n                    <ul class=\"hfast fastList\">\n                        <li>{{content('poma.para2Bullet1')}}</li>\n                        <li>{{content('poma.para2Bullet2')}}</li>\n                    </ul>\n                    <p class=\"subTitle\">{{content('poma.para3')}}</p>\n                    <p class=\"subTitle\">{{content('poma.para4')}}</p>\n                </div>\n                <div class=\"checkbox saveMyInfoBox\">\n                    <input track-input=\"POMA_CHECKBOX\" ng-model=\"saveMyInfo\" type=\"checkbox\" name=\"saveMyInfo\" id=\"saveMyInfo\" ng-click=\"actions.onCheckedSavedMyInfo($event)\"/>\n                    <label for=\"saveMyInfo\">{{content('poma.saveMyInfoCheckBox')}}</label>\n                </div>\n                <div ng-if=\"saveMyInfo\">\n                    <p class=\"legal\" id=\"pomaLegalterms\" ng-bind-html=\"htmlContent('poma.legalTerms', {country:locale.country, lang:locale.lang})\"></p>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <p class=\"billingTxt secondary legal\" ng-if=\"showBillingAgreementText\">\n        <span id=\"billingAgreement\" data-ng-bind-html=\"htmlContent(baContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang})\"></span>\n    </p>\n\n    <p class=\"billingTxt secondary legal\" ng-if=\"showRpAgreementText\">\n        <span id=\"rpAgreement\" data-ng-bind-html=\"htmlContent(rpContentKey, {merchantName: merchant, country: locale.country, lang: locale.lang})\"></span>\n    </p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/passwordInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoPasswordInput', {
    tag: 'xo-password-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: false
        },
        singlePassword: {
            type: 'var',
            required: false
        },
        isDisabled: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.passwordToolTip = 'show';
            this.passwordMismatch = 'hide';
            this.requirementLength = 'active';
            this.requirementNumberSymbol = 'active';

            // Set singlePassword as true by default
            // NOTE: PROX flow is still using two password fields
            this.singlePassword = this.singlePassword !== false;

            /*
                The next 2 methods serve to allow passwordValidate & confirmPasswordValidate directives
                to access + change the scope variables inside here as the scopes
                in these directives are different and do not inherit from here.
            */
            this.setScopeProp = function (prop, newVal) {
                _this[prop] = newVal;
            };

            this.getScopeProp = function (prop) {
                return _this[prop];
            };

            /*
             * single password case
             * flags and functions to enable single password hide and
             * show password feature
             */
            var enableSinglePassword = function enableSinglePassword() {
                _this.showRawPassword = false;
                _this.showPasswordTextToggleLink = false;

                _this.toggleShowRawPassword = function ($event) {
                    var $passwordEl = (0, _jquery2['default'])('#password');
                    var valLength = $passwordEl.val().length;

                    $event.preventDefault();
                    _this.showRawPassword = !_this.showRawPassword;

                    if (_this.showRawPassword) {
                        $passwordEl.prop('type', 'text');
                    } else {
                        $passwordEl.prop('type', 'password');
                    }

                    // timeout is need to get this function running after
                    // the onPasswordBlur function
                    (0, _angular.$timeout)(function () {
                        $passwordEl.focus();
                        // firefox set the cursor to the end of the value text
                        $passwordEl.get(0).setSelectionRange(valLength, valLength);
                    });
                };
            };

            if (this.singlePassword) {
                enableSinglePassword();
            }
        }
    },
    actions: {
        // 'singlePassword' case - show the 'hide/show' password link
        onPasswordFocusBlur: function onPasswordFocusBlur($event, focused) {
            var passwordValLength = this.user.password && this.user.password.length;

            if (this.singlePassword) {
                if (focused) {
                    this.showPasswordTextToggleLink = true;
                } else {
                    // if password value length is zero then it is false
                    this.showPasswordTextToggleLink = passwordValLength ? true : false;
                }
            }
        }
    }
});


(0, _angular.$registerDirective)('password-validate', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, controller) {
            var ngModel = controller;
            var passwordInputScope = scope.componentScope;

            ngModel.$setValidity('password', false);

            var fourSequence = function fourSequence(value) {
                value += ' ' + value.split('').reverse().join('');
                var sequences = '`1231234234534564567567867897890890-90-= ' + // row 1
                'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\ ' + // row 2
                'asdfsdfgdfghfghjghjkhjkljkl;kl;\' ' + // row 3
                'zxcvxcvbcvbnvbnmbnm,nm,.m,./ ' + // row 4
                '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+ ' + // shift + row 1
                'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}| ' + // shift + row 2
                'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:" ' + // shift + row 3
                'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'; // shift + row 4

                var len = value.length;

                for (var i = 0; i < len - 3; i++) {
                    if (sequences.indexOf(value.substr(i, 4)) > -1) {
                        return false;
                    }
                }
                return true;
            };

            var containsDoubleByte = function containsDoubleByte(s) {
                return (/[^\u0000-\u00ff]/.test(s)
                );
            };

            ngModel.$parsers.unshift(function (viewValue) {
                passwordInputScope.setScopeProp('requirementLength', viewValue.length >= 8 && viewValue.length <= 20 ? false : 'active');
                passwordInputScope.setScopeProp('requirementNumberSymbol', /\d/.test(viewValue) || /[\-!@#$%\^&*()_+|~=`{}\[\]:';'<>?,.\/\\]/.test(viewValue) ? false : 'active');

                passwordInputScope.setScopeProp('requirementInfoSec', false);
                if (scope.user.country === 'AU') {
                    var lcViewVal = viewValue.toLowerCase();
                    var firstName = scope.user && scope.user.first_name && scope.user.first_name.toLowerCase();
                    var lastName = scope.user && scope.user.last_name && scope.user.last_name.toLowerCase();
                    var dob = scope.user && scope.user.dob_day + '/' + scope.user.dob_month + '/' + scope.user.dob_year;

                    if (lcViewVal.indexOf(firstName) > -1 || lcViewVal.indexOf(lastName) > -1 || lcViewVal.indexOf(dob) > -1) {
                        passwordInputScope.setScopeProp('requirementInfoSec', 'active');
                    }
                }

                passwordInputScope.setScopeProp('restrictionEmail', false);
                passwordInputScope.setScopeProp('restrictionFourRepeated', viewValue.length > 3 && /(.)\1{3}/.test(viewValue) ? 'active' : false);
                passwordInputScope.setScopeProp('restrictionNonValidCharacters', /[\x00-\x08\x0E-\x1F\x80-\xFF ]/.test(viewValue) ? 'active' : false); // eslint-disable-line no-control-regex
                passwordInputScope.setScopeProp('restrictionFourSequence', viewValue.length > 3 && !fourSequence(viewValue) ? 'active' : false);
                passwordInputScope.setScopeProp('restrictionDoubleByte', containsDoubleByte(viewValue) ? 'active' : false);

                var requirements = !(passwordInputScope.getScopeProp('requirementLength') || passwordInputScope.getScopeProp('requirementNumberSymbol') || passwordInputScope.getScopeProp('requirementInfoSec'));
                var restrictions = !(passwordInputScope.getScopeProp('restrictionEmail') || passwordInputScope.getScopeProp('restrictionFourRepeated') || passwordInputScope.getScopeProp('restrictionNonValidCharacters') || passwordInputScope.getScopeProp('restrictionFourSequence') || passwordInputScope.getScopeProp('restrictionDoubleByte'));

                ngModel.$setValidity('password', requirements && restrictions);
                passwordInputScope.setScopeProp('passwordToolTip', requirements && restrictions ? 'hide' : 'show');
                return viewValue;
            });
        }
    };
});

(0, _angular.$registerDirective)('confirm-password-validate', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, controller) {
            var ngModel = controller;
            var passwordInputScope = scope.componentScope;

            ngModel.$setValidity('confirmPassword', false);

            passwordInputScope.$watch('user.password', function (newValue) {
                var cPass = passwordInputScope.user.confirmPassword;

                if (cPass && cPass.length && cPass !== newValue) {
                    ngModel.$setValidity('confirmPassword', false);
                    passwordInputScope.setScopeProp('passwordMismatch', 'show');
                }
            });

            ngModel.$parsers.unshift(function (viewValue) {
                var passwordVal = passwordInputScope.user.password;

                passwordInputScope.setScopeProp('restrictionMatch', passwordVal && viewValue.length > 0 && passwordVal.indexOf(viewValue) === 0 && passwordVal === viewValue);

                ngModel.$setValidity('confirmPassword', passwordVal === viewValue);

                passwordInputScope.setScopeProp('passwordMismatch', passwordInputScope.getScopeProp('restrictionMatch') ? 'hide' : 'show');
                return viewValue;
            });
        }
    };
});

_squid.$Component;

_squid.$locale;

_angular.$timeout;

_angular.$registerDirective;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/passwordInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup passwords clearfix\" content>\n    <div ng-switch=\"isDisabled\" class=\"inputField passwordField confidential {{locale.metadata.directionality}}\"\n         ng-class=\"{ 'half': !singlePassword, 'full': singlePassword }\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"password\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input ng-model=\"user.password\" ng-focus=\"actions.onPasswordFocusBlur($event, true)\" ng-blur=\"actions.onPasswordFocusBlur($event, false)\" id=\"password\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\" aria-required=\"true\" aria-describedby=\"passwordToolTip\" maxlength=\"22\" value=\"\" password-validate />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n        <div ng-if=\"singlePassword && !isDisabled && showPasswordTextToggleLink\" class=\"showHidePasswordLinks\" ng-switch=\"showRawPassword\">\n            <a href=\"#\" id=\"showPasswordLink\" ng-switch-when=\"false\" title=\"{{ content('password.showPassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.show') }}</a>\n            <a href=\"#\" id=\"hidePasswordLink\" ng-switch-when=\"true\" title=\"{{ content('password.hidePassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.hide') }}</a>\n        </div>\n\n        <div ng-class=\"passwordToolTip\">\n            <xo-tooltip trigger=\"#password\" show-event=\"keyup\" ng-class=\"passwordToolTip\" id=\"passwordToolTip\">\n                <div class=\"tip tipDesc passwordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"requirement\" ng-class=\"requirementLength\">{{ content('scripts.requirementLength') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementNumberSymbol\">{{ content('scripts.requirementNumberSymbol') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementInfoSec\" feature=\"requirementInfoSec\">{{ content('scripts.informationSecurity') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionEmail\">{{ content('scripts.restrictionEmail') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourRepeated\">{{ content('scripts.restrictionFourRepeated') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionNonValidCharacters\">{{ content('scripts.restrictionNonValidCharacters') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourSequence\">{{ content('scripts.restrictionFourSequence') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionDoubleByte\">{{ content('scripts.restrictionDoubleByte') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n    <div ng-if=\"!singlePassword\" ng-switch=\"isDisabled\"\n         class=\"inputField confirmPasswordField half last-child confidential\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input ng-model=\"user.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               aria-required=\"true\" maxlength=\"22\" value=\"\" confirm-password-validate />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n        <div ng-class=\"passwordMismatch\">\n            <xo-tooltip trigger=\"#confirmPassword\" show-event=\"keyup\" id=\"confirmPasswordToolTip\">\n                <div class=\"tip tipDesc confirmPasswordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"restriction active\">{{ content('scripts.restrictionMatch') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoRedirectingFromXoonWarning', {
    tag: 'xo-redirecting-from-xoon-warning',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        flags: {
            type: 'var',
            required: true
        },
        // mode is not present in multistep, so it is set as not required
        mode: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                auth: _index.$AuthModel.instance().retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            // Default to 'signup' as multistep will not pass mode prop
            this.mode = this.mode || 'signup';
        },
        populate: function populate() {
            var $ccField = $('#cc');

            // Check the validity of fields read from config
            if (($ccField.val() || '').length > 0 && $ccField.hasClass('ng-valid')) {
                _logger.$logger.info('checkout_fpti', {
                    from: this.mode === 'signup' ? 'signup' : 'guest_xo',
                    to: 'prep_change_email'
                });
                this.showPrompt = true;
            } else {
                this.actions.redirectToHermes();
            }
        }
    },

    actions: {
        redirectToHermes: function redirectToHermes(isRedirectConfirmationShown) {

            var redirectLogType = isRedirectConfirmationShown ? 'with' : 'without';
            var transitionName = isRedirectConfirmationShown ? 'process_yes_change_email' : 'process_change_email';

            _logger.$logger.info('splitscreen_email_change_redirect_' + redirectLogType + '_modal_confirmation');

            _logger.$logger.info('checkout_fpti', {
                from: this.mode === 'signup' ? 'signup' : 'guest_xo',
                to: transitionName
            });

            // need this to get token in ".then" function of clearCookies call
            var that = this;

            // We need to clear loginEmail and rmuc cookies
            // to make sure UL treats this user as splitscreen eligible
            this.models.auth.clearCookies({ loginEmail: true, rmuc: true }).then(function () {
                // Make sure to send locale and country as we need to carry this back
                // to hermes, if user changed these params in xoon
                (0, _squid.$dispatch)('hermes', {
                    token: that.token,
                    'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                    'country.x': _squid.$locale.country
                });
            });
        },
        triggerRedirect: function triggerRedirect($event) {
            if ($event) {
                $event.preventDefault();
            }

            this.actions.redirectToHermes(true);
        },
        closePopupModal: function closePopupModal($event) {
            // We need this as this function is called from xo-modal
            // as a callback function
            if ($event) {
                $event.preventDefault();
            }

            _logger.$logger.info('checkout_fpti', {
                from: this.mode === 'signup' ? 'signup' : 'guest_xo',
                to: 'process_no_change_email'
            });

            this.showPrompt = false;
            this.flags.showRedirectWarningPrompt = false;
        }
    }

});


_squid.$Component;

_squid.$locale;

_squid.$dispatch;

_logger.$logger;

_index.$AuthModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-modal ng-if=\"showPrompt\"\n    show=\"showPrompt\" override-default-container=\"true\"\n    on-close=\"actions.closePopupModal\"\n    enable-close-on-escape=\"true\" content>\n    <div id=\"redirectPromptBox\">\n        <div class=\"informationContent\">\n            <h1 class=\"alpha\" ng-bind-html=\"htmlContent('splitScreenExp.areYouSure')\"></h1>\n            <p class=\"subTitle\" ng-bind-html=\"htmlContent('splitScreenExp.confirmEmailChange')\"></p>\n        </div>\n\n        <div class=\"promptActionLinks\">\n            <a class=\"first\" ng-click=\"actions.triggerRedirect($event)\" href=\"#\" ng-bind-html=\"htmlContent('splitScreenExp.yesChange')\"></a>\n            <a class=\"last\" ng-click=\"actions.closePopupModal($event)\" href=\"#\" ng-bind-html=\"htmlContent('splitScreenExp.noDontChange')\"></a>\n        </div>\n    </div>\n</xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _errorHandlerHelper = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js");

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

var _index2 = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/styles.less");

var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = _index.$Component.extend('$xoGuestSelectShippingMethodDirective', {
    tag: 'xo-guest-select-shipping-method',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        billingAddress: {
            type: 'var',
            required: false
        },
        shippingAddress: {
            type: 'var',
            required: false
        },
        isShippingSameAsBilling: {
            type: 'var',
            required: false
        },
        showShipping: {
            type: 'var',
            required: false
        },
        buttonParams: {
            type: 'var',
            required: false
        },
        updatePageLevelErrorMessage: {
            type: 'var',
            required: false
        },
        flags: {
            type: 'var',
            required: false
        },
        trackSntReq: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // Decides whether to show whole section
            this.showShippingMethodSection = true;

            // Decides whether to show merchant options
            this.showMerchantOptions = true;
            this.showZipCode = false;
            this.zipCode = '';

            // Decides whether to show different DropDown
            this.isShowShippingMethodsDropDown = false;
            this.noShippingMethodDropDown = true;

            // Decides whether to show pick up store Text
            this.isStorePickUp = false;

            // Models
            this.currencyCode = '';

            this.selectedShippingCharge = '';

            // Initial charges
            this.charges = [{}];

            // No shipping charges
            this.noShippingChargesList = this.charges;

            // Hide the additional drop down that is rendered in iOS
            this.hideSelectDropdown = navigator.appVersion.indexOf('iPhone') !== -1;

            // Models mapped to guest scope component
            this.billingAddress = this.props.billingAddress;
            this.shippingAddress = this.props.shippingAddress;
            this.flags = this.props.flags;
            this.isShippingSameAsBilling = this.props.isShippingSameAsBilling;
            this.showShipping = this.props.showShipping;
            this.trackSntReq = this.props.trackSntReq;

            // Decides on disable/enable of dropdown
            this.changeShippingMethod = 'changeShippingMethodDisabled';
            this.selectedShippingMethodText = 'disableShippingMethod';
            this.dropDownBackground = 'normalBackground';

            // Used for instant update feature
            this.callbackShippingOptions = [];
            this.fallbackShippingOptions = [];
            this.selectedMethod = {};
            this.callbackInsuranceOffered = false;
            this.defaultFallbackOptionIndex = 0;

            this.shippingMethodNotSelected = true;

            this.shipAndTaxError = false;
            this.override = false;
            this.noErrorOrOverride = true;

            this.triggerFetchShippingMethods = false;
            this.localeCountry = _index.$locale.country;

            this.trackZipCode = {
                prev: '',
                current: ''
            };

            this.trackState = {
                prev: '',
                current: ''
            };

            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
                var newTotal = _this.buttonCartAmounts.total;

                Object.keys(patchableAmountEntities).forEach(function (key) {
                    var detail = patchableAmountEntities[key];

                    if (!isNaN(detail.value)) {
                        detail.value = Number(detail.value);
                        amounts.details[key] = detail.value.toFixed(decimalDigits);
                    } else {
                        detail.value = 0;
                    }
                    var difference = detail.valueInCart ? detail.value - detail.valueInCart : detail.value;

                    newTotal += difference;
                });
                amounts.total = newTotal.toFixed(decimalDigits);
                Object.keys(constantAmountEntities).forEach(function (key) {
                    var detail = constantAmountEntities[key];

                    if (detail.valueInCart !== undefined) {
                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
                    }
                });

                _logger.$logger.info('snt_populate_patch_amount_details', {
                    patchableAmountEntities: patchableAmountEntities,
                    constantAmountEntities: constantAmountEntities,
                    amounts: amounts,
                    decimalDigits: decimalDigits
                });
            };

            // Todo: Understand: Why are we modifying API response?
            var getExternalCallbackOptionsForPatch = function getExternalCallbackOptionsForPatch() {
                var externalCallbackOptions = _this.models.checkoutCart.getExternalCallbackOptions();

                if (_this.response.shipping_options_source === 'CALLBACK') {
                    externalCallbackOptions.callback_shipping_options = _this.callbackShippingOptions;
                    externalCallbackOptions.callback_insurance_option_offered = _this.callbackInsuranceOffered;
                } else if (_this.response.shipping_options_source === 'FALLBACK') {
                    externalCallbackOptions.fallback_shipping_options = _this.fallbackShippingOptions;
                }
                _logger.$logger.info('snt_external_callback_options_for_patch', {
                    externalCallbackOptions: externalCallbackOptions
                });
                return externalCallbackOptions;
            };

            // Generates the request body to be used for patch Cart
            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
                // What will get patched?
                // 1. amount values in the cart,
                // 2. shipping method (only in case of non instant update flows)
                // 3. external_callback_options (only in case of instant update flows)

                var currencyDigits = _index.$locale.metadata && _index.$locale.metadata.currency && _index.$locale.metadata.currency.digits;
                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];

                if (isNaN(decimalDigits)) {
                    decimalDigits = 2;
                }
                var patchEntities = [];
                var amounts = {
                    'currency': _this.currencyCode,
                    'details': {
                        'subtotal': _this.buttonCartAmounts.subTotal.toFixed(decimalDigits)
                    }
                };
                var patchableAmountEntities = {
                    shipping: {
                        value: shippingAmt,
                        valueInCart: _this.buttonCartAmounts.shippingAmt
                    },
                    tax: {
                        value: taxAmt,
                        valueInCart: _this.buttonCartAmounts.taxAmt
                    },
                    insurance: {
                        value: insuranceAmt,
                        valueInCart: _this.buttonCartAmounts.insuranceAmt
                    }
                };
                // amount details which are not affected by SnT response,
                // but still need to get included in the patch request if initially present
                var constantAmountEntities = {
                    handling_fee: {
                        valueInCart: _this.buttonCartAmounts.handlingAmt
                    },
                    shipping_discount: {
                        valueInCart: _this.buttonCartAmounts.shippingDiscountAmt
                    },
                    discount: {
                        valueInCart: _this.buttonCartAmounts.discount
                    }
                };

                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);
                patchEntities.push({
                    field: 'purchaseAmount',
                    value: amounts
                });

                if (_this.isInstantUpdateFlow) {
                    patchEntities.push({
                        field: 'externalCallbackOptions',
                        value: getExternalCallbackOptionsForPatch()
                    });
                } else {
                    var shippingMethod = '';

                    if (shipMethod && _this.shippingMethods) {
                        shippingMethod = _this.shippingMethods.getShippingMethodId(shipMethod);
                    }
                    patchEntities.push({
                        field: 'shippingMethod',
                        value: shippingMethod
                    });
                }

                var patchRequest = {
                    id: _this.token,
                    patchEntities: patchEntities
                };

                _logger.$logger.info('snt_patch_request', { patchRequest: patchRequest });
                return patchRequest;
            };

            // Function which will update costs which were patched
            var updatePreviousCosts = function updatePreviousCosts() {
                _this.previousCosts = {};
                if (_this.models.checkoutCart.purchase.amounts.shipping) {
                    _this.previousCosts.shippingAmount = Number(_this.models.checkoutCart.purchase.amounts.shipping.amount);
                }
                if (_this.models.checkoutCart.purchase.amounts.tax) {
                    _this.previousCosts.taxAmount = Number(_this.models.checkoutCart.purchase.amounts.tax.amount);
                }
                _logger.$logger.info('snt_update_previous_costs', { previousCosts: _this.previousCosts });
            };

            // Responsible to patch the cart with shipping, tax (and insurance in case of instant update)
            var updateShippingTaxCharge = function updateShippingTaxCharge(shippingAmt, taxAmt, shipMethod, insurance) {
                _logger.$logger.info('snt_update_shipping_tax_charge', {
                    shippingAmt: shippingAmt,
                    taxAmt: taxAmt,
                    shipMethod: shipMethod,
                    decodeEntities: (0, _util.decodeEntities)(shipMethod),
                    insurance: insurance
                });
                var patchReq = getPatchReqData(shippingAmt, taxAmt, (0, _util.decodeEntities)(shipMethod), insurance);

                _this.models.checkoutCart.action('patchCartData', {
                    data: patchReq,
                    batch: {
                        name: 'patchCartData',
                        id: 'checkoutCart'
                    },
                    success: function success(result) {
                        _logger.$logger.info('snt_patch_cart_data_success');
                        _this.checkoutSession = _index3.$CheckoutSessionModel.instance(_this.token);
                        updatePreviousCosts();
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('snt_patch_cart_failure', { error: err });
                            throw err;
                        }
                    }
                });
            };

            // Checks whether domestic shipping methods are supported for the country or not
            this.isDomesticShippingMethodsSupported = function () {
                var country = _this.isShippingSameAsBilling ? _this.billingAddress.country : _this.shippingAddress.country;
                var result = void 0;

                if (_this.isInstantUpdateFlow) {
                    // for countries which have no state or zip code in their address templates, SnT must be called based on country change
                    // which implies isDomesticShippingMethodsSupported would be false
                    result = !(0, _index.$feature)('noZipCodeOrState', false, country);
                } else {
                    result = (0, _index.$feature)('allowWPSDomesticShippingMethods', false, country);
                }

                _logger.$logger.info('snt_is_domestic_shipping_methods_supported', {
                    result: result,
                    isInstantUpdateFlow: _this.isInstantUpdateFlow
                });
                return result;
            };

            // Sets the zip code whenever user enters the postal code field.
            this.setZipCode = function (caller) {
                if (_this.isDomesticShippingMethodsSupported()) {
                    _this.showZipCode = true;
                    if (_this.isShippingSameAsBilling) {
                        _this.zipCode = _this.billingAddress.postal_code;
                    } else {
                        _this.zipCode = _this.shippingAddress.postal_code;
                    }
                } else {
                    _this.showZipCode = false;
                }

                _logger.$logger.info('snt_set_zip_code', {
                    isShippingSameAsBilling: _this.isShippingSameAsBilling,
                    zipCode: _this.zipCode,
                    showZipCode: _this.showZipCode,
                    caller: caller
                });
            };

            // Checks whether there was a change in zip code
            var isZipCodeChange = function isZipCodeChange() {
                var result = _this.trackZipCode.prev !== _this.trackZipCode.current;

                _logger.$logger.info('snt_zip_code_changed', {
                    trackZipCode: _this.trackZipCode,
                    result: result
                });
                return result;
            };

            // Checks whether there was a change in state
            var isStateChange = function isStateChange() {
                var result = _this.trackState.prev !== _this.trackState.current;

                _logger.$logger.info('snt_state_changed', {
                    trackState: _this.trackState,
                    result: result
                });
                return result;
            };

            // Checks whether there was a change in country
            // Todo: Understand: Won't billing address country will always be the same as locale country
            var isCountryChange = function isCountryChange() {
                _logger.$logger.info('snt_country_changed', {
                    bc: _this.billingAddress && _this.billingAddress.country,
                    lc: _this.localeCountry
                });

                if (_this.billingAddress.country && _this.localeCountry) {
                    return _this.billingAddress.country !== _this.localeCountry;
                }
                // Todo: Understand: Why are we returning true by default
                return true;
            };

            // Util function to help safe convert a value to decimal
            var safeConvert = function safeConvert(value) {
                value = Number(value);
                _logger.$logger.info('snt_safe_convert', {
                    value: value
                });
                if (isNaN(value)) {
                    throw new Error(value + ' cannot be divided');
                }
                return value / 100;
            };

            // Checks whether shipping and tax response has tax in it
            // Todo: instead of returning a boolean why not returntax amount if there is any
            var responseHasTaxCharges = function responseHasTaxCharges() {
                _logger.$logger.info('snt_response_has_tax_charges', {
                    charges: _this.response.charges
                });
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].tax;
            };

            // Checks whether shipping and tax response has shipping charges
            var responseHasShippingCharges = function responseHasShippingCharges() {
                _logger.$logger.info('snt_response_has_shipping_charges', {
                    charges: _this.response.charges
                });
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].shipping_charge;
            };

            /*
             Checks whether patch cart is required or not .
             Use cases where this is called
             ------------------------------
             1. When user selects a shipping method from dropdown.
             2. User selects store pick Up , wants to change shipping address but shipping address fields are empty ,
             applicationShippingAmt will be passed as undefined to this function .
             */
            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
                var result = applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;

                _logger.$logger.info('snt_is_patch_card_required', {
                    applicableShippingAmt: applicableShippingAmt,
                    applicableTaxAmt: applicableTaxAmt,
                    previousCosts: _this.previousCosts,
                    result: result
                });

                return result;
            };

            var getTaxFromResponse = function getTaxFromResponse(charge) {
                // todo: Understand: is charge different from towhat is there in response since we want to get tax from
                // response!
                var responseCharge = charge || responseHasTaxCharges() && _this.response.charges[0];
                var result = void 0;

                if (responseCharge && responseCharge.tax) {
                    // todo: Understand: Why the below condition
                    if (!_this.buttonCartAmounts.shippingAmt && !_this.showShipping) {
                        result = safeConvert(responseCharge.tax.item_tax.value);
                    } else {
                        result = safeConvert(responseCharge.tax.total_tax.value);
                    }
                }
                _logger.$logger.info('snt_tax_from_response', {
                    result: result,
                    responseCharge: responseCharge
                });
                return result;
            };

            // Returns tax amount
            var getTax = function getTax(charge) {
                _logger.$logger.info('snt_get_tax', {
                    isInstantUpdateFlow: _this.isInstantUpdateFlow,
                    isBuyNow: _this.isBuyNow,
                    buttonCartAmountsTaxAmt: _this.buttonCartAmounts.taxAmt

                });

                // todo: Understand: Why do we need isInstantUpdateFlow condition when getTaxFromResponse(charge); is
                // the default!?
                if (_this.isInstantUpdateFlow) {
                    return getTaxFromResponse(charge);
                }
                if ((_this.isBuyNow || _this.isCartUpload) && _this.buttonCartAmounts.taxAmt >= 0) {
                    return _this.buttonCartAmounts.taxAmt;
                }
                return getTaxFromResponse(charge);
            };

            // Disables the shipping method dropdown
            var disableDropDown = function disableDropDown() {
                _logger.$logger.info('snt_disable_dropdown');
                _this.isShowShippingMethodsDropDown = false;
                _this.noShippingMethodDropDown = true;

                _this.changeShippingMethod = 'changeShippingMethodDisabled';
                _this.dropDownBackground = 'normalBackground';
                _this.selectedShippingMethodText = 'disableShippingMethod';

                var span = $('#noShippingMethod > div > span > span > span');

                span.html(_index.$locale.content.get('shippingMethod.selectMethod'));
            };

            // Enable the shipping method dropdown
            var enableDropDown = function enableDropDown() {
                _logger.$logger.info('snt_enable_dropdown');
                _this.isShowShippingMethodsDropDown = true;
                _this.noShippingMethodDropDown = false;
                _this.shippingMethodNotSelected = true;

                _this.changeShippingMethod = 'changeShippingMethodEnabled';
                _this.dropDownBackground = 'normalBackground';
                _this.selectedShippingMethodText = 'enableShippingMethod';
            };

            // Enable store pick up to show shipping address
            var enableStorePickUp = function enableStorePickUp() {
                _logger.$logger.info('snt_enable_store_pickup');
                _this.flags.hideShippingAddress = true;
                _this.flags.showSingleAddress = true;
                _angular.$rootScope.$emit('store_pick_up_selected');
            };

            // Disable store pick Up
            var disableStorePickUp = function disableStorePickUp() {
                _logger.$logger.info('snt_disable_store_pickup');
                _this.flags.hideShippingAddress = false;
                _this.flags.showSingleAddress = false;
            };

            // Checks whether zip code is empty or not
            var isFormZipCodeEmpty = function isFormZipCodeEmpty() {
                // Todo: Understand: Is zipCodeField always present for non instant update flow?
                // Basically understand instant update flow
                var result = void 0;

                if (_this.isInstantUpdateFlow) {
                    var zipCodeField = _this.isShippingSameAsBilling ? $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0] : $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
                    // The zip code field is not present for some countries.
                    // isFormZipCodeEmpty() in that case returns false

                    if (!zipCodeField) {
                        _logger.$logger.info('snt_is_form_zip_code_empty_no_zip_field');
                        return false;
                    }
                }
                if (_this.isShippingSameAsBilling) {
                    result = _this.billingAddress && !_this.billingAddress.postal_code;
                } else {
                    result = _this.shippingAddress && !_this.shippingAddress.postal_code;
                }
                _logger.$logger.info('snt_is_form_zip_code_empty', {
                    result: result,
                    isShippingSameAsBilling: _this.isShippingSameAsBilling
                });
                return result;
            };

            // Checks whether line1 is emoty or not
            var isFormAddressLine1Empty = function isFormAddressLine1Empty() {
                var result = void 0;

                if (_this.isShippingSameAsBilling) {
                    result = _this.billingAddress && !_this.billingAddress.line1;
                } else {
                    result = _this.shippingAddress && !_this.shippingAddress.line1;
                }
                _logger.$logger.info('snt_is_form_address_line1_empty', { result: result });

                return result;
            };

            // Checks whether state is empty or not
            var isFormStateEmpty = function isFormStateEmpty() {
                var result = void 0;

                if (_this.isInstantUpdateFlow) {
                    var stateField = _this.isShippingSameAsBilling ? $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0] : $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
                    // The state field is not present for some countries.
                    // isFormStateEmpty() in that case returns false

                    if (!stateField) {
                        _logger.$logger.info('snt_is_form_state_empty_no_state');
                        return false;
                    }
                }
                if (_this.isShippingSameAsBilling) {
                    result = _this.billingAddress && !_this.billingAddress.state;
                } else {
                    result = _this.shippingAddress && !_this.shippingAddress.state;
                }
                _logger.$logger.info('snt_is_form_state_empty', {
                    result: result,
                    isShippingSameAsBilling: _this.isShippingSameAsBilling
                });

                return result;
            };

            // Returns the current zip code entered by the user
            var getCurrentZipCode = function getCurrentZipCode() {
                _logger.$logger.info('snt_get_current_zip_code', {
                    isShippingSameAsBilling: _this.isShippingSameAsBilling,
                    baPostalCode: _this.billingAddress.postal_code,
                    saPostalCode: _this.shippingAddress.postal_code
                });

                if (_this.isShippingSameAsBilling) {
                    if (_this.billingAddress.postal_code) {
                        return _this.billingAddress.postal_code;
                    }
                }

                // Todo: Understand should it be else if?
                if (_this.shippingAddress.postal_code) {
                    return _this.shippingAddress.postal_code;
                }
            };

            // Returns current state selected by the user
            var getCurrentState = function getCurrentState() {
                _logger.$logger.info('snt_get_current_state', {
                    isShippingSameAsBilling: _this.isShippingSameAsBilling,
                    baPostalCode: _this.billingAddress.state,
                    saPostalCode: _this.shippingAddress.state
                });

                if (_this.isShippingSameAsBilling) {
                    if (_this.billingAddress.state) {
                        return _this.billingAddress.state;
                    }
                }
                if (_this.shippingAddress.state) {
                    return _this.shippingAddress.state;
                }
            };

            var isValidPostalCodeElement = function isValidPostalCodeElement(element) {
                var isValidBillingPostalCodeElement = (element === 'billingPostalCode' || element === 'postalCode') && _this.isShippingSameAsBilling;
                var isValidShippingPostalCodeElement = (element === 'shippingPostalCode' || element === 'postalCode') && !_this.isShippingSameAsBilling;

                _logger.$logger.info('snt_is_valid_postal_code_element', { result: isValidBillingPostalCodeElement || isValidShippingPostalCodeElement });
                return isValidBillingPostalCodeElement || isValidShippingPostalCodeElement;
            };

            // Function which patches the cart with button parameters
            var patchCartWithButtonParams = function patchCartWithButtonParams() {
                _logger.$logger.info('snt_patch_cart_with_button_params', {
                    buttonCartAmounts: _this.buttonCartAmounts
                });
                if (!_this.buttonCartAmounts) {
                    // todo: Understand: No error?
                    return;
                }
                var shippingAmt = _this.buttonCartAmounts.shippingAmt;
                var taxAmt = _this.buttonCartAmounts.taxAmt;

                if (isPatchCartRequired(shippingAmt, taxAmt)) {
                    updateShippingTaxCharge(shippingAmt, taxAmt, 'DEFAULT');
                }
            };

            // Listener to fetch adapted shipping methods when locale changes
            // Todo: Cleanup: localeChange not required
            var localeChange = _angular.$rootScope.$on('localeChange', function (event) {
                _this.localeCountry = _index.$locale.country;
                if (!isCountryChange()) {
                    disableDropDown();
                    _this.fetchShippingMethods();
                }
            });

            // Todo: cleanup: not needed
            _angular.$rootScope.$on('$destroy', localeChange);

            // Listener which is responsible to patch Cart with button params if shipping address fields are empty
            var changeInShippingAddress = _angular.$rootScope.$on('change_in_shipping_address', function (event) {
                _logger.$logger.info('snt_change_in_shipping_address');
                if (isFormZipCodeEmpty() || isFormStateEmpty()) {
                    disableDropDown();
                    _this.isStorePickUp = false;
                    patchCartWithButtonParams();
                }
            });

            _angular.$rootScope.$on('$destroy', changeInShippingAddress);

            this.setAllowPayWithSnT = function (value) {
                _logger.$logger.info('snt_set_allow_pay_with_snt', { value: value });
                _this.flags.allowPayWithSnT = value;
            };

            this.handleZipCodeBlur = function (event) {
                _logger.$logger.info('snt_handle_zip_code_blur', {
                    allowSnTCall: _this.flags.allowSnTCall
                });

                if (_this.flags.allowSnTCall) {
                    if (!_this.showShipping) {
                        disableDropDown();
                        _this.fetchShippingMethods();
                    } else if (!isFormZipCodeEmpty() && !isFormStateEmpty()) {
                        _this.trackZipCode.current = getCurrentZipCode();
                        _this.trackState.current = getCurrentState();
                        if (isZipCodeChange() || isStateChange()) {
                            if (_this.isDomesticShippingMethodsSupported()) {
                                disableDropDown();
                                _this.fetchShippingMethods();
                            } else {
                                _this.setAllowPayWithSnT(true);
                            }
                        } else {
                            _this.setAllowPayWithSnT(true);
                        }
                    } else if (!isFormAddressLine1Empty() && (isFormZipCodeEmpty() || isFormStateEmpty())) {
                        if (isFormZipCodeEmpty()) {
                            _this.trackZipCode.prev = '';
                        }
                        if (isFormStateEmpty()) {
                            _this.trackState.prev = '';
                        }
                        if (_this.isDomesticShippingMethodsSupported()) {
                            _angular.$rootScope.$emit('showErrorFields');
                            disableDropDown();
                            _this.isStorePickUp = false;
                            disableStorePickUp();
                            patchCartWithButtonParams();
                        }
                    } else {
                        _logger.$logger.info('snt_handle_zip_code_blur_default', {
                            showZipCode: false
                        });
                        _this.showZipCode = false;
                    }
                }
            };

            // Listener which is responsible to call shipping tax API to fetch shipping methods for the given address
            var zipCodeBlur = _angular.$rootScope.$on('zip_code_blur', this.handleZipCodeBlur);

            _angular.$rootScope.$on('$destroy', zipCodeBlur);

            var handleZipCodeKeyPress = function handleZipCodeKeyPress(event, args) {
                var zipCodeElement = args && args.event && args.event.target && args.event.target.id;

                _logger.$logger.info('snt_handle_zip_code_key_press', {
                    zipCodeElement: zipCodeElement
                });

                _this.setAllowPayWithSnT(true);
                /* On keypress of zip code element in US / CA , SnT should be applied before Pay.
                 For other countries , flag will be set when SnT Call is made during Page load .
                 */
                if (zipCodeElement && isValidPostalCodeElement(zipCodeElement) && _this.isDomesticShippingMethodsSupported() && isZipCodeChange()) {
                    _this.setAllowPayWithSnT(false);
                }
            };

            var zipCodeKeyPress = _angular.$rootScope.$on('zip_code_keypress', handleZipCodeKeyPress);

            _angular.$rootScope.$on('$destroy', zipCodeKeyPress);

            /*
             Watcher on the ship to Billing checkbox
             Use cases
             ---------
             1. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is empty
             we disable dropdown and patch cart with button params.
             2. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is not empty,
             we fetch shipping methods based on shipping address.
             3. User has selected a shipping method based on shipping address , checks the ship to my billing checkbox ,
             we fetch shipping methods based on billing address.
             */
            this.$watch('isShippingSameAsBilling', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_shipping_same_as_billing_watch');
                    disableDropDown();
                    _this.trackZipCode = {
                        prev: '',
                        current: ''
                    };

                    _this.trackState = {
                        prev: '',
                        current: ''
                    };
                    _this.fetchShippingMethods();
                    _this.isStorePickUp = false;
                    _this.setZipCode('snt_shipping_same_as_billing_watch');
                }
            });

            /*
             For instant update flows, the SnT service call is triggered when there is a change in
             i. State
             ii. Zip code
             Changes to any other address fields will not trigger the SnT call.
             The address fields are again compared during submit. If they are found to be different, SnT is again called.
             */

            // Watcher for billing address postal code
            this.$watch('billingAddress.postal_code', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_billing_address_postal_code_watch', {
                        newVal: newVal,
                        oldVal: oldVal
                    });
                    _this.shipAndTaxError = false;
                    _this.setZipCode('snt_billing_address_postal_code_watch');
                }
            });

            // Watcher for shipping address postal code
            this.$watch('shippingAddress.postal_code', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_billing_address_postal_code_watch', {
                        newVal: newVal,
                        oldVal: oldVal
                    });
                    _this.shipAndTaxError = false;
                    _this.setZipCode('snt_billing_address_postal_code_watch');
                }
            });

            // Watchers for billing address state change
            this.$watch('billingAddress.state', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_billing_address_state_watch', {
                        newVal: newVal,
                        oldVal: oldVal
                    });
                    if (_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.flags.allowSnTCall) {
                        if (!isFormStateEmpty()) {
                            if (_this.isDomesticShippingMethodsSupported()) {
                                disableDropDown();
                                _this.fetchShippingMethods();
                            }
                        }
                    }
                }
            });

            // Watchers for billing address country change
            this.$watch('billingAddress.country', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_billing_address_country_watch', {
                        newVal: newVal,
                        oldVal: oldVal
                    });
                    if (_this.isShippingSameAsBilling && _this.flags.allowSnTCall) {
                        if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
                            _angular.$rootScope.$emit('hideErrorFields');
                            _this.triggerFetchShippingMethods = true;
                        }
                    }
                }
            });

            // Todo: Undertand: Why watch? just call a function when set true
            this.$watch('triggerFetchShippingMethods', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_trigger_fetch_shipping_methods_watch', {
                        newVal: newVal,
                        oldVal: oldVal
                    });
                    if (newVal) {
                        disableDropDown();
                        _this.fetchShippingMethods();
                    }
                }
            });

            // Watchers for shipping address country change
            this.$watch('shippingAddress.country', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_shipping_address_country_watch', {
                        newVal: newVal,
                        oldVal: oldVal,
                        isShippingSameAsBilling: _this.isShippingSameAsBilling,
                        allowSnTCall: _this.flags.allowSnTCall
                    });
                    if (!_this.isShippingSameAsBilling && _this.flags.allowSnTCall) {
                        if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
                            disableDropDown();
                            _this.fetchShippingMethods();
                        }
                    }
                }
            });

            // Watchers for shipping address state change
            this.$watch('shippingAddress.state', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _logger.$logger.info('snt_shipping_address_state_watch', {
                        newVal: newVal,
                        oldVal: oldVal,
                        isShippingSameAsBilling: _this.isShippingSameAsBilling,
                        allowSnTCall: _this.flags.allowSnTCall
                    });
                    if (!_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.flags.allowSnTCall) {
                        if (_this.isDomesticShippingMethodsSupported()) {
                            disableDropDown();
                            _this.fetchShippingMethods();
                        }
                    }
                }
            });

            // Function responsible to format each item to be shown in the dropdown
            var getShippingCharge = function getShippingCharge(charge, index) {

                var DASH = '--';
                var SPACE = ' ';

                function prefix(str, prefixStr) {
                    if (str) {
                        return (prefixStr ? prefixStr : '') + str;
                    }
                    return '';
                }

                var shippingMethod = charge.shipping_charge.shipping_method;

                var _ref = charge.shipping_charge || {},
                    _ref$shipping_amount = _ref.shipping_amount,
                    shipping_amount = _ref$shipping_amount === undefined ? {} : _ref$shipping_amount;
                // TODO: shipping amount and insurance amount formatting code can be refactored
                // Format shipping amount if available


                var shippingCurrency = '';

                if (shipping_amount) {
                    var amount = (parseInt(charge.shipping_charge.shipping_amount.value, 10) / 100).toFixed(2);
                    var currencyCode = charge.shipping_charge.shipping_amount.currency_code;
                    var formattedAmount = (0, _index.formatCurrency)(amount, currencyCode);

                    shippingCurrency = prefix(SPACE + formattedAmount, SPACE + DASH);
                }
                var shippingDeliveryTime = charge.shipping_charge.delivery_time;

                var displayShippingMethod = (0, _util.decodeEntities)(shippingMethod);

                var displayShippingDeliveryTime = prefix(shippingDeliveryTime, ' \\n ');

                // Format insurance if available
                var insuranceCurrency = '';

                if (charge.shipping_charge.insurance_amount) {
                    var insuranceAmount = (parseInt(charge.shipping_charge.insurance_amount.value, 10) / 100).toFixed(2);
                    var insuranceCurrencyCode = charge.shipping_charge.insurance_amount.currency_code;
                    var formattedInsuranceAmount = (0, _index.formatCurrency)(insuranceAmount, insuranceCurrencyCode);

                    insuranceCurrency = '' + SPACE + formattedInsuranceAmount;
                }

                var result = {

                    shippingCharge: charge,
                    shippingMethod: displayShippingMethod,
                    shippingCurrency: shippingCurrency,
                    shippingDeliveryTime: displayShippingDeliveryTime,
                    insuranceCurrency: insuranceCurrency,
                    index: index
                };

                _logger.$logger.info('snt_get_shipping_charge', {
                    result: result
                });

                return result;
            };

            // Function responsible to set default shipping method
            var setDefaultShippingMethod = function setDefaultShippingMethod() {
                _logger.$logger.info('snt_set_default_shipping_method');

                var span = $('#shippingMethodsDropDown > div > span > span > span');

                span.html(_index.$locale.content.get('shippingMethod.selectMethod'));

                _this.isStorePickUp = false;

                disableStorePickUp();

                _this.shippingChargesList = [{}];
            };

            // Populates the shipping method dropdown with shipping charges .
            var populateShippingCharges = function populateShippingCharges() {
                _logger.$logger.info('snt_populate_shipping_charges');
                setDefaultShippingMethod();
                if (_this.charges.length >= 1) {
                    enableDropDown();
                    _this.shippingChargesList = _this.charges.map(getShippingCharge);
                    _logger.$logger.info('snt_populate_shipping_charges_list', {
                        shippingChargesList: _this.shippingChargesList
                    });
                } else {
                    disableDropDown();
                }
            };

            // Checks whether selected shipping method is store pick up or not
            var isStorePickUpMethod = function isStorePickUpMethod(shipping_method_type) {
                var result = shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';

                _logger.$logger.info('snt_is_store_pickup', {
                    result: result
                });
                return result;
            };

            // Function called when user selects a shipping method from the dropdown
            this.selectShippingMethod = function (selectedShippingCharge) {
                _logger.$logger.info('snt_selected_shipping_method');
                _this.selectedMethod.index = selectedShippingCharge.index;
                _this.selectedShippingCharge = selectedShippingCharge;

                // deselect insurance checkbox
                _this.selectedShippingCharge.insuranceCheckboxChecked = false;
                _this.selectedShippingCharge.showInsuranceSelectCheckbox = false;

                var taxAmtApplied = void 0;
                var amountValue = void 0;
                var methodType = void 0;
                var insurance = void 0;
                var patchWithInsurance = false;

                if (_this.selectedShippingCharge && _this.selectedShippingCharge.shippingCharge && _this.selectedShippingCharge.shippingCharge.shipping_charge) {
                    _logger.$logger.info('snt_selected_shipping_charge');

                    var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;

                    _this.flags.allowEditShipping = true;
                    _this.flags.showSingleAddress = false;
                    _this.isStorePickUp = false;
                    if (isStorePickUpMethod(shippingCharge.shipping_method_type)) {
                        _this.isStorePickUp = true;
                        enableStorePickUp();
                    }
                    _this.shippingMethodNotSelected = false;
                    methodType = shippingCharge.shipping_method_type;
                    amountValue = safeConvert(shippingCharge.shipping_amount.value);
                    taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
                    insurance = shippingCharge.insurance_amount && shippingCharge.insurance_amount.value;

                    _logger.$logger.info('snt_selected_shipping_charge_insurance', {
                        insurance: insurance
                    });

                    if (insurance) {
                        insurance = safeConvert(insurance);
                        /**
                         *  Patch Insurance if
                         *  1. offer_insurance_option=false and there is insurance amount in response;
                         *  2. offer_insurance_option=true and there is an insurance amount in response,
                         *     then user needs to select the apply insurance checkbox first
                         */
                        if (!shippingCharge.offer_insurance_option) {
                            _logger.$logger.info('snt_selected_shipping_charge_dont_offer_insurance_option');
                            patchWithInsurance = true;
                        } else {
                            _logger.$logger.info('snt_selected_shipping_charge_show_insurance_checkbox');

                            _this.selectedShippingCharge.showInsuranceSelectCheckbox = true;
                        }
                    }
                } else {
                    _logger.$logger.info('snt_no_selected_shipping_charge');
                    _this.isStorePickUp = false;
                    amountValue = _this.buttonCartAmounts.shippingAmt;
                    taxAmtApplied = getTax();
                    methodType = 'DEFAULT';
                }

                if (_this.isInstantUpdateFlow) {
                    updateExternalCallbackOptions(_this.response.shipping_options_source, _this.selectedMethod.prevIndex, _this.selectedMethod.index);
                    if (patchWithInsurance) {
                        updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
                    } else {
                        updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
                    }
                } else if (isPatchCartRequired(amountValue, taxAmtApplied)) {
                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
                }

                _logger.$logger.info('snt_selected_shipping_method_final', {
                    prevIndex: _this.selectedMethod.index,
                    isInstantUpdateFlow: _this.isInstantUpdateFlow
                });
                _this.selectedMethod.prevIndex = _this.selectedMethod.index;
            };
            // Function called when user selects a optional insurance field in checkbox
            this.onInsuranceCheckboxChange = function (insuranceCheckboxChecked) {
                _this.selectedShippingCharge.insuranceCheckboxChecked = insuranceCheckboxChecked;
                var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;
                var insurance = safeConvert(shippingCharge.insurance_amount.value);
                var taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
                var amountValue = safeConvert(shippingCharge.shipping_amount.value);
                var methodType = shippingCharge.shipping_method_type;

                _logger.$logger.info('snt_on_insurance_checkbox_change', {
                    insuranceCheckboxChecked: insuranceCheckboxChecked,
                    amountValue: amountValue,
                    taxAmtApplied: taxAmtApplied,
                    methodType: methodType,
                    insurance: insurance
                });

                if (_this.selectedShippingCharge.insuranceCheckboxChecked === true) {
                    // Patch the cart with insurance
                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
                } else {
                    // Patch the cart without insurance
                    updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
                }
            };

            // Function responsible to populate Error fields
            var populateErrorFields = function populateErrorFields() {
                _logger.$logger.info('snt_populate_error_fields', {
                    isShippingSameAsBilling: _this.isShippingSameAsBilling
                });
                disableDropDown();
                _this.showZipCode = false;
                if (_this.isShippingSameAsBilling) {
                    _this.city = _this.billingAddress.city;
                    _this.state = _this.billingAddress.state;
                } else {
                    _this.city = _this.shippingAddress.city;
                    _this.state = _this.shippingAddress.state;
                }
            };

            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
                _logger.$logger.info('snt_populate_callback_shipping_options', {
                    charges: _this.charges
                });

                if (!_this.charges) {
                    return;
                }
                _this.callbackShippingOptions = _this.charges.map(function (charge, index) {
                    var shippingCharge = charge.shipping_charge;
                    var taxCharge = charge.tax;
                    var insurance = shippingCharge && shippingCharge.insurance_amount;
                    var option = {};

                    if (shippingCharge) {
                        option.method = shippingCharge.shipping_method;
                        option.amount = {
                            value: safeConvert(shippingCharge.shipping_amount && shippingCharge.shipping_amount.value),
                            currency: shippingCharge.shipping_amount && shippingCharge.shipping_amount.currency_code
                        };
                        option.is_default = shippingCharge.default_method;
                        option.is_selected = false;
                        if (insurance) {
                            option.insurance = {
                                value: safeConvert(insurance.value),
                                currency: insurance.currency_code
                            };
                            _this.callbackInsuranceOffered = true;
                        }
                        if (taxCharge) {
                            option.tax = {
                                value: safeConvert(taxCharge.total_tax.value),
                                currency: taxCharge.total_tax.currency_code
                            };
                        }
                    }
                    return option;
                });
                _logger.$logger.info('snt_populate_callback_shipping_options', {
                    callbackShippingOptions: _this.callbackShippingOptions
                });
            };

            var updateExternalCallbackOptions = function updateExternalCallbackOptions(optionsSource, prevIndex, index) {
                if (optionsSource === 'CALLBACK' && _this.callbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        _this.callbackShippingOptions[prevIndex].is_selected = false;
                    }
                    _this.callbackShippingOptions[index].is_selected = true;
                } else if (optionsSource === 'FALLBACK' && _this.fallbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        _this.fallbackShippingOptions[prevIndex].is_selected = false;
                    }
                    _this.fallbackShippingOptions[index].is_selected = true;
                }
                _logger.$logger.info('snt_update_external_extcallback_options', {
                    optionsSource: optionsSource,
                    prevIndex: prevIndex,
                    index: index,
                    callbackShippingOptions: _this.callbackShippingOptions,
                    fallbackShippingOptions: _this.fallbackShippingOptions
                });
            };

            // Find the charges of the default option and patch cart with corresponding values.
            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
                var shippingAmt = void 0;
                var taxAmt = void 0;
                var insuranceAmt = void 0;
                var methodType = void 0;
                // SnT service always returns FALLBACK response when no_shipping = 1

                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(_this.defaultFallbackOptionIndex)) {
                    var defaultOption = _this.fallbackShippingOptions[_this.defaultFallbackOptionIndex];

                    if (defaultOption) {
                        shippingAmt = defaultOption.amount && defaultOption.amount.value;
                        taxAmt = defaultOption.tax && defaultOption.tax.value;
                        insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
                    }
                }
                _logger.$logger.info('snt_updateShippingTaxChargeWithDefaultOption', {
                    shippingAmt: shippingAmt,
                    taxAmt: taxAmt,
                    methodType: methodType,
                    insuranceAmt: insuranceAmt
                });
                // Todo: Understand: shouldnt this call be inside if
                updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
            };

            /*  Function which is responsible to process shipping tax response
             Use cases
             ---------
             1. If shipping tax API returns error, show Error fields.
             2. (i) WPS: If response has shipping charges and shipping options are to be shown, populate the dropdown with charges else patch cart
             with shipping amount returned.
                (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
             3. If no_shipping = 1
                (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
                (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
             4. Apply tax if applicable.
             */
            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {
                _logger.$logger.info('snt_processShippingAndTaxResponse');
                var applicableShippingAmt = _this.buttonCartAmounts && _this.buttonCartAmounts.shippingAmt;

                // Set selected shipping charge as null to disallow form submit without selecting a shipping method.
                _this.selectedShippingCharge = null;

                // Handle error from service
                if (_this.shipAndTaxError) {
                    populateErrorFields();
                }
                if (_this.isInstantUpdateFlow) {
                    _logger.$logger.info('snt_is_instant_update_flow');
                    if (!_this.response.shipping_region_supported) {
                        _logger.$logger.info('snt_shipping_region_not_supported');

                        _this.flags.instantUpdateShippingRegionSupported = false;

                        var msgsArray = errorHandlerHelper.getPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.nonEmptyMerchantDisplayName });

                        // As updatePageLevelErrorMessage is an optional parameter we are
                        // checking for the parameter before calling the function
                        if (_this.updatePageLevelErrorMessage) {
                            _this.updatePageLevelErrorMessage(msgsArray);
                        }

                        return;
                    }
                    if (_this.response.shipping_options_source === 'CALLBACK') {
                        _logger.$logger.info('snt_shipping_options_source_is_callback');
                        populateCallbackShippingOptions();
                    }
                    if (_this.showShipping) {
                        _logger.$logger.info('snt_instant_update_show_shipping_is_true');
                        // this.showShipping is true when merchant passes no_shipping parameter with value 0 or 2.
                        // In this case, the shipping values from the SnT response is considered.
                        if (responseHasShippingCharges()) {
                            populateShippingCharges();
                            patchCartWithButtonParams();
                        }
                    } else {
                        // this.showShipping is false when merchant passes no_shipping parameter with value 1
                        // In this case, shipping options aren't shown. The default fallback shipping option is considered.
                        _logger.$logger.info('snt_show_shipping_is_not_true');
                        _this.showShippingMethodSection = false;
                        _this.flags.showShippingLabel = false;
                        updateShippingTaxChargeWithDefaultOption();
                    }
                    return;
                }
                // non instant update flow, no_shipping = 0
                else if (_this.showShipping) {
                        _logger.$logger.info('snt_show_shipping_is_true');
                        if (responseHasShippingCharges()) {
                            if (_this.response.show_shipping_options) {
                                _logger.$logger.info('snt_show_shipping_options_is_true');
                                populateShippingCharges();
                            } else {
                                _logger.$logger.info('snt_show_shipping_options_is_not_true');
                                // shippingCharges with out amount is returned in the charges array even shipping is not
                                // configured in the profile for the merchant. so safe to check for null values before
                                // accessing shipping_amount.

                                var _ref2 = _this.response.charges[0].shipping_charge || {},
                                    _ref2$shipping_amount = _ref2.shipping_amount;

                                _ref2$shipping_amount = _ref2$shipping_amount === undefined ? {} : _ref2$shipping_amount;
                                var value = _ref2$shipping_amount.value;
                                // call safeConvert only when value is present

                                if (value) {
                                    applicableShippingAmt = safeConvert(value);
                                }
                                _this.showShippingMethodSection = false;
                                _this.flags.showShippingLabel = false;
                            }
                        }
                    }
                    // not instant update flow, no_shipping = 1 , profile_override = true , shipping passed in button.
                    else if (_this.response.profile_override_allowed) {
                            _logger.$logger.info('snt_profile_override_allowed');
                            // If shipping Amt is not empty , set applicable shipping amt for patch cart
                            if (_this.buttonCartAmounts && _this.buttonCartAmounts.shippingAmt) {
                                applicableShippingAmt = _this.buttonCartAmounts.shippingAmt;
                                _this.showShippingMethodSection = false;
                                _this.flags.showShippingLabel = false;
                            }
                        }

                var applicableTaxAmt = getTax();

                // Patch if shipping amt or tax amount has changed
                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
                    updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt, 'DEFAULT');
                }
            };

            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
                _logger.$logger.info('snt_clearFallbackOptionsSelectionFlags', {
                    fallbackShippingOptions: _this.fallbackShippingOptions
                });
                if (!_this.fallbackShippingOptions) {
                    return;
                }
                for (var i = 0; i < _this.fallbackShippingOptions.length; i++) {
                    _this.fallbackShippingOptions[i].is_selected = false;
                }
            };

            // Function which gets shipping and tax charges from the merchant profile.
            this.fetchShippingMethods = function () {

                _this.flags.showShippingLabel = true;
                _this.flags.instantUpdateShippingRegionSupported = true;
                _this.selectedMethod = {};
                _this.response = {};
                _this.callbackShippingOptions = [];
                _this.callbackInsuranceOffered = false;
                _this.showShippingMethodSection = true;
                _this.shippingChargesList = [{}];

                // Todo: Understand: What?
                _this.setAllowPayWithSnT(false);

                clearFallbackOptionsSelectionFlags();

                var shippingAddress = _this.billingAddress;

                if (!_this.isShippingSameAsBilling) {
                    shippingAddress = _this.shippingAddress;
                }

                _this.trackZipCode.prev = shippingAddress.postal_code;
                _this.trackState.prev = shippingAddress.state;

                _this.dropDownBackground = 'processingBackground';

                _this.selectedShippingMethodText = 'disableShippingMethod';

                _this.changeShippingMethod = 'changeShippingMethodDisabled';

                var cartWeight = void 0,
                    discount = void 0,
                    cartHandling = void 0,
                    currCode = void 0;

                if (_this.models.checkoutCart.cartWeight && _this.models.checkoutCart.cartWeight.value) {
                    cartWeight = {
                        value: Number(_this.models.checkoutCart.cartWeight.value).toFixed(2),
                        unit: _this.models.checkoutCart.cartWeight.unit
                    };
                }

                if (_this.models.checkoutCart.purchase.amounts.discount && _this.models.checkoutCart.purchase.amounts.discount.amount) {
                    discount = Number(_this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2);
                }

                if (_this.models.checkoutCart.purchase.amounts.handling_fee && _this.models.checkoutCart.purchase.amounts.handling_fee.amount) {
                    cartHandling = Number(_this.models.checkoutCart.purchase.amounts.handling_fee.amount).toFixed(2);
                }

                currCode = _this.models.checkoutCart.purchase.amounts.total.currency_code;

                var sntRequest = {
                    'currency_code': _this.currencyCode,
                    'cart_weight': cartWeight,
                    'cart_handling': { value: cartHandling, currency_code: currCode },
                    'discount': { value: discount, currency_code: currCode },
                    'item_list': _this.models.checkoutCart.purchase.items,
                    'tax_on_shipping_required': _this.showShipping, //   tax on shipping is not applicable when no_shipping is 1
                    'merchant_id': _this.models.checkoutPayee.merchant.id,
                    'locale': _index.$locale.lang + '_' + _index.$locale.country
                };

                _logger.$logger.info('snt_fetch_shipping_methods', {
                    sntRequest: sntRequest,
                    state: shippingAddress.state,
                    postal_code: shippingAddress.postal_code
                });

                sntRequest.address = {
                    'line1': shippingAddress.line1,
                    'line2': shippingAddress.line2,
                    'city': shippingAddress.city,
                    'state': shippingAddress.state,
                    'postal_code': shippingAddress.postal_code,
                    'country_code': shippingAddress.country,
                    'id': _this.token
                };

                if (_this.isInstantUpdateFlow) {
                    _this.trackSntReq.address = sntRequest.address;
                    sntRequest.external_callback_options = _this.models.checkoutCart.getExternalCallbackOptions();
                    // TODO: For EC flows, populate sntRequest.token as well.
                }
                _this.shippingMethods = new _index2.$ShippingMethodModel(sntRequest);

                _this.shippingMethods.save({
                    data: _this.shippingMethods,

                    contingencies: {
                        VALIDATION_ERROR: function VALIDATION_ERROR(name, err) {
                            _logger.$logger.info('snt_get_shipping_methods_VALIDATION_ERROR');
                            _this.shipAndTaxError = true;
                            if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
                                _angular.$rootScope.$emit('showErrorFields');
                            }
                            populateErrorFields();
                            patchCartWithButtonParams();
                        },
                        INTERNAL_SERVICE_ERROR: function INTERNAL_SERVICE_ERROR(name, err) {
                            _logger.$logger.info('snt_get_shipping_methods_INTERNAL_SERVICE_ERROR');
                            _this.shipAndTaxError = true;
                            if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
                                _angular.$rootScope.$emit('showErrorFields');
                            }
                            populateErrorFields();
                            patchCartWithButtonParams();
                        }
                    },
                    success: function success(result) {
                        _logger.$logger.info('snt_get_shipping_methods_success');
                        _this.response = result;
                        _this.charges = result.charges;
                        _this.triggerFetchShippingMethods = false;
                        _this.setAllowPayWithSnT(true);
                        processShippingAndTaxResponse();
                    }
                });
            };
            _angular.$rootScope.$on('submission_triggered', function () {
                _logger.$logger.info('snt_submission_triggered');
                disableDropDown();
                _this.fetchShippingMethods();
            });
        },

        populate: function populate() {

            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
            this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
            if (this.isInstantUpdateFlow) {
                this.fallbackShippingOptions = this.models.checkoutCart.getExternalCallbackOptions().fallback_shipping_options;
                if (this.fallbackShippingOptions) {
                    this.defaultFallbackOptionIndex = _index.$util.findIndex(this.fallbackShippingOptions, function (option) {
                        return option.is_default;
                    });
                }
            }

            this.buttonCartAmounts = {
                shippingAmt: this.buttonParams.shipping ? Number(this.buttonParams.shipping.amount) : undefined,
                taxAmt: this.buttonParams.tax ? Number(this.buttonParams.tax.amount) : undefined,
                discount: this.models.checkoutCart.purchase.amounts.discount ? Number(this.models.checkoutCart.purchase.amounts.discount.amount) : undefined,
                subTotal: Number(this.models.checkoutCart.purchase.amounts.subtotal.amount),
                total: Number(this.buttonParams.total.amount)
            };

            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;

            // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
            // then we need the value of merchantDisplayName to be 'the merchant' as it is the first word
            // in shippingMethod.shippingRegionUnsupported content key used below
            this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
                nonEmptyReturnValue: true,
                isSentenceBeginning: true
            });

            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;

            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;

            if (this.models.checkoutCart.cartWeight) {
                if (this.models.checkoutCart.cartWeight.value) {
                    this.cartWeight = {
                        value: Number(this.models.checkoutCart.cartWeight.value).toFixed(2),
                        unit: this.models.checkoutCart.cartWeight.unit
                    };
                }
            }

            if (this.models.checkoutCart.purchase.amounts.discount) {
                if (this.models.checkoutCart.purchase.amounts.discount.amount) {
                    this.cartDiscount = {
                        value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
                        currency_code: this.currencyCode
                    };
                }
            }

            if (this.models.checkoutCart.purchase.amounts.handling_fee) {
                this.buttonCartAmounts.handlingAmt = Number(this.models.checkoutCart.purchase.amounts.handling_fee.amount);
            }

            if (this.models.checkoutCart.purchase.amounts.insurance) {
                this.buttonCartAmounts.insuranceAmt = Number(this.models.checkoutCart.purchase.amounts.insurance.amount);
            }

            if (this.models.checkoutCart.purchase.amounts.shipping_discount) {
                this.buttonCartAmounts.shippingDiscountAmt = Number(this.models.checkoutCart.purchase.amounts.shipping_discount.amount);
            }

            this.previousCosts = {
                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
            };

            if (!this.isDomesticShippingMethodsSupported()) {
                this.triggerFetchShippingMethods = true;
            }

            _logger.$logger.info('snt_populate', {
                buttonCartAmounts: this.buttonCartAmounts,
                previousCosts: this.previousCosts
            });

            // trigger zipCodeBlur handler to fetch shipping methods in case of pre-filled address
            this.handleZipCodeBlur();
        }
    }
}); /**
     * Created by aaramamurthy on 2/29/16.
     *
     * Component responsible to show shipping methods set by merchant to a buyer during guest checkout flow.
     */

_angular.$rootScope;

_index.$Component;

_index.$locale;

_index.formatCurrency;

_index.$feature;

_index.$util;

_logger.$logger;

_index2.$ShippingMethodModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutSessionModel;

_index3.$CheckoutPayeeModel;

_util.decodeEntities;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Created by aaramamurthy on 3/22/16.
 *
 * This is a dropdown multiline directive customised for shipping charges dropdown .
 * Existing multiline dropdown does not provide the functionality to have element based styling inside an dropdown item.
 * Existing multiline dropdown also shows an empty object in the dropdown if passed.
 * This directive populates the dropdown by making shipping amount as bold .
 * This directive populates the dropdown with items which is a valid object and has a value.
 */



!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {

    squid.module('xo-shipping-method-dropdown.directive', ['squid']).directive('xoShippingMethodDropDown', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',

            require: '?ngModel',

            link: function link($scope, $select, attrs, ngModel) {

                var isListVisible = false;
                var listCreated = false;

                $select = $($select);

                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
                var $list;

                function updateCover() {
                    $timeout(function () {
                        var span = $span.find('span span');

                        var text = $select.find('[selected]').text().replace(/\\n/gi, '<br>').trim();

                        var shippingAmount = text.substring(text.search('--'), text.search('<br>'));

                        var boldText = text.replace(shippingAmount, shippingAmount.bold());

                        boldText = boldText.replace('--', '-');

                        span.html(boldText);
                    }, 10);
                }

                function createList($options) {
                    if ($options.length < 2) {
                        return;
                    }

                    function getModel() {
                        var modelName;
                        var model;
                        var subParts;

                        if ($select.attr('ng-options')) {
                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
                        } else {
                            var $option = $($select.find('[ng-repeat]')[0]);

                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
                        }

                        // This is to handle cases like card.billingAddress
                        if (modelName.indexOf('.') !== -1) {
                            subParts = modelName.split('.');
                            model = $scope;

                            for (var i = 0; i < subParts.length; i++) {
                                model = model[subParts[i]];
                            }
                        } else {
                            // And this is to handle straightforward model names
                            model = $scope[modelName];
                        }

                        return model;
                    }

                    function hideList(event) {
                        $list.hide();
                        $container.append($list);
                        isListVisible = false;
                        $container.removeClass('open');
                    }

                    function positionList() {
                        $list.css('left', $container.offset().left + 'px');
                        $list.css('top', $container.offset().top + $container.height() + 'px');
                        $list.css('width', $container.width() + 'px');
                    }

                    function setFocusOnSelected() {
                        var $selected = $select.find('[selected]');

                        if ($selected.length) {
                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');

                            $item.focus();
                        } else {
                            $list.find('li')[0].focus();
                        }
                    }

                    function showList() {
                        $('body').append($list);
                        $container.addClass('open');
                        $list.show();
                        positionList();
                        isListVisible = true;
                        setFocusOnSelected();
                    }

                    function processContainerKeypress(event) {
                        var keyCode = event.keyCode;

                        if (keyCode === 13 || keyCode === 40) {
                            // enter or down arrow
                            if (!isListVisible) {
                                showList();
                            } else {
                                hideList();
                                $container.focus();
                            }
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                            }
                        }
                    }

                    if ($list) {
                        $list.remove();
                    }

                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');

                    Array.prototype.forEach.call($options, function (option) {
                        var $option = $(option);
                        var value = $option.attr('value');

                        var text = option.innerHTML.replace(/\\n/gi, '<br>');

                        var shippingAmount = text.substring(text.search('--'), text.search('<br>'));

                        var boldText = text.replace(shippingAmount, shippingAmount.bold());

                        boldText = boldText.replace('--', '- ');

                        if (boldText.indexOf('content(') !== -1) {
                            boldText = $scope.content(boldText.substring(boldText.indexOf('(\'') + 2, boldText.indexOf('\')')));
                        }

                        var html = '<li tabindex="0"';

                        if (value !== $option.text()) {
                            html = html + ' data-value="' + value + '"';
                        }
                        html = html + '>' + boldText + '</li>';
                        if (value !== '') {
                            $list.append($(html));
                        }
                    });

                    $container.append($list);
                    $list.hide();

                    $($list.find('li')).click(function (event) {
                        var $target = $(event.target);
                        var value = $target.data('value');

                        if ($target[0].nodeName.toLowerCase() !== 'li') {
                            value = $target.parent().data('value');
                        }

                        if (typeof value !== 'undefined') {
                            $select.find('option').removeAttr('selected');
                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
                            $select.find('option').removeProp('selected');
                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
                        } else {
                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
                            $select.val(value);
                        }

                        if ($select.attr('ng-model')) {
                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                                /* This parses the 'ng-options' directive and returns the options model.
                                 For example: If you have: ng-options='opt as opt.label for opt in options'
                                 Here it will parse this attribute and return 'options */
                                var model = getModel();

                                ngModel.$setViewValue(model[value]);
                            } else {
                                ngModel.$setViewValue(value);
                            }
                        }

                        updateCover();
                        hideList();
                    });

                    var $innerContainer = $container.find('.innerContainer');

                    $container.click(function (event) {
                        if (isListVisible) {
                            hideList();
                            $container.focus();
                        } else {
                            showList();
                        }
                    });

                    $container.keydown(function (event) {
                        processContainerKeypress(event);
                    });

                    $innerContainer.keydown(function (event) {
                        processContainerKeypress(event);
                    });

                    $list.find('li').keydown(function (event) {
                        var keyCode = event.keyCode;
                        var $target = $(event.target);

                        if (keyCode === 13) {
                            // enter
                            $target.click();
                            event.stopPropagation();
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 40) {
                            // down arrow
                            if (!$target.is(':last-of-type')) {
                                $target.next().focus();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 38) {
                            // up arrow
                            if (!$target.is(':first-of-type')) {
                                $target.prev().focus();
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    });

                    $(window).resize(function () {
                        if (isListVisible) {
                            positionList();
                        }
                    });

                    $(window).bind('hashchange', function () {
                        if (isListVisible) {
                            hideList();
                        }
                    });

                    $(document).click(function (event) {
                        var $target = $(event.target);

                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
                            hideList();
                        }
                    });

                    listCreated = true;
                    updateCover();
                }

                function render() {
                    var options = $select.find('option');

                    if (!listCreated) {
                        createList(options);
                    }
                }

                $select.wrap($container);
                $container = $select.parent();

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter focus', function () {
                    $span.addClass('active');
                });

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseleave blur', function () {
                    $span.removeClass('active');
                });

                $select.after($span);

                $select.addClass('replaced');

                $select.attr('tabindex', '-1');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                    $scope.$watch(attrs.ngModel, function () {
                        render();
                    });
                } else {
                    $timeout(function () {
                        $scope.$broadcast('pageRendered');
                    }, 0);
                }

                $scope.$on('pageRendered', function () {
                    render();
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectShippingMethod\" ng-if=\"showShippingMethodSection\" content>\n    <label class=\"shippingMethodTitle\">{{content('shipping.shippingMethodTitle')}}</label>\n\n    <div id=\"merchantOptions\" class=\"merchantOptionsStyle\">\n        <p class=\"guestMerchantOptions\" ng-show=\"showMerchantOptions\">\n            {{content('shippingMethod.guestMerchantOptions')}}\n        </p>\n\n        <p class=\"guestMerchantOptions\" ng-show=\"showZipCode\">\n            {{content('shippingMethod.zipCode')}}:\n        </p>\n\n        <p class=\"zipCodeOptions\" ng-show=\"showZipCode\">\n            {{zipCode}}\n        </p>\n\n        <p class=\"addressOptions\" ng-show=\"shipAndTaxError\">\n            [{{city}},{{state}} {{zipCode}}]\n        </p>\n\n    </div>\n\n    <div id=\"shippingMethodsDropDown\" ng-if=\"isShowShippingMethodsDropDown && !noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,dropDownBackground,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-shipping-method-drop-down ng-model=\"selectedShippingCharge\"\n                ng-change=\"selectShippingMethod(selectedShippingCharge)\"\n                id=\"shippingMethodDropDown\" name=\"shippingMethodDropDown\"\n                ng-required = \"shippingMethodNotSelected\" ng-hide=\"hideSelectDropdown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\" > {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in shippingChargesList\" value=\"{{$index}}\">\n                {{charge.shippingMethod}}{{charge.shippingCurrency}}{{charge.shippingDeliveryTime}}\n            </option>\n\n        </select>\n\n    </div>\n\n    <div class=\"row-fluid checkbox shippingMethodApplyInsuranceContainer\"\n         ng-if=\"selectedShippingCharge && selectedShippingCharge.showInsuranceSelectCheckbox\">\n\n        <input type=\"checkbox\" ng-model=\"selectedShippingCharge.insuranceCheckboxChecked\"\n               name=\"shippingMethodApplyInsurance\" id=\"shippingMethodApplyInsurance\"\n               ng-change=\"onInsuranceCheckboxChange(selectedShippingCharge.insuranceCheckboxChecked)\">\n        <label class=\"noBottom\" for=\"shippingMethodApplyInsurance\"\n               ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance',{amount: selectedShippingCharge.insuranceCurrency})\">\n        </label>\n\n    </div>\n\n    <div id=\"noShippingMethod\" ng-if=\"noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-dropdown-multiline id=\"noShippingMethodDropDown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\"> {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in noShippingChargesList track by $index\" value=\"{{$index}}\">\n\n            </option>\n\n        </select>\n\n    </div>\n\n    <div id=\"shippingMethodProcessing\" ng-show=\"isProcessing\">\n        <div class=\"spinner\">\n            <p class=\"loader\" ></p>\n        </div>\n    </div>\n\n    <div id=\"showPickUpStore\" class=\"pickUpStoreText\" ng-if=\"isStorePickUp\">\n        {{content('shippingMethod.storeLocationInfo')}}\n    </div>\n\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _errorHandlerHelper = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js");

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = _squid.$Component.extend('xoGuestSepaLightbox', {
    tag: 'xo-guest-sepa-lightbox',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        address: {
            type: 'var',
            required: false
        },
        singlePagePaymentForm: {
            type: 'var',
            required: false
        },
        updatePageLevelErrorMessage: {
            type: 'var',
            required: false
        },
        validated: {
            type: 'var',
            required: false
        },
        sepa: {
            type: 'var',
            required: false
        },
        onboard: {
            type: 'var',
            required: false
        },
        sectionElement: {
            type: 'var',
            required: false
        },
        flags: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {},
        populate: function populate() {
            var _this = this;

            var openSepa = function openSepa() {
                var form = _this.singlePagePaymentForm;
                var formValid = true;
                var firstFailedElementName = determineFirstFailedElement();

                // Clear existing error messages
                _this.validated = true;

                _this.noErrorShowSepa = false;

                function determineFirstFailedElement() {
                    var result = void 0;
                    var sepaNotRequiredFields = ['sepaAgree', 'sepaGuestAgree', 'guestagree', 'agree'];

                    for (var i in form) {
                        if (form[i] && form[i].hasOwnProperty && form[i].hasOwnProperty('$valid') && sepaNotRequiredFields.indexOf(form[i].$name) === -1 && // Dont check validity for fields we don't need for SEPA
                        !form[i].$valid) {
                            formValid = false;
                            result = form[i].$name;
                            break;
                        }
                    }

                    return result;
                }
                // If form is valid then call validateBank Api and then open sepa

                if (formValid) {
                    _this.addBankModel = new _index.$AddBankModel({
                        user: _this.onboard.user,
                        bank: _this.onboard.bank
                    });

                    _this.addBankModel.action('validate', {

                        data: _this.addBankModel.getBankData(),

                        resultModel: {},

                        success: function success(data) {
                            _this.addBankModel.creditorDetails = data.creditorDetails;
                            _this.addBankModel.fiDetails = data.fiDetails;
                            _this.noErrorShowSepa = true;
                            (0, _angular.$timeout)(function () {
                                window.scrollTo(0, 0);
                            }, 100);
                        },

                        contingencies: {
                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
                                var pageLevelErrorObj = _util.$fiErrorUtil.addPageErrors(data, 'bank');

                                _this.hideSepa();
                                _this.updatePageLevelErrorMessage(pageLevelErrorObj.msgs, pageLevelErrorObj.type);
                                _util.$fiErrorUtil.addFieldErrors(data, _this.sectionElement);
                                firstFailedElementName = determineFirstFailedElement();
                                errorHandlerHelper.scrollToElement(firstFailedElementName);
                            }
                        },
                        validation: function validation(data) {

                            var returnObj = { fields: [] };

                            _this.hideSepa();

                            angular.forEach(data.fields || [], function (field) {
                                returnObj.fields.push(field.property);
                            });

                            errorHandlerHelper.addFieldError(returnObj);

                            firstFailedElementName = determineFirstFailedElement();
                            errorHandlerHelper.scrollToElement(firstFailedElementName);
                        }
                    });
                } else {
                    _this.hideSepa();
                    errorHandlerHelper.scrollToElement(firstFailedElementName);
                }
            };

            this.hideSepa = function () {
                _this.noErrorShowSepa = false;
                _this.sepa.show = false;
            };

            // Added the sepa content change based on US755520
            var setSepaOverlayContent = function setSepaOverlayContent() {
                _this.sepaTitle = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.sepaTitleUnbranded' : 'DEMemberGuest.sepaTitle';
                _this.sepaAgreement = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.ddAgreementUnbrandedPara1' : 'DEMemberGuest.ddAgreementPara1';
                if (_this.flags.show_sepa_overlay) {
                    if (_this.flags.isUnbranded && _this.flags.commit) {
                        _this.sepaSubmit = 'common.acceptAndComplete';
                    } else {
                        _this.sepaSubmit = 'common.acceptAndContinue';
                    }
                } else {
                    _this.sepaSubmit = 'header.close';
                }
            };

            this.$watch('sepa.show', function (newVal, oldVal) {
                if (newVal) {
                    openSepa();
                }
            });

            this.$watch('flags.show_sepa_overlay', function (newVal, oldVal) {
                if (newVal) {
                    setSepaOverlayContent();
                }
            });

            setSepaOverlayContent();
        }
    },
    actions: {
        closeSepa: function closeSepa($event) {
            $event.preventDefault();
            this.hideSepa();
        },
        acceptSepa: function acceptSepa($event) {
            $event.preventDefault();

            this.hideSepa();
            this.sepa.sepaGuestAgree = true;
            this.sepa.sepaAgree = true;
            if (this.flags.show_sepa_overlay) {
                this.doneFn();
            }
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$AddBankModel;

_angular.$timeout;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sepa/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"kmliUpsell upsellOpen sepa\" ng-if=\"noErrorShowSepa\">\n    <div class=\"upsellMask\"></div>\n\n    <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\" content>\n        <div class=\"sepaContainer\">\n\n\n            <a href=\"#\" class=\"close\" ng-click=\"actions.closeSepa($event)\">close</a>\n\n            <h1 id=\"sepaTitle\" class=\"alpha\">{{ content(sepaTitle) }}</h1>\n\n            <p id=\"sepaAgreement\">{{ content(sepaAgreement) }}</p>\n\n            <div class=\"carrierinfo\">\n                <span><strong>{{ content('DEMemberGuest.accountCarrier') }}</strong></span>\n                <div><span>{{addBankModel.user.first_name}} {{addBankModel.user.last_name}}</span></div>\n                <div><span>{{address.line1}}</span></div>\n                <div><span ng-if=\"address.line2\">{{address.line2}}</span></div>\n                <div><span>{{address.postal_code}} {{address.city}}</span></div>\n            </div>\n\n            <div class=\"bankinfo\">\n                <p>\n                    <span class=\"col1\"> <strong>{{content('DEMemberGuest.IBAN')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.piAccountNumber}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bankName')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.isssuerDetails.name}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bic')}} </strong> </span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.bic}}</span>\n                </p>\n            </div>\n\n            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content(sepaSubmit) }}\"\n                   class=\"btn full\"\n                   ng-click=\"actions.acceptSepa($event)\" />\n\n            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/template.html");

var _template2 = _interopRequireDefault(_template);

var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoGuestSimplifiedSelectShippingMethods', {
    tag: 'xo-guest-simplified-select-shipping-methods',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },

        selectedShippingMethod: {
            type: 'var',
            required: false
        },

        shippingMethods: {
            type: 'var',
            required: true
        },

        selectShippingMethod: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        clickDropdown: function clickDropdown($event) {
            if ($event) {
                $event.stopPropagation();
            }

            this.isActive = !this.isActive;
        },
        selectShippingMethod: function selectShippingMethod(selected) {
            // filtering the correct method from the props. Will only be 1.
            var shippingMethod = this.props.shippingMethods.find(function (method) {
                return method.id === selected.id;
            });

            // storing the selected shipping method in the incontext cache.
            this.selectShippingMethod(shippingMethod);
        },
        getFormattedType: function getFormattedType(shippingMethod) {
            return (0, _squid.$renderContent)(_constants.SHIPPING_TYPE_MAPPING[shippingMethod.type] || '');
        },
        getFormattedLabel: function getFormattedLabel(shippingMethod) {
            if (shippingMethod.amount && parseFloat(shippingMethod.amount.value) > 0) {
                var amountFormatted = (0, _squid.formatCurrency)(shippingMethod.amount.value, shippingMethod.amount.currency_code);
                return (0, _squid.$renderContent)('shipping.customLabelAndAmount', {
                    amount: amountFormatted,
                    label: shippingMethod.label
                });
            }

            return shippingMethod.label;
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.isActive = false;

            // closing the dropdown on 'clickBody' event
            this.$on('clickBody', function () {
                _this.isActive = false;
            });
        }
    }
});


_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_index.$CheckoutAppDataModel;

_constants.SHIPPING_TYPE_MAPPING;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/simplifiedShippingMethods/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"simplifiedSelectShippingMethod\" content> <label class=\"shippingMethodTitle\" ng-bind-html=\"content('shipping.shippingMethodTitle')\"></label>\n\n    <div id=\"merchantOptions\" class=\"merchantOptionsStyle\">\n        <p class=\"guestMerchantOptions\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\"></p>\n    </div>\n\n    <div id=\"shippingMethodContainer\" class=\"dropdownContainer\" ng-class=\"{active: isActive}\" ng-click=\"actions.clickDropdown($event)\" tabindex=\"1\">\n        <div ng-if=\"!props.selectedShippingMethod || isActive\" class=\"soft\" ng-bind-html=\"content('shipping.selectShippingMethod')\"></div>\n\n        <div ng-if=\"props.selectedShippingMethod && !isActive\" class=\"display\">\n            <label class=\"selectedType\" ng-bind-html=\"actions.getFormattedType(props.selectedShippingMethod)\"></label>\n            <span ng-bind-html=\"actions.getFormattedLabel(props.selectedShippingMethod)\"></span>\n        </div>\n\n        <ul class=\"dropdown\">\n            <li ng-repeat=\"shippingMethod in shippingMethods track by $index\" ng-click=\"actions.selectShippingMethod(shippingMethod)\">\n                <span ng-bind-html=\"actions.getFormattedLabel(shippingMethod)\"></span>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sticky.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.setStickyInstrument = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

/**
 * Makes billing agreement financial instrument sticky if necessary
 *
 * @param {CheckoutSession} checkoutSession
 * @return {Promise}
 */
var setStickyInstrument = exports.setStickyInstrument = function setStickyInstrument(checkoutSession) {
    if (!checkoutSession) {
        throw new TypeError('missing checkoutSession');
    }

    if (checkoutSession.selectedFuturePaymentInstrument) {
        // session already has a sticky instrument
        _logger.$logger.info('no_setStickyFI_call_checkoutsession_already_has_sticky_fi');
        return _squid.$promise.resolve();
    }

    var stickyInstrument = checkoutSession.getSelectedStickyInstrument();

    // billing agreement is not supported for WPS and guest transactions
    // we dont do setStickyFI call in both WPS and guest transactions
    if (stickyInstrument) {
        _logger.$logger.info('calling_checkoutsession_setStickyFI_API');
        return checkoutSession.action('setStickyFI', {
            data: {
                instrument_id: stickyInstrument.instrument_id
            }
        });
    }

    _logger.$logger.info('no_setStickyFI_call_checkoutsession_has_no_selected_sticky_fi');
    return _squid.$promise.resolve();
};

_squid.$promise;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"singlePagePayment\" id=\"singlePagePayment\">\n\n    <!-- BillingAgreement flows need to display description passed by merchant in cart -->\n    <xo-ba-message-banner ng-if=\"billingAgreementMerchantMsg\" token=\"token\"></xo-ba-message-banner>\n\n    <xo-message message=\"topErrorMessage\"></xo-message>\n    <xo-login-button ng-if=\"landingAbTestCheck()\" redirect=\"redirect\"></xo-login-button>\n    <xo-message message=\"errorMessage\"></xo-message>\n\n    <xo-xoon-header token=\"token\" flags=\"flags\" user=\"onboard.user\" mode=\"mode\" fi-mode=\"onboard.fiMode\"></xo-xoon-header>\n\n    <form id=\"singlePagePaymentForm\" name=\"singlePagePaymentForm\" class=\"singlePagePaymentForm\" ng-submit=\"singlePagePaymentForm.$valid && actions.onSubmit()\" ng-class=\"{'validated': validated, 'APAC': isApac()}\" novalidate>\n\n        <xo-country-list is-unbranded=\"isUnbranded\" token=\"token\" show-mask=\"showMask\" mode=\"mode\"></xo-country-list>\n\n        <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n            <span ng-if=\"showFISwitchTab()\">\n                <ul class=\"form-tabs\" id=\"paymentTab\">\n                    <li ng-repeat=\"fi in getToggleKeys\" class=\"{{fi.type}} {{onboard.fiMode === fi.type ? 'active' : ''}}\" ui-sref-active=\"active\">\n                        <a ng-click=\"actions.toggleFIMode($event, fi.type)\" href=\"#\" class=\"{{fi.type}}Tab\">{{content(fi.label)}}</a>\n                    </li>\n                </ul>\n            </span>\n\n            <div ng-if=\"showTeslaAddBankFlow()\">\n                <xo-tesla-add-bank token=\"token\" user=\"onboard.user\"></xo-bank-input>\n            </div>\n\n            <div ng-if=\"!showTeslaAddBankFlow()\">\n                <div ng-if=\"onboard.fiMode === 'card'\" id=\"cardFields\">\n                <xo-credit-card\n                    token=\"token\"\n                    card=\"onboard.card\"\n                    user=\"onboard.user\"\n                    name-below=\"true\"\n                    card-number-changed=\"cardNumberChanged\"\n                    set-buyer-fx-flag=\"setBuyerFxFlag\">\n                </xo-credit-card>\n\n                <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                    <a ng-if=\"!singleStepModel.selectedInstallmentData.preventChange\" id=\"paymentMethod\" ui-sref=\"{{currentState}}.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-to-top>\n                        <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                            {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                        </span>\n                        <span ng-if=\"!singleStepModel.selectedInstallmentData\">\n                            {{content('paymentMethod.changeInstallmentLongLink')}}\n                        </span>\n                    </a>\n                    <a ng-if=\"singleStepModel.selectedInstallmentData.preventChange\"\n                       class=\"getInstallments btn btn-secondary\" disabled>\n                        <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                            {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                        </span>\n                    </a>\n                    <div ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                        <a href=\"#\" id=\"installmentHelp\" aria-label=\"{{content('common.altHelp')}}\" class=\"verifyHelp\">\n                        </a>\n                    </div>\n                    <xo-tooltip ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                        <div class=\"tip tipDesc emailToolTip\">\n                            {{content('paymentMethod.installmentPreselectedHelp')}}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <input ng-if=\"isInstallmentsVisible() && !singleStepModel.selectedInstallmentData\"\n                       type=\"text\"\n                       name=\"installments\"\n                       id=\"installments\"\n                       ng-model=\"singleStepModel.selectedInstallmentData.installment_option_selected.term\"\n                       value=\"\"\n                       class=\"hiddenInput ng-pristine\"\n                       required/>\n\n                <xo-name-input user=\"onboard.user\"></xo-name-input>\n\n                <xo-inline-currency-conversion\n                    card=\"onboard.card\"\n                    token=\"token\"\n                    treatment=\"flags.buyerFxTreatment\"\n                    ng-if=\"flags.hasBuyerFxPrePlanData && flags.buyerFxTreatment\">\n                </xo-inline-currency-conversion>\n            </div>\n\n            <div ng-if=\"onboard.fiMode === 'bank'\" id=\"bankFields\">\n                <xo-name-input user=\"onboard.user\"></xo-name-input>\n                <xo-bank-input token=\"token\" bank=\"onboard.bank\" is-unbranded=\"isUnbranded\" user=\"onboard.user\"></xo-bank-input>\n            </div>\n\n            <xo-phone-input ng-if=\"!hasDialingCodeOverride() && !flags.allowChoice && !flags.cupDetected\" phone=\"onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n\n\n            <h2 class=\"billingLabel sectionTitle\" ng-if=\"!flags.whiteListedIndiaMerchant\">{{content('addressBook.billingAddress')}}</h2>\n            <div id=\"billingAddress\" ng-class=\"{'validated': billingAddressValidated}\" ng-if=\"!flags.whiteListedIndiaMerchant\">\n                <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\" trigger-zip-code-blur=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" trigger-zip-code-key-press=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n            </div>\n\n\n            <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"flags.allowEditShipping && !flags.disallowShipToBilling && !flags.whiteListedIndiaMerchant\">\n                <input ng-model=\"flags.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\" class=\"shipToBilling\"/>\n                <label class=\"noBottom\" for=\"shipToBilling\" ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n            </div>\n\n            <h2 ng-if=\"flags.showShippingLabel && (flags.wps_SnT_flow || isInstantUpdateFlow || ixoModel.ixoShippingMethods)\" class=\"nolap shippingLabel sectionTitle\">{{content('shipping.shippingLabel')}}</h2>\n\n            <div id=\"showShippingAddress\" ng-if=\"flags.showSingleAddress\">\n                <div class=\"showShippingAddressHeading\">\n                    <span class=\"showShippingAddressTitle\">{{content('shipping.shippingTitle')}}</span>\n                    <a class=\"editShippingAddress\"\n                       ng-click=\"actions.editShippingAddress()\">{{content('common.change')}}</a>\n                </div>\n                <div class=\"shippingAddress\">\n                    {{shippingAddress.displayLine1}}<br/>\n                    {{shippingAddress.displayLine2}}<br/>\n                    {{shippingAddress.displayLine3}}\n                </div>\n            </div>\n\n            <div ng-if=\"(!flags.shipToBilling || flags.whiteListedIndiaMerchant) && flags.allowEditShipping\" ng-hide=\"(flags.wps_SnT_flow || isInstantUpdateFlow) && flags.hideShippingAddress\" id=\"shippingAddress\" ng-class=\"{'validated': shippingAddressValidated}\">\n\n                <h2 class=\"nolap shippingAddressLabel sectionTitle\">{{content('shipping.shippingTitle')}}</h2>\n\n                <xo-message message=\"changeShippingCountryAlert\"></xo-message>\n\n                <xo-select-shipping-country token=\"token\" shipping-address=\"onboard.shipping_address\"\n                                            disable-change-shipping-country=\"flags.disableChangeShippingCountry\"></xo-select-shipping-country>\n\n                <xo-add-address address=\"onboard.shipping_address\" is-shipping=\"true\" token=\"token\" country=\"onboard.shipping_address.country\" trigger-zip-code-blur=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" trigger-zip-code-key-press=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n\n            </div>\n\n            <div id=\"shippingMethod\" ng-if=\"flags.wps_SnT_flow || isInstantUpdateFlow || ixoModel.ixoShippingMethods\">\n                <xo-guest-select-shipping-method ng-if=\"!ixoModel.ixoShippingMethods\"\n                                                 token=\"token\"\n                                                 show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"onboard.billing_address\"\n                                                 shipping-address=\"onboard.shipping_address\"\n                                                 track-snt-req=\"trackSntReq\"\n                                                 is-shipping-same-as-billing=\"flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 update-page-level-error-message=\"actions.updatePageLevelErrorMessage\"\n                                                 flags = \"flags\"></xo-guest-select-shipping-method>\n                <xo-guest-simplified-select-shipping-methods\n                    ng-if=\"ixoModel.ixoShippingMethods\"\n                    token=\"token\"\n                    select-shipping-method=\"ixoModel.updateIxoSelectedShippingMethod\"\n                    shipping-methods=\"ixoModel.ixoShippingMethods\"\n                    selected-shipping-method=\"ixoModel.ixoSelectedShippingMethod\">\n                </xo-guest-simplified-select-shipping-methods>\n            </div>\n\n            <div ng-if=\"showContactInfo()\">\n                <h2 class=\"nolap billingLabel sectionTitle\">{{content('addPhone.contactInformation')}}</h2>\n                <p ng-if=\"flags.cupDetected\" class=\"subTitle upopMobileNotify\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></p>\n                <xo-phone-input phone=\"onboard.phone\" show-phone-type=\"!flags.cupDetected\" countryCode=\"locale.country\"></xo-phone-input>\n                <xo-email-input ng-if=\"displayEmailInContactInfo()\" class=\"emailInputContactSection\" flags=\"flags\" user=\"onboard.user\"></xo-email-input>\n            </div>\n\n            <xo-onboard-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" token=\"token\" flags=\"flags\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                onboard=\"onboard\" sepa=\"sepa\" merchant=\"nonEmptyMerchantDisplayName\"></xo-onboard-options>\n\n            <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                <div ng-if=\"!hasCurrConversion\">\n                    {{ content('billingAgreement.invoicingRegEMsg', {merchantName: nonEmptyMerchantDisplayName, amountInInvCurrency: amountInInvCurrency}) }}\n                </div>\n                <div ng-if=\"hasCurrConversion\">\n                    {{ content('billingAgreement.invoicingRegEMsgWithCurrConversion', {amountInPayerCurrency: amountInPayerCurrency, merchantName: nonEmptyMerchantDisplayName, amountInInvCurrency: amountInInvCurrency}) }}\n                </div>\n            </div>\n\n            <div class=\"buttons\">\n                <div id=\"returnToMerchantInfo\" ng-if=\"showNewSignupComplianceExp && !flags.commit\">\n                    <p>{{content('common.textAboveAgreeButton')}}</p>\n                </div>\n\n                <a id=\"backButton\" ng-if=\"flags.backButtonWebview\" href=\"#/checkout/login\" class=\"btn btn-secondary half\" ng-click=\"actions.logWebviewBackButtonClick(); actions.goBack($event)\">\n                    {{content('common.back')}}\n                </a>\n\n                <button\n                    type=\"submit\" class=\"btn\"\n                    track-input=\"{{flags.poma_flow ? (flags.commit ? 'Agree_Pay_Now' : 'Agree_Continue') : (flags.commit ? 'Pay_Now' : 'Continue')}}\"\n                    track-submit=\"{{flags.track_submit_transition}}\"\n                    id=\"{{flags.showPomaUi ? 'pomaSubmit' : 'guestSubmit'}}\"\n                    ng-bind-html=\"htmlContent(this.submitButtonText, { currency: selectedCurrency })\"\n                    ng-click=\"actions.positionToErrorField()\"\n                    ng-class=\"{backButtonEnabled: flags.backButtonWebview}\">\n                </button>\n\n            </div>\n        </div>\n        </div>\n    </form>\n</div>\n\n<xo-modal ng-if=\"showAddressNormalizationLightbox\" show=\"true\">\n    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n</xo-modal>\n\n<xo-guest-sepa-lightbox single-page-payment-form=\"singlePagePaymentForm\"\n    onboard=\"onboard\" section-element=\"sectionElement\" update-page-level-error-message=\"actions.updatePageLevelErrorMessage\" address=\"onboard.billing_address\" is-unbranded=\"isUnbranded\" flags=\"flags\"\n    validated=\"validated\" sepa=\"sepa\" done-fn=\"actions.onSubmit\"></xo-guest-sepa-lightbox>\n\n<xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n<xo-confirm-upop token=\"token\" card-model=\"onboard.card\" phone=\"onboard.phone\" on-success=\"onUpopSuccess\" on-cancel=\"onUpopCancel\" on-init-error=\"onUpopCancel\" ng-if=\"launchUpopScreen\" button-text-key=\"upopConfirmButtonTextKey\"></xo-confirm-upop>\n<xo-currency-conversion-lightbox\n    token=\"token\"\n    done-fn=\"onCompleteDCC\"\n    pre-plan-treatment=\"flags.buyerFxTreatment\"\n    ng-if=\"launchCurrencyConversionLightbox\">\n</xo-currency-conversion-lightbox>\n<xo-travel-rule-lightbox token=\"token\" ng-if=\"launchTravelRuleLightbox\" done-fn=\"onTravelRuleSuccess\"></xo-travel-rule-lightbox>\n<xo-redirecting-from-xoon-warning token=\"token\" flags=\"flags\" mode=\"mode\" ng-if=\"flags.showRedirectWarningPrompt\"></xo-redirecting-from-xoon-warning>\n\n<xo-cart-changed\n    ng-if=\"flags.showCartChanged\"\n    token=\"token\"\n    disable-change-shipping-country=\"disableChangeShippingCountry\"\n    shipping-address=\"onboard.shipping_address\"\n    formatted-shipping-address=\"formattedShippingAddress\"\n    ixo-model=\"ixoModel\"\n    show-form=\"shippingChangeFeature.showForm\"\n    message=\"shippingChangeFeature.message\"\n    on-shipping-change=\"shippingChangeFeature.handleOnShippingChange\"\n    on-continue=\"shippingChangeFeature.showOrResolveInterstitial\"\n></xo-cart-changed>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
// Default experience keys - For "DE" and other flows.
var DEFAULT_TOGGLE_FI = exports.DEFAULT_TOGGLE_FI = [{
    type: 'bank',
    label: 'bank.bank'
}, {
    type: 'card',
    label: 'bank.card'
}];

// Keys when "Bank" is selected as default.
var TESLA_TOGGLE_FI_BANK = exports.TESLA_TOGGLE_FI_BANK = [{
    type: 'bank',
    label: 'bank.bank'
}, {
    type: 'card',
    label: 'bank.cardWithoutCredit'
}];

// Keys when "Card" is selected as default.
var TESLA_TOGGLE_FI_CARD = exports.TESLA_TOGGLE_FI_CARD = [{
    type: 'card',
    label: 'bank.cardWithoutCredit'
}, {
    type: 'bank',
    label: 'bank.bank'
}];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoTeslaAddBank', {
    tag: 'xo-tesla-add-bank',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        mode: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                teslaFlowIdData: _index2.$TeslaFlowIdModel.instance(this.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.mode = this.mode || 'signup';
        },
        populate: function populate() {
            var _this = this;

            var setupRedirectUrl = function setupRedirectUrl() {
                var _ref = _this.models.teslaFlowIdData || {},
                    teslaFlowID = _ref.encodedParam;

                _this.finalUrl = '' + window.location.origin + _index.$config.urls.teslaAddBankUrl + teslaFlowID + '&country.x=' + _index.$locale.country + '&locale.x=' + _index.$locale.lang + '_' + _index.$locale.country + '&tsrce=xoonboardingnodeweb';

                _logger.$logger.info('tesla_add_bank_final_url', _this.finalUrl);
            };

            setupRedirectUrl();

            this.$on('localeChange', function () {
                setupRedirectUrl();
            });
        }
    },

    actions: {
        onContinueClick: function onContinueClick($event) {

            // FPTI logging when clicked on continue.
            _logger.$logger.info('checkout_fpti', {
                from: 'SIGNUP',
                to: 'process_tesla_continue'
            });

            $event.preventDefault();
            _logger.$logger.info('tesla_add_bank_redirection_button_clicked');
            window.location.href = this.finalUrl;
        }
    }

});


_index.$Component;

_index.$locale;

_index.$config;

_index2.$TeslaFlowIdModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <p class=\"subTitle ng-binding\">\n        {{content('bank.bankDescription')}}\n    </p>\n\n    <button class=\"btn\" id=\"teslaAddBankSubmit\" ng-click=\"actions.onContinueClick($event)\">{{content('common.continueLabel')}}</button>\n</div>"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/travelRuleLightbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTravelRuleLightbox', {
    tag: 'xo-travel-rule-lightbox',

    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // Open interstitial after element is rendered
            (0, _angular.$timeout)(function () {
                _this.modalOpen = true;
            });
        }
    }
});


_squid.$Component;

_angular.$timeout;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/travelRuleLightbox/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"travelRuleInterstitial\">\n    <div class=\"travelRule\" ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\" modal-box focus-when=\"modalOpen\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <xo-message message=\"message\"></xo-message>\n                <xo-travel-rule token=\"token\" on-user-info-success=\"doneFn\"></xo-travel-rule>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var defaultSignupTitleContentKey = 'largeScreenPayment.signupTitle';
var defaultGuestTitleContentKey = 'largeScreenPayment.title';

var titleTreatmentKeyToContentKeyMapping = {
    signup: defaultSignupTitleContentKey,
    guest: defaultGuestTitleContentKey,
    ebay: 'signupAccountCreation.heading',
    bank: 'largeScreenPayment.bankTitle',
    walletTokenization: 'common.createPayPalSubTitleSignup',
    xo_xoon_header_title_subtitle_global_control: defaultSignupTitleContentKey,
    xo_xoon_header_title_subtitle_global_throttle: defaultSignupTitleContentKey,
    xo_xoon_header_title_subtitle_global_test: 'splitScreenExp.signupOnboardTitle',
    xo_xoon_header_title_subtitle_IN_control: defaultSignupTitleContentKey,
    xo_xoon_header_title_subtitle_IN_treatment_a: 'header.titleSaferCheckout',
    xo_xoon_header_title_subtitle_IN_treatment_b: 'header.titleAddYourCard',
    xo_xoon_header_title_subtitle_IN_treatment_c: 'header.titleFreeAccount',
    indiaTitleBilling: 'header.titleBilling',
    xo_xoon_jp_add_bank_treatment: 'header.titleTeslaBankOrCard',
    xo_xoon_jp_add_bank_treatment_card: 'header.titleTeslaCardOrBank'
};

var defaultSignupTitlePropsContentKey = 'largeScreenPayment.titleProp';
var defaultGuestTitlePropsContentKey = defaultSignupTitlePropsContentKey;

var titlePropsTreatmentKeyToContentKeyMapping = {
    signup: defaultSignupTitlePropsContentKey,
    guest: defaultGuestTitlePropsContentKey,
    google: 'signup.androidPayTitleProp',
    samsung: 'signup.tokenizedWalletInfoTitleProp',
    walletTokenization: 'signup.androidPayTitleProp',
    xo_xoon_header_title_subtitle_global_control: defaultSignupTitlePropsContentKey,
    xo_xoon_header_title_subtitle_global_throttle: defaultSignupTitlePropsContentKey,
    xo_xoon_header_title_subtitle_global_test: 'common.buyerProtectionSignup',
    xo_xoon_header_title_subtitle_IN_control: defaultSignupTitlePropsContentKey,
    xo_xoon_header_title_subtitle_IN_treatment_a: 'header.subTitleCreateYourAccount',
    xo_xoon_header_title_subtitle_IN_treatment_b: 'header.subTitleSaveYourCard',
    xo_xoon_header_title_subtitle_IN_treatment_c: 'header.subTitleSaveYourCard',
    indiaTitleBilling: 'header.subTitleBilling'
};

exports.titleTreatmentKeyToContentKeyMapping = titleTreatmentKeyToContentKeyMapping;
exports.titlePropsTreatmentKeyToContentKeyMapping = titlePropsTreatmentKeyToContentKeyMapping;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/styles.less");

var _template = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _lib = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/lib.js");

var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/constants.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoXoonHeader', {
    tag: 'xo-xoon-header',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        flags: {
            type: 'var',
            required: true
        },
        user: {
            type: 'var',
            required: true
        },
        // This mode is carried from pages 'mode' setting
        // It is not flags.mode that changes upon radio button clicks
        // in optional signup flow
        mode: {
            type: 'var',
            required: true
        },
        fiMode: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve(),
                tokenizedWalletInfoModel: _index.$TokenizedWalletInfoModel.instance(this.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.token).retrieve()
            };
        },
        experiments: function experiments() {
            return {
                // we are running title and subTitle pxp only for signup flows
                titleSubtitleContentExp: this.props.mode === 'signup' ? (0, _squid.$pxp)('xo_xoon_header_title_subtitle', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_xoon_header_title_subtitle_)(.*)') : null
            };
        },
        teslaAddBank: function teslaAddBank() {
            return {
                teslaAddBankEXP: (0, _squid.$elmo)('xo_xoon_tesla_add_bank', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_xoon_jp_add_bank_treatment)(.*)')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.currentCountryName = _squid.$util.getProperty(this.locale, 'metadata.localization.countryName', {
                'default': this.locale.country
            });
        },
        populate: function populate() {
            var _this = this;

            var checkTeslaEligbility = function checkTeslaEligbility() {
                var _teslaAddBank$teslaAd = _this.teslaAddBank.teslaAddBankEXP,
                    teslaAddBankEXP = _teslaAddBank$teslaAd === undefined ? {} : _teslaAddBank$teslaAd;
                var teslaAddBankTreatment = teslaAddBankEXP.treatment_name;

                _this.teslaTreatmentFIType = teslaAddBankTreatment;
                _this.teslaAddBankEXP = teslaAddBankTreatment && teslaAddBankTreatment.includes('xo_xoon_jp_add_bank_treatment');
            };

            checkTeslaEligbility();

            var setTitleSubtitleContentAndFlags = function setTitleSubtitleContentAndFlags() {
                _this.subject = _this.models.tokenizedWalletInfoModel.getSubject(); // Samsung or Android

                var _ref = _this.experiments.titleSubtitleContentExp || {},
                    titleSubtitleContentExpTreatment = _ref.treatment_name;

                // Add experiment check and default values (props.mode) on FLow Context keys


                var pageTitleFlowContextKey = (0, _lib.getPageTitleContextKey)(_this.models, _this.props.mode, _this.props.fiMode, _this.currentCountryName) || _this.teslaAddBankEXP && _this.teslaTreatmentFIType || titleSubtitleContentExpTreatment || _this.props.mode;
                var pageTitlePropsFlowContextKey = (0, _lib.getPageTitlePropsContextKey)(_this.models, _this.subject, _this.currentCountryName) || titleSubtitleContentExpTreatment || _this.props.mode;

                // get the actual content key from constants file mapping
                _this.pageTitleContentKey = _constants.titleTreatmentKeyToContentKeyMapping[pageTitleFlowContextKey];
                _this.pageTitlePropsContentKey = _constants.titlePropsTreatmentKeyToContentKeyMapping[pageTitlePropsFlowContextKey];

                // if the treatment returned by pxp does not have words like 'control' and 'throttle'
                // then it is a test treatment, so lets set flags.titleSubtitleContentExpTreatment = true
                // This flag is used in onboardOptions template to decide display components
                if (titleSubtitleContentExpTreatment && !(titleSubtitleContentExpTreatment.indexOf('control') > -1 || titleSubtitleContentExpTreatment.indexOf('throttle') > -1)) {
                    // Set flag to use in oboardingOptions template
                    _this.props.flags.titleSubtitlePxpTreatment = true;
                }
            };

            var setInitialFlags = function setInitialFlags() {
                setTitleSubtitleContentAndFlags();
            };

            setInitialFlags();
        }
    },

    actions: {
        redirectWarningPromptInit: function redirectWarningPromptInit($event) {
            if ($event) {
                $event.preventDefault();
            }

            // Redirection will be triggered in redirectWarningPrompt directive
            // based on few conditions check
            this.flags.showRedirectWarningPrompt = true;
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$pxp;

_squid.$util;

_squid.$elmo;

_lib.getPageTitleContextKey;

_lib.getPageTitlePropsContextKey;

_constants.titleTreatmentKeyToContentKeyMapping;

_constants.titlePropsTreatmentKeyToContentKeyMapping;

_index.$TokenizedWalletInfoModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index3.$CheckoutInputDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/lib.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getPageTitlePropsContextKey = exports.getPageTitleContextKey = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// Return keys for few specific flows that needs title override
// Please refer to ./constants.js file for default keys used in the flow
var getPageTitleContextKey = function getPageTitleContextKey(models, mode, fiMode, currentCountryName) {
    if (models.checkoutInputData.isEbayTxn()) {
        // prox signup flow title
        return 'ebay';
    } else if (fiMode === 'bank') {
        return 'bank';
    } else if (models.checkoutCart.isWalletTokenization()) {
        return 'walletTokenization';
    } else if (currentCountryName === 'India' && models.checkoutCart.isBilling() && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
        return 'indiaTitleBilling';
    } else if (mode === 'guest') {
        return 'guest';
    }
    // We have an experiment that decides key for mode === 'signup'
};

// Return keys for few specific flows that needs title props or sub title override
// Please refer to ./constants.js file for default keys used in the flow
var getPageTitlePropsContextKey = function getPageTitlePropsContextKey(models, subject, currentCountryName) {

    var WALLET_RESPONSE = ['google', 'Samsung'];

    if (models.checkoutCart.isWalletTokenization()) {

        _logger.$logger.info(subject + '_WALLET_TOKENIZATION');

        if (WALLET_RESPONSE.indexOf(subject) > -1) {
            return subject.toLowerCase();
        } else {
            // Oops something terrible happened! API response does't have our key. return default instead
            return 'walletTokenization';
        }
    }

    if (currentCountryName === 'India' && models.checkoutCart.isBilling() && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
        return 'indiaTitleBilling';
    }
};

exports.getPageTitleContextKey = getPageTitleContextKey;
exports.getPageTitlePropsContextKey = getPageTitlePropsContextKey;


_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"headerBox\" content>\n    <h1 class=\"alpha\" id=\"pageTitle\" ng-bind-html=\"htmlContent(pageTitleContentKey)\"></h1>\n    <p class=\"subTitle\" id=\"pageTitleProps\" ng-bind-html=\"htmlContent(pageTitlePropsContentKey, { subject: subject, countryName: currentCountryName })\"></p>\n\n    <xo-message ng-if=\"showEmailCheckInfoBox\" id=\"headerEmailCheckInfo\" message=\"emailCheckInfo\"></xo-message>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/lib/contentKeys.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
 * Returns the appropriate billing agreement xo-content key.
 *
 *   enterpriseAgreement.{CODE}NoFiStickyConsentSignup
 *   billingAgreement.signupAgreementCibStickyPay
 *   billingAgreement.signupAgreementCibStickyContinue
 *   billingAgreement.signupAgreementFiStickyPay
 *   billingAgreement.signupAgreementFiStickyContinue
 *
 * @param {cart} a CheckoutCartModel instance
 * @param {appData} a CheckoutAppDataModel instance
 * @return {String}
 */

var getBAContentKey = exports.getBAContentKey = function getBAContentKey() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cart = _ref.cart,
        appData = _ref.appData,
        locale = _ref.locale;

    var consentCode = cart.get('billing.consent_code');

    if (consentCode) {
        return 'enterpriseAgreement.' + consentCode + 'NoFiStickyConsentSignup';
    }

    var isCIB = cart.get('billing.type') === 'CHANNEL_INITIATED_BILLING';
    var type = isCIB ? 'Cib' : 'Fi';
    var useraction = appData.useraction();
    var action = useraction === 'commit' ? 'Pay' : 'Continue';
    var isIndiaDomestic = locale.country === 'IN' && locale.country === appData.get('merchant.merchant_country', 'US');
    var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
    var keySuffix = type + 'Sticky' + indiaDomestic + action;

    return 'billingAgreement.signupAgreement' + keySuffix;
};

/**
 * Returns the appropriate RP xo-content key.
 *
 *   billingAgreement.signupRpAgreementFiStickyPay
 *   billingAgreement.signupRpAgreementFiStickyContinue
 *
 * @param {appData} a CheckoutAppDataModel instance
 * @return {String}
 */
var getRPContentKey = exports.getRPContentKey = function getRPContentKey() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appData = _ref2.appData;

    var useraction = appData.useraction();
    var action = useraction === 'commit' ? 'Pay' : 'Continue';

    return 'billingAgreement.signupRpAgreementFiSticky' + action;
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.hasDialingCodeOverride = exports.redirectToSubscriptionFinalRoute = exports.decodeEntities = exports.hasAddressChanged = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var isString = function isString(value) {
    return typeof value === 'string';
}; // eslint-disable-line angular/typecheck-string

var areAddressFieldsEqual = function areAddressFieldsEqual(address1Field, address2Field) {
    if (address1Field === address2Field) {
        return true;
    }

    var fields = [address1Field, address2Field];

    if (fields.includes(undefined) && fields.includes('')) {
        return true;
    }

    if (isString(address1Field) && isString(address2Field)) {
        return address1Field.toUpperCase() === address2Field.toUpperCase();
    }

    return false;
};

var hasAddressChanged = exports.hasAddressChanged = function hasAddressChanged(address1, address2) {
    var addressFields = ['line1', 'line2', 'city', 'state', 'postal_code', 'country_code'];

    return addressFields.some(function (field) {
        return !areAddressFieldsEqual(address1[field], address2[field === 'country_code' ? 'country' : field]);
    });
};

var decodeEntities = exports.decodeEntities = function decodeEntities(input) {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    var converter = window[ENTITY_ELEM];

    converter.innerHTML = input;
    return converter.innerText || converter.text || converter.textContent;
};

var redirectToSubscriptionFinalRoute = exports.redirectToSubscriptionFinalRoute = function redirectToSubscriptionFinalRoute() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'guest';
    var isSubscriptionV1 = arguments[1];

    var protocol = _angular.$window.location.protocol + '//';
    var stageUrl = _squid.$meta.stage || _angular.$window.location.hostname;
    var subscriptionReturnUri = isSubscriptionV1 ? _squid.$config.urls.subscriptionsV1ReturnUrl : _squid.$config.urls.wpsSubscriptionReturnUrl;
    var params = {
        token: _squid.$meta.token,
        mode: mode,
        // Read mfid from params in case buyer landed with 302 URL redirection,
        // and meta for internal redirects.
        mfid: _squid.$util.param('mfid') || _squid.$meta.mfid,
        'country.x': _squid.$locale.country,
        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country
    };
    var redirectUrl = _squid.$util.buildURL(protocol + stageUrl + subscriptionReturnUri, params);

    _squid.$util.redirect(redirectUrl);
};

/**
 * Certain regions (ie: Macau) live within territories
 * but have their own dialing codes. We need to shift the UX
 * to have the phone number after the province selection
 * https://engineering.paypalcorp.com/jira/browse/PPPLMER-48433
 */
var hasDialingCodeOverride = exports.hasDialingCodeOverride = function hasDialingCodeOverride() {
    var overrides = _squid.$locale.metadata.regionalOverrides;

    if (!overrides) {
        return false;
    }

    return Object.keys(overrides).map(function (key) {
        return overrides[key].props;
    }).some(function (override) {
        return override.hasOwnProperty('internationalDialingCode');
    });
};

_angular.$window;

_squid.$meta;

_squid.$util;

_squid.$locale;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/login-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/login-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template, opinionlab) {

    squid.module('xo-login-button.directive', ['squid']).directive('xoLoginButton', [function () {

        return {
            template: template,

            scope: {
                redirect: '=?'
            },

            controller: ['$scope', function ($scope) {}]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addCard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addCard/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/directive.js"), // TODO: Check if its used
__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/login-button/directive.js"), __webpack_require__("../node_modules/xo-locale/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/ui-utils/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template, util) {
    return angular.module('xo-multistep-signup-add-card.directive', ['squid', 'xo-value-props.directive', 'xo-phone.phoneInput', 'xo-name-input.directive', 'xo-guest.emailInput', 'xo-guest.passwordInput', 'xo-guest.countryList', 'xo-onboard.sepa.directive', // TODO: Check if its used
    'xo-guest-select-shipping-method.directive', 'xo-xoon-header.directive', 'xomodel.onboard', 'xo-login-button.directive', 'locale.helper', 'xomodel.address', 'xomodel.checkout', 'xo-ui-utils.directive', 'xo-accessibility.directive', 'xo-ba-message-banner.directive']).directive('formErrorDetect', [function () {
        return function ($scope, el, attrs) {
            $scope.$watch(attrs.name + '.$error', function (newVal, oldVal) {
                var cardModel = $scope.multistepSignupModel.onboard.card;

                /*
                * Here we are making sure that both luhn and len validation
                * together marks the cardModel validity which in-tern handles
                * form submit and validity in front-end
                * Background:
                * card input element has luhn and len validation as part of
                * ui-validate util
                */
                if (newVal.luhn && newVal.luhn[0].$invalid || newVal.len && newVal.len[0].$invalid) {
                    cardModel.valid = false;
                } else {
                    cardModel.valid = true;
                }
            }, true);
        };
    }]).directive('xoMultistepSignupAddCard', [function () {
        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                multistepSignupModel: '=?',
                positionToErrorField: '=?',
                backState: '=?',
                backendError: '=?',
                clearBackendError: '=?',
                normalizeAddress: '=?',
                prefillAddressCommon: '=?',
                buttonParams: '=?'
            },

            link: function link($scope) {
                $scope.$watch(function () {
                    return $scope.multistepSignupModel.onboard.card.number;
                }, function cardNumberChangeHandler(newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
                    oldValue = oldValue ? oldValue.replace(/ /g, '').toLowerCase() : null;

                    if (newValue) {
                        if (newValue !== oldValue) {
                            if ($scope.multistepSignupModel.selectedInstallmentData && !$scope.multistepSignupModel.selectedInstallmentData.preventChange) {
                                // Resetting selected installment data, if installment change is not explicitly prohibited.
                                $scope.multistepSignupModel.selectedInstallmentData = undefined;
                            }
                        }
                    }
                });

                $scope.$watch(function () {
                    return $scope.multistepSignupModel.onboard.card.type;
                }, function cardTypeChangeHandler(newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;

                    var eligibilityModel = $scope.multistepSignupModel.eligibilityModel;
                    var cardNetwork;

                    if (newValue && eligibilityModel && eligibilityModel.installments && eligibilityModel.installments.length > 0) {
                        eligibilityModel.installments.some(function cardCheck(card, index, array) {
                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                                // Card Network Found
                                cardNetwork = card;
                                return true;
                            }
                            return false;
                        });

                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
                            // Card network && installments found
                            if (cardNetwork.installment_options.length === 1) {
                                $scope.multistepSignupModel.selectedInstallmentData = {
                                    installment_option_selected: cardNetwork.installment_options[0],
                                    preventChange: true
                                };
                            }

                            $scope.multistepSignupModel.allowInstallments = true;
                        } else {
                            // Card network does not exists Or No installment found
                            $scope.multistepSignupModel.allowInstallments = false;
                        }
                    } else {
                        $scope.multistepSignupModel.allowInstallments = false;
                    }
                });

                $scope.$on('$destroy', function () {
                    $scope.clearBackendError('multistepsignupaddcard');
                });

                if ($scope.backendError) {
                    $scope.backendError('multistepsignupaddcard');
                }
            },

            controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$feature', '$q', '$CheckoutAppDataModel', '$ShippingRuleSummaryModel', '$CheckoutPayeeModel', '$CheckoutCartModel', '$BillingAddressModel', '$ShippingAddressModel', '$PrefillAddressModel', '$pxpFactors', '$config', '$dispatch', '$localeHelper', '$location', '$meta', function ($scope, $rootScope, $populate, $state, $util, $locale, $feature, $q, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel, $BillingAddressModel, $ShippingAddressModel, $PrefillAddressModel, $pxpFactors, $config, $dispatch, $localeHelper, $location, $meta) {
                $scope.locale = $locale;
                $scope.formattedValues = {};
                $scope.mode = 'signup';
                $scope.fiMode = 'card';
                $scope.backUri = 'checkout.multistepsignup.multistepsignupaddcard';
                $scope.normalize = $feature('addressNormalization', false, $locale.country);
                $scope.componentsFlag = util.componentsMap($locale.country);

                $scope.$on('localeChange', function () {
                    $scope.componentsFlag = util.componentsMap($locale.country);
                    $scope.multistepSignupModel.onboard.billing_address.country = $locale.country;
                    $scope.multistepSignupModel.onboard.shipping_address.country = $locale.country;
                });

                $scope.zipMasking = function () {
                    var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    $scope.formattedValues.postalCode = $locale.country === 'RU' ? newValue : util.maskingUtil.maskZip(newValue);
                    $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode && $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
                };

                function checkShippingRulesExist() {
                    if ($scope.multistepSignupModel.wps_flow && $scope.multistepSignupModel.snt_supported_flow) {
                        return $populate($scope, {
                            shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                                params: {
                                    merchant_id: $scope.payee.merchant.id,
                                    currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                                }
                            })
                        }).then(function () {
                            if ($scope.shippingRulesSummary.isSnTEnabled) {
                                $scope.multistepSignupModel.merchant_has_snt_profile = true;
                            }
                        });
                    } else {
                        return $q.when();
                    }
                }

                $scope.isInstallmentsVisible = function isInstallmentsVisible() {
                    var model = $scope.multistepSignupModel;
                    var hasConditionMet = model.allowInstallments && model.onboard.card.number && model.onboard.card.valid;
                    var isBilling = $scope.checkoutCart.isBilling();

                    return !isBilling && hasConditionMet;
                };

                if ($scope.multistepSignupModel.onboard.ue_billing_address) {
                    $scope.multistepSignupModel.onboard.billing_address = $scope.multistepSignupModel.onboard.ue_billing_address;
                    $scope.zipMasking($scope.multistepSignupModel.onboard.ue_billing_address.postal_code);
                }

                if ($locale.country === 'BR' && $scope.multistepSignupModel.onboard.billing_address) {
                    $scope.multistepSignupModel.onboard.billing_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.billing_address.postal_code);
                }

                $scope.setSelectedCurrency = function (selection) {
                    var _$scope$multistepSign = $scope.multistepSignupModel.onboard.card.currencyConvData;
                    _$scope$multistepSign = _$scope$multistepSign === undefined ? {} : _$scope$multistepSign;
                    var from_code = _$scope$multistepSign.from_code,
                        to_code = _$scope$multistepSign.to_code;


                    $scope.selectedCurrency = selection === 'PAYPAL' ? from_code : to_code;
                    _logger.$logger.info('CONVERSION_SELECTION_CHANGED_TO_' + selection);
                };

                $scope.setSubmitButtonKey = function () {
                    var _$scope$multistepSign2 = $scope.multistepSignupModel.flags,
                        hasData = _$scope$multistepSign2.hasBuyerFxPrePlanData,
                        _$scope$multistepSign3 = _$scope$multistepSign2.buyerFxTreatment,
                        treatment = _$scope$multistepSign3 === undefined ? '' : _$scope$multistepSign3;

                    var inCurrency = treatment.includes('treatment_2') && hasData;

                    $scope.submitButtonKey = 'common.continue' + (inCurrency ? 'InCurrency' : '') + 'Label';
                };

                $scope.$watch('multistepSignupModel.onboard.card.ppconversion', function (selection) {
                    $scope.setSelectedCurrency(selection);
                    $scope.setSubmitButtonKey();
                });

                $scope.setBuyerFxFlag = function (_ref) {
                    var treatment = _ref.treatment,
                        hasBuyerFxPrePlanData = _ref.hasBuyerFxPrePlanData;

                    if (treatment) {
                        $scope.multistepSignupModel.flags.buyerFxTreatment = treatment;
                    }

                    if (hasBuyerFxPrePlanData) {
                        $scope.setSelectedCurrency($scope.multistepSignupModel.onboard.card.ppconversion);
                    }

                    $scope.multistepSignupModel.flags.hasBuyerFxPrePlanData = hasBuyerFxPrePlanData;
                    $scope.setSubmitButtonKey();

                    _logger.$logger.info('SETTING_BUYER_FX_FLAG_IN_MULTISTEP_DIR', {
                        treatment: treatment,
                        hasBuyerFxPrePlanData: hasBuyerFxPrePlanData
                    });
                };

                $scope.submitButtonKey = 'common.continueLabel';

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    // Needed to show custom description sent by merchant in Billing Agreement flow
                    $scope.billingAgreementMerchantMsg = $scope.checkoutCart.getBillingDescription();

                    // Log to FPTI to indicate the page has been rendered
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHECKOUT_MULTISTEPSIGNUP',
                        to: 'prepare_checkout_multistepsignup'
                    });

                    $scope.multistepSignupModel.flags.allowEditShipping = $scope.checkoutAppData.get('flags.allow_change_shipping', false);

                    $scope.multistepSignupModel.installmentDisabled = $scope.checkoutCart.isBilling();

                    $scope.multistepSignupModel.wps_flow = $scope.checkoutAppData.is_wps_flow();
                    $scope.multistepSignupModel.snt_supported_flow = $scope.checkoutAppData.is_snt_supported();

                    $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required);

                    checkShippingRulesExist();

                    $scope.prefill = function () {
                        var postal_code = $scope.multistepSignupModel.onboard.billing_address.postal_code;

                        $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.billing_address, $scope.multistepSignupModel.onboard.user, $scope.multistepSignupModel.flags.billingAddress, false);
                    };

                    // Get merchant passed shipping address from either purchase plan or billing agreement plan
                    var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
                    var merchantSuppliedNumber = $scope.checkoutCart.get('purchase.phone_fields') || $scope.checkoutCart.get('billing.phone_fields');

                    if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_billing_address) {
                        $scope.multistepSignupModel.onboard.billing_address = $BillingAddressModel.create($scope.token, {
                            country: $locale.country
                        }, merchantSuppliedAddress);

                        $scope.prefill();

                        $scope.zipMasking($scope.multistepSignupModel.onboard.billing_address.postal_code);

                        $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode;
                        $scope.multistepSignupModel.onboard.user.first_name = merchantSuppliedAddress.first_name;
                        $scope.multistepSignupModel.onboard.user.last_name = merchantSuppliedAddress.last_name;
                    }

                    if (merchantSuppliedNumber && merchantSuppliedNumber.telephone_country === $locale.country) {
                        $scope.multistepSignupModel.onboard.phone.telephone = merchantSuppliedNumber.normalized_phone_number;
                    }
                });

                var basl_hermes_xoon_redirect = $util.param('hermesXoonRedirect') || $meta.query && $meta.query.hermesXoonRedirect;
                var basl_abtest_throttle = $util.param('abTestThrottle') || $meta.query && $meta.query.abTestThrottle;

                $scope.showLogin = basl_hermes_xoon_redirect || basl_abtest_throttle;

                $scope.redirect = function () {
                    $dispatch('hermes', {
                        hermesLoginRedirect: 'xoon',
                        token: $scope.token,
                        'locale.x': $locale.lang + '_' + $locale.country,
                        'country.x': $locale.country
                    });
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
                    } else {
                        $scope.normalize = false;
                        $scope.multistepSignupModel.onboard.billing_address.setProperties(normalizedAddress);

                        if ($scope.multistepSignupModel.flags.shipToBilling) {
                            $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
                        } else {
                            $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
                        }
                    }
                };

                $scope.changeCountry = function changeCountry() {
                    if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
                        $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
                    } else {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
                    }
                };

                $scope.onSubmit = function onSubmit() {
                    // Backup user entered address
                    $scope.multistepSignupModel.onboard.ue_billing_address = $BillingAddressModel.create($scope.token, {
                        country: $locale.country
                    }, $scope.multistepSignupModel.onboard.billing_address);

                    if ($scope.componentsFlag.shippingAddress) {
                        $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
                            country: $locale.country
                        }, $scope.multistepSignupModel.onboard.shipping_address);
                    }

                    // Remove phone formatting
                    $scope.multistepSignupModel.onboard.phone.telephone = $scope.multistepSignupModel.onboard.phone.telephone.replace(/[^0-9]/gi, '');

                    if ($scope.normalize) {
                        $scope.clearBackendError('multistepsignupaddcard');
                        $scope.normalizeAddress($scope.multistepSignupModel.onboard.billing_address, $scope.uponNormalization);
                    } else if ($scope.componentsFlag.shippingAddressPage) {
                        if (!$scope.multistepSignupModel.flags.shipToBilling) {
                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
                        }
                    } else {
                        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
                    }
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addCard/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-add-card.route', ['squid', 'xo-multistep-signup-add-card.directive', 'hermes.page.xo-sidebar.route']).factory('$MultistepSignupAddCardRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupAddCardRoute', {
            name: 'multistepsignupaddcard',

            directive: 'xo-multistep-signup-add-card',

            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'multistepSignupModel'
                }
            }]
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addCard", "../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addShipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addShipping/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template, util) {

    return angular.module('xo-multistep-signup-add-shipping.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddShipping', [function () {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                multistepSignupModel: '=?',
                positionToErrorField: '=?',
                backState: '=?',
                backendError: '=?',
                clearBackendError: '=?',
                normalizeAddress: '=?',
                prefillAddressCommon: '=?'
            },

            link: function link($scope) {
                if ($scope.backendError) {
                    $scope.backendError('multistepsignupaddshipping');
                }

                $scope.$on('$destroy', function () {
                    $scope.clearBackendError('multistepsignupaddshipping');
                });
            },

            controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$feature', '$ShippingAddressModel', '$CheckoutAppDataModel', '$CheckoutCartModel', '$pxpFactors', '$config', '$location', function ($scope, $rootScope, $populate, $state, $util, $locale, $feature, $ShippingAddressModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxpFactors, $config, $location) {

                $scope.locale = $locale;
                $scope.validated = false;
                $scope.formattedValues = {};
                $scope.normalize = $feature('addressNormalization', false, $locale.country);
                $scope.prefillDone = false;

                if (!$scope.multistepSignupModel.onboard.shippingCountryChanged) {
                    $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
                }

                $scope.zipMasking = function (newValue) {
                    $scope.formattedValues.postalCode = util.maskingUtil.maskZip(newValue);
                    $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
                };

                if ($scope.multistepSignupModel.onboard.ue_shipping_address) {
                    $scope.multistepSignupModel.onboard.shipping_address = $scope.multistepSignupModel.onboard.ue_shipping_address;
                    $scope.zipMasking($scope.multistepSignupModel.onboard.ue_shipping_address.postal_code);
                }

                $scope.changeCountry = function changeCountry() {
                    if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
                        $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
                    } else {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
                    }
                };

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    // To fix the back case where the '-' is not added to zip code
                    if ($scope.multistepSignupModel.onboard.shipping_address) {
                        $scope.multistepSignupModel.onboard.shipping_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.shipping_address.postal_code);
                    }

                    $scope.prefill = function (override) {
                        var postal_code = $scope.multistepSignupModel.onboard.shipping_address.postal_code;

                        $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.flags.shippingAddress, override);

                        if (!$scope.prefillDone) {
                            $scope.prefillDone = true;
                        }
                    };

                    // Get merchant passed shipping address from either purchase plan or billing agreement plan
                    var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');

                    if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_shipping_address) {
                        $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, {
                            country: $locale.country
                        }, merchantSuppliedAddress);
                        $scope.prefill(true);
                        $scope.zipMasking($scope.multistepSignupModel.onboard.shipping_address.postal_code);
                        $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode;
                    }
                });

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
                    } else {
                        $scope.normalize = false;
                        $scope.multistepSignupModel.onboard.shipping_address.setProperties(normalizedAddress);
                        $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
                    }
                };

                $scope.validate = function () {
                    $scope.validated = true;
                    return true;
                };

                $scope.onSubmit = function onSubmit() {
                    // set recipient_name property
                    var shippingAddress = $scope.multistepSignupModel.onboard.shipping_address;
                    // TODO: in some locale, last_name can be displayed first, and space ' ' can be unnecessary.

                    shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;

                    // backup user entered address
                    $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
                        country: $locale.country
                    }, shippingAddress);

                    if ($scope.normalize) {
                        $scope.clearBackendError('multistepsignupaddshipping');
                        $scope.normalizeAddress(shippingAddress, $scope.uponNormalization);
                    } else {
                        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
                    }
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addShipping/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-add-shipping.route', ['squid', 'xo-multistep-signup-add-shipping.directive']).factory('$MultistepSignupAddShippingRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupAddShippingRoute', {
            name: 'multistepsignupaddshipping',

            directive: 'xo-multistep-signup-add-shipping',

            children: [{
                name: '$AddressNormalizationRoute',
                attributes: {
                    id: 'token',
                    address: 'multistepSignupModel.onboard.shipping_address',
                    'done-fn': 'uponNormalization'
                }
            }]
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addShipping", "../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/template.html"), __webpack_require__("./js/lib/index.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {

    return angular.module('xo-multistep-signup-address-normalization.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddressNormalization', ['$rootScope', function ($rootScope) {

        return {
            template: template,

            scope: {
                id: '=?',
                address: '=?',
                doneFn: '=?'
            },

            controller: ['$scope', '$locale', '$config', function ($scope, $locale, $config) {}]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-address-normalization.route', ['squid', 'xo-multistep-signup-address-normalization.directive']).factory('$MultistepSignupAddressNormalizationRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupAddressNormalizationRoute', {
            name: 'multistepsignupaddressnormalization',

            directive: 'xo-multistep-signup-address-normalization',

            children: []
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization", "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js"), __webpack_require__("../node_modules/xo-models/src/inventory/index.js"), __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, util) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomultistepsignupapi', ['squid']).factory('$MultistepApiCalls', ['$MultistepSignupModel', '$CheckoutSessionModel', '$CheckoutAppDataModel', '$CheckoutPayeeModel', '$InventoryModel', '$ShoppingCartModel', '$CheckoutCartModel', '$rootScope', '$state', '$config', '$locale', '$NationalIdModel', '$location', '$dispatch', '$getRedirectUrl', '$renderContent', '$q', '$FundingOptionsModel', function ($MultistepSignupModel, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $InventoryModel, $ShoppingCartModel, $CheckoutCartModel, $rootScope, $state, $config, $locale, $NationalIdModel, $location, $dispatch, $getRedirectUrl, $renderContent, $q, $FundingOptionsModel) {

        function processFieldMap(errorCategory) {
            var fieldMap = util.contingencyMap(errorCategory.errorCode || errorCategory.code);

            if (fieldMap) {
                if (!fieldMap.fields && (errorCategory.fields || errorCategory.details && errorCategory.details.fields)) {
                    // eslint-disable-line no-extra-parens
                    errorCategory.fields = errorCategory.fields || errorCategory.details && errorCategory.details.fields;

                    var fields = errorCategory.fields.map(function (value, index, array) {
                        if (angular.isString(value)) {
                            return {
                                field: value
                            };
                        }

                        return value;
                    });

                    fieldMap.fields = fields;
                }
            } else {
                _logger.$logger.info('signup_validation_error', {
                    message: errorCategory.errorCode || errorCategory.code + ' not mapped'
                });
            }

            return fieldMap;
        }

        function redirectTohermesCC(path, $location, token) {
            // eslint-disable-line no-shadow
            var url;
            var protocol;
            var host;
            var port;

            protocol = $location.protocol() + '://';

            if ($location.host()) {
                host = $location.host();
            }

            if ($location.port()) {
                port = ':' + $location.port();
            }

            url = protocol + host + port + config.urls.fallbackUrl.hermes + '?token=' + token + path; // eslint-disable-line no-undef,block-scoped-var

            window.location = url;
        }

        function setStickyInstrument(checkoutSession) {
            // make billing agreement FI sticky for sign up

            var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();

            if (stickyInstrument) {
                return checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: stickyInstrument.instrument_id
                    }
                });
            }
        }

        function showGenericError(code) {
            return function () {
                $state.go('checkout.genericError', { code: code });
            };
        }

        function markCartCheckedout(checkoutAppData) {
            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);

            return shoppingCartModel.action('cartCheckedOut', {
                success: function success(result) {
                    _logger.$logger.info('cart checked out successfully');
                }
            });
        }

        function handlePaymentContingencies(checkoutCart, payee, code) {
            return function () {
                inventoryOperation(checkoutCart, payee, 'failed');
                return $state.go('checkout.genericError', { code: code });
            };
        }

        function makePayment(checkoutSession, checkoutCart, checkoutAppData, payee) {
            return checkoutSession.action('createPayment', {
                'data': {
                    payer_id: checkoutSession.payer && checkoutSession.payer.id,
                    intent: checkoutCart.payment_action
                },
                success: function success(result) {
                    $rootScope.paymentComplete = true;
                    if ($config.enableShoppingCartWPS && checkoutAppData.flags.is_shopping_cart_flow) {
                        markCartCheckedout(checkoutAppData);
                    }
                    return $state.go('checkout.done');
                },
                contingencies: {
                    TRANSACTION_REFUSED: handlePaymentContingencies(checkoutCart, payee, 'TRANSACTION_REFUSED'),
                    INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED(err, message) {
                        inventoryOperation(checkoutCart, payee, 'failed');
                        _logger.$logger.info('INSTRUMENT_DECLINED_contingency', {
                            name: err,
                            message: message
                        });
                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                    },
                    PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_DENIED'),
                    DUPLICATE_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_ALREADY_DONE'),
                    CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED(err, message) {
                        inventoryOperation(checkoutCart, payee, 'failed');
                        // Log the error and redirect to hermes add card page
                        _logger.$logger.info('CC_PROCESSOR_DECLINED_CONTINGENCY', {
                            name: err,
                            message: message
                        });
                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                    },
                    DEFAULT: handlePaymentContingencies(checkoutCart, payee, 'DEFAULT')
                },
                error: function error(err) {
                    _logger.$logger.info('createPayment Failed due to service error', err);
                    inventoryOperation(checkoutCart, payee, 'failed');
                    return $state.go('checkout.genericError', { code: 'DEFAULT' });
                }

            });
        }

        function authorizeSession(checkoutSession) {
            var multistepSignupModel = $MultistepSignupModel.instance();
            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
            var payee = $CheckoutPayeeModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);

            if (checkoutSession.resolve_3ds) {
                var cc_id = checkoutSession.get('resolve_3ds.ccId');
                var plans = checkoutSession.get('plan.sources', null);
                var plan = plans && plans.filter(function (e) {
                    return e.instrument_id === cc_id;
                })[0].amount || null;

                multistepSignupModel.resolve_3ds_data = {
                    cc_id: cc_id,
                    flow_id: 'HERMES',
                    merchant_id: payee.get('merchant.id'),
                    merchant_country_code: checkoutAppData.get('merchant.merchant_country'),
                    transaction_amount_currency: plan && plan.currency_code,
                    transaction_amount_value: plan && plan.amount
                };

                multistepSignupModel.is3ds = true;
                $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
            } else {
                return $q.when(setStickyInstrument(checkoutSession))['catch'](function (err) {
                    _logger.$logger.info('setStickyFI Failed', err);
                })['finally'](function () {
                    return checkoutSession.action('authorize', {
                        success: function success() {
                            var isSubscriptionsV1 = checkoutCart.isSubscriptionsV1();
                            var isWpsSubscription = checkoutAppData.is_wps_subscription_flow();

                            if (isWpsSubscription || isSubscriptionsV1) {
                                return (0, _util.redirectToSubscriptionFinalRoute)(multistepSignupModel.flags.mode, isSubscriptionsV1);
                            } else if (checkoutAppData.doec_on_approve()) {
                                return checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData);
                            } else {
                                $state.go('checkout.end');
                            }
                        }
                    });
                });
            }
        }

        function inventoryOperation(checkoutCart, payee, paymentStatus) {
            var cartHasInventory = checkoutCart.get('cartHasInventory');

            if (cartHasInventory) {
                var inventoryModel = $InventoryModel.instance($rootScope.token);
                var inventoryItems = inventoryModel.getInventoryItems();
                var purchaseItems = checkoutCart.get('purchaseUnits');
                var cartItems,
                    inventoryPatchInput = {};

                if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
                    cartItems = purchaseItems[0].item_list.items;
                }
                paymentStatus = paymentStatus ? paymentStatus : 'success';
                if (cartItems && inventoryItems) {
                    inventoryPatchInput = {
                        inventoryItems: inventoryItems,
                        cartItems: cartItems,
                        merchantId: payee.get('merchant.id', ''),
                        paymentStatus: paymentStatus
                    };
                } else {
                    return $q.when(); // don't need to call patchInventory if items not present
                }

                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse) {
                            if (patchResponse.showSoldoutPage) {
                                // show soldout page
                                return {
                                    soldoutpage: true,
                                    items: patchResponse.soldoutItems,
                                    soldOutUrl: patchResponse.soldoutUrl
                                };
                            } else if (patchResponse.patchCart) {
                                var purchase_unit = checkoutCart.get('purchaseUnits')[0];

                                purchase_unit.item_list.items = patchResponse.cartItems;
                                var patchCartPayload = {
                                    id: $rootScope.token,
                                    patchEntities: [{
                                        field: 'inventoryItems',
                                        value: purchase_unit.item_list.items
                                    }]
                                };

                                return checkoutCart.action('patchCartData', {
                                    data: patchCartPayload
                                });
                            }
                        } else {
                            return;
                        }
                    }
                });
            } else {
                return $q.when(); // not an inventory request proceed with existing flow
            }
        }

        function checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData) {
            return inventoryOperation(checkoutCart, payee).then(function (result) {
                if (result && result.soldoutpage) {
                    return $state.go('checkout.soldout', {
                        items: encodeURIComponent(result.items),
                        soldOutUrl: encodeURIComponent(result.soldOutUrl)
                    });
                }
                return makePayment(checkoutSession, checkoutCart, checkoutAppData, payee);
            });
        }

        function createSession() {

            var multistepSignupModel = $MultistepSignupModel.instance();
            var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);

            return checkoutSession.action('create', {
                data: {
                    fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                },
                success: function success() {
                    return $q.when().then(function () {
                        if (!multistepSignupModel.flags.shipToBilling) {
                            return multistepSignupModel.onboard.shipping_address.save({

                                data: multistepSignupModel.onboard.shipping_address.serialize(),

                                validation: function validation(message, err) {
                                    // TODO need to handle
                                }
                            });
                        }
                    }).then(function () {
                        var _ref = multistepSignupModel.flags || {},
                            hasBuyerFxPrePlanData = _ref.hasBuyerFxPrePlanData,
                            buyerFxTreatment = _ref.buyerFxTreatment;

                        // If this purchase is a cross-border transaction that requires
                        // currency conversion then `buyerFxTreatment` will be truthy


                        if (buyerFxTreatment) {
                            var _multistepSignupModel = multistepSignupModel.onboard,
                                card = _multistepSignupModel.card,
                                _multistepSignupModel2 = _multistepSignupModel.card;
                            _multistepSignupModel2 = _multistepSignupModel2 === undefined ? {} : _multistepSignupModel2;
                            var type = _multistepSignupModel2.type;
                            var purchase = checkoutSession.purchase;

                            var isConversionChangeable = (0, _utils.isConversionChangeableForCardType)(type);

                            /**
                             * If buyer fx pre-plan call failed and the card is changeable
                             * then we haven't logged event 3 yet. Event 3 for changeable
                             * cards is usually logged in xo-wallet-components creditcard-input
                             * directive after a successful call to the pre-plan API.
                             */
                            if (!hasBuyerFxPrePlanData && isConversionChangeable) {
                                /**
                                 * FPTI event #3 for Buyer FX
                                 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                                 */
                                (0, _utils.logBuyerFxFptiEvent3)(purchase);
                            }

                            /**
                             * FPTI event 7 for Buyer FX
                             * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                             */
                            (0, _utils.logBuyerFxFptiEvent7)({
                                card: card,
                                hasPrePlanData: hasBuyerFxPrePlanData,
                                isConversionChangeable: isConversionChangeable,
                                isSignup: true,
                                purchase: purchase
                            });
                        }

                        if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && multistepSignupModel.onboard.card.ppconversion === 'VENDOR') {
                            return $FundingOptionsModel.instance($rootScope.token).action('updateConversion', {
                                data: {
                                    conversionType: 'VENDOR',
                                    planId: checkoutSession.plan.id
                                }
                            })['catch'](function (err) {
                                _logger.$logger.warn('ERROR_updateConversion to VENDOR failed', err);
                            });
                        }
                    }).then(function () {
                        return authorizeSession(checkoutSession);
                    });
                },
                contingencies: {
                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD(err, message) {
                        _logger.$logger.info('NEED_CREDIT_CARD_contingency', {
                            name: err,
                            message: message
                        });
                        redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                    }
                }
            });
        }

        var multiStepFunctions = {

            onboard: function onboard() {

                var pageError = { // eslint-disable-line no-reserved-keys
                    multistepsignupaddcard: [],
                    multistepsignupaddshipping: [],
                    multistepsignupcreateaccount: [],
                    transient: true
                };

                var multistepSignupModel = $MultistepSignupModel.instance();

                multistepSignupModel.onboard.billing_address.country = $locale.country;
                multistepSignupModel.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);

                return multistepSignupModel.onboard.action(multistepSignupModel.flags.mode, {

                    data: multistepSignupModel.onboard.serialize(),

                    success: createSession,

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
                            var messages = [];

                            messages.push($locale.content.get('genericError.genericError'));

                            multistepSignupModel.pageError = pageError;
                            pageError.multistepsignupaddcard.errorMessage = {
                                msgs: messages,
                                type: 'error'
                            };

                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        },
                        ADD_KYC_FAILED: function ADD_KYC_FAILED() {
                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
                        },
                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
                            var messages = [];

                            messages.push($locale.content.get('creditcard.linkedCardToAddNewCard'));

                            multistepSignupModel.pageError = pageError;
                            pageError.multistepsignupaddcard.errorMessage = {
                                msgs: messages,
                                type: 'error'
                            };

                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        },
                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(message, errorData) {
                            // @TODO send to correct page in hermes
                            // $dispatch('hermes');
                            // auth model-> check if user logged in
                            var addFIContingency = errorData && errorData[0] === 'VALIDATION_ERROR' ? 'retry' : 'noretry';

                            $dispatch('hermes', {
                                redirectToHermes: true,
                                addFIContingency: addFIContingency,
                                token: $rootScope.token,
                                'locale.x': $locale.lang + '_' + $locale.country,
                                'country.x': $locale.country
                            });
                        },
                        ISSUER_DECLINE: function ISSUER_DECLINE(message, result) {
                            // @TODO send to correct page in hermes
                            // $dispatch('hermes');
                            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
                        },
                        VALIDATION_ERROR: function VALIDATION_ERROR(message, errors) {

                            var messages = [];
                            var compileVars = {
                                loginRedirectUrl: $getRedirectUrl('hermes', {
                                    hermesLoginRedirect: 'xoon'
                                })
                            };
                            // Iterate over the errorData to support multiple error support

                            Object.keys(errors).forEach(function (key, index, array) {

                                var errorCategory = errors[key];
                                // errorCategory sanity checks

                                if (!errorCategory || angular.isString(errorCategory) || key === 'transient' || key === 'payload') {
                                    return;
                                }

                                var fieldMap = processFieldMap(errorCategory);
                                var msg;
                                var compileMessageWith;

                                if (fieldMap) {

                                    if (fieldMap.pageError) {
                                        compileMessageWith = fieldMap.compileMessageWith;

                                        if (compileMessageWith) {
                                            // substitute the actual value
                                            // this is required as it is not good to have custom
                                            // code inside library - lib/utils.js
                                            $.each(compileMessageWith, function (objKey, val) {
                                                var actualValue = compileVars[val];

                                                if (actualValue) {
                                                    compileMessageWith[objKey] = actualValue;
                                                }
                                            });

                                            msg = $renderContent(fieldMap.pageError.contentKey, compileMessageWith);
                                        } else {
                                            msg = $locale.content.get(fieldMap.pageError.contentKey);
                                        }
                                        messages.push(msg);
                                    }

                                    pageError[fieldMap.path].push(fieldMap);

                                    if (messages.length > 0) {
                                        pageError[fieldMap.path].errorMessage = {
                                            msgs: messages,
                                            type: 'error'
                                        };
                                    }
                                }
                            });

                            multistepSignupModel.pageError = pageError;
                            throw pageError;
                        }
                    },
                    validation: function validation(res) {
                        if (res && (res.field === 'secondaryId' || res.field === 'passport')) {
                            // The validation error cannot be corrected at this point in onboarding
                            redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
                        } else {
                            _logger.$logger.info('signup_validation', {
                                message: res
                            });
                        }
                    }
                });
            },

            routeToHermesOn3DSDeclineForSignUp: function routeToHermesOn3DSDeclineForSignUp() {
                // dispatch to hermesnodeweb up on 3DS authenticate decline.
                _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
                $dispatch('hermes', {
                    token: $rootScope.token,
                    redirectToHermesOn3DSDecline: 'xoon'
                });
            },

            clear3DSContingency: function clear3DSContingency() {
                var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);

                return checkoutSession.action('clear3DSContingency', {
                    data: {
                        ccId: checkoutSession.resolve_3ds.ccId
                    },
                    success: function success() {
                        // don't call authorize if the contingency is not cleared
                        if (!checkoutSession.resolve_3ds) {
                            return authorizeSession(checkoutSession);
                        } else {
                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
                        }
                    },
                    contingencies: {
                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
                        DEFAULT: function handleContingency(name, contingency) {
                            _logger.$logger.info('clear3DSContingency_contingency', {
                                'int_error_description': contingency && contingency.message,
                                'contingency_name': name
                            });
                            // route to member review page upon patch xo throws contingency for signup
                            multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
                        }
                    }

                });
            }

        };

        return multiStepFunctions;
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_util.redirectToSubscriptionFinalRoute;

_logger.$logger;

_utils.isConversionChangeableForCardType;

_utils.logBuyerFxFptiEvent3;

_utils.logBuyerFxFptiEvent7;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/apiCalls", "../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/createAccount/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _contentKeys = __webpack_require__("../node_modules/xo-guest-components/src/lib/contentKeys.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/createAccount/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js"), __webpack_require__("../node_modules/xo-models/src/user/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, module, template, util) {

    return angular.module('xo-multistep-signup-create-account.directive', ['squid', 'xomodel.onboard', 'xo-value-props.directive', 'xo-dob-input.directive', 'xo-national-id-input.directive', 'xomodel.user', 'xomultistepsignupapi']).directive('xoMultistepSignupCreateAccount', [function () {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                multistepSignupModel: '=?',
                positionToErrorField: '=?',
                backState: '=?',
                backendError: '=?',
                clearBackendError: '=?'
            },

            controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$ShippingAddressModel', '$logger', '$CheckoutSessionModel', '$CheckoutAppDataModel', '$CheckoutCartModel', '$UserInfoModel', '$dispatch', '$pxpFactors', '$config', '$MultistepApiCalls', '$pxp', function ($scope, $rootScope, $populate, $state, $util, $locale, $ShippingAddressModel, $logger, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $UserInfoModel, $dispatch, $pxpFactors, $config, $MultistepApiCalls, $pxp) {

                // Log to FPTI to indicate the page has been rendered
                $logger.info('checkout_fpti', {
                    from: 'CHECKOUT_MULTISTEPSIGNUP_MULTISTEPSIGNUPCREATEACCOUNT',
                    to: 'prepare_checkout_multistepsignup_multistepsignupcreateaccount'
                });

                $scope.locale = $locale;
                $scope.componentsFlag = util.componentsMap($locale.country);
                $scope.metadata = angular.copy($locale.metadata);
                $scope.countries = $scope.metadata.territory;

                $scope.checkoutCart = $CheckoutCartModel.instance($scope.token);
                $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);

                if ($scope.checkoutAppData && $scope.checkoutAppData.merchant) {
                    $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                        nonEmptyReturnValue: true
                    });
                }

                function formatFiLast4() {
                    var ccNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    return 'x-' + ccNum.replace(/\s+/g, '').slice(-4);
                }

                function formatFiName() {
                    var ccType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    var tmp = ccType.toLowerCase();

                    return tmp.charAt(0).toUpperCase() + tmp.slice(1);
                }

                var contentOpts = {
                    cart: $scope.checkoutCart,
                    appData: $scope.checkoutAppData,
                    locale: $scope.locale
                };

                $scope.isWpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                $scope.isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();
                $scope.isSubscription = $scope.isWpsSubscription || $scope.isSubscriptionsV1;
                $scope.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
                $scope.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);

                $scope.fiName = formatFiName($scope.multistepSignupModel.onboard.card.type);
                $scope.fiFormatLast4 = formatFiLast4($scope.multistepSignupModel.onboard.card.number);

                // Reset password fields
                delete $scope.multistepSignupModel.onboard.user.password;
                delete $scope.multistepSignupModel.onboard.user.confirmPassword;

                var useraction = $scope.checkoutAppData.useraction();

                $scope.isCommit = useraction && useraction.toLowerCase() === 'commit';
                $logger.info('checkout_fpti', {
                    'billing_page_button_text': $scope.isCommit ? 'paynow_y' : 'paynow_n'
                });
                if ($scope.isSubscription) {
                    $scope.submitButtonKey = 'wpsSubscription.guest.createAccountAndSubscribe.button.text';
                } else if ($scope.isCommit) {
                    $scope.submitButtonKey = 'common.agreeAndPay';
                } else {
                    $scope.submitButtonKey = 'common.agreeAndContinue';
                }

                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
                    var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_createaccount_design;

                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                        $scope.createAccountDesignExp = result;
                    });
                }

                function handleUIValidation(fields) {
                    var $fields = $(fields);

                    $fields.addClass('backendError');

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                function isNameCyrillic() {
                    var result = true;
                    var regexCyrillic = /[а-яА-ЯЁё]/;

                    if (!regexCyrillic.test($('#firstName').val())) {
                        result = false;
                        handleUIValidation('#firstName');
                    }
                    if (!regexCyrillic.test($('#lastName').val())) {
                        result = false;
                        handleUIValidation('#lastName');
                    }
                    if (!regexCyrillic.test($('#middleName').val())) {
                        result = false;
                        handleUIValidation('#middleName');
                    }

                    if (!result) {
                        var messages = [];

                        messages.push($locale.content.get('addTaxId.cyrillicNameError'));
                        $scope.multistepSignupModel.pageError = $scope.multistepSignupModel.pageError || {};
                        $scope.multistepSignupModel.pageError.multistepsignupcreateaccount = {
                            errorMessage: {
                                msgs: messages,
                                type: 'error'
                            }
                        };
                    }

                    return result;
                }

                $scope.onContinue = function () {
                    var validInput = true;

                    if ($scope.multistepSignupModel.onboard.user.countryOfResidence === 'RU') {
                        validInput = isNameCyrillic();
                    }

                    var isLegalAge = util.validateLegalAge($scope.multistepSignupModel.onboard.user.dob_month, $scope.multistepSignupModel.onboard.user.dob_day, $scope.multistepSignupModel.onboard.user.dob_year);

                    if (!isLegalAge) {
                        validInput = false;
                        handleUIValidation('#dobText');
                    }

                    if (validInput) {
                        $scope.onSubmit();
                    }
                };

                $scope.legalAgreeToolTip = function () {
                    if ($scope.multistepSignupModel.onboard.agree) {
                        $scope.showTooltip = false;
                    } else {
                        $scope.showTooltip = true;
                    }
                };

                $scope.validate = function () {
                    $scope.legalAgreeToolTip();
                    $scope.validated = true;
                    return true;
                };

                $scope.onComplete3DSHandler = function (status) {
                    $scope.multistepSignupModel.is3ds = false;
                    if (status === 'decline' || status === 'close') {
                        // Flow should route to member review page for sign up case
                        // up on receiving "decline" or "close" response from 3DS authenticate call
                        $MultistepApiCalls.routeToHermesOn3DSDeclineForSignUp();
                    } else if (status === 'success') {
                        // Up on Successful authenticate, perform Patch on XO session and authorise.
                        $MultistepApiCalls.clear3DSContingency();
                    }
                };

                $scope.onSubmit = function () {

                    $logger.info($scope.multistepSignupModel.flags.mode + '_submit', {
                        type: $scope.multistepSignupModel.onboard.card.type,
                        country: $locale.country,
                        lang: $locale.lang
                    }).flush();

                    if ($scope.multistepSignupModel.flags.shipToBilling) {
                        $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, $scope.multistepSignupModel.onboard.billing_address, {
                            first_name: $scope.multistepSignupModel.onboard.user.first_name,
                            last_name: $scope.multistepSignupModel.onboard.user.last_name
                        });
                    }

                    $MultistepApiCalls.onboard()['catch'](function (pageError) {
                        var addCard = pageError.multistepsignupaddcard;
                        var addShipping = pageError.multistepsignupaddshipping;
                        var createAcc = pageError.multistepsignupcreateaccount;

                        // Globally handled contingencies also trigger the catch block.
                        if (addCard && addCard.length > 0) {
                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        } else if (addShipping && addShipping.length > 0) {
                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
                        } else if (createAcc && createAcc.length > 0) {
                            $scope.backendError('multistepsignupcreateaccount');
                        }
                    });
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_contentKeys.getBAContentKey;

_contentKeys.getRPContentKey;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/createAccount/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-create-account.route', ['squid', 'xo-multistep-signup-create-account.directive']).factory('$MultistepSignupCreateAccountRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupCreateAccountRoute', {
            name: 'multistepsignupcreateaccount',

            directive: 'xo-multistep-signup-create-account',

            children: []
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/createAccount", "../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/index.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, module, template) {

    return angular.module('xo-multistep-signup.directive', ['squid', 'xomultistepsignupmodel', 'xomodel.onboard', 'xomodel.checkout', 'xomodel.address', 'xo-fi-contingency-list.util']).directive('xoMultistepSignup', ['$rootScope', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                buttonParams: '=?'
            },

            controller: ['$populate', '$scope', '$state', '$locale', '$MultistepSignupModel', '$OnboardModel', '$logger', '$PrefillAddressModel', '$OnboardUserModel', '$OnboardPhoneModel', '$ShippingAddressModel', '$BillingAddressModel', '$InstallmentOptionsModel', '$location', '$feature', '$timeout', '$CheckoutPayeeModel', '$CheckoutCartModel', '$CheckoutAppDataModel', '$fiErrorUtil', '$util', function ($populate, $scope, $state, $locale, $MultistepSignupModel, $OnboardModel, $logger, $PrefillAddressModel, $OnboardUserModel, $OnboardPhoneModel, $ShippingAddressModel, $BillingAddressModel, $InstallmentOptionsModel, $location, $feature, $timeout, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel, $fiErrorUtil, $util) {

                $scope.locale = $locale;

                $scope.multistepSignupModel = $MultistepSignupModel.instance();

                function triggerPageDesignFPTILog() {
                    var pageContext = 'Full-context';

                    if ($rootScope.miniBrowser) {
                        pageContext = 'In-context';
                    }

                    $logger.info('checkout_fpti', {
                        'design': pageContext
                    });
                }
                // Log Initial Page Design
                triggerPageDesignFPTILog();
                // Trigger Design FPTI Log on Page Design Change
                $rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);

                var normalizeCallback;
                var lastPrefillCall = {};

                function sanitizeZip(value) {
                    return (value || '').replace(/[^0-9]+/g, '');
                }

                $scope.multistepSignupModel.onboard = new $OnboardModel({

                    user: $OnboardUserModel.instance($scope.token, {
                        country: $locale.country
                    }),

                    billing_address: $BillingAddressModel.create($scope.token, {
                        country: $locale.country
                    }),

                    shipping_address: $ShippingAddressModel.create($scope.token, {
                        country: $locale.country
                    }),

                    phone: new $OnboardPhoneModel()
                });

                $scope.multistepSignupModel.onboard.card.ppconversion = 'PAYPAL';

                // remove this upon oas ramp completion
                $scope.multistepSignupModel.onboard.testParams = {
                    oas: $util.param('oas'),
                    cardCandidate: $util.param('cardCandidate')
                };

                $populate($scope, {
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    $scope.multistepSignupModel.onboard.user.email = $scope.checkoutCart.payer && $scope.checkoutCart.payer.email;
                });

                $scope.multistepSignupModel.onboard.shipping_address.setProperties({
                    first_name: '',
                    last_name: ''
                });

                $scope.multistepSignupModel.onboard.billing_address.setProperties({
                    first_name: '',
                    last_name: ''
                });

                $scope.multistepSignupModel.flags = {
                    mode: 'signup',
                    shipToBilling: true,
                    allowEditShipping: true,

                    billingAddress: {
                        addrPrefilled: false
                    },
                    shippingAddress: {
                        addrPrefilled: false
                    }
                };

                function sortCountryList() {
                    $scope.metadata = angular.copy($locale.metadata);
                    return $scope.metadata.territory;
                }

                $scope.multistepSignupModel.countries = sortCountryList();

                $scope.positionToErrorField = function positionToErrorField() {
                    var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');

                    var firstErrorField = errorFields && errorFields.length && errorFields[0];

                    if (firstErrorField) {
                        firstErrorField.focus();
                        window.document.body.scrollTop = $(firstErrorField).offset().top;
                    } else {
                        // If there are no field errors and only page level errors.
                        window.document.body.scrollTop = 0;
                    }

                    $('.backendError:visible').on('blur', function (event) {
                        $(this).removeClass('backendError');
                    });

                    if ($('#installments').length) {
                        $('#paymentMethod').addClass('ng-invalid');
                    } else {
                        $('#paymentMethod').removeClass('ng-invalid');
                    }

                    return true;
                };

                $scope.backState = function backState() {
                    history.back();
                    // $scope.$apply();
                };

                $scope.backendError = function backendError(pageName) {
                    $timeout(function () {
                        var modelErrors = $scope.multistepSignupModel.pageError;

                        if (modelErrors && modelErrors[pageName]) {
                            var pageErrors = modelErrors[pageName];

                            pageErrors.forEach(function (err) {
                                if (err.name) {
                                    // Highlight the Error Fields by name
                                    $fiErrorUtil.addFieldErrorsByName(err, 'form', err.name);
                                } else {
                                    // Highlight the Error Fields by ng-model
                                    $fiErrorUtil.addFieldErrors(err, 'form', err.model);
                                }
                            });
                        }
                    }, 10);
                };

                $scope.clearBackendError = function clearBackendError(pageName) {
                    if ($scope.multistepSignupModel.pageError) {
                        $scope.multistepSignupModel.pageError[pageName] = [];
                    }
                };

                $scope.normalizeAddress = function normalizeAddress(address, callback) {
                    $scope.multistepSignupModel.onboard.toBeNormalizedAddress = address;
                    $state.go('checkout.multistepsignup.multistepsignupaddressnormalization');
                    normalizeCallback = callback;
                };

                $scope.prefillAddressCommon = function (postal_code, address, user, flag, override) {

                    if (!postal_code) {
                        return;
                    }

                    var addressType = address instanceof $ShippingAddressModel ? 'shipping' : 'billing';

                    if (!override && lastPrefillCall[addressType] === sanitizeZip(postal_code)) {
                        return;
                    }

                    $scope.prefillAddress = new $PrefillAddressModel({
                        id: $scope.token,
                        address: {
                            country: $locale.country,
                            postal_code: postal_code
                        }
                    });

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,

                        success: function success(result) {

                            if (result) {
                                lastPrefillCall[addressType] = sanitizeZip(result.postal_code);
                                address.setProperties(result);
                            }

                            if (address.name) {
                                var names = util.nameUtil.splitName(address.name); // eslint-disable-line block-scoped-var,no-undef

                                user.setProperties(names);
                            }

                            flag.addrPrefilled = true;

                            $timeout(function () {
                                flag.addrPrefilled = true;
                            }, 1000);
                        },

                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                flag.addrPrefilled = true;
                            }
                        }
                    });
                };

                $scope.uponNormalization = function uponNormalization(normalizedAddress, isBack) {
                    if (normalizeCallback) {
                        normalizeCallback(normalizedAddress, isBack);
                    }
                };

                /* Eligibility Check call is done only after first load. Hence is done in the parent directive
                 * and not in addCard directive. Addcard directive will be called after each back button
                 * rendering
                 */
                function isInstallmentEligible() {

                    $populate($scope, {
                        payee: $CheckoutPayeeModel.instance($scope.token),
                        checkoutCart: $CheckoutCartModel.instance($scope.token),
                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                    }).then(function () {

                        if ($scope.checkoutCart.isBilling()) {
                            // Reference transaction detected
                            $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
                        } else {
                            $scope.multistepSignupModel.eligibilityModel = {};

                            var installments = $InstallmentOptionsModel.instance($scope.token);

                            /* Updating the eligibilityModel with the installment response.
                             * Show Or hide of installment depends upon the card type.
                             * Card model changes for type is checked in addCard directive to determine installment display.
                             */
                            installments.save({
                                data: {
                                    payee: $scope.payee,
                                    checkoutCart: $scope.checkoutCart,
                                    checkoutAppData: $scope.checkoutAppData
                                },

                                resultModel: $scope.multistepSignupModel.eligibilityModel

                            }).then(function () {
                                $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
                            });
                        }
                    });
                }

                if ($feature('installments', false, $locale.country)) {
                    isInstallmentEligible();
                } else {
                    // BUG - switching from BR to RU country needs this timeout
                    // Without timeout the route change is so fast that it just loads an empty cached page
                    // without the form elements
                    $timeout(function () {
                        $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
                    });
                }
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomultistepsignupmodel', ['squid']).factory('$MultistepSignupModel', ['$Model', function ($Model) {
        return $Model.extend('MultistepSignupModel', {});
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup", "../node_modules/xo-guest-components/src/multistep-signup/index.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    var name = {
        splitName: function splitName(fullName) {
            var index = fullName.indexOf(' ');

            return {
                first_name: index > 0 ? fullName.substr(0, index) : fullName,
                last_name: index > 0 ? fullName.substr(index + 1) : ''
            };
        }
    };

    var masking = {
        maskZip: function maskZip(value) {
            if (value) {
                var unformatted = value.replace(/[^0-9]/gi, '');

                return unformatted.length > 5 ? [unformatted.slice(0, 5), '-', unformatted.slice(5)].join('') : unformatted;
            }

            return '';
        }
    };

    var validateLegalAge = function validateLegalAge(dobMonth, dobDay, dobYear) {
        var currentDate = new Date();
        var currentMonth = currentDate.getMonth() + 1;
        var currentDay = currentDate.getDate();
        var currentYear = currentDate.getFullYear();
        var largestDOBYear = currentYear - 18; // Legal age is 18

        var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay;

        return isLegal;
    };

    var componentsMap = function componentsMap(locale) {
        var flags = {};

        switch (locale) {
            case 'BR':
                flags = {
                    zipCode: true,
                    billingAddressLabel: false,
                    shippingAddress: false,
                    shippingAddressPage: true,
                    dobDropDown: true,
                    addTaxId: true
                };
                break;
            case 'RU':
                flags = {
                    zipCode: false,
                    billingAddressLabel: true,
                    shippingAddress: true,
                    shippingAddressPage: false,
                    dobDropDown: false,
                    dobText: true
                };
                break;
            default:
                flags = {
                    nameInput: true,
                    zipCode: true,
                    billingAddressLabel: true,
                    shippingAddress: true,
                    dobDropDown: true
                };
                break;
        }

        return flags;
    };

    var contingencyMap = function contingencyMap(code) {
        var errorElementMap = {
            INVALID_FIRST_NAME: {
                fields: [{ field: 'first_name' }],
                model: 'user.',
                path: 'multistepsignupaddcard'
            },
            INVALID_LAST_NAME: {
                fields: [{ field: 'last_name' }],
                model: 'user.',
                path: 'multistepsignupaddcard'
            },
            INVALID_MIDDLE_NAME: {
                fields: [{ field: 'middle_name' }],
                model: 'user.',
                path: 'multistepsignupaddcard'
            },
            INVALID_NATIVE_FIRST_NAME: {
                fields: [{ field: 'first_name' }],
                model: 'user.',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_NATIVE_LAST_NAME: {
                fields: [{ field: 'last_name' }],
                model: 'user.',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_NATIVE_MIDDLE_NAME: {
                fields: [{ field: 'middle_name' }],
                model: 'user.nativeName.',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_PHONE_TYPE: {
                fields: [{ field: 'phoneType' }],
                model: 'phone.',
                path: 'multistepsignupaddcard'
            },
            INVALID_PHONE_NUMBER: {
                fields: [{ field: 'telephone' }],
                model: 'phone.',
                path: 'multistepsignupaddcard'
            },
            INVALID_CITY_STATE_ZIPCODE: {
                fields: [{ field: 'city' }, { field: 'state' }, { field: 'zipCode' }],
                model: 'address.',
                path: 'multistepsignupaddcard'
            },
            INVALID_LINE1: {
                fields: [{ field: 'line1' }],
                model: 'address.',
                path: 'multistepsignupaddcard'
            },
            INVALID_CITY: {
                fields: [{ field: 'city' }],
                model: 'address.',
                path: 'multistepsignupaddcard'
            },
            INVALID_STATE: {
                fields: [{ field: 'state' }],
                model: 'address.',
                path: 'multistepsignupaddcard'
            },
            INVALID_ZIPCODE: {
                fields: [{ field: 'zipCode' }],
                model: 'address.',
                path: 'multistepsignupaddcard'
            },

            INVALID_NATIONAL_ID_TYPE: {
                fields: [{ field: 'type' }],
                model: 'nationalIdModel.nationalId.',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_NATIONAL_ID: {
                fields: [{ field: 'Id' }],
                name: 'national',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_SECONDARY_ID_TYPE: {
                fields: [{ field: 'secondaryIdType' }],
                model: 'nationalIdModel.',
                path: 'multistepsignupcreateaccount'
            },
            INVALID_SECONDARY_ID: {
                fields: [{ field: 'secondaryIdValue' }],
                model: 'nationalIdModel.',
                path: 'multistepsignupcreateaccount'
            },

            INVALID_CARD_NUMBER: {
                path: 'multistepsignupaddcard'
            },
            INVALID_BILLING_ADDRESS: {
                model: 'address.',
                path: 'multistepsignupaddcard'
            },
            INVALID_SHIPPING_ADDRESS: {
                model: 'address.',
                path: 'multistepsignupaddshipping'
            },
            INVALID_EXPIRY: {
                path: 'multistepsignupaddcard'
            },
            PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
                fields: [{
                    field: 'password'
                }, {
                    field: 'confirmPassword'
                }],
                model: 'user.',
                path: 'multistepsignupcreateaccount'
            },
            PASSWORD_HAS_ILLEGAL_CHARACTERS: {
                fields: [{
                    field: 'password'
                }, {
                    field: 'confirmPassword'
                }],
                model: 'user.',
                path: 'multistepsignupcreateaccount'
            },
            ACCOUNT_ALREADY_EXISTS: {
                fields: [{
                    field: 'user.email'
                }],
                pageError: {
                    contentKey: 'login.userMayHaveAccount'
                },
                compileMessageWith: {
                    href: 'loginRedirectUrl'
                },
                path: 'multistepsignupcreateaccount'
            },
            DOB_INVALID: {
                fields: [{
                    field: 'user.dob_day'
                }, {
                    field: 'user.dob_month'
                }, {
                    field: 'user.dob_year'
                }],
                path: 'multistepsignupcreateaccount'
            },
            CC_NUMBER_BLOCKED: {
                model: 'card.',
                pageError: {
                    contentKey: 'creditcard.errorGeneral'
                },
                path: 'multistepsignupaddcard'
            },
            COUNTRY_NOT_SUPPORTED: {
                model: 'card.',
                pageError: {
                    contentKey: 'creditcard.complianceDecline'
                },
                path: 'multistepsignupaddcard'
            },
            CARD_GENERIC_ERROR: {
                model: 'card.',
                pageError: {
                    contentKey: 'creditcard.errorGeneral'
                },
                path: 'multistepsignupaddcard'
            }
        };

        return errorElementMap[code];
    };

    var util = {};

    util.nameUtil = name;
    util.maskingUtil = masking;
    util.componentsMap = componentsMap;
    util.contingencyMap = contingencyMap;
    util.validateLegalAge = validateLegalAge;

    return util;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup.route', ['squid', 'xo-multistep-signup.directive', 'xo-multistep-signup-add-card.route', 'xo-multistep-signup-add-shipping.route', 'xo-multistep-signup-create-account.route', 'xo-multistep-signup-address-normalization.route']).factory('$MultistepSignupRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupRoute', {
            name: 'multistepsignup',

            directive: 'xo-multistep-signup',

            children: [{
                name: '$MultistepSignupAddCardRoute',
                attributes: {
                    token: 'token',
                    'multistep-signup-model': 'multistepSignupModel',
                    'position-to-error-field': 'positionToErrorField',
                    'back-state': 'backState',
                    'backend-error': 'backendError',
                    'clear-backend-error': 'clearBackendError',
                    'normalize-address': 'normalizeAddress',
                    'prefill-address-common': 'prefillAddressCommon',
                    'button-params': 'buttonParams'
                }
            }, {
                name: '$MultistepSignupAddShippingRoute',
                attributes: {
                    token: 'token',
                    'multistep-signup-model': 'multistepSignupModel',
                    'position-to-error-field': 'positionToErrorField',
                    'back-state': 'backState',
                    'backend-error': 'backendError',
                    'clear-backend-error': 'clearBackendError',
                    'normalize-address': 'normalizeAddress',
                    'prefill-address-common': 'prefillAddressCommon'
                }
            }, {
                name: '$MultistepSignupCreateAccountRoute',
                attributes: {
                    token: 'token',
                    'multistep-signup-model': 'multistepSignupModel',
                    'position-to-error-field': 'positionToErrorField',
                    'back-state': 'backState',
                    'backend-error': 'backendError',
                    'clear-backend-error': 'clearBackendError'
                }
            }, {
                name: '$MultistepSignupAddressNormalizationRoute',
                attributes: {
                    token: 'token',
                    address: 'multistepSignupModel.onboard.toBeNormalizedAddress',
                    'done-fn': 'uponNormalization'
                }
            }]
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup", "../node_modules/xo-guest-components/src/multistep-signup/route.js"))

/***/ }),

/***/ "../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var jquery = __webpack_provided_window_dot_jQuery;

// jQuery Mask Plugin v1.14.11
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp={scope:{},findInternal:function(a,l,d){a instanceof String&&(a=String(a));for(var p=a.length,h=0;h<p;h++){var b=a[h];if(l.call(d,b,h,a))return{i:h,v:b}}return{i:-1,v:void 0}}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(a,l,d){if(d.get||d.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[l]=d.value)};
$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);$jscomp.polyfill=function(a,l,d,p){if(l){d=$jscomp.global;a=a.split(".");for(p=0;p<a.length-1;p++){var h=a[p];h in d||(d[h]={});d=d[h]}a=a[a.length-1];p=d[a];l=l(p);l!=p&&null!=l&&$jscomp.defineProperty(d,a,{configurable:!0,writable:!0,value:l})}};
$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,d){return $jscomp.findInternal(this,a,d).v}},"es6-impl","es3");
(function(a,l,d){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports?module.exports=a(require("jquery")):a(l||d)})(function(a){var l=function(b,e,f){var c={invalid:[],getCaret:function(){try{var a,r=0,g=b.get(0),e=document.selection,f=g.selectionStart;if(e&&-1===navigator.appVersion.indexOf("MSIE 10"))a=e.createRange(),a.moveStart("character",-c.val().length),r=a.text.length;else if(f||"0"===f)r=f;return r}catch(C){}},setCaret:function(a){try{if(b.is(":focus")){var c,
g=b.get(0);g.setSelectionRange?g.setSelectionRange(a,a):(c=g.createTextRange(),c.collapse(!0),c.moveEnd("character",a),c.moveStart("character",a),c.select())}}catch(B){}},events:function(){b.on("keydown.mask",function(a){b.data("mask-keycode",a.keyCode||a.which);b.data("mask-previus-value",b.val());b.data("mask-previus-caret-pos",c.getCaret());c.maskDigitPosMapOld=c.maskDigitPosMap}).on(a.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){b.keydown().keyup()},
100)}).on("change.mask",function(){b.data("changed",!0)}).on("blur.mask",function(){d===c.val()||b.data("changed")||b.trigger("change");b.data("changed",!1)}).on("blur.mask",function(){d=c.val()}).on("focus.mask",function(b){!0===f.selectOnFocus&&a(b.target).select()}).on("focusout.mask",function(){f.clearIfNotMatch&&!h.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],b,c,f,n,d=0;d<e.length;d++)(b=m.translation[e.charAt(d)])?(c=b.pattern.toString().replace(/.{1}$|^.{1}/g,""),f=b.optional,
(b=b.recursive)?(a.push(e.charAt(d)),n={digit:e.charAt(d),pattern:c}):a.push(f||b?c+"?":c)):a.push(e.charAt(d).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");n&&(a=a.replace(new RegExp("("+n.digit+"(.*"+n.digit+")?)"),"($1)?").replace(new RegExp(n.digit,"g"),n.pattern));return new RegExp(a)},destroyEvents:function(){b.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(a){var c=b.is("input")?"val":"text";if(0<arguments.length){if(b[c]()!==a)b[c](a);
c=b}else c=b[c]();return c},calculateCaretPosition:function(){var a=b.data("mask-previus-value")||"",e=c.getMasked(),g=c.getCaret();if(a!==e){var f=b.data("mask-previus-caret-pos")||0,e=e.length,d=a.length,m=a=0,h=0,l=0,k;for(k=g;k<e&&c.maskDigitPosMap[k];k++)m++;for(k=g-1;0<=k&&c.maskDigitPosMap[k];k--)a++;for(k=g-1;0<=k;k--)c.maskDigitPosMap[k]&&h++;for(k=f-1;0<=k;k--)c.maskDigitPosMapOld[k]&&l++;g>d?g=e:f>=g&&f!==d?c.maskDigitPosMapOld[g]||(f=g,g=g-(l-h)-a,c.maskDigitPosMap[g]&&(g=f)):g>f&&(g=
g+(h-l)+m)}return g},behaviour:function(f){f=f||window.event;c.invalid=[];var e=b.data("mask-keycode");if(-1===a.inArray(e,m.byPassKeys)){var e=c.getMasked();setTimeout(function(){c.setCaret(c.calculateCaretPosition())},10);c.val(e);c.setCaret(e.length);return c.callbacks(f)}},getMasked:function(a,b){var g=[],d=void 0===b?c.val():b+"",n=0,h=e.length,q=0,l=d.length,k=1,r="push",p=-1,t=0,y=[],v,z;f.reverse?(r="unshift",k=-1,v=0,n=h-1,q=l-1,z=function(){return-1<n&&-1<q}):(v=h-1,z=function(){return n<
h&&q<l});for(var A;z();){var x=e.charAt(n),w=d.charAt(q),u=m.translation[x];if(u)w.match(u.pattern)?(g[r](w),u.recursive&&(-1===p?p=n:n===v&&(n=p-k),v===p&&(n-=k)),n+=k):w===A?(t--,A=void 0):u.optional?(n+=k,q-=k):u.fallback?(g[r](u.fallback),n+=k,q-=k):c.invalid.push({p:q,v:w,e:u.pattern}),q+=k;else{if(!a)g[r](x);w===x?(y.push(q),q+=k):(A=x,y.push(q+t),t++);n+=k}}d=e.charAt(v);h!==l+1||m.translation[d]||g.push(d);g=g.join("");c.mapMaskdigitPositions(g,y,l);return g},mapMaskdigitPositions:function(a,
b,e){a=f.reverse?a.length-e:0;c.maskDigitPosMap={};for(e=0;e<b.length;e++)c.maskDigitPosMap[b[e]+a]=1},callbacks:function(a){var h=c.val(),g=h!==d,m=[h,a,b,f],q=function(a,b,c){"function"===typeof f[a]&&b&&f[a].apply(this,c)};q("onChange",!0===g,m);q("onKeyPress",!0===g,m);q("onComplete",h.length===e.length,m);q("onInvalid",0<c.invalid.length,[h,a,b,c.invalid,f])}};b=a(b);var m=this,d=c.val(),h;e="function"===typeof e?e(c.val(),void 0,b,f):e;m.mask=e;m.options=f;m.remove=function(){var a=c.getCaret();
c.destroyEvents();c.val(m.getCleanVal());c.setCaret(a);return b};m.getCleanVal=function(){return c.getMasked(!0)};m.getMaskedVal=function(a){return c.getMasked(!1,a)};m.init=function(d){d=d||!1;f=f||{};m.clearIfNotMatch=a.jMaskGlobals.clearIfNotMatch;m.byPassKeys=a.jMaskGlobals.byPassKeys;m.translation=a.extend({},a.jMaskGlobals.translation,f.translation);m=a.extend(!0,{},m,f);h=c.getRegexMask();if(d)c.events(),c.val(c.getMasked());else{f.placeholder&&b.attr("placeholder",f.placeholder);b.data("mask")&&
b.attr("autocomplete","off");d=0;for(var l=!0;d<e.length;d++){var g=m.translation[e.charAt(d)];if(g&&g.recursive){l=!1;break}}l&&b.attr("maxlength",e.length);c.destroyEvents();c.events();c.val(c.getMasked());c.setCaret(c.getMasked().length)}};m.init(!b.is("input"))};a.maskWatchers={};var d=function(){var b=a(this),e={},f=b.attr("data-mask");b.attr("data-mask-reverse")&&(e.reverse=!0);b.attr("data-mask-clearifnotmatch")&&(e.clearIfNotMatch=!0);"true"===b.attr("data-mask-selectonfocus")&&(e.selectOnFocus=
!0);if(p(b,f,e))return b.data("mask",new l(this,f,e))},p=function(b,e,f){f=f||{};var c=a(b).data("mask"),d=JSON.stringify;b=a(b).val()||a(b).text();try{return"function"===typeof e&&(e=e(b)),"object"!==typeof c||d(c.options)!==d(f)||c.mask!==e}catch(t){}},h=function(a){var b=document.createElement("div"),d;a="on"+a;d=a in b;d||(b.setAttribute(a,"return;"),d="function"===typeof b[a]);return d};a.fn.mask=function(b,d){d=d||{};var e=this.selector,c=a.jMaskGlobals,h=c.watchInterval,c=d.watchInputs||c.watchInputs,
t=function(){if(p(this,b,d))return a(this).data("mask",new l(this,b,d))};a(this).each(t);e&&""!==e&&c&&(clearInterval(a.maskWatchers[e]),a.maskWatchers[e]=setInterval(function(){a(document).find(e).each(t)},h));return this};a.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};a.fn.unmask=function(){clearInterval(a.maskWatchers[this.selector]);delete a.maskWatchers[this.selector];return this.each(function(){var b=a(this).data("mask");b&&b.remove().removeData("mask")})};a.fn.cleanVal=function(){return this.data("mask").getCleanVal()};
a.applyDataMask=function(b){b=b||a.jMaskGlobals.maskElements;(b instanceof a?b:a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(d)};h={maskElements:"input,td,span,div",dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:!/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent)&&h("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},
S:{pattern:/[a-zA-Z]/}}};a.jMaskGlobals=a.jMaskGlobals||{};h=a.jMaskGlobals=a.extend(!0,{},h,a.jMaskGlobals);h.dataMask&&a.applyDataMask();setInterval(function(){a.jMaskGlobals.watchDataMask&&a.applyDataMask()},h.watchInterval)},__webpack_provided_window_dot_jQuery,window.Zepto);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/xo-locale/dist/country.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/app/index.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.resolvers.country', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app', 'xomodel.onboard']).factory('$CountryResolvers', function ($q, $rootScope, $populate, $util, $meta, $localeHelper, $locale, $AuthModel, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel, $GuestUpgradeModel) {

        return {

            viaCountryPreference: {
                method: function method() {
                    return $locale.chosenCountry;
                }
            },

            viaLocaleTestUrlParam: {
                desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
                method: function method() {
                    var locale = $util.param('locale.test');

                    if (locale) {
                        return $localeHelper.normalizeLocale(locale).country;
                    }
                }
            },

            viaMerchantParam: {
                desc: 'As part of url merchants can pass the locale.x=en_FR or country.x=FR. Here we extract the country param',
                method: function method() {
                    var country = $util.param('country.x');

                    if (country) {
                        return country;
                    }

                    var locale = $util.param('locale.x');

                    return $localeHelper.normalizeLocale(locale).country;
                }
            },

            viaUserProfile: {
                desc: 'From AuthModel. Country comes as "US", "FR" etc. ',
                method: function method() {
                    var data = {};

                    return $populate(data, {
                        auth: $AuthModel.instance()
                    }).then(function () {
                        return data.auth.country;
                    });
                }
            },

            viaCheckoutSession: {
                desc: 'From Merchant locale in CheckoutAppDataModel. merchant_locale comes as en_US etc.',
                method: function method() {
                    // check before creating $CheckoutAppDataModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                    }).then(function () {
                        var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');

                        if (!merchant_locale) {
                            return;
                        }

                        if (merchant_locale.match(/^\w{2}_\w{2}$/)) {
                            return $localeHelper.normalizeLocale(merchant_locale).country;
                        }

                        return merchant_locale;
                    });
                }
            },

            viaCheckoutBilling: {
                desc: 'From Merchant passed billingAddress in CheckoutCart.',
                method: function method() {
                    // check before creating $CheckoutCartModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutCart.get('payer_info.billing_address.country_code');
                    });
                }
            },

            viaCheckoutShipping: {
                method: function method() {
                    // check before creating $CheckoutCartModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutCart.get('purchase.shipping_address.country_code');
                    });
                }
            },

            viaMerchantCountry: {
                method: function method() {
                    // check before creating $CheckoutAppDataModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                    }).then(function () {
                        return data.checkoutAppData.get('merchant.merchant_country');
                    });
                }
            },

            viaGuestAccountCountry: {
                desc: 'From Guest account legal country in ISO country code format (e.g. US, AU)',
                method: function method() {
                    // only perform this resolver for guest-upgrade flow (has data param)
                    if (!$util.param('data')) {
                        return;
                    }

                    return $GuestUpgradeModel.instance().retrieve({
                        error: angular.noop,
                        transientError: true
                    }).then(function (model) {
                        return model.get('user.country');
                    });
                }
            },

            viaCountryCoBrand: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.cobrand');
                    });
                }
            },

            viaLangCookie: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.lang_cookie.country');
                    });
                }
            },

            viaBrowserPref: {
                method: function method() {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.browser_lang.country');
                    });
                }
            },

            viaIP: {
                method: function method() {
                    return $meta.ipcountry;
                }
            },

            viaDefault: {
                method: function method() {
                    return 'US';
                }
            }

        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/country.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/helper.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.helper', ['squid']).factory('$localeHelper', function () {
        return {
            /**
             *
             * @param locale - Ex: en_US
             * @returns {{country: *, dialect}}
             */
            normalizeLocale: function normalizeLocale(locale) {
                if (!locale) {
                    return {};
                }

                locale = locale.replace('-', '_');

                var country;
                var language;

                if (locale.match(/^\w{2}_\w{2}$/)) {
                    locale = locale.split('_');

                    language = locale[0];
                    country = locale[1];
                } else {
                    language = locale;
                }

                return {
                    country: country,
                    language: language
                };
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/helper.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-locale/dist/resolvers.js"), __webpack_require__("../node_modules/xo-locale/dist/language.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    return angular.module('xolocale', ['squid', 'beaver', 'locale.resolvers', 'locale.resolvers.language', 'locale.helper']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-locale/dist/language.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/app/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.resolvers.language', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app']).factory('$LanguageResolvers', function ($q, $rootScope, $populate, $util, $AuthModel, $config, $locale, $localeHelper, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel) {

        var browserPrefCountries = ['US', 'GB', 'CA'];

        return {
            viaLanguagePreference: {
                method: function method(country) {
                    return $locale.chosenLang;
                }
            },

            viaLocaleTestUrlParam: {
                desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
                method: function method() {
                    var locale = $util.param('locale.test');

                    if (locale) {
                        return $localeHelper.normalizeLocale(locale).language;
                    }
                }
            },

            viaMerchantParam: {
                desc: 'As part of url merchants can pass the locale.x=en_FR, were we extract the language param',
                method: function method() {
                    var locale = $util.param('locale.x');

                    if (locale) {
                        return $localeHelper.normalizeLocale(locale).language;
                    }
                }
            },

            viaUserProfile: {
                method: function method(country) {
                    var data = {};

                    return $populate(data, {
                        auth: $AuthModel.instance()
                    }).then(function () {
                        var locale = $localeHelper.normalizeLocale(data.auth.language);

                        return locale && locale.language;
                    });
                }
            },

            viaMerchantLocale: {
                method: function method() {
                    // check before creating $CheckoutAppDataModel
                    if (!$rootScope.token) {
                        return;
                    }

                    var data = {};

                    return $populate(data, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                    }).then(function () {
                        var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');

                        if (!merchant_locale) {
                            return;
                        }

                        if (!merchant_locale.match(/^\w{2}_\w{2}$/)) {
                            return;
                        }

                        return $localeHelper.normalizeLocale(merchant_locale && merchant_locale).language;
                    });
                }
            },

            viaLangCookie: {
                method: function method(country) {
                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        var lang_cookie = appData.get('locale_info.lang_cookie', {});

                        if (lang_cookie.country === country) {
                            return lang_cookie.language;
                        }
                    });
                }
            },

            viaBrowserPref: {
                method: function method(country) {
                    if (browserPrefCountries.indexOf(country) === -1) {
                        return $q.when();
                    }

                    return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
                        return appData.get('locale_info.browser_lang.language');
                    });
                }
            },

            viaDefault: {
                method: function method(country) {
                    return $config.supportedCountries[country][0];
                }
            }

        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/language.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/resolvers.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/country.js"), __webpack_require__("../node_modules/xo-locale/dist/language.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.resolvers', [// eslint-disable-line angular/no-service-method
    'locale.resolvers.country', 'locale.resolvers.language']).service('$LocaleResolver', function ($locale, $Class, $util, $logger, $CountryResolvers, $LanguageResolvers, $config, $q) {

        var LocaleResolver = $Class.extend('LocaleResolver', {

            registerCountryResolver: function registerCountryResolver(name, resolver) {
                $CountryResolvers[name] = resolver;
            },

            registerLangResolver: function registerLangResolver(name, resolver) {
                $LanguageResolvers[name] = resolver;
            },

            resolvePromiseChain: function resolvePromiseChain(resolvers, validator, args) {

                var self = this;
                var promise = $q.when();
                var result;

                angular.forEach(resolvers, function (resolver) {

                    promise = promise.then(function () {

                        if (result) {
                            return result;
                        }

                        return $q.when(resolver.method.apply(self, args || [])).then(function (resolved) {

                            if (resolved && validator(resolved)) {
                                result = {
                                    resolver: resolver.name,
                                    resolved: resolved
                                };
                                return result;
                            }
                        });
                    }, angular.noop);
                });

                return promise;
            },

            resolveCountry: function resolveCountry() {

                var validator = function validator(country) {
                    return Boolean(country && $config.supportedCountries[country]);
                };

                var resolvers = $util.map($config.locale.country.resolvers, function (name) {
                    $CountryResolvers[name].name = name;
                    return $CountryResolvers[name];
                });

                return this.resolvePromiseChain(resolvers, validator).then(function (resolved) {
                    $logger.debug('resolve_country', {
                        country: resolved.resolved,
                        resolver: resolved.resolver
                    });
                    return resolved.resolved;
                });
            },

            resolveLanguage: function resolveLanguage(country) {

                var validator = function validator(language) {
                    return Boolean($config.supportedCountries[country].indexOf(language) > -1);
                };

                var resolvers = $util.map($config.locale.lang.resolvers, function (name) {
                    $LanguageResolvers[name].name = name;
                    return $LanguageResolvers[name];
                });

                return this.resolvePromiseChain(resolvers, validator, [country]).then(function (resolved) {
                    $logger.debug('resolve_lang', {
                        lang: resolved.resolved,
                        resolver: resolved.resolver
                    });
                    return resolved.resolved;
                });
            },

            setUserPreferredCountry: function setUserPreferredCountry(country) {
                $util.assert(country, 'No country provided');
                this.userPreferredCountry = country;
            },

            setUserPreferredLanguage: function setUserPreferredLanguage(language) {
                $util.assert(language, 'No language provided');
                this.userPreferredLanguage = language;
            },

            resolve: function resolve(preventContentLoad) {

                var self = this;

                function resolveCountry() {
                    if (self.userPreferredCountry) {
                        return $q.when(self.userPreferredCountry);
                    }

                    return self.resolveCountry();
                }

                function resolveLanguage(country) {
                    if (self.userPreferredLanguage) {
                        return $q.when(self.userPreferredLanguage);
                    }

                    return self.resolveLanguage(country);
                }

                return resolveCountry().then(function (country) {
                    return resolveLanguage(country).then(function (language) {
                        return {
                            language: language,
                            country: country
                        };
                    });
                }).then(function (result) {
                    return $locale.change(result.country, result.language, preventContentLoad);
                });
            }

        });

        return new LocaleResolver();
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/resolvers.js"))

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/dolphin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-dolphin',
    template: _template2['default'],
    hasUserClosedTheBanner: false,
    isPhoneConfirmed: false,
    // prevent iframe timer from executing overlay has loaded in any scenario (error or success)
    hasOverlayLoaded: false,
    isTimerRunning: false,
    timerDuration: 10000,
    actions: {
        startTimer: function startTimer() {
            var _this = this;

            _logger.$logger.info('xoDolphin_startTimer');
            // Set a 10 second timer to check if UL has loaded or not
            this.isTimerRunning = true;
            (0, _angular.$timeout)(function () {
                if (!_this.hasOverlayLoaded && _this.isTimerRunning) {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_timeout',
                        'context_id': _angular.$rootScope.token
                    });
                    _this.isTimerRunning = false;
                }
            }, this.timerDuration);
        },
        closeBanner: function closeBanner() {
            this.showBanner = false;
            this.hasUserClosedTheBanner = true;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'close_banner',
                'context_id': _angular.$rootScope.token
            });
        },
        openOverlay: function openOverlay() {
            var _this2 = this;

            var onPostMessagesHandler = function onPostMessagesHandler(postMessage) {
                if (!angular.isObject(postMessage)) {
                    try {
                        postMessage = JSON.parse(postMessage);
                    } catch (e) {
                        _logger.$logger.info('xoDolphin_jsonParseFailed');
                    }
                }

                if (!postMessage || !postMessage.data || !postMessage.data.event) {
                    _logger.$logger.info('xoDolphin_invalidPostMessage');
                    return;
                }

                if (postMessage.data.event === 'phoneConfirmationLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _angular.$rootScope.$emit('loaded');
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'phoneConfirmationCompleted') {
                    _this2.isPhoneConfirmed = true;
                    // For auto triggered overlays (confirm3 & add3), the banner is hidden by default
                    // Unhide it once phone confirmation completes or SMS to complete it is sent out
                    if (_this2.toastParams.autoTriggeredOverlay) {
                        _logger.$logger.info('xoDolphin_showBannerOnAutoTriggeredOverlay');
                        _this2.showBanner = true;
                    }
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'successfully_confirmed',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'smsSent') {
                    // Set isPhoneConfirmed to true as user will complete the phone confirmation from sms
                    // hence from app point of view it s completed for the 'current' request
                    // Also, the experience is exactly the same (show success message)
                    _this2.isPhoneConfirmed = true;
                    _this2.successContent = _this2.toastParams.smsSentKey;
                    _this2.showBanner = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'sms_sent',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'phoneConfirmationError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'generic_error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'close') {
                    _this2.hasOverlayLoaded = true;
                    _this2.actions.closeOverlay();
                }
            };
            (0, _angular.$timeout)(function () {
                _logger.$logger.info(_utils.flowName, {
                    'from': 'show_banner',
                    'to': 'show_overlay',
                    'context_id': _angular.$rootScope.token
                });

                _this2.$element.addClass('overlayOpen').promise().then(function () {
                    // Note: A second timeout is added here to avoid a race condition where the DOM is not yet available
                    // for the inject script to pick a targetElement for injecting the iframe.
                    (0, _angular.$timeout)(function () {
                        var variant = _this2.toastParams && _this2.toastParams.variant;
                        var options = (0, _utils.getInjectULBaseObject)(variant);
                        options.onPostMessage = onPostMessagesHandler;
                        if (!options.targetElement) {
                            _logger.$logger.info('xoDolphin_missingTargetElement');
                        }
                        if (window.PAYPAL && window.PAYPAL.unifiedLogin && options.targetElement) {
                            _logger.$logger.info('xoDolphin_injectIframe');
                            window.PAYPAL.unifiedLogin.inject(options);
                            _this2.actions.startTimer();
                        }
                    });
                });
            });
        },
        closeOverlay: function closeOverlay() {
            var _this3 = this;

            this.$element.removeClass('overlayOpen');
            this.isTimerRunning = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'overlay_closed',
                'context_id': _angular.$rootScope.token
            });
            (0, _angular.$timeout)(function () {
                _logger.$logger.info('xoDolphin_hideOverlay');
                _this3.showOverlay = false;
                _this3.hasOverlayLoaded = false;
            }, 300);
        }
    },
    lifecycle: {
        enter: function enter() {
            var ulToast = _squid.$util.param('ulToast') || _squid.$util.param('ulToastWpsDone');
            this.toastParams = ulToast && _utils.variantParams[ulToast];
        },
        populate: function populate() {
            var _this4 = this;

            if (!this.toastParams) {
                _logger.$logger.info('Missing or invalid toast param!');
                return;
            }

            this.showBanner = !this.toastParams.autoTriggeredOverlay;
            this.showOverlay = this.toastParams.autoTriggeredOverlay;
            this.bannerContent = this.toastParams.messageKey;
            this.successContent = this.toastParams.successKey;
            this.autoTriggeredOverlay = this.toastParams.autoTriggeredOverlay;
            this.variant = this.toastParams.variant;
            // DeviceInfo doesnt seem to have isDesktop, hence just avoiding the mobile use case
            this.fixedBanner = _index.$DeviceInfo.isMobile() ? '' : 'dolphinBannerFixed';

            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': this.toastParams.transitionName,
                'banner_type': this.toastParams.bannerType,
                'context_id': _angular.$rootScope.token
            });

            // Cannot use `$apply` as we need to wait for the entire digest cycle to complete
            (0, _angular.$timeout)(function () {
                if (_this4.autoTriggeredOverlay) {
                    _this4.actions.openOverlay();
                    return;
                }
                angular.element('#confirmPhoneBtn').on('click', function () {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'click_link',
                        'context_id': _angular.$rootScope.token
                    });
                    _this4.showOverlay = true;
                    // Allow overlay DOM to be added before animating it in
                    (0, _angular.$timeout)(_this4.actions.openOverlay, 150);
                });
                // Add a delay to open the overlay when it's A) auto trigger and B) Not WPS
                // `ulToastWpsDone` will be added by UL only if it is indeed a WPS flow
            }, this.autoTriggeredOverlay && !_squid.$util.param('ulToastWpsDone') ? 1800 : 0);
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_utils.getInjectULBaseObject;

_utils.flowName;

_utils.variantParams;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dolphinContainer\" ng-if=\"showBanner\">\n    <section class=\"dolphinBanner {{ fixedBanner }}\" content>\n        <div class=\"dolphinBannerContent {{ variant }}\" ng-if=\"!isPhoneConfirmed\" ng-bind-html=\"htmlContent(bannerContent)\"></div>\n        <div class=\"dolphinBannerContent\" ng-if=\"isPhoneConfirmed\">\n            <span class=\"dolphinBannerSuccessIcon\"></span>\n            <span class=\"dolphinBannerSuccessContent\">{{ content(successContent) }}</p>\n        </div>\n        <div class=\"dolphinBannerCloseIcon\" ng-click=\"actions.closeBanner()\"></div>\n    </section>\n</div>\n<section ng-if=\"showOverlay\" class=\"pageOverlay\">\n    <div ng-if=\"!autoTriggeredOverlay\" class=\"overlayMask\"></div>\n    <div ng-if=\"autoTriggeredOverlay\" class=\"overlayAutoTriggerMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"actions.closeOverlay()\"></a>\n                <div id=\"injectedULPhoneConfirmation\"></div>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getDolphinEligibility = exports.variantParams = exports.flowName = exports.getInjectULBaseObject = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var getCreditInterstitialEligibility = function getCreditInterstitialEligibility() {
    // TODO: Refactor the usage of PXP result stored in rootScope once Credit team make a change to this
    var creditInterstitialPXPResult = _angular.$rootScope['creditInterstitialPXPResult'];
    var creditInterstitialControl = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_control';
    // If there is a value && it is not Control, then it's any of the treatments
    return creditInterstitialPXPResult && creditInterstitialPXPResult !== creditInterstitialControl;
};

var getInjectULBaseObject = exports.getInjectULBaseObject = function getInjectULBaseObject(variant) {
    var options = {
        config: {
            name: 'PPFrameRedirect',
            height: 577
        },
        queryParams: {
            intent: variant === 'add3' || variant === 'confirm3' ? 'xoAutoTrigger' : 'xoToast',
            flowId: _angular.$rootScope.token,
            flowInfo: _uiRouter.$state.current && _uiRouter.$state.current.name,
            'country.x': _squid.$locale.country,
            'locale.x': _squid.$locale.getLocaleCode()
        },
        iframePathname: '/signin/phone-confirmation',
        targetElement: document.getElementById('injectedULPhoneConfirmation')
    };

    return options;
};

var flowName = exports.flowName = 'ul_dolphin';

// A simple object to map all the properties specific to a particular variant
// Not creating a function & abstracting common things for the sake of simplicity
// Once the performance is measured, only 1 of the 4 variants will be left behind
// and this object will have only 2 props again.
// A variant prop is added to define the class name in the template
// The query param's value is not used directly to avoid XSS
var variantParams = exports.variantParams = {
    confirm: {
        messageKey: 'login.confirmPhone',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_link',
        // `variant` uses a hardcoded value for th ulToast query param
        // it is used later in the flow from here instead of the query param
        variant: 'confirm'
    },
    confirm1: {
        messageKey: 'login.confirmPhoneWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_button',
        variant: 'confirm1'
    },
    confirm2: {
        messageKey: 'login.confirmPhoneLongWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'long_text_button',
        variant: 'confirm2'
    },
    confirm3: {
        // There is no messageKey in this variant
        successKey: 'login.confirmPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'confirm_phone',
        bannerType: 'auto_trigger',
        variant: 'confirm3',
        autoTriggeredOverlay: true
    },
    add: {
        messageKey: 'login.addPhone',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_link',
        variant: 'add'
    },
    add1: {
        messageKey: 'login.addPhoneWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_button',
        variant: 'add1'
    },
    add2: {
        messageKey: 'login.addPhoneLongWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'long_text_button',
        variant: 'add2'
    },
    add3: {
        // There is no messageKey in this variant
        successKey: 'login.addPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'add_phone',
        bannerType: 'auto_trigger',
        variant: 'add3',
        autoTriggeredOverlay: true
    }
};

var getDolphinEligibility = exports.getDolphinEligibility = function getDolphinEligibility(stateName) {
    var isReviewOrFi = /checkout\.review|checkout\.selectFi/.test(stateName) && _squid.$util.param('ulToast');

    if (!isReviewOrFi) {
        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': 'not_ryp',
            'context_id': _angular.$rootScope.token
        });
        return _squid.$promise.resolve();
    }

    return _eligibility.$stickyCTA.instance().getEligibility()
    // Dolphin can be enabled only in case sticky & credit interstitial are not eligibile
    .then(function (isStickyEligible) {
        var eligibilityReason = 'no_sticky_or_credit';
        var isCreditInsterstialEligible = getCreditInterstitialEligibility();

        if (isCreditInsterstialEligible) {
            eligibilityReason = 'has_credit_interstitial';
        }

        if (isStickyEligible) {
            eligibilityReason = 'has_sticky';
        }

        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': eligibilityReason,
            'context_id': _angular.$rootScope.token
        });

        return !isStickyEligible && !isCreditInsterstialEligible;
    });
};

_angular.$rootScope;

_uiRouter.$state;

_squid.$locale;

_squid.$promise;

_squid.$util;

_logger.$logger;

_eligibility.$stickyCTA;

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ul = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

/**
 * Created by upigilam on 4/8/16.
 * UL handler is to exchange ST to RT exchanges.
 */

var $ul = exports.$ul = {

    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {

        return (0, _angular.$q)(function (resolve, reject) {

            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 10000;
            var ulTimeoutPromise = null;

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            function failureHandler(reason) {
                logSubmit({ errorCode: reason });
                _logger.$logger.info('UL_Loading_error_' + reason);
                return reject(new Error('UL_Loading_error_' + reason));
            }

            function startTimer(tag) {
                _logger.$logger.info('UL_START_TIMER_' + tag);
                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    failureHandler('timed_out');
                    if (!silent) {
                        _angular.$rootScope.$emit('loaded');
                    }
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                if (!silent) {
                    _angular.$rootScope.$emit('loaded');
                }
                _logger.$logger.info('UL_STOP_TIMER_' + tag);

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                    ulTimeoutPromise = null;
                }
            }

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    logSubmit();
                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.refresh_token = true;
                    });
                    return resolve();
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    failureHandler(data.event);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
                    // actions on the element which is causing excess spinners later.
                    var child = document.getElementById('ulTargetAttribute');
                    child.parentNode.removeChild(child);
                    stopTimer(data.event);
                    failureHandler(data.event);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('UL' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                if (!silent) {
                    _angular.$rootScope.$emit('loading');
                }

                var ulTargetAttribute = document.createElement('div');
                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
                // ulTargetAttribute.style.display = "None";

                // Making 0px, it works for FF, Chrome, Safari
                ulTargetAttribute.style.width = '0px';
                ulTargetAttribute.style.margin = '0px';
                ulTargetAttribute.style.height = '0px';
                ulTargetAttribute.style.padding = '0px';

                document.body.appendChild(ulTargetAttribute);

                var options = {
                    targetElement: document.getElementById('ulTargetAttribute'),
                    queryParams: {
                        'country.x': locale_country,
                        'locale.x': locale_code,
                        'flowId': token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                if (_config.$config.deploy.isLocal()) {
                    if (_config.$meta.stage) {
                        options.origin = 'https://' + _config.$meta.stage;
                    } else {
                        // if no stage url shows up then use any backup url for origin
                        options.origin = _config.$config.urls.onboarding.split('/webapps/')[0];
                    }
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUl');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        });
    }
};

// Loads unifiedLogin key on to PAYPAL window object


angular.value("$ul", $ul);
_angular.$rootScope;

_angular.$q;

_angular.$timeout;

_logger.$logger;

_config.$config;

_config.$meta;

_model.$CalDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/address/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ValidateAddressModel = exports.$PrefillAddressModel = exports.$AddressNormalizationModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddressNormalizationModel = exports.$AddressNormalizationModel = _squid.$Model.extend('$AddressNormalizationModel', {
    api: new _squid.$Api({
        uri: '/api/address/normalize'
    })
});

var $PrefillAddressModel = exports.$PrefillAddressModel = _squid.$Model.extend('$PrefillAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/prefill'
    })
});

var $ValidateAddressModel = exports.$ValidateAddressModel = _squid.$Model.extend('$ValidateAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/validate'
    })
});

angular.value("$AddressNormalizationModel", $AddressNormalizationModel);
angular.value("$PrefillAddressModel", $PrefillAddressModel);
angular.value("$ValidateAddressModel", $ValidateAddressModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPBlacklist = exports.$TokenizedWalletMsbOfferModel = exports.$TokenizedWalletPinModel = exports.$TokenizedFundingCapabilitiesModel = exports.$TokenizedWalletInfoModel = exports.$TokenizedWalletEligibilityModel = exports.$MessengerIntegrationDataModel = exports.$AppDataModel = exports.$LocaleConfigModel = exports.$PXPModel = exports.$TeslaFlowIdModel = undefined;

var _brandNames, _msbDisclaimerLinks;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $TeslaFlowIdModel = exports.$TeslaFlowIdModel = _squid.$Model.extend('$TeslaFlowIdModel', {
    api: new _squid.$Api({
        uri: '/api/teslaFlowId/:id'
    })
});

var $PXPModel = exports.$PXPModel = _squid.$Model.extend('$PXPModel', {
    api: new _squid.$Api({
        uri: '/api/pxp/:id'
    })
});

var $LocaleConfigModel = exports.$LocaleConfigModel = _squid.$Model.extend('$LocaleConfigModel', {
    api: new _squid.$Api({
        uri: '/api/localeConfig'
    })
});

var $AppDataModel = exports.$AppDataModel = _squid.$Model.extend('$AppDataModel', {
    api: new _squid.$Api({
        uri: '/api/app'
    }),

    isMobile: function isMobile() {
        return this.platform === 'mobile';
    }
});

var $MessengerIntegrationDataModel = exports.$MessengerIntegrationDataModel = _squid.$Model.extend('$MessengerIntegrationDataModel', {
    api: new _squid.$Api({
        uri: '/api/messenger'
    })
});

var $TokenizedWalletEligibilityModel = exports.$TokenizedWalletEligibilityModel = _squid.$Model.extend('$TokenizedWalletEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/eligibility/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    isEligible: function isEligible() {
        return this.eligible;
    }
});

var subjectTypes = {
    SAMSUNG_PAY: 'Samsung',
    ANDROID_PAY: 'google'
};

var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

/**
 * disclaimer links used on the *pay review page
 */
var disclaimerLinks = function disclaimerLinks(country) {
    var _ref;

    return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppsamsungpay-tnc', _ref[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppandroidpay-tnc', _ref;
};

// disclaimer links used on Msb offer popup
var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

/**
 * this model populates data from tokenized wallet mayfly object
 * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
 *
 * - wallet_id (used for both Samsung Pay and Android Pay)
 * - external_device_id (used for Samsung Pay only)
 * - subject (used for both Samsung Pay and Android Pay)
 *
 * Note: model is being populated in xo-preload on the server (see config.json)
 */

var $TokenizedWalletInfoModel = exports.$TokenizedWalletInfoModel = _squid.$Model.extend('$TokenizedWalletInfoModel', {

    api: new _squid.$Api({
        uri: '/api/info/tokenizedWallet/:id'
    }),

    isAndroidPay: function isAndroidPay() {
        return this.subject === subjectTypes.ANDROID_PAY;
    },

    isSamsungPay: function isSamsungPay() {
        return this.subject === subjectTypes.SAMSUNG_PAY;
    },

    getSubject: function getSubject() {
        return this.subject || subjectTypes.ANDROID_PAY;
    },

    // until we use mayfly for android pay - fallback to Android Pay
    brandName: function brandName() {
        return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
    },

    // until we use mayfly for android pay - fallback to Android Pay
    getDisclaimerLink: function getDisclaimerLink() {
        var country = _squid.$locale.country.toLowerCase();

        return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
    },

    // get Msb terms and conditions link based on the subject
    getMsbDisclaimerLink: function getMsbDisclaimerLink() {
        return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
    }
});

var $TokenizedFundingCapabilitiesModel = exports.$TokenizedFundingCapabilitiesModel = _squid.$Model.extend('$TokenizedFundingCapabilitiesModel', {
    api: new _squid.$Api({
        uri: '/api/capabilities/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true,

    isDirectFundingEnabled: function isDirectFundingEnabled() {
        return this.directFundingEnabled;
    },

    isTopupEnabled: function isTopupEnabled() {
        return this.topupFundingEnabled;
    },
    getProductName: function getProductName() {
        return this.name;
    },

    getCurrency: function getCurrency() {
        return this.issuingCurrency;
    },

    getContingencies: function getContingencies() {
        return this.contingencies;
    },

    getTopupAmountChoices: function getTopupAmountChoices() {
        return this.topUpAmountChoices;
    }
});

var $TokenizedWalletPinModel = exports.$TokenizedWalletPinModel = _squid.$Model.extend('$TokenizedWalletPinModel', {
    api: new _squid.$Api({
        uri: '/api/pin/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    getPinOrigin: function getPinOrigin() {
        return this.pinOrigin;
    },
    getSuggestedPin: function getSuggestedPin() {
        return this.suggestedPin;
    },
    getSuggestedKey: function getSuggestedKey() {
        return this.suggestedKey;
    },
    getPinId: function getPinId() {
        return this.pinId;
    },
    isPinIdPresent: function isPinIdPresent() {
        return !!this.pinId;
    },
    isSetupEligible: function isSetupEligible() {
        return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
    }
});

var $TokenizedWalletMsbOfferModel = exports.$TokenizedWalletMsbOfferModel = _squid.$Model.extend('$TokenizedWalletMsbOfferModel', {
    api: new _squid.$Api({
        uri: '/api/msb/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true
});

var $PXPBlacklist = exports.$PXPBlacklist = {
    isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
        return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
    }
};

angular.value("$TeslaFlowIdModel", $TeslaFlowIdModel);
angular.value("$PXPModel", $PXPModel);
angular.value("$LocaleConfigModel", $LocaleConfigModel);
angular.value("$AppDataModel", $AppDataModel);
angular.value("$MessengerIntegrationDataModel", $MessengerIntegrationDataModel);
angular.value("$TokenizedWalletEligibilityModel", $TokenizedWalletEligibilityModel);
angular.value("$TokenizedWalletInfoModel", $TokenizedWalletInfoModel);
angular.value("$TokenizedFundingCapabilitiesModel", $TokenizedFundingCapabilitiesModel);
angular.value("$TokenizedWalletPinModel", $TokenizedWalletPinModel);
angular.value("$TokenizedWalletMsbOfferModel", $TokenizedWalletMsbOfferModel);
angular.value("$PXPBlacklist", $PXPBlacklist);
_squid.$config;

_squid.$locale;

_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    })
});

var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    loggedIn: function loggedIn() {
        return this.logged_in;
    },

    visitorId: function visitorId() {
        return this.visitor_id;
    },

    accessToken: function accessToken() {
        return this.access_token;
    },

    accessTokenPresent: function accessTokenPresent() {
        return this.access_token_present;
    },

    refreshToken: function refreshToken() {
        return this.refresh_token;
    },

    rememberedOT: function rememberedOT() {
        return this.remembered && this.remembered_device_token;
    },

    isSessionTimeout: function isSessionTimeout() {
        return this.meta && this.meta.invalidated;
    },

    clearCookies: function clearCookies() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.action('clearCookies', { data: data });
    },

    showNotYou: function showNotYou() {
        var isAuthApiCall = this.is_auth_api_call;
        var isConsumerApp = _squid.$util.param('source') === 'consumerApp';
        var redirectToHermesOn3DSDecline = _squid.$util.param('redirectToHermesOn3DSDecline');
        var isUlReturnLoggedIn = _squid.$util.param('ulReturn') && this.auth_state === 'LOGGEDIN';

        // for Tokenized Venice integraion (Google Pay Venice / Samsung Pay Venice) - `not you` link should be hidden.
        // `TokenizedWalletInfoModel` is always populated in xo-preload (even for error cases - it will be just empty)
        // so we don't need to retrieve the model
        var tokenizedWalletInfo = _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token);
        var isNotVeniceTokenizedIntegration = function isNotVeniceTokenizedIntegration() {
            return !tokenizedWalletInfo || tokenizedWalletInfo && !tokenizedWalletInfo.is_venice_integration;
        };

        // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)
        return isAuthApiCall && !isConsumerApp && !redirectToHermesOn3DSDecline && !isUlReturnLoggedIn && !this.disallow_login_switch && isNotVeniceTokenizedIntegration();
    },

    logout: function logout() {
        _squid.$Model.bulkInvalidate('invalidateOnLogout');
        _angular.$rootScope.$broadcast('logout');
        return this.action('logout');
    },

    /**
     * Perform a logout and then redirect.
     * @param reason - used to log reason why a redirect was trigged.
     */
    logoutAndRedirect: function logoutAndRedirect() {
        var _this = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'logout';

        return this.logout().then(function () {
            return _this.redirectToLogin(reason);
        });
    },

    // redirect to UL as landing through xo-landing-router
    // so first it hits hermes app and then redirects to UL
    redirectToLogin: function redirectToLogin(reason, ctx) {
        if (!reason) {
            return false;
        }
        // current query parameters
        var qs = _squid.$util.queryString() || '';
        var params = { 'ulClientRedirect': reason };

        params = _squid.$util.extend(params, ctx); // update params with context that may be sent

        // insert "ulClientRedirect" param and remove "ul", "ulReturn"
        var updatedQs = _squid.$util.queryStringSplice(qs, params, ['ul', 'ulReturn']);

        // base url should not be hardcoded to "/webapps/hermes" due to other use cases such as
        // 1. * Pay (Android Pay / Samsung Pay) -- uses /agreements/setup to exchange BA token to EC token
        var ulAsLandingUrl = _squid.$util.paypalURL('' + window.location.pathname + updatedQs);

        _logger.$logger.info('redirecting_to_ulAsLanding');
        return _squid.$util.redirect(ulAsLandingUrl);
    }

});

var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
    api: new _squid.$Api({
        uri: '/api/auth/ulogin',
        postAttempts: 1,
        cache: false
    })
});

angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_angular.$rootScope;

_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/lib/xoAPayUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAPayUtils = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _jwtToken = '';
var _authenticated;

// Call browser PaymentRequest API that returns a promise
function createPaymentRequest() {
    var supportedInstruments = [{
        supportedMethods: ['https://android.com/pay'],
        data: {
            minGooglePlayServicesVersion: '10400000',
            paymentMethodTokenizationParameters: {
                tokenizationType: 'GATEWAY_TOKEN',
                parameters: {
                    gateway: 'paypal'
                }
            }
        }
    }];
    var details = {
        // Payment request requires an amount. Hardcode the value for now.
        total: { label: 'Checkout', amount: { currency: 'USD', value: '5.00' } }
    };

    var options = {};

    try {
        return new PaymentRequest(supportedInstruments, details, options); // eslint-disable-line no-undef
    } catch (e) {
        _logger.$logger.info('PAYMENT_REQUEST_NOT_SUPPORTED');
    }
}

function updateCookie(url, params) {
    (0, _angular.$http)({
        method: 'GET',
        url: url,
        params: params
    })['catch'](function (err) {
        _logger.$logger.info('tokenized_wallet_update_cookie_error', { err: err });
    });
}

function isPaymentRequestAPISupported() {
    var currentVersionMatch = navigator.userAgent.match(/Chrome\/([0-9]+)\./i);

    return _index.$DeviceInfo.isMobile() && window.navigator.vendor === 'Google Inc.' && 'PaymentRequest' in window && navigator.userAgent.match(/Android/i) && currentVersionMatch && Number(currentVersionMatch[1]) >= 58;
}

var $xoAPayUtils = exports.$xoAPayUtils = {
    isAPayAPISupported: function isAPayAPISupported() {
        return isPaymentRequestAPISupported();
    },

    canMakeAPayPayment: function canMakeAPayPayment() {
        if (!isPaymentRequestAPISupported()) {
            return _angular.$q.resolve(false);
        }

        var paymentRequest = window.appPaymentRequest || createPaymentRequest();

        if (paymentRequest && paymentRequest.canMakePayment) {
            _logger.$logger.info('APAY_CHECK_CAN_MAKE_PAYMENT');
            _logger.$logger.info('checkout_fpti', {
                from: 'payment_request_check_payment',
                to: 'prepare_payment_request_check_payment'
            });

            return paymentRequest.canMakePayment().then(function (result) {
                if (result) {

                    _logger.$logger.info('APAY_CAN_MAKE_PAYMENT');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'payment_request_check_payment',
                        to: 'process_payment_request_can_make_payment'
                    });
                    return true;
                } else {
                    _logger.$logger.info('APAY_CAN_NOT_MAKE_PAYMENT_NO_PAYMENT');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'payment_request_can_make_payment',
                        to: 'process_payment_request_can_not_make_payment',
                        error_source: 'PaymentRequestAPI',
                        error_type: 'no_payment'

                    });
                    return false;
                }
            })['catch'](function (err) {
                _logger.$logger.info('APAY_CAN_NOT_MAKE_PAYMENT_SOFT_DECLINE', {
                    msg: err && err.message,
                    name: err && err.name
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'payment_request_can_make_payment',
                    to: 'prepare_payment_request_can_make_payment_soft_decline',
                    int_error_code: err && err.name,
                    int_error_description: err && err.message,
                    error_source: 'PaymentRequestAPI',
                    error_type: 'soft_decline'
                });

                return false;
            });
        } else {
            return _angular.$q.resolve(false);
        }
    },

    authenticateAPay: function authenticateAPay() {
        var forceAuthenticate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!forceAuthenticate && _authenticated !== undefined) {
            return _angular.$q.resolve(_authenticated);
        }

        _authenticated = false;
        _jwtToken = '';

        // Do not proceed if PaymentRequest is not supported.
        if (!isPaymentRequestAPISupported()) {
            return _angular.$q.resolve(false);
        }

        var paymentRequest = window.appPaymentRequest || createPaymentRequest();

        if (paymentRequest) {
            _logger.$logger.info('APAY_AUTHENTICATION_BEGIN');
            _logger.$logger.info('checkout_fpti', {
                from: 'payment_request_auth',
                to: 'prepare_payment_request_auth'
            });

            return paymentRequest.show().then(function (result) {
                result.complete('success');

                _logger.$logger.info('APAY_AUTHENTICATION_SUCCEEDED');
                _logger.$logger.info('checkout_fpti', {
                    from: 'payment_request_auth',
                    to: 'process_payment_request_auth',
                    param_type: 'JWT'
                });

                var paymentMethodToken = result.details && result.details.paymentMethodToken && JSON.parse(result.details.paymentMethodToken);

                _jwtToken = paymentMethodToken.authJwt;
                _authenticated = true;
                return true;
            })['catch'](function (err) {
                _logger.$logger.info('APAY_AUTHENTICATION_FAILED', {
                    msg: err && err.message,
                    name: err && err.name
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'payment_request_auth',
                    to: 'process_payment_request_auth',
                    int_error_code: err && err.name,
                    int_error_description: err && err.message,
                    error_source: 'PaymentRequestAPI',
                    error_type: 'soft_decline'

                });

                return false;
            });
        } else {
            return _angular.$q.resolve(false);
        }
    },

    getAPayAuthToken: function getAPayAuthToken() {
        return _jwtToken;
    },

    setAPayCookie: function setAPayCookie(token) {
        if (_squid.$config.tokenizedWalletCookieURL) {
            updateCookie(_squid.$config.tokenizedWalletCookieURL, {
                op: 'set',
                token: token
            });
        }
    },

    clearAPayCookie: function clearAPayCookie(token) {
        if (_squid.$config.tokenizedWalletCookieURL) {
            updateCookie(_squid.$config.tokenizedWalletCookieURL, {
                op: 'clear',
                token: token
            });
        }
    },

    setOTAPayCookie: function setOTAPayCookie(token) {
        if (_squid.$config.tokenizedWalletCookieURL) {
            updateCookie(_squid.$config.tokenizedWalletCookieURL, {
                op: 'setot',
                token: token
            });
        }
    }
};

angular.value("$xoAPayUtils", $xoAPayUtils);
_angular.$http;

_angular.$q;

_logger.$logger;

_squid.$config;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CheckoutSessionModel = exports.$CardBackupModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.serializeInstallmentsOptionsData = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _processorDecline = __webpack_require__("../node_modules/xo-models/src/processorDecline/index.js");

var _utils = __webpack_require__("../node_modules/xo-models/src/checkout/lib/utils.js");

var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    isPurchase: function isPurchase() {
        return Boolean(this.purchase);
    },

    getCartCurrencyCode: function getCartCurrencyCode() {
        return _squid.$util.getProperty(this, 'purchase.amounts.total.currency_code');
    },

    // NOTE returns undefined if this is not a purchase or there is some other error
    getPurchaseAmount: function getPurchaseAmount() {
        if (!this.isPurchase()) {
            return;
        }
        var purchaseAmount = _squid.$util.getProperty(this, 'purchase.amounts.total.amount');
        var purchaseAmountFloat = parseFloat(purchaseAmount);

        return purchaseAmountFloat || undefined;
    },

    isBilling: function isBilling() {
        return Boolean(this.billing);
    },

    isSubscriptionsV1: function isSubscriptionsV1() {
        return this.isBilling() && this.billing.type === 'SUBSCRIPTIONS_V1';
    },

    getBaToken: function getBaToken() {
        return this.isBilling() && this.billing.ba_token;
    },

    isBillingPurchase: function isBillingPurchase() {
        return this.isPurchase() && this.isBilling();
    },

    isBillingNoPurchase: function isBillingNoPurchase() {
        return this.isBilling() && !this.isPurchase();
    },

    getBillingDescription: function getBillingDescription() {
        return this.billing && this.billing.description;
    },

    isMultiSellerPurchase: function isMultiSellerPurchase() {
        return this.purchaseUnits && this.purchaseUnits.length > 1;
    },

    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
        return this.isPurchase() && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
    },

    isWalletTokenization: function isWalletTokenization() {
        return this.isBilling() && this.billing.intent === 'TOKENIZED_WALLET';
    },

    getExternalCallbackOptions: function getExternalCallbackOptions() {
        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
    }
});

var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/appData'
    }),

    useraction: function useraction() {
        // user_action from session takes precedence over CGI param.
        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;

        return rest_integration || incontext_integration || _squid.$util.param('useraction');
    },

    is_wps_flow: function is_wps_flow() {
        return this.flags && this.flags.is_wps_flow;
    },

    is_snt_supported: function is_snt_supported() {
        return this.flags && this.flags.is_snt_supported;
    },

    doec_on_approve: function doec_on_approve() {
        return this.flags && this.flags.doec_on_approve;
    },

    is_wps_subscription_flow: function is_wps_subscription_flow() {
        return this.flags && this.flags.is_wps_subscription_flow;
    },

    /*
     * Returns a string or undefined value
     * nonEmptyReturnValue - if true, then always return non empty string
     * isSentenceBeginning - if true, and merchant brand_name and merchant_name is undefined
     *              then returns 'The merchant'. If false, returns 'the merchant'
     * NOTE: We should not return merchant_email for any reason as it is a PII
     */
    getMerchantDisplayName: function getMerchantDisplayName() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            nonEmptyReturnValue = _ref.nonEmptyReturnValue,
            isSentenceBeginning = _ref.isSentenceBeginning,
            getContent = _ref.getContent;

        var merchantName = this.merchant.brand_name || this.merchant.merchant_name;

        if (nonEmptyReturnValue) {
            var contentKey = isSentenceBeginning ? 'common.Themerchant' : 'common.themerchant';
            var merchantAltName = getContent ? getContent(contentKey) : _squid.$locale.content.get(contentKey);

            return merchantName || merchantAltName;
        }

        return merchantName;
    },

    isInvoiceFlow: function isInvoiceFlow() {
        return Boolean(this.flags && this.flags.is_invoice_flow);
    },


    // Returns true if flow should be treated as a second button (PP Credit) transaction
    isSecondButton: function isSecondButton() {
        return this.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
    }
});

var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {

    formatLast4: function formatLast4() {
        var last4;

        if (this.last4) {
            last4 = this.last4;

            if (!this.parent.isAuthRequired) {
                last4 = 'x-' + last4;
            }
        }

        return last4;
    }
});

var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/fundingOptions',
        postAttempts: 2
    }),

    eachPlan: function eachPlan(method, context) {
        angular.forEach(this.plans, method, this);
    },

    hasECheck: function hasECheck() {
        var _instruments = this.instruments,
            instruments = _instruments === undefined ? [] : _instruments;


        return instruments.some(function (instr) {
            return instr.type === 'ECHECK' || instr.subtype === 'ECHECK';
        });
    },

    hasCredit: function hasCredit() {
        var _instruments2 = this.instruments,
            instruments = _instruments2 === undefined ? [] : _instruments2;


        return instruments.some(function (instrument) {
            return instrument.type === 'CREDIT';
        });
    },

    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
        });

        return fundingInstrument && fundingInstrument.planId;
    },

    // get IACH and PAD banks combined by plan.primaryFs.id
    // order matters, so if IACH comes first then PAD is filtered and vise versa
    getPadAndIachCombinedPlans: function getPadAndIachCombinedPlans() {
        var _this = this;

        var plans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.plans;

        if (!plans) {
            return [];
        }
        var planIds = {};

        plans.forEach(function (plan) {
            var planId = plan.planId,
                primaryFs = plan.primaryFs;


            if (_this.isIACH(plan) && !planIds[planId]) {
                planIds[primaryFs.padPlanId] = true;
            }
            if (_this.isPAD(plan) && !planIds[planId]) {
                planIds[primaryFs.iachPlanId] = true;
            }
        });

        return plans.filter(function (plan) {
            return !planIds[plan.planId];
        });
    },

    // get plan by planId
    getPlanByPlanId: function getPlanByPlanId(id) {
        var plan = _squid.$util.find(this.plans, function (p) {
            return p.primaryFs && p.planId === id;
        });

        return plan;
    },

    getPlanSubType: function getPlanSubType() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _plan$primaryFs = plan.primaryFs;
        _plan$primaryFs = _plan$primaryFs === undefined ? {} : _plan$primaryFs;
        var subtype = _plan$primaryFs.subtype;


        return subtype;
    },


    // is plan PAD bank (bank is charged after some delay)
    isPAD: function isPAD(plan) {
        return this.getPlanSubType(plan) === 'PAD';
    },


    // is plan IACH bank (instant transfer)
    isIACH: function isIACH(plan) {
        return this.getPlanSubType(plan) === 'IACH';
    },


    // is plan MEFT bank
    isMEFT: function isMEFT(plan) {
        return this.getPlanSubType(plan) === 'MEFT';
    },


    // is plan IACH bank (instant transfer)
    isIACHWithPad: function isIACHWithPad(plan) {
        return this.isIACH(plan) && plan.primaryFs.padPlanId;
    },

    // get PAD hop date (when bank will be charged) based on selected plan and PAD toggle state
    getPadPlanHopDate: function getPadPlanHopDate(plan) {
        if (this.isIACH(plan)) {
            var padPlan = this.getPlanByPlanId(plan.primaryFs.padPlanId);

            if (padPlan) {
                return padPlan.primaryFs.hop_date;
            }
        } else {
            return plan.primaryFs.hop_date;
        }
    },

    // get PAD or IACH plan id based on selected plan and PAD toggle state
    getPadOrIachPlanIdBySelectedPlan: function getPadOrIachPlanIdBySelectedPlan(_ref2) {
        var plan = _ref2.plan,
            isPadToggleSelected = _ref2.isPadToggleSelected;

        if (!plan || !plan.primaryFs) {
            return;
        }

        var _plan$primaryFs2 = plan.primaryFs,
            padPlanId = _plan$primaryFs2.padPlanId,
            iachPlanId = _plan$primaryFs2.iachPlanId,
            planId = plan.planId;


        if (isPadToggleSelected) {
            return this.isPAD(plan) ? planId : padPlanId;
        } else {
            return this.isIACH(plan) ? planId : iachPlanId;
        }
    },

    onPopulate: function onPopulate() {
        var self = this;

        angular.forEach(this.plans, function (plan) {
            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
                    enumerable: true,
                    configurable: false,
                    writeable: false,
                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
                });
            }
        });
    },

    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(fsId, fsSubtype) {
        var bankPadPlan = _squid.$util.find(this.plans, function () {
            var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _plan$primaryFs3 = plan.primaryFs;
            _plan$primaryFs3 = _plan$primaryFs3 === undefined ? {} : _plan$primaryFs3;
            var id = _plan$primaryFs3.id,
                type = _plan$primaryFs3.type,
                subtype = _plan$primaryFs3.subtype;


            return id === fsId && type === 'BANK' && subtype === fsSubtype;
        });

        if (!bankPadPlan) {
            return;
        }

        var _bankPadPlan$primaryF = bankPadPlan.primaryFs;
        _bankPadPlan$primaryF = _bankPadPlan$primaryF === undefined ? {} : _bankPadPlan$primaryF;
        var subtype = _bankPadPlan$primaryF.subtype,
            padPlanId = _bankPadPlan$primaryF.padPlanId,
            iachPlanId = _bankPadPlan$primaryF.iachPlanId;


        return subtype === 'IACH' ? padPlanId : iachPlanId;
    },


    isPadToggleApplicable: function isPadToggleApplicable() {
        var padToggleApplicable = false;

        this.eachPlan(function (plan) {
            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
                }
            }
        }, this);

        return padToggleApplicable;
    },

    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
        var padToggleApplicable = false;
        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
            return plan.planId === planId;
        });

        if (selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
            padToggleApplicable = true;
        }

        return padToggleApplicable;
    },

    getPreferred: function getPreferred() {
        var _this2 = this;

        return _squid.$util.find(this.plans, function (plan) {
            return _this2.isPreferred(plan);
        });
    },

    isPreferred: function isPreferred() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.isPAD(plan)) {
            // if the current plan is PAD -> find corresponding IACH plan to see if it's preferred
            var iachPlan = this.getPlanByPlanId(plan.primaryFs.iachPlanId) || {};
            var _iachPlan$primaryFs = iachPlan.primaryFs;
            _iachPlan$primaryFs = _iachPlan$primaryFs === undefined ? {} : _iachPlan$primaryFs;

            var _iachPlan$primaryFs$i = _iachPlan$primaryFs.isPreferred,
                _isPreferred = _iachPlan$primaryFs$i === undefined ? false : _iachPlan$primaryFs$i;

            return _isPreferred;
        }

        var _plan$primaryFs4 = plan.primaryFs;
        _plan$primaryFs4 = _plan$primaryFs4 === undefined ? {} : _plan$primaryFs4;
        var _plan$primaryFs4$isPr = _plan$primaryFs4.isPreferred,
            isPreferred = _plan$primaryFs4$isPr === undefined ? false : _plan$primaryFs4$isPr;


        return isPreferred;
    },

    // get Merchant specific balance by plan id
    getMsbByPlanId: function getMsbByPlanId(planId) {
        var plan = this.getPlanByPlanId(planId);

        return plan && plan.incentive;
    },

    /**
     * Avoid plans that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayPlans: function getDisplayPlans() {
        // return type should be undefined in no plans
        // for billing agreement use case
        return this.plans ? this.plans.filter(function (plan) {
            return !plan.rewards;
        }) : this.plans;
    },
    /**
     * Avoid instruments that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayInstruments: function getDisplayInstruments() {
        var _instruments3 = this.instruments,
            instruments = _instruments3 === undefined ? [] : _instruments3;


        return instruments.filter(function (instrument) {
            return instrument.type !== 'REWARDS';
        });
    }
});

// Map the data needed for the installmentsOptions endpoint
var serializeInstallmentsOptionsData = exports.serializeInstallmentsOptionsData = function serializeInstallmentsOptionsData(_ref3) {
    var merchant_country = _ref3.checkoutAppData.merchant.merchant_country,
        checkoutCart = _ref3.checkoutCart,
        country = _ref3.country,
        id = _ref3.payee.merchant.id,
        isMemberCredit = _ref3.isMemberCredit,
        cc = _ref3.cc;

    var payload = {
        checkoutAppData: {
            merchant: {
                merchant_country: merchant_country
            }
        },
        checkoutCart: {},
        country: country,
        payee: {
            merchant: {
                id: id
            }
        },
        isMemberCredit: isMemberCredit,
        cc: cc
    };

    if (checkoutCart.purchase && checkoutCart.purchase.amounts) {
        var _checkoutCart$purchas = checkoutCart.purchase.amounts.total,
            amount = _checkoutCart$purchas.amount,
            currency_code = _checkoutCart$purchas.currency_code;


        payload.checkoutCart.purchase = {
            amounts: {
                total: {
                    amount: amount,
                    currency_code: currency_code
                }
            }
        };
    }

    return payload;
};

var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    save: function save(options) {
        options.data = serializeInstallmentsOptionsData(options.data);

        return this._super.save.call(this, options);
    }
});

var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/flowEligibility'
    })
});

var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:parent.id/shipping/:id'
    })
});

var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping/add'
    }),

    serialize: function serialize() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            recipient_name: this.recipient_name,
            line1: this.line1,
            line2: this.line2,
            city: this.city,
            state: this.state,
            postal_code: this.postal_code,
            country: this.country
        };
    }
});

var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/payee'
    }),

    getId: function getId() {
        return this.merchant && this.merchant.id;
    },

    isGambling: function isGambling() {
        return this.merchant && this.merchant.isGambling;
    },

    isOnBaNoStickyList: function isOnBaNoStickyList() {
        var merchantId = this.getId();

        return merchantId && _squid.$config.disableMerchantForStickyBA && _squid.$config.disableMerchantForStickyBA.indexOf(merchantId) > -1;
    }
});

var creditOptionsModel = {
    largeEligibleAmount: {
        US: 99,
        GB: 150
    }
};

// keeping sacEligibleAmount available for backwards compat, largeEligibleAmount preferred
creditOptionsModel.sacEligibleAmount = creditOptionsModel.largeEligibleAmount;

var $CreditOptionsModel = exports.$CreditOptionsModel = creditOptionsModel;

var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
    },

    getPreferredShippingAddress: function getPreferredShippingAddress() {
        var preferredAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.preferred_address) {
                    preferredAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return preferredAddress;
    },

    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
        var primaryAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.primary_address) {
                    primaryAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return primaryAddress;
    }
});

var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {

    onPopulate: function onPopulate() {
        this.sources = this.children($FundingSourceModel, this.sources);
    },

    eachSource: function eachSource(method, context) {
        angular.forEach(this.sources, method, this);
    },

    hasFundingMethodType: function hasFundingMethodType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.sub_type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    isPAD: function isPAD() {
        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
    },

    isIACH: function isIACH() {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
                found = true;
            }
        }, this);

        return found;
    },

    isSplitBalance: function isSplitBalance() {
        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE');
    },

    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
        return this.isSplitBalance() && this.isIACH();
    },

    isMSB: function isMSB() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
    },

    isBalance: function isBalance() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
    },

    hasConversion: function hasConversion() {
        return this.conversion !== null && _typeof(this.conversion) === 'object';
    }
});

var $CardBackupModel = exports.$CardBackupModel = _squid.$Model.extend('$CardBackupModel', {
    onPopulate: function onPopulate() {
        if (!this.get('parent.meta.populated')) {
            return;
        }

        // If plan IDs change, we need to reevaluate the correct backup plan id
        this.resetIfDoesNotApply();
        this.reevaluateEligibility();
    },


    /**
     * getCardBackupInstrument
     * Get the user's last selection for card backup, if still eligible
     * @returns {Object|undefined} the plan of the user's last selection, or undefined otherwise
     */
    getPlan: function getPlan() {
        if (!this.isAllowed()) {
            return;
        }

        return this.plan;
    },


    /**
     * setCardBackupInstrument
     * Save the user's selection for backup. Tied to the currently selected plan
     * @param {Object} plan - the plan to use as the backup
     * @param {Object} [forPlan] - if needed, the plan to compare against. prefer not to pass it in
     */
    setPlan: function setPlan(plan, forPlan) {
        this.plan = plan;
        this.forPlan = forPlan || this.getCheckoutSessionPlan();
    },
    isAllowed: function isAllowed() {
        var _forPlan = this.forPlan;
        _forPlan = _forPlan === undefined ? {} : _forPlan;
        var _forPlan$primaryFs = _forPlan.primaryFs;
        _forPlan$primaryFs = _forPlan$primaryFs === undefined ? {} : _forPlan$primaryFs;
        var type = _forPlan$primaryFs.type,
            secondaryFIs = _forPlan.secondaryFIs;


        if (type !== 'CARD' || secondaryFIs !== false) {
            return false;
        }
        return this.allowCardBackup;
    },
    getCheckoutSessionPlan: function getCheckoutSessionPlan() {
        return this.get('parent.fundingOptions.plans.0');
    },
    reevaluateEligibility: function reevaluateEligibility() {
        var _this3 = this;

        (0, _processorDecline.getProcessorDeclineRetryEligibility)(this.id, this.parent).then(function (eligibility) {
            _this3.allowCardBackup = eligibility;

            return eligibility;
        });
    },
    reset: function reset(forPlan) {
        this.setPlan(undefined, forPlan);
    },

    /**
     * resetIfDoesNotApply
     * resets the selected backup for card if no longer valid based on user's choice
     * matches the plan ID if still valid but plan IDs change
     * @param {String} [plan] - current checkout session funding options plan user has selected
     */
    resetIfDoesNotApply: function resetIfDoesNotApply(plan) {
        if (!plan) {
            plan = this.getCheckoutSessionPlan();
        }

        var getKey = function getKey(p) {
            return p && p.primaryFs && p.primaryFs.id;
        };
        var planKey = getKey(plan);
        var forKey = getKey(this.forPlan);

        if (!planKey || planKey !== forKey) {
            return this.reset(plan);
        }

        // Since planIds may change, if backup is still valid then find the new plan
        var plans = this.get('parent.fundingOptions.plans') || [];
        var currentPlanKey = getKey(this.plan);
        var newPlan = currentPlanKey && plans.find(function (p) {
            return getKey(p) === currentPlanKey;
        });

        // If, for whatever reason, the old instrument isn't in the new plans, we'll reset
        if (currentPlanKey && !newPlan) {
            return this.reset(plan);
        }

        this.forPlan = plan;
        this.plan = newPlan;
    }
});

var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/session',
        postAttempts: 2
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    smartDollarAuthFailed: false, // initial value for smartDollar authorization check

    onPopulate: function onPopulate() {
        this.plan = new $CheckoutPlanModel(this.plan);
        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);

        // Reevaluate the eligibility for allowing backup with cards. This can
        // change when the checkout session is updated
        this.cardBackup = this.child($CardBackupModel, this.cardBackup || {});
        _squid.$event.emit('checkoutSessionChange'); // emit a session change event for apps to react accordingly
    },

    /**
     * Finds the plan in billing cases that the user is intending to use as the sticky FI.
     * @return {Object} the instrument representation from futurePaymentInstruments
     */
    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
        // This method doesn't apply for non-billing cases
        if (!this.futurePaymentInstruments) {
            return;
        }

        // For BA no purchase cases (no plan), use either
        // 1. selectedFuturePaymentInstrument (we've made and persisted a selection)
        // 2. first of futurePaymentInstruments (we haven't made a selection and need to save it later)
        if (!(this.plan && this.plan.sources)) {
            return this.selectedFuturePaymentInstrument || this.futurePaymentInstruments[0];
        }

        // Otherwise, if we have a plan list (ie. this is a purchase case),
        // we'll always want to take the currently selected plan,
        // as selectedFuturePaymentInstrument may not be updated to the user's current plan
        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
            return fi.instrument_id ? fi.instrument_id : undefined;
        });

        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
            return fi.instrument_id === selectedInstrumentId;
        });

        return stickyInstrument;
    },

    getPlanList: function getPlanList() {
        // Only show plans that need to be shown.
        return this.fundingOptions && this.fundingOptions.getDisplayPlans();
    },

    // returns true if more than one plan uses BALANCE as the primary FI
    isMultipleBalancePlan: function isMultipleBalancePlan() {
        var matchingBalancePlans = 0;

        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
            // if BALANCE is the primary FI...
            if (plan.primaryFs.name === 'BALANCE') {
                // increment number of balance plans found
                matchingBalancePlans++;
            }
            // exit once we have more than one balance plan
            return matchingBalancePlans > 1;
        });
    },

    getDisallowedInstruments: function getDisallowedInstruments() {
        if (this.fundingOptions && this.fundingOptions.disallowedInstruments && angular.isArray(this.fundingOptions.disallowedInstruments)) {
            var filteredDisallowedInstruments = this.fundingOptions.disallowedInstruments.filter(function (instrument) {
                if (instrument.type === 'CARD' && instrument.declineReason === 'unsupportedDueToExpiration') {
                    return (0, _utils.filterCardWithinLastNMonths)(instrument, (0, _squid.$feature)('expirePeriod'));
                }
                return true;
            });
            this.fundingOptions.disallowedInstruments = filteredDisallowedInstruments;
        }
        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
    },

    getDisallowedPreferred: function getDisallowedPreferred() {
        var disallowedInstrument = this.getDisallowedInstruments();

        // find only the disallowed instrument that has been marked as preferred.
        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
            return fi.isPreferred;
        });

        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
        // we do not show it in the disallowed section.
        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
            var instrumentID = plan.primaryFs && plan.primaryFs.id;

            if (instrumentID && disallowedInstrument.id) {
                return instrumentID === disallowedInstrument.id;
            } else {
                return false;
            }
        });

        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
    },

    expiredInstruments: function expiredInstruments() {
        var expiredInstruments = [];
        var disallowedPreferred = this.getDisallowedPreferred();
        var disallowedInstruments = this.getDisallowedInstruments();

        if (disallowedPreferred) {
            expiredInstruments.push(disallowedPreferred);
        }

        _squid.$util.forEach(disallowedInstruments, function (instrument) {
            if (instrument.type === 'CARD' && !instrument.isPreferred && instrument.declineReason === 'unsupportedDueToExpiration') {
                expiredInstruments.push(instrument);
            }
        });

        return expiredInstruments;
    },

    preferredExpiredInstruments: function preferredExpiredInstruments() {
        var disallowedPreferred = this.getDisallowedPreferred();

        if (disallowedPreferred && disallowedPreferred.type === 'CARD' && disallowedPreferred.isPreferred && disallowedPreferred.declineReason === 'unsupportedDueToExpiration') {
            return true;
        }

        return false;
    },

    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
        return {
            'line1': this.shipping.line1,
            'line2': this.shipping.line2,
            'city': this.shipping.city,
            'state': this.shipping.state,
            'postal_code': this.shipping.postal_code,
            'country_code': this.shipping.country
        };
    },

    getPPCconversionInfo: function getPPCconversionInfo() {
        var ppcFi = void 0;
        if (this.fundingOptions && this.fundingOptions.instruments) {
            ppcFi = this.fundingOptions.instruments.find(function (fi) {
                return fi.type === 'CREDIT' && fi.name === 'BILL_ME_LATER';
            });
        }
        if (ppcFi && ppcFi.currency_conversion) {
            return Object.assign({}, ppcFi.currency_conversion);
        }
        return null;
    }

});

angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("serializeInstallmentsOptionsData", serializeInstallmentsOptionsData);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CardBackupModel", $CardBackupModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Class;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$event;

_squid.$feature;

_processorDecline.getProcessorDeclineRetryEligibility;

_utils.filterCardWithinLastNMonths;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/lib/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
* @param {Date} d1
* @param {Date} d2
* @returns {number}
*/
var monthDiff = function monthDiff(d1, d2) {
    var months = void 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth() + 1;
    return months <= 0 ? 0 : months;
};

/**
* @param {Object} fi - A funding instrument
* @param {boolean} expiredPeriod - feature boolean flag from config.json
* @returns {boolean}
*/
var filterCardWithinLastNMonths = function filterCardWithinLastNMonths(fi, expirePeriod) {
    var expire_year = fi.expire_year,
        expire_month = fi.expire_month;


    var expiryDate = new Date(expire_year + '-' + expire_month + '-01');

    var monthDifference = monthDiff(expiryDate, new Date());

    return monthDifference !== 0 && monthDifference <= expirePeriod;
};

exports.filterCardWithinLastNMonths = filterCardWithinLastNMonths;

/***/ }),

/***/ "../node_modules/xo-models/src/eligibility/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$stickyCTA = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var checkEligibility = function checkEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return _squid.$promise.all([(0, _squid.$populate)(models, {
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
        checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
    }), _gdprCookieBanner.$GDPRCookieBannerModel.instance().hasBanner()]).then(function () {
        // Device Checks
        var userAgent = _angular.$window.navigator.userAgent;
        var isIE = !!userAgent.match(/MSIE|trident|edge/i);
        var isMobile = _index.$DeviceInfo.isMobile();
        var miniBrowser = _angular.$rootScope.miniBrowser;
        var isValidTraffic = isMobile || miniBrowser;
        var isSmallScreen = _angular.$window.innerWidth <= 600;

        // Flow Checks
        var billing = models.checkoutCartModel.isBilling();
        var invoice = models.checkoutAppDataModel.get('flags.is_invoice_flow');
        var upop = models.checkoutSessionModel.unconfirmed_upop;
        var gpdr = _gdprCookieBanner.$GDPRCookieBannerModel.instance().shown();

        // Feature checks
        var eligibleCountry = (0, _squid.$feature)('stickyCTA');
        var ineligibilityConditions = {
            isIE: isIE,
            upop: upop,
            invoice: invoice,
            gpdr: gpdr,
            billing: billing,
            isNotSmallScreen: !isSmallScreen,
            isNotValidTraffic: !isValidTraffic,
            isNotEligibleCountry: !eligibleCountry
        };

        var decision = isValidTraffic && eligibleCountry && isSmallScreen && !billing && !invoice && !upop && !isIE && !gpdr;

        var ineligibilityReasons = Object.keys(ineligibilityConditions).filter(function (key) {
            return ineligibilityConditions[key];
        });
        var eligibility_reason = 'eligible';

        if (ineligibilityReasons.length > 0 || !decision) {
            eligibility_reason = 'ineligible-' + ineligibilityReasons.join(',');
        }
        _logger.$logger.info('checkout_fpti', {
            from: 'sticky_cta',
            to: 'process_eligibility_check',
            eligibility_reason: eligibility_reason
        });

        return decision;
    });
};

var checkPxp = function checkPxp() {
    var _$CheckoutAppDataMode = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        merchant = _$CheckoutAppDataMode.merchant;

    var country = merchant && merchant.merchant_country;

    return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_sticky_cta_(.*)', false, true).then(function (treatment) {
        if (treatment) {
            var test = /xo_hermesnode_sticky_cta_(.*)/g;
            var name = treatment && treatment.treatment_name;
            var treatmentTest = test.exec(name);
            var treatmentName = treatmentTest.length > 1 && treatmentTest[1];

            _logger.$logger.info('checkout_fpti', {
                from: 'sticky_cta',
                to: 'process_pxp_check',
                eligibility_reason: treatmentName
            });
            return treatmentName;
        }
        return '';
    });
};

var mapper = function mapper(eligibility, treatment) {
    var variant = {
        'treatmentA': 'bottom',
        'treatmentB': 'top',
        'control': '',
        'DEFAULT': ''
    };
    var result = variant[treatment] || variant.DEFAULT;

    _logger.$logger.info('checkout_fpti', {
        from: 'sticky_cta',
        to: 'process_variant_check',
        eligibility_reason: result || 'ineligible'
    });
    return result;
};

/**
 * To be replaced by $EligibilityClass.
 * Following new EligibilityClass pattern.
*/
var $stickyCTA = exports.$stickyCTA = _squid.$Model.extend('$stickyCTA', {
    getEligibility: function getEligibility() {
        return checkEligibility().then(function (eligibility) {
            if (eligibility) {
                return checkPxp().then(function (treatment) {
                    return mapper(eligibility, treatment);
                });
            } else {
                return '';
            }
        });
    }
});

angular.value("$stickyCTA", $stickyCTA);
_angular.$rootScope;

_angular.$window;

_logger.$logger;

_squid.$Model;

_squid.$populate;

_squid.$pxp;

_squid.$feature;

_squid.$promise;

_index.$DeviceInfo;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_gdprCookieBanner.$GDPRCookieBannerModel;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardInfoModel = exports.$WalletInstrumentNameMapping = exports.$WalletPreferences = exports.$ResolveOTP = exports.$Resolve3DS = exports.$CardTypeFromBinModel = exports.$BillingAddressesModel = exports.$CurrencyConversionModel = exports.$BillingAddressModel = exports.$AddBillingAddressModel = exports.$DeleteCardModel = exports.$SepaModel = exports.$PreferredFi = exports.$AddBankModel = exports.$BankModel = exports.$CardTypesModel = exports.$UnavailableCardModel = exports.$AddCardModel = exports.$CardModel = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILLING_ADDRESS_FORMAT = {
    DEFAULT: {
        ',': ', ',
        ' ': ' '
    },
    IL: {
        he: {
            ',': '‏, ‏',
            ' ': '‏ ‏'
        }
    }
};

var $CardModel = exports.$CardModel = _squid.$Model.extend('$CardModel', {
    serialize: function serialize() {
        return {
            type: this.type,
            number: this.number.replace(/[^\d]+/g, ''),
            security_code: this.security_code,
            expiry_month: this.expiry_month && _squid.$util.pad(this.expiry_month, 2),
            expiry_year: this.expiry_year,
            issue_number: this.issue_number ? this.issue_number : undefined,
            start_month: this.start_month ? _squid.$util.pad(this.start_month, 2) : undefined,
            start_year: this.start_year ? this.start_year : undefined
        };
    },

    last4: function last4() {
        var cardNumber = this.number;

        return cardNumber.substr(cardNumber.length - 4);
    },

    isExisting: function isExisting() {
        return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
    }
});

var $AddCardModel = exports.$AddCardModel = _squid.$Model.extend('$AddCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id?'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.card = new $CardModel();
    },

    serialize: function serialize() {
        var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;

        return {
            cardType: this.cardType ? this.cardType : 'creditCard',
            sponsor_id: this.sponsor_id,
            preference: this.preference,
            user: this.user,
            card: this.card.serialize(),
            address: id ? {
                id: id
            } : this.address.serialize()
        };
    },

    clearId: function clearId() {
        delete this.id;
    }
});

var $UnavailableCardModel = exports.$UnavailableCardModel = _squid.$Model.extend('$UnavailableCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/unavailable/card?addFIContingency'
    })
});

var $CardTypesModel = exports.$CardTypesModel = _squid.$Model.extend('$CardTypesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/types?country=:country&token=:token'
    }),

    retrieve: function retrieve() {
        return this._super.retrieve.apply(this, arguments).then(function (result) {
            this.disallowedCards = (0, _squid.$feature)('disallowedCards', undefined, this.country);
            // override disallowed cards with card types config list based on country
            if (this.disallowedCards) {
                result.disallowed = this.disallowedCards.cardTypes;
            }
            return result;
        });
    },

    supportedNames: function supportedNames() {
        if (typeof this.allowed === 'undefined') {
            return;
        }

        return this.allowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    },

    unsupportedNames: function unsupportedNames() {
        if (typeof this.disallowed === 'undefined') {
            return;
        }

        return this.disallowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    }
});

var $BankModel = exports.$BankModel = _squid.$Model.extend('$BankModel', {
    init: function init() {
        this._super.init.apply(this);
        this.bank_account_number = '';
        this.bank_routing_number = '';
        this.iban_number = '';
    },

    serialize: function serialize() {
        var data = {};

        if (this.bank_account_number) {
            data.bank_account_number = this.bank_account_number;
        }
        if (this.bank_routing_number) {
            data.bank_routing_number = this.bank_routing_number;
        }
        if (this.iban_number) {
            data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
        }
        return data;
    }
});

var $AddBankModel = exports.$AddBankModel = _squid.$Model.extend('$AddBankModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.user = this.user || {
            first_name: '',
            dob_day: '',
            dob_month: '',
            dob_year: '',
            currency_code: '',
            country: ''
        };
        this.bank = this.bank || new $BankModel();
        this.address = this.address || {};
        this.creditorDetails = this.creditorDetails || {};
        this.fiDetails = this.fiDetails || {};
    },

    getBankData: function getBankData() {
        var data = {};

        // Set user info
        data.user = this.user;

        // Set bank info
        var bank = {};

        this.bank = this.bank || {};

        if (this.candidate_id) {
            data.candidate_id = this.candidate_id;
        }

        if (this.bank.bank_account_number) {
            bank.bank_account_number = this.bank.bank_account_number;
        }

        if (this.bank.bank_routing_number) {
            bank.bank_routing_number = this.bank.bank_routing_number;
        }

        if (this.bank.iban_number) {
            bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
        }
        data.bank = bank;

        // Set address info
        if (this.address) {
            data.address = {
                line1: this.address.line1,
                line2: this.address.line2,
                city: this.address.city,
                country: this.address.country,
                postal_code: this.address.postal_code
            };
        }

        return data;
    }
});

var $PreferredFi = exports.$PreferredFi = _squid.$Model.extend('$PreferredFi', {
    api: new _squid.$Api({
        uri: '/api/fi/preferred'
    }),

    init: function init() {
        this._super.init.apply(this);

        // Get the type of device to send to FI for logging
        function getUiChannel() {
            var capabilities = _index.$DeviceInfo.getCapabilities();

            if (capabilities.isTablet) {
                return 'Tablet';
            } else if (capabilities.isMobile) {
                return 'Mobile';
            } else if (capabilities.isDesktop) {
                return 'Desktop';
            } else if (capabilities.isApp) {
                return 'App';
            } else {
                return null;
            }
        }

        this.uiChannel = getUiChannel();
    },

    serialize: function serialize() {
        return {
            preferred: this.preferred,
            uiChannel: this.uiChannel
        };
    }
});

var $SepaModel = exports.$SepaModel = _squid.$Model.extend('$SepaModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    })
});

var $DeleteCardModel = exports.$DeleteCardModel = _squid.$Model.extend('$DeleteCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/delete'
    })
});

var $AddBillingAddressModel = exports.$AddBillingAddressModel = _squid.$Model.extend('$AddBillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/:instrumentid/addbillingaddress'
    })
});

var $BillingAddressModel = exports.$BillingAddressModel = _squid.$Model.extend('$BillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress/validate'
    }),

    format: function format() {

        var langConfig = (BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};

        var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
        var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

        return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
    },

    serialize: function serialize() {
        return {
            line1: this.line1 && this.line1.trim(),
            line2: this.line2 && this.line2.trim(),
            city: this.city && this.city.trim(),
            state: this.state && this.state.trim(),
            postal_code: this.postal_code && this.postal_code.trim(),
            normalization_status: this.normalization_status,
            country: this.country
        };
    }
});

var $CurrencyConversionModel = exports.$CurrencyConversionModel = _squid.$Model.extend('$CurrencyConversionModel', {
    api: new _squid.$Api({
        uri: '/api/fi/currencyConversion'
    })
});

var $BillingAddressesModel = exports.$BillingAddressesModel = _squid.$Model.extend('$BillingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($BillingAddressModel, this.addresses);
    }
});

var $CardTypeFromBinModel = exports.$CardTypeFromBinModel = _squid.$Model.extend('$CardTypeFromBinModel', {
    api: new _squid.$Api({
        uri: '/api/fi/cardTypeFromBin'
    })
});

var $Resolve3DS = exports.$Resolve3DS = _squid.$Model.extend('$Resolve3DS', {
    api: new _squid.$Api({
        uri: '/api/fi/3ds/:id'
    })
});

var $ResolveOTP = exports.$ResolveOTP = _squid.$Model.extend('$ResolveOTP', {
    api: new _squid.$Api({
        uri: '/api/fi/otp/:id'
    })
});

var $WalletPreferences = exports.$WalletPreferences = _squid.$Model.extend('$WalletPreferences', {
    api: new _squid.$Api({
        uri: '/api/fi/wallet/preferences'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    init: function init() {
        this._super.init.apply(this);
        this.topup = {};
        this.direct = {};
    },

    serialize: function serialize() {
        var data = {};

        if (this.topup.amount) {
            var _topup = this.topup,
                amount = _topup.amount,
                _topup$fundingSource = _topup.fundingSource;
            _topup$fundingSource = _topup$fundingSource === undefined ? {} : _topup$fundingSource;
            var instrument_id = _topup$fundingSource.instrument_id;

            // Set the Topup funding instrument in the wallet preference api, which will be used by future Topup transactions

            data.topup = {
                amount: amount,
                instrument_id: instrument_id,
                autoload_minimum_threshold: _squid.$config.topup.autoload_minimum_threshold
            };
        } else {
            var _direct$fundingSource = this.direct.fundingSource;
            _direct$fundingSource = _direct$fundingSource === undefined ? {} : _direct$fundingSource;
            var _instrument_id = _direct$fundingSource.instrument_id;

            // Set the Direct funding instrument in the wallet preference api, which will be used by future Direct funding transactions

            data.direct = {
                instrument_id: _instrument_id,
                currency_code: this.currency
            };
        }
        return data;
    },

    /**
        * Return the preferred topup/direct fundingsource.
        * Originally values of topup & direct are from the FI wallet preferences api, which gets assigned during the init() call.
        * Values can be changed in the Review and the Wallet pages.
        */
    getPreferred: function getPreferred() {
        if (this.topup.fundingSource && this.topup.fundingSource.instrument_id) {
            // xo-hermes-fi will always return topup.fundingSource even when there is no preferred topup instrument, hence making the additional check here.
            return this.topup.fundingSource;
        } else {
            return this.direct.fundingSource || {};
        }
    }
});

var $WalletInstrumentNameMapping = exports.$WalletInstrumentNameMapping = _squid.$Model.extend('$WalletInstrumentNameMapping', {
    init: function init() {
        this._super.init.apply(this);
        this.INSTRUMENT_MAP = {
            AMSOUTH: /AMSOUTH,/,
            BOFA: /BANK OF AMERICA/,
            CAPITAL: /CAPITAL/,
            CHASE: /CHASE/,
            CITI: /CITIBANK/,
            FIFTHTHIRD: /FIFTH THIRD BANK/,
            HUNTINGTON: /HUNTINGTON/,
            INGDIRECT: /ING DIRECT/,
            NATIONALCITY: /NATIONAL CITY/,
            PNC: /PNC/,
            REGIONS: /REGIONS/,
            SUNTRUST: /SUNTRUST/,
            TDWATERHOUSE: /TD WATERHOUSE/,
            USAA: /USAA/,
            USBANK: /US BANK/,
            VISA: /VISA/,
            WAMUTUAL: /WASHINGTON MUTUAL/,
            WELLSFARGO: /WELLS FARGO/
        };
        this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
    },

    getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
        var _this = this;

        if (!fsName) {
            return;
        }

        fsName = fsName.toUpperCase();

        return _squid.$util.find(this.INSTRUMENT_NAMES, function (instName) {
            if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
                return true;
            }
            return false;
        });
    }
});

var $CardInfoModel = exports.$CardInfoModel = _squid.$Model.extend('$CardInfoModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id'
    })
});

angular.value("$CardModel", $CardModel);
angular.value("$AddCardModel", $AddCardModel);
angular.value("$UnavailableCardModel", $UnavailableCardModel);
angular.value("$CardTypesModel", $CardTypesModel);
angular.value("$BankModel", $BankModel);
angular.value("$AddBankModel", $AddBankModel);
angular.value("$PreferredFi", $PreferredFi);
angular.value("$SepaModel", $SepaModel);
angular.value("$DeleteCardModel", $DeleteCardModel);
angular.value("$AddBillingAddressModel", $AddBillingAddressModel);
angular.value("$BillingAddressModel", $BillingAddressModel);
angular.value("$CurrencyConversionModel", $CurrencyConversionModel);
angular.value("$BillingAddressesModel", $BillingAddressesModel);
angular.value("$CardTypeFromBinModel", $CardTypeFromBinModel);
angular.value("$Resolve3DS", $Resolve3DS);
angular.value("$ResolveOTP", $ResolveOTP);
angular.value("$WalletPreferences", $WalletPreferences);
angular.value("$WalletInstrumentNameMapping", $WalletInstrumentNameMapping);
angular.value("$CardInfoModel", $CardInfoModel);
_index.$DeviceInfo;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$feature;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fiApis = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var $fiApis = exports.$fiApis = {
    patchCvv: function patchCvv(checkoutSession) {
        var cvvData = checkoutSession.get('cvvData');

        if (cvvData) {
            return checkoutSession.action('patchCvv', {
                data: {
                    id: cvvData.id,
                    cvv: cvvData.security_code,
                    type: cvvData.type,
                    number: cvvData.number
                }
            });
        }

        return _angular.$q.when();
    }
};

angular.value("$fiApis", $fiApis);
_angular.$q;

/***/ }),

/***/ "../node_modules/xo-models/src/frs/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$FreeReturnShippingOptInModel = exports.$FreeReturnShippingApplicabilityModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $FreeReturnShippingApplicabilityModel = exports.$FreeReturnShippingApplicabilityModel = _squid.$Model.extend('$FreeReturnShippingApplicabilityModel', {
    api: new _squid.$Api({
        uri: '/api/offers/freeReturnShipping/checkApplicability'
    })
});

var $FreeReturnShippingOptInModel = exports.$FreeReturnShippingOptInModel = _squid.$Model.extend('$FreeReturnShippingOptInModel', {
    api: new _squid.$Api({
        uri: '/api/offers/freeReturnShipping/optInUser'
    })
});

angular.value("$FreeReturnShippingApplicabilityModel", $FreeReturnShippingApplicabilityModel);
angular.value("$FreeReturnShippingOptInModel", $FreeReturnShippingOptInModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/gdprCookieBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GDPRCookieBannerModel = exports.isGdprValid = exports.testGdprBannerCookie = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var testGdprBannerCookie = exports.testGdprBannerCookie = function testGdprBannerCookie(cookies) {
    return (/(^|;\s*)cookie_prefs=/.test(cookies)
    );
};

var isGdprValid = exports.isGdprValid = function isGdprValid() {
    if (_squid.$util.param('forceGDPR')) {
        return true;
    }

    var country = _squid.$locale.country;

    return _squid.$util.getProperty(_squid.$config, 'GDPR.cookieBanner', { 'default': false }) && _squid.$util.getProperty(_squid.$config, 'GDPR.countries', { 'default': [] }).indexOf(country) > -1;
};

var $GDPRCookieBannerModel = exports.$GDPRCookieBannerModel = _squid.$Model.extend('$GDPRCookieBannerModel', {
    api: new _squid.$Api({
        uri: '/api/cookieBanner'
    }),

    /**
     * Handles the logic for when to fetch the banner and when to return
     * Don't repeat the call for same country
     * Don't return the banner if not PXP check
     * @returns {Promise} resolves an object
     */
    getBanner: function getBanner() {
        var _this = this;

        // API is cached on country. Return current result if already present
        if (this.lastResult && this.lastCountry === _squid.$locale.country && this.lastLang === _squid.$locale.lang) {
            return this.lastResult;
        }

        // Invalidate the model to make a fresh call
        this.invalidate();

        // Log if the user has cookie indicating a previous interaction with the cookie banner
        if (testGdprBannerCookie(document.cookie)) {
            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_has_cookie'
            });
        }

        // Cache the result promise and params
        this.lastCountry = _squid.$locale.country;
        this.lastLang = _squid.$locale.lang;
        this.lastResult = this.retrieve().then(function (res) {
            var html = res.html,
                css = res.css,
                js = res.js;


            if (!html || !js || !css) {
                _logger.$logger.info('gdpr_response_missing_props', {
                    html: !!html,
                    js: !!js,
                    css: !!css
                });
                _this.reset();
                return;
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_shown'
            });

            return { html: html, css: css, js: js };
        });

        return this.lastResult;
    },
    reset: function reset() {
        this.html = '';
        this.css = '';
        this.js = '';
    },
    shown: function shown() {
        return !!this.html;
    },

    // Check if a banner was shown in the flow.
    // SOME EDGE CASES:
    //   Will not update when the user clicks to accept the banner, and it closes
    //   Will update if retrieve is called with a new country and blank data is returned
    hasBanner: function hasBanner() {
        var _this2 = this;

        // check config flag
        // check if already populated
        // make call again and let regular logic populate html
        // return boolean

        if (!isGdprValid()) {
            return _squid.$promise.resolve(false);
        }
        if (this.html) {
            return _squid.$promise.resolve(this.shown());
        }
        return this.getBanner().then(function () {
            return _this2.shown();
        });
    }
});

angular.value("testGdprBannerCookie", testGdprBannerCookie);
angular.value("isGdprValid", isGdprValid);
angular.value("$GDPRCookieBannerModel", $GDPRCookieBannerModel);
_squid.$Model;

_squid.$Api;

_squid.$locale;

_squid.$config;

_squid.$util;

_squid.$promise;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$InventoryModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
    api: new _squid.$Api({
        uri: '/api/catalog/:id/item/',
        postAttempts: 2,
        cache: true
    }),

    setInvetoryItems: function setInvetoryItems(inventoryItems) {
        this.inventoryItems = inventoryItems;
    },

    getInventoryItems: function getInventoryItems() {
        return this.inventoryItems;
    }
});

angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditOfferModel = exports.$MemberSegmentModel = exports.$fireMORSBeacon = exports.$MessageDiscoverModel = exports.$MarketingOfferModel = undefined;

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $MarketingOfferModel = exports.$MarketingOfferModel = _squid.$Model.extend('$MarketingOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/search-ads',
        postAttempts: 1,
        cache: true
    }),
    init: function init() {
        this.setProperties({ ads: [] });
        this.meta = { populated: false };
    },
    onPopulate: function onPopulate() {
        var _this = this;

        if (this.targetPlacements && this.targetPlacements[0]) {
            var targetAd = this.ads.find(function (ad) {
                return ad.valid && ad.campaign.adunit_id === _this.targetPlacements[0].placement_code;
            });

            this.ad = undefined;
            if (targetAd) {
                var ad = {};
                var nvpContent = targetAd && targetAd.content && targetAd.content.nvp;

                nvpContent.forEach(function (obj) {
                    ad[obj.name] = obj.value;
                });
                ad['impressionUrl'] = targetAd && targetAd.tracking && targetAd.tracking.impression_url;
                ad['clickUrl'] = targetAd && targetAd.tracking && targetAd.tracking.click_url;
                ad['campaignId'] = targetAd && targetAd.campaign && targetAd.campaign.campaign_id;
                ad['buyItemId'] = targetAd && targetAd.campaign && targetAd.campaign.buy_item_id;
                ad['placementCode'] = targetAd && targetAd.campaign && targetAd.campaign.adunit_id;
                this.ad = ad;
            }
        }
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'site': this.site,
            'locale': this.locale,
            'si': this.si,
            'visit_id': _uuid2['default'].v4(),
            'page': this.page,
            'epu': this.payer,
            'pu_type': this.puType || 'ANONYMOUS',
            'country_code': this.countryCode,
            'payment_context': {
                'total_transaction_amount': this.totalTransactionAmount,
                'total_shipping_amount': this.totalShippingAmount,
                'business_case': 'NONE',
                'business_case_variation': '',
                'validate_existing_offer': 'false',
                'payment_units': [{
                    'transaction_amount': this.totalTransactionAmount,
                    'transaction_id': '',
                    'encrypted_transaction_id': '',
                    'activity_id': '',
                    'payee': {
                        'pu_type': 'BUSINESS',
                        'country_code': this.countryCode,
                        'epu': this.payee,
                        'pu': ''
                    }
                }]
            },
            'target_placements': this.targetPlacements,
            'wallet_instruments': this.walletInstruments,
            'addl_property_installments_not_allowed': this.installmentsNotAllowed
        };
    },
    getTargetAd: function getTargetAd() {
        return this.ad;
    },
    isAdFound: function isAdFound() {
        if (this.ad) {
            for (var property in this.ad) {
                if (this.ad.hasOwnProperty(property)) {
                    return true;
                }
            }
        }
        return false;
    }
});

var $MessageDiscoverModel = exports.$MessageDiscoverModel = _squid.$Model.extend('$MessageDiscoverModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/discover-messages',
        postAttempts: 1
    })
});

var $fireMORSBeacon = exports.$fireMORSBeacon = {
    fireBeacon: function fireBeacon(uri) {
        var img = document.createElement('img');

        img.setAttribute('src', uri);
        document.body.appendChild(img);
        return;
    }
};

var $MemberSegmentModel = exports.$MemberSegmentModel = _squid.$Model.extend('$MemberSegmentModel', {
    api: new _squid.$Api({
        uri: '/api/segment/memberSegment',
        postAttempts: 1
    }),
    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    getMemberSegment: function getMemberSegment() {
        return this.memberSegment;
    },
    getCreditOffer: function getCreditOffer() {
        return this.creditOffer;
    },
    isNewMember: function isNewMember() {
        return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
    },
    isExistingMember: function isExistingMember() {
        return this.memberSegment === 'EXISTING_MEMBER';
    },
    // Member Segments that are eligble for the New Experience
    isEligibleForExperimentation: function isEligibleForExperimentation() {
        var eligibleMemberSegments = _squid.$config.memberSegments;

        return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
    }
});

var $CreditOfferModel = exports.$CreditOfferModel = $MessageDiscoverModel.extend('$CreditOfferModel', {
    init: function init() {
        this.setProperties({
            bannerMessages: []
        });
    },
    populate: function populate(result) {
        var _this2 = this;

        if (result && result.touchpoint_messages) {
            var touchpoint_messages = result.touchpoint_messages.find(function (element) {
                return element.touchpoint_code === _this2.touchpoint;
            });

            this.storeMessages(touchpoint_messages);
        }
    },
    storeMessages: function storeMessages(touchpoint_messages) {
        if (touchpoint_messages) {
            this.viewName = touchpoint_messages.view_name;

            if (touchpoint_messages.messages) {
                var messages = touchpoint_messages.messages;

                for (var i = 0; i < touchpoint_messages.messages.length; i++) {
                    var presentmentType = messages[i].content.json.PresentmentType;

                    if (presentmentType === 'Banner') {
                        this.bannerMessages.push(messages[i]);
                    }
                }
            }
        }
    },
    getBannerCount: function getBannerCount() {
        return this.bannerMessages.length;
    },
    hasBannerMessage: function hasBannerMessage() {
        return this.getBannerCount() > 0;
    },
    getTouchpointCode: function getTouchpointCode() {
        return this.touchpoint;
    },
    getBannerMessage: function getBannerMessage(i) {
        i = !i ? 0 : i;

        if (this.getBannerCount() > i) {
            return this.bannerMessages[i];
        }
        return null;
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.application_context) {
            this.application_context.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'country_code': this.locale.country,
            'language': this.locale.lang + '_' + this.locale.country,
            'identity_context': [{
                'type': 'PAYER_ID',
                'value': this.payer
            }, {
                'type': 'MERCHANT_PAYER_ID',
                'value': this.payee
            }],
            'recommendation_context': {
                'view_names': this.view_names ? this.view_names : [],
                'touchpoint_details': [{
                    'code': this.touchpoint,
                    'message_count': this.message_count ? this.message_count : 1
                }]
            },
            'application_context': this.application_context
        };
    }
});

angular.value("$MarketingOfferModel", $MarketingOfferModel);
angular.value("$MessageDiscoverModel", $MessageDiscoverModel);
angular.value("$fireMORSBeacon", $fireMORSBeacon);
angular.value("$MemberSegmentModel", $MemberSegmentModel);
angular.value("$CreditOfferModel", $CreditOfferModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/onboard/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SingleStepModel = exports.$GuestUpgradeModel = exports.$OnboardPhoneModel = exports.$OnboardUserModel = exports.$OnboardModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

var $OnboardModel = exports.$OnboardModel = _squid.$Model.extend('$OnboardModel', {
    api: new _squid.$Api({
        uri: '/api/onboard'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.fiMode = this.fiMode || 'card'; // Supports card or bank
        this.bank = this.bank || new _index.$BankModel();
        this.card = this.card || new _index.$CardModel();
    },

    serialize: function serialize() {
        var data = {
            user: this.user.serialize(),
            billing_address: this.billing_address.serialize(),
            shipping_address: this.shipping_address.serialize(),
            phone: this.phone.serialize(),
            marketing_optin: this.marketingOptin,
            shipping_address_validation: this.shipping_address_validation,
            billing_address_present: this.billing_address_present,
            payment_experience_initiator: this.payment_experience_initiator,
            poma_flow: this.poma_flow,
            prox_flow: this.prox_flow,
            testParams: this.testParams,
            content_identifier: this.content_identifier,
            frs_optin_flow_applicable: this.frs_optin_flow_applicable, // Free Return Shipping Opt-in flow applicability flag
            frs_optin_active_flow: this.frs_optin_active_flow, // Denotes FRS opt in flow type - Active (true) or Silent (false)
            flow_eligibility_data: this.flow_eligibility_data,
            bypass_address_verification: this.bypass_address_verification
        };

        if (this.nationalIdModel) {
            data.nationalIdModel = {
                'secondaryIdType': this.nationalIdModel.secondaryIdType,
                'secondaryIdValue': this.nationalIdModel.secondaryIdValue
            };

            if (this.nationalIdModel.nationalId) {
                data.nationalIdModel.nationalId = {
                    type: this.nationalIdModel.nationalId.type,
                    subType: this.nationalIdModel.nationalId.subType,
                    value: this.nationalIdModel.nationalId.value
                };
            }
        }

        if (this.fiMode === 'card') {
            data.card = this.card.serialize();
        } else {
            data.bank = this.bank.serialize();
        }

        data.skipInitiateAuth = this.skipInitiateAuth;

        return data;
    }
});

var $OnboardUserModel = exports.$OnboardUserModel = _squid.$Model.extend('$OnboardUserModel', {
    serialize: function serialize() {
        var onboardUserModel = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            countryOfResidence: this.countryOfResidence,
            country: this.country,
            dob_day: this.dob_day,
            dob_month: this.dob_month,
            dob_year: this.dob_year,
            occupation: this.occupation,
            nationality: this.nationality,
            gender_type: this.gendertype,
            place_of_birth: this.placeofbirth
        };

        if (this.nativeName) {
            onboardUserModel.nativeName = {
                first_name: this.nativeName.first_name,
                last_name: this.nativeName.last_name,
                middle_name: this.nativeName.middle_name
            };
        }

        return onboardUserModel;
    }
});

var $OnboardPhoneModel = exports.$OnboardPhoneModel = _squid.$Model.extend('$OnboardPhoneModel', {
    serialize: function serialize() {
        return {
            type: this.phoneType,
            number: this.telephone,
            countryCode: this.IntDialingCountryCode
        };
    }
});

/**
 * A model for handling onboarding guest accounts
 * into PayPal accounts (happens post transaction)
 */

var $GuestUpgradeModel = exports.$GuestUpgradeModel = _squid.$Model.extend('$GuestUpgradeModel', {
    api: new _squid.$Api({
        uri: '/api/onboard/guest-upgrade'
    }),

    serialize: function serialize() {
        var data = {
            user: this.user.serialize(),
            phone: this.phone.serialize(),
            billing_address: this.billing_address.serialize(),
            payerId: this.payerId,
            transaction: this.transaction,
            marketing_optin: this.marketing_optin,
            contentIdentifier: this.contentIdentifier,
            experienceIdentifier: this.experienceIdentifier,
            experienceChannel: this.experienceChannel,
            nationalId: this.nationalIdModel ? this.nationalIdModel.serialize() : _directive.$NationalIdModel.instance().serialize()
        };

        // append additional phone data
        data.phone.country_prefix = this.phone && this.phone.IntDialingCountryCode;

        // append additional billing_address data
        data.billing_address.normalization_status = this.billing_address && this.billing_address.normalization_status;

        return data;
    },

    serializeEmailFlow: function serializeEmailFlow() {
        var data = {
            user: this.user.serialize(),
            phone: this.phone.serialize(),
            billing_address: this.billing_address.serialize(),
            payerId: this.payerId,
            transaction: this.transaction,
            receiptId: this.receiptId,
            marketing_optin: this.marketing_optin,
            card: this.card
        };

        return data;
    }
});

var $SingleStepModel = exports.$SingleStepModel = _squid.$Model.extend('$SingleStepModel', {});

angular.value("$OnboardModel", $OnboardModel);
angular.value("$OnboardUserModel", $OnboardUserModel);
angular.value("$OnboardPhoneModel", $OnboardPhoneModel);
angular.value("$GuestUpgradeModel", $GuestUpgradeModel);
angular.value("$SingleStepModel", $SingleStepModel);
_squid.$Model;

_squid.$Api;

_index.$CardModel;

_index.$BankModel;

_directive.$NationalIdModel;

/***/ }),

/***/ "../node_modules/xo-models/src/processorDecline/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getProcessorDeclineRetryEligibility = getProcessorDeclineRetryEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var INELIGIBLE = _squid.$promise.resolve(false);
var lastBuyerId = null;

// Check eligibility for processor decline retry feature
// First checks if feature eligibility is met, then PXP eligibility is met
function getProcessorDeclineRetryEligibility(token, checkoutSession) {
    if (!(0, _squid.$feature)('cardBackup')) {
        return INELIGIBLE;
    }

    // TODO: Refactor the eligibility rules to a set of common rules
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(token),
        checkoutPayee: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var checkoutCart = models.checkoutCart,
            checkoutPayee = models.checkoutPayee,
            checkoutAppData = models.checkoutAppData;

        var plans = checkoutSession.get('fundingOptions.plans', []);
        var moreThanOneCard = plans.filter(function (fi) {
            return fi.primaryFs.type === 'CARD';
        }).length < 2;

        // exclude rewards from the eligibility list
        var hasRewards = plans.filter(function (fi) {
            return fi && fi.rewards !== undefined;
        }).length > 0;

        // See https://engineering.paypalcorp.com/confluence/display/HellsKitchen/Hermes+Processor+Decline+Retry for eligibility reasons
        var isGambling = checkoutPayee.isGambling();
        var isBilling = checkoutCart.isBilling();
        // We're only sure that Sale transactions will go onto the new payments stack, for now
        var isNotSale = checkoutCart.get('payment_action') !== 'sale';
        var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
        // Exclude all WPS products
        var isWpsOrInvoice = checkoutAppData.get('flags.is_wps_flow') || checkoutAppData.get('flags.is_invoice_flow');
        // We will need to confirm functionality for this before we can enable for this feature
        var isMultiSellerPurchase = checkoutCart.isMultiSellerPurchase();
        var hasInstallments = checkoutSession.installments && checkoutSession.installments.length > 1;
        var involvedCurrencies = plans.reduce(function (currencies, plan) {
            currencies[plan.primaryFs.amount.currency_code] = 1;
            return currencies;
        }, {});
        // Buyer promo email routing through checkoutserv, downstream does not support
        var hasBuyerPromoEmail = checkoutAppData.get('flags.display_buyer_email_promotional_opt_in');

        if (checkoutCart.get('purchase.amounts.total.currency_code')) {
            involvedCurrencies[checkoutCart.purchase.amounts.total.currency_code] = 1;
        }

        var ineligibilityCriteria = {
            isGambling: isGambling,
            moreThanOneCard: moreThanOneCard,
            hasRewards: hasRewards,
            isBilling: isBilling,
            isNotSale: isNotSale,
            isThirdParty: isThirdParty,
            isWpsOrInvoice: isWpsOrInvoice,
            isMultiSellerPurchase: isMultiSellerPurchase,
            hasInstallments: hasInstallments,
            currencyConversion: Object.keys(involvedCurrencies).length > 1,
            hasBuyerPromoEmail: hasBuyerPromoEmail
        };
        var ineligibleReasons = Object.keys(ineligibilityCriteria).filter(function (key) {
            return ineligibilityCriteria[key];
        });
        var eligible = ineligibleReasons.length === 0;

        // Logging for FPTI
        _logger.$logger.info('checkout_fpti', {
            from: 'processor_decline_retry',
            // This logs whether user is eligible by Hermes criteria
            to: 'processor_decline_retry_' + (eligible ? 'eligible' : 'ineligible')
        });

        if (!eligible) {
            // This logs the overall result of the eligibility check
            _logger.$logger.info('processor_decline_retry_ineligible', {
                reasons: ineligibleReasons.join()
            });
        }

        return eligible;
    }).then(function (featureEligible) {
        // BuyerId is needed to make sure pxp is reloaded if a new user logs in.
        // Refactor: Make this a common pxp model that is invalidated on logout
        var buyerId = models.auth.buyerId;

        var sameBuyer = buyerId === lastBuyerId;

        lastBuyerId = buyerId;

        if (!featureEligible) {
            return false;
        }

        // Only run the PXP if the feature is eligible, as requested from analytics
        return (0, _squid.$pxp)('xo_hermes_processor_decline_retry', {}, 'xo_hermes_processor_decline_retry_treatment', sameBuyer ? false : true, true).then(function (pxpRes) {
            if (!pxpRes) {
                _logger.$logger.info('processor_decline_retry_ineligible', {
                    pxpIneligible: true
                });
            }

            return !!pxpRes;
        });
    }).then(function (eligibleWithPxp) {
        if (eligibleWithPxp) {
            _logger.$logger.info('processor_decline_retry_eligible');
        }
        return eligibleWithPxp;
    });
}

_squid.$feature;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_logger.$logger;

_thirdPartyInfo.thirdPartyExperience;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutAppDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MerchantPreferenceModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $MerchantPreferenceModel = exports.$MerchantPreferenceModel = _squid.$Model.extend('$MerchantPreferenceModel', {
    init: function init() {
        this._super.init.apply(this);

        this.setProperties({
            rm: _squid.$util.param('rm'), // Return Method
            return_url: _squid.$util.param('return'),
            auto_return: {
                enabled: false
            },
            pdt: {
                enabled: false
            }
        });
    },


    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/profilemanagement/:id/getMerchantPreferences'
    }),

    autoReturn: function autoReturn() {
        return this.auto_return.enabled;
    },
    pdtEnabled: function pdtEnabled() {
        return this.pdt && this.pdt.enabled;
    },
    returnUrl: function returnUrl() {
        return this.return_url || this.auto_return.url;
    },


    /**
     * 0 – redirect using GET method ( default behavior )
     * 1 – redirect using the GET method, but no payment variables are included
     * 2 – redirect using the POST method, and include all payment variables
     */
    returnMethod: function returnMethod() {
        if (this.rm === '2') {
            return this.pdtEnabled() ? 'GET' : 'POST';
        }

        return 'GET';
    },
    returnMethodSupported: function returnMethodSupported() {
        return this.returnMethod() === 'GET';
    },


    /**
     * Determines if payment details need to be sent back to the merchant.
     * @returns {boolean}
     */
    postPaymentData: function postPaymentData() {
        return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
    },


    // charset of merchant having in profile
    charSet: function charSet() {
        return this.charset;
    }
});

angular.value("$MerchantPreferenceModel", $MerchantPreferenceModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/prox/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ContextualLoginModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ContextualLoginModel = exports.$ContextualLoginModel = _squid.$Model.extend('$ContextualLoginModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            key: _squid.$util.param('ctxId')
        });
    },
    api: new _squid.$Api({
        uri: '/api/contextualLogin/:key'
    })
});

angular.value("$ContextualLoginModel", $ContextualLoginModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingRuleSummaryModel = exports.$ShippingMethodModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShippingMethodModel = exports.$ShippingMethodModel = _squid.$Model.extend('$ShippingMethodModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/charges'
    }),

    getShippingMethodId: function getShippingMethodId(shippingMethodType) {
        var shippingMethodsMap = {
            DEFAULT: '0',
            AIR_SERVICE: '1',
            ECONOMY: '2',
            EXPEDITED_AIR_SERVICE: '3',
            EXPEDITED_FLAT_RATE_SHIPPING: '4',
            EXPRESS: '5',
            EXPRESS_DOMESTIC: '6',
            FREE_SHIPPING: '7',
            GROUND: '8',
            GLOBAL_PRIORITY: '9',
            INTERNATIONAL_ECONOMY: '10',
            INTERNATIONAL_EXPEDITED: '11',
            INTERNATIONAL_EXPRESS: '12',
            INTERNATIONAL_EXPRESS_AIR: '13',
            INTERNATIONAL_PRIORITY_AIR: '14',
            NEXT_DAY: '15',
            NEXT_DAY_AIR: '16',
            NEXT_DAY_AIR_ECONOMY: '17',
            ONE_DAY_SHIPPING: '18',
            OVERNIGHT: '19',
            OVERNIGHT_FLAT_RATE_SHIPPING: '20',
            PICKUP: '21',
            PRIORITY: '22',
            RUSH_DELIVERY: '23',
            STANDARD_DOMESTIC: '24',
            STANDARD_EXPEDITED: '25',
            STANDARD_FLAT_RATE_SHIPPING: '26',
            STANDARD_INTERNATIONAL: '27',
            STANDARD_SHIPPING: '28',
            STORE_PICKUP: '29',
            TWO_DAY_SHIPPING: '30',
            WORLDWIDE_SHIPPING: '31',
            TWO_DAY_AIR: '32'
        };

        return shippingMethodsMap[shippingMethodType];
    },

    isStorePickUp: function isStorePickUp(shipping_method_type) {
        return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
    }
});

var $ShippingRuleSummaryModel = exports.$ShippingRuleSummaryModel = _squid.$Model.extend('$ShippingRuleSummaryModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/:id/rulesSummary'
    })
});

angular.value("$ShippingMethodModel", $ShippingMethodModel);
angular.value("$ShippingRuleSummaryModel", $ShippingRuleSummaryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/shoppingcart/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShoppingCartModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShoppingCartModel = exports.$ShoppingCartModel = _squid.$Model.extend('$ShoppingCartModel', {
    api: new _squid.$Api({
        uri: '/api/shoppingcart/:id',
        postAttempts: 2,
        cache: false
    })
});

angular.value("$ShoppingCartModel", $ShoppingCartModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/subscription/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SubscriptionsV1Model = exports.$SubscriptionModel = exports.$CreateBAModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt',
        postAttempts: 3
    })
});

var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt/:id',
        postAttempts: 3,
        cache: true
    })
});

var $SubscriptionsV1Model = exports.$SubscriptionsV1Model = _squid.$Model.extend('$SubscriptionsV1Model', {
    api: new _squid.$Api({
        uri: '/api/billagmt/subscriptions/v1/:id',
        cache: true
    })
});

angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
angular.value("$SubscriptionsV1Model", $SubscriptionsV1Model);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UserProductSubscriptionModel = exports.$AuthConsentModel = exports.$UserPhotoModel = exports.$EConsentModel = exports.$WaxUserModel = exports.$PatchPhoneModel = exports.$AddKYCModel = exports.$ValidatePhoneModel = exports.$UserInfoModel = exports.$CheckoutInputDataModel = exports.$CheckoutClientDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CheckoutClientDataModel = exports.$CheckoutClientDataModel = _squid.$Model.extend('$CheckoutClientDataModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/clientData'
    }),

    merchantIdentityData: function merchantIdentityData() {
        return {
            email: this.email,
            brand_name: this.display_name,
            logo_uri: this.logo_uri,
            identity_uri: this.identity_uri
        };
    },

    validateClient: function validateClient() {
        if (this.partner_id && this.identity_uri) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_client'
            };
        }
    },
    validateRedirectUri: function validateRedirectUri(redirectUrl) {
        if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_redirect_url'
            };
        }
    }
});

var ACTION = {
    login: 'login',
    resolve: 'resolve',
    addCard: 'addCard',
    addBank: 'addBank',
    changeCurrencyConv: 'changeCurrencyConv',
    signup: 'signup',
    mandate: 'mandate',
    addCredit: 'addCredit',
    ulReturn: 'ulReturn',
    creditReturn: 'creditReturn',
    guestCurrencyConversion: 'guestCurrencyConversion',
    guestAuthentication: 'guestAuthentication',
    compliance: 'compliance'
};

var $CheckoutInputDataModel = exports.$CheckoutInputDataModel = _squid.$Model.extend('$CheckoutInputDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            client_id: _squid.$util.param('client_id'),
            action: _squid.$util.param('action'),
            redirect_uri: _squid.$util.param('redirect_uri'),
            scope: _squid.$util.param('scope'),
            state: _squid.$util.param('state'),
            flow: _squid.$util.param('flow'),
            payer_id: _squid.$util.param('payer_id'),
            mandate_reference_number: _squid.$util.param('mandate_reference_number'),
            funding_option_id: _squid.$util.param('funding_option_id'),
            locale: _squid.$util.param('locale'),
            logout: _squid.$util.param('logout'),
            refresh_parent: _squid.$util.param('refresh_parent'),
            escape_hatch: _squid.$util.param('escape_hatch'),
            failedBecause: _squid.$util.param('failedBecause'),
            redirectReferrer: _squid.$util.param('redirectReferrer'),
            id_token: _squid.$util.param('prox_id'),
            nonce: _squid.$util.param('nonce'),
            hide_rm: _squid.$util.param('hideRM'),
            payloadEnc: _squid.$util.param('payloadEnc'),
            xcancel: _squid.$util.param('x-cancel'),
            xsuccess: _squid.$util.param('x-success')
        });
    },

    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/user/:id/payerId'
    }),

    isEbayTxn: function isEbayTxn() {
        return Boolean(this.client_id);
    },

    validAction: function validAction() {
        var actions = {
            login: 'login',
            resolve: 'resolve',
            addCard: 'addCard',
            addBank: 'addBank',
            changeCurrencyConv: 'changeCurrencyConv',
            signup: 'signup',
            mandate: 'mandate',
            addCredit: 'addCredit',
            ulReturn: 'ulReturn',
            creditReturn: 'creditReturn',
            guestCurrencyConversion: 'guestCurrencyConversion',
            guestAuthentication: 'guestAuthentication',
            compliance: 'compliance'
        };

        return actions.hasOwnProperty(this.action);
    },

    showRYP: function showRYP() {
        return !this.isEbayTxn();
    },

    requiresOAuth: function requiresOAuth() {
        return this.action === ACTION.login || this.action === ACTION.signup;
    },

    requiresRedirectUri: function requiresRedirectUri() {
        return this.action === ACTION.mandate || !this.requiresOAuth();
    },

    validRedirectUri: function validRedirectUri() {
        if (this.requiresRedirectUri()) {
            return Boolean(this.redirect_uri);
        }
        return true;
    },

    validate: function validate() {
        var error;
        var success = true;

        if (this.isEbayTxn()) {
            if (!this.validAction()) {
                success = false;
                error = 'invalid_action';
            } else if (!this.validRedirectUri()) {
                success = false;
                error = 'invalid_redirect_uri';
            }
        }

        return {
            success: success,
            error: error
        };
    },

    errorUrl: function errorUrl(err, errorDesc) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        if (err) {
            url += '&error=' + err;
        }
        if (errorDesc) {
            url += '&error_description=' + errorDesc;
        }

        return url;
    },

    successUrl: function successUrl(code) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        url += '&code=' + code;

        return url;
    },

    rmEnabled: function rmEnabled(featureEnabled) {
        return featureEnabled && this.action === ACTION.login;
    },

    hideRM: function hideRM() {
        return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
    }
});

var $UserInfoModel = exports.$UserInfoModel = _squid.$Model.extend('$UserInfoModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/session'
    })
});

var $ValidatePhoneModel = exports.$ValidatePhoneModel = _squid.$Model.extend('$ValidatePhoneModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/validatePhone',
        cache: false
    })
});

var $AddKYCModel = exports.$AddKYCModel = _squid.$Model.extend('$AddKYCModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/addKYC'
    })
});

var $PatchPhoneModel = exports.$PatchPhoneModel = _squid.$Model.extend('$PatchPhoneModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:token/session/patch',
        cache: false
    })
});

var $WaxUserModel = exports.$WaxUserModel = _squid.$Model.extend('$WaxUserModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/waxUser'
    })
});

var $EConsentModel = exports.$EConsentModel = _squid.$Model.extend('$EConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/eConsent'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $UserPhotoModel = exports.$UserPhotoModel = _squid.$Model.extend('$UserPhotoModel', {
    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: 'api/user/photo'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $AuthConsentModel = exports.$AuthConsentModel = _squid.$Model.extend('$AuthConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/authConsent'
    })
});

var $UserProductSubscriptionModel = exports.$UserProductSubscriptionModel = _squid.$Model.extend('$UserProductSubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/user/productSubscription'
    })
});

angular.value("$CheckoutClientDataModel", $CheckoutClientDataModel);
angular.value("$CheckoutInputDataModel", $CheckoutInputDataModel);
angular.value("$UserInfoModel", $UserInfoModel);
angular.value("$ValidatePhoneModel", $ValidatePhoneModel);
angular.value("$AddKYCModel", $AddKYCModel);
angular.value("$PatchPhoneModel", $PatchPhoneModel);
angular.value("$WaxUserModel", $WaxUserModel);
angular.value("$EConsentModel", $EConsentModel);
angular.value("$UserPhotoModel", $UserPhotoModel);
angular.value("$AuthConsentModel", $AuthConsentModel);
angular.value("$UserProductSubscriptionModel", $UserProductSubscriptionModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-page-components/src/aside-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoAsideHeader', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            hdrtype: '@?',
            heading: '@?',
            subHead: '@?',
            addLink: '@?',
            backUrl: '@?',
            closeUrl: '@?',
            hidex: '@?',
            headerLeftLink: '=?',
            headerLeft: '@?',
            headerLeftIcon: '@?',
            headerRightLink: '=?',
            headerRight: '@?',
            headerRightIcon: '@?',
            subHeaderLeftLink: '@?',
            subHeaderLeft: '@?',
            subHeaderLeftIcon: '@?',
            subHeaderRightLink: '@?',
            subHeaderRight: '@?',
            subHeaderRightIcon: '@?',
            showDualFi: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _angular.$timeout)(function () {
                // Explicitly select `x` button and `<` buttons from manage wallet
                // and add card pages
                // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64007
                // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64008
                $element.find('a.focusableIcon').focus();
            });

            if (_angular2['default'].isUndefined($scope.closeUrl)) {
                $scope.closeUrl = 'checkout.review';
            }

            if ($scope.addLink) {
                $scope.subHeaderRight = 'asideHeader.add';
                $scope.subHeaderRightLink = $scope.addLink;
            }

            $scope.onClickLink = function (event, target, showDualFi) {
                event.preventDefault();
                if (showDualFi) {
                    $scope.showFiOptions = true;
                } else if (_angular2['default'].isFunction(target)) {
                    target();
                } else {
                    _uiRouter.$state.go(target);
                }
            };
        }]
    };
});

_uiRouter.$state;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"header noButtons\" tabindex=\"-1\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\" aria-label=\"Back button\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left focusableIcon\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\" aria-label=\"Back button\"\n           data-test-id=\"closeAsideWallet\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\" data-test-id=\"sideBarAddLink\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoBaMessageBanner', {
    tag: 'xo-ba-message-banner',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        isMessengerIntegration: {
            type: 'var',
            required: false
        },
        borderPosition: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                    checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            this.borderPosition = this.borderPosition || 'bottom';
        },
        populate: function populate() {
            this.merchantMsg = this.models.checkoutCart.getBillingDescription();

            // We need other variables only if this.merchantMsg exists
            if (this.merchantMsg) {
                // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
                // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
                // in content keys used in template
                this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true
                });

                var _ref = window.xprops || {},
                    _ref$experience = _ref.experience,
                    experience = _ref$experience === undefined ? { facebook: false } : _ref$experience;

                this.isFacebookIntegration = experience.facebook;
            }
        }
    }
});


_squid.$Component;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"{{ borderPosition + 'Border' }} baMessageBanner row-fluid\" ng-if=\"merchantMsg\" content>\n    <h1 ng-if=\"!isMessengerIntegration\" class=\"baIntegration noBottom alpha\" id=\"merchantMsgHeader\">\n        {{ content('billingAgreement.merchantMsgHeader', { merchantName: nonEmptyMerchantDisplayName }) }}\n    </h1>\n    <h1 ng-if=\"isFacebookIntegration\" class=\"fbIntegration messengerBAHeader\" id=\"merchantMsgHeader\">\n        {{ content('messenger.fbHeader') }}\n    </h1>\n    <h1 ng-if=\"!isFacebookIntegration && isMessengerIntegration\" class=\"messengerIntegration messengerBAHeader\" id=\"merchantMsgHeader\">\n        {{ content('messenger.baHeader') }}\n    </h1>\n    <div class=\"merchantMsg\" id=\"merchantMsg\">\n        <span class=\"subTitle given-name\">\n            {{ merchantMsg }}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('cartWrapper', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            showAmt: '=?',
            showArrow: '=?',
            token: '=?',
            baToken: '=?'
        },
        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.checkoutCart.isSubscriptionsV1()) {
                    $scope.showAmt = true;

                    (0, _squid.$populate)($scope, {
                        subscriptionsV1Data: _index2.$SubscriptionsV1Model.instance($scope.baToken)
                    }).then(function () {
                        var planReview = $scope.subscriptionsV1Data.planReview;

                        var plan = planReview.new_plan || planReview.current_plan;

                        $scope.subscriptionAmount = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value') / 100;
                        $scope.currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');
                    })['catch'](_angular.noop);
                }

                if ($scope.checkoutCart.purchase) {
                    $scope.currencyCode = $scope.checkoutCart.purchase.amounts.total.currency_code;
                }

                $scope.getAmount = function () {
                    if ($scope.checkoutCart.isSubscriptionsV1()) {
                        return $scope.subscriptionAmount;
                    } else if ($scope.checkoutCart.purchase) {
                        return $scope.checkoutCart.purchase.amounts.total.amount;
                    }
                };
            });
        }]
    };
});

_angular.noop;

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

_index2.$SubscriptionsV1Model;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt && getAmount()\">\n            <format-currency class=\"formatCurrency\" code=\"currencyCode\"\n                             amount=\"getAmount()\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/directive.js");

var _showCartDecision = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/showCartDecision.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoCart', function () {
    return {
        template: _template2['default'],
        restrict: 'E',

        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?'
        },

        controller: ['$scope', function ($scope) {

            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function loadCartData() {

                var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                var cartDesc = $scope.checkoutCart.get('purchase.description');

                $scope.note = $scope.checkoutCart.get('note');

                // resolve string in descriptions array since the only element may be `null`
                // TODO: fix backend to return a string, to avoid this conditional
                if (cartDesc && angular.isString(cartDesc[0])) {
                    cartDesc = cartDesc[0];
                } else {
                    cartDesc = '';
                }

                $scope.desc = cartDesc;
                $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
                var showCartDetails = !$scope.checkoutAppData.flags.hide_cart_details;
                var notMultiSellerPurchase = !$scope.checkoutCart.isMultiSellerPurchase();
                // Always Render minicart for wps subscription .
                var wpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

                $scope.showArrow = wpsSubscription || isSubscriptionsV1 || showCartDetails && (cartDesc || $scope.hasItems || $scope.note) && notMultiSellerPurchase;

                // add details to render to the checkoutCart items
                $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                    item.details = {};

                    if (item.quantity > 1) {
                        item.details.price = item.price.amount;
                        item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                    }

                    if (item.description) {
                        if (!item.name) {
                            item.name = item.description;
                        } else {
                            item.details.description = item.description;
                        }
                    }

                    // move options to detail section
                    if (item.item_option_selections) {
                        item.details.hasSelections = true;
                        item.details.item_option_selections = item.item_option_selections;
                    }

                    if (item.sku) {
                        item.details.sku = item.sku;
                    }

                    item.hasDetails = Object.keys(item.details).length > 0;
                    item.details.hasMore = item.hasDetails || item.details.hasSelections;
                });

                // Mapping of field name as recieved by API to corresponding property key
                $scope.amountHeaders = {
                    'total': 'header.total',
                    'subtotal': 'header.itemTotal',
                    'tax': 'header.tax',
                    'shipping': 'header.shipping',
                    'insurance': 'header.insurance',
                    'handling_fee': 'header.handling',
                    'shipping_discount': 'header.shippingDiscount',
                    'description': 'header.description',
                    'discount': 'header.discount'
                };

                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;

                var purchase = $scope.checkoutCart.purchase;
                var total = purchase && purchase.amounts && purchase.amounts.total;

                $scope.isCartTextTotalOrSubTotal = userAction === 'commit' || $scope.showCartTotal === true ? 'header.total' : 'header.subTotal';

                return (0, _showCartDecision.showCartDecision)($scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutCart.isSubscriptionsV1(), total, $scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (result) {
                    $scope.showAmt = result.showAmt;
                    $scope.showCartSubTotal = result.showCartSubTotal;
                    $scope.showAmountInCartIcon = result.showAmountInCartIcon;
                });
            }).then(function handleCartOpenClose() {
                // the cart is only automatically open under the following criteria:
                // 1. the cart has a 'note to buyer' ($scope.note is defined)
                // 2. the cart was not previously automatically opened before
                // 3. the state has transitioned to checkout.review or checkout.guest
                function decideShowCart(currentState) {
                    var falsePositive = /^checkout\.(selectFi)$/.test(currentState) && /^checkout\.(review|guest)$/.test($scope.openedAlready);
                    var notOpened = !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState);
                    var canShow = notOpened || falsePositive;

                    if ($scope.note && canShow) {
                        $scope.openedAlready = currentState; // may have been undefined before
                        return true;
                    }

                    return false;
                }

                $scope.showCartItem = function (breakdown) {
                    return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
                };

                $scope.showCart = decideShowCart(_uiRouter.$state.current.name);

                // TODO: Must we really couple this so tightly with the state transition names?
                var openCartListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
                    $scope.showCart = decideShowCart(toState.name);
                });

                $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

                $scope.toggleCart = function ($event) {
                    $scope.showCart = !$scope.showCart;
                    $event.preventDefault();
                };

                $scope.closeCart = function ($event) {
                    $scope.showCart = false;
                    // for accessible autofocus on cart toggle link button
                    $scope.$broadcast('cart-closed');
                    if ($event) {
                        $event.preventDefault();
                    }
                };

                $scope.$on('clickBody', function ($event, target) {
                    if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
                        $scope.closeCart($event);
                        $scope.$apply();
                    }
                });

                // this listener / broadcast allows accessibility components to scan and focus inside the cart
                // when the cart is displayed
                $scope.$watch('showCart', function (showCart) {
                    if (showCart) {
                        $scope.$broadcast('cart-updated');
                    }
                });
            }).then(function handleEllipsisIssues() {
                // NOTE: the scattered broadcasts of "cart-updated" events are mostly
                // to allow the accessibility directives modal-box and focus-when to
                // know when to recalculate keyboard behavior / focus
                $scope.toolongTracker = {};

                // this function is invoked by the onEllipsis directive that tracks
                // if the item name won't fit within the restricted space.
                $scope.toolong = function (idx) {
                    $scope.toolongTracker[idx] = true;
                    $scope.$broadcast('cart-updated');
                };

                $scope.showMore = function (idx, type) {
                    // there are 2 types of more, "floating" when the name is too long
                    // and "inline" when the name can fit, but there are additional details.
                    //
                    // Show a more if the item
                    // 1. has an expanded state
                    // 2. is not already expanded
                    // 3. if it is appropriate to show that type.
                    var itemIsTooLong = $scope.toolongTracker[idx];
                    var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';

                    return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
                };

                $scope.expandedIndex = -1; // initially, none of the line items are expanded
                $scope.isExpanded = function isExpanded(idx) {
                    return idx === $scope.expandedIndex;
                };
                $scope.hasExpandedState = function hasExpandedState(idx) {
                    // A line item is exandable if
                    // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
                    // 2. there are details (attached to purchase.items in the cart)
                    // 3. there is item number (sku) in the item
                    var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
                    var nameTooLong = $scope.toolongTracker[idx];

                    return nameTooLong || item.hasDetails || item.sku;
                };
                $scope.expand = function expand(idx) {
                    $scope.expandedIndex = idx;
                    $scope.$broadcast('cart-updated');
                };
                $scope.collapse = function collapse() {
                    $scope.expandedIndex = -1;
                    $scope.$broadcast('cart-updated');
                };

                // Set default focus on cart first element "more" link
                $scope.focusElementCssSelector = 'a.more';

                // Change the focus element as user clicks on elements
                $scope.$watch('expandedIndex', function (expandedIndex) {
                    if (expandedIndex === -1) {
                        $scope.focusElementCssSelector = 'a.more';
                    } else {
                        // If any "more" link or item is clicked in cart, then
                        // set focus to itemNameContainer
                        $scope.focusElementCssSelector = '.itemNameContainer.expanded';
                    }
                });

                $scope.$emit('dataLoaded');
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$util;

_squid.formatQuantity;

_uiRouter.$state;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_showCartDecision.showCartDecision;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('itemDetails', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            details: '=?',
            sku: '=?',
            currencyCode: '=?',
            onClickLess: '&?'
        },
        controller: function controller() {/* dumb component */}
    };
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul focusable content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections track by $index\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n  </li>\n</ul>\n<a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {



/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */

exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports['default'] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
    // Escape opening tags on vulnerable tags
    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
    element.innerHTML = input;
    return element.textContent || element.innerText;
}

function decodeEntitiesAngularFilter() {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    // Retrieve the converter element rather than create one every
    // time. Angular may call this filter many times repeatedly and
    // we should make a small effort to optimize the process
    var converter = window[ENTITY_ELEM];

    /**
     * Takes a string with HTML entities within and renders it as the unicode
     * characters they represent. This is done by leveraging the browser to
     * perform this transformation internally. InnerText is chosen as the output
     * so as to kill any HTML itself that was supplied.
     *
     * @param {String} input a String containing HTML entities that need to be
     * decoded and HTML stripped.
     * @return {String} the same string with HTML tags removed and entities
     * decoded.
     */
    return decodeEntities.bind(null, converter);
}

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$pxpCartAmt', function () {
    return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
        if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
            var pageName = 'xo_hermes_no_line_item_details';
            var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
            var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';

            return _angular.$q.all([(0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtBlacklistTreatment, false, true), (0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtTreatment, false, true)]).then(function (results) {
                var showAmtBlacklist = results[0];
                var showAmt = results[1];

                if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
                    return true;
                }

                if (showAmt && showAmt.treatment_name === showAmtTreatment) {
                    return true;
                }

                return false; // default to hide
            });
        }

        return _angular.$q.when(!noLineItemDetails && isPurchase);
    };
});

_squid.$pxp;

_angular.$q;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/cart/lib", "../node_modules/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/showCartDecision.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.showCartDecision = showCartDecision;

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

function showCartDecision(isSubscriptionFlow, total, merchantCountry, merchantId, noLineItemDetails, isPurchase) {
    return (0, _pxp.$pxpCartAmt)(merchantCountry, merchantId, noLineItemDetails, isPurchase).then(function (showAmount) {
        // Show cart subtotal if there is a total amount
        // Do not show subtotal for wps subscription flow.
        // Show amount in cart icon only if showAmount is truthy and total amount is not zero
        return {
            showAmt: showAmount,
            showCartSubTotal: showAmount && total && !isSubscriptionFlow,
            showAmountInCartIcon: showAmount && +total.amount !== 0
        };
    });
}

_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _decode_entities = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/decode_entities.js");

var _decode_entities2 = _interopRequireDefault(_decode_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
    var elemRect = elem.getBoundingClientRect();

    // cross browser, returns decimals for ultra-precision
    return elemRect.right - elemRect.left;
}

function getNaturalWidth(elem) {
    var old = {
        overflow: elem.style.overflow,
        width: elem.style.width,
        display: elem.style.display
    };
    var result = void 0;

    elem.style.overflow = 'visible';
    elem.style.width = 'auto';
    elem.style.display = 'inline-block';
    result = getVisibleWidth(elem);
    elem.style.overflow = old.overflow;
    elem.style.width = old.width;
    elem.style.display = old.display;

    return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ? function (elem, style) {
    return _angular.$window.getComputedStyle(elem)[style];
} // modern browsers
: function (elem, style) {
    return elem.currentStyle[style];
}; // IE

function hasEllipsis(elem) {
    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
        return getVisibleWidth(elem) < getNaturalWidth(elem);
    }

    return false;
}

(0, _squid.$registerDirective)('onEllipsis', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function invokeSubscriber() {
                (0, _angular.$parse)(attrs.onEllipsis)(scope);
                scope.$apply();
            }

            (0, _angular.$timeout)(function () {
                if (hasEllipsis(element[0])) {
                    invokeSubscriber();
                }
            });
        }
    };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _squid.$registerDirective)('dynamicMaxheight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function resizeContainer() {
                var $element = (0, _jquery2['default'])(element);
                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
                var siblings = $element.siblings().filter(function () {
                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');

                    return pos !== 'fixed' && pos !== 'absolute';
                }).map(function getOuterHeights() {
                    return (0, _jquery2['default'])(this).outerHeight();
                });
                var siblingsHeight = 0;
                var i = void 0;

                for (i = 0; i < siblings.length; i += 1) {
                    siblingsHeight += siblings[i];
                }

                var spaceAvailable = parentHeight - siblingsHeight;

                if (!isNaN(spaceAvailable)) {
                    $element.css('max-height', spaceAvailable + 'px');
                }
            }

            // if an expression is provided, it is used as an event to listen for and recalculate the height
            if (attrs.dynamicMaxheight) {
                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
            }

            (0, _angular.$timeout)(resizeContainer);
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$filterProvider;

_angular.$window;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscription/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$subscription', {
    tag: 'subscription',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _subscriptionTerms2['default'].getItemName(this.models.subscriptionData);
            this.itemOptions = _subscriptionTerms2['default'].getItemOptions(this.models.subscriptionData);

            this.getFirstAmount = function () {
                return _subscriptionTerms2['default'].getFormattedFirstAmount(_this.models.subscriptionData);
            };

            this.getTermsText = function () {
                return _subscriptionTerms2['default'].getTermsText(_this.models.subscriptionData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"subs-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\">\n                <span class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</span>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.firstAmount')}}</h4>\n            <div ng-bind-html=\"getFirstAmount()\" class=\"content\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SubscriptionsV1', {
    tag: 'subscriptions-v1',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionsV1Model.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _models$subscriptionD = this.models.subscriptionData,
                planReview = _models$subscriptionD.planReview,
                billingAgreementCart = _models$subscriptionD.billingAgreementCart;

            var plan = planReview.new_plan || planReview.current_plan;

            var itemAmount = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.first_payment.value');
            var currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');

            this.termsText = _subscriptionTerms2['default'].getTermsText({ plan: plan });
            this.startDate = billingAgreementCart.start_time_formatted;
            this.autoRenewIndicator = billingAgreementCart.auto_renewal === 'true';

            this.itemName = _squid.$util.getProperty(plan, 'plan.name');
            this.taxPercentage = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.taxPercentage');
            this.itemPrice = _subscriptionTerms2['default'].getFormattedAmount(itemAmount, currencyCode);

            this.quantity = !isNaN(billingAgreementCart.quantity) && billingAgreementCart.quantity;
            this.shipping = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.shipping_amount.value');
            this.shippingAmount = _subscriptionTerms2['default'].getFormattedAmount(this.shipping, currencyCode);
            this.setupFee = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.setup_fee.value');
            this.setupFeeAmount = _subscriptionTerms2['default'].getFormattedAmount(this.setupFee, currencyCode);

            var totalAmount = _subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value');
            this.totalAmount = _subscriptionTerms2['default'].getFormattedAmount(totalAmount, currencyCode);
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$util;

_index.$SubscriptionsV1Model;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <div class=\"item-option\">\n                    <div ng-repeat=\"terms in termsText track by $index\">\n                        {{terms}}\n                    </div>\n                    <div ng-if=\"autoRenewIndicator\" class=\"subscription-terms\">{{content('subscriptions.message.renewsUntilCancelled')}}</div>\n                    <div class=\"start-date\"> {{content('subscriptions.message.startDate')}} {{ startDate }}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"landing-page-item-details-container\">\n            <div class=\"item-details-row no-margin-bottom\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxPercentage}\">{{ itemName }} </div>\n                <div class=\"item-details-right\"> {{ itemPrice }}</div>\n            </div>\n            <div class=\"item-details-row label-color\" ng-if=\"quantity\">\n                <div class=\"item-details-left\">{{ content('header.quantity') }} {{ quantity }}</div>\n                <div class=\"item-details-right\"></div>\n            </div>\n            <div class=\"item-details-row\" ng-if=\"shipping\">\n                <div class=\"item-details-left\">{{ content('header.shipping') }}</div>\n                <div class=\"item-details-right\">{{ shippingAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row\" ng-if=\"setupFee\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxPercentage}\">{{ content('subscriptions.message.setupFee') }}</div>\n                <div class=\"item-details-right\">{{ setupFeeAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row margin-top-30\" ng-if=\"taxPercentage\">\n                <div class=\"item-details-left label-color\" ng-class=\"{'tax-indicator-before': taxPercentage}\">{{ content('subscriptions.message.includesTax', {tax: taxPercentage}) }}</div>\n                <div class=\"item-details-right\"></div>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\" >{{content('header.total')}}</h4>\n            <div class=\"content\">{{ totalAmount }}</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                          token=\"token\" ba-token=\"checkoutCart.getBaToken()\"\n            ></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" id=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"focusElementCssSelector\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h2 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h2>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <subscription ng-if=\"checkoutAppData.is_wps_subscription_flow()\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </subscription>\n\n                <subscriptions-v1 ng-if=\"checkoutCart.isSubscriptionsV1()\"\n                                  ba-token=\"checkoutCart.getBaToken()\"\n                                  merchant-id=\"payee.getId()\">\n                </subscriptions-v1>\n\n                <div ng-if=\"!checkoutAppData.is_wps_subscription_flow()\" dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items track by $index\" class=\"items\">\n\n                            <div focusable class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts track by $index\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showCartSubTotal\">\n                    <span class=\"itemNameContainer\">{{ content(isCartTextTotalOrSubTotal) }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {



/* Constants for FB messenger related components */
module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: {
        US: '55982004572',
        AU: '171522459698178',
        CA: '164660263560926',
        GB: '167465479930420',
        HK: '575224445931086',
        JP: '252040838174046',
        NZ: '171522459698178',
        PH: '1895483750701842',
        SG: '1405303076421245',
        IL: '369238992488',
        CZ: '199396843578121',
        DE: '109838022384872',
        AT: '109838022384872',
        CH: '109838022384872',
        FR: '124143236317',
        IT: '198366693576785',
        BR: '170288122998781',
        ES: '244240615638886',
        MX: '42433532610',
        ZA: '388473619362',
        NL: '105370782861413',
        DK: '133211860117553',
        SE: '121404111292725',
        RU: '275216545856555',
        PL: '244706038980513',
        NO: '304581546592510',
        GR: '704200349634422',
        IN: '347199669139259',
        AE: '402374783229274',
        BH: '402374783229274',
        DZ: '402374783229274',
        EG: '402374783229274',
        JO: '402374783229274',
        KW: '402374783229274',
        MA: '402374783229274',
        OM: '402374783229274',
        QA: '402374783229274',
        SA: '402374783229274',
        TN: '402374783229274',
        YE: '402374783229274',
        AR: '474276366001351',
        CL: '474276366001351',
        CO: '474276366001351',
        CR: '474276366001351',
        DO: '474276366001351',
        EC: '474276366001351',
        PE: '474276366001351',
        UY: '474276366001351',
        VE: '474276366001351'
    },
    FB_TEST_PAGE_ID: '676472402496128',
    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
    PXP_MESSENGER_IN: 'xo_wps_fb_messenger_plugin_IN',
    PXP_MESSENGER_PLUGIN_TREATMENT_IN: 'xo_wps_fb_messenger_plugin_IN_treatment'
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _index3 = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js");

var _index4 = _interopRequireDefault(_index3);

var _template = __webpack_require__("../node_modules/xo-page-components/src/done/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTORETURN_TIMEOUT = 5000;
// If the user returns into checkout, it causes errors since the checkout
// session is not what we'd expect it to look like. Rather than proofing our
// code against this, we will attempt to prevent navigation instead.
// Any valid routes should be added here
var WHITELISTED_ROUTES = ['checkout.end'];

(0, _angular.$registerDirective)('xo-done', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            $scope.isGuestSignup = _angular.$rootScope.mode && _angular.$rootScope.mode === 'signup';
            $scope.locale = _squid.$locale;

            function addPageMessage(code) {
                var CONTENT_KEY_MAPPING = {
                    NO_UPGRADE: 'accountUpgradeFailed'
                };

                if (code && CONTENT_KEY_MAPPING[code]) {
                    $scope.errorMessage = {
                        msgs: [_squid.$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
                        type: 'warning'
                    };
                }
            }

            function isThirdPartyFlow() {
                return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token),
                payee: _index2.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {
                // We need merchant display name (which can be undefined) to display in
                // merchant details section of the page
                $scope.merchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName();
                // We need non empty value for merchantDisplayName in #merchant-text tag
                $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true
                });

                return (0, _squid.$populate)($scope, {
                    merchantPreferenceModel: _profilemanagement.$MerchantPreferenceModel.instance($scope.payee.merchant.id)
                }).then(function () {
                    // Show auto return page when feature is enabled by merchant and txn
                    $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
                    _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                        return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
                        autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
                    });

                    // Set content key based on device
                    $scope.autoReturnContentKey = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                    $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';

                    if (_uiRouter.$stateParams.code) {
                        addPageMessage(_uiRouter.$stateParams.code);
                    }
                    var amount = $scope.checkoutSession.transactionDetails.amount.total;
                    var code = $scope.checkoutSession.transactionDetails.amount.currency;

                    $scope.formattedAmount = (0, _squid.formatCurrency)(amount, code);
                    var itemList = $scope.checkoutSession.itemsList;

                    itemList.forEach(function (item) {
                        item.quantity = (0, _squid.formatQuantity)(item.quantity);
                    });
                });
            }).then(function () {
                var pxpContext = _index4['default'].getMessengerPXPContext();

                _logger.$logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);

                // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
                // Also not loading if merchant auto return is enabled

                if (!$scope.isAutoReturn && !isThirdPartyFlow()) {
                    if (_index4['default'].isDolphinEligibleOnWpsDone(_uiRouter.$state.current && _uiRouter.$state.current.name)) {
                        _logger.$logger.info('ul_dolphin', {
                            'from': 'dolphin_elg_chk',
                            'to': 'process_dolphin_elg_chk',
                            'eligibility_reason': 'wps_done_flow',
                            'context_id': _angular.$rootScope.token
                        });
                        $scope.isDolphinEligibleOnWpsDone = true;
                    } else {
                        _squid.$promise.all([(0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT, false, true), (0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_IN, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_IN, false, true)]).then(function () {
                            var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var country = _squid.$locale.country;
                            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
                            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
                            var payerId = _$scope$checkoutSessi.id;


                            _logger.$logger.info('Messenger_done_page_PXP_RESULT', results);

                            var _results$ = results[0];
                            _results$ = _results$ === undefined ? {} : _results$;
                            var treatment_name = _results$.treatment_name,
                                _results$2 = results[1];
                            _results$2 = _results$2 === undefined ? {} : _results$2;
                            var in_treatment_name = _results$2.treatment_name;


                            if (treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT || in_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_IN) {
                                _logger.$logger.info('messenger_done_page_test_traffic');
                                _logger.$logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_treatment'
                                });
                                $scope.pxpMessengerIntegrationEnabled = true;
                            } else {
                                _logger.$logger.info('messenger_done_page_control_traffic');
                                _logger.$logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_control'
                                });
                                $scope.pxpMessengerIntegrationEnabled = false;
                            }
                        });
                    }
                }

                (0, _jquery2['default'])('#outerWrapper').addClass('xo-done');

                $scope.expansion = false;
                $scope.toggle = function () {
                    if ($scope.expansion === false) {
                        $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                        $scope.expansion = true;
                    } else {
                        $scope.expansion = false;
                    }
                    return $scope.expansion;
                };

                $scope.autoReturnStatementClick = function (event) {
                    event.preventDefault();
                    if (event.target && event.target.nodeName === 'A') {
                        _logger.$logger.info('autoreturn_statement_clicked');
                        $scope.returnToMerchant();
                    }
                };

                if ($scope.isAutoReturn) {
                    _logger.$logger.info('autoreturn_to_merchant');
                    (0, _angular.$timeout)($scope.returnToMerchant, AUTORETURN_TIMEOUT);
                }
            });

            $scope.$on('localeChange', function () {
                if (_uiRouter.$stateParams.code) {
                    addPageMessage(_uiRouter.$stateParams.code);
                }
            });

            $scope.returnToMerchant = function () {
                _logger.$logger.info('return_to_merchant_clicked');
                return _uiRouter.$state.go('checkout.end');
            };

            var onExitListeners = function onExitListeners() {
                var removeClassListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        (0, _jquery2['default'])('#outerWrapper').removeClass('xo-done');
                    }
                });
                var preventBackListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
                    if (!~WHITELISTED_ROUTES.indexOf(newState.name)) {
                        _logger.$logger.info('done_page_prevent_routing', {
                            to: newState.name
                        });
                        event.preventDefault();
                        preventBackListener();

                        return _uiRouter.$state.go('checkout.genericError', {
                            code: 'PAYMENT_ALREADY_DONE'
                        });
                    }
                });

                return function () {
                    removeClassListener();
                    preventBackListener();
                };
            };

            $scope.$on('$destroy', onExitListeners());
        }]
    };
});

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$timeout;

_squid.$locale;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_squid.formatCurrency;

_squid.formatQuantity;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_profilemanagement.$MerchantPreferenceModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DoneRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/done/directive.js");

var $DoneRoute = exports.$DoneRoute = _squid.$ComponentRoute.extend('DoneRoute', {
    name: 'done',
    directive: 'xo-done',
    titleContent: 'done.paymentCompleted',
    query: ['code'],
    trackingData: {
        fptiState: 'done_page',
        templateName: 'memberDone.dust',
        pageGoal: 'Payment Done Receipt',
        trackStateExit: true,
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-done',
                'pagename2': '%::fullpage-done:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$DoneRoute", $DoneRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-done-content\" content>\n    <xo-dolphin ng-if=\"isDolphinEligibleOnWpsDone\"></xo-dolphin>\n    <div ng-click=\"toggle()\" class=\"splash-receipt\" tabindex=\"-1\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{ content('done.payment_target', { merchantName: nonEmptyMerchantDisplayName }) }}</div>\n            <a id=\"details-text\" link-button href=\"#\" aria-expanded=\"{{expansion}}\">{{content('paymentMethod.msbDetails')}}</a>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\"\n            tabindex=\"-1\" focus-when=\"expansion\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList track by $index\">\n                <div class=\"row\">\n                    <span class=\"ltrOverride\" directionality><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n        <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n          <div id=\"messenger-ba-integration-content\" style=\"display:none\">\n            <div class=\"text\">{{ content('messenger.integration') }}</div>\n          </div>\n          <div id=\"ba-integration-content\" style=\"display:none\">\n            <div class=\"receipt title\">{{ content('messenger.linkedTitle') }}</div>\n            <div class=\"text\">{{ content('messenger.linkedSubtitle') }}</div>\n          </div>\n          <div id=\"stm-upsell-content\" class=\"text\">{{ content('messenger.upsell') }}</div>\n          <xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n        </div>\n\n        <h2 ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</h2>\n        <div ng-repeat=\"item in checkoutSession.plan.sources track by $index\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <h2 ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</h2>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <ul class=\"multilineAddressList\">\n                <li ng-repeat=\"item in checkoutSession.shipping.full_address_multiline track by $index\" directionality-text=\"item\">{{item}}</li>\n            </ul>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <h2 class=\"receipt title\">{{content('done.purchaseDetails')}}</h2>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n\n        <div ng-if=\"merchantDisplayName || checkoutAppData.merchant.phone\">\n            <h2 text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</h2>\n            <div class=\"text\" id=\"merchantInfoSection\">\n                <div ng-if=\"merchantDisplayName\"><span directionality-text=\"merchantDisplayName\">{{ merchantDisplayName }}</span></div>\n                <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            </div>\n        </div>\n\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" data-test-id=\"autoreturn-link\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: checkoutAppData.merchant.brand_name, autoReturnUrl: checkoutAppData.urls.return_url})\"/>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _footerMap = __webpack_require__("../node_modules/xo-page-components/src/footer/footerMap.js");

var _footerMap2 = _interopRequireDefault(_footerMap);

var _opinionlab = __webpack_require__("../node_modules/xo-page-components/src/footer/opinionlab.js");

var _opinionlab2 = _interopRequireDefault(_opinionlab);

var _template = __webpack_require__("../node_modules/xo-page-components/src/footer/template.html");

var _template2 = _interopRequireDefault(_template);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFooter', function () {
    return {
        template: _template2['default'],
        restrict: 'EA',
        scope: {
            token: '=?',
            escapeHatchIncontext: '=?',
            cancel: '@?',
            merchant: '@?',
            languageSwitch: '=?',
            showVenmoLegalLinks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.isIFrame = _squid.$util.isIFrame();
            if ($scope.escapeHatchIncontext) {
                $scope.showEscapeHatch = $scope.isIFrame;
            }
            $scope.locale = _squid.$locale;
            $scope.proxSignUpFlow = _index4.$CheckoutInputDataModel.instance($scope.token).isEbayTxn();
            $scope.year = new Date().getFullYear();

            $scope.isApac = function () {
                return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf($scope.locale.country) > -1;
            };

            // Determine if country belongs to a region to serve correct footer links
            var getRegion = function getRegion(country) {
                var regions = _squid.$config.regions;
                for (var region in regions) {
                    if (regions[region].indexOf(country) > -1) {
                        return region;
                    }
                }
                return false;
            };

            function isDESecondButtonFlow() {
                return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
            }

            $scope.footerLinks = function () {
                if ($scope.isApac()) {
                    return _footerMap2['default'].APAC;
                }

                // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                // that were available in Aries
                if (isDESecondButtonFlow()) {
                    return _footerMap2['default']['DESecondButton'];
                }

                return _footerMap2['default'][$scope.locale.country] || _footerMap2['default'][getRegion($scope.locale.country)] || _footerMap2['default'].DEFAULT;
            };

            $scope.showPolicyInfo = function () {
                return $scope.isApac() || $scope.locale.country === 'AU';
            };

            $scope.cancelRedirect = function ($event) {
                $event.preventDefault();

                var cancelUri = $scope.cancel;
                var redirectUri = _squid.$util.param('redirect_uri');

                if (window.xprops && window.xprops.onCancel && !cancelUri) {
                    return window.xprops.onCancel({
                        orderID: $scope.token
                    });
                }

                // "redirect_uri" as a query param overrides the cancel url in the checkout session
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {

                    cancelUri = _squid.$util.buildURL(redirectUri, {
                        opType: 'cancel',
                        return_uri: $scope.cancel,
                        token: $scope.token
                    });
                }

                _index5.$ReturnToMerchant.goTo(cancelUri);
            };

            $scope.isIndiaLegalEntity = function () {
                // for PayPal India domestic launch legal entity should be 84
                // update footer with indian policy for this case
                return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84 || $scope.locale.country === 'IN';
            };

            if ($scope.token) {
                (0, _squid.$populate)($scope, {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance($scope.token),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance($scope.token),
                    auth: _index2.$AuthModel.instance()
                }).then(function () {
                    var payee = $scope.checkoutPayee;

                    if (payee && payee.merchant && payee.merchant.id) {
                        var hcl = _squid.$config.hideCancelLinkForMerchant;

                        var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
                        if (shouldHide) {
                            $scope.hideCancel = true;
                        }
                    }
                    $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                    $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
                });
            }

            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, ctx) {
                var url = ctx && ctx.popupUrl;
                _logger.$logger.info('show_popup_modal', { url: url, ua: _angular.$window.navigator.userAgent });
                $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
                $scope.show = true;
                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
            });

            $scope.hideModal = function () {
                _logger.$logger.info('hide_popup_modal');
                $scope.show = false;
            };

            $scope.$on('$destroy', cancelShowModal);

            $scope.showOL = function showOL(event) {
                event.preventDefault();

                var placeholder = 'main:ec:hermes';
                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
                var data = {
                    opVars: {
                        rlogId: _angular.$window.meta.rlogId || '',
                        page: page || window.location.hash,
                        csci: 'Unknown',
                        calc: _angular.$window.meta.correlationId,
                        custId: 'Unknown',
                        merchantId: 'Unknown',
                        token: $scope.token || 'Unknown'
                    },
                    locale: {
                        country: _squid.$locale.country,
                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                    }
                };

                (0, _opinionlab2['default'])(data);
            };

            $scope.showFeedback = function () {
                return !_index.$DeviceInfo.isDevice() && !isDESecondButtonFlow();
            };

            $scope.hideReturnCancelUrl = function () {
                if (window.xprops && window.xprops.onCancel) {
                    return false;
                }

                if (!$scope.cancel) {
                    return true;
                }

                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.done') {
                    return true;
                }

                return false;
            };

            $scope.showVenmoLinks = function () {
                // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !!$scope.showVenmoLegalLinks;
            };

            $scope.showPaypalLinks = function () {
                // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !$scope.showVenmoLegalLinks;
            };
        }]
    };
});

_uiRouter.$state;

_angular.$window;

_angular.$rootScope;

_angular.$sce;

_squid.$config;

_squid.$util;

_squid.$locale;

_squid.$populate;

_squid.$integration;

_index.$DeviceInfo;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index4.$CheckoutInputDataModel;

_index5.$ReturnToMerchant;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {



!(module.exports = {
    CA: [{
        id: 'policy',
        content: 'footer.policiesCA'
    }, {
        id: 'terms',
        content: 'footer.termsCA'
    }, {
        id: 'privacy',
        content: 'footer.privacyCA'
    }],

    BE: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DE: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'legal',
        content: 'footer.DELegal'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }, {
        id: 'paymentdesc',
        content: 'footer.DEKeyPaymentDesc'
    }],

    ES: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    FR: [{
        id: 'legal',
        content: 'footer.FRLegal'
    }, {
        id: 'useragreement',
        content: 'footer.FRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.FRPrivacy'
    }],

    IT: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    NL: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    IE: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    APAC: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EMEA: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EM: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    LATAM: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    AU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    AT: [{
        id: 'imprint',
        content: 'footer.ATImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    CH: [{
        id: 'imprint',
        content: 'footer.CHImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    DK: [{
        id: 'useragreement',
        content: 'footer.DKUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    SE: [{
        id: 'useragreement',
        content: 'footer.SEUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    PL: [{
        id: 'useragreement',
        content: 'footer.PLUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    NO: [{
        id: 'useragreement',
        content: 'footer.NOUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    TR: [{
        id: 'useragreement',
        content: 'footer.TRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    BR: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    MX: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    RU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DESecondButton: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }],

    DEFAULT: [{
        id: 'policy',
        content: 'footer.policies',
        venmoContent: 'footer.venmo_policies'
    }, {
        id: 'terms',
        content: 'footer.terms',
        venmoContent: 'footer.venmo_terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy',
        venmoContent: 'footer.venmo_privacy'
    }]
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel || '#'}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\" ng-if=\"showPaypalLinks()\">\n                <li ng-repeat=\"link in footerLinks() track by $index\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n                <li ng-if=\"showFeedback()\"><a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{content('OpinionLab.SiteFeedback')}}</a></li>\n            </ul>\n            <ul class=\"footerLinks\" ng-if=\"showVenmoLinks()\">\n                <li ng-repeat=\"link in footerLinks() track by $index\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n                <li ng-if=\"showFeedback()\"></li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options direction=\"top\" ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-if=\"isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.4plpolicyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreInfo\" ng-if=\"!isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal ng-if=\"show\" show=\"show\" enable-mobile-interstitial=\"true\" show-close-button=\"true\" on-close=\"hideModal\">\n        <div class=\"popupModalContainer\">\n            <iframe src=\"{{popupUrl}}\" class=\"popupModal\" frameborder=\"0\"></iframe>\n        </div>\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$gdprCookieBannerComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * General Data Protection Regulation (GDPR) defines standards on how personal data is collected, processed, transferred and disposed.
 * Affected Countries: All "GDPR" countries: Please check config.json for country list.
 * Wiki: https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki/GDPR:-Feature,-Integration-documentation
 */
var $gdprCookieBannerComponent = exports.$gdprCookieBannerComponent = _squid.$Component.extend('$gdprCookieBanner', {
    tag: 'xo-gdpr-cookie-banner',
    template: _template2['default'],
    actions: {
        // Fetch the GDPR banner, append to DOM if available
        refreshGDPR: function refreshGDPR() {
            var _this = this;

            var gdprModel = _gdprCookieBanner.$GDPRCookieBannerModel.instance();

            return gdprModel.getBanner().then(function () {
                var banner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                // Run cleanup once we know the result, to prevent screen flash
                _this.actions.cleanup();

                var html = banner.html,
                    css = banner.css,
                    js = banner.js;


                if (!html || !css || !js) {
                    return;
                }

                var div = angular.element(html);
                var style = angular.element(css);
                var script = angular.element(js);

                var el = _this.$element.find('#gdpr-cookie-banner-outerwrap');

                el.append(style);
                el.append(div);
                el.append(script);

                if (!(0, _angular.isFunction)(window.bindGdprEvents)) {
                    _logger.$logger.error('gdpr_banner_bindGdprEvents_not_defined');
                    return;
                }

                // TODO: Remove this class add when cookie banner script is fixed to add this class properly
                angular.element(document.body).addClass('gdprCookieBanner-acceptedAll');

                window.bindGdprEvents();
            });
        },

        // Clear out the banner container to remove the old elements
        cleanup: function cleanup() {
            var el = this.$element.find('#gdpr-cookie-banner-outerwrap');

            el.empty();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.actions.refreshGDPR();

            // On "localeChange" we are re-fetching data.
            this.$on('localeChange', function () {
                _this2.actions.refreshGDPR();
            });
        }
    }
});

angular.value("$gdprCookieBannerComponent", $gdprCookieBannerComponent);
_squid.$Component;

_angular.isFunction;

_gdprCookieBanner.$GDPRCookieBannerModel;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SetHeaderText = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/header/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/header/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoHeader', function () {
    return {
        template: _template2['default'],
        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?',
            isUnbranded: '=?',
            unbrandedTitle: '=?',
            unbrandedSubTitle: '=?',
            languageSwitch: '=?',
            redirectiframe: '=?',
            redirectLightbox: '=?',
            isVenmoFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            var _ref = window.xprops || {},
                _ref$experience = _ref.experience,
                experience = _ref$experience === undefined ? { facebook: false } : _ref$experience;

            $scope.isFacebookBAIntegration = experience.facebook;
            $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            $scope.subTitle = (0, _squid.$renderContent)($scope.unbrandedSubTitle);
            $SetHeaderText.subscribe($scope, function (event, text) {
                $scope.unbrandedTitle = text;
                $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            });
        }]
    };
});

var headerText = '';
var $SetHeaderText = exports.$SetHeaderText = {
    setText: function setText(text) {
        headerText = text;
        _angular.$rootScope.$emit('update_header_text', text);
    },
    getText: function getText() {
        return headerText;
    },
    subscribe: function subscribe($scope, callback) {
        var handler = _angular.$rootScope.$on('update_header_text', callback);
        $scope.$on('$destroy', handler);
    }
};

angular.value("$SetHeaderText", $SetHeaderText);
_angular.$rootScope;

_squid.$integration;

_squid.$renderContent;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\" disable-id=\"true\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isFacebookBAIntegration\" class=\"ng-scope facebookPayPalHeader\">\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/paypal_monogram_logo.png\" class=\"facebookPayPalHeader-logo\" alt=\"PayPal\">\n            <span class=\"facebookPayPalHeader-separator\"></span>\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/facebook_logo.svg\" class=\"facebookPayPalHeader-logo\" alt=\"Facebook\">\n        </div>\n        <div ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/marketingOffers/template.html");

var _template2 = _interopRequireDefault(_template);

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMarketingOffers', function () {
    return {
        template: _template2['default'],
        scope: {
            placementCode: '=?',
            titleTxtProperty: '=?',
            subtitleProperty: '=?',
            token: '=?',
            pageName: '=?',
            backgroundImage: '=?',
            xoTitleTag: '@?',
            xoTitleClass: '@?'
        },
        controller: ['$scope', '$element', '$sce', function ($scope, $element, $sce) {
            var morsOfferFlag = $scope.placementCode === '202003' && (0, _squid.$feature)('morsValuePropOffers');
            var populateObj = void 0;

            if (morsOfferFlag) {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                    payee: _index.$CheckoutPayeeModel.instance($scope.token),
                    auth: _auth.$AuthModel.instance()
                };
            } else {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
                };
            }
            (0, _squid.$populate)($scope, populateObj).then(function () {
                $scope.locale = _squid.$locale;
                $scope.token = _angular.$rootScope.token;
                function setDefaultValues() {
                    $scope.ad = {
                        Title: (0, _squid.$renderContent)($scope.titleTxtProperty),
                        Body: (0, _squid.$renderContent)($scope.subtitleProperty),
                        backgroundImage: $scope.backgroundImage
                    };
                }

                $scope.$watch('ad.backgroundImage', function (imageUrl) {
                    if (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element($element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina && url) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    }
                });

                if ($scope.placementCode === '202002') {
                    $scope.pu_type = 'ANONYMOUS';
                    $scope.presentation_types = ['CompositeText'];
                    $scope.pxpInfo = {
                        name: 'xo_xoon_hermes_mors',
                        pattern: '(xo_xoon_hermes_mors_)(.*)',
                        treatment: 'xo_xoon_hermes_mors_treatment'
                    };
                } else if ($scope.placementCode === '202003') {
                    $scope.className = 'props';
                    $scope.pu_type = 'PERSONAL';
                    $scope.presentation_types = ['GenericComposite'];
                    $scope.pxpInfo = {
                        name: 'xo_mors_hermes_placements_ryi',
                        pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
                        treatment: 'xo_mors_hermes_placements_ryi_treatment'
                    };
                } else {
                    setDefaultValues();
                }

                //  serve ads only if pxp is true, country is US and lang is en
                if (_squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && $scope.placementCode && (0, _squid.$feature)('morsValuePropOffers')) {
                    $scope.marketingOfferData = new _marketingoffer.$MarketingOfferModel({
                        countryCode: $scope.locale.country,
                        page: $scope.pageName,
                        puType: $scope.pu_type,
                        locale: _squid.$locale.lang + '_' + _squid.$locale.country,
                        totalTransactionAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
                        },
                        totalShippingAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
                        },
                        payee: morsOfferFlag ? $scope.payee.merchant.id : '',
                        payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
                        si: morsOfferFlag ? $scope.checkoutSession.id : '',
                        visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
                        targetPlacements: [{
                            'placement_code': $scope.placementCode,
                            'presentation_types': $scope.presentation_types
                        }]
                    });
                    (0, _squid.$pxp)($scope.pxpInfo.name, { 'ctx.COUNTRY': _squid.$locale.country }, $scope.pxpInfo.pattern, false, true).then(function (res) {

                        _logger.$logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
                        if (res && res.treatment_name === $scope.pxpInfo.treatment) {

                            return _marketingoffer.$MarketingOfferModel.instance($scope.token).save({
                                silent: true,
                                data: $scope.marketingOfferData.serialize(),
                                // Ignore all errors from this api, by passing transientError as true
                                transientError: true,
                                success: function success(result) {
                                    var ads_arr = result && result.ads || [];
                                    var adFound = false;

                                    // MORS could serve multiple ads for a given page. Iterate to get the
                                    // correct one based on the ad placement_id
                                    ads_arr.forEach(function (ad) {
                                        var adunit_id = ad.campaign.adunit_id;

                                        if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                            adFound = true;
                                            $scope.ad = {};
                                            var content = ad.content.nvp;
                                            content.forEach(function (obj) {
                                                $scope.ad[obj.name] = obj.value;
                                            });
                                            $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                            $scope.ad['clickUrl'] = ad.tracking.click_url;
                                        }
                                    });

                                    if (adFound) {
                                        $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                                        // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                                        // and 202003 placement_ids as this will already be assigned.

                                        // notify MORS of successful rendering by firing the impressionurl
                                        // beacon and by setting the click url to be fired for future
                                        // conversion.
                                        // setting the placement_id helps to differentiate between multiple ads
                                        // displayed on the same page

                                        _logger.$logger.info('MORS_ad_displayed');
                                        _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                        _angular.$rootScope.$broadcast('MORSDisplayed', {
                                            clickUrl: $scope.ad.clickUrl,
                                            placementId: $scope.placementCode
                                        });
                                    } else {
                                        _logger.$logger.info('MORS_ad_not_found');
                                        setDefaultValues();
                                        _angular.$rootScope.$broadcast('MORSNotDisplayed');
                                    }
                                },

                                error: function error(err) {
                                    setDefaultValues();
                                    _logger.$logger.error('MORS_api_failure', { error: err });
                                }
                            });
                        } else {
                            setDefaultValues();
                            _angular.$rootScope.$broadcast('MORSNotDisplayed');
                        }
                    });
                } else {
                    setDefaultValues();
                    _angular.$rootScope.$broadcast('MORSNotDisplayed');
                }
                $scope.$on('localeChange', function () {
                    setDefaultValues();
                });
            });
        }]
    };
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_squid.$renderContent;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_marketingoffer.$MarketingOfferModel;

_marketingoffer.$fireMORSBeacon;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/merchant-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
    tag: 'xo-merchant-header',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        merchant: {
            type: 'var',
            required: false
        },
        disableId: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var _ref = this.models || {},
                checkoutAppData = _ref.checkoutAppData;

            if (checkoutAppData) {
                // get Merchant display name - can be undefined in which case we have an empty header
                this.merchantDisplayName = checkoutAppData.getMerchantDisplayName();

                if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
                    this.merchant = checkoutAppData.merchant;
                }
            }
        }
    }
});


(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.bind('load', function () {
                var MAX_WIDTH = 780;
                var MAX_HEIGHT = 90;

                if (this.width > MAX_WIDTH) {
                    var ratio = MAX_WIDTH / this.width;
                    var height = this.height * ratio;

                    this.width = MAX_WIDTH;
                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
                }
            });
        }
    };
});

_angular.noop;

_squid.$Component;

_squid.$registerDirective;

_index.$CheckoutAppDataModel;

_index2.$CheckoutInputDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

module.exports = "<header role=\"banner\">\n    <div ng-attr-id=\"{{ props.disableId ? '' : 'header' }}\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchantDisplayName || merchant.brand_name\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n                {{ merchantDisplayName || merchant.brand_name }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchantDisplayName || merchant.brand_name}}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {



var addValidParam = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js").addValidParam;

function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
    var params = {};
    var customData = checkoutCart.get('purchase.custom');

    if (returnToMerchantMethod === 'POST') {
        // TODO: find out why we get postbackData as undefined
        // UPDATE: couldn't reproduce an issue on the stage for now
        if (checkoutSession.postbackData) {
            params = checkoutSession.postbackData;
        }
    } else {
        var transactionDetail = checkoutSession.transactionDetails;

        if (transactionDetail) {
            addValidParam(params, 'tx', transactionDetail.id);
            addValidParam(params, 'st', transactionDetail.state);

            if (transactionDetail.amount) {
                addValidParam(params, 'amt', transactionDetail.amount.total);
                addValidParam(params, 'cc', transactionDetail.amount.currency);
            }
        }

        // Cart uploads can have more than one item so we don't add any in return URL
        if (!is_cart_upload_flow) {
            var itemDetail = checkoutSession.get('itemsList.0');
            if (itemDetail) {
                addValidParam(params, 'item_name', itemDetail.name);
                addValidParam(params, 'item_number', itemDetail.sku);
            }
        }

        addValidParam(params, 'cm', customData);
    }
    return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
 * to know more details about post back data

 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
        if (feature === 'WPS') {
            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
        }
        return {};
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/route-to-complete/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/route-to-complete/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoRouteToComplete', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            /* hide the footer cancel link */
            angular.element('#defaultCancelLink').hide();

            _angular.$rootScope.$on('$stateChangeStart', function (event) {
                event.preventDefault();
            });

            /* hide header paypal logo*/
            $('.paypalHeaderWrapper').hide();

            $('.footerWrapper').addClass('routecss');

            /* urlType is passed from xo-end or from xo-page-components/footer/directive.
            *  urltype can be either success(incase of successfull flow completion ) or cancel
            * */
            var urlType = _uiRouter.$stateParams.urlType;

            // show the return to merchant url only in case of success.
            if (urlType === 'success') {
                $scope.enableSuccessReturnUrl = true;
            }

            if (urlType === 'cancel') {
                // defaulting to False. Once the cancel content is available, turn it to true.
                $scope.enableCancelReturnUrl = true;
            }

            $scope.goToMerchant = function () {
                _angular.$window.onunload = _angular.$window.onbeforeunload = function () {};
                _angular.$window.location = _uiRouter.$stateParams.url;
            };

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {
                $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
            });

            $scope.$on('$destroy', function (event) {
                $('.paypalHeaderWrapper').show();
                $('.footerWrapper').removeClass('routecss');
            });
        }]
    };
});

_squid.$populate;

_uiRouter.$stateParams;

_angular.$rootScope;

_angular.$window;

_index.$CheckoutAppDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$RouteToCompleteRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/route-to-complete/directive.js");

var $RouteToCompleteRoute = exports.$RouteToCompleteRoute = _squid.$ComponentRoute.extend('$RouteToCompleteRoute', {
    name: 'routeToComplete',
    directive: 'xo-route-to-complete',
    titleContent: 'genericError.pleaseTryAgain',
    query: ['url', 'urlType'],
    trackingData: {
        fptiState: 'route-to-complete',
        buzname: {
            'fullpage': {
                'pagename': '%::route-to-complete',
                'pagename2': '%::route-to-complete:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$RouteToCompleteRoute", $RouteToCompleteRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"routecss\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\">{{content('genericMessage.paymentSuccessTitle')}}</div>\n        <div class=\"message\">{{content('genericMessage.successMessage')}}</div>\n        <div ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{content('genericMessage.returnButton')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n        <div ng-if=\"enableCancelReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{merchant ? content('base.cancelUrl', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFirstAmount: _subscriptionTerms2['default'].getFirstAmount,
    getFormattedFirstAmount: _subscriptionTerms2['default'].getFormattedFirstAmount,
    getFormattedAmount: _subscriptionTerms2['default'].getFormattedAmount,
    getItemOptions: _subscriptionTerms2['default'].getItemOptions,
    getItemName: _subscriptionTerms2['default'].getItemName,
    getCurrencyCode: _subscriptionTerms2['default'].getCurrencyCode,
    getTermsText: _subscriptionTerms2['default'].getTermsText,
    getEffectiveDate: _subscriptionTerms2['default'].getEffectiveDate,
    getNumericValueNonZero: _subscriptionTerms2['default'].getNumericValueNonZero
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var BILL_PERIOD_YEAR = 'YEAR';
var TRIAL_SUBSCRIPTION = 'TRIAL';
var REGULAR_SUBSCRIPTION = 'REGULAR';
var INFINITE_CYCLES = 'INFINITE';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case BILL_PERIOD_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    if (amount === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return (0, _squid.formatCurrency)(amount, currencyCode, false);
    }
}

/**
 * This method computes first trial key
 * @returns {string} Content Key for 1st trial, which must be prepended by wpsSubscription.message
 */
function computeFirstTrialKey() {
    if (pluralTimeUnit) {
        // {amount} for the first {timePeriod} {timeUnit}
        return 'firstTrialPeriod.plural';
    } else {
        // {amount} for the first {timeUnit}
        return 'firstTrialPeriod.singular';
    }
}

/**
 * This method computes content key for 2nd trial
 * @returns {string} Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeSecondTrialKey() {
    if (pluralTimeUnit) {
        // Then {amount} for the next {timePeriod} {timeUnit}
        return 'secondTrialPeriod.plural';
    } else {
        // Then {amount} for the next {timeUnit}
        return 'secondTrialPeriod.singular';
    }
}

/**
 * Computes and returns content key for regular subscription
 * There can be 12 variations of regular subscription content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeRegularSubscriptionKey(totalCycles) {
    var key = 'regularSubscriptionPeriod';

    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param subscriptionTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermText(subscriptionTerms, index, currencyCode) {
    var amount = +subscriptionTerms[index].amount,
        billPeriod = subscriptionTerms[index].billPeriod,
        periodType = subscriptionTerms[index].periodType,
        billFrequency = +subscriptionTerms[index].billFrequency,
        totalCycles = +subscriptionTerms[index].totalCycles;
    var contentKey = void 0;
    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === TRIAL_SUBSCRIPTION) {
        if (index === 0) {
            // First Trial
            contentKey = computeFirstTrialKey();
        } else if (index === 1) {
            // Second Trial
            contentKey = computeSecondTrialKey();
        }
    } else if (periodType === REGULAR_SUBSCRIPTION) {
        contentKey = computeRegularSubscriptionKey(totalCycles);
    }
    contentKey = 'wpsSubscription.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

function mapBaResponse(baResponseData) {
    var mappedSubscriptionDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var mappedTerms = [];
    var firstTrialAmount = null;
    var regularAmount = void 0;
    mappedSubscriptionDetails.currencyCode = plan && plan.currency_code;

    if (allTerms) {
        allTerms.forEach(function (eachTerm) {
            var totalCycles = eachTerm.duration === INFINITE_CYCLES ? Infinity : eachTerm.cycles;
            var eachMappedTerm = {
                amount: eachTerm.amount && eachTerm.amount.value / 100,
                billPeriod: eachTerm.frequency,
                periodType: eachTerm.type,
                billFrequency: eachTerm.frequency_interval,
                totalCycles: totalCycles
            };
            if (eachTerm.type === TRIAL_SUBSCRIPTION && eachTerm.index === '1') {
                firstTrialAmount = eachMappedTerm.amount;
            } else if (eachTerm.type === REGULAR_SUBSCRIPTION) {
                regularAmount = eachMappedTerm.amount;
            }
            mappedTerms.push(eachMappedTerm);
        });

        // firstTrialAmount can be zero for free trial, null for no trial
        // and valid value if there is trial amount
        mappedSubscriptionDetails.firstAmount = firstTrialAmount !== null ? firstTrialAmount : regularAmount;
        mappedSubscriptionDetails.subscriptionTerms = mappedTerms;
    }

    return mappedSubscriptionDetails;
}

/**
 * Prepare and return a subscription terms
 * @param baResponseData
 * @returns {Object} Containing Subscription Terms Text
 */
function getTermsText(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);
    var subscriptionTerms = subscriptionDetails.subscriptionTerms;
    var currencyCode = subscriptionDetails.currencyCode;
    var termTextList = [];

    for (var i = 0, len = subscriptionTerms.length; i < len; i++) {
        termTextList.push(prepareIndividualTermText(subscriptionTerms, i, currencyCode));
    }
    return termTextList;
}

/**
 * Returns a un formatted first amount from ba response
 */
function getFirstAmount(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);

    return subscriptionDetails.firstAmount;
}

/**
 * Returns the currency code
 */
function getCurrencyCode(baResponseData) {
    var plan = baResponseData && baResponseData.plan;

    return plan && plan.currency_code;
}

/**
 * Returns a formatted first amount from ba response data
 */
function getFormattedFirstAmount(baResponseData) {
    var amount = getFirstAmount(baResponseData);
    var currencyCode = getCurrencyCode(baResponseData);

    return (0, _squid.formatCurrency)(amount, currencyCode, false);
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.options;
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;

    return name;
}

function getEffectiveDate(baResponseData) {
    return baResponseData && baResponseData.effective_date;
}

function getFormattedAmount(amount, currencyCode) {
    return (0, _squid.formatCurrency)(amount / 100, currencyCode, false);
}

function getNumericValueNonZero(obj, path) {
    var data = parseInt(_squid.$util.getProperty(obj, path), 10);
    return !isNaN(data) && data > 0 && data;
}

module.exports = {
    getFirstAmount: getFirstAmount,
    getFormattedFirstAmount: getFormattedFirstAmount,
    getFormattedAmount: getFormattedAmount,
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getCurrencyCode: getCurrencyCode,
    getTermsText: getTermsText,
    getEffectiveDate: getEffectiveDate,
    getNumericValueNonZero: getNumericValueNonZero
};

_squid.formatCurrency;

_squid.Content;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    /**
     * add non empty key, value to the object
     * @param {Object} object where to add new key, value
     * @param {String} key
     * @param {Any type} value, can not be empty
     * @returns {void}
     */
    addValidParam: function addValidParam(obj, key, val) {
        if (!obj) {
            return;
        }
        if (typeof key === 'string' && key && val !== undefined && val !== null) {
            obj[key] = val;
        }
    },

    // Get PXP context for Messenger feature
    getMessengerPXPContext: function getMessengerPXPContext() {
        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
        var pxpContext = {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
        };

        return pxpContext;
    },

    isDolphinEligibleOnWpsDone: function isDolphinEligibleOnWpsDone(stateName) {
        return (/checkout\.done/.test(stateName) && !!_squid.$util.param('ulToastWpsDone')
        );
    }
}; /* eslint-disable angular/typecheck-string */


_squid.$util;

_squid.$locale;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                type: '@?',
                title: '@?',
                text: '@?',
                textContent: '@?',
                imageUrl: '@?'
            },
            link: function link(scope, element, attrs) {
                if (angular.isString(attrs.imageUrl)) {
                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
                    // to standard size i.e. 150X150 pixels.
                    attrs.$observe('imageUrl', function (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'background-size': '150px 150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    });
                }
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/formatReturnContent.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

Object.defineProperty(exports, '$ReturnToMerchant', {
  enumerable: true,
  get: function get() {
    return _util.$ReturnToMerchant;
  }
});

var _formatReturnContent = __webpack_require__("../node_modules/xo-return-to-merchant/dist/formatReturnContent.js");

Object.defineProperty(exports, 'formatReturnContent', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.formatReturnContent;
  }
});
Object.defineProperty(exports, 'MAX_MERCHANT_NAME_LENGTH', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;
  }
});

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReturnToMerchant = undefined;
exports.goTo = goTo;
exports.postToMerchant = postToMerchant;
exports.postTo = postTo;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goTo(url, forceRedirect) {
    if (!url) {
        return;
    }

    _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
        url: url
    });

    // if V4 in-context integration, we'll terminate and call the close handler.
    if (window.xchild) {
        _logger.$logger.done();
        _angular.$rootScope.$emit('loading');

        var paymentToken = _angular.$rootScope.token;
        var cart = _index2.$CheckoutCartModel.instance(paymentToken);
        var appData = _index2.$CheckoutAppDataModel.instance(paymentToken);
        var orderID = paymentToken;
        var intent = cart.payment_action;
        var billingToken = cart.billing && cart.billing.ba_token;
        var paymentID = appData.payment_id;
        var cancelUrl = url;

        return window.xprops.onCancel({
            paymentToken: paymentToken,
            billingToken: billingToken,
            orderID: orderID,
            paymentID: paymentID,
            intent: intent,
            cancelUrl: cancelUrl
        });
    }

    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
    var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl);

    if (showPaymentSuccess) {
        _logger.$logger.info('redirect', {
            url: url
        });
        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
        };

        // wait until state change is done and then redirect
        // for some reason, in case of webview (invoice flow) and code split
        // when user is redirecting to the return url - dynamic chunk fails to load
        // which triggers reload of the previous page
        return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS',
            returnUrl: url
        })['catch'](function (err) {
            _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                error: err && err.message
            });
        })['finally'](function () {
            _angular.$window.location = url;
        });
    }

    if (forceRedirect) {
        _squid.$util.redirect(url);
    } else {
        var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();

        if (isVZeroIframe) {
            _squid.$util.redirect(url, { redirectImmediateParent: true });
        }

        // If we are not in minibrowser, do a hard redirect
        else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
                _squid.$util.redirect(url);
            } else {

                // Construct a message to send to the parent
                var result = this.postToMerchant({
                    operation: 'return_to_merchant',
                    returnUrl: url,
                    updateParent: true
                });

                // Otherwise we have no choice but to return to the merchant
                if (!result) {
                    _squid.$util.redirect(url);
                }
            }
    }

    var userStatus = function userStatus() {
        _logger.$logger.info('redirected_user_still_on_page_second_checkpoint');
    };

    (0, _angular.$timeout)(function () {
        _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
        (0, _angular.$timeout)(userStatus, 10000);
    }, 10000);
}

function postToMerchant(msg) {

    try {
        msg = _angular2['default'].toJson(msg, 0);

        // If we are not in IE, attempt to send a postMessage
        if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
            _angular.$window.opener.postMessage(msg, '*');
            _logger.$logger.info('minibrowser_postmessage');
            return true;
        }
        // Otherwise, attempt to send a message through the iframe bridge
        var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;

        if (bridge && bridge.returnToParent) {
            bridge.returnToParent(msg);
            _logger.$logger.info('minibrowser_bridgemessage');
            return true;
        }

        _logger.$logger.warn('minibrowser_nopostback');
    } catch (err) {
        _logger.$logger.error('minibrowser_postback_error', {
            error: err.stack || err.toString()
        });
    }

    return false;
}

function postTo(url, msg) {
    var form = document.createElement('form');

    form.method = 'POST';
    form.action = url;
    form.className = 'hide';

    for (var key in msg) {
        var input = document.createElement('input');

        input.name = key;
        input.value = msg[key];
        form.appendChild(input);
    }

    _angular.$window.document.body.appendChild(form);
    form.submit();
    _logger.$logger.info('web_postmessage');
    return true;
}

var $ReturnToMerchant = exports.$ReturnToMerchant = {
    goTo: goTo,
    postToMerchant: postToMerchant,
    postTo: postTo
};

_angular2['default'].value("goTo", goTo);
_angular2['default'].value("postToMerchant", postToMerchant);
_angular2['default'].value("postTo", postTo);
_angular2['default'].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_squid.$util;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/factory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingChangeFactory = $ShippingChangeFactory;

var _util = __webpack_require__("../node_modules/xo-shipping-change/src/util.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $ShippingChangeFactory(token, checkoutAppData, checkoutSession, checkoutCart) {
    return {
        getCartTotal: function getCartTotal() {
            return (0, _util.getCartTotal)(checkoutCart);
        },
        getPayload: function getPayload() {
            return checkoutSession.retrieve().then(function () {
                var shipping = checkoutSession.get('shipping');
                var paymentID = checkoutAppData.get('payment_id');
                var billingToken = checkoutCart.get('billing.ba_token', null);

                return (0, _util.getPayload)(token, paymentID, billingToken, shipping);
            });
        },
        updateCart: function updateCart() {
            return (0, _util.updateCart)(checkoutSession, checkoutCart);
        },
        callOnShippingChange: function callOnShippingChange(payload) {
            var allowChangeShipping = checkoutAppData.get('flags.allow_change_shipping', false);

            if (!allowChangeShipping) {
                return (0, _squid.$promise)({
                    cartHasChanged: false,
                    rejected: false
                });
            }

            return (0, _util.callOnShippingChange)(payload, checkoutCart, checkoutSession);
        }
    };
}

angular.value("$ShippingChangeFactory", $ShippingChangeFactory);
_util.getCartTotal;

_util.getPayload;

_util.updateCart;

_util.callOnShippingChange;

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCartTotal = getCartTotal;
exports.getPayload = getPayload;
exports.updateCart = updateCart;
exports.callOnShippingChange = callOnShippingChange;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function getCartTotal(cart) {
    return {
        currency: cart.get('purchase.amounts.total.currency_code'),
        value: cart.get('purchase.amounts.total.amount')
    };
}

function getPayload(paymentToken, paymentID, billingToken) {
    var shipping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var city = shipping.city,
        state = shipping.state,
        country = shipping.country,
        postal_code = shipping.postal_code;


    var shippingChangePayload = {
        paymentID: paymentID,
        paymentToken: paymentToken,
        orderID: paymentToken,
        billingToken: billingToken,
        shipping_address: {
            city: city,
            state: state,
            country_code: country,
            postal_code: postal_code
        },
        selected_shipping_method: null
    };

    var checkForIxoPaymentDetails = function checkForIxoPaymentDetails() {
        if (!window.xprops || !window.xprops.supplement || !window.xprops.supplement.getPaymentDetails) {
            return (0, _squid.$promise)();
        }

        return window.xprops.supplement.getPaymentDetails(shippingChangePayload.paymentID).then(function (payment) {
            if (payment && payment.selected_shipping_method) {
                return (0, _squid.$promise)(payment.selected_shipping_method);
            }
        });
    };

    return checkForIxoPaymentDetails().then(function (selectedShippingMethod) {
        shippingChangePayload.selected_shipping_method = selectedShippingMethod;
    }).then(function () {
        return shippingChangePayload;
    });
}

function updateCart(session, cart) {
    session.invalidate();

    cart.invalidate();
    cart.api.cache = false;

    return _squid.$promise.all([session.reload(), cart.reload()]).then(function () {
        return getCartTotal(cart);
    });
}

function callOnShippingChange(payload, cart, session) {

    var rejected = false;

    var shippingChangeActions = {
        reject: function reject() {
            rejected = true;
        }
    };

    var cartTotal = getCartTotal(cart);

    return window.xprops.onShippingChange(payload, shippingChangeActions).then(function () {
        return updateCart(session, cart);
    }).then(function (total) {
        var newCartTotal = getCartTotal(cart);
        var cartHasChanged = cartTotal.currency !== newCartTotal.currency || cartTotal.value !== newCartTotal.value;

        return { cartHasChanged: cartHasChanged, rejected: rejected };
    });
}

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.thirdPartyExperience = exports.venmoExperience = exports.thirdPartyInfo = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _sessionStorage = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var BA = 'BILLING_AGREEMENT';

var readCookie = function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0, len = ca.length; i < len; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

var thirdPartyInfo = exports.thirdPartyInfo = {
    /**
     * @name isThirdPartyEligible
     * @returns {Promise}
     */
    isThirdPartyEligible: function isThirdPartyEligible() {
        var _this = this;

        return this.isBaiduEligible().then(function (baiduEligibility) {
            return _this.isVenmoEligible() || baiduEligibility;
        });
    },


    /**
     * @name isBaiduEligible
     * @returns {Promise}
     */
    isBaiduEligible: function isBaiduEligible() {
        return _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token, {
            params: {
                geolocation: _squid.$meta.geolocation
            }
        }).retrieve().then(function (eligibility) {
            _logger.$logger.info('baidu_eligibility', eligibility);
            return eligibility.baiduWallet;
        });
    },


    /**
     * @name isVenmoEligible
     * @description Handler to call to determine if user can use Venmo
     * @returns {Boolean}
     */
    isVenmoEligible: function isVenmoEligible() {
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        var isBillingAgreement = cart.isBilling();
        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookie = this.isVenmoCookiePresent();
        var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
        var isMSPTransaction = cart.isMultiSellerPurchase();
        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookie: isVenmoCookie,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US',
            isNotSFAuthenticationSession: !isSFAuthenticationSession,
            isNotMSPTransaction: !isMSPTransaction
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookie ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },


    /**
     * @name isVenmoCookiePresent
     * @returns {Boolean}
     */
    isVenmoCookiePresent: function isVenmoCookiePresent() {
        var cookieValue = readCookie(PWV_COOKIE);

        return Boolean(cookieValue);
    },


    /**
     * @name buildVenmoURL
     * @description Build the venmo URL scheme
     * @returns {String}
     */
    buildVenmoURL: function buildVenmoURL() {
        // SCHEME needs to change according to old or new experience
        // const linkType = venmoUrlSchemeType();
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var token = void 0;
        var total = void 0;
        var currency = void 0;
        var intent = void 0;

        // Send BA token instead of EC token for a billing agreement purchase
        token = cartModel.get('billing.ba_token') ? cartModel.get('billing.ba_token') : _angular.$rootScope.token;
        // For BA: setting billing agreement as payment_action explicitly, not relying on payment action returned in cart
        intent = cartModel.billing ? BA : cartModel.payment_action;

        // total cannot be undefined, outdated venmo app clients will crash otherwise
        total = cartModel.get('purchase.amounts.total.amount', '0');
        currency = cartModel.get('purchase.amounts.total.currency_code', 'none');

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': token,
            total: total,
            currency: currency, // can be undefined for BA w/o purchase
            intent: intent
        });

        return SCHEME + '?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

var allowedThirdPartyExperiences = {
    VENMO: 'VENMO_EXPERIENCE',
    BAIDU: 'BAIDU_EXPERIENCE'
};

var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';

var thirdPartyExperience = exports.thirdPartyExperience = {
    setAsVenmoExperience: function setAsVenmoExperience(token) {
        var _JSON$stringify;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    setAsBaiduExperience: function setAsBaiduExperience(token) {
        var _JSON$stringify2;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    isThirdPartyExperience: function isThirdPartyExperience(token) {
        var availableExperiences = [];

        for (var key in allowedThirdPartyExperiences) {
            availableExperiences.push(allowedThirdPartyExperiences[key]);
        }

        var currentExperience = this.getExperience(token);

        return Boolean(availableExperiences.indexOf(currentExperience) > -1);
    },
    getExperience: function getExperience(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        // if logged in, and guest, we return the experience if any
        if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
            var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');

            return payload && payload[token] || 'MEMBER_EXPERIENCE';
        } else {
            // If not logged in, we reset the third party experience
            this.resetThirdPartyExperience();
            return 'MEMBER_EXPERIENCE';
        }
    },
    resetThirdPartyExperience: function resetThirdPartyExperience() {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
    }
};

_squid.$config;

_squid.$util;

_squid.$meta;

_logger.$logger;

_auth.$AuthModel;

_index.$DeviceInfo;

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports['default'] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
    try {

        window['sessionStorage'].setItem('__feature_test__', '0');
        window['sessionStorage'].removeItem('__feature_test__');
        return window.sessionStorage;
    } catch (err) {
        return {
            getItem: function getItem(key) {
                if (arguments < 1) {
                    throw new Error('1 argument required');
                }
                return store[key];
            },
            setItem: function setItem(key, val) {
                if (arguments < 2) {
                    throw new Error('2 arguments required');
                }
                store[key] = val;
            },
            removeItem: function removeItem(key) {

                delete store[key];
            }
        };
    }
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-title/dist/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoTitle', [function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            titleTxt: '@?',
            className: '@?',
            tagName: '@?'
        },
        link: function link($scope, $element) {
            if ($scope.tagName) {
                var newEl = document.createElement($scope.tagName || 'h1');

                newEl.className = $scope.className || 'alpha';
                newEl.textContent = '{{ titleTxt }}';
                (0, _angular.$compile)(newEl)($scope);
                $element.empty().append(newEl);
            }
        }
    };
}]);

/***/ }),

/***/ "../node_modules/xo-title/dist/template.html":
/***/ (function(module, exports) {

module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "../node_modules/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$FptiBuilder', function () {
    /**
     *  Build the front-end FPTI event from three data sources
     *      1. the per-product configuration
     *      2. the buzname defined per-route
     *      3. the additional attributes that only available at a specific checkpoint
     *
     */

    return _squid.$Class.extend('FptiBuilder', {

        resolvePageQualifier: function resolvePageQualifier(trackingData) {
            // The pages can populated pageQualifier to override the default one
            this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
            // because 'fullpage' has been widely embedded into routes
            // we had better to keep it as a place holder
            : 'fullpage'; // update later if it's in-context
        },

        build: function build() {

            if (!this.trackingData && !this.error) {
                // do nothing if neither page nor error tracking
                return this;
            }

            this.resolvePageQualifier(this.trackingData);

            this._dataObj = new _model.$FptiDataModel().decorate('base', this.baseData).decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', (0, _squid.$getLatestCorrelationID)()).decorate('uuid', _model.$CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);

            return this;
        },

        toString: function toString() {
            var dataAry = [];

            _angular2['default'].forEach(this._dataObj, function (v, k) {
                dataAry.push(k + '=' + v);
            });

            return dataAry.join('&');
        }
    });
});

_squid.$getLatestCorrelationID;

_squid.$Class;

_model.$FptiDataModel;

_model.$CalDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$ButtonTrackingService', function () {
    var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
    var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
    var _alreadyFired = false;

    function _strToElements(str) {
        var elements = {};

        if (str && str.length) {
            str.split('&').forEach(function (param) {
                var nvp = param.split('=');

                elements[nvp[0]] = nvp[1];
            });
        }
        return elements;
    }

    function _fireButtonTrackingBeacon(elements) {
        var url = _beaconUrl;
        var xoData = {};

        function buildParam(param, value) {
            var p = '&' + param + '=' + (value ? value : 'null');

            return p;
        }

        function getGUIID(ts) {
            return _strToElements(ts).vr;
        }

        function addToDocument(uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);
        }

        // Get some params from FPTI data.
        _beaconParams.forEach(function (param) {
            url += buildParam(param, elements[param]);
        });

        // Build the rest of the params.
        url += buildParam('fpti', getGUIID(_squid.$cookies && _squid.$cookies.ts));
        url += buildParam('WWW_AKA_MVT_BUTTONS', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_BUTTONS);
        url += buildParam('WWW_AKA_MVT_ID', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_ID);
        url += buildParam('ip', _squid.$meta && _squid.$meta.ipaddress);

        if (_angular.$rootScope.token) {
            (0, _squid.$populate)(xoData, {
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                appData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                url += buildParam('mrid', xoData.payee && xoData.payee.getId());
                url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
                addToDocument(url);
            });
        } else {
            url += buildParam('mrid', null);
            url += buildParam('calf', null);
            addToDocument(url);
        }
    }

    return {
        fireBeacon: function fireBeacon(fptiData) {
            if (!_alreadyFired && fptiData) {
                var elements = _strToElements(fptiData);

                // Fire the beacon if this is a page render.
                if (elements.page) {
                    _alreadyFired = true;
                    return _fireButtonTrackingBeacon(elements);
                }
            }
        },
        resetAlreadyFired: function resetAlreadyFired() {
            _alreadyFired = false;
        }
    };
});

_angular.$rootScope;

_squid.$meta;

_squid.$cookies;

_squid.$populate;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/button.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module('tracking.directive', ['ui.router']).directive('trackSubmit', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var transition = attr && attr.trackSubmit;
                var trackSubmit = {
                    currentRoute: _uiRouter.$state.current,
                    transition: transition,
                    errors: []
                };

                _angular2['default'].forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                    var elem = $(el);
                    var elementId = elem.attr('id');
                    var elementName = elem.attr('name');
                    var errorKey = elem.attr('data-error-key');
                    var errorText = elem.has('required') ? 'required' : 'no error key';
                    var fieldName = elementId ? elementId : elementName;

                    if (!fieldName) {
                        var elementModel = elem.attr('ng-model');

                        fieldName = elementModel ? elementModel : 'unnamed-field';
                    }

                    trackSubmit.errors.push({
                        fieldName: fieldName,
                        errorMessage: errorKey ? errorKey : errorText
                    });
                });

                _angular.$rootScope.$broadcast('trackSubmit', trackSubmit);
            });
        }
    };
}).directive('trackLink', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var state = attr && attr.trackLink;

                if (state) {
                    var trackLink = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };

                    _angular.$rootScope.$broadcast('trackLink', trackLink);
                }
            });
        }
    };
}).directive('trackClick', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = attr && attr.trackClick;

                if (state) {
                    var trackClick = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };
                    _angular.$rootScope.$broadcast('trackClick', trackClick);
                }
            });
        }
    };
}).directive('trackInput', function () {
    /*
    * Track an input tag with track-input attribute
    * you can use the value of track-input attribute as
    * a tracking attr Eg.: track-input="xo_guest_yes"
    */
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = void 0;

                if (event.target.type === 'checkbox') {
                    if (event.target.checked) {
                        state = attr && attr.trackInput + '_CHECKED';
                    } else {
                        state = attr && attr.trackInput + '_UNCHECKED';
                    }
                } else {
                    state = attr && attr.trackInput;
                }

                var trackInput = {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                };

                if (state) {
                    trackInput.transition = state;
                }

                _angular.$rootScope.$broadcast('trackInput', trackInput);
            });
        }
    };
});

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fpti', function () {
    var _beaconUrl = void 0;

    // Logic to switch between production/staging urls. This way we don't pollute live logs,
    // and we are able to test on stage using the fpti log viewing tool.
    if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
        _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
    } else {
        _beaconUrl = _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    return {
        // Get all the tracking data defined at the page level
        getPageTrackingData: function getPageTrackingData(route) {
            route = route || {};

            var trackingData = route.trackingData || {};
            var routeParent = route.parent;

            trackingData.token = _angular.$rootScope.token;

            while (routeParent) {
                trackingData = _angular2['default'].merge({}, routeParent.trackingData || {}, trackingData);
                routeParent = routeParent.parent;
            }
            return trackingData;
        },

        setupDataString: function setupDataString(route, err, data) {
            var trackingData = this.getPageTrackingData(route);
            var PAYPAL = window && window.PAYPAL;

            var fptiData = void 0;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                var payload = {
                    baseData: window.meta.fpti,
                    trackingData: trackingData,
                    error: err,
                    isInContext: _angular.$rootScope.miniBrowser
                };

                _angular2['default'].extend(payload, data || {});
                fptiData = new _builder.$FptiBuilder(payload).build().toString();

                // FPTI client side tracking only if we have template
                if (route && route.template && _angular2['default'].isFunction(PAYPAL.analytics.setup)) {
                    PAYPAL.core.pta = PAYPAL.analytics.setup({
                        data: fptiData,
                        url: _beaconUrl
                    });
                }
            }
            return fptiData;
        }
    };
}).factory('$fptiError', function () {
    function stringifyErrorMessage(msg) {
        return encodeURIComponent(_angular2['default'].isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
        : (_angular2['default'].toJson(msg) || 'undefined').substring(0, 128));
    }

    return _squid.$Error.extend({
        construct: function construct(err) {
            if (!err) {
                return;
            }
            this.type = err.type;
            this.field = err.field;
            this.msg = stringifyErrorMessage(err.message || err.error);
            this.code = err.code || err.cause;
        }
    });
});

_squid.$config;

_squid.$Error;

_builder.$FptiBuilder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-tracking/dist/listener.js"), __webpack_require__("../node_modules/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    // Declare the dependency to register the listeners
    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

var _button = __webpack_require__("../node_modules/xo-tracking/dist/button.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // eslint-disable-line max-statements
    var token = window.meta.token;
    // logAppName is the appname from meta.js. if the logAppName is not defined, default it to 'appNameNotDefined'.
    var appName = _squid.$meta.logAppName || 'appNameNotDefined';
    var addTrackingData = function addTrackingData(object) {
        return _squid.$util.extend(object, {
            dc: _squid.$meta.dc,
            az: _squid.$meta.az,
            cust: _index.$AuthModel.instance().buyer_id || '',
            comp: appName
        });
    };
    var cplSettings = _squid.$config.enableCPL;
    var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || (0, _squid.$experiment)('cpl_tracking', cplSettings.throttle, token));
    var cplEnabled = passesCplThrottle || _squid.$util.params().forceEnableCPL;

    function logTransition(state) {
        return !(state.trackingData && state.trackingData.suppressTransitionLog);
    }

    function logStateExit(state) {
        return state.trackingData && state.trackingData.trackStateExit;
    }

    function getBeaconUrl() {
        // Logic to switch between production/staging urls. This way we don't pollute live logs,
        // and we are able to test on stage using the fpti log viewing tool.
        return _squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
        : _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    /*
    * Triggers pa.js recordClick with custom parameters
    */
    function fptiCustomRecordClick(route, customData) {
        var analyticsInstance, fptiData, fptiDataObj;
        var PAYPAL = window.PAYPAL;

        if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
            PAYPAL.core = PAYPAL.core || {};

            analyticsInstance = new PAYPAL.analytics.Analytics();

            fptiData = new _builder.$FptiBuilder({
                trackingData: route.trackingData,
                isInContext: _angular.$rootScope.miniBrowser,
                comp: appName
                // ... Other flow data pass-in here to resolve page qualifier
            }).build();

            // Grab the fpti data object and extend with custom params
            // The fpti data obj should include pxp params as well
            fptiDataObj = fptiData._dataObj;
            $.extend(fptiDataObj, customData);

            analyticsInstance.setRequestData(fptiDataObj);
            analyticsInstance.recordClick({
                url: getBeaconUrl()
            });
        }
    }

    _angular.$rootScope.$on('trackInput', function (event, trackInput) {
        if (!trackInput) {
            return;
        }
        var customData = {
            link: trackInput && trackInput.transition,
            page: trackInput && trackInput.page
        };

        fptiCustomRecordClick(trackInput.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackClick', function (event, trackClick) {
        if (!trackClick) {
            return;
        }
        var customData = {
            link: trackClick && trackClick.transition
        };

        fptiCustomRecordClick(trackClick.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackSubmit', function (event, trackSubmit) {
        if (!trackSubmit) {
            return;
        }
        var currentRoute = trackSubmit && trackSubmit.currentRoute;
        var routeName = currentRoute ? currentRoute.name : 'noRoute';

        _logger.$logger.info('track_submit', {
            route_name: routeName
            // ID stuff here later
        });

        if (logTransition(currentRoute)) {
            routeName = routeName.replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
            var transition = trackSubmit.transition || state;

            _logger.$logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: transition
            });
        }

        if (trackSubmit.errors && trackSubmit.errors.length) {
            var fptiFieldErrors = JSON.stringify(trackSubmit.errors);

            _logger.$logger.info('checkout_fpti', {
                form_field_errors: fptiFieldErrors
            });
        }

        var errors = trackSubmit.errors;

        if (_angular2['default'].isArray(errors)) {
            errors.forEach(function (err) {
                _logger.$logger.debug('track_submit_error', err);
                if (_fpti.$fpti) {
                    _fpti.$fpti.setupDataString(currentRoute, new _fpti.$fptiError({
                        type: 'fieldError',
                        field: err.fieldName,
                        code: err.errorMessage
                    }));
                }
            });

            if (errors.length) {
                _logger.$logger.flush(true);
            }
        }
    });

    _angular.$rootScope.$on('unhandled_error', function (event, exception) {
        if (_fpti.$fpti) {
            _fpti.$fpti.setupDataString(exception.currentRoute, new _fpti.$fptiError({
                type: 'pageError',
                message: exception.message,
                code: exception.cause
            }));
        }
    });

    _angular.$rootScope.$on('trackLink', function (event, trackLink) {
        if (!trackLink) {
            return;
        }

        var currentRoute = trackLink.currentRoute;
        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

        _logger.$logger.info(routeName + '_exit', {
            fptiState: state,
            fptiTransition: trackLink.transition
        });
    });

    _angular.$rootScope.$on('$transition', function (event, data) {
        (0, _angular.$timeout)(function () {
            if (_fpti.$fpti) {
                var fptiData = _fpti.$fpti.setupDataString(data.toState, null, addTrackingData({
                    transition_time: data.duration
                }));

                // This seems to conflict with CPL data, so don't fire if CPL
                if (!cplEnabled) {
                    // Fire and forget button tracking beacon.
                    _button.$ButtonTrackingService.fireBeacon(fptiData);
                }
            }
        });
    });

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        var from = fromState && fromState.name.replace(/\./g, '_');
        var to = toState && toState.name.replace(/\./g, '_');

        if (from && logTransition(fromState) && logStateExit(fromState)) {
            var trackingData = fromState.trackingData && fromState.trackingData || {};

            _logger.$logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
        }

        _logger.$logger.info('state_change', {
            from: from || 'start',
            to: to || 'end'
        });

        // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
        if (toState.template) {
            _model.$CalDataModel.generateMetaIds();
        }

        _angular.$rootScope.currentState = to;

        if (to && logTransition(toState)) {
            _logger.$logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
        }
    });

    _angular.$rootScope.$on('page_loaded', function (event, from, to) {
        if (from !== 'checkout_init') {
            return;
        }
        var key = _model.$FptiConstants.stateName[to] || 'review';
        var landing_page = _model.$FptiConstants.landing_page[key];

        _logger.$logger.info('landing_page', {
            'from': landing_page,
            'to': 'process_page_loaded',
            fpti_landing_page: landing_page
        });
    });

    _angular.$rootScope.$on('page_reloaded', function () {
        _logger.$logger.flush(true);
        _model.$CalDataModel.generateMetaIds();
    });

    _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
        var to = toState.name.replace(/\./g, '_');

        if (toState.hasResolver && to) {
            _logger.$logger.info(to + '_load');
        } else if (to) {
            _logger.$logger.info(to + '_rendering');
        }
    });

    _angular.$rootScope.$on('addrDiff', function (event, addrDiff) {
        if (!addrDiff) {
            return;
        }
        _logger.$logger.info('checkout_fpti' + addrDiff);
    });

    function getHash(url) {
        if (!url || !~url.indexOf('#')) {
            // eslint-disable-line no-bitwise
            return;
        }

        url = url.split('#');
        return url[url.length - 1];
    }

    var oldHash = window.location.hash;

    window.addEventListener('hashchange', function (event) {
        _logger.$logger.info('hashchange', {
            from: getHash(event.oldURL || oldHash),
            to: getHash(event.newURL || window.location.hash)
        });

        if (!_squid.$loader.isLoading()) {
            _logger.$logger.flush();
        }

        oldHash = window.location.hash;
    });

    $(document).on('click', function (event) {
        if (event && event.target && event.target.tagName) {
            var name = event.target.tagName.toLowerCase();

            if (event.target.id) {
                name += '#' + event.target.id;
            } else if (event.target.attributes && event.target.attributes['ng-model']) {
                name += ':' + event.target.attributes['ng-model'].value;
            } else if (event.target.className) {
                name += '.' + event.target.className.split(' ').join('.');
            }

            _logger.$logger.info('click', { el: name });
        }
    });

    if (cplEnabled) {
        window.fptiserverurl = getBeaconUrl();

        var firstInvocation = true;
        var trackPageStart = function trackPageStart() {
            if (firstInvocation) {
                firstInvocation = false;
                return;
            }
            try {
                window.PAYPAL.analytics.startCPLTracking();
            } catch (e) {
                console.log('error starting cpl tracking ' + e);
            }
        };

        var firstDone = true;
        var trackDone = function trackDone(beaconData) {
            window.PAYPAL.analytics.endCPLTracking({
                pageData: addTrackingData(beaconData),
                inferStart: firstDone
            });
            firstDone = false;
        };

        var currentRoute = null;

        _angular.$rootScope.$on('startLoad', function () {
            return trackPageStart();
        });
        _angular.$rootScope.$on('$stateChangeSuccess', function (e, route) {
            currentRoute = route;
        });

        _angular.$rootScope.$on('allLoaded', function () {
            try {
                var buildParams = {
                    productOverride: window.fptiProductOverride,
                    trackingData: _fpti.$fpti.getPageTrackingData(currentRoute)
                };
                var legacyFptiData = new _builder.$FptiBuilder(buildParams).build()._dataObj;
                var product = window.fptiProductOverride || 'ec';

                legacyFptiData.pgrp = 'main:' + product + ':hermes';
                legacyFptiData.flid = token;
                trackDone(legacyFptiData);
            } catch (e) {
                console.log('error tracking CPL data ' + e);
            }
        });
    }
});

_index.$AuthModel;

_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$experiment;

_squid.$loader;

_logger.$logger;

_model.$CalDataModel;

_model.$FptiConstants;

_builder.$FptiBuilder;

_button.$ButtonTrackingService;

_fpti.$fpti;

_fpti.$fptiError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular); /* eslint-disable angular/di */


_angular2['default'].module().constant('$FptiConstants', {
    // The prototype of buzname data object
    buznameMap: {
        flowgatename: {
            placeHolder: '',
            fptiKey: 'fltp'
        },
        'flowname': {
            placeHolder: 'ec:hermes:',
            fptiKey: 'flnm'
        },
        'hier1': {
            placeHolder: 'main_ec_hermes_',
            fptiKey: 'shir'
        },
        'inout': {
            placeHolder: 'inout',
            fptiKey: 'lgin'
        },
        'pagename': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'pgrp'
        },
        'pagename2': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'page'
        },
        'version': {
            placeHolder: 'hermes',
            fptiKey: 'vers'
        }
    },
    // Full list of FPTI keys indexed by readable names
    // This mapping can also be served as default decorator
    fptiKeys: {
        'businessType': 'bztp',
        'correlationId': 'calc', // CalDataModel
        'cust': 'cust',
        'errorCode': 'eccd',
        'fieldError': 'erfd',
        'flowgatename': 'fltp', // buzname
        'flowname': 'flnm', // buzname
        'loggedIn': 'lgin', // buzname
        'merchantId': 'mrid',
        'merchantType': 'mbtp',
        'pageError': 'erpg',
        'pageGoal': 'goal', // route
        'pageGroup': 'pgrp', // buzname
        'pageName': 'page', // buzname
        'pageQualifer': 'qual', // buzname
        'pageStartTime': 'pgst', // FptiBuilder
        'pageTechnologyFlag': 'pgtf', // productConfig
        'paymentFlowId': 'pfid',
        'rLogId': 'teal',
        'sessionId': 'fpti',
        'siteHierarchy': 'shir', // buzname
        'sourceCi': 's', // productConfig
        'tealeaf': 'teal',
        'templateName': 'tmpl', // route
        'transition_time': 'transition_time',
        'uuid': 'csci', // CalDataModel
        'version': 'vers', // buzname
        'visitorId': 'vid',
        'ecToken': 'fltk', // metadata
        'pxpExpSelected': 'xe',
        'pxpTreatementSelected': 'xt',
        'pxpQualifiedTreatment': 'qt',
        'pxpContextId': 'qc',
        'dc': 'dc',
        'az': 'az',
        'comp': 'comp'
    },
    landing_page: {
        login: 'LOGIN',
        econsent: 'eConsent',
        review: 'Review',
        error_page: 'error_page',
        add_card: 'add_card',
        add_bank: 'add_bank',
        billing: 'billing',
        done_page: 'done_page',
        shoppingCart: 'shoppingCart',
        emptyCart: 'emptyCart',
        soldout: 'soldout',
        openButton: 'openButton'
    },
    stateName: {
        checkout_login: 'login',
        checkout_genericError: 'error_page',
        checkout_fastlogin: 'login',
        checkout_econsent: 'econsent',
        checkout_review: 'review',
        checkout_pageAddCard_addCardFlow_addCard: 'add_card',
        checkout_updateCard_addCardFlow_addCard: 'add_card',
        checkout_pageAddFi_bank_add: 'add_bank',
        guest: 'billing',
        checkout_done: 'done_page',
        checkout_guest: 'billing',
        checkout_signup: 'billing',
        guestupgrade_genericError: 'error_page',
        checkout_multistepsignup_multistepsignupaddcard: 'billing',
        checkout_shoppingCart: 'shoppingCart',
        checkout_emptyCart: 'emptyCart',
        checkout_soldout: 'soldout',
        checkout_openButton: 'openButton'
    }
}).factory('$FptiDataModel', ['$FptiConstants', function ($FptiConstants) {
    var productConfig = {};

    // TODO to read from config.json
    productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
    productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

    /**
     * Utilizing Decorator pattern to allow defining additional logic for specific keys
     */
    return _squid.$Class.extend('FptiDataModel', {
        init: function init() {
            this._dataObj = _angular2['default'].extend({}, productConfig);
            this._decoratorList = [];
        },
        decorators: {
            buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
                if (!trackingData) {
                    return;
                }

                var buzname = trackingData.buzname;

                if (!buzname) {
                    return;
                }

                var buznameDiff = buzname[pageQualifier];

                if (!buznameDiff) {
                    return;
                }

                var dataObj = this._dataObj;
                var buznameMap = $FptiConstants.buznameMap;
                // read app specific place holder from config
                var placeHolderConfig = _squid.$config && _squid.$config.fpti && _squid.$config.fpti.buznameEntryPlaceHolder;

                Object.keys(buznameMap).forEach(function (key) {
                    var buznameEntry = buznameMap[key];
                    var fptiKey = buznameEntry.fptiKey;
                    var placeHolder = buznameEntry.placeHolder;

                    if (buznameDiff[key]) {
                        if (placeHolderConfig && placeHolderConfig[key]) {
                            placeHolder = placeHolderConfig[key];
                        }

                        if (productOverride) {
                            var _placeHolder$split = placeHolder.split(':'),
                                main = _placeHolder$split[0],
                                hermes = _placeHolder$split[2];

                            placeHolder = main + ':' + productOverride + ':' + hermes;
                        }

                        dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
                    } else {
                        dataObj[fptiKey] = placeHolder;
                    }
                });
                dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
            },

            base: function base(_base) {
                if (_base) {
                    for (var key in _base) {
                        if (!this._dataObj[key]) {
                            this._dataObj[key] = _base[key];
                        }
                    }
                }
            },

            locale: function locale(_locale) {
                if (_locale && _locale.country) {
                    this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
                }
            },

            pxptrackingdata: function pxptrackingdata(pxpData) {
                var qt = [];
                var qc = [];
                var xe = [];
                var xt = [];

                _squid.$util.some(pxpData, function (trackInfo) {
                    var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');

                    if (match) {
                        qt.push(match[1]);
                    }

                    match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
                    if (match) {
                        qc.push(match[1]);
                    }

                    _squid.$util.some(trackInfo.treatments, function (treatment) {
                        xe.push(treatment.experiment_id);
                        xt.push(treatment.treatment_id);
                    });
                });

                this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
            },

            templateName: function templateName(trackingData, pageQualifier, isInContext) {
                if (trackingData && trackingData.templateName) {
                    var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');

                    this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
                }
            },

            fieldError: function fieldError(err) {
                if (err && err.type === 'fieldError') {
                    this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            },

            pageError: function pageError(err) {
                if (err && err.type === 'pageError') {

                    this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            }

        },
        decorate: function decorate(name) {
            this._decoratorList.push({
                name: name,
                params: Array.prototype.slice.call(arguments, 1)
            });
            return this;
        },
        getDataObject: function getDataObject(isInContext) {
            var i;
            var decorator;

            for (i = 0; i < this._decoratorList.length; i++) {
                decorator = this._decoratorList[i];
                if (!decorator) {
                    continue;
                }
                var name = decorator.name;
                var params = decorator.params;

                if (_angular2['default'].isFunction(this.decorators[name])) {
                    // Invoke the decorator and pass in the parameter list
                    this.decorators[name].apply(this, params);
                } else {
                    var fptiKey = $FptiConstants.fptiKeys[name];

                    // If the fptiKey is defined and value is present, add the k-v pair
                    if (fptiKey && params && params.length > 0) {
                        this._dataObj[fptiKey] = params[0];
                    }
                }
            }

            // 'fullpage' was widely used as default key in page routs definition
            // finally replace it here if it's incontext
            var dataObj = this._dataObj;

            if (isInContext) {
                Object.keys(dataObj).forEach(function (k) {
                    if (_angular2['default'].isString(dataObj[k])) {
                        // some values can be number
                        dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
                    }
                });
            }

            return this._dataObj;
        }
    });
}]).factory('$CalDataModel', function () {
    var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';

    function _generateCorrelationId() {
        var uidRandomArr = (_uuid2['default'].v4() || uuid_v4_mask).split('-');
        var uidTime = (_uuid2['default'].v1() || uuid_v1_mask).split('-');

        return uidTime[0] + uidRandomArr[0].substr(0, 5);
    }

    function _generateUUID() {
        return (_uuid2['default'].v4() || uuid_v4_mask).replace(/-/g, '');
    }

    var CalModel = _squid.$Model.extend({
        _calCorrId: _generateCorrelationId(),
        _uuid: _generateUUID(),

        generateCalCorrId: function generateCalCorrId() {
            this._calCorrId = _generateCorrelationId();
        },
        generateUUID: function generateUUID() {
            this._uuid = _generateUUID();
        },
        generateMetaIds: function generateMetaIds() {
            this.generateCalCorrId();
            this.generateUUID();
        },

        getCalCorrId: function getCalCorrId() {
            return this._calCorrId;
        },

        getUUID: function getUUID() {
            return this._uuid;
        }
    });

    return new CalModel();
});

_squid.$Model;

_squid.$Class;

_squid.$util;

_squid.$config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/model.js"))

/***/ }),

/***/ "../node_modules/xo-tray-height/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

/** Name:  Tray height helper */
angular.module().directive('xoTrayHeight', function () {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            // Check to see if we can use the safer full height approach
            // or if we need to fallback to calculating the height using
            // math and relying on the "right" timing.
            var topClass = 'xo-sidebar-wrapper';
            var topSelector = '.' + topClass;
            var topElem = document.querySelector(topSelector);
            var inScope = topElem && topElem.querySelector('[xo-tray-height]');
            var useNewFlow = topElem && inScope;

            /**
             * NOTE:
             * The following code, despite being the "new" flow, is still
             * a stopgap solution until such time as the markup and or
             * CSS undergo an overhaul. It relies on the more stable
             * cascading relative/absolute positioning and 100% height
             * *and* the fact that the code is an instance of xo-tray-height
             * within the xo-sidebar-wrapper.
             */
            function calculate() {
                var curElem = element[0];

                while (!~curElem.className.indexOf(topClass)) {
                    var style = getComputedStyle(curElem, null);

                    if (style.position !== 'absolute') {
                        curElem.style.position = 'relative';
                    }
                    curElem.style.height = '100%';
                    curElem = curElem.parentNode;
                }
            }

            /**
             * NOTE:
             * The following DEPRECATED version of the calculate method
             * relies on calculating the heights using math. This heavy
             * handed approach is fine if it is called at the right times
             * and often enough; however, this criteria is hard to achieve.
             *
             * A markup and styles overhaul is recommended to do away with
             * both of these methods.
             */
            function deprecatedCalculate() {
                // DEPRECATED
                _logger.$logger.warn('xo-tray-height-fallback', {
                    message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
                });
                var height;
                var headerHeight;
                var mainHeight;
                var trayMinheight = 400;
                var asideContentHeight;
                var $aside = $(element).parents('aside:visible');
                var $asideContent = $aside.find('.asideContent');

                if (!$aside || !$asideContent) {
                    return;
                }

                // Updates the tray height to the section height
                headerHeight = $aside.find('.header').outerHeight(true);
                mainHeight = $('#main').outerHeight(true);

                height = mainHeight - headerHeight;
                asideContentHeight = $asideContent.outerHeight(true);
                if ($scope.miniBrowser) {
                    $aside.find('.aside').css('height', '534px');
                    var minHeight = 534 - headerHeight;

                    $asideContent.css('height', minHeight);
                } else if (asideContentHeight > height) {
                    $asideContent.css('height', height);
                    $aside.find('aside:visible').addClass('hasScroll');
                } else {
                    height = height > trayMinheight ? height : trayMinheight;
                    $asideContent.css('height', height);
                    $aside.removeClass('hasScroll');
                }
            }

            if (useNewFlow) {
                calculate();
            } else {
                (0, _angular.$timeout)(deprecatedCalculate, 1);

                $scope.$on('SidebarError', function () {
                    deprecatedCalculate();
                });
            }
        }
    };
});

/* grab the logger so we can warn about being in the fallback mode */


_angular.$timeout;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adds role='button' and tabindex='0' to anchor elements
// so that it is keyboard navigable and recognized by screen
// readers as a button.
//
// As anchors without href do not fire their click event
// automatically on a Space or ENTER key, this directive forces
// that functionality.
//
// If something is assigned to the link-button attribute, then
// it is used as an aria-label.
(0, _squid.$registerDirective)('link-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
            var $element = (0, _jquery2['default'])(element);

            $element.attr('role', 'button');
            $element.attr('tabindex', '0');
            if (ariaLabel) {
                $element.attr('aria-label', ariaLabel);
            }
            $element.on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive gives an element characteristics of a native
// select element in terms of keyboard navigation. It becomes reachable
// via the tab key, reflects screenreader characteristics and
// can be activated by any of the DOWN, SPACE or ENTER KEYS.
(0, _squid.$registerDirective)('select-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var $element = (0, _jquery2['default'])(element);
            if (!attrs.hasOwnProperty('disableRole')) {
                $element.attr('role', 'button');
            }

            $element.attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive makes a container with links act as if it were a select dropdown
// in terms of keyboard accessibility. The following characteristics are implemented:
//
// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
// * ESC cancels and closes the dropdown
// * SPACE or ENTER select an option
// * You cannot TAB out of a dropdown until you select or cancel
//
// in addition, the following extra characteristics are implemented
//
// * The TAB (and SHIFT-TAB) key will also function to move between options
// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
//
// How to use:
// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
//    The expression is run whenever the ESC key is pressed.
// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
//    tabs to escape the select-box element.
(0, _squid.$registerDirective)('select-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);

            function escapeToggle() {
                if (attrs.selectCancel) {
                    (0, _angular.$parse)(attrs.selectCancel)(scope);
                    scope.$apply();
                }
            }

            element.attr('role', 'menu');

            element.on('keydown.selectBox', function (event) {
                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                var $origin = (0, _jquery2['default'])(event.target);

                if (!(event.altKey || event.ctrlKey)) {
                    var index = $allTabbable.index($origin);

                    switch (event.keyCode) {
                        case _ui.KEYS.TAB:
                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
                                // Enable default behavior to escape select-box
                                escapeToggle();
                                break;
                            } else if (event.shiftKey) {
                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            } else {
                                index = (index + 1) % $allTabbable.length;
                            }
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.RIGHT:
                            index = (index + 1) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.UP:
                        case _ui.KEYS.LEFT:
                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            $origin.click();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.ESC:
                            escapeToggle();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
});

// similar to select-box, this directive restrains tabbing within a container
// to the container itself.
//
// 1. modal-cancel is the equivalent of select-cancel from select-box, and
// should define a cancellation / ESC function.
(0, _squid.$registerDirective)('modal-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function escapeToggle() {
                (0, _angular.$parse)(attrs.modalCancel)(scope);
                scope.$apply();
            }

            // Gets the index of the element that should be focused after pressing Tab
            function getNextIndex($element, $elements, shift) {
                if (shift) {
                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
                } else {
                    return ($elements.index($element) + 1) % $elements.length;
                }
            }

            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
                element.on('keydown.modalBox', function (event) {
                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                    var $origin = (0, _jquery2['default'])(event.target);

                    if (!(event.altKey || event.ctrlKey)) {
                        switch (event.keyCode) {
                            case _ui.KEYS.TAB:
                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
                                $allTabbable.eq(index).focus();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            case _ui.KEYS.ESC:
                                escapeToggle();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
    };
});

// A simple version of modal that doesn't rely on controlling keyboard behavior
// as strictly. Should be used in cases where tab items are not as easily accessible
// via JS (ie. iframes)
// Redirects focus to container when focusin event fired on element not in container
(0, _squid.$registerDirective)('simple-modal', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.attr('tabindex', '-1');

            var cancelFn;
            if (attrs.modalCancel) {
                cancelFn = function cancelFn() {
                    (0, _angular.$parse)(attrs.modalCancel)(scope);
                    scope.$apply();
                };
            }

            function registerModal() {
                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
                    if (!element[0].contains(event.target)) {
                        event.stopPropagation();
                        element.focus();
                    }
                });
                if (cancelFn) {
                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
                        if (!element[0].contains(event.target)) {
                            deregisterModal();
                            cancelFn();
                        }
                    });
                }
            }

            function deregisterModal() {
                (0, _jquery2['default'])(document).off('focusin.simple-modal');
                (0, _jquery2['default'])(document).off('click.simple-modal');
            }

            // Watch the expression provided to simpleModal and add modal behavior when
            // expression result changes to truthy
            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
                scope.$watch(attrs['simpleModal'], function (newVal) {
                    if (newVal) {
                        registerModal();
                    } else {
                        deregisterModal();
                    }
                });
            } else {
                registerModal();
            }

            scope.$on('$destroy', deregisterModal);
        }
    };
});

// this directive gives an element characteristics of a native
// option element in terms of aria attributes. It must be used
// as a child of a selectBox for proper keyboard behavior as it
// disables default tabbing behavior.
//
// The expression provided to the directive is used to set the
// aria-selected attribute when the expression evaluates to true.
(0, _squid.$registerDirective)('select-option', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            (0, _jquery2['default'])(element).attr('role', 'menuitem');
            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
            }
        }
    };
});

// adapted from http://stackoverflow.com/a/24416690
// This directive makes the element focused when the expression
// provided _changes_ to true.
//
// In order to avoid conflicts with autofocus when a page first loads,
// adding the focused-once-before attribute will enable the expression
// only if it has been focused on before.
//
// * if the element itself is not focusable, then it will locate the first focusable
// element within it.
// * if the additional attribute focus-element is provided, it is wrapped
// as a jQuery element (could be selector string or actual element) and focused on
// it will be parsed when the focus-when attribute is true
// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
// the directive listens to the event specified by focus-on
(0, _squid.$registerDirective)('focus-when', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            function locateAndFocus(active) {
                (0, _angular.$timeout)(function () {
                    if (active) {
                        // deal with figuring out which element to focus on
                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);

                        // this works by fallthrough. it will try each one
                        // in succession until an element is found
                        if (attrs.focusElement) {
                            // scenario 1 - specific element provided
                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
                        }

                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
                            // scenario 2 - element with directive is not focusable
                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
                        }

                        // default / scenario 3 - no valid targets specified or found
                        if ($elementToFocus.length === 0) {
                            $elementToFocus = (0, _jquery2['default'])(element);
                        }

                        $elementToFocus.first().focus();
                    }
                });
            }

            var active = true;

            if ('focusedOnceBefore' in attrs) {
                active = false;
                (0, _jquery2['default'])(element).on('focus', function () {
                    active = true;
                });
            }

            if (attrs.focusRefreshOn) {
                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
                    locateAndFocus(active);
                });
            } else {
                scope.$watch(attrs.focusWhen, function (val) {
                    locateAndFocus(active && val);
                });
            }
        }
    };
});

// angularUI router specific - listens to a specific transition
// defined in two attributes, focusWhenState (this directive) and TransitionsTo
var FOCUS_EVENT_NAME = 'accessible-focus';
(0, _squid.$registerDirective)('focus-when-state', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var startState = attrs.focusWhenState;
            var endState = attrs.transitionsTo;
            var transitionMessage = startState + ' > ' + endState;
            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (fromState.name === startState && toState.name === endState) {
                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
                }
            });

            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
                if (message === transitionMessage) {
                    (0, _angular.$timeout)(function () {
                        return element[0].focus();
                    });
                }
            });

            // see http://stackoverflow.com/a/27016855
            scope.$on('$destroy', unregisterEventFn);
        }
    };
});

// Listens for the next state transition and focuses an element provided by selector
// Use with links where focus is needed to return to a specific element after the transition
(0, _squid.$registerDirective)('focus-after-transition', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.on('click', function () {
                var focusSelector = attrs['focusAfterTransition'];
                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    cancel();
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])(focusSelector).focus();
                    });
                });
            });
        }
    };
});

// focuses on the first focusable element on a container containing form elements
(0, _squid.$registerDirective)('form-autofocus', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // wait for the entire DOM to settle down first
            (0, _angular.$timeout)(function () {
                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
                if ($allFocusable.length > 0) {
                    $allFocusable.first().focus();
                }
            });
        }
    };
});

// Change element to be focusable and tabbable or unfocusable if it is
// not typically a focusable element by removing the tabindex attribute.
(0, _squid.$registerDirective)('focusable', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function setFocusable(value) {
                if (value) {
                    element.attr('tabindex', 0);
                } else {
                    element.removeAttr('tabindex');
                }
            }

            if (attrs.focusable) {
                scope.$watch(attrs.focusable, function (newVal) {
                    if (newVal) {
                        setFocusable(true);
                    } else {
                        setFocusable(false);
                    }
                });
            } else {
                setFocusable(true);
            }
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$rootScope;

_angular.isDefined;

_ui.KEYS;

_ui.focusable;

_ui.tabbable;

_ui.findAll;

_ui.filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var KEYS = {
    TAB: 0x09,
    ENTER: 0x0D,
    ESC: 0x1B,
    SPACE: 0x20,
    LEFT: 0x25,
    UP: 0x26,
    RIGHT: 0x27,
    DOWN: 0x28
};

function visible(element) {
    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
        return _jquery2['default'].css(this, 'visibility') === 'hidden';
    }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
    var map;
    var mapName;
    var img;

    if (nodeName === 'area') {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
            return false;
        }
        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
    }
    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
    var isTabIndexNaN = isNaN(tabIndex);

    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}

function filterAll(elements, filterFn) {
    return (0, _jquery2['default'])(elements).filter(function () {
        return filterFn(this);
    });
}

function findAll(container, filterFn) {
    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
}

exports.KEYS = KEYS;
exports.visible = visible;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.findAll = findAll;
exports.filterAll = filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoBanner', {
    tag: 'xo-banner',
    template: _template2['default'],
    transclude: true,
    props: {
        isNmj: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        // Need buyer_id from $AuthModel first to get the URL for the user profile photo
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()
            };
        },
        userPhoto: function userPhoto(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    photoData: _index.$UserPhotoModel.instance(models.auth.buyer_id).retrieve({
                        params: {
                            'min_size': 45
                        }
                    })['catch'](function (error) {
                        _logger.$logger.info('error_retrieve_user_photo');
                        return {};
                    })
                };
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var avatarElement = this.$element.find('#banner-picture');
            var auth = this.models.auth;
            var photoData = this.userPhoto.photoData;

            // Currently only showing initials for New Member Journey
            var showInitials = auth.first_name && auth.last_name && this.props.isNmj;

            if (avatarElement && auth.buyer_id) {
                // The "phantom" avatar image is displayed by default via CSS
                // background-image property. If the request for a user's
                // profile photo returns a URL, the background-image property
                // is replaced with that URL.

                // Show user photo for avatar
                if (photoData && photoData.photo_url) {
                    avatarElement.css('background-image', 'url("' + photoData.photo_url + '")');
                    _logger.$logger.info('xoBanner_user');
                }

                // No user photo: show user initials instead of phantom image
                if (!photoData.photo_url && showInitials) {
                    avatarElement.addClass('initials');
                    this.initials = '' + auth.first_name[0] + auth.last_name[0];
                    _logger.$logger.info('xoBanner_initials');
                }
            } else {
                // Leave the phantom avatar as the background image
                _logger.$logger.info('xoBanner_default');
            }
        }
    }
});


_squid.$Component;

_auth.$AuthModel;

_index.$UserPhotoModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/styles.less");

/**
 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
 *
 * Add directionality to the container html div element of a input field.
 * <div directionality><input type=text ng-model="user.name"></div>
 */
(0, _squid.$registerDirective)('directionality', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            var currentWatchDeregister = void 0;
            var input = element.find('input');

            if (!input.length) {
                listenForInputRendered();
                return;
            }

            // If the input has not yet been rendered inside the container, listen for dom node inserted
            // then, if the node inserted is an input, we will use that element and init the directionality
            // listeners. The first input rendered is the one that will be captured by this directive.
            function listenForInputRendered() {
                element.bind('DOMNodeInserted', checkDOMNodeInserted);

                function checkDOMNodeInserted(event) {
                    if (event && event.target && event.target.tagName === 'INPUT') {
                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
                        input = angular.element(event.target);
                        init();
                    }
                }
            }

            function setDirectionality(value) {
                if (value) {
                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
                } else {
                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
                }
            }

            function jqueryOnKeyupHandler(event) {
                setDirectionality(event.target.value);
            }

            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
            function resetDirectionalityListener() {
                // remove directionality listeners that were set on prior locale
                input.unbind('keyup', jqueryOnKeyupHandler);
                if (currentWatchDeregister) {
                    currentWatchDeregister();
                }

                // set new directionality listeners for the current locale if 'rtl'
                if (document.documentElement.getAttribute('dir') === 'rtl') {
                    (0, _angular.$timeout)(function () {
                        // Watch ng-model on input to set directionality if it contains RTL char
                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
                            setDirectionality(value);
                        });
                        // jQuery listener for cases where ng-model is not populated until post validation
                        input.on('keyup', jqueryOnKeyupHandler);
                    });
                }
            }

            function init() {
                resetDirectionalityListener();
                scope.$on('localeChange', function () {
                    resetDirectionalityListener();
                });
            }

            init();
        }
    };
});

/**
 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
 * or dir="ltr" attribute to the html element.
 *
 * Add directionality-text="<<model>>" to the div or span or any element containing text.
 * <span directionality-text="user.name"><{{user.name}}</span>
 */
(0, _squid.$registerDirective)('directionality-text', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            if (document.documentElement.getAttribute('dir') === 'rtl') {
                var $element = $(element);

                (0, _angular.$timeout)(function () {
                    if (attrs.directionalityText) {
                        scope.$watch(attrs.directionalityText, function () {
                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
                        });
                    } else {
                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
                    }
                });
            }
        }
    };
});

_squid.$util;

_squid.$registerDirective;

_angular.$document;

_angular.$parse;

_angular.$timeout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function link($scope, $select, attrs, ngModel) {
                var isListVisible = false;
                var listCreated = false;

                $select = $($select);

                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
                var $list = void 0;

                function updateCover() {
                    $timeout(function () {
                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
                    }, 10);
                }

                function createList($options) {
                    if ($options.length < 2) {
                        return;
                    }

                    function getModel() {
                        var modelName = void 0;
                        var model = void 0;
                        var subParts = void 0;

                        if ($select.attr('ng-options')) {
                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
                        } else {
                            var $option = $($select.find('[ng-repeat]')[0]);

                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
                        }

                        // This is to handle cases like card.billingAddress
                        if (modelName.indexOf('.') !== -1) {
                            subParts = modelName.split('.');
                            model = $scope;

                            for (var i = 0; i < subParts.length; i++) {
                                model = model[subParts[i]];
                            }
                        } else {
                            // And this is to handle straightforward model names
                            model = $scope[modelName];
                        }

                        return model;
                    }

                    function hideList(event) {
                        $list.hide();
                        $container.append($list);
                        isListVisible = false;
                        $container.removeClass('open');
                    }

                    function positionList() {
                        $list.css('left', $container.offset().left + 'px');
                        $list.css('top', $container.offset().top + $container.height() + 'px');
                        $list.css('width', $container.width() + 'px');
                    }

                    function setFocusOnSelected() {
                        var $selected = $select.find('[selected]');

                        if ($selected.length) {
                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');

                            $item.focus();
                        } else {
                            $list.find('li')[0].focus();
                        }
                    }

                    function showList() {
                        $('body').append($list);
                        $container.addClass('open');
                        $list.show();
                        positionList();
                        isListVisible = true;
                        setFocusOnSelected();
                    }

                    function processContainerKeypress(event) {
                        var keyCode = event && event.keyCode;

                        if (keyCode === 13 || keyCode === 40) {
                            // enter or down arrow
                            if (!isListVisible) {
                                showList();
                            } else {
                                hideList();
                                $container.focus();
                            }
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                            }
                        }
                    }

                    if ($list) {
                        $list.remove();
                    }

                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');

                    Array.prototype.forEach.call($options, function (option) {
                        var $option = $(option);
                        var value = $option.attr('value');
                        var text = option.innerHTML.replace(/\\n/gi, '<br>');

                        if (text.indexOf('content(') !== -1) {
                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
                        }

                        var html = '<li tabindex="0"';

                        if (value !== $option.text()) {
                            html = html + ' data-value="' + value + '"';
                        }
                        html = html + '>' + text + '</li>';
                        $list.append($(html));
                    });

                    $container.append($list);
                    $list.hide();

                    $($list.find('li')).click(function (event) {
                        var $target = $(event.target);
                        var value = $target.data('value');

                        if (typeof value !== 'undefined') {
                            $select.find('option').removeAttr('selected');
                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
                            $select.find('option').removeProp('selected');
                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
                        } else {
                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
                            $select.val(value);
                        }

                        if ($select.attr('ng-model')) {
                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                                /* This parses the 'ng-options' directive and returns the options model.
                                For example: If you have: ng-options='opt as opt.label for opt in options'
                                Here it will parse this attribute and return 'options */
                                var model = getModel();

                                ngModel.$setViewValue(model[value]);
                            } else {
                                ngModel.$setViewValue(value);
                            }
                        }
                        updateCover();
                        hideList();
                    });

                    var $innerContainer = $container.find('.innerContainer');

                    $container.click(function () {
                        if (isListVisible) {
                            hideList();
                            $container.focus();
                        } else {
                            showList();
                        }
                    });

                    $container.keydown(function (event) {
                        return processContainerKeypress(event);
                    });
                    $innerContainer.keydown(function (event) {
                        return processContainerKeypress(event);
                    });

                    $list.find('li').keydown(function (event) {
                        var keyCode = event && event.keyCode;
                        var $target = $(event.target);

                        if (keyCode === 13) {
                            // enter
                            $target.click();
                            event.stopPropagation();
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 40) {
                            // down arrow
                            if (!$target.is(':last-of-type')) {
                                $target.next().focus();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 38) {
                            // up arrow
                            if (!$target.is(':first-of-type')) {
                                $target.prev().focus();
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    });

                    $(window).resize(function () {
                        if (isListVisible) {
                            positionList();
                        }
                    });

                    $(window).bind('hashchange', function () {
                        if (isListVisible) {
                            hideList();
                        }
                    });

                    $(document).click(function (event) {
                        var $target = $(event.target);

                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
                            hideList();
                        }
                    });

                    $container.blur(function (event) {
                        // The setTimeout here is to ensure activeElement is set before our function executes
                        $timeout(function () {
                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);

                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
                                hideList(event);
                            }
                        }, 1);
                    });

                    listCreated = true;
                    updateCover();
                }

                function render() {
                    var options = $select.find('option');

                    if (!listCreated) {
                        createList(options);
                    }
                }

                $select.wrap($container);
                $container = $select.parent();

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter focus', function () {
                    return $span.addClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseleave blur', function () {
                    return $span.removeClass('active');
                });
                $select.after($span);
                $select.addClass('replaced');
                $select.attr('tabindex', '-1');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                if ($select.attr('ng-options')) {
                    $scope.$watch(attrs.ngModel, function () {
                        render();
                    });
                } else {
                    $timeout(function () {
                        return $scope.$broadcast('pageRendered');
                    });
                }

                $scope.$on('pageRendered', function () {
                    return render();
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    $.fn.dropdown = function () {
        console.warn('Dropdown deprecated');
    };
    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', ['$parse', '$window', '$timeout', '$util', '$compile', function ($parse, $window, $timeout, $util, $compile) {
        var userAgent = ($window.navigator || {}).userAgent;
        var isWinOS = Boolean(userAgent.match(/\(win/i));

        return {
            restrict: 'A',
            scope: {
                dropdownTextBindVar: '=?'
            },
            link: function link($scope, $element, attrs) {
                var $parentScope = $scope.$parent;
                var $select = $($element);
                // TODO: This html should be refactored out into a template.
                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
                var selectInitialValue = '';
                var ngChange = '';

                $select.parent().addClass('custom-select-container');
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter', function () {
                    return $span.addClass('active');
                });
                $select.bind('mouseleave', function () {
                    return $span.removeClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('focus', function () {
                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
                    $span.addClass('active');
                });

                function executeSelectChange() {
                    // setTimeout here is to ensure activeElement is set before our function executes
                    $timeout(function () {
                        var val = $parse(attrs.ngModel)($parentScope);

                        if (selectInitialValue !== val) {
                            if (ngChange) {
                                ngChange($parentScope);
                            }
                            selectInitialValue = val;
                        }
                    }, 5);
                }

                if (isWinOS) {
                    if (attrs['ngChange']) {
                        ngChange = $parse(attrs.ngChange);
                        attrs['ngChange'] = '';
                    }

                    $select.bind('blur', function () {
                        executeSelectChange();
                        $span.removeClass('active');
                    });
                    $select.bind('click', function () {
                        return executeSelectChange();
                    });
                } else {
                    $select.bind('blur', function () {
                        return $span.removeClass('active');
                    });
                }

                $select.after($span);
                $select.addClass('replaced');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
                if (angular.isDefined($scope.dropdownTextBindVar)) {
                    var selectTextElement = $span.find('span span');

                    if (selectTextElement.length) {
                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
                    }

                    $scope.$watch('dropdownTextBindVar', function (newVal) {
                        if (document.documentElement.getAttribute('dir') === 'rtl') {
                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
                        }
                    });
                }
                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
                else {
                        var updateCover = function updateCover() {
                            $timeout(function () {
                                var text = $select.find(':selected').text().trim();

                                $span.find('span span').text(text);
                                if (document.documentElement.getAttribute('dir') === 'rtl') {
                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
                                }
                            }, 5);
                        };

                        $parentScope.$watch(attrs.ngModel, updateCover);
                        $scope.$on('contentChange', updateCover);
                        if (match) {
                            $parentScope.$watch(match[1], updateCover);
                        }
                        // Update cover on arrow key press, for case where menu is not open
                        // but user is interacting with dropdown (eg. Firefox)
                        $select.bind('keyup', function (event) {
                            // Arrow keys are 37 - 40
                            if (event.which >= 37 || event.which <= 40) {
                                updateCover();
                            }
                        });
                    }

                toggleOptionsLTROverride();
                if (match) {
                    $parentScope.$watch(match[1], function (newVal) {
                        toggleOptionsLTROverride();
                    });
                }

                function toggleOptionsLTROverride() {
                    if (document.documentElement.getAttribute('dir') === 'rtl') {
                        $timeout(function () {
                            var options = $select.find('option');

                            for (var i = 0; i < options.length; i++) {
                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
                            }
                        });
                    }
                }
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angularAria = __webpack_require__("../node_modules/angular-aria/angular-aria.min.js");

// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
    bindRoleForClick: false,

    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
    // These attributes should only be set once the form is submitted, to match what
    // visually what we display
    ariaInvalid: false,
    ariaRequired: false,
    // Removing aria-hidden attribute for hidden elements
    ariaHidden: false
});

(0, _squid.$registerDirective)('xo-error-tooltip', function () {
    return {
        restrict: 'A',
        require: ['?^form', '?ngModel'],
        link: function link(scope, element, attrs, ctrls) {
            var formCtrl = ctrls[0],
                modelCtrl = ctrls[1];


            function shouldBeRequired() {
                if (formCtrl) {
                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
                    // adopt error-key in all input tags
                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));

                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
                } else {
                    return modelCtrl.$error.required;
                }
            }

            function shouldBeInvalid() {
                if (formCtrl) {
                    return formCtrl.$submitted && modelCtrl.$invalid;
                } else {
                    return modelCtrl.$invalid;
                }
            }

            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
            function formatSpaceSplitString(str, id, add) {
                var strArray = void 0;

                if (str) {
                    strArray = str.split(' ');
                } else {
                    strArray = [];
                }

                var idIndex = strArray.indexOf(id);

                if (~idIndex && !add) {
                    strArray.splice(idIndex, 1);
                } else if (!~idIndex && add) {
                    strArray.push(id);
                }

                return strArray.join(' ');
            }

            // Add tooltip behavior after DOM settles
            (0, _angular.$timeout)(function () {
                var generateId = function generateId() {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
                };
                var requiredId = generateId();
                var invalidId = generateId();
                var requiredError = void 0;
                var invalidError = void 0;

                if (attrs.errorKey) {
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
                    element.after(invalidError);
                } else if (attrs.errorText) {
                    // errorText if case is for backward compatibility, we can get rid of this once
                    // all teams adopt error-key in all input tags for tooltip message display
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
                    element.after(invalidError);
                }

                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
                    element.addClass('hasErrorTooltipRequired');
                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
                    element.after(requiredError);
                    element.removeAttr('aria-required');
                }

                function setAriaAttributes() {
                    var addTooltips = {
                        required: false,
                        invalid: false
                    };

                    // Do not associate "Required" error with aria-describedby
                    // because this should already be read out either by "required"
                    // attribute or "aria-required"=true, and only associate "Invalid"
                    // error if "Required" is not showing to match visuals
                    if (shouldBeRequired()) {
                        addTooltips.required = true;
                    } else if (shouldBeInvalid()) {
                        addTooltips.invalid = true;
                    }

                    var describedby = element.attr('aria-describedby');

                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
                    element.attr('aria-describedby', describedby);
                }

                scope.$watch(shouldBeRequired, function (newVal) {
                    setAriaAttributes();
                });
                scope.$watch(shouldBeInvalid, function (newVal) {
                    element.attr('aria-invalid', newVal);
                    setAriaAttributes();
                });

                // Set scroll so that the error message is in view when element receives focus
                element.on('focus', function (event) {
                    var windowBot = $(window).scrollTop() + $(window).height();
                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;

                    if (windowBot < Math.max(requiredBot, invalidBot)) {
                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
                    }
                });
            });
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$compile;

_angular.$timeout;

_angularAria.$ariaProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("../node_modules/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', [function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                redirectiframe: '=?',
                redirectLightbox: '=?'
            },

            controller: ['$scope', '$rootScope', '$populate', '$CheckoutInputDataModel', '$window', '$CheckoutAppDataModel', '$util', '$injector', '$logger', function ($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
                    $scope.isIFrame = $util.isIFrame();

                    $scope.closeFrame = function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.xchild) {
                            if (window.xprops.onCancel) {
                                return window.xprops.onCancel({
                                    token: $scope.token,
                                    cancelUrl: cancel_url
                                });
                            } else {
                                return window.xchild.close();
                            }
                        }

                        if ($scope.redirectLightbox) {
                            var result = _index.$ReturnToMerchant.postToMerchant({
                                operation: 'return_to_merchant',
                                returnUrl: cancel_url,
                                updateParent: true
                            });

                            // Otherwise we have no choice but to return to the merchant
                            if (!result) {
                                $util.redirect(cancel_url);
                            }

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else if ($scope.redirectiframe) {
                            $window.location.replace(cancel_url);

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else {

                            var iFrameFlow = $injector.get('$IFrameFlow');

                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');

                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');

                            if ($scope.auth && $scope.auth.code) {
                                url += '&code=' + $scope.auth.code;
                            }

                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
                        }
                        $scope.$emit('exitFrame');
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_index.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', [function () {
        return {
            template: template,

            restrict: 'E',

            controller: ['$scope', '$rootScope', '$window', '$util', '$logger', function ($scope, $rootScope, $window, $util, $logger) {
                $scope.isIFrame = $util.isIFrame();
                $scope.closeFrame = function (event) {
                    var url = $window.location.href && $window.location.href.split('#')[0] || '';

                    if (url.indexOf('proxflow') > -1) {
                        url = url.replace('proxflow', 'webapps/helios');
                    }

                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';

                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
                    } else {
                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
                    }

                    $window.top.location = url;
                    $scope.$emit('exitFrame');
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/styles.less");

var treatmentType = void 0;
var newLocale = void 0;
var oldLocale = void 0;

function getTreatment() {
    if (treatmentType !== undefined) {
        return treatmentType;
    }
    if ((0, _squid.$feature)('floatingLabels')) {
        return true;
    }
    var token = _angular.$rootScope.token;
    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;

    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
    return treatmentType;
}

(0, _squid.$registerDirective)('floating-label', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();

                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var input = element.find('input');

                if (input.attr('placeholder')) {
                    input.addClass('hasPlaceholder');
                }

                // To hide the placeholder labels for pre-populated input fields
                scope.$watch(input.attr('ng-model'), function (value) {
                    input.toggleClass('focused', !!value);
                });

                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
                input.on('keyup', function (event) {
                    var val = event.target.value;

                    input.toggleClass('focused', !!val);
                });

                input.on('focus blur click', function (event) {
                    if (scope.showFloatingLabels) {
                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
                    }
                });

                if (!('disableAutoblur' in attrs)) {
                    input.trigger('blur');
                }
            });
        }
    };
});

(0, _squid.$registerDirective)('floating-label-dropdown', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();
                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var select = element.find('select');
                var label = element.find('label');
                var flSpan = element.find('.custom-select span span');

                select.on('change mouseenter mouseleave blur', function (event) {
                    var value = event.currentTarget.value;

                    select.toggleClass('focused', event.type === 'change' || value.length > 0);
                    flSpan.toggleClass('noValue', value.length < 1);
                    label.toggleClass('hide', value.length < 1);
                }).trigger('mouseleave');
            });
        }
    };
});

_angular.$timeout;

_angular.$rootScope;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;

_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index2 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TITLE_KEY_MAPPING = {
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'sorry',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'sorry',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosedTitle',
    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
    RETRY: 'sorry',
    SENDING_LIMIT_EXCEEDED: 'genericErrorMessageTitle',
    STUDENT_ACCOUNT: 'studentAccountTitle',
    TRANSACTION_REFUSED: 'transactionRefusedTitle',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
    CREDIT_CARD_AUTH_FAILED: 'smartDollarAuthFailedMsg'
};

var CONTENT_KEY_MAPPING = {
    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
    AGREEMENT_ALREADY_CREATED: 'agreementAlreadyCreated',
    // TODO: rename to a common one, e.g TOKENIZED_WALLET_ELIGIBILITY_ERROR later
    ANDROID_PAY_ALREADY_PROVISIONED: 'tokenizedWalletAlreadyProvisioned',
    ANDROID_PAY_ELIGIBILITY_ERROR: 'tokenizedWalletGenericError',
    // end of TODO
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
    DEFAULT_TOKENIZED_WALLET_ERROR: 'tokenizedWalletGenericError',
    DEFAULT: 'genericError',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
    EINVALIDCSRF_JWT_EXPIRED: 'csrfTokenExpired',
    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
    GAMER_ACCOUNT_UNVERIFIED: 'accountUnverified',
    GAMER_INELIGIBLE: 'transactionRefusedTitle',
    GAMER_FI_INELIGIBLE: 'fiIneligible',
    GAMER_FI_UNCONFIRMED: 'fiUnconfirmed',
    GAMER_INVALID_ACCOUNT_TYPE: 'invalidAccountType',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'unauthorizedCountryLogin',
    GAMER_NO_VALID_FUNDING_INSTRUMENT: 'fiIneligible',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'unauthorizedCountryAccountRegistered',
    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosed',
    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
    PAYER_CANNOT_PAY: 'paymentDeniedError',
    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
    PAYMENT_DENIED: 'paymentDeniedError',
    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
    RESTRICTED_USER: 'buyerRestrictedError',
    RETRY: 'thingsNotWorking',
    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
    STUDENT_ACCOUNT: 'studentAccountMessage',
    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
    TRANSACTION_REFUSED: 'transactionRefusedMessage',
    CREDIT_CARD_AUTH_FAILED: 'transactionRefusedMessage',
    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
    UNSUPPORTED_DUE_TO_RECEIVER_PREFERENCE: 'unsupportedReceiverPreferences',
    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
    var merchantNameFromProps = this.props.merchant;

    // we may not get merchantName as props, look for models also
    var merchantNameFromModels = void 0;
    if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
        var merchant = this.models.checkoutAppData.merchant;

        merchantNameFromModels = merchant.brand_name || merchant.merchant_name;
    }

    var merchantName = merchantNameFromProps || merchantNameFromModels;

    if (merchantName) {
        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
    }

    return (0, _squid.$renderContent)(key + 'Default');
};

var renderContentWithWalletTokenizationName = function renderContentWithWalletTokenizationName(key) {
    var brandName = this.models.tokenizedWalletInfoModel.brandName();

    return (0, _squid.$renderContent)(key, { type: brandName });
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
    AGREEMENT_ALREADY_CREATED: renderContentWithMerchantName,
    ANDROID_PAY_ALREADY_PROVISIONED: renderContentWithWalletTokenizationName,
    DEFAULT_TOKENIZED_WALLET_ERROR: renderContentWithWalletTokenizationName,
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED', 'GAMER_INVALID_ACCOUNT_TYPE'];

var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];

var RETRY_LINK = ['EINVALIDCSRF_JWT_EXPIRED', 'GUEST_CHECKOUT_NOT_ALLOWED', 'RETRY'];

var TRANSACTION_REFUSED_BA_TITLE_MSG = {
    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');

exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
    tag: 'xo-generic-error',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        logout: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        cancelUrl: {
            type: 'str',
            required: false
        },
        merchant: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    cart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    auth: _index.$AuthModel.instance().retrieve()['catch'](angular.noop),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()['catch'](angular.noop)
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            var self = this;

            // to not break other application's error integration, we'll still support base64 decoded code parameters
            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
            } else {
                self.errorCode = _uiRouter.$stateParams.code;
            }

            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;

            _angular.$rootScope.allowUnload = true;
            self.cancelLink = self.props.cancelUrl;

            self.cancelRedirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = self.cancelLink;

                if (_angular.$rootScope.partnerIntegration) {
                    _logger.$logger.info('genericerror_partner_integration');
                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
                }

                _index2.$ReturnToMerchant.goTo(redirectUrl);
            };

            self.retryCheckout = function ($event) {
                $event.preventDefault();
                _squid.$util.reload();
            };

            self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

            self.loggingOut = function ($event) {
                $event.preventDefault();
                cancelPreventStateChange();
                self.props.logout();
            };

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            // Cancel link should be shown for "Credit Ineligible" page for DE
            if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                (0, _jquery2['default'])('#defaultCancelLink').hide();
            }
            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');

            self.$on('$destroy', function (event) {
                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
                if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                    (0, _jquery2['default'])('#defaultCancelLink').show();
                }
                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            self.getTitle = function () {
                var key = self.titleKey;

                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            self.getContent = function () {
                var key = self.contentKey;

                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the cancel button label, based on presence of brand/merchant name
            self.getCancelLabel = function () {
                if (self.walletTokenization) {
                    var brandName = _this.models.tokenizedWalletInfoModel.brandName();

                    return (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                } else {
                    var merchantName = _this.props.merchant;

                    return (0, _index2.formatReturnContent)(_squid.$renderContent, merchantName);
                }
            };

            this.personalizedBanner = {
                show: false
            };

            _logger.$logger.info('checkout_fpti', {
                landing_page: 'error_page',
                int_error_code: '1',
                int_error_description: _uiRouter.$stateParams.code
            });
        },
        populate: function populate() {
            var _models = this.models,
                checkoutAppData = _models.checkoutAppData,
                checkoutPayee = _models.checkoutPayee,
                cart = _models.cart,
                auth = _models.auth;


            this.walletTokenization = cart && cart.isWalletTokenization();
            this.personalizedBanner.show = auth && auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');

            if (checkoutAppData) {
                this.cancelLink = checkoutAppData.urls.cancel_url;
            }

            if (checkoutPayee) {
                var merchant = checkoutPayee.merchant;


                if (merchant.id && !this.hideCancelLink) {
                    var hcl = _squid.$config.hideCancelLinkForMerchant;

                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;

                    if (shouldHide) {
                        this.hideCancelLink = true;
                    }
                }
            }

            if (auth) {
                this.showLogoutLink = _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1 && !auth.disallow_login_switch; // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)

                this.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: auth.first_name,
                    last_name: auth.last_name
                }) || auth.email;
            }

            // Map error code for Android Pay
            if (this.walletTokenization) {
                // For Android Pay, map all errors to generic Android Pay error except for
                // ANDROID_PAY_ALREADY_PROVISIONED
                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
                    this.errorCode = 'DEFAULT_TOKENIZED_WALLET_ERROR';
                }
            }

            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];

            if (titleKey) {
                if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingNoPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
                } else if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
                } else {
                    this.titleKey = 'genericError.' + titleKey;
                }
            }

            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
            this.contentKey = 'genericError.' + contentKey;
        }
    }
});


_angular.$rootScope;

_uiRouter.$stateParams;

_logger.$logger;

_index.$AuthModel;

_app.$TokenizedWalletInfoModel;

_index2.$ReturnToMerchant;

_index2.formatReturnContent;

_squid.$Component;

_squid.$util;

_squid.$renderContent;

_squid.$config;

_squid.formatNameInformal;

_squid.$integration;

_squid.$feature;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n\n        <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </xo-banner>\n        <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </div>\n\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, template) {

    return angular.module('xo-generic-message.directive', ['squid']).directive('xoGenericMessage', ['$rootScope', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=?'
            },

            controller: ['$scope', '$rootScope', '$stateParams', '$state', '$logger', '$CheckoutAppDataModel', '$DeviceInfo', '$window', '$populate', function ($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $DeviceInfo, $window, $populate) {

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $('.paypalHeaderWrapper').hide();
                $('.footerWrapper').addClass('genericMessage');

                var titleKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
                    DEFAULT: 'paymentSuccessTitle'
                };

                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;

                var contentKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
                    DEFAULT: 'paymentSuccessMessage'
                };

                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];

                if (contentKey) {
                    $scope.contentKey = 'genericMessage.' + contentKey;
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance($scope.token),
                    cart: _index.$CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    var merchant = $scope.checkoutAppData.merchant;

                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                    var _$stateParams$returnU = $stateParams.returnUrl,
                        returnUrl = _$stateParams$returnU === undefined ? $scope.checkoutAppData.urls.return_url : _$stateParams$returnU;

                    var isHTTPUrl = Boolean(returnUrl.indexOf('http') === 0 || returnUrl.indexOf('www') === 0);
                    var enableSuccessReturnButton = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);

                    if (enableSuccessReturnButton) {
                        $scope.enableSuccessReturnUrl = true;
                        var contentWithButtonKeyMapping = {
                            PAYMENT_SUCCESS: 'successMessage',
                            DEFAULT: 'paymentSuccessMessage'
                        };
                        var contentWithButtonKey = $stateParams.code && contentWithButtonKeyMapping[$stateParams.code];

                        if (contentWithButtonKey) {
                            $scope.contentKey = '';
                        }
                        $scope.returnButtonLabel = (0, _squid.$renderContent)('genericMessage.continueButton');
                        var walletTokenization = $scope.cart && $scope.cart.isWalletTokenization();

                        if (walletTokenization) {
                            var brandName = $scope.tokenizedWalletInfoModel.brandName();

                            $scope.returnButtonLabel = (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                        }
                        $scope.goToMerchant = function () {
                            $logger.info('checkout_fpti', {
                                'from': 'POST_3DS',
                                'to': 'checkout_end',
                                'message': 'REDIRECT_TO_MERCHANT_ON_BUTTON_CLICK',
                                'returnUrl': returnUrl
                            });
                            $window.onunload = $window.onbeforeunload = function () {};
                            $window.location = returnUrl;
                        };
                    }
                });

                $scope.$on('$destroy', function (event) {
                    $('.paypalHeaderWrapper').show();
                    $('.footerWrapper').removeClass('genericMessage');
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_app.$TokenizedWalletInfoModel;

_index.$CheckoutCartModel;

_squid.$renderContent;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-message.directive', ['squid']).directive('xoMessage', ['$timeout', '$loader', '$rootScope', function ($timeout, $loader, $rootScope) {
        return {
            scope: {
                message: '=?', // Expected type - {msgs: [], type: "info|error|success|warning"}
                isgreyheader: '=?'
            },
            template: template,
            link: function link(scope, element, attrs) {

                // Hide and show the alerts so that messages can be registered by
                // screen reader even if they are repeats. Uses $timeout to
                // wait for DOM before showing alerts again.
                var toggleAlert = function toggleAlert() {
                    var $alert = element.find('ul');
                    $alert.detach();
                    $timeout(function () {
                        element.find('#pageLevelErrors').append($alert);
                    });
                };

                // Toggle the alert whenever message changes by removing it and reappending it
                // to the DOM. Should fire even if message
                // is changed to the same, as assumes that the message should be reapplied.
                var cancel;
                scope.$watchCollection('message', function () {
                    if ($loader.isLoading() && !cancel) {
                        // If loading, toggle the alert after all loading calls have been made.
                        // This is so that the alert can be read by screen reader after focus
                        cancel = $rootScope.$on('allLoaded', function () {
                            cancel();
                            toggleAlert();

                            cancel = null;
                        });
                    } else {
                        toggleAlert();
                    }
                });

                scope.$on('$destroy', function () {
                    if (cancel) {
                        cancel();
                    }
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/modal/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            show: '=?',
            showCloseButton: '=?',
            enableCloseOnEscape: '=?',
            onClose: '=?',
            enableMobileInterstitial: '@?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },
        controller: ['$scope', function ($scope) {
            $scope.animate = false; // Don't animate until triggered
            $scope.showOverlay = $scope.show;

            var escapeKeyHandler = function escapeKeyHandler($event) {
                if ($event.keyCode === 27) {
                    // Escape key maps to keycode 27
                    $scope.hideModal();
                }
            };

            if ($scope.enableCloseOnEscape) {
                // Handle escape button as close button click
                $(document).bind('keyup', escapeKeyHandler);
            }

            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;
                $(document).unbind('keyup', escapeKeyHandler);
                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        }],

        link: function link($scope, elem, attrs) {
            // HACK: without this check, the modal slides down/fades out upon it being rendered
            $scope.$watch('show', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    // When the show prop changes
                    $scope.animate = true; // Ensure the modal is animated
                }
            });
        }
    };
});

_squid.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-wrapper\" ng-class=\"{'animate': animate}\" ng-show='show' content>\n\t<div class=\"modal-overlay\"></div>\n\t<div class=\"modal-dialog\" ng-class=\"{'mobile-interstitial': enableMobileInterstitial}\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

exports['default'] = (0, _squid.$registerDirective)('prefix-attrs-with', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            var prefix = attrs.prefixAttrsWith;

            if (prefix && prefix.length) {
                ['id', 'for', 'name'].forEach(function (attrName) {
                    var base = attrs[attrName];

                    if (base) {
                        elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + '-' + base));
                    }
                });
            }
        }
    };
});


_squid.$util;

_squid.$registerDirective;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', [function () {
        return {
            template: template,
            scope: {
                token: '=?',
                track: '@?',
                onClick: '=?',
                buttonText: '@?',
                isProcessing: '=?',
                validate: '=?'
            },
            controller: ['$scope', function ($scope) {

                $scope.submit = function () {
                    if ($scope.onClick) {
                        $scope.onClick();
                    } else {
                        $scope.validate = true;
                    }
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {

    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', [function () {

        return {
            scope: {},
            template: template,
            controller: ['$scope', '$element', '$rootScope', '$locale', '$logger', '$loader', '$timeout', function ($scope, $element, $rootScope, $locale, $logger, $loader, $timeout) {
                var $body = angular.element(document.getElementsByTagName('body'));
                var $priorActiveElement = $();
                var $capturedElement = $();
                var $header = $('header');
                var $slidingArea = $('#main');
                var $footer = $('footer');

                /**
                 * This hides page content from any screen readers.
                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
                 *
                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
                 * At the very least, let's cache these selectors :|
                 */
                function hidePageContentFromScreenReader(toggle) {
                    $header.attr('aria-disabled', toggle);
                    $slidingArea.attr('aria-disabled', toggle);
                    $footer.attr('aria-disabled', toggle);
                }

                function preventDefault(event) {
                    var _event$target = event.target;
                    _event$target = _event$target === undefined ? {} : _event$target;
                    var targetId = _event$target.id;

                    // Only call preventDefault if the target is not a captcha input.
                    // If the target is a captcha input we don't want to prevent the
                    // user from entering the captcha code.

                    if (targetId !== 'captchaCode') {
                        event.preventDefault();
                    }
                }

                function captureFocus(event) {
                    if (!$element.has(event.target).length) {
                        $capturedElement = $(event.target);
                    }
                }

                function setLoadingMessage(message) {
                    if (angular.isObject(message)) {
                        $scope.message = message.heading;
                        $('#spinnerMessage').css('font-size', '17.5px');
                        $('#spinnerMessage').html(message.heading);
                        $('#spinnerSubHeading').html(message.subHeading);
                    } else {
                        $scope.message = message;
                        $('#spinnerMessage').html(message);
                    }
                }

                function showSpinner() {
                    $scope.loading = true;
                    $logger.info('show_loading_spinner');
                    $body.addClass('loading');

                    // remember what was previously focused
                    $priorActiveElement = $(':focus');

                    $(':input, a').blur();

                    hidePageContentFromScreenReader(true);

                    if ($loader.firstLoad()) {
                        setLoadingMessage($locale.content.get('base.processing'));
                    }

                    // focus on the message so that screen readers will let the user know the page is loading
                    $(document).on('keydown', preventDefault);
                    $(document).on('focusin', captureFocus);
                    $timeout(function () {
                        $('#spinner-message').focus();
                    });
                }

                function hideSpinner() {
                    $scope.loading = false;
                    $logger.info('hide_loading_spinner');
                    $('#preloaderSpinner').hide();
                    $body.removeClass('loading');
                    $(document).off('keydown', preventDefault);
                    $(document).off('focusin', captureFocus);

                    hidePageContentFromScreenReader(false);

                    // Focus captured element if focus was given to an element while spinner was active.
                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
                        $capturedElement.focus();
                        // Focus element that had focus before if it is still within the document
                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
                        $priorActiveElement.focus();
                    } else {
                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
                        // the element last clicked, rather than top of page.
                        $slidingArea.focus();
                    }
                    $priorActiveElement = $();
                    $capturedElement = $();
                }

                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);

                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
                    setLoadingMessage(text);
                });

                $scope.$on('$destroy', function () {
                    hideSpinner();
                    cancelStartLoad();
                    cancelAllLoaded();
                    cancelSetLoadingMessage();
                });

                if ($loader.isLoading()) {
                    showSpinner();
                }
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tooltip/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDefaultShowEvent($el) {
    return $el.is('a') || $el.is('button') ? 'click' : 'focus';
}

// Modify the aria-describedby property to include the id when showing the element so contents are properly read
function addDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') ? $el.attr('aria-describedby').split(' ') : [];

    if (!~describedByIds.indexOf(id)) {
        describedByIds.push(id);
    }

    $el.attr('aria-describedby', describedByIds.join(' '));
}

// Modify the aria-describedby attribute to remove the id when hiding the element so contents are no longer read
function removeDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') || '';

    $el.attr('aria-describedby', describedByIds.split(' ').filter(function (existingId) {
        return existingId !== id;
    }).join(' '));
}

var isMouseTypeEvent = function isMouseTypeEvent(type) {
    return (/mouse/.test(type)
    );
};

function debounceOnMouseTrigger(type, fn) {
    var isMouseType = isMouseTypeEvent(type);

    return function () {
        var _arguments = arguments;

        if (isMouseType) {
            (0, _angular.$timeout)(function () {
                return fn.apply(null, _arguments);
            }, 250);
        } else {
            fn.apply(null, arguments);
        }
    };
}

exports['default'] = _squid.$Component.extend('xoTooltip', {
    tag: 'xo-tooltip',
    template: _template2['default'],
    transclude: true,
    props: {
        trigger: {
            type: 'str',
            required: false
        },
        showEvent: {
            type: 'str',
            required: false
        },
        hideEvent: {
            type: 'str',
            required: false
        },
        displayInline: {
            type: 'var',
            required: false
        },
        align: {
            type: 'str',
            required: false
        }
    },
    lifecycle: {
        populate: function populate() {
            var $element = this.$element,
                trigger = this.trigger;

            var $trigger = $(trigger);
            var toolTip = $element.find('.toolTip');
            var toolTipID = this.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
            var isMouseOver = false;

            /**
             * Toggle the show/hide state of the tooltip
             */
            var toggle = function toggle(event) {
                if (toolTip.length && toolTip.is(':visible')) {
                    close(event);
                } else {
                    show(event);
                }
            };

            /**
             * Show the tooltip, if not already shown.
             */
            var show = function show(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                addDescribedById($trigger, toolTipID);

                // Show the tooltip and position the page scroll to include the element on page
                $element.show();
                toolTip.slideDown({
                    progress: function progress() {
                        var windowBot = $(window).scrollTop() + $(window).height();
                        var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
                        if (toolTipBot > windowBot) {
                            $(window).scrollTop(toolTipBot - $(window).height());
                        }
                    }
                });
            };

            /**
             * Hide the tooltip
             */
            var close = function close(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                if (!isMouseOver) {
                    if (toolTip.length && toolTip.is(':visible')) {
                        toolTip.slideUp(100, function () {
                            $element.hide();
                        });
                    } else {
                        $element.hide();
                    }

                    removeDescribedById($trigger, toolTipID);
                }
            };

            /**
             * Setting up the DOM behavior for this component
             */
            // Set defaults for showEvent and hideEvent if not provided
            this.showEvent = this.showEvent || getDefaultShowEvent($element);
            this.hideEvent = this.hideEvent || 'blur';

            var SHOW_EVENT = this.showEvent + '.toolTip';
            var HIDE_EVENT = this.hideEvent + '.toolTip';

            // Initially hide the tooltip
            $element.hide();

            // If tooltip is clicked, don't bubble up and trigger parent handlers
            $element.on('click', function (event) {
                return event.stopPropagation();
            });

            // If the tooltip contains an element with a "close" class, treat it as a close button
            $element.on('click', '.close', close);

            // Track whether the mouse is on the tooltip or not
            $element.on('mouseover', function () {
                isMouseOver = true;
            });
            $element.on('mouseleave', function () {
                isMouseOver = false;
            });

            // Clicking anywhere on the document not on the tooltip will close the tooltip.
            // Event is not passed so that other actions are not prevented
            $(document).on('click.toolTip', function (e) {
                // Needed because when the trigger is clicked, this click handler will also be fired.
                // So without this check the tooltip will open due to the trigger click and then this
                // document event handler would immediately close it
                if (!$trigger.is(e.target)) {
                    close();
                } else {
                    show();
                }
            });

            // Register the handlers to show and hide the tooltip
            if (this.showEvent === this.hideEvent) {
                $trigger.on(SHOW_EVENT, toggle);
                $element.on(SHOW_EVENT, toggle);
            } else {
                $trigger.on(SHOW_EVENT, show);
                $trigger.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
                // Also allow close event to happen on the tooltip itself, for mouse type events
                $element.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
            }

            // Clean up external listeners on exit
            this.$on('$destroy', function () {
                $(document).off('click.toolTip');
                $trigger.off(SHOW_EVENT);
                $trigger.off(HIDE_EVENT);
                close();
            });
        }
    }
});


_angular.$timeout;

_squid.$Component;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/ui-utils/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Generic scroll top.
(0, _squid.$registerDirective)('scrollTop', function () {
    return {
        link: function link(scope, element, attr) {
            var targetId = attr['scrollTop'];

            (0, _jquery2['default'])(element).on('focus', function () {
                (0, _jquery2['default'])('#' + targetId).scrollTop((0, _jquery2['default'])(element).offset().top);
            });
        }
    };
});

// Element types that accept disabled attribute
// See https://www.w3.org/TR/html5/disabled-elements.html#disabled-elements
//
//  Usage:
//      Provide expression to be evaluated to determine if form needs to be disabled
//      Form will be disabled when the expression evaluates to true
//          <form disable-form="expression"></form>
var ACCEPT_DISABLED = 'button, input, select, textarea, optgroup, option, fieldset';
(0, _squid.$registerDirective)('disable-form', function () {
    return {
        link: function link(scope, element, attrs) {
            var toggleDisabled = function toggleDisabled(disable) {
                var collection = element.find(ACCEPT_DISABLED);

                if (disable) {
                    collection.attr('disabled', true);
                } else {
                    collection.removeAttr('disabled');
                }
            };

            // Watch number of elements to get a rough idea of if any new inputs are
            // added that also need to be disabled.
            scope.$watch(function checkIfDisabled() {
                return (0, _angular.$parse)(attrs['disableForm'])(scope) && element.find(ACCEPT_DISABLED).length;
            }, toggleDisabled);
        }
    };
});

_angular.$parse;

_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoValidation', function () {
    return {
        template: '',
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attr, ngModel) {
            var validationUtil = {
                // because IE8 doesnt have String.prototype.trim()
                trim: function trim(value) {
                    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

                    return value.replace(rtrim, '');
                },


                /**
                 * Generic function that runs a given input against
                 * a given regular expression
                 *
                 * @param {String} value input to test
                 * @param {String/RegExp} regex Regular expression to test against
                 * @returns {Boolean} matches or does not match given pattern
                 */
                valid: function valid(value, regex) {
                    if (this.empty(value)) {
                        return false;
                    }

                    if (_angular2['default'].isString(regex)) {
                        regex = new RegExp(regex);
                    }

                    return regex ? regex.test(value) : true;
                },


                // returns whether empty or not
                empty: function empty(value) {
                    if (!value) {
                        return true;
                    }

                    // IE8 and below doesn't have native .trim()
                    return !this.trim(value);
                },


                // returns whether alphabetic or not
                alphabetic: function alphabetic(value) {
                    return this.valid(value, /[A-Za-z]+$/);
                },


                // returns whether numeric or not
                numeric: function numeric(value) {
                    var NUMERIC_REGEX = new RegExp('^[0-9]+$');

                    return this.valid(value, NUMERIC_REGEX);
                },
                validBankAccount: function validBankAccount(value) {
                    if (!scope.showIBAN) {
                        return this.numeric(value);
                    }

                    return true;
                },
                validRouting: function validRouting(value) {
                    if (!scope.showIBAN) {
                        return this.valid(value, /^\d{8}$/);
                    }
                    return true;
                },
                validIBANCode: function validIBANCode(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
                    }
                    return true;
                },
                validIBAN: function validIBAN(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^DE\d{20}$/);
                    }

                    return true;
                },
                validIBANCountry: function validIBANCountry(value) {
                    value = value && value.replace(/ +/g, '');
                    return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
                },


                // @Deprecated: This function is deprecated.
                // first two letters are the country code the rest are the bank account numbers max length 32
                validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
                    value = value && value.replace(/ +/g, '');
                    return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
                },
                validLast4: function validLast4(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex

                    return this.valid(value, LAST_4);
                },
                validStreet: function validStreet(value) {
                    return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
                },


                // Validating phone format with metadata from griffin
                validPhone: function validPhone(value) {
                    var regex = scope.pattern;

                    /*
                        * User can enter phone format in various manner according to griffin mask
                        * (00) 0000-0000
                        * 00 000 0000
                        * Since the griffin pattern only validates against numbers, need to trim the input
                        * to only validate the numbers
                        */
                    value = value && value.replace(/[^0-9]/gi, '');
                    return this.valid(value, regex);
                },
                validDobYear: function validDobYear(value) {
                    return value !== 'YYYY';
                },
                validDobDay: function validDobDay(value) {
                    return value !== 'DD';
                },
                validDobMonth: function validDobMonth(value) {
                    return value !== 'MM';
                },
                validPoBox: function validPoBox(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

                    if (boxRE.test(value)) {
                        return true;
                    }

                    return false;
                },
                validAddressSansPoBox: function validAddressSansPoBox(value) {
                    var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
                    var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;

                    if (boxRE.test(value) || cassRE.test(value)) {
                        return false;
                    }
                    return true;
                },
                validEmailOrPhone: function validEmailOrPhone(value) {
                    if (!value) {
                        return false;
                    }

                    return this.validEmail(value) || this.validPhone(value);
                },
                validEmail: function validEmail(value) {
                    if (!value) {
                        return false;
                    }
                    var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
                    // @TODO - Unsafe regular expression, need to fix.
                    var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

                    return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
                },
                highAscii: function highAscii(value) {
                    var trimmedValue = this.trim(value);
                    // @TODO - Unsafe regular expression, need to fix.
                    var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

                    return this.valid(trimmedValue, HIGH_ASCII_REGEX);
                },


                // expected format: MM/DD/YYYY
                validDate: function validDate(value) {
                    var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                    var dArr = value.split('/');
                    var d = new Date(value);
                    var isValid = false;

                    if (re.test(value)) {
                        isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
                    }

                    return isValid;
                },


                /* Expects value and state. state can be "past" or "future".
                    NOTE: This function validates only month and year, not day!
                    Please use validDate() if you need to validate the whole date. */
                validDateWithoutDay: function validDateWithoutDay(value, options) {
                    // eslint-disable-line max-statements
                    var state = options.state;

                    value = value.replace(/\s/g, '');

                    if (value === '') {
                        return true;
                    }

                    var split = value.split('/');
                    var month = split[0];
                    var year = split[1];
                    var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
                    var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
                    var validYear = true;
                    var validMonth = true;

                    if (value.length < 5) {
                        return false;
                    }

                    if (!this.validDobMonth(month)) {
                        return false;
                    }

                    month = parseInt(month, 10);
                    year = parseInt(year, 10);

                    if (state === 'past') {
                        validYear = year <= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month <= currentMonth;
                        }
                    } else if (state === 'future') {
                        validYear = year >= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month >= currentMonth;
                        }
                    }

                    if (!validYear || !validMonth) {
                        return false;
                    }

                    return true;
                },


                // formats to MM/DD/YYYY
                mmddyyyy: function mmddyyyy(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
                },


                // formats to YY-MMM-DDDD
                yyyymmdd: function yyyymmdd(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
                },


                // pads a number to two digits
                twoDigits: function twoDigits(value) {
                    return value < 10 ? '0' + value : '' + value;
                },


                // expects YYYY-MM-DD
                legalAge: function legalAge(value) {
                    if (this.empty(value)) {
                        return false;
                    }

                    var dateParts = value.split('-'); // expecting YYYY-MM-DD
                    var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                    var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
                    var validBD = new Date(new Date() - 18 * yr);

                    return validBD >= birthDate;
                },
                validZip: function validZip(value, options) {

                    var postalCodeRegex = {
                        // TODO: Once this is removed from the xo-add-address template, we can remove it...
                        GB: /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
                        /**
                         * Note: These are "nice to have".
                         * Once we add support for these countries, we can remove these.
                         */
                        BA: /^\d{5}$/,
                        CY: /^\d{4}$/,
                        EE: /^\d{5}$/,
                        HR: /^\d{5}$/,
                        LU: /^\d{4}$/,
                        LV: /^\d{4}$/,
                        MT: /^\d{3,4}$/,
                        SI: /^\d{4}$/,
                        SK: /^[0-9]{3}[\s][0-9]{2}$/,
                        NZ: /^\d{4}$/,
                        LT: /^\d{5}$/,
                        BG: /^\d{4}$/,
                        CZ: /^\d{5}$/,
                        GR: /^\d{3}[\s]\d{2}$/,
                        HU: /^\d{4}$/,
                        MX: /^\d{5}$/
                    };

                    var country = options && options.country;
                    var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
                    var isRequired = scope.zipEntry && scope.zipEntry.required;

                    if (!isRequired && this.empty(value)) {
                        return true;
                    }

                    // If there is no regex, or it's not populated yet...
                    if (!regex || _angular2['default'].isString(regex) && regex.indexOf('validationPattern') > -1) {
                        return !this.empty(value);
                    }

                    value = value && value.toUpperCase();

                    if (_angular2['default'].isString(regex)) {
                        if (regex.charAt(0) !== '^') {
                            regex = '^' + regex;
                        }
                        if (regex.charAt(regex.length - 1) !== '$') {
                            regex += '$';
                        }
                    }

                    return this.valid(value, regex);
                },
                validExpiry: function validExpiry(value, options) {
                    var $monthEl = (0, _jquery2['default'])('[ng-model="card.expiry_month"]');
                    var $yearEl = (0, _jquery2['default'])('[ng-model="card.expiry_year"]');
                    var month = $monthEl.val();
                    var year = $yearEl.val();
                    var isValid = false;
                    var monthElName = 'card.expiry_month';
                    var yearElName = 'card.expiry_year';
                    var cardType = options.cardType;

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    if (month && year) {
                        isValid = this.validExpires(month, year);
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];
                    var monthFieldName = monthElName;
                    var yearFieldName = yearElName;

                    if (monthFieldName.indexOf('.') !== -1) {
                        monthFieldName = monthFieldName.split('.')[1];
                    }

                    if (yearFieldName.indexOf('.') !== -1) {
                        yearFieldName = yearFieldName.split('.')[1];
                    }

                    var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                    if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
                        isValid = true;
                    }

                    if (form) {
                        form[monthFieldName].$setValidity('validExpiry', isValid);
                        form[yearFieldName].$setValidity('validExpiry', isValid);
                    }

                    return isValid;
                },
                validExpires: function validExpires(month, year) {
                    var date = new Date();
                    var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
                    var currentMonth;

                    if (year < currentYear) {
                        return false;
                    } else if (year > currentYear) {
                        return this.validDobMonth(month);
                    }

                    // account for display date vs. system date
                    currentMonth = date.getMonth() + 1;
                    return this.validDobMonth(month) && month >= currentMonth;
                },
                startDate: function startDate(value, options) {
                    var valueOptions = {
                        cardType: scope.card.type
                    };

                    valueOptions[elem.attr('id')] = value;

                    return this.setStartDateValidity(valueOptions);
                },


                setExpiryValidity: function setExpiryValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var expiryValidity = this.validExpiry(null, {
                        cardType: cardType
                    });

                    return expiryValidity;
                },

                // start date validation for Maestro card
                setStartDateValidity: function setStartDateValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var startDateValidity = true;
                    var $monthEl = (0, _jquery2['default'])('#startmonth');
                    var $yearEl = (0, _jquery2['default'])('#startyear');
                    var month = $monthEl.val();
                    var year = $yearEl.val();

                    if (cardType === 'MAESTRO') {
                        if (!month || !year) {
                            startDateValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id'),
                        form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.startmonth.$setValidity('startDate', startDateValidity);
                        form.startyear.$setValidity('startDate', startDateValidity);
                    }

                    return startDateValidity;
                },
                dobField: function dobField(value, options) {
                    var valueOptions = {};
                    var fieldMap = {
                        dobDayCC: 'day',
                        dobMonthCC: 'month',
                        dobYearCC: 'year'
                    };

                    valueOptions.cardType = scope.card.type;
                    valueOptions[fieldMap[elem.attr('id')]] = value;

                    return this.setDOBValidity(valueOptions);
                },
                setDOBValidity: function setDOBValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
                    var dobValidity = true;

                    var $monthEl = (0, _jquery2['default'])('#dobMonthCC');
                    var $dayEl = (0, _jquery2['default'])('#dobDayCC');
                    var $yearEl = (0, _jquery2['default'])('#dobYearCC');

                    var month = options.month || $monthEl.val();
                    var year = options.year || $yearEl.val();
                    var day = options.day || $dayEl.val();

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (day) {
                        day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    var cardType = options.cardType;

                    if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
                        if (!month || !year || !day) {
                            dobValidity = false;
                            // invalidate if < 18 y/o.
                        } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
                            dobValidity = false;
                        } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
                            dobValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.dobMonthCC.$setValidity('dobField', dobValidity);
                        form.dobDayCC.$setValidity('dobField', dobValidity);
                        form.dobYearCC.$setValidity('dobField', dobValidity);
                    }

                    return dobValidity;
                },
                validName: function validName(value) {
                    return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
                },
                isChecked: function isChecked(value, options) {
                    // $.is does not exist in $
                    // eslint-disable-line angular/ng_angularelement
                    var $el = (0, _jquery2['default'])(options.el);

                    return $el.is(':checked');
                },
                validRUPassport: function validRUPassport(value, options) {
                    if (scope.user.countryOfResidence === 'RU') {
                        return this.valid(value, /^\d{10}$/);
                    }
                    return true;
                }
            };

            var customValidator = function customValidator(value) {
                var ruleJson = _angular2['default'].fromJson(elem.attr('xo-validation'));
                var validator = ruleJson.validator;
                var options = ruleJson.options;

                ngModel.$setValidity(validator, validationUtil[validator](value, options));

                return value;
            };

            ngModel.$parsers.unshift(customValidator);
            ngModel.$formatters.unshift(customValidator);
        }
    };
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/3ds/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, template) {
    return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', [function () {
        return {
            template: template,
            scope: {
                token: '=?',
                data: '=?',
                onComplete3dsHandler: '=?'
            },
            controller: ['$scope', '$rootScope', '$timeout', '$window', '$Resolve3DS', '$DeviceInfo', '$CheckoutAppDataModel', '$config', '$locale', '$logger', function ($scope, $rootScope, $timeout, $window, $Resolve3DS, $DeviceInfo, $CheckoutAppDataModel, $config, $locale, $logger) {
                var resolve3DS = $Resolve3DS.instance($scope.token);

                $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';

                $scope.data = $scope.data || {};

                var isIos = $DeviceInfo.getiOSVersion();

                var timeout3DSConfig = $config.timeout3DS || { DEFAULT: 30000 };

                var lightBoxTimeout = isIos && $locale.country === 'IN' ? 0 : timeout3DSConfig[$locale.country] || timeout3DSConfig.DEFAULT;

                function show3DSLightBox() {
                    if ($scope.show3DS) {
                        var lightbox = angular.element(document.getElementById('light-box'));

                        lightbox.addClass('open');
                        $scope.show3DS = false;
                        $rootScope.$emit('loaded');
                    }
                }

                // TODO: should happen before iframe in html starts rendering
                // Solution: move to new componentized directive structure
                $scope.on3DSPageLoad = show3DSLightBox;
                $window.on3DSPageLoad = $scope.on3DSPageLoad;

                function handleInitFailure(message) {
                    // Since init3DS call failed. We disable the feature and proceed to checkout.
                    $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
                        data: {
                            payment_experience: 'HERMESNODE',
                            '3d_secure_authentication_supported': false
                        },
                        silent: true,
                        transientError: true
                    }).then(function () {
                        $logger.info('checkout_fpti', {
                            from: '3DS_CHALLENGE',
                            to: 'process_3ds_challenge',
                            int_error_description: message,
                            error_type: 'soft_decline',
                            error_source: 'fiLifecycle'
                        });

                        $scope.onComplete3dsHandler('success');
                    });
                }

                function init3DSApi() {
                    $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));

                    return resolve3DS.action('init3DS', {
                        data: {
                            cc_id: $scope.data.cc_id,
                            flow_id: $scope.data.flow_id,
                            merchant_id: $scope.data.merchant_id,
                            merchant_country: $scope.data.merchant_country_code,
                            currency: $scope.data.transaction_amount_currency,
                            transaction_amount: $scope.data.transaction_amount_value
                        },
                        success: function success(response) {
                            if (response.status === 'SUCCESS' && response.acsUrl) {
                                $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'prepare_3ds_challenge' });

                                $scope.acsUrl = response.acsUrl;
                                $scope.acsMethod = response.acsMethod || 'POST';
                                $scope.acsPaReq = response.acsPaReq;

                                var form = $('<form/>', {
                                    action: $scope.acsUrl,
                                    method: $scope.acsMethod,
                                    id: 'iFrameForm',
                                    target: 'threeDSFrame'
                                });

                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'TermUrl',
                                    value: $scope.termUrl
                                }));

                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'PaReq',
                                    value: $scope.acsPaReq
                                }));
                                $('#lightBoxAcsWrapper').append(form);
                                $('#iFrameForm').submit();

                                // wait for 3DS page to load with a timeout

                                // The $scope.show3DS in the line below is set true when the 3DS modal is eligible to be shown to user when the
                                // bank page loads in its iframe, i.e., after init3DS success
                                $scope.show3DS = true;
                                $rootScope.$emit('loading');
                                $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
                                $timeout(function () {
                                    if ($scope.show3DS) {
                                        $logger.info('checkout_fpti', {
                                            from: '3DS_CHALLENGE',
                                            to: '3DS_CHALLENGE',
                                            int_error_description: 'load_3ds_issuer_page_content_timeout',
                                            error_type: 'soft_decline',
                                            error_source: 'fiLifecycle'
                                        });
                                    }
                                    show3DSLightBox();
                                }, lightBoxTimeout);
                            } else {
                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge',
                                    int_error_description: 'acsUrl_not_presented_on_init',
                                    error_type: 'soft_decline',
                                    error_source: 'fiLifecycle'
                                });

                                // When there is no 3DS challenge page to be shown, we return success to the caller
                                $scope.onComplete3dsHandler('success');
                            }
                        },
                        error: function error() {
                            handleInitFailure('unknown_error_on_init3DS');
                        },
                        validation: function validation() {
                            handleInitFailure('validation_error_on_init3DS');
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                handleInitFailure('contingency_presented_on_init3DS');
                            }
                        }
                    });
                }

                function complete3DSApi(paRes) {
                    return resolve3DS.action('complete3DS', {
                        data: {
                            third_party_response: paRes,
                            cc_id: $scope.data.cc_id,
                            flow_id: $scope.data.flow_id
                        },
                        success: function success(response) {
                            var status = void 0;

                            if (response.status === 'SUCCESS') {
                                status = 'success';

                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge'
                                });
                            } else {
                                status = 'decline';

                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge',
                                    int_error_description: 'complete3DS_decline',
                                    error_type: 'soft_decline',
                                    error_source: 'fiLifecycle'
                                });
                            }

                            $scope.onComplete3dsHandler(status);
                        }
                    });
                }

                $scope.close3DSFrame = function () {
                    $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'process_user_close' });
                    $logger.flush();

                    var lightbox = angular.element(document.getElementById('light-box'));

                    lightbox.removeClass('open');

                    $timeout(function () {
                        var lightboxMask = angular.element(document.getElementById('mask'));

                        lightboxMask.remove();
                        $scope.onComplete3dsHandler('close');
                    }, 200);
                };

                init3DSApi();

                $scope.complete3DS = function (paRes) {
                    complete3DSApi(paRes);
                };

                $window.complete3DSFrame = function (paRes) {
                    $scope.complete3DS(paRes);
                };

                // when the esc key is pressed
                $('html').on('keyup', function (ev) {
                    if (ev.which === 27) {
                        $scope.close3DSFrame();
                    }
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _showCartDecision = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/showCartDecision.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html"), __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/styles.less"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {

    return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xomodel.checkout', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', ['$rootScope', function ($rootScope) {
        return {
            template: template,

            scope: {
                token: '=?',
                user: '=?',
                bank: '=?',
                isUnbranded: '=?'
            },

            /* auto formatting the user entered IBAN input */
            link: function link(scope, element, attr) {
                var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';

                element.on('keyup', function (event) {

                    $('#ibanNumber').mask(IBANMask, {
                        'translation': {
                            0: { pattern: /[A-Za-z0-9]/ }
                        }
                    });
                });
            },

            controller: ['$scope', '$populate', '$locale', '$pxp', '$AddBankModel', '$CheckoutCartModel', '$CheckoutAppDataModel', '$CheckoutPayeeModel', '$CurrencyConversionModel', function ($scope, $populate, $locale, $pxp, $AddBankModel, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $CurrencyConversionModel) {

                $populate($scope, {
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {

                    // TODO: In the future, automate this information
                    var BANK_CURRENCY = 'EUR';
                    var BANK_COUNTRY = 'DE';
                    var showDCCTreatmentName = 'xo_xoonboarding_bank_dcc_test';
                    var UTC = 'UTC';

                    $scope.showIBAN = true;

                    var days = [];
                    var months = [];
                    var years = [];

                    var i = void 0;

                    for (i = 1; i <= 31; i += 1) {
                        var d = i < 10 ? '0' + i : i.toString();

                        days.push(d);
                    }

                    for (i = 1; i <= 12; i += 1) {
                        var m = i < 10 ? '0' + i : i.toString();

                        months.push(m);
                    }

                    var year = new Date().getFullYear();

                    for (i = year - 17; i >= year - 100; i -= 1) {
                        years.push(i);
                    }

                    $scope.days = days;
                    $scope.months = months;
                    $scope.years = years;

                    $scope.toggleIBAN = function () {
                        $scope.showIBAN = !$scope.showIBAN;
                    };

                    $scope.onibanKeyup = function () {
                        $scope.bank.iban_number = $scope.bank.iban_number.toUpperCase();
                    };

                    var merchantID = $scope.payee.get('merchant.id', '');

                    // check if currency conversion is needed by comparing cart's currency code with EUR
                    var sourceCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
                    var sourceValue = $scope.checkoutCart.get('purchase.amounts.total.amount');

                    if (!(sourceCurrency && sourceValue)) {
                        return;
                    }

                    // Check if currency conversion is required
                    if (sourceCurrency !== BANK_CURRENCY) {
                        return $pxp('xo_xoonboarding_bank_dcc', {
                            'uid': merchantID
                        }, showDCCTreatmentName).then(function () {
                            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                treatment_name = _ref.treatment_name;

                            if (treatment_name === showDCCTreatmentName) {

                                $CurrencyConversionModel.instance().retrieve({
                                    params: {
                                        sourceCurrency: sourceCurrency,
                                        sourceValue: sourceValue,
                                        targetCurrency: BANK_CURRENCY,
                                        countryCode: BANK_COUNTRY,
                                        language: $locale.lang
                                    }
                                }).then(function (pricing) {
                                    if (pricing) {
                                        // If pricing object is true, currency conversion is valid
                                        $scope.isCurrencyConversionValid = true;

                                        var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                                        var userAction = $scope.checkoutAppData.useraction();
                                        var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;

                                        var total = $scope.checkoutCart.get('purchase.amounts.total');

                                        (0, _showCartDecision.showCartDecision)($scope.checkoutAppData.is_wps_subscription_flow(), total, $scope.checkoutAppData.get('merchant.merchant_country'), merchantID, noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (result) {
                                            $scope.showTotalAmount = result.showAmountInCartIcon;
                                            if ($scope.showTotalAmount) {
                                                $scope.targetFormatStr = pricing.from.currencyFormatSymbolISOCurrency;
                                            } else {
                                                $scope.sourceCurrencyCode = pricing.to.currencyCode;
                                            }
                                        });

                                        // Exchange Spread is the entire conversion spread. Eg: 1 USD = 1.5194 EUR
                                        $scope.exchangeSpreadFormatStr = pricing.spread;
                                        // griffin's dateTimeShort does not return timezone, so concatenate TZ
                                        $scope.fxDate = pricing.issuedDate.dateTimeShort + ' ' + UTC;
                                    } else {
                                        _logger.$logger.warn('Currency conversion API returned empty pricing object');
                                        $scope.isCurrencyConversionValid = false;
                                    }
                                })['catch'](function (err) {
                                    _logger.$logger.warn('currency_conversion_error', {
                                        reason: 'Error retrieving currency conversion rates for the source amount',
                                        error: err
                                    });
                                    $scope.isCurrencyConversionValid = false;
                                });
                            }
                        });
                    }
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_showCartDecision.showCartDecision;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addCep/template.html"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
    return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'xo-zipcode.directive']).directive('xoAddCep', [function () {
        return {
            template: template,

            scope: {
                token: '=?',
                sidebar: '=?',
                prefillAddress: '=?',
                doneFn: '=?'
            },

            controller: ['$scope', '$populate', '$state', '$PrefillAddressModel', '$locale', function ($scope, $populate, $state, $PrefillAddressModel, $locale) {
                $scope.country = $locale.country;
                $scope.address = {};

                $scope.onSubmit = function () {
                    $scope.prefillAddress.address = {
                        country: $locale.country,
                        postal_code: $scope.address.postal_code
                    };

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,

                        success: function success(result) {
                            $scope.prefillAddress.address = result;
                            $scope.doneFn();
                        }
                    });
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddCepRoute', {

            name: 'addCep',
            directive: 'xo-add-cep',
            titleContent: 'addBillingAddress.title',
            loginRequired: true,
            children: []
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addCep", "../node_modules/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addbilling/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {

    return squid.module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'xo-accessibility.directive']).directive('xoAddBilling', [function () {

        return {
            template: template,

            scope: {
                auth: '=?',
                token: '=?',
                doneFn: '=?',
                parentCallbacks: '=?',
                sidebar: '=?',
                showmeftsection: '=?',
                hideparenthead: '=?',
                billingaddressupdated: '=?',
                prefillAddress: '=?'
            },

            controller: ['$scope', '$populate', '$BillingAddressesModel', '$BillingAddressModel', '$PrefillAddressModel', '$feature', '$state', '$element', '$config', '$locale', '$timeout', function ($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout) {
                var country = $locale.getCountryCodeISO();

                $scope.billing = true; // to denote its billing address page still
                $scope.normalize = $feature('addressNormalization');
                $scope.country = country;
                var $el = $($element);

                if ($scope.showmeftsection) {
                    $scope.showmeftsection.toggle = false;
                }

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = true;
                }

                function isUserInputtedAddress(address) {
                    return address.id === '0';
                }

                // Label fields has having error if needed to, and focus the first error if needed
                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[name="' + field.field + '"]'));

                                if ($field.length === 0 && field.field === 'zip') {
                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                }

                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                            }
                        });
                    }

                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
                }

                var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;

                if (prefilledAddress) {
                    $scope.prefilled = true;
                }

                $scope.address = $scope.address || prefilledAddress || { country: country };

                $populate($scope, {
                    billingAddresses: $BillingAddressesModel.instance()
                }).then(function () {

                    $scope.cancelFn = function () {
                        $state.go('^.addCard');
                    };

                    $scope.onSubmit = function () {
                        $scope.updateAddress();
                    };

                    $scope.prefill = function () {
                        $scope.address.country = $scope.country;
                        $scope.prefillAddress = new $PrefillAddressModel({
                            id: $scope.token,
                            address: $scope.address
                        });

                        $scope.prefillAddress.save({
                            data: $scope.prefillAddress,

                            success: function success(result) {
                                $scope.address = result;
                                $scope.prefilled = true;
                                $scope.showAddressFields = true;

                                $timeout(function () {
                                    var value = $scope.address.state;

                                    var $option = $el.find('[value="' + value + '"]');

                                    $option.prop('selected', 'selected');
                                    $option.trigger('change');

                                    value = $option.attr('label');
                                }, 1000);
                            }
                        });
                    };

                    $scope.updateAddress = function () {

                        var newBilling = new $BillingAddressModel({
                            line1: $scope.address.line1,
                            line2: $scope.address.line2,
                            city: $scope.address.city,
                            state: $scope.address.state,
                            postal_code: $scope.address.postal_code,
                            normalization_status: $scope.address.normalization_status,
                            country: country,
                            id: '0'
                        });

                        newBilling.save({
                            data: $scope.billingAddress,

                            success: function success() {
                                if ($scope.normalize) {
                                    // set to false so that html related to billing address is hidden when child is shown
                                    $scope.billing = false;
                                    $scope.address.full_address = newBilling.full_address;
                                    $state.go('.addressNormalization');
                                } else {
                                    $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                                }
                            },

                            validation: function validation(res) {
                                handleValidation(res);
                            }

                        });
                    };

                    $scope.uponNormalization = function (normalizedAddress, isBack) {
                        if (isBack) {
                            $scope.billing = true;
                            $state.go('^');
                        } else {
                            $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
                        }
                    };

                    $scope.updateBillingAddressAndReturn = function (target, address) {
                        var newBillingAddress;

                        if (address && address instanceof $BillingAddressModel) {
                            newBillingAddress = address;
                        } else {
                            newBillingAddress = new $BillingAddressModel({
                                line1: address.line1,
                                line2: address.line2,
                                city: address.city,
                                state: address.state,
                                postal_code: address.postal_code,
                                normalization_status: address.normalization_status,
                                country: address.country || $scope.country,
                                full_address: address.full_address || $scope.address.full_address,
                                id: '0'
                            });
                        }

                        var addresses = $scope.billingAddresses.addresses;

                        if (!isUserInputtedAddress(addresses[0])) {
                            addresses.unshift(newBillingAddress);
                        } else {
                            addresses[0] = newBillingAddress;
                        }
                        $scope.billingaddressupdated.value = true;

                        $state.go(target);
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js"), __webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js"), __webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddBillingRoute', {

            name: 'addBilling',
            directive: 'xo-add-billing',
            titleContent: 'addBillingAddress.title',

            trackingData: {
                fptiState: 'edit_billing'
            },
            loginRequired: true,
            children: [{
                name: '$AddressNormalizationRoute',
                attributes: {
                    id: 'token',
                    sidebar: 'sidebar',
                    address: 'address',
                    'done-fn': 'uponNormalization'
                }
            }]

        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addbilling", "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addcard/template.html"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/message/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template, $) {

    return squid.module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', [function () {

        return {
            template: template,

            scope: {
                token: '=?',
                done: '=?',
                message: '=?',
                pagetitle: '=?',
                sidebar: '=?',
                showmeftsection: '=?',
                hideparenthead: '=?',
                billingaddressupdated: '=?',
                cardmodel: '=?',
                parentCallbacks: '=?',
                selectedPromotionCardType: '=?',
                promotion: '=?',
                pageLevel: '=?',
                logout: '=?',
                phone: '=?',
                manageCardFlow: '=?',
                onSuccess: '=?',
                backUri: '=?'
            },
            controller: ['$scope', '$populate', '$state', '$BillingAddressesModel', '$CardTypesModel', '$CheckoutSessionModel', '$AuthModel', '$CheckoutCartModel', '$timeout', '$element', '$rootScope', '$locale', '$util', '$feature', '$ResolveOTP', '$Class', '$fiErrorUtil', '$renderContent', function ($scope, $populate, $state, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $feature, $ResolveOTP, $Class, $fiErrorUtil, $renderContent) {

                $populate($scope, {
                    cart: $CheckoutCartModel.instance($scope.token),
                    auth: $AuthModel.instance(),
                    billingAddresses: $BillingAddressesModel.instance(),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                        contingencies: {
                            NEED_CREDIT_CARD: angular.noop,
                            EXPIRED_CREDIT_CARD: angular.noop
                        }
                    })
                }).then(function () {

                    // Set up the back url if passed down from the parent or else use the default review route
                    $scope.backUri = $scope.backUri || 'checkout.review.sidebar.wallet';

                    if ($scope.showmeftsection) {
                        $scope.showmeftsection.toggle = true;
                    }

                    if ($scope.hideparenthead) {
                        $scope.hideparenthead.toggle = false;
                    }

                    $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();

                    var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;

                    if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
                        $state.go('^.selectCard');
                    }

                    $scope.showplcc = type === 'plcc';
                    $scope.country = $locale.country;

                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;

                    $scope.cardmodel.cardType = 'creditCard';

                    if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
                        $scope.cardmodel.cardType = 'privateLabel';
                        $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
                    }

                    $scope.cardmodel.user = {
                        first_name: $scope.auth.first_name,
                        last_name: $scope.auth.last_name
                    };

                    $scope.cardmodel.address = $scope.billingAddresses.addresses[0];

                    if ($scope.billingaddressupdated.value) {
                        $scope.billingaddressupdated = {
                            msgs: [$locale.content.get('editCard.newAddressAdded')],
                            type: 'success',
                            value: true
                        };
                    }

                    $scope.gotoBilling = function (address) {
                        if ($scope.pageLevel) {
                            $scope.pageLevel.message = null;
                        }
                        if (!address) {
                            if ($locale.country === 'BR') {
                                $scope.parentCallbacks.showCep();
                            } else {
                                $state.go('^.addBilling');
                            }
                        }
                    };

                    $scope.isCUP = function () {
                        return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
                    };

                    $scope.flag = function (field) {
                        return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
                    };

                    $scope.buttonText = function () {
                        var contentString = 'creditcard.addBtn';

                        if ($scope.cardmodel.card.isExisting()) {
                            contentString = 'creditcard.updateBtn';
                        } else if ($scope.isCUP()) {
                            contentString = 'creditcard.continuetext';
                        }
                        return contentString;
                    };

                    $scope.cardTypeChanged = function () {
                        $scope.phone.phoneType = $scope.flag('phoneType');
                    };

                    function addErrorMessage(contentKey) {
                        if (contentKey) {
                            contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
                            var message = $locale.content.get('creditcard.' + contentKey);

                            $scope.message.msgs.push(message);
                        }
                    }

                    function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
                        var errorData;

                        if (result.errorCodes) {
                            errorData = result;
                        } else {
                            errorData = {
                                errorCodes: result && [result['0']]
                            };
                        }
                        $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);

                        if (window.scrollTo) {
                            window.scrollTo(0, 0);
                        }
                    }

                    $scope.cancelFn = function () {
                        if ($scope.sidebar) {
                            if (!$scope.checkoutSession.plccOffer) {
                                $state.go('checkout.review.sidebar.wallet');
                            } else {
                                $state.go('^.selectCard');
                            }
                        } else {
                            $scope.done();
                        }
                    };

                    function initiateOTP() {
                        var resolveOTP = new $ResolveOTP({ id: $scope.cardmodel.id });

                        resolveOTP.action('init', {
                            data: {
                                phone: {
                                    country_code: $scope.phone.IntDialingCountryCode,
                                    number: $scope.phone.telephone
                                }
                            },
                            resultModel: {},
                            success: function success() {
                                $scope.message = {};
                                $state.go('.confirmUpop');
                            },

                            error: function error() {
                                handleContingencies({}, 'confirmUpop', 'declineMessage');
                            },

                            contingencies: {
                                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                                    // prop for last 4 digits of card in error message
                                    var prop = {
                                        number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                                    };

                                    handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                                    $fiErrorUtil.addFieldErrors(result, $element);
                                },
                                DEFAULT: function DEFAULT() {
                                    handleContingencies({}, 'confirmUpop', 'declineMessage');
                                }
                            }
                        });
                    }

                    $scope.onSubmit = function () {
                        if ($scope.pageLevel) {
                            $scope.pageLevel.message = null;
                        }
                        var isNewCard = !$scope.cardmodel.card.isExisting();

                        if (isNewCard) {
                            delete $scope.cardmodel.id;
                        }

                        if ($('#plccAgree').is(':checked')) {
                            $scope.cardmodel.preference = true;
                        }

                        // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
                        if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {

                            initiateOTP();
                        } else {
                            $scope.cardmodel.save({

                                success: function success() {
                                    if ($scope.isCUP()) {
                                        initiateOTP();
                                    } else {

                                        $scope.checkoutSession.fundingOptions.action('update', {

                                            resultModel: $scope.checkoutSession,

                                            data: {
                                                planId: $scope.cardmodel.id
                                            },
                                            success: function success(result) {
                                                if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                                                    delete $scope.checkoutSession.plccOffer;
                                                }

                                                delete $scope.checkoutSession.errorData;

                                                var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                                                var numberAdded;
                                                var cardTypeAdded;

                                                if (cardAdded) {
                                                    numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                                                    cardTypeAdded = cardAdded.type;
                                                }

                                                var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                                                var cvvData = $scope.checkoutSession.cvvData;
                                                var last4ToUse;
                                                var cardTypeToUse;

                                                if (cvvData) {
                                                    last4ToUse = cvvData.number;
                                                    cardTypeToUse = cvvData.type;
                                                }

                                                if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                                                    $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
                                                }

                                                var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
                                                    type: cardTypeAdded,
                                                    number: last4Added
                                                });
                                                var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
                                                var addCardMessage = $renderContent('smallToolTip.cardAdded');

                                                var msgs = [addCardMessage];

                                                if (!isNewCard) {
                                                    msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                                                }

                                                $scope.checkoutSession.message = {
                                                    type: 'success',
                                                    msgs: msgs
                                                };

                                                $scope.done();
                                            },

                                            contingencies: {
                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                                                    $scope.message.msgs = [];
                                                    $scope.message.type = 'info';
                                                    addErrorMessage('addedButCannotUse');
                                                }
                                            }
                                        });
                                    }
                                },

                                contingencies: {
                                    ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
                                        if ($scope.sidebar) {
                                            $scope.$emit('SidebarError');
                                        }
                                        $scope.billingaddressupdated.value = false;
                                        if (result && result.errorCodes) {
                                            handleContingencies(result, 'creditcard', 'errorInvalidData');
                                            $fiErrorUtil.addFieldErrors(result, $element);
                                        } else if (result && result['0']) {
                                            handleContingencies(result, 'creditcard');
                                        } else {
                                            handleContingencies({}, 'creditcard', 'errorInternalError');
                                        }
                                    },
                                    DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
                                        handleContingencies({}, 'creditcard', 'errorInternalError');
                                    },
                                    VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
                                        var $field = $($element).find('[ng-model="card.number"]');

                                        $field.addClass('backendError');
                                        $field.attr('aria-invalid', true);
                                        $field.focus();
                                    },
                                    DEFAULT: function DEFAULT(name, result) {
                                        handleContingencies({ errorCodes: [name] }, 'creditcard', 'errorInternalError');
                                    }

                                },

                                error: function error() {
                                    handleContingencies({}, 'creditcard', 'errorInternalError');
                                },

                                validation: function validation(res) {// eslint-disable-line no-empty-function
                                }
                            });
                        }
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_cardMetaData.$CardMetaData;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddCardRoute', {

            name: 'addCard',
            directive: 'xo-add-card',
            titleContent: 'asideHeader.addCard',

            trackingData: {
                fptiState: 'add_or_update_cc'
            },
            loginRequired: true,
            children: [{
                route: _route2['default'],
                attributes: {
                    token: 'token',
                    phone: 'phone',
                    cardmodel: 'cardmodel',
                    'on-success': 'onSuccess'
                }
            }]
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardExpiryDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
    tag: 'xo-card-expiry',
    template: _template2['default'],

    props: {
        expiryMonth: {
            type: 'var',
            required: false
        },
        expiryYear: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                showNumericKeypad: (0, _squid.$pxp)('xo_xoon_numeric_keypad_expirydob', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_xoon_numeric_keypad_expirydob_test')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.expiryFormat = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);

            if (this.expiryMonth && this.expiryYear) {
                if (this.expiryFormat === 'MMYY') {
                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
                } else if (this.expiryFormat === 'MMYYYY') {
                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
                }
            }

            if (this.expiryFormat === 'MMYY') {
                this.maxlength = 5;
                this.expiryMask = '99/99';
            } else {
                this.maxlength = 7;
                this.expiryMask = '99/9999';
            }

            this.formatExpiry = function (event) {
                var key = event.keyCode || event.charCode;
                var $el = $(event.target);
                var val = $el.val().replace(/[^0-9\/]/gi, '');
                var strokes = val.length;

                // Ignore delete keys
                if (key === 8 || key === 46) {
                    return;
                }

                // after two characters add a slash char
                if (strokes === 2) {
                    val += '/';
                }

                _this.expiryDate = val;
                $el.mask(_this.expiryMask);
            };

            var currentYear = new Date().getFullYear().toString();
            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });

            this.validate = function (expiryDate) {
                if (!expiryDate) {
                    return;
                }

                var month = void 0,
                    year = void 0,
                    unformatted = void 0;
                var isValid = false;

                unformatted = expiryDate.replace(/[^0-9]/gi, '');
                if (unformatted.length > 3) {
                    month = unformatted.substring(0, 2);
                    if (_this.expiryFormat === 'MMYY') {
                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
                    } else if (_this.expiryFormat === 'MMYYYY') {
                        year = unformatted.substring(2, 6);
                    }

                    isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
                }

                _this.expiryYear = year;
                _this.expiryMonth = month;

                return isValid;
            };
        },
        populate: function populate() {
            // We are controlling card-expiry field through PXP.
            // Note: If locale is 'JP', then we always use keyType as 'tel' (jquery-mask-fix)
            if (this.experiments && this.experiments.showNumericKeypad || _squid.$locale.country === 'JP') {
                this.keyType = 'tel';
            } else {
                this.keyType = 'text';
            }
        }
    }
});

angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;

_squid.$pxp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" content>\n    <div class=\"inputField\" floating-label directionality>\n        <input type=\"{{keyType}}\" \n               ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               ng-keyup=\"formatExpiry($event)\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-key=\"validation.validExpirationDate\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n        <label for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$CardMetaData = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CARD_META_DATA = {
    DEFAULT: {
        fields: {
            address: true,
            cvv: true,
            dob: false,
            expiry: true,
            issue: false,
            phone: false
        },
        length: {
            cvv: 3,
            min: 16,
            max: 16
        },
        luhn: true,
        phoneType: 'Mobile',
        spaces: '4,8,12'
    },

    PLCC: {
        fields: {
            expiry: false,
            cvv: false,
            address: false
        },
        length: {
            min: 10,
            max: 16
        }
    },

    MAESTRO: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    SWITCH: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        fields: {
            issue: true
        },
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    DINERSCLUB: {
        pattern: /^(36|38|30[0-5])/,
        length: {
            min: 14,
            max: 14
        }
    },

    DISCOVER: {
        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
        length: {
            min: 14
        }
    },

    MASTERCARD: {
        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
    },

    AMEX: {
        pattern: /^3[47]/,
        length: {
            cvv: 4,
            min: 15,
            max: 15
        },
        spaces: '4,10'
    },

    VISA: {
        pattern: /^4/,
        length: {
            min: 13
        },
        subTypes: {
            QIWI: {
                pattern: /^(428122|489049|469395|446942|462012)/
            }
        }
    },

    JCB: {
        pattern: /^(?:2131|1800|35[0-9]{3})/,
        length: {
            min: 15
        }
    },

    CBNATIONALE: {},

    CETELEM: {
        fields: {
            dob: true
        },
        length: {
            max: 19
        },
        spaces: '4,8,12,16'
    },

    COFIDIS: {
        fields: {
            dob: true,
            expiry: false,
            cvv: false
        },
        length: {
            min: 8,
            max: 9
        },
        spaces: '4,8',
        luhn: false
    },

    COFINOGA: {
        fields: {
            dob: true,
            cvv: false
        },
        length: {
            min: 17,
            max: 17
        },
        spaces: '4,8,12,16'
    },

    ELO: {
        pattern: /^9/,
        length: {
            min: 13
        }
    },

    HIPER: {
        pattern: /^6/,
        length: {
            min: 13
        }
    },

    HIPERCARD: {
        pattern: /^7/,
        length: {
            min: 13
        }
    },

    CUPCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            cvv: 4,
            min: 15,
            max: 15
        }
    },

    CUPDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            min: 15,
            max: 15
        }
    }
};

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
});

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
});

function getTypeByPattern(cardMetaData, types, number) {
    var result = void 0;

    types.some(function (type) {
        var metaData = cardMetaData[type];

        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
            result = type;
            return true;
        }
        return false;
    });
    return result;
}

var $CardMetaData = exports.$CardMetaData = {
    getMetaData: function getMetaData(card, field) {
        var cardType = card && card.type || 'DEFAULT';

        if (cardType === 'CUP') {
            cardType = cardType + (card.dualType ? card.dualType : '');
            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
        }
        return _squid.$Class.get(CARD_META_DATA[cardType], field);
    },
    getCardType: function getCardType(types, number) {
        var cardType = {};

        if (_angular2['default'].isArray(types) && number) {
            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
            var metaData = CARD_META_DATA[cardType.type];

            if (metaData && metaData.subTypes) {
                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
            }
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);
_squid.$Class;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/utils.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/directive.js");

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template, $) {

    squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive']).directive('scrollToTop', [function () {
        return {
            link: function link(scope, element, attr) {
                $(element).on('focus', function () {
                    if ($('#mxCardTitle').is(':visible')) {
                        $('#creditCardForm').scrollTop($(element).offset().top);
                    }
                });
            }
        };
    }]).directive('jsOnchange', [function () {
        /**
         * The 'jsOnchange' directive uses JavaScript's native 'onchange'
         * event instead of Angular's 'ng-change' directive. We need
         * this because 'ng-change' gets fired every time the input changes
         * but we want to fire the event until the users focuses out of the input,
         * which is how JavaScript's 'onchange' event works.
         */
        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                var jsChangeHandler = scope.$eval(attrs.jsOnchange);

                element.on('change', jsChangeHandler);
                element.on('$destroy', function () {
                    element.off('change');
                });
            }
        };
    }]).directive('xoCreditCard', ['$timeout', '$util', function ($timeout, $util) {
        return {
            template: template,
            restrict: 'E',
            scope: {
                token: '=?',
                card: '=?',
                user: '=?',
                selectedPromotionCardType: '=?',
                promotion: '=?',
                cardTypeChanged: '=?',
                cardNumberChanged: '=?',
                manageCardFlow: '=?',
                setBuyerFxFlag: '=?'
            },
            controller: ['$scope', '$populate', '$CardTypesModel', '$Class', '$locale', '$CardTypeFromBinModel', '$config', '$feature', '$pxp', '$logger', '$CheckoutAppDataModel', '$CheckoutCartModel', '$FlowEligibilityModel', '$meta', function ($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $FlowEligibilityModel, $meta) {
                $scope.locale = $locale;
                $scope.country = $scope.locale.country;

                var isUnsupportedCard;
                var lastVerifiedBin = '';
                var lastRequestedBin = ''; // bin requested to service to fetch card type and pending response.

                function updateBuyerFXCurrencyConversion() {
                    return $pxp('xo_xoon_dcc_popup_content', { 'ctx.COUNTRY': $scope.locale.country }, '(xo_xoon_dcc_popup_content_)(.*)').then(function () {
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                            treatment = _ref.treatment_name;

                        if (treatment) {
                            var isControl = treatment.includes('control');

                            $scope.setBuyerFxFlag({ treatment: treatment });
                            if (!isControl) {
                                $scope.isBuyerFxApplicable = true;
                            }
                        }
                    });
                }

                function logConversionDataToFPTI(isChangeable) {
                    var _$scope$card$currency = $scope.card.currencyConvData;
                    _$scope$card$currency = _$scope$card$currency === undefined ? {} : _$scope$card$currency;
                    var from_code = _$scope$card$currency.from_code,
                        to_code = _$scope$card$currency.to_code,
                        spread = _$scope$card$currency.spread;

                    /**
                     * If conversion is not chnagable because of our agreement with
                     * the card issuer we will not have conversion data. In that
                     * case we will get the from code from the metadata and the
                     * to code from the cart.
                     */

                    if (!from_code) {
                        from_code = $util.getProperty($scope, 'locale.metadata.currency.code');
                        to_code = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
                    }

                    /**
                     * FPTI event #3 for Buyer FX guest experience
                     * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                     */
                    $logger.info('checkout_fpti', {
                        from: 'CURRENCY_CONVERSION',
                        to: 'prepare_currency_conversion_pre_plan',
                        conversion_type: (0, _utils.getDefaultCoversionSelection)($scope.card),
                        is_conversion_shown: isChangeable ? 1 : 0,
                        currency_conversion_from_curr: from_code,
                        currency_conversion_to_curr: to_code,
                        currency_conversion_spread: spread,
                        locale: $locale.country
                    });
                }

                function setConversionData(data) {
                    /**
                     * We want to enter this conditional if both of the
                     * following conditions are met:
                     * 1. The PXP `xo_xoon_dcc_popup_content` returns a
                     *    treatment or control value
                     * 2. Either:
                     *    a. `data` is present, in which case this
                     *       function is being called after a successful
                     *       call to the `calculateCurrencyConversion` API
                     *       and we need to set `card.currencyConvData` and
                     *       log to FPTI
                     *    b. `card.currencyConvData` is NOT `undefined`, which
                     *       occurs when a user has prevously entered a card and
                     *       a successful call the the currency conversion API
                     *       has occurred and the user is now deleting/changing
                     *       the card number for some reason
                     */
                    if ($scope.isBuyerFxApplicable && (data || $scope.card.currencyConvData)) {
                        $scope.card.currencyConvData = data;
                        $logger.info('setting_currency_conversion_data', { hasConversionData: Boolean(data) });
                        $scope.setBuyerFxFlag({ hasBuyerFxPrePlanData: Boolean(data) });

                        /**
                         * If data is `undefined` then we are resetting
                         * conversion data and therefore need to reset the
                         * default conversion selection to 'PAYPAL'
                         */
                        if (!data) {
                            $scope.card.ppconversion = 'PAYPAL';
                        } else {
                            /**
                             * If we have data the getCurrencyConversion() call
                             * was successful and the conversion selection is
                             * changeable.
                             */
                            logConversionDataToFPTI(true);
                        }
                    }
                }

                function conversionErrorHandler(key) {
                    /**
                     * Set `$scope.card.currencyConvData` to `undefined` so that if this isn't
                     * the first card the user entered and the previous card got a 200 response
                     * from the API, then we don't want the conversion data for that card to be
                     * used for the newly entered card.
                     */
                    setConversionData();
                    $logger.warn('Contingency encountered during calculateCurrencyConversion call.');
                    return;
                }

                function getCurrencyConversion(number) {
                    $scope.checkoutCart.action('calculateCurrencyConversion', {
                        data: {
                            cardNumber: number,
                            country: $locale.country
                        },
                        success: setConversionData,
                        contingencies: {
                            DEFAULT: conversionErrorHandler
                        },
                        error: conversionErrorHandler
                    });
                }

                function currencyConvCardTypeChangeHandler() {
                    $scope.card.ppconversion = 'PAYPAL';
                }

                $scope.checkCardForDccCall = function checkCardForDccCall() {
                    var _$scope$card = $scope.card;
                    _$scope$card = _$scope$card === undefined ? {} : _$scope$card;
                    var number = _$scope$card.number;

                    /**
                     * If the cart currency and the currency for the user's billing address are the
                     * same or we are not showing the BuyerFX PXP then we don't need to make the
                     * API call to get conversion information since no conversion is necessary
                     */

                    if (!$scope.isBuyerFxApplicable || !(0, _utils.isConversionApplicable)($scope)) {
                        return;
                    }

                    var cardNumber = (0, _utils.removeNonNumericCharsAndTruncate)(number, $scope.maxLength());
                    var isCardLenValid = $scope.cardLengthValid(cardNumber);
                    var isCardLuhnValid = $scope.cardLuhnValid(cardNumber);

                    // If the card has changed, we want to wipe out the currency conversion data
                    // associated with the previous card number that the user had entered.
                    setConversionData();

                    /**
                     * If the card length or luhn isn't valid, we return because we are in the
                     * process of entering in new card number or because the card number isn't
                     * valid and we don't want to make the API call until it is.
                     */
                    if (!isCardLenValid || !isCardLuhnValid) {
                        return;
                    }

                    var _$scope$card2 = $scope.card;
                    _$scope$card2 = _$scope$card2 === undefined ? {} : _$scope$card2;
                    var type = _$scope$card2.type,
                        currencyConvData = _$scope$card2.currencyConvData;

                    /**
                     * Combined check for all conditions for a getCurrencyConversion call
                     * 1. Card type is defined
                     * 2. If we haven't fetched conversion data for this card yet
                     * 3. If card allows for conversion selection
                     *      (i.e. card type is not AMEX, CUP, DISCOVER, or JCB)
                     */

                    if (type && !currencyConvData) {
                        /**
                         * If conversion is not changeable we log to FPTI now since we aren't
                         * calling getCurrencyConversion(), which logs in the success callback.
                         */
                        if (_utils.unchangeableCardTypes.includes(type)) {
                            logConversionDataToFPTI(false);
                            return;
                        }

                        getCurrencyConversion(cardNumber);
                    }
                };

                $scope.$watch('card.type', function () {
                    currencyConvCardTypeChangeHandler();
                    if ($scope.cardTypeChanged) {
                        $scope.cardTypeChanged();
                    }
                });

                $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];

                $scope.cardLengthValid = function (number) {
                    if ($scope.card && $scope.card.isExisting()) {
                        return true;
                    }

                    number = (0, _utils.removeNonNumericCharsAndTruncate)(number);

                    return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
                };

                $scope.cardLuhnValid = function (input) {
                    if (!$scope.flag('luhn') || $scope.card && $scope.card.isExisting()) {
                        return true;
                    }

                    input = (0, _utils.removeNonNumericCharsAndTruncate)(input);

                    var sum = 0;
                    var numdigits = input.length;
                    var parity = numdigits % 2;
                    var i = 0;
                    var digit = void 0;

                    for (; i < numdigits; i++) {

                        digit = parseInt(input.charAt(i), 10);

                        if (i % 2 === parity) {
                            digit *= 2;
                        }

                        if (digit > 9) {
                            digit -= 9;
                        }

                        sum += digit;
                    }

                    return sum % 10 === 0;
                };

                var _ref2 = $scope.selectedPromotionCardType || {},
                    promotionType = _ref2.type;

                $scope.isPlcc = promotionType === 'plcc';

                $scope.flag = function (field) {
                    if ($scope.isPlcc && !$scope.card.type) {
                        $scope.card.type = 'PLCC';
                    }
                    return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
                };

                $scope.maxLength = function () {
                    if ($scope.card && $scope.card.isExisting()) {
                        return 30;
                    }

                    return $scope.flag('length.max') + $scope.flag('spaces.length');
                };

                if ($scope.card && $scope.card.number) {
                    $scope.unformattedCardNumber = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());
                }

                $scope.showMXCardLogos = function () {
                    return $locale.country === 'MX';
                };

                function pxpMXCardLabels() {
                    if ($scope.showMXCardLogos()) {
                        $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function () {
                            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                treatment_name = _ref3.treatment_name;

                            $scope.showLabels = treatment_name === 'xo_hermes_mx_cardlogo_treatment';
                        });
                    } else {
                        $scope.showLabels = false;
                    }
                }

                $populate($scope, {
                    cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
                        token: $scope.token,
                        country: $locale.country
                    }),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token).retrieve(),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
                        params: {
                            geolocation: $meta.geolocation,
                            localeCountry: $locale.country
                        }
                    })
                }).then(function () {
                    if ((0, _utils.isConversionApplicable)($scope)) {
                        return updateBuyerFXCurrencyConversion();
                    }
                }).then(function () {
                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
                    var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;

                    $scope.cardProductValid = function () {
                        return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
                    };

                    var forceDropDown = false;

                    function str(item) {
                        var s = item.toString();

                        return item < 10 ? '0' + s : s;
                    }

                    var scanCardExperimentEligibility = function scanCardExperimentEligibility() {
                        if (!_index.$DeviceInfo.isSafariiOSBrowserView()) {
                            return _squid.$promise.resolve(false);
                        }
                        // Scan credit card feature is only available in iosVersion 8+
                        if (_index.$DeviceInfo.isSafariiOSBrowserView() && _index.$DeviceInfo.getiOSVersion()[0] < 8) {
                            return _squid.$promise.resolve(false);
                        }

                        return (0, _squid.$elmo)('xo_hermes_addcard_camera_icon', { 'ctx.COUNTRY': $locale.country }, 'xo_hermes_addcard_camera_icon_show');
                    };

                    scanCardExperimentEligibility().then(function (result) {
                        $scope.showScanCardExperiment = result || false;
                    });

                    $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');
                    $scope.disallowedCardMessageFeature = $feature('disallowedCards', undefined, $scope.country);
                    if ($scope.disallowedCardMessageFeature) {
                        $scope.showUnsupportedCardMessage = true;
                        $scope.unsupportedCardNamesCommaSeparated = $scope.cardTypes.unsupportedNames().join(', ');
                    }

                    $scope.$on('localeChange', function () {
                        $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
                            token: $scope.token,
                            country: $locale.country
                        });

                        $scope.cardTypes.retrieve().then(function () {
                            if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
                                delete $scope.card.type;
                                forceDropDown = false;
                                $scope.changeCardNumber(true);
                            }
                        });

                        $scope.country = $locale.country;

                        pxpMXCardLabels();
                    });

                    pxpMXCardLabels();

                    $scope.cvvShown = function () {
                        if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
                            return false;
                        }

                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }

                        return $scope.flag('fields.cvv');
                    };

                    $scope.expiryShown = function () {
                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }
                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        return $scope.flag('fields.expiry');
                    };

                    $scope.enableDropDown = function () {
                        return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
                    };

                    $scope.showDropDown = function () {
                        if ($scope.enableDropDown()) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
                            return true;
                        }

                        return false;
                    };

                    $scope.showAcceptedCardLogos = function () {
                        return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
                    };

                    $scope.getCardTypeByNumber = function (types, number) {
                        if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
                            return _cardMetaData.$CardMetaData.getCardType(types, number);
                        }
                    };

                    function formatCardNumber(number) {
                        var spaces = $scope.flag('spaces');
                        var formatted = [];

                        for (var i = 0; i < number.length; i++) {
                            if (spaces.indexOf(i) > -1) {
                                formatted.push(' ');
                            }

                            formatted.push(number.charAt(i));
                        }

                        return formatted.join('');
                    }

                    $scope.$watch('country', function (newValue, oldValue) {
                        cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
                    });

                    /**
                     * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
                     */
                    $scope.ccOnBlur = function () {
                        if ($scope.cardNumberChanged) {
                            $scope.cardNumberChanged($scope.unformattedCardNumber);
                        }
                    };

                    // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
                    // on regex defined for card type. If not regex was defined, pick one
                    // of the allowed card type.
                    function selectCardTypeForDualBrands(result) {
                        var dualCardTypes = $feature('dualCardTypes', {});
                        var match;

                        Object.keys(dualCardTypes).some(function (key) {
                            return result.some(function (cardType) {
                                if (cardType.type === key) {
                                    match = key;
                                    return true;
                                }
                                return false;
                            });
                        });

                        if (match) {
                            var regex = new RegExp(dualCardTypes[match]);
                            var selected = $util.find(result, function (cardType) {
                                if (regex.test(cardType.type)) {
                                    return true;
                                }
                            });

                            if (selected && selected.type === 'CUP') {
                                $util.some(result, function (cardType) {
                                    if (/^AMEX$/.test(cardType.type)) {
                                        selected.dualType = cardType.type;
                                        return true;
                                    }
                                });
                            }

                            return selected;
                        } else {
                            return $util.find(result, function (cardType) {
                                return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
                            });
                        }
                    }

                    function selectCardType(result) {
                        if (angular.isArray(result)) {
                            if (result.length >= 2) {
                                result = selectCardTypeForDualBrands(result);
                            } else {
                                result = result[0];
                            }
                        }

                        return result || {};
                    }

                    function clearCardType() {
                        $scope.card.type = '';
                        $scope.card.isCupSecureCard = false;
                        $scope.card.dualType = '';
                        $scope.card.productType = '';
                    }

                    function getCardTypeByNumberServiceCall(number) {
                        if (number.length >= 9) {
                            /*
                             * We have BIN numbers of different lengths - 6, 8, 9
                             * For a 9 digit BIN number, when users enter 6 digits,
                             * we might get a response different from what is expected out
                             * of 9 digit BIN number.
                             * So, we decided to call fims only when user entered card number
                             * length is greater than or equal to 9.
                             * This will also avoid multiple calls to fims at different length
                             * of card (i.e. calling fims at every new digit after 6th digit until 9th digit)
                             */
                            var bin = number.slice(0, 9);

                            if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
                                $scope.card.type = lastVerifiedBin.type;
                                $scope.card.isCupSecureCard = lastVerifiedBin.isCupSecureCard;
                                $scope.card.dualType = lastVerifiedBin.dualType;
                                $scope.card.productType = lastVerifiedBin.productType;
                                return;
                            }

                            if (isUnsupportedCard === bin || bin === lastRequestedBin) {
                                return;
                            }

                            // protect against requesting substring of already requested bin
                            if (bin.length <= lastRequestedBin.length && lastRequestedBin.indexOf(bin) > -1) {
                                return;
                            }

                            lastRequestedBin = bin;

                            // Make sure isCupSecureCard is set to false, as there is a possibility the next
                            // retrieve could indicate it as a CUP UPOP card.
                            $scope.card.isCupSecureCard = false;

                            $CardTypeFromBinModel.instance().save({
                                data: {
                                    user_country: $scope.country,
                                    bin: bin
                                },
                                silent: true,
                                success: function success(result) {

                                    // Log card brands returned from fims
                                    if (result) {
                                        var logObj = {
                                            totalItems: result.length,
                                            brands: []
                                        };

                                        result.forEach(function (brandObj) {
                                            logObj.brands.push(brandObj.type);
                                        });

                                        $logger.info('fims_card_type_from_bin_response', logObj);
                                    }

                                    result = selectCardType(result);
                                    var type = result.type;

                                    var disallowedCard = false;

                                    if ($scope.cardTypes.allowed.indexOf(type) === -1) {
                                        disallowedCard = true;
                                    } else if ($scope.debitCardFlow) {
                                        if (result.productType !== 'DEBIT') {
                                            disallowedCard = true;
                                        }
                                    }

                                    if (disallowedCard) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        $scope.allowedCardsTooltip = true;
                                        return;
                                    }

                                    isUnsupportedCard = undefined;
                                    forceDropDown = false;
                                    if (!$scope.showDropDown()) {
                                        $scope.card.type = type;
                                        // CUP Non Upop card is a CUP Secure Card.
                                        $scope.card.isCupSecureCard = type === 'CUP' && !result.isUpop;
                                        $scope.card.dualType = result.dualType;
                                        $scope.card.productType = result.productType;
                                    }

                                    // check for shorter version of bin coming back after longer version, protect against overwrite
                                    if (!lastVerifiedBin.bin || lastVerifiedBin.bin.indexOf(bin) === -1) {
                                        lastVerifiedBin = {
                                            bin: bin,
                                            type: type,
                                            isCupSecureCard: type === 'CUP' && !result.isUpop,
                                            dualType: result.dualType,
                                            productType: result.productType
                                        };
                                    }

                                    // This logic is to handle copy paste case when all numbers are entered at once
                                    if ($scope.card.type && number.length >= $scope.flag('length.min')) {
                                        if (/android/i.test(navigator.userAgent)) {
                                            return;
                                        }

                                        var ccNumber = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());

                                        if (ccNumber.indexOf(number) >= 0) {
                                            $scope.card.number = formatCardNumber(ccNumber);
                                        }
                                    }

                                    return;
                                },
                                contingencies: {
                                    GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        lastRequestedBin = undefined;
                                    }
                                },
                                error: function error() {
                                    clearCardType();
                                    isUnsupportedCard = bin;
                                }
                            });
                        } else {
                            isUnsupportedCard = undefined;
                            forceDropDown = false;
                            clearCardType();
                        }
                    }

                    $scope.getAllowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
                    };

                    $scope.getDisallowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
                    };

                    $scope.enableAddMode = function () {
                        if ($scope.card.isExisting()) {
                            $scope.card.number = '';
                        }
                    };

                    $scope.changeType = function () {
                        forceDropDown = true;

                        $scope.changeCardNumber(true);

                        // If the card type dropdown changes we want to
                        // check to see if we need to call the DCC API
                        // and if it is then make a call
                        $scope.checkCardForDccCall();

                        // Blank out unsupported fields

                        if (!$scope.flag('fields.expiry')) {
                            delete $scope.card.expiry_month;
                            delete $scope.card.expiry_year;
                        }

                        if (!$scope.flag('fields.issue')) {
                            delete $scope.card.start_month;
                            delete $scope.card.start_year;
                            delete $scope.card.issue_number;
                        }

                        if (!$scope.flag('fields.dob')) {
                            delete $scope.card.dob_day;
                            delete $scope.card.dob_month;
                            delete $scope.card.dob_year;
                        }

                        if (!$scope.flag('fields.cvv')) {
                            delete $scope.card.security_code;
                        }
                    };

                    $scope.changeCardNumber = function (isCardTypeChanged) {
                        // If buyer tries to modify an update card number. We remove the whole string
                        // so buyer can add a card instead.
                        $scope.enableAddMode();
                        $scope.allowedCardsTooltip = false;

                        var regex = /[０-９]/;

                        if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
                            $logger.info('checkout_fpti', {
                                'is_fullwidth_character': true
                            });
                        }

                        var number = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());
                        var formattedNumber = void 0;

                        $scope.unformattedCardNumber = number;

                        // Attempt to determine the card type
                        var cardType = void 0;

                        if (cardTypeServiceCall) {
                            if (!isCardTypeChanged) {
                                getCardTypeByNumberServiceCall(number);
                            }

                            if (isUnsupportedCard) {
                                $scope.allowedCardsTooltip = true;
                            }
                        } else {
                            if (!isCardTypeChanged) {
                                // Hide dropdown and trigger bin matching when the cc number is < 4 digits
                                if (number.length < 4) {
                                    forceDropDown = false;
                                }

                                if (!$scope.enableDropDown()) {
                                    cardType = $scope.getAllowedCardTypeByNumber(number);
                                    $scope.card.type = cardType.type;
                                    $scope.card.subType = cardType.subType;
                                }
                            }

                            if ($scope.isPlcc && $scope.card.type) {
                                $scope.cvvShown();
                                $scope.expiryShown();
                            }

                            if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
                                $scope.allowedCardsTooltip = true;
                            }
                        }

                        // Format the card number

                        /*
                         * PPPLMER-1563 commented out to fix this bug
                        if (/android/i.test(navigator.userAgent)) {
                            return;
                        }
                        */

                        formattedNumber = formatCardNumber(number);

                        // If the card is already formatted correctly, we can leave the user to continue in peace.
                        if ($scope.card.number === formattedNumber) {
                            return;
                        }

                        // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
                        $timeout(function () {

                            // re-formatting the number, since the card type may not have resolved before the first call
                            $scope.card.number = formatCardNumber(number);

                            // Save the current cursor positions
                            var ccField = document.getElementById('cc');

                            if (!ccField) {
                                return;
                            }
                            var inputLength = ccField.value.length;
                            var cursorStart = ccField.selectionStart;

                            // Wait for the formatted card to be reflected on the page
                            $timeout(function () {

                                // If the cursor was at the end of the input field, keep it at the end
                                if (cursorStart === inputLength) {
                                    ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
                                    // Otherwise place the cursor to the position it was in before we replaced with the formatted number
                                } else {
                                    ccField.selectionStart = ccField.selectionEnd = cursorStart;
                                }
                            });
                        });
                    };

                    var year = new Date().getFullYear();

                    $scope.months = $util.map($util.range(1, 13), str);
                    $scope.startYears = $util.map($util.range(year - 10, year), str);
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_cardMetaData.$CardMetaData;

_utils.unchangeableCardTypes;

_utils.getDefaultCoversionSelection;

_utils.isConversionApplicable;

_utils.removeNonNumericCharsAndTruncate;

_index.$DeviceInfo;

_squid.$promise;

_squid.$elmo;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.removeNonNumericCharsAndTruncate = exports.isConversionApplicable = exports.getDefaultCoversionSelection = exports.unchangeableCardTypes = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var getForcedCards = function getForcedCards(type) {
    return _squid.$util.getProperty(_squid.$config, 'currencyConversion.cards.forced' + type, { 'default': [] });
}; /* eslint-disable no-arrow-condition, no-confusing-arrow, angular/typecheck-string */
var unchangeableCardTypes = exports.unchangeableCardTypes = [].concat(getForcedCards('PayPal'), getForcedCards('Vendor'));

var getDefaultCoversionSelection = exports.getDefaultCoversionSelection = function getDefaultCoversionSelection() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type;

    return getForcedCards('Vendor').includes(type) ? 'VENDOR' : 'PAYPAL';
};

/**
 * @function isConversionApplicable
 * @description checks to see if currency conversion is needed for the transaction
 * @param {object} scope - Angular scope
 * @returns {boolean}
 */
var isConversionApplicable = exports.isConversionApplicable = function isConversionApplicable(scope) {
    var cartCurrency = scope.checkoutCart.get('purchase.amounts.total.currency_code');
    var billingCurrency = _squid.$util.getProperty(scope, 'locale.metadata.currency.code');

    // If the cart currency and the currency for the user's billing address
    // are both presetn and different then currency conversion is applicable
    var hasDifferentCurrency = Boolean(cartCurrency && billingCurrency && cartCurrency !== billingCurrency);

    /**
     * Certain countries (e.g. IN) only allow domestic transactions, transactions between
     * a buyer and merchant both from that country (e.g. IN buyer & IN merchant), to be
     * done in the domestic currency (e.g. INR). For these countries we should not show
     * the conversion information, even if the cart currency is different from the countries
     * domestic currency. (See PPPLMER-63051)
     */
    var ineligibleDomesticCountriesList = _squid.$util.getProperty(_squid.$config, 'currencyConversion.domesticTransactionsIneligibleCountries', { 'default': [] });
    var merchantCountry = scope.checkoutAppData.get('merchant.merchant_country');
    var isForcedDomesticConversion = _squid.$locale.country === merchantCountry && ineligibleDomesticCountriesList.includes(_squid.$locale.country);

    return hasDifferentCurrency && !isForcedDomesticConversion;
};

/**
 * @function removeNonNumericCharsAndTruncate
 * @description removes non-numeric chars and optionally truncates
 *      the string based on the provided `maxLen` param
 * @param {string} str
 * @param {number} maxLen
 * @returns {string}
 */
var removeNonNumericCharsAndTruncate = exports.removeNonNumericCharsAndTruncate = function removeNonNumericCharsAndTruncate(str, maxLen) {
    if (typeof str !== 'string') {
        return '';
    }

    var replacedStr = str.replace(/[^0-9]+/g, '');

    return maxLen ? replacedStr.slice(0, maxLen) : replacedStr;
};

_squid.$config;

_squid.$locale;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCvvDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
    tag: 'xo-cvv',
    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        showLabel: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
            this.cvvLength = function () {
                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
            };
            this.cvvRequired = function () {
                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
            };
        }
    }
});

angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_cardMetaData.$CardMetaData;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\">\n    <div class=\"cvvSecurityCode inputField\" floating-label directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-key=\"validation.validCSC\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <label ng-if=\"showLabel\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {

    return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', [function () {
        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                message: '=?',
                pagetitle: '=?',
                sidebar: '=?',
                showmeftsection: '=?',
                hideparenthead: '=?',
                promotion: '=?',
                pageLevel: '=?',
                logout: '=?',
                phone: '=?',
                fundingid: '=?',
                onSuccess: '=?',
                backUri: '=?'
            },

            controller: ['$scope', '$state', '$populate', '$AddCardModel', '$CardModel', '$CheckoutSessionModel', '$PrefillAddressModel', '$util', '$renderContent', function ($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {

                $scope.addCCDone = function () {
                    $scope.parentCallbacks.finish();
                };

                $scope.callbacks = {
                    done: function done() {
                        $scope.parentCallbacks.finish();
                    },

                    showCep: function showCep() {
                        $scope.prefillAddress = new $PrefillAddressModel({
                            id: $scope.token
                        });

                        $state.go('^.addCep');
                    },

                    cardTypeSelected: function cardTypeSelected(type) {
                        $scope.selectedPromotionCardType = {
                            type: type
                        };
                        $state.go('^.addCard');
                    }
                };

                $scope.cepDone = function () {
                    $state.go('^.addBilling');
                };

                $scope.selectedPromotionCardType = {
                    type: $scope.promotion && $scope.promotion.type
                };

                if ($scope.promotion) {
                    $scope.promotion.type = null;
                }

                $scope.billingaddressupdated = {
                    value: false
                };

                $scope.phone = {
                    hide_type: true
                };

                $scope.cardmodel = new $AddCardModel({
                    card: new $CardModel()
                });

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                        contingencies: {
                            NEED_CREDIT_CARD: angular.noop,
                            EXPIRED_CREDIT_CARD: angular.noop
                        }
                    })
                }).then(function () {

                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
                        var card = $scope.checkoutSession.errorData.resolution.data;

                        if (card.fundingId && card.fi && card.fi.type) {
                            $scope.cardmodel.id = card.fundingId;
                            $scope.cardmodel.card = new $CardModel({
                                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                type: card.fi.type.toUpperCase(),
                                productType: card.fi.productType
                            });
                        }
                    }
                    if ($scope.fundingid) {
                        var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                            if (funding && funding.id === $scope.fundingid) {
                                return funding;
                            }
                        });

                        if (fundingSource) {
                            $scope.cardmodel.id = fundingSource.id;
                            $scope.cardmodel.card = new $CardModel({
                                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                                lastDigits: fundingSource.lastDigits,
                                type: fundingSource.name,
                                name: $renderContent('fsMappings.' + fundingSource.name)
                            });
                        }
                    }
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
    tag: 'xo-dob-card-input',
    template: _template2['default'],

    props: {
        user: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            function pad() {
                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

                return function (num) {
                    return (new Array(length + 1).join('0') + num).substr(-length);
                };
            }

            var year = new Date().getFullYear();

            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
        }
    }
});


_squid.$Component;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

Object.keys(_cardMetaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cardMetaData[key];
    }
  });
});

var _directive2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

Object.keys(_directive2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive2[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('CardRoute', {

            name: 'addCardFlow',
            directive: 'xo-add-card-flow',
            titleContent: 'asideHeader.addCard',
            children: [{
                name: '$AddCardRoute',
                attributes: {
                    token: 'token',
                    cardmodel: 'cardmodel',
                    done: 'addCCDone',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    sidebar: 'sidebar',
                    showmeftsection: 'showmeftsection',
                    hideparenthead: 'hideparenthead',
                    billingaddressupdated: 'billingaddressupdated',
                    isupdatecard: 'isupdatecard',
                    'parent-callbacks': 'callbacks',
                    'selected-promotion-card-type': 'selectedPromotionCardType',
                    promotion: 'promotion',
                    'page-level': 'pageLevel',
                    logout: 'logout',
                    phone: 'phone',
                    'on-success': 'onSuccess',
                    'back-uri': 'backUri'
                }

            }, {
                name: '$SelectCardRoute',
                attributes: {
                    token: 'token',
                    'parent-callbacks': 'callbacks',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    sidebar: 'sidebar',
                    'selected-promotion-card-type': 'selectedPromotionCardType',
                    promotion: 'promotion'
                }
            }, {
                name: '$AddBillingRoute',
                attributes: {
                    token: 'token',
                    sidebar: 'sidebar',
                    showmeftsection: 'showmeftsection',
                    'parent-callbacks': 'callbacks',
                    hideparenthead: 'hideparenthead',
                    billingaddressupdated: 'billingaddressupdated',
                    'prefill-address': 'prefillAddress'
                }
            }, {
                name: '$AddCepRoute',
                attributes: {
                    token: 'token',
                    sidebar: 'sidebar',
                    'done-fn': 'cepDone',
                    'prefill-address': 'prefillAddress'
                }
            }]
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card", "../node_modules/xo-wallet-components/src/add-card/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/selectcard/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {

    return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', [function () {

        return {
            template: template,

            scope: {
                parentCallbacks: '=?',
                token: '=?',
                promotion: '=?'
            },

            controller: ['$scope', '$populate', '$CheckoutSessionModel', function ($scope, $populate, $CheckoutSessionModel) {

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    $scope.selectCardType = function (type) {
                        // card type is either 'cc' or 'plcc'
                        $scope.parentCallbacks.cardTypeSelected(type);
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', ['$ComponentRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SelectCardRoute', {

            name: 'selectCard',
            directive: 'xo-select-card',
            titleContent: 'asideHeader.selectCard',
            children: []
        });
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/selectcard", "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
var ONE_MINUTE_IN_SECS = 60;

exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
    tag: 'xo-confirm-otp',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardModel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        message: {
            type: 'var',
            required: false
        },
        buttonTextKey: {
            type: 'var',
            required: false
        }
    },
    actions: {
        addMessage: function addMessage(type, contentKey) {
            if (contentKey) {
                this.message({
                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
                    type: type || 'error'
                });
            }
        },
        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
            if (this.confirmCodeTimer) {
                _angular.$interval.cancel(this.confirmCodeTimer);
            }
            this.countdown = 0;
        },
        stopResendCodeTimer: function stopResendCodeTimer() {
            if (this.resendCodeTimer) {
                _angular.$timeout.cancel(this.resendCodeTimer);
            }
            this.showResendLink = false;
        },
        updateCountdown: function updateCountdown() {
            if (this.countdown > 0) {
                this.countdown--;
                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
            } else {
                if (!this.isConfirmProcessing) {
                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
                }
                this.actions.stopConfirmCodeTimer();
                this.actions.stopResendCodeTimer();
            }
        },
        startCountdown: function startCountdown(resetTimer) {
            var _this = this;

            if (resetTimer) {
                this.actions.stopConfirmCodeTimer();
                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
                this.actions.updateCountdown();
                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
            }

            this.actions.stopResendCodeTimer();
            this.showResendLink = false;
            this.resendCodeTimer = (0, _angular.$timeout)(function () {
                _this.showResendLink = true;
            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
            this.actions.addMessage('success', 'confirmUpop.codeSent');
        },
        processed: function processed() {
            if (!this.countdown && this.isConfirmProcessing) {
                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
            }
            this.isProcessing = this.isConfirmProcessing = false;
        },
        handleContingencies: function handleContingencies() {
            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var prop = arguments[1];

            var errorData = void 0;

            if (result.errorCodes) {
                errorData = result;
            } else {
                errorData = {
                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
                };
            }

            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

            if (window.scrollTo) {
                window.scrollTo(0, 0);
            }
        },
        sendNewCode: function sendNewCode() {
            // reset the code field.
            if (this.cardModel) {
                this.cardModel.otp_code = '';
            }
            this.actions.resendCode(true);
        },
        resendCode: function resendCode(resetTimer) {
            var _this2 = this;

            this.isProcessing = true;

            this.resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this2.actions.startCountdown(resetTimer);
                },

                error: function error() {
                    _this2.actions.handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this2.cardLast4
                        };

                        _this2.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        _this2.actions.handleContingencies();
                    }
                }
            })['finally'](this.actions.processed);
        },
        confirmOTP: function confirmOTP() {
            var _this3 = this;

            this.isProcessing = this.isConfirmProcessing = true;

            this.resolveOTP.action('complete', {
                silent: true,
                data: {
                    code: this.cardModel.otp_code,
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    },
                    card_data: {
                        expiration_time: {
                            month: this.cardModel.expiry_month,
                            year: this.cardModel.expiry_year
                        },
                        card_verification_code: this.cardModel.security_code
                    }
                },

                success: this.onSuccess,

                error: function error() {
                    _this3.actions.handleContingencies({}, 'confirmUpop');
                    _this3.actions.processed();
                },

                contingencies: {
                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this3.cardLast4
                        };

                        _this3.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
                        _this3.actions.processed();
                    }
                }
            })['catch'](function () {
                _this3.actions.handleContingencies();
                _this3.actions.processed();
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardModel.id });
            this.isProcessing = this.showResendLink = false;
            this.cardLast4 = this.cardModel.last4();
            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
            this.actions.startCountdown(true);

            if (!this.buttonTextKey) {
                this.buttonTextKey = 'common.confirm';
            }

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this4.$element.addClass('processing');
                } else {
                    _this4.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_angular.$interval;

_angular.$timeout;

_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardModel.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-key=\"confirmUpop.fieldInvalidOTP\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"{{buttonTextKey}}\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _addCard = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/styles.less");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/template.html");

var _template2 = _interopRequireDefault(_template);

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
    tag: 'xo-confirm-upop',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardModel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        },
        buttonTextKey: {
            type: 'var',
            required: false
        },
        onInitError: {
            type: 'var',
            required: false
        }
    },

    actions: {
        initSuccess: function initSuccess() {
            this.showCollectOtpScreen = true;
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.phone = this.props.phone || {};
            this.cardLast4 = this.cardModel.last4();

            // Set only from Login page
            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;

            (0, _angular.$timeout)(function () {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
                if (_this.fromLoginOverlay) {
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
                    });
                }
            });

            var hideModal = function hideModal() {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
            };

            var done = function done(handler, target, errorData) {
                hideModal();
                (0, _angular.$timeout)(function () {
                    return handler ? handler(errorData) : _this.goto(target);
                }, 300);
            };

            var _success = function _success() {
                done(_this.props.onSuccess, 'checkout.review');
            };

            this.closeModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                done(_this.props.onCancel, '^');
            };

            this.confirmed = function () {
                if (_this.props.onSuccess) {
                    // Make sure Guest/Signup always passes the onSuccess callback method.
                    return _success();
                }

                // Update is only applicable for Hermes Member flow.
                var checkoutSession = _index.$CheckoutSessionModel.instance(_this.token);

                checkoutSession.fundingOptions.action('update', {
                    resultModel: checkoutSession,
                    silent: true,
                    data: {
                        planId: _this.cardModel.id
                    },
                    success: function success() {
                        if (checkoutSession.cvvData) {
                            checkoutSession.set('cvvData.security_code', _this.cardModel.security_code);
                        }
                        var isNewCard = !_this.cardModel.isExisting();

                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];

                        checkoutSession.message = {
                            type: 'success',
                            msgKeys: msg
                        };

                        _success();
                    },
                    contingencies: {
                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                            checkoutSession.message = {
                                type: 'info',
                                msgKeys: 'creditcard.addedButCannotUse'
                            };

                            _success();
                        }
                    }
                });
            };

            this.flag = function (field) {
                return _addCard.$CardMetaData.getMetaData(_this.cardModel, field);
            };

            this.setMessage = function (message) {
                _this.message = message;
            };

            this.setInitErrorData = function (errorData) {
                if (_this.props.onInitError) {
                    // Pass on the errorData to onInitError callback function for client specific content adaptation.
                    done(_this.props.onInitError, '^', errorData);
                } else {

                    // prop for last 4 digits of card in error message
                    var prop = {
                        number: _this.cardModel.last4()
                    };

                    // Build the content message from errorData
                    _this.setMessage(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
                }
            };
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$stateParams;

_addCard.$CardMetaData;

_util.$fiErrorUtil;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
    tag: 'xo-init-otp',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardModel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        flag: {
            type: 'var',
            required: false
        },
        setErrorData: {
            type: 'var',
            required: false
        }
    },

    actions: {
        initOtp: function initOtp() {
            var _this = this;

            var handleContingencies = function handleContingencies() {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var prop = arguments[1];

                var errorData = void 0;

                if (result.errorCodes) {
                    errorData = result;
                } else {
                    errorData = {
                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
                    };
                }

                _this.setErrorData(errorData);

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            };

            this.isProcessing = true;

            var resolveOTP = new _index.$ResolveOTP({ id: this.cardModel.id });

            resolveOTP.action('init', {
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this.onSuccess();
                },

                error: function error() {
                    handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {

                        handleContingencies(result);
                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        handleContingencies();
                    }
                }
            })['finally'](function () {
                _this.isProcessing = false;
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this2.$element.addClass('processing');
                } else {
                    _this2.$element.removeClass('processing');
                }
            });

            if (this.flag('fields.expiry') && !this.cardModel.get('expiry_month') || this.flag('fields.cvv') && !this.cardModel.get('security_code') || this.flag('fields.phone') && !(this.phone && this.phone.telephone)) {

                this.showInitScreen = true;
            } else {
                this.actions.initOtp();
            }

            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showInitScreen\" class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardModel.expiry_month\" expiry-year=\"cardModel.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardModel\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoConfirmUpopRoute', {
    path: 'confirmUpop',
    directive: _directive2['default'],
    titleContent: 'confirmUpop.confirm',
    trackingData: {
        fptiState: 'confirm_upop'
    },
    query: ['fromLoginOverlay'],
    loginRequired: true,
    pageOnOverlay: true,
    children: []
});


_index.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" set-error-data=\"setInitErrorData\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"actions.initSuccess\" flag=\"flag\" ng-if=\"!showCollectOtpScreen\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"confirmed\" ng-if=\"showCollectOtpScreen\" button-text-key=\"buttonTextKey\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"ppLogoContainer\">\n                <div class=\"logo\"></div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionOptions', {
    tag: 'xo-currency-conversion-options',

    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        token: {
            type: 'var',
            required: false
        },
        treatment: {
            type: 'var',
            required: false
        },
        isPrePlan: {
            type: 'str',
            required: false
        },
        updateConversionSelection: {
            type: 'var',
            required: false
        },
        openModal: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var modelsObj = {
                checkoutCart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve()
            };

            if (!this.isPrePlan) {
                modelsObj.checkoutSession = _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve();
            }

            return modelsObj;
        }
    },

    actions: {
        onConversionOptionChange: function onConversionOptionChange() {
            if (this.isPrePlan) {
                this.card.ppconversion = this.models.ppconversion;
            } else {
                // For post-plan conversion we need to update the chosen conversion
                // selection in the guest currency conversion interstitial component
                this.updateConversionSelection(this.models.ppconversion);
            }

            /**
             * FPTI event #4 for Buyer FX guest experience
             * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
             */
            var planType = this.isPrePlan ? 'pre' : 'post';

            _logger.$logger.info('checkout_fpti', {
                from: 'CURRENCY_CONVERSION',
                to: 'changed_currency_conversion_' + planType + '_plan',
                currency_conversion_selected: this.models.ppconversion,
                currency_conversion_from_curr: this.conversion.from_code,
                currency_conversion_to_curr: this.conversion.to_code,
                currency_conversion_spread: this.conversion.spread
            });

            this.conversionIsPayPal = this.models.ppconversion === this.conversionOptions.PAYPAL;
        }
    },

    lifecycle: {
        enter: function enter() {
            this.conversionOptions = _squid.$config.currencyConversion.options;
            this.isPrePlan = this.props.isPrePlan === 'true';
            var _props$treatment = this.props.treatment,
                treatment = _props$treatment === undefined ? '' : _props$treatment;


            this.isTreatment1 = treatment.includes('treatment_1');
            this.conversionIsPayPal = true;
        },
        populate: function populate() {
            this.models.ppconversion = this.conversionOptions.PAYPAL;

            /**
             * In the pre-plan case the conversion data will be located at
             * this.card.currencyConvData, whereas in the post-plan caes it
             * will be located at this.models.checkoutSession.plan.converison
             */
            var modelWithConversion = this.isPrePlan ? this.card : this.models.checkoutSession;
            var conversionKey = this.isPrePlan ? 'currencyConvData' : 'plan.conversion';

            this.conversion = modelWithConversion.get(conversionKey);

            var _models$checkoutCart$ = this.models.checkoutCart.get('grossTotalAmount', {}),
                toValue = _models$checkoutCart$.value,
                toCurrency = _models$checkoutCart$.currency;

            var _conversion = this.conversion,
                fullString = _conversion.to,
                amount = _conversion.to_amount,
                amountForex = _conversion.to_amount_forex,
                fromCurrency = _conversion.from_code;

            var formattedToStr = (0, _squid.truncateCurrencyConversionString)({
                fullString: fullString,
                amount: amount,
                amountForex: amountForex
            });

            this.paypalRate = '1 ' + fromCurrency + ' = ' + formattedToStr;
            this.spread = this.conversion.spread;

            // Get formatted currency amounts to display
            var paypalTotalPath = this.isPrePlan ? 'currencyConvData.payment_amt.value' : 'plan.sources.0.amount.amount_formatted_currency';

            this.paypalConversionTotal = this.isPrePlan ? (0, _squid.formatCurrency)(this.card.get(paypalTotalPath), fromCurrency, false) : this.models.checkoutSession.get(paypalTotalPath);
            this.issuerConversionTotal = (0, _squid.formatCurrency)(toValue, toCurrency, false);

            // Currency codes are used as labels for treatment 2
            this.toCurrency = toCurrency;
            this.fromCurrency = fromCurrency;

            // New Zealand departed from the other non-localized APAC countries and is not
            // showing the PayPal rate disclosure but instead is showing the spread disclosure
            this.showRateDisclosure = _squid.$locale.country !== 'NZ';
            this.showBRDisclosure = _squid.$locale.country === 'BR';
            var _$config$AMLRuleCount = _squid.$config.AMLRuleCountries,
                AMLRuleCountries = _$config$AMLRuleCount === undefined ? [] : _$config$AMLRuleCount;


            this.showAMLDisclosure = AMLRuleCountries.includes(_squid.$locale.country);

            // When the pre-plan API fails we show the conversion options
            // in an interstitial after the user submits the form.
            if (!this.isPrePlan && typeof this.openModal === 'function') {
                // eslint-disable-line angular/typecheck-function
                this.openModal();
            }
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.formatCurrency;

_squid.$config;

_squid.truncateCurrencyConversionString;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"conversion-options-container\" data-test-id=\"conversion-options-container\" content>\n    <ul class=\"conversion-options\">\n        <!-- PayPal conversion option -->\n        <li class=\"conversion-options__option\">\n            <input\n                type=\"radio\"\n                ng-model=\"models.ppconversion\"\n                ng-change=\"actions.onConversionOptionChange()\"\n                name=\"ppconversion\"\n                id=\"conversion-PayPal\"\n                value=\"{{conversionOptions.PAYPAL}}\"\n                data-test-id=\"conversion-paypal\"\n                required/>\n            <label for=\"conversion-PayPal\" data-test-id=\"conversion-paypal-label\">\n                {{ isTreatment1 ? content('currencyOptions.bfxConversionPayPalLabelRate') : fromCurrency }}\n            </label>\n        </li>\n\n        <!-- Issuer conversion option -->\n        <li class=\"conversion-options__option\">\n            <input\n                type=\"radio\"\n                class=\"conversion-option-input\"\n                ng-model=\"models.ppconversion\"\n                ng-change=\"actions.onConversionOptionChange()\"\n                name=\"ppconversion\"\n                id=\"conversion-vendor\"\n                value=\"{{conversionOptions.VENDOR}}\"\n                data-test-id=\"conversion-vendor\"\n                required/>\n            <label for=\"conversion-vendor\" data-test-id=\"conversion-vendor-label\">\n                {{ isTreatment1 ? content('currencyOptions.bfxConversionIssuerLabelRate') : toCurrency }}\n            </label>\n        </li>\n    </ul>\n\n    <dl class=\"conversion-total\" data-test-id=\"conversion-total\">\n        <!-- PayPal conversion amount -->\n        <dt class=\"conversion-total__title\" ng-if=\"conversionIsPayPal\">\n            {{ content('currencyOptions.bfxConversionPayPalTotal') }}\n        </dt>\n        <dd class=\"conversion-total__amount\" ng-if=\"conversionIsPayPal\">\n            {{ paypalConversionTotal }}\n        </dd>\n\n        <!-- Issuer conversion amount -->\n        <dt class=\"conversion-total__title\" ng-if=\"!conversionIsPayPal\">\n            {{ content('currencyOptions.bfxConversionIssuerTotal') }}\n        </dt>\n        <dd class=\"conversion-total__amount\" ng-if=\"!conversionIsPayPal\">\n            {{ issuerConversionTotal }}\n        </dd>\n    </dl>\n\n    <ul class=\"conversion-disclaimers\">\n        <!-- PayPal conversion disclaimers -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-paypal-rate\"\n            ng-if=\"conversionIsPayPal\"\n            data-test-id=\"disclaimer-paypal\">\n            {{ content('currencyOptions.bfxConversionPayPalRate') }} {{ paypalRate }}\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer\"\n            ng-if=\"conversionIsPayPal\"\n            data-test-id=\"disclaimer-paypal-spread\">\n            {{ content('currencyOptions.bfxConversionPayPalSpreadDisclosureGuest', { spread: spread }) }}\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer\"\n            ng-if=\"conversionIsPayPal && showRateDisclosure\"\n            data-test-id=\"disclaimer-paypal-rate\">\n            {{ content('currencyOptions.bfxConversionPayPalRateDisclosure') }}\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-secondary\"\n            ng-if=\"conversionIsPayPal && showAMLDisclosure\"\n            data-test-id=\"disclaimer-paypal-AML\">\n            {{ content('currencyOptions.bfxConversionAMLRulesDisclosure') }}\n        </li>\n\n        <!-- Issuer conversion disclaimers -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-issuer-rate\"\n            ng-class=\"{ 'conversion-disclaimer-inline': isPrePlan }\"\n            ng-if=\"!conversionIsPayPal\"\n            data-test-id=\"disclaimer-issuer\">\n            {{ content('currencyOptions.bfxConversionIssuerDisclosure') }}\n        </li>\n\n        <!-- BR disclaimer that applies to PayPal and Issuer -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-secondary\"\n            ng-if=\"showBRDisclosure\"\n            data-test-id=\"disclaimer-IOF\">\n            {{ content('currencyOptions.bfxConversionBRIOFRateDisclosure') }}\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    // When adding a key, please keep list in alphabetical order
    var contingencyList = {
        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
        COUNTRY_NOT_SUPPORTED: 'complianceDecline',
        DUPLICATED_TRANSACTION: 'duplicateTransaction',
        EMPTY_DATA: 'errorGeneral',
        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
        INTERNAL_ERROR: 'errorInternalError',
        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
        INVALID_BANK_ADDRESS: 'errorGeneral',
        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
        INVALID_BANK_IBAN: 'invalidPINumber',
        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
        INVALID_EXPIRY: 'errorInvalidExpirationDate',
        INVALID_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_IBAN_CODE: 'invalidPINumber',
        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
        INVALID_LAST_NAME: 'errorInvalidLastName',
        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
        INVALID_PHONE: 'errorInvalidPhone',
        INVALID_SECURITY_CODE: 'errorInvalidCSC',
        ISSUER_DECLINE: 'errorIssuerReject',
        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
        NOT_CONFIRMED: 'notConfirmed',
        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
        RESTRICTED_CARD: 'cardRestricted',
        RESTRICTED_CARD_GUEST: 'cardRestrictedGuest',
        SETTLEMENT_DENIED: 'errorInstrumentRefused',
        TRANSACTION_TIMEOUT: 'transactionTimeout',
        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue'
    };

    return contingencyList;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, contingencyList) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', ['$renderContent', function ($renderContent) {
        return {
            addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {

                // error handling for filifecycle and fimanagement. 
                if (!errorData.errorCodes) {
                    errorData.errorCodes = errorData && [errorData['0']];
                }

                var messages = [];

                if (errorData.errorCodes && errorData.errorCodes.length) {
                    errorData.errorCodes.forEach(function (errorCode) {
                        var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
                        var message;

                        if (angular.isArray(contentKey)) {
                            for (var i = 0; i < contentKey.length; i++) {
                                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
                                if (message && message.string) {
                                    break;
                                }
                            }
                        } else {
                            message = $renderContent(contentBundle + '.' + contentKey, prop);
                        }

                        messages.push(message);
                    });

                    return {
                        msgs: messages,
                        type: 'error'
                    };
                }
            },

            /**
             * Highlight the Error Fields by ng-model
             * @param errorData
             * @param element
             * @param modelPrefix
             */
            addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {

                if (errorData.fields && errorData.fields.length) {
                    errorData.fields.forEach(function (field) {
                        var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');

                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    });
                }
                $(element).find('.backendError:first').focus();
            },

            /**
             * Highlight the Error Fields by element name
             * @param errorData
             * @param element
             * @param modelPrefix
             */
            addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {

                if (errorData.fields && errorData.fields.length) {
                    errorData.fields.forEach(function (field) {
                        var fieldName = void 0;

                        if (modelPrefix && field.field && field.field.length > 0) {
                            // Add prefix with CamelCase of field name
                            fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
                        } else {
                            fieldName = field.field;
                        }
                        var $field = $(element).find('[name="' + fieldName + '"]');

                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    });
                }
                $(element).find('.backendError:first').focus();
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/fi-contingency-list", "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/installment-options/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-installment-options.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xo-tray-height.directive']).directive('xoInstallmentOptions', [function () {
        return {
            template: template,

            scope: {
                token: '=?',
                doneFn: '=?',
                cardNumber: '=?'
            },

            controller: ['$AuthModel', '$scope', '$populate', '$CheckoutSessionModel', '$InstallmentOptionsModel', '$CheckoutPayeeModel', '$CheckoutCartModel', '$CheckoutAppDataModel', function ($AuthModel, $scope, $populate, $CheckoutSessionModel, $InstallmentOptionsModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel) {

                $populate($scope, {
                    auth: $AuthModel.instance($scope.token)
                }).then(function () {

                    if ($scope.auth.logged_in) {

                        // Installment support for authenticated user
                        $populate($scope, {
                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
                        }).then(function () {
                            $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
                            $scope.installments = $scope.checkoutSession.installments;
                        });
                    } else {
                        // Installment support added for not authenticated user, e.g. BR signup flow
                        var installmentsModel = $InstallmentOptionsModel.instance($scope.token);

                        installmentsModel.save({
                            data: {
                                cc: $scope.cardNumber,
                                payee: $CheckoutPayeeModel.instance($scope.token),
                                checkoutCart: $CheckoutCartModel.instance($scope.token),
                                checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                            },

                            success: function success(result) {
                                $scope.cardInfo = result.cardInfo;
                                $scope.installments = result.installment_options;
                            }
                        });
                    }
                });

                $scope.onSelect = function (index) {
                    var selectedInstallmentData = $scope.installments[index];

                    $scope.installmentsModel = $InstallmentOptionsModel.instance($scope.token);

                    var param = {
                        term: selectedInstallmentData.term,
                        payment_value: selectedInstallmentData.monthly_payment.value,
                        payment_currency: selectedInstallmentData.monthly_payment.currency
                    };

                    if (selectedInstallmentData.total_cost) {
                        param.total_cost_value = selectedInstallmentData.total_cost.value;
                        param.total_cost_currency = selectedInstallmentData.total_cost.currency;
                    }

                    if (selectedInstallmentData.discount_amount) {
                        param.discount_value = selectedInstallmentData.discount_amount.value;
                        param.discount_currency = selectedInstallmentData.monthly_payment.currency;
                    }

                    if (selectedInstallmentData.discount_percentage) {
                        param.discount_percentage = selectedInstallmentData.discount_percentage;
                    }

                    return $scope.installmentsModel.action('select', {
                        data: param,

                        success: function success(result) {
                            if ($scope.auth.logged_in) {
                                $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
                            }
                            $scope.doneFn(result);
                        }
                    });
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index6 = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");

__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/pay-upon-invoice/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoPayUponInvoice', {
    tag: 'xo-pay-upon-invoice',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                auth: _index5.$AuthModel.instance(this.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
            var days = [];
            var months = [];
            var years = [];

            var i = void 0;

            for (i = 1; i <= 31; i += 1) {
                var d = i < 10 ? '0' + i : i.toString();

                days.push(d);
            }

            for (i = 1; i <= 12; i += 1) {
                var m = i < 10 ? '0' + i : i.toString();

                months.push(m);
            }

            var year = new Date().getFullYear();

            for (i = year - 17; i >= year - 100; i -= 1) {
                years.push(i);
            }

            this.dobDays = days;
            this.dobMonths = months;
            this.dobYears = years;

            this.hideHelper = true;

            this.onboard = new _index3.$OnboardModel({
                user: new _index3.$OnboardUserModel({
                    country: _index.$locale.country
                }),
                billing_address: _index4.$BillingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),
                shipping_address: _index2.$ShippingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),

                phone: new _index3.$OnboardPhoneModel()
            });
        },
        populate: function populate() {
            var _this = this;

            var shippingAddress = this.models.checkoutCart.get('purchase.shipping_address');
            var billingAddress = this.models.checkoutCart.get('billing_address') || {};

            billingAddress.first_name = this.models.checkoutCart.get('payer.first_name');
            billingAddress.last_name = this.models.checkoutCart.get('payer.last_name');

            // basic validation to check if any data is missing
            var validateAddress = function validateAddress(address) {
                return address && address.line1 && address.city && address.postal_code;
            };

            /**
            /* Set prefill billing address. By default set to merchant passed billing address if its valid
             * Otherwise prefill valid shipping address as billing address
             */

            var getDefaultAddress = function getDefaultAddress() {
                var isValidBilling = validateAddress(billingAddress);
                var isValidShipping = validateAddress(shippingAddress);
                var defaultAddress = billingAddress;

                _logger.$logger.info('pay_upon_invoice_is_billing_valid_' + isValidBilling);
                if (!isValidBilling && isValidShipping) {
                    defaultAddress = shippingAddress;
                    _logger.$logger.info('pay_upon_invoice_set_shipping_as_default');
                }
                return defaultAddress || {};
            };

            var prefilledAddress = getDefaultAddress();

            this.isPrefilledAddress = validateAddress(prefilledAddress) && prefilledAddress.first_name && prefilledAddress.last_name;
            if (this.isPrefilledAddress) {
                this.shipping = prefilledAddress;
                this.shipping.recipientName = prefilledAddress.first_name + ' ' + prefilledAddress.last_name;
                this.shipping.zipAndCity = prefilledAddress.postal_code + ' ' + prefilledAddress.city;
            }

            var getPayButtonText = function getPayButtonText() {
                _this.useraction = _this.models.checkoutAppData.useraction();

                var payButtonText = _index.$locale.content.get('common.agreeAndContinue');

                if (_this.useraction && _this.useraction.toLowerCase() === 'commit') {
                    payButtonText = _index.$locale.content.get('common.agreeAndPay');
                }
                return payButtonText;
            };

            this.payButtonText = getPayButtonText();

            /**
            /* Set the prefilled Phone Number either from shipping address or billing address which merchants pass while making create payment call
             * If both are present shipping address take the preference over billing address.
             */
            var prefilledNumber = this.models.checkoutCart.get('purchase.phone_fields') || this.models.checkoutCart.get('billing.phone_fields');

            if (prefilledNumber && prefilledNumber.telephone_country === _index.$locale.country) {
                this.onboard.phone.telephone = prefilledNumber.normalized_phone_number;
            }

            this.onboard.shipping_address = _index2.$ShippingAddressModel.create(this.token, { country: _index.$locale.country }, prefilledAddress);

            this.onboard.billing_address = _index4.$BillingAddressModel.create(this.token, {
                country: _index.$locale.country
            }, prefilledAddress);

            // saving in to user object so that email field pre-populate if its passed in from setEc.
            this.onboard.user.email = this.models.checkoutCart.payer && this.models.checkoutCart.payer.email;
        }
    },

    actions: {
        changeShipping: function changeShipping() {
            this.isPrefilledAddress = !this.isPrefilledAddress;
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.onboard.billing_address.country = _index.$locale.country;
            this.addressNormalization = new _index6.$AddressNormalizationModel({
                address: this.onboard.billing_address
            });

            var handleValidation = function handleValidation() {

                var data = {
                    errorCodes: ['BILL_ADDR_NOT_ALLOWED']
                };

                _this2.errorMessage = _util.$fiErrorUtil.addPageErrors(data, 'payUponInvoice');

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }

                return _angular.$q.reject();
            };

            this.addressNormalization.save({

                data: this.addressNormalization,

                contingencies: {
                    VALIDATION_ERROR: function VALIDATION_ERROR() {
                        handleValidation()['catch'](function (error) {
                            _logger.$logger.info('PUI_addressNormalization_validation_rejection_captured');
                        });
                    }

                },
                error: function error() {
                    _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
                },
                success: function success(result) {
                    var loginDataGsid = {
                        user: {
                            email: _this2.onboard.user.email
                        },
                        pui_flow: true
                    };
                    // Adding login call to get the Global session ID
                    // by passing email and actorinfovo(just with actor type) to STS.
                    // auth_state will be anonymous after the below passive login call.
                    // since account is not created yet.

                    return _angular.$q.when().then(function () {
                        _logger.$logger.info('PUI_Invoking_login_call_to_get_GSID');
                        return _this2.models.auth.action('login', {
                            data: loginDataGsid,
                            success: function success() {
                                _logger.$logger.info('PUI_login_call_succeeded');
                            },
                            error: function error() {
                                _logger.$logger.info('PUI_login_call_failed_to_get_GSID');
                                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
                            }
                        }).then(function () {
                            _this2.normalizedAddress = result;

                            var checkoutSession = _index2.$CheckoutSessionModel.instance(_this2.token);

                            checkoutSession.action('createPUI', {
                                data: {
                                    user: _this2.onboard.user,
                                    address: _this2.onboard.billing_address,
                                    isPayerRequired: true,
                                    paymentMethod: 'pay_upon_invoice',
                                    phone: _this2.onboard.phone || ''

                                },
                                contingencies: {
                                    PAYMENT_METHOD_UNUSABLE: function PAYMENT_METHOD_UNUSABLE() {
                                        _uiRouter.$state.go('checkout.genericError', {
                                            code: 'PAYMENT_PROCESS_ERROR'
                                        });
                                    }
                                },
                                error: function error() {
                                    _logger.$logger.info('PUI: checkout session creation failed');
                                    _uiRouter.$state.go('checkout.genericError', {
                                        code: 'PAYMENT_PROCESS_ERROR'
                                    });
                                },
                                success: function success(successResult) {
                                    var loginData = {
                                        user: {
                                            account_number: successResult.payer.account_number,
                                            email: successResult.payer.email
                                        }
                                    };

                                    return _angular.$q.when().then(function () {
                                        return _this2.models.auth.action('login', {
                                            data: loginData,
                                            success: function success() {
                                                _logger.$logger.info('PUI: guest login', {
                                                    from: 'LOGIN',
                                                    to: 'process_login'
                                                });
                                            },
                                            error: function error() {
                                                _logger.$logger.info('PUI: login guest user failed');
                                                _uiRouter.$state.go('checkout.genericError', { code: 'PAYMENT_PROCESS_ERROR' });
                                            }
                                        }).then(function () {
                                            return checkoutSession.action('authorize', {
                                                error: function error() {
                                                    _logger.$logger.info('PUI: authorize payment failed');
                                                    _uiRouter.$state.go('checkout.genericError', {
                                                        code: 'PAYMENT_PROCESS_ERROR'
                                                    });
                                                },
                                                success: function success() {
                                                    _uiRouter.$state.go('checkout.end');
                                                }
                                            });
                                        });
                                    });
                                },
                                VALIDATION_ERROR: function VALIDATION_ERROR() {
                                    _uiRouter.$state.go('checkout.genericError', {
                                        code: 'PAYMENT_PROCESS_ERROR'
                                    });
                                }
                            });
                        });
                    });
                }
            });
        }
    }
});


_angular.$q;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$ShippingAddressModel;

_index3.$OnboardModel;

_index3.$OnboardUserModel;

_index3.$OnboardPhoneModel;

_index4.$BillingAddressModel;

_util.$fiErrorUtil;

_index5.$AuthModel;

_logger.$logger;

_uiRouter.$state;

_index6.$AddressNormalizationModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/pay-upon-invoice/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"payUponInvoice\" id=\"payUponInvoice\">\n\n\n    <div class=\"personalInfo\" >{{content('payUponInvoice.title')}}</div>\n    <xo-message message=\"errorMessage\"></xo-message>\n\n    <form id=\"payUponInvoiceForm\" name=\"payUponInvoiceForm\" class=\"payUponInvoiceForm\"\n          ng-submit=\"payUponInvoiceForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"addressArea\">\n            <label class=\"nolap billingLabel\">{{content('payUponInvoice.addressTitle')}}</label>\n            <div  ng-if=\"isPrefilledAddress\" class=\"billingArea\">\n                <div class=\"addressDisplay\" >\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.recipientName}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.line1}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\" ng-if=\"shipping.line2\">\n                        {{shipping.line2}}\n                    </div>\n\n                    <div class=\"postal-code\">\n                        {{shipping.zipAndCity}}\n                    </div>\n                </div>\n            </div>\n            <a class=\"edits changeShipping\" ng-if=\"isPrefilledAddress\" ng-click=\"actions.changeShipping()\" >\n                {{ content('common.change') }}\n            </a>\n        </div>\n\n        <div id=\"billingAddress\" class=\"billingArea clearfix\" ng-if=\"!isPrefilledAddress\">\n            <div class=\"addressSubTitle\">{{content('payUponInvoice.notification')}}</div>\n            <xo-add-address address=\"onboard.billing_address\" is-shipping=\"true\" country=\"locale.country\"></xo-add-address>\n        </div>\n\n        <div id=\"phone\" ng-if=\"isUnbranded\">\n            <xo-phone-input phone=\"onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n        </div>\n\n        <xo-email-input user=\"onboard.user\" hide-helper=\"hideHelper\"></xo-email-input>\n\n        <!-- DOB fields for Country specific cards -->\n        <!-- TODO: Pull out DOB fields into a separate component -->\n        <div id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\" >\n            <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n            <span class=\"dobHelper\">\n                <a href=\"#\" id=\"verifyHelp\" alt=\"Why do we need this\" class=\"verifyHelp\">\n                </a>\n            </span>\n\n            <xo-tooltip trigger=\"#verifyHelp\">\n                <div class=\"tip tipDesc emailToolTip\">\n                    {{ content('payUponInvoice.dobTooltip') }}\n                </div>\n            </xo-tooltip>\n            <div class=\"dropdown fidobDay nullable\">\n                <select xo-dropdown name=\"dobDayCC\" ng-model=\"onboard.user.dob_day\"\n                        ng-options=\"day for day in dobDays track by day\"\n                        id=\"dobDayCC\"  ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobMonth nullable\">\n                <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"onboard.user.dob_month\"\n                        ng-options=\"month for month in dobMonths track by month\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear nullable\">\n                <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"onboard.user.dob_year\"\n                        ng-options=\"year for year in dobYears track by year\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"row-fluid checkbox legal\">\n            <input ng-model=\"sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                   bind-html-compile=\"htmlContent('payUponInvoice.agreeTerms')\"></label>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit id=\"invoiceSubmit\" type=\"submit\" value=\"{{ payButtonText }}\"\n            class=\"btn\" ng-click=\"validated=true\" />\n        </div>\n    </form>\n</div>\n\n\n\n"

/***/ }),

/***/ "../node_modules/xo-webpack-config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__("../node_modules/object-assign/index.js");

// array
__webpack_require__("../node_modules/core-js/fn/array/find.js");
__webpack_require__("../node_modules/core-js/fn/array/includes.js");

// string
__webpack_require__("../node_modules/core-js/fn/string/includes.js");


// object
__webpack_require__("../node_modules/core-js/fn/object/entries.js");
__webpack_require__("../node_modules/core-js/fn/object/values.js");



/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("./css/app.less");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _route = __webpack_require__("./pages/xo-checkout/route.js");

var _route2 = __webpack_require__("./pages/xo-guest-upgrade/route.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

if (_index.$util.param('data')) {
    var guestUpgradeRoute = new _route2.$GuestUpgradeRoute();

    guestUpgradeRoute.bootstrap('guestupgrade', _middleware.$Middleware);
} else {
    var baseRoute = new _route.$BaseRoute();

    baseRoute.bootstrap('checkout.landing', _middleware.$Middleware);
}

window.bootstrap = true;

_logger.$logger;

_route.$BaseRoute;

_route2.$GuestUpgradeRoute;

_middleware.$Middleware;

_index.$util;

/***/ }),

/***/ "./js/bootstrap.js":
/***/ (function(module, exports, __webpack_require__) {



window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
//      http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('');
}]);

if (!window.prefetch) {
    angular.bootstrap(document.body, ['app']);
    __webpack_require__("./js/app.js");
}

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$contingencyHandler = $contingencyHandler;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function showGenericError(code) {
    return function (errCode) {
        errCode = code || errCode;
        // Encode error text
        errCode = errCode ? window.btoa(errCode) : errCode;
        _uiRouter.$state.go('checkout.genericError', {
            code: errCode
        });
    };
}

/**
 * Route with default parameters unless special handler implemented otherwise
 *
 * To satisfy url: '/pageAddCard/:country/:fiType' in the route definition.
 * {country: ..., fiType: ...} must be passed for ui.router..
 *
 */
function route(path, params) {
    return function () {
        _uiRouter.$state.go(path, params);
    };
}

var routeToAddCC = function routeToAddCC(msg, contingency) {
    var gamblingCauses = ['PAYER_FUNDING_INSTRUMENT_INELIGIBLE', 'PAYER_FINANCIAL_INSTRUMENT_OUT_OF_COUNTRY', 'PAYER_FINANCIAL_INSTRUMENT_UNDER_AGE'];
    var isGambling = gamblingCauses.indexOf(contingency.cause) > -1;
    var param = isGambling ? {
        gaming: '1'
    } : {};

    return route('checkout.pageAddCard.addCardFlow.addCard', param);
};

function forbidden(err) {
    throw new _squid.$Forbidden(err);
}

function fallback(product) {
    return function (err) {
        throw new _squid.$FallbackError({
            reason: err,
            product: product
        });
    };
}

function $contingencyHandler(contingency) {
    if (contingency instanceof _squid.$Contingency) {

        // Leave a footprint here. The subsequent state where log how it goes..
        _logger.$logger.warn('contingency_handler', contingency);

        return contingency.handle({
            // TODO : modify these routes
            // Route
            NEED_CREDIT_CARD: routeToAddCC,
            NEED_CONFIRMED_CARD: routeToAddCC,
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: routeToAddCC,
            EXPIRED_CREDIT_CARD: routeToAddCC,

            // Generic Error Pages
            CURRENCY_COMPLIANCE: showGenericError(),
            INVALID_RESOURCE_ID: showGenericError(),
            PAYMENT_ALREADY_DONE: showGenericError(),
            PAYEE_BLOCKED_TRANSACTION: showGenericError(),
            RESTRICTED_USER: showGenericError(),
            PAYMENT_DENIED: showGenericError(),
            PAYER_CANNOT_PAY: showGenericError(),
            PAYEE_ACCOUNT_RESTRICTED: showGenericError(),
            PAYER_COUNTRY_NOT_ALLOWED: showGenericError(),
            PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
            PAYER_COUNTRY_NOT_ENABLED: showGenericError(),
            PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError(),
            GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError(),
            GUEST_CHECKOUT_NOT_ALLOWED: showGenericError(),
            EINVALIDCSRF_JWT_EXPIRED: showGenericError(),

            // Fallbacks
            TRANSACTION_REFUSED: fallback('ux'),
            VERIFY_USER_IDENTITY: fallback('ux'),
            SENDING_LIMIT_EXCEEDED: fallback('ux'),
            PAYER_INVALID_FOR_PAYMENT: fallback('ux'),
            PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
            PERMISSION_DENIED: fallback('ux'),
            NEGATIVE_BALANCE_TRANSACTION_REFUSED: fallback('ux'),
            INVALID_TOKEN: fallback('ux'),
            INVALID_FUNDING_OPTION: fallback('ux'),
            INTERNAL_SERVICE_ERROR: fallback('ux'),
            VALIDATION_ERROR: fallback('ux'),
            SHIPPING_ADDRESS_INVALID: fallback('ux'),
            RISK_DENIED: fallback('ux'),
            DOMESTIC_TRANSACTION_REQUIRED: fallback('ux'),
            INVALID_ARGUMENT: fallback('ux'),
            CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
            UNSUPPORTED_PAYEE_CURRENCY: fallback('ux'),
            PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
            CANNOT_PAY_SELF: fallback('hermes'),

            // Forbidden
            BUYER_NOT_SET: forbidden,

            // TODO: duplicate - PAYER_INVALID_FOR_PAYMENT: forbidden,
            // Default
            DEFAULT: function logUnhandledContingency() {
                _logger.$logger.warn('ui_unhandled_contingency_' + this.message);

                throw new _squid.$FallbackError({
                    reason: 'unhandled_contingency',
                    product: 'ux'
                });
            }
        });
    }
}

angular.value("$contingencyHandler", $contingencyHandler);
_uiRouter.$state;

_logger.$logger;

_squid.$Forbidden;

_squid.$FallbackError;

_squid.$Contingency;

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$apiErrorHandler = $apiErrorHandler;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _fallback = __webpack_require__("./js/lib/fallback.js");

var _contingency = __webpack_require__("./js/lib/contingency.js");

var ERROR_STATE = void 0;
var ERROR_PREVENTED = void 0;

function $apiErrorHandler(err) {
    if (err instanceof _squid.$ApiError) {
        _logger.$logger.error('api_error', {
            error: err.toString()
        });

        throw new _squid.$FallbackError({
            reason: 'api_error',
            product: 'ux'
        });

        // @TODO - wtf?
        return true; // eslint-disable-line no-unreachable
    }
}

function $forbiddenHandler(err) {
    if (err instanceof _squid.$Forbidden) {
        _logger.$logger.warn('forbidden_handler');
        _index.$AuthModel.instance().invalidate();

        throw new _squid.$FallbackError({
            reason: 'user_not_logged_in',
            product: 'ux'
        });
    }
}

var handlers = [{
    type: _squid.$FallbackError,
    handle: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Contingency,
    handle: _contingency.$contingencyHandler
}, {
    type: _squid.$Forbidden,
    handle: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {
    if (ERROR_STATE) {
        if (ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    // non token based Guest Upgrade Flow
    if (_squid.$util.param('data')) {
        _logger.$logger.error('guest_upgrade_error', {
            error: err
        });
        _uiRouter.$state.go('guestupgrade.genericError', {
            code: 'GUEST_UPGRADE_ERROR'
        });
        return;
    }

    var handled = handlers.some(function (handler) {
        if (err instanceof handler.type) {
            handler.handle(err);
            return true;
        }

        return false;
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/) && !(err instanceof _squid.$Error)) {
        errName = errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    var errObj = {
        error: err.stack || err.toString(),
        message: errMsg,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: _angular.$window.location.toString()
    };

    _logger.$logger.error(errName, errObj);

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        route: (_uiRouter.$state || {}).current,
        message: errObj.error,
        code: errObj.cause,
        currentRoute: _uiRouter.$state.current
    });

    if (event.defaultPrevented) {
        ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

function constructEventName(toState, fromState) {
    var fromStateFormatted = fromState.name.replace(/\./g, '_') || 'start';
    var toStateFormatted = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + fromStateFormatted + '_to_' + toStateFormatted;
}

var stateChangeError = _angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});
var windowError = _angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        debounceFactor: details.message,
        debounceInterval: 1000
    });
});

_angular.$rootScope.$on('$destroy', stateChangeError);
_angular.$rootScope.$on('$destroy', windowError);

angular.value("$apiErrorHandler", $apiErrorHandler);
angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_angular.$rootScope;

_angular.$window;

_uiRouter.$state;

_squid.$Forbidden;

_squid.$ApiError;

_squid.$FallbackError;

_squid.$util;

_squid.$Error;

_squid.$Contingency;

_index.$AuthModel;

_logger.$logger;

_fallback.$fallbackErrorHandler;

_contingency.$contingencyHandler;

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fallbackErrorHandler = $fallbackErrorHandler;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function goToUrl(url, wpsParams, xoAppData) {
    if (xoAppData.is_wps_flow()) {
        return _index.$ReturnToMerchant.postTo(url, wpsParams);
    }

    return _index.$ReturnToMerchant.goTo(url);
}

/**
 * This function contains an additional determination of fallback url in case of an UX fallback
 *
 * @param {object} checkoutAppDataModel
 * @param {string} fallbackUrl
 * @returns {string}
 */
function determineUrlForUxFallback(checkoutAppDataModel, fallbackUrl) {
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');

    // For UX fallback during a PPPlus transaction the fallback url
    // is merchants cancel_url with added parameter ppp_msg = 1
    if (experienceInitiator === 'PAYPAL_PLUS') {
        return _squid.$util.buildURL(checkoutAppDataModel.get('urls.cancel_url'), { ppp_msg: '1' });
    }

    return fallbackUrl;
}

function goToGenericError() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DEFAULT';

    _uiRouter.$state.go('checkout.genericError', { code: code });
    return true;
}

function $fallbackErrorHandler() {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reason = err.reason;

    var models = {};

    return (0, _squid.$populate)(models, {
        checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token),
        checkoutInputData: _index2.$CheckoutInputDataModel.instance(_angular.$rootScope.token),
        payeeModel: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
    }).then(function () {
        var checkoutAppData = models.checkoutAppData,
            checkoutCart = models.checkoutCart,
            checkoutInputData = models.checkoutInputData;


        if (checkoutCart.isWalletTokenization()) {
            return goToGenericError();
        }

        if (checkoutAppData.doec_on_approve() && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_payment_already_done', { reason: reason });
            return goToGenericError('PAYMENT_ALREADY_DONE');
        }

        var _$config$fallbackWhit = _squid.$config.fallbackWhitelist;
        _$config$fallbackWhit = _$config$fallbackWhit === undefined ? {} : _$config$fallbackWhit;
        var _$config$fallbackWhit2 = _$config$fallbackWhit.whitelist,
            whitelist = _$config$fallbackWhit2 === undefined ? [] : _$config$fallbackWhit2;


        if (err instanceof _squid.$FallbackError) {
            var _err$product = err.product,
                product = _err$product === undefined ? 'ux' : _err$product;
            var entry_point = err.entry_point;


            if (checkoutInputData.requiresOAuth()) {
                // there is no fallback for flows that require oauth code return (ex:PROX Signup),
                // so we show a generic error page
                _logger.$logger.error('fallback_inhibited_for_oauth_return_flows', { reason: reason });
                return goToGenericError(reason);
            }

            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // For checkout-order tokens symphony sets checkoutAppData.flags.disable_legacy_fallback flag to 'true'.
            // In such cases we disable fallback to UX and show the generic error page.
            if (checkoutAppData.get('flags.disable_legacy_fallback')) {
                _logger.$logger.error('fallback_inhibited_for_checkout_order_tokens', { reason: reason });
                return goToGenericError(reason);
            }

            _squid.$util.assert(reason, 'expected fallback reason');

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point
            });

            var country = _squid.$locale.country;

            var paymentAction = checkoutCart.payment_action;

            _logger.$logger.info('fallback_reason_' + reason);
            if (checkoutAppData.is_wps_flow()) {
                _logger.$logger.log('info', 'wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, { reason: reason });
            }

            if (!_squid.$config.fallbackEnabled && !entry_point) {
                _logger.$logger.info('fallback_disabled_by_config');
                return goToGenericError();
            }

            /**
             * CONFIG BASED WHITELIST:
             * Determines if we should fallback or instead redirect to generic error page.
             * We go to generic error page if the reason is not in the whitelist
             * If the users' browser supports session storage they will be shown the retry link
             * in generic error page.
             */
            var fallbackNotWhitelisted = whitelist.indexOf(reason) === -1;

            // We can add countries to the config param to enable fallback to UX
            // If fallback reason not whitelisted
            if (fallbackNotWhitelisted) {
                _logger.$logger.info('fallback_reason_not_whitelisted', { reason: reason, product: product, country: country, paymentAction: paymentAction });

                // We're using sessionStorage for retry detection
                if (_squid.$util.sessionStorageEnabled()) {
                    var RETRY_KEY = 'retry_page_shown';
                    var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                    var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                    var destination = 'RETRY';

                    // Reset if there's an invalid value for timesSeen for some reason
                    if (!timesSeen || timesSeen < 0) {
                        timesSeen = 0;
                    }

                    // Only try to go to retry page if we're within retry attempts
                    if (timesSeen < RETRY_PAGE_LIMIT) {
                        timesSeen++;
                        sessionStorage.setItem(RETRY_KEY, timesSeen);
                    } else {
                        destination = 'DEFAULT';
                    }

                    _logger.$logger.info('checkout_fpti', {
                        'enable_refresh_prompt': reason
                    });

                    return goToGenericError(destination);
                }
                return goToGenericError();
            }

            _logger.$logger.info('fallback_reason_whitelisted', { reason: reason, product: product, country: country, paymentAction: paymentAction });

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _angular.$log.info('Fallback inhibited in local mode. Please refresh to re-enable error logging');
            }

            _angular.$rootScope.$emit('loading');

            var urlParams = {
                token: _squid.$meta.token,
                fallback: 1,
                landing: entry_point,
                useraction: _squid.$util.param('useraction')
            };

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var _checkoutAppData$flag = checkoutAppData.flags,
                appDataFlags = _checkoutAppData$flag === undefined ? {} : _checkoutAppData$flag;

            var base = _squid.$config.urls.fallbackUrl[product];
            var wpsParams = void 0;

            if (checkoutAppData.is_wps_subscription_flow()) {
                base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                wpsParams.cmd = wpsParams.hosted_button_id ? '_s-xclick' : '_xclick-subscriptions';
            } else if (checkoutAppData.is_wps_flow()) {
                base = appDataFlags.is_cart_upload_flow || appDataFlags.is_shopping_cart_flow ? _squid.$config.urls.fallbackUrl['cartUpload'] : _squid.$config.urls.fallbackUrl['buyNow'];
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
            }

            if (appDataFlags.is_invoice_flow) {
                urlParams.id = checkoutAppData.invoice_id;
                base = _squid.$config.urls.fallbackUrl['invoice'];
            }

            var hostname = _squid.$meta.stage ? _squid.$meta.stage : _angular.$window.location.hostname;
            var url = _squid.$util.buildURL('https://' + hostname + base, urlParams);

            if (checkoutAppData.is_wps_flow() || appDataFlags.is_invoice_flow) {
                goToUrl(url, wpsParams, checkoutAppData);
                return true;
            }

            if (product === 'ux') {
                var uxUrl = determineUrlForUxFallback(checkoutAppData, url);

                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return checkoutAppData.action('updateFallbackAction', {
                    data: {
                        fallback_action: 'CA_FALLBACK_USER_ACTION_LOGIN_GUEST_TAB_SELECTION'
                    },
                    success: function success() {
                        _index.$ReturnToMerchant.goTo(uxUrl);
                        return true;
                    },

                    contingencies: {
                        DEFAULT: function DEFAULT() {
                            _index.$ReturnToMerchant.goTo(uxUrl);
                            return true;
                        }
                    }
                })['catch'](function () {
                    _index.$ReturnToMerchant.goTo(uxUrl);
                    return true;
                });
            }

            // Safe to always return to Aries
            _squid.$util.redirect(url);
        }

        return goToGenericError();
    })['catch'](function (modelLoadErr) {
        _logger.$logger.info('fallback_model_load_error', { reason: modelLoadErr });
        return goToGenericError(modelLoadErr);
    });
}

angular.value("$fallbackErrorHandler", $fallbackErrorHandler);
_angular.$window;

_angular.$log;

_angular.$rootScope;

_uiRouter.$state;

_index.$ReturnToMerchant;

_squid.$FallbackError;

_squid.$config;

_squid.$meta;

_squid.$util;

_squid.$locale;

_squid.$populate;

_index2.$CheckoutInputDataModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_logger.$logger;

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _contingency = __webpack_require__("./js/lib/contingency.js");

Object.keys(_contingency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contingency[key];
    }
  });
});

var _error = __webpack_require__("./js/lib/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _fallback = __webpack_require__("./js/lib/fallback.js");

Object.keys(_fallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fallback[key];
    }
  });
});

var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");

Object.keys(_metaBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metaBuilder[key];
    }
  });
});

var _middleware = __webpack_require__("./js/lib/middleware.js");

Object.keys(_middleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _middleware[key];
    }
  });
});

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

Object.keys(_miniBrowser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _miniBrowser[key];
    }
  });
});

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$integration$init;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {
    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false

}, _$DEFAULT[$FLOWS.PARTNER] = {
    REDIRECT_TOP: false,
    REDIRECT_QUERY_PARAM: true
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = {
    REDIRECT_TOP: false
}, _$integration$init));

angular.value("$FLOWS", $FLOWS);
_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$metaBuilder = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function buildMeta() {
    return {
        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
        cartId: _squid.$util.param('cart_id'),
        calc: _model.$CalDataModel.getCalCorrId(),
        csci: _model.$CalDataModel.getUUID(),
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        },
        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
        app_name: 'xoonboardingnodeweb'
    };
}

_squid.$Api.registerMetaBuilder(buildMeta);

var $metaBuilder = exports.$metaBuilder = {
    build: buildMeta
};

angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;

_model.$CalDataModel;

_squid.$util;

_squid.$meta;

_squid.$Api;

_squid.$locale;

_squid.$config;

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Middleware = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _xoAPayUtils = __webpack_require__("../node_modules/xo-models/src/auth/lib/xoAPayUtils.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var noop = function noop() {
    return undefined;
};

var $Middleware = exports.$Middleware = [function checkToken() {
    var urlToken = _squid.$util.param('token');
    var bodyToken = _squid.$meta.token;

    if (urlToken !== _squid.$meta.token) {
        _logger.$logger.error('token_mismatch', {
            server: _squid.$meta.token,
            client: urlToken
        });
    }

    if (!urlToken && !bodyToken && !_squid.$util.param('data')) {
        throw new Error('No token or data found in page url');
    }

    // first set regular token (EC transactions)
    _angular.$rootScope.token = bodyToken || urlToken;

    _angular.$window.root = _angular.$rootScope;
}, function resolveLocale() {
    var models = {};

    if (_angular.$rootScope.token) {
        return (0, _squid.$populate)(models, {
            appData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve({
                contingencies: {
                    DEFAULT: noop
                }
            }),
            cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
        })['finally'](function () {
            // We need to have finally here instead of then, as we always want
            // locale to be resolved no matter failure of getCart or getAppData call
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    checkoutBillingCountry: models.cart && models.cart.get('payer_info.billing_address.country_code'),
                    checkoutShippingCountry: models.cart && models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData && models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData && models.appData.get('merchant.merchant_locale'),
                    countryParam: _squid.$util.param('country.x') || _squid.$meta.query && _squid.$meta.query['country.x'],
                    localeParam: _squid.$util.param('locale.x') || _squid.$meta.query && _squid.$meta.query['locale.x']
                }
            });
        });
    } else if (_squid.$util.param('data')) {
        var options = {
            params: {
                data: _squid.$util.param('data')
            }
        };

        return (0, _squid.$populate)(models, {
            guestAccountData: _index3.$GuestUpgradeModel.instance().retrieve({
                options: options,
                contingencies: {
                    MAYFLY_ERROR: noop,
                    DEFAULT: noop
                }
            })
        }).then(function () {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    countryParam: models.guestAccountData.get('user.country')
                }
            });
        });
    }
},

/*
 * checkFlowType: this function checks the flow type and adds call info logs
 *
 * We moved this fn from checkToken to a separate middleware, as we found an issue
 * when checkoutAppData call fails
 *
 * ISSUE FIXED: when checkoutAppData call fails with INVALID_RESOURCE_ID,
 * we redirect user to generie error page, and error page was shown without any
 * content/text, as resolveLocale middleware was never executed due to error thrown
 * in checkToken middleware function (error thrown by checkoutAppData failure)
 */
function checkFlowType() {
    // wps tokens are not preceeded with 'EC-'
    var wpsPattern = /^[0-9A-Z]{17}$/;

    // now test for WPS, set flags as necessary and log.
    // make sure ebay transactions aren't counted
    var isEbay = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn();

    // identify WPS vs checkout-order token
    if (!isEbay && wpsPattern.test(_angular.$rootScope.token)) {
        return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            // For WPS tokens appData.is_wps_flow() will always return 'true'.
            var isWPS = appData.is_wps_flow();

            _logger.$logger.info('xoon_' + (isWPS ? 'wps' : 'xo_order') + '_flow', {
                token: _angular.$rootScope.token
            });
        });
    }
}, function logout() {
    if (!_squid.$config.clientSideLogout) {
        return;
    }

    return _index4.$AuthModel.instance().retrieve().then(function (auth) {
        if (auth.logged_in || auth.email) {
            return auth.action('logout');
        }
    });
},

/**
 * Redirect back to Hermes if Android user with PayPal available through Android pay who
 * landed on Xoon due to BASL. 2 checks need to be done to determine if user has PayPal
 * in Android pay wallet: 1. chrome version >=58 (this version support payment api)
 * 2. call canMakePayment api call to validate if PayPal is already available in Android pay
 */
function checkAPayBASLRedirect() {
    if (!_squid.$config.apayEnabled) {
        return;
    }
    // Check if browser supports PaymentRequest API.
    if (!_xoAPayUtils.$xoAPayUtils.isAPayAPISupported()) {
        return;
    }

    var models = {};

    return (0, _squid.$populate)(models, {
        cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()
    }).then(function () {
        // Do nothing for APay onboarding flow.
        if (models.cart.isWalletTokenization()) {
            return;
        }

        // Call PaymentRequest API to check if paypal as payment available
        return _xoAPayUtils.$xoAPayUtils.canMakeAPayPayment().then(function (result) {
            if (result) {
                return (0, _squid.$dispatch)('hermes', {
                    token: _angular.$rootScope.token,
                    hermesLoginRedirect: 'xoon',
                    'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                    'country.x': _squid.$locale.country
                });
            }
        });
    });
}, function xcomponent() {
    if (window.xprops && window.xprops.init) {
        return _angular.$q.all([_index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
            var checkoutAppData = _ref[0],
                checkoutPayee = _ref[1];

            return window.xprops.init({
                paymentToken: _angular.$rootScope.token,
                merchantID: checkoutPayee.merchant.id,
                cancelUrl: checkoutAppData.urls.cancel_url
            });
        });
    }
}, function updateMerchantData() {
    if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
        return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
                var checkoutInputData = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
                var identityData = clientData.merchantIdentityData();

                appData.merchant = {
                    brand_name: identityData.brand_name,
                    logo_url: identityData.logo_uri
                };

                appData.urls = {
                    cancel_url: checkoutInputData.errorUrl('user_cancelled')
                };
            });
        });
    }
}, function checkJavaScriptInjection() {
    if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
        _logger.$logger.info('prox_signup_start', { cart_id: _angular.$rootScope.token });
        var redirectUri = _squid.$util.param('redirect_uri');

        if (redirectUri && redirectUri.indexOf('http') !== 0) {
            _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI_JAVASCRIPT_INJECTION', {
                uri: redirectUri
            });
            return _angular.$q.reject(new _squid.$FallbackError({
                reason: 'invalidRedirectURI',
                product: 'ux'
            }));
        }
    }
}, function verifyRedirectURI() {
    if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
        var redirectUri = _squid.$util.param('redirect_uri');

        return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
            var isValidUri = clientData.validateRedirectUri(redirectUri) || {};

            if (!isValidUri.success) {
                _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI', {
                    uri: redirectUri
                });
                return _angular.$q.reject(new _squid.$FallbackError({
                    reason: 'invalidRedirectURI',
                    product: 'ux'
                }));
            }
        });
    }
},

// allow PROX to support country content separate from Hermes
function proxFallbackManager() {
    if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
        (0, _squid.$featureCountries)('guestFallback').forEach(function (country, index) {
            _squid.$config.features[country].guestFallback = false;
        });
    }
}, function handleTagManager() {
    _angular.$window.dataLayer = {
        // Two letter country code of the current page's content
        contentCountry: _squid.$locale.country.toLowerCase(),
        // Two letter locale
        contentLanguage: _squid.$locale.lang.toLowerCase()
    };

    var tagManagerUrl = '//www.paypalobjects.com/tagmgmt/bs-chunk.js';

    // Based on the environment, Tag Manager end point can be changed. For now the local and stage end points are same.
    if (_angular.$window.location.href.indexOf('qa.paypal.com') > -1 || _angular.$window.location.href.indexOf('localhost') > -1) {
        tagManagerUrl = '//nexus.ensighten.com/paypal/stage/Bootstrap.js';
    }

    // Defer loading of the script when the spinner is done.
    _angular.$rootScope.$on('allLoaded', function () {
        // Defer to the end of the callstack.
        var scriptTag = createTagManagerScript(tagManagerUrl);

        scriptTag.defer = true;
        insertScript(scriptTag);
    });

    function createTagManagerScript(url) {
        var tagManagerObjec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tagManager';

        _angular.$window.tagManagerObjec = tagManagerObjec;

        _angular.$window[tagManagerObjec] = _angular.$window[tagManagerObjec] || function () {
            (_angular.$window[tagManagerObjec].q = _angular.$window[tagManagerObjec].q || []).push(arguments);
        };

        _angular.$window[tagManagerObjec].l = 1 * new Date();

        var scriptElement = document.createElement('script');
        scriptElement.src = url;

        return scriptElement;
    }

    function insertScript(scriptElement) {
        var firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(scriptElement, firstScript);
    }
}, function setupMiniBrowser() {
    if (_squid.$util.param('data')) {
        return _miniBrowser.$MiniBrowser.initialize(_squid.$util.param('cancel_url'));
    }

    return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
        return _miniBrowser.$MiniBrowser.initialize(appData.urls.cancel_url);
    });
}, function logStart() {
    _logger.$logger.info('app_start_design', {
        is_directintegration: _miniBrowser.$MiniBrowser.isDirectIntegration ? 1 : 0,
        is_incontext: _miniBrowser.$MiniBrowser.isMiniBrowser || _miniBrowser.$MiniBrowser.isFrame ? 1 : 0
    });
}, function checkWpsSubscriptionEligibility() {
    // in the the guest upgrade flow, the $rootScope.token is undefined, so this will skip the check if so
    if (_angular.$rootScope.token) {
        return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            if (appData && appData.is_wps_subscription_flow()) {
                return (0, _squid.$pxp)('xo_subscription_hermes_xoon', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_subscription_treatment_xoon').then(function () {
                    var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    var treatmentName = result.treatment_name;

                    if (treatmentName !== 'xo_subscription_treatment_xoon') {
                        return _angular.$q.reject(new _squid.$FallbackError({
                            reason: 'fallback_wps_subscription_pxp_control',
                            product: 'ux'
                        }));
                    }
                });
            }
        });
    }
}, function checkForSDK() {
    var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');

    var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();

    if (isSDKintegration && !sdkLoaded) {
        throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
    }
}];

angular.value("$Middleware", $Middleware);
_angular.$q;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$CheckoutInputDataModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_miniBrowser.$MiniBrowser;

_xoAPayUtils.$xoAPayUtils;

_index.$CheckoutClientDataModel;

_index3.$GuestUpgradeModel;

_index4.$AuthModel;

_squid.$FallbackError;

_squid.$config;

_squid.$meta;

_squid.$util;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_squid.$dispatch;

_squid.$featureCountries;

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MiniBrowser = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var MiniBrowser = _squid.$Class.extend('MiniBrowser', {
    isMiniBrowser: false,
    partnerIntegration: false,
    isDirectIntegration: false,

    _isMiniBrowser: function _isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
    },
    _isFrame: function _isFrame() {
        return _squid.$util.isIFrame();
    },
    initialize: function initialize(cancel_url) {
        this.isMiniBrowser = _angular.$rootScope.miniBrowser = this._isMiniBrowser();
        this.isFrame = this._isFrame();
        this.partnerIntegration = _angular.$rootScope.partnerIntegration = _angular.$window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1';

        //  this.nativeIntegration is true, whenever the query param native_xo=1 when hermes was launched
        this.nativeIntegration = _squid.$util.param('native_xo') === '1';

        this.isDirectIntegration = this.isMiniBrowser || this.partnerIntegration || Boolean(_squid.$util.param('incontext')) || _angular.$window.location.pathname.indexOf('/checkoutnow') > -1;

        _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);

        if (this.partnerIntegration) {
            _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            _logger.$logger.info('partner_integration_flow');
        } else if (this.nativeIntegration && (0, _squid.$feature)('nativexoSupport')) {
            // we are setting the flow to be native checkout type
            // whenever the nativeIntegration flag is on
            // setting this flow will enable the redirect_uri query param
            // passed to hermes to override the merchant's redirect url
            // on cancel or redirect after a successful payment
            _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            _logger.$logger.info('nativexo_integration_flow');
        }

        if (this.isMiniBrowser && !this.partnerIntegration) {
            var msg = void 0;

            try {
                msg = {
                    cancelUrl: cancel_url,
                    landingUrl: _angular.$window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (error) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', { error: error });
            }

            if (!_index.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }
        }
    }
});

var $MiniBrowser = exports.$MiniBrowser = new MiniBrowser();

angular.value("$MiniBrowser", $MiniBrowser);
_angular.$rootScope;

_angular.$window;

_index.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_squid.$Class;

_squid.$feature;

_squid.$locale;

_squid.$util;

_logger.$logger;

/***/ }),

/***/ "./pages/xo-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html"), __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("../node_modules/xo-validation/dist/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {

    return angular.module('hermes.page.xo-add-card.directive', ['squid', 'fi.apis', 'beaver', 'xo-add-card.directive', 'xo-validation.directive', 'xo-tooltip.directive', 'xo-dropdown.directive', 'xo-value-props.directive', 'xo-done.directive']).directive('xoPageAddCardPage', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=?'
            },

            controller: function controller($scope, $rootScope, $state, $stateParams, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, // eslint-disable-line no-shadow
            $ShippingAddressModel, $locale, $fiApis, $logger) {

                function populateInfoMessage() {
                    var msg = void 0;

                    if ($stateParams.gaming === '1') {
                        msg = $locale.content.get('creditcard.noEligibleFI');
                    } else if ($stateParams.country === 'DE') {
                        if ($stateParams.fiType === 'BANK') {
                            msg = $locale.content.get('creditcard.cannotUseBank');
                        } else {
                            msg = $locale.content.get('creditcard.cannotUseCard');
                        }
                    } else {
                        msg = $locale.content.get('creditcard.noFIContingency');
                    }

                    $scope.message = {
                        msgs: [msg],
                        type: 'error'
                    };
                }

                populateInfoMessage();

                $scope.pagetitle = $locale.content.get('addCard.addACard');

                $scope.callbacks = {
                    finish: function finish() {
                        var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
                        var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
                        var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
                        var shippingAddress = $ShippingAddressModel.instance('123');

                        var showGenericError = function showGenericError(code) {
                            return function () {
                                $state.go('checkout.genericError', { code: code });
                            };
                        };

                        var makePayment = function makePayment() {
                            return checkoutSession.action('createPayment', {
                                data: {
                                    payer_id: checkoutSession.payer.id,
                                    intent: checkoutCart.payment_action
                                },

                                success: function success(result) {
                                    $rootScope.paymentComplete = true;
                                    $logger.info('wps_cart_to_txn_mapping', {
                                        cart_id: $rootScope.token,
                                        txn_id: result.transactionDetails && result.transactionDetails.id,
                                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
                                    });
                                    return $state.go('checkout.done');
                                },

                                contingencies: {
                                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE')
                                }
                            });
                        };

                        var authorize = function authorize() {
                            checkoutSession.action('authorize', {
                                success: function success() {
                                    if (checkoutAppData.doec_on_approve()) {
                                        return makePayment();
                                    } else {
                                        $state.go('checkout.end');
                                    }
                                }
                            });
                        };

                        var setStickyInstrument = function setStickyInstrument() {

                            if ($stateParams.mode !== 'signup') {
                                return;
                            }
                            var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();

                            if (stickyInstrument) {
                                return checkoutSession.action('setStickyFI', {
                                    data: {
                                        instrument_id: stickyInstrument.instrument_id
                                    }
                                });
                            }
                        };

                        if (shippingAddress.isNew) {
                            shippingAddress.save({
                                data: shippingAddress,
                                success: function success() {
                                    _angular.$q.when(setStickyInstrument())['catch'](function (err) {
                                        $logger.info('setStickyFI Failed', err);
                                    }).then(function () {
                                        return authorize();
                                    });
                                }
                            });
                        } else {
                            _angular.$q.when(setStickyInstrument())['catch'](function (err) {
                                $logger.info('setStickyFI Failed', err);
                            }).then($fiApis.patchCvv(checkoutSession)).then(authorize(), function (err) {
                                $logger.error('patchCvv error', err);
                            });
                        }
                    }
                };
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_angular.$q;

/***/ }),

/***/ "./pages/xo-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js"), __webpack_require__("./pages/xo-add-card/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-add-card.route', ['squid', 'xo-add-card.route', 'hermes.page.xo-add-card.directive']).factory('$AddCardPageRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddCardPageRoute', {
            name: 'pageAddCard',
            directive: 'xo-page-add-card-page',
            titleContent: 'asideHeader.addCard',
            query: ['gaming', 'country', 'fiType', 'mode'],
            trackingData: {
                templateName: 'addCard.dust',
                pageGoal: 'Add Card',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-add-cc',
                        'pagename2': '%::fullpage-add-cc:guest:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: [{
                name: '$AddCardFlowRoute',
                attributes: {
                    token: 'token',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    'parent-callbacks': 'callbacks'
                }
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-add-card", "pages/xo-add-card/route.js"))

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _fn = __webpack_require__("../node_modules/xo-guest-components/src/fraudnet/fn.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html"), __webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/merchant-header/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/header/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/footer/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/cart/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-validation/dist/directive.js"), __webpack_require__("../node_modules/xo-device-info/dist/index.js"), __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js"), __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {

    return angular.module('hermes.page.xo-checkout.directive', ['squid', 'xo-spinner.directive', 'xo-merchant-header.directive', 'xo-header.directive', 'xo-footer.directive', 'xo-cart.directive', 'xo-error-tooltip.directive', 'xo-validation.directive', 'xo-device-info', 'xo-gdpr-cookie-banner.directive']).directive('xoCheckout', function ($document, $config, $util) {

        return {
            template: template,
            scope: {},

            controller: function controller($scope, $rootScope, $state, $renderContent, $locale, $LocaleResolver, $DeviceInfo, $FallbackError, $feature, $populate, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel) {

                $scope.token = $rootScope.token;
                $scope.locale = $locale;

                _fn.$fn.trigger();
                $scope.isGdprValid = _gdprCookieBanner.isGdprValid;

                function setLanguageToggleFlags() {
                    var landingPage = $scope.checkoutAppData.get('flags.landing_page');
                    var hermesLoginRedirectParam = $util.param('hermesLoginRedirect');
                    var languageToggleFeature = $feature('languageToggle');

                    // Language Toggle - header
                    if (landingPage === 'BILLING' && !hermesLoginRedirectParam) {
                        $scope.languageSwitchHeader = { show: languageToggleFeature };
                    } else {
                        $scope.languageSwitchFooter = { show: languageToggleFeature };
                    }
                }

                function checkShippingRulesExist() {
                    return $populate($scope, {
                        shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                            params: {
                                merchant_id: $scope.checkoutPayee.merchant.id,
                                currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                            }
                        })
                    });
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    setLanguageToggleFlags();

                    var isSntSupported = $scope.checkoutAppData.is_snt_supported();

                    // call checkShippingRulesExist only if the token is WPS and not WPS subscription flow, or the token
                    // is instant update flow
                    // We have instant update flow check here to avoid making unnecessary calls to shippingRulesSummary
                    if (isSntSupported || $scope.checkoutCart.instantUpdateIntegration) {
                        checkShippingRulesExist().then(function () {

                            // We need instant update flow check here again, because all instant update flows will
                            // not have SnTEnabled in shippingRulesSummary
                            if ($scope.shippingRulesSummary && $scope.shippingRulesSummary.isSnTEnabled || $scope.checkoutCart.instantUpdateIntegration) {
                                // preserve these cart amount values passed from the merchant
                                // since they could get changed after SnT from profile/callback (in case instant update) is applied
                                // TODO: get rid of buttonParams and start using checkoutCart in SnT module
                                $scope.buttonParams = {
                                    shipping: $scope.checkoutCart.purchase.amounts.shipping,
                                    tax: $scope.checkoutCart.purchase.amounts.tax,
                                    total: $scope.checkoutCart.purchase.amounts.total
                                };
                            }
                        });
                    }
                });

                // Change html dir attribute for RTL/LTR, append RTL styling if needed.
                function setDirectionality() {
                    $document.prop('documentElement').setAttribute('dir', $locale.metadata.directionality);
                }

                // Change html lang attribute and document title
                function localizeHead() {
                    $document.prop('documentElement').setAttribute('lang', $locale.lang);
                    setDirectionality();

                    var content = $renderContent('base.payPal');

                    if (content) {
                        $document.title = content;
                    }
                }

                function getPaymentMethod() {
                    var paymentMethodViaUrl = $util.param('paymentMethod');
                    var paymentMethodViaCheckoutAppData = $scope.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;

                    return paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
                }

                function checkUnbranded() {
                    var paymentMethod = getPaymentMethod();

                    if (!paymentMethod || !$config.allowedUnbrandedPayments) {
                        return false;
                    }

                    // If paymentMethod in URL is NOT in the list of allowed payment methods, return false
                    if ($config.allowedUnbrandedPayments.indexOf(paymentMethod) === -1) {
                        return false;
                    }

                    return true;
                }

                $scope.isUnbranded = checkUnbranded();

                $scope.paymentMethod = '';

                if ($scope.isUnbranded) {
                    $scope.paymentMethod = getPaymentMethod();

                    if ($scope.paymentMethod === 'invoice') {
                        $scope.unbrandedTitle = 'payUponInvoice.header';
                        $scope.unbrandedSubTitle = 'payUponInvoice.processedBy';
                    }
                }

                $scope.isApp = $DeviceInfo.isApp();

                var contentChange = $rootScope.$on('contentChange', localizeHead);

                localizeHead();

                var cancel = $rootScope.$on('allLoaded', function () {
                    angular.element('#preloaderSpinner').hide();

                    // Opera for Andriod has support for window.performance.timing but
                    // not for window.performance.now()
                    var loadTime = 'N/A';
                    if ('now' in performance) {
                        loadTime = performance.now();
                    } else if (['timeOrigin', 'timing'].some(function (key) {
                        return key in performance;
                    })) {
                        var _performance = performance,
                            timeOrigin = _performance.timeOrigin,
                            _performance$timing = _performance.timing,
                            timing = _performance$timing === undefined ? {} : _performance$timing;

                        var start = timeOrigin || timing.navigationStart;
                        loadTime = Date.now() - start;
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'BILLING',
                        to: 'prepare_billing_page_loaded',
                        page_load_time: loadTime
                    });
                    cancel();
                });

                $scope.$on('localeChange', function () {
                    localizeHead();
                    setLanguageToggleFlags();
                });

                $scope.$on('$destroy', function () {
                    cancel();
                    contentChange();
                });

                $document.bind('click', function (event) {
                    $scope.$broadcast('clickBody', event.target);
                });
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_fn.$fn;

_gdprCookieBanner.isGdprValid;

_logger.$logger;

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");

__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");

var _index = __webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-tracking/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-checkout/directive.js"), __webpack_require__("./pages/xo-landing/route.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("./pages/xo-generic-message/route.js"), __webpack_require__("./pages/xo-end/route.js"), __webpack_require__("./pages/xo-guest/route.js"), __webpack_require__("./pages/xo-signup/route.js"), __webpack_require__("./pages/xo-add-card/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/route.js"), __webpack_require__("./pages/xo-pay-upon-invoice/route.js"), __webpack_require__("../node_modules/xo-page-components/src/done/route.js"), __webpack_require__("../node_modules/xo-page-components/src/route-to-complete/route.js"), __webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-checkout.route', ['squid', 'hermes.page.xo-landing.route', 'hermes.page.xo-checkout.directive', 'hermes.page.xo-generic-error.route', 'hermes.page.xo-generic-message.route', 'hermes.page.xo-end.route', 'hermes.page.xo-guest.route', 'hermes.page.xo-signup.route', 'hermes.page.xo-add-card.route', 'xo-multistep-signup.route', 'hermes.page.xo-pay-upon-invoice.route', 'xo-done', 'xo-route-to-complete']).factory('$BaseRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('CheckoutRoute', {

            defaultState: 'checkout.landing',
            middleware: _index.$Middleware,

            name: 'checkout',
            directive: 'xo-checkout',
            titleContent: 'base.payPal',
            children: [{
                name: '$LandingRoute',
                attributes: {
                    'is-unbranded': 'isUnbranded'
                }
            }, {
                name: '$GuestRoute',
                attributes: {
                    token: 'token',
                    'is-unbranded': 'isUnbranded',
                    'payment-method': 'paymentMethod',
                    'button-params': 'buttonParams'
                }
            }, {
                name: '$SignupRoute',
                attributes: {
                    token: 'token',
                    'button-params': 'buttonParams'
                }

            }, {
                name: '$AddCardPageRoute',
                attributes: {
                    token: 'token'
                }

            }, {
                name: '$xoSoldOutPageRoute'
            }, {
                name: '$GenericErrorRoute'
            }, {
                name: '$GenericMessageRoute'
            }, {
                name: '$EndRoute'
            }, {
                name: '$MultistepSignupRoute',
                attributes: {
                    token: 'token',
                    'button-params': 'buttonParams'
                }
            }, {
                name: '$PayUponInvoiceRoute',
                attributes: {
                    token: 'token',
                    'is-unbranded': 'isUnbranded'
                }
            }, {
                name: '$DoneRoute'
            }, {
                name: '$RouteToCompleteRoute',
                attributes: {
                    token: 'token'
                }
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_index.$Middleware;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-checkout", "pages/xo-checkout/route.js"))

/***/ }),

/***/ "./pages/xo-end/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index6 = __webpack_require__("../node_modules/xo-models/src/prox/index.js");

var _index7 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _index8 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _returnParams = __webpack_require__("../node_modules/xo-page-components/src/returnParams/index.js");

var _template = __webpack_require__("./pages/xo-end/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoEnd', {

    tag: 'xo-end',

    template: _template2['default'],

    props: {},

    resolve: {
        models: function models() {
            return {
                payee: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
                checkoutSession: _index3.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()
            };
        },
        dependentModels: function dependentModels(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    merchantPreferences: _index7.$MerchantPreferenceModel.instance(models.payee.merchant.id).retrieve()
                };
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            angular.element('#outerWrapper').addClass('xo-end');
            _angular.$rootScope.$emit('startLoad');
        },
        exit: function exit() {
            // If there is any error in this directive, then we need to hide spinner
            // so that when user reaches generic error page, he can return to merchant
            // by clicking on "return to merchant" button
            _angular.$rootScope.$emit('allLoaded');
        },
        populate: function populate() {
            var _this = this;

            function returnMethod(merchantPreferences) {
                if (merchantPreferences) {
                    return merchantPreferences.returnMethod();
                }
                return 'GET';
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                if (checkoutAppData.is_wps_flow() && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                } else {
                    return checkoutAppData.urls.return_url;
                }
            }

            function postToMerchant(wpsURL, wpsData) {
                _index8.$ReturnToMerchant.postTo(wpsURL, wpsData);
            }

            var goToMerchant = function goToMerchant(wpsURL, wpsData) {
                // if PDT is disabled don't send params in the url
                if (_this.dependentModels.merchantPreferences && !_this.dependentModels.merchantPreferences.pdtEnabled()) {
                    return _index8.$ReturnToMerchant.goTo(wpsURL);
                }
                return _index8.$ReturnToMerchant.goTo(_index.$util.buildURL(wpsURL, wpsData));
            };

            _angular.$q.when().then(function () {

                /*
                    If we're in an in-context flow, the parent button
                    iframe may need the access token to continue running
                    and execute the payment (e.g. in 3rd party cookies
                    disabled mode)
                     We reload the auth model, since after the user is
                    onboarded this model is not updated, then pass the
                    access token up. The token will only be passed if
                    we're on the same-domain as the parent button.
                */

                if (window.xprops && window.xprops.onAuth) {
                    var auth = _index5.$AuthModel.instance();

                    return auth.reload().then(function () {
                        window.xprops.onAuth({ accessToken: auth.access_token });
                    });
                }
            }).then(function () {

                // handle the return url with post and get , with and without PDT for WPS alone
                // PDT - Payment Data Transfer
                if (_this.models.checkoutAppData.is_wps_flow()) {
                    var wpsURL = returnUrl(_this.models.checkoutAppData, _this.dependentModels.merchantPreferences);
                    var returnToMerchantMethod = returnMethod(_this.dependentModels.merchantPreferences);
                    var isWPSCart = _this.models.checkoutAppData.flags.is_cart_upload_flow || _this.models.checkoutAppData.flags.is_shopping_cart_flow;
                    var wpsParams = (0, _returnParams.$returnParams)(_this.models.checkoutCart, _this.models.checkoutSession, returnToMerchantMethod, 'WPS', isWPSCart);

                    return returnToMerchantMethod === 'POST' ? postToMerchant(wpsURL, wpsParams) : goToMerchant(wpsURL, wpsParams);
                }

                var params = {};
                // Creating the checkoutInputData here so that it would not make payer-id call.
                var checkoutInputData = _index4.$CheckoutInputDataModel.instance(_angular.$rootScope.token);

                // Don't post PayerID for RT without purchase
                if (!_this.models.checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = _this.models.checkoutSession.payer.id;
                }

                var billingData = _this.models.checkoutCart.billing;

                // exclude BA token in the returnUrl for external merchant - (merchant not calling BEAM directly)
                if (billingData && billingData.ba_token && !_this.models.checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                // When "redirect_uri" is passed as a query param
                if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
                    params.return_uri = _this.models.checkoutAppData.urls.return_url ? _index.$util.buildURL(_this.models.checkoutAppData.urls.return_url, params) : null;

                    // Add these params after building `return_uri` to ensure they are not added into the final url
                    params.intent = _this.models.checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.paymentId = _this.models.checkoutAppData.payment_id;
                    params.token = _angular.$rootScope.token;
                }

                var handleRedirection = function handleRedirection(url) {
                    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
                    var isMobileDevice = Boolean(_index2.$DeviceInfo.isDevice() && !isHTTPUrl);

                    /* Webview to App view switching is not happening properly
                    * so to handle , adding a work around by adding cancel / return to merchant url
                    * on success page
                    * routeToComplete is the route which shows cancel / return to merchant url*/
                    if (isMobileDevice) {
                        _logger.$logger.info('Switching_Webview_To_App_view', {
                            url: url
                        });
                        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {
                            // leave this blank , having this comment for lint warning - Unexpected Empty Function
                        };
                        _angular.$window.location = url;

                        return _uiRouter.$state.go('checkout.routeToComplete', {
                            url: url,
                            urlType: 'success'
                        });
                    } else {
                        _index8.$ReturnToMerchant.goTo(url);
                    }

                    return _index.$unresolved;
                };

                function finishProxFlow() {
                    // for Prox Signup flow (eBay), generate auth code
                    var auth = _index5.$AuthModel.instance();

                    _logger.$logger.info('prox_exit_login_code_start');

                    return auth.action('loginCode', {
                        data: {
                            user: {},
                            client: {
                                client_id: _index.$config.proxStsClientId,
                                redirect_uri: checkoutInputData.redirect_uri,
                                scope: checkoutInputData.scope,
                                id_token: '',
                                nonce: auth.nonce,
                                response_type: 'code',
                                skip_oauth: false,
                                skip_consent: true,
                                target_client_id: _index.$util.base64Decode(checkoutInputData.client_id),
                                visitor_id: auth.visitor_id,
                                scope_consent_context: 'access_token'
                            }
                        }

                    })['catch'](function (err) {
                        _logger.$logger.error('prox_exit_login_code_error', err);
                        _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl(err.message));

                        return _index.$unresolved;
                    }).then(function (loginCodeResult) {
                        if (loginCodeResult && loginCodeResult.data && loginCodeResult.data.code) {
                            _logger.$logger.info('prox_exit_login_code_success');
                            return handleRedirection(checkoutInputData.successUrl(loginCodeResult.data.code));
                        } else {
                            _logger.$logger.error('prox_exit_login_code_not_found');
                            _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl('auth_code_error'));

                            return _index.$unresolved;
                        }
                    });
                }

                if (!checkoutInputData.isEbayTxn()) {
                    // non-Ebay/xoon flow
                    return _angular.$q.when().then(function () {
                        if (window.xprops && window.xprops.onAuthorize) {
                            _logger.$logger.done();
                            _angular.$rootScope.$emit('loading');

                            var xparams = {
                                paymentToken: _angular.$rootScope.token,
                                orderID: _angular.$rootScope.token,
                                billingToken: params['ba_token'],
                                payerID: params['PayerID'],
                                paymentID: params['paymentId'] || _this.models.checkoutAppData.payment_id,
                                intent: _this.models.checkoutCart.payment_action
                            };

                            if (_this.models.checkoutAppData.get('urls.return_url')) {
                                xparams.returnUrl = _index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params);
                            }

                            return window.xprops.onAuthorize(xparams);
                        } else if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
                            var redirect = _index.$util.buildURL(_index.$util.param('redirect_uri'));

                            _logger.$logger.info('Nativeapp_Redirection', {
                                redirect: redirect
                            });
                            return handleRedirection(_index.$util.buildURL(redirect, params));
                        } else {
                            return handleRedirection(_index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params));
                        }
                    });
                } else {
                    // PrOX flow only
                    return _angular.$q.when().then(function () {
                        _logger.$logger.info('prox_exit_for_authcode_start');
                        if (_index.$util.param('fromLipp') === 'true') {
                            var lippParamList = {
                                client_id: _index.$util.param('client_id'),
                                scope: _index.$util.param('scope'),
                                state: _index.$util.param('state'),
                                redirect_uri: _index.$util.param('redirect_uri'),
                                metadata_id: _index.$util.param('cart_id')
                            };
                            var lippUrl = _index.$util.buildURL(_angular.$window.location.protocol + '//' + _angular.$window.location.host + _index.$config.urls.lippRedirectUrl, lippParamList);

                            // reroute to LIPP to generate authcode if send from lipp
                            _logger.$logger.info('XOON_REDIRECT_TO_LIPP_FOR_AUTHCODE');
                            return _index8.$ReturnToMerchant.goTo(lippUrl, true);
                        }if (_index.$util.param('ctxId')) {
                            // for UL flow
                            return _index6.$ContextualLoginModel.instance(_angular.$rootScope.token).retrieve().then(function (response) {
                                if (response.success) {
                                    _logger.$logger.info('XOON_REDIRECT_TO_UL_FOR_AUTHCODE');
                                    _logger.$logger.info('checkout_fpti', { from: 'xoon_ul_auth_code', to: 'ul_auth_code' });
                                    var clUrl = _angular.$window.location.protocol + '//' + _angular.$window.location.host + _index.$config.urls.contextualLoginRedirectUrl + _index.$util.param('ctxId');

                                    return _index8.$ReturnToMerchant.goTo(clUrl, true);
                                } else {
                                    _logger.$logger.error('XOON_UNABLE_TO_UPDATE_PAYLOAD_TO_UL_FOR_AUTHCODE');
                                    _logger.$logger.info('checkout_fpti', { from: 'xoon_ul_auth_code', to: 'regular_prox_ul_payload_update_error' });
                                    return finishProxFlow();
                                }
                            });
                        } else {
                            return finishProxFlow();
                        }
                    });
                }
            }); // end of then function
        } // populate

    }

});


_angular.$q;

_angular.$rootScope;

_angular.$window;

_index.$Component;

_index.$config;

_index.$util;

_index.$unresolved;

_index.$integration;

_index2.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_index3.$CheckoutSessionModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index4.$CheckoutInputDataModel;

_index5.$AuthModel;

_index6.$ContextualLoginModel;

_index7.$MerchantPreferenceModel;

_index8.$ReturnToMerchant;

_returnParams.$returnParams;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("./pages/xo-end/directive.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-end.route', ['squid']).factory('$EndRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('EndRoute', {
            name: 'end',
            directive: 'xo-end'
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-end", "pages/xo-end/route.js"))

/***/ }),

/***/ "./pages/xo-end/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-end-content\" content>\n    <!-- find css for this page in public/css/pages -->\n</div>\n"

/***/ }),

/***/ "./pages/xo-generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericErrorPageComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("./pages/xo-generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
    tag: 'xo-generic-error-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
    $locale, $CheckoutInputDataModel, $util, $logger, $state) {

        $scope.token = $rootScope.token;
        var terminalKey = 'terminal-error-' + $scope.token,
            refreshKey = 'has-seen-error-' + $scope.token;

        function renderErrorPage() {
            // prevent render flicker
            $scope.shouldRender = true;

            if ($CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
                $scope.cancelUrl = $util.param('redirect_uri');
                $scope.merchant = $locale.content.get('signup.ebay');
            }
        }

        if (!$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
            return renderErrorPage();
        }

        // is not a refresh, user landing for the first time on generic error page.
        if (!sessionStorage.getItem(refreshKey)) {
            sessionStorage.setItem(refreshKey, '1');
            return renderErrorPage();
        } else {
            // This is a refresh. Go to guest page if a refresh happens, don't show generic error page
            $logger.info('checkout_fpti', {
                user_refresh: 1
            });
            // delete the refresh key, so that next time renders the error page.
            sessionStorage.removeItem(refreshKey);
            // go guest page if a refresh happens
            $state.go('checkout.landing')['catch'](function () {
                // don't try to do this again
                sessionStorage.setItem(terminalKey, '1');
            });
        }
    }
});

angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_squid.$Component;

/***/ }),

/***/ "./pages/xo-generic-error/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-generic-error.route', ['squid', 'hermes.page.xo-generic-error.directive']).factory('$GenericErrorRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GenericErrorRoute', {
            name: 'genericError',
            directive: 'xo-generic-error-page',
            titleContent: 'genericError.pleaseTryAgain',
            query: ['code'],
            // need to find these values
            trackingData: {
                templateName: 'genericError.dust',
                pageGoal: 'Generic Error',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-generic-error',
                        'pagename2': '%::fullpage-generic-error:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },
            children: []
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-error", "pages/xo-generic-error/route.js"))

/***/ }),

/***/ "./pages/xo-generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-error ng-if=shouldRender token=\"token\" merchant={{merchant}} cancel-url={{cancelUrl}} is-unbranded=\"isUnbranded\"></xo-generic-error>\n"

/***/ }),

/***/ "./pages/xo-generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
    return angular.module('hermes.page.xo-generic-message.directive', ['squid', 'xomodel.checkout', 'xo-generic-message.directive']).directive('xoGenericMessagePage', function ($rootScope) {

        return {
            template: template,

            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {

                $scope.token = $rootScope.token;
                angular.element('#defaultCancelLink').hide();

                var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $rootScope.$on('$destroy', stateChangeStart);
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-generic-message/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-generic-message.route', ['squid', 'hermes.page.xo-generic-message.directive']).factory('$GenericMessageRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GenericMessageRoute', {
            name: 'genericMessage',
            directive: 'xo-generic-message-page',
            titleContent: 'genericError.pleaseTryAgain',
            query: ['code', 'returnUrl'],
            // need to find these values
            trackingData: {},
            children: []
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-message", "pages/xo-generic-message/route.js"))

/***/ }),

/***/ "./pages/xo-guest-upgrade/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");

__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-tracking/dist/index.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-guest-upgrade.route', ['squid', 'hermes.page.xo-generic-error.route', 'xo-guest-upgrade.directive']).factory('$GuestUpgradeRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GuestUpgradeRoute', {

            defaultState: 'guestupgrade',
            middleware: _middleware.$Middleware,

            name: 'guestupgrade',
            directive: 'xo-guest-upgrade',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            trackingData: {
                templateName: 'xoguestupgrade.dust',
                pageGoal: 'guest upgrade',
                pageQualifier: 'guestupgrade',
                buzname: {
                    'guestupgrade': {
                        'pagename': '%::guestupgrade',
                        'pagename2': '%::guestupgrade:prox-guest-upgrade',
                        'version': 'version-1:%:'
                    }
                }
            },
            children: [{
                name: '$GenericErrorRoute'
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_middleware.$Middleware;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest-upgrade", "pages/xo-guest-upgrade/route.js"))

/***/ }),

/***/ "./pages/xo-guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-guest/template.html"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {

    return angular.module('hermes.page.xo-guest.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoGuest', function ($rootScope, $SingleStepModel) {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                isUnbranded: '=?',
                paymentMethod: '=?',
                buttonParams: '=?'
            },

            controller: function controller($scope, $state) {
                $scope.mode = 'guest';
                $scope.backUri = 'checkout.guest';
                $scope.singleStepModel = new $SingleStepModel();

                $scope.onComplete = function () {
                    $state.go('checkout.end');
                };
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-guest/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-guest/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-guest.route', ['squid', 'hermes.page.xo-guest.directive', 'hermes.page.xo-sidebar.route']).factory('$GuestRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GuestRoute', {
            name: 'guest',
            directive: 'xo-guest',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            trackingData: {
                fptiState: 'guest_xo',
                trackStateExit: false,
                templateName: 'guest.dust',
                pageGoal: 'Payment Start',
                pageQualifier: 'guest',
                buzname: {
                    'guest': {
                        'pagename': '%::fullpage-guest',
                        'pagename2': '%::fullpage-guest:member:hermes:',
                        'version': 'guest:%:'
                    },
                    'signup': {
                        'pagename': '%::fullpage-guestSignup',
                        'pagename2': '%::fullpage-guestSignup:member:hermes:',
                        'version': 'guestSignup:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$GuestUpgradeInterstitialRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel'
                }
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest", "pages/xo-guest/route.js"))

/***/ }),

/***/ "./pages/xo-landing/helper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.landingPageResolver = undefined;

var _paypalSdkConstants = __webpack_require__("../node_modules/paypal-sdk-constants/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var landingFlow = function landingFlow(models) {
    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
    var merchantId = models.checkoutPayeeModel.getId();
    var paymentMethodViaUrl = _squid.$util.param('paymentMethod');
    var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
    var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
    var isUnbranded = paymentMethod !== undefined;

    function getProcessedRoute(appRoute) {
        var isForcedSignup = void 0;

        switch (appRoute) {
            case 'checkout.guest':
                isForcedSignup = 0;
                break;
            case 'checkout.signup':
            case 'checkout.multistepsignup':
                isForcedSignup = 1;
                break;
            default:
                isForcedSignup = -1;
                break;
        }

        _logger.$logger.info('checkout_fpti', {
            from: 'LANDING_PAGE_PARAM',
            forced_signup_offered: isForcedSignup,
            landing_page: 'Billing',
            locale: _squid.$locale.lang + '_' + _squid.$locale.country
        });

        return appRoute;
    }

    function callEPM() {
        return _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
            params: {
                localeCountry: _squid.$locale.country,
                fundingSource: window.xprops && window.xprops.fundingSource,
                merchantId: merchantId,
                merchantCountry: merchantCountry
            }
        }).then(function (flowEligibility) {
            var mode = flowEligibility.guest ? 'guest' : 'signup';
            _logger.$logger.info(mode + '_flow_offered_by_epm_at_route');
            var appRoute = mode === 'signup' ? 'checkout.signup' : 'checkout.guest';
            return getProcessedRoute(appRoute);
        });
    }

    if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
        var passedInExp = _squid.$util.param('showExp');

        if ('guest'.includes(passedInExp)) {
            return getProcessedRoute('checkout.guest');
        }

        if ('signup'.includes(passedInExp)) {
            return getProcessedRoute('checkout.signup');
        }
    }

    var _ref = window.xprops || {},
        _ref$fundingSource = _ref.fundingSource,
        fundingSourceFromXprops = _ref$fundingSource === undefined ? '' : _ref$fundingSource,
        _ref$fundingOffered = _ref.fundingOffered,
        fundingOfferedFromXprops = _ref$fundingOffered === undefined ? [] : _ref$fundingOffered;

    function isSPBSignEligible() {
        // fundingOfferedFromXprops is already an array from xprops.
        if (fundingSourceFromXprops === _paypalSdkConstants.FUNDING.PAYPAL && fundingOfferedFromXprops.includes(_paypalSdkConstants.FUNDING.CARD)) {
            return (0, _squid.$pxp)('xo_xoon_spb_signup', 'xo_xoon_spb_signup_test', undefined, false, true).then(function (result) {
                var treatmentName = result && result.treatment_name;
                return treatmentName === 'xo_xoon_spb_signup_test';
            });
        }
        return _angular.$q.resolve(false);
    }

    return isSPBSignEligible().then(function (spbSignupEligible) {
        if (spbSignupEligible) {
            return getProcessedRoute('checkout.signup');
        } else if (isUnbranded) {
            var isUnbrandedAllowed = (0, _squid.$feature)('unbranded', true, merchantCountry);
            var isPuiAllowed = (0, _squid.$feature)('invoicePayment', true, merchantCountry);

            if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
                return getProcessedRoute('checkout.pay-upon-invoice');
            }
            return getProcessedRoute('checkout.guest');
        } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && _squid.$util.param('exp') === 'signup') {
            return getProcessedRoute('checkout.signup');
        } else if ((0, _squid.$feature)('multiStepSignup', false, _squid.$locale.country)) {
            return getProcessedRoute('checkout.multistepsignup');
        } else if (models.checkoutInputData.isEbayTxn()) {
            // force signup for eBay users
            _logger.$logger.info('ebay_flow_signup');
            return getProcessedRoute('checkout.signup');
        } else {
            // if you here means, now we need to determine the route based on symphony EPM call.
            return callEPM();
        }
    });
};

var landingPageResolver = {
    landingFlow: landingFlow
};

exports.landingPageResolver = landingPageResolver;


_paypalSdkConstants.FUNDING;

_squid.$util;

_squid.$feature;

_squid.$config;

_squid.$locale;

_squid.$pxp;

_index.$FlowEligibilityModel;

_logger.$logger;

_angular.$q;

_angular.$rootScope;

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _helper = __webpack_require__("./pages/xo-landing/helper.js");

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('LandingRoute', {
    name: 'landing',

    // Uncomment the following line to suffix content to
    // the title of the page
    // Base title is 'PayPal Checkout'
    // titleContent: 'accountCreationGuest.heading',

    scope: {
        isUnbranded: '=?'
    },

    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },

    init: function init() {
        this._super.init.apply(this);

        _squid.$event.on('countryChange', function () {
            _index2.$FlowEligibilityModel.instance(_angular.$rootScope.token).invalidate();
        });
    },


    resolve: {
        action: function action() {
            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutPayeeModel: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                // C2 ramp - force CN country code to C2 upon landing
                if (_squid.$locale.country === 'CN') {
                    _squid.$locale.change('C2', _squid.$locale.lang);
                    _logger.$logger.info('CN_locale_forced_to_C2');
                }
            }).then(function () {

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _index3.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return _helper.landingPageResolver.landingFlow(models);
                            }
                        }
                    });
                } else {
                    return _helper.landingPageResolver.landingFlow(models);
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;

_squid.$ComponentRoute;

_squid.$config;

_squid.$event;

_squid.$locale;

_squid.$populate;

_logger.$logger;

_index.$CheckoutInputDataModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$FlowEligibilityModel;

_index3.$InventoryModel;

_helper.landingPageResolver;

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {

    return angular.module('hermes.page.xo-pay-upon-invoice.directive', ['squid', 'xo-value-props.directive', 'xo-pay-upon-invoice.directive']).directive('xoPayUponInvoicePage', function ($rootScope, $logger) {

        return {
            template: template,

            scope: {
                token: '=?',
                isUnbranded: '=?'
            },

            controller: function controller($scope, $rootScope, $state, $locale) {// eslint-disable-line no-shadow

            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-pay-upon-invoice.route', ['squid', 'hermes.page.xo-pay-upon-invoice.directive']).factory('$PayUponInvoiceRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('PayUponInvoiceRoute', {
            name: 'pay-upon-invoice',
            directive: 'xo-pay-upon-invoice-page',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'payment.payWithCard',

            trackingData: {
                templateName: 'pay-upon-invoice.dust',
                pageGoal: 'Payment Start',
                pageQualifier: 'pay-upon-invoice',
                buzname: {
                    'pay-upon-invoice': {
                        'pagename': '%::fullpage-pay-upon-invoice',
                        'pagename2': '%::fullpage-pay-upon-invoice:guest:hermes:',
                        'version': 'pay-upon-invoice:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: []
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-pay-upon-invoice", "pages/xo-pay-upon-invoice/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/installment-options/directive.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {

    return angular.module('hermes.page.xo-sidebar-installment-options.directive', ['squid', 'xo-aside-header.directive', 'xo-installment-options.directive', 'xo-tray-height.directive']).directive('xoSidebarInstallmentOptionsPage', function () {

        return {
            template: template,

            scope: {
                backUri: '=?',
                parentModel: '=?'
            },

            controller: function controller($scope, $rootScope, $state) {
                $scope.token = $rootScope.token;

                $scope.cardInfo = {
                    number: $scope.parentModel.onboard.card.number.replace(/ /g, ''),
                    type: $scope.parentModel.onboard.card.type
                };

                $scope.onComplete = function (result) {
                    $scope.parentModel.setProperties({
                        selectedInstallmentData: result
                    });

                    angular.element('#paymentMethod').removeClass('ng-invalid'); // FIXME : setup a callback in xo-multistep-signup

                    $state.go($scope.backUri);
                };

                $scope.$emit('populated');
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar-installment-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-sidebar-installment-options.route', ['squid', 'hermes.page.xo-sidebar-installment-options.directive']).factory('$SidebarInstallmentOptionsRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('InstallmentOptionsRoute', {
            name: 'installmentOptions',
            directive: 'xo-sidebar-installment-options-page',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            trackingData: {
                templateName: 'tray/installmentOptions.dust',
                pageGoal: 'Installment Options',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-installment-options',
                        'pagename2': '%::fullpage-installment-options::hermes:',
                        'version': ':%:'
                    }
                }
            },
            children: []
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar-installment-options", "pages/xo-sidebar-installment-options/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, index, template) {

    return angular.module('hermes.page.xo-sidebar.directive', ['squid']).directive('xoSidebar', function () {

        return {
            template: template,

            scope: {
                backUri: '=?',
                parentModel: '=?'
            },

            link: function link($scope, element, attr) {

                $scope.$on('populated', function () {
                    angular.element('body').addClass('trayOpen');
                    angular.element('#wrapper').addClass('maskMember');

                    var payButton = angular.element('.confirmButton');

                    if (payButton) {
                        payButton.attr('disabled', true);
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element('body').removeClass('trayOpen');

                    var payButton = angular.element('.confirmButton');

                    if (payButton) {
                        payButton.attr('disabled', false);
                    }
                });
            },
            controller: function controller($scope, $rootScope, $window, $state, $util, $populate) {

                $util.assert($scope.backUri, 'Expected backUri');

                $populate($scope);

                $scope.token = $rootScope.token;

                $scope.onPageClick = function ($event) {
                    $event.stopPropagation();
                };

                $scope.close = function () {
                    $state.go($scope.backUri);
                };

                $scope.callbacks = {
                    done: function done() {
                        $state.go($scope.backUri);
                    }
                };
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-sidebar/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar/directive.js"), __webpack_require__("./pages/xo-sidebar-installment-options/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-sidebar.route', ['squid', 'hermes.page.xo-sidebar.directive', 'hermes.page.xo-sidebar-installment-options.route']).factory('$SidebarRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SidebarRoute', {
            name: 'sidebar',
            directive: 'xo-sidebar',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            children: [{
                name: '$SidebarInstallmentOptionsRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'parentModel'
                }
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar", "pages/xo-sidebar/route.js"))

/***/ }),

/***/ "./pages/xo-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-signup/template.html"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {

    return angular.module('hermes.page.xo-signup.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoSignup', function ($rootScope, $SingleStepModel) {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                buttonParams: '=?'
            },

            controller: function controller($scope, $rootScope, $state, $locale) {
                // eslint-disable-line no-shadow
                $scope.mode = 'signup';
                $scope.backUri = 'checkout.signup';
                $scope.singleStepModel = new $SingleStepModel();

                $scope.onComplete = function () {
                    $state.go('checkout.end');
                };
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-signup/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-signup.route', ['squid', 'hermes.page.xo-signup.directive', 'hermes.page.xo-sidebar.route']).factory('$SignupRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SignupRoute', {
            name: 'signup',
            directive: 'xo-signup',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            trackingData: {
                fptiState: 'signup',
                trackStateExit: true,
                templateName: 'signup.dust',
                pageGoal: 'Signup Start',
                pageQualifier: 'signup',
                buzname: {
                    'signup': {
                        'pagename': '%::fullpage-signup',
                        'pagename2': '%::fullpage-signup:member:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$GuestUpgradeInterstitialRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel'
                }
            }]
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-signup", "pages/xo-signup/route.js"))

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/xo-webpack-config/polyfills.js");
module.exports = __webpack_require__("./js/bootstrap.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/main.js